import * as Zo from "react";
import Ub, { forwardRef as Bb, useContext as wv, createElement as gg, PureComponent as pR, createContext as $b, useMemo as N0, useRef as xa, useEffect as sn, useCallback as Jo, useState as Yr, lazy as ee, Suspense as hR, Fragment as Hb, useLayoutEffect as fR } from "react";
import { toast as vR, makeStyles as el, css as Lt, Loader as Fb, Tooltip as al, getTheme as zb, Text as e1, ToastContainer as mR } from "@conexasaude/conexa-hero";
import gR from "zustand";
import { keyframes as yR } from "@emotion/react";
var SR = Object.defineProperty, bR = (e, t, r) => t in e ? SR(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, CR = (e, t, r) => (bR(e, typeof t != "symbol" ? t + "" : t, r), r);
class wR {
  constructor() {
    CR(this, "eventList", {});
  }
  on(t, r) {
    return this.eventList[t] || (this.eventList[t] = []), this.eventList[t].push(r), () => {
      this.off(t);
    };
  }
  off(t) {
    delete this.eventList[t];
  }
  trigger(t, r, n) {
    return this.eventList[t] && this.eventList[t].forEach((o) => o(r, n)), !1;
  }
}
const la = new wR(), t1 = {
  trigger: la.trigger.bind(la)
}, ER = {
  on: la.on.bind(la),
  off: la.off.bind(la)
};
function IR(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var r1 = { exports: {} }, ll = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var yg;
function AR() {
  if (yg)
    return ll;
  yg = 1;
  var e = Ub, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(a, l, u) {
    var d, c = {}, p = null, h = null;
    u !== void 0 && (p = "" + u), l.key !== void 0 && (p = "" + l.key), l.ref !== void 0 && (h = l.ref);
    for (d in l)
      n.call(l, d) && !i.hasOwnProperty(d) && (c[d] = l[d]);
    if (a && a.defaultProps)
      for (d in l = a.defaultProps, l)
        c[d] === void 0 && (c[d] = l[d]);
    return { $$typeof: t, type: a, key: p, ref: h, props: c, _owner: o.current };
  }
  return ll.Fragment = r, ll.jsx = s, ll.jsxs = s, ll;
}
var ul = {}, Sg;
function _R() {
  if (Sg)
    return ul;
  Sg = 1;
  var e = {};
  /**
   * @license React
   * react-jsx-runtime.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  return e.NODE_ENV !== "production" && function() {
    var t = Ub, r = Symbol.for("react.element"), n = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), f = Symbol.iterator, m = "@@iterator";
    function g(x) {
      if (x === null || typeof x != "object")
        return null;
      var ue = f && x[f] || x[m];
      return typeof ue == "function" ? ue : null;
    }
    var C = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function b(x) {
      {
        for (var ue = arguments.length, we = new Array(ue > 1 ? ue - 1 : 0), Be = 1; Be < ue; Be++)
          we[Be - 1] = arguments[Be];
        E("error", x, we);
      }
    }
    function E(x, ue, we) {
      {
        var Be = C.ReactDebugCurrentFrame, rt = Be.getStackAddendum();
        rt !== "" && (ue += "%s", we = we.concat([rt]));
        var mt = we.map(function(tt) {
          return String(tt);
        });
        mt.unshift("Warning: " + ue), Function.prototype.apply.call(console[x], console, mt);
      }
    }
    var w = !1, _ = !1, I = !1, D = !1, B = !1, L;
    L = Symbol.for("react.module.reference");
    function R(x) {
      return !!(typeof x == "string" || typeof x == "function" || x === o || x === s || B || x === i || x === d || x === c || D || x === v || w || _ || I || typeof x == "object" && x !== null && (x.$$typeof === h || x.$$typeof === p || x.$$typeof === a || x.$$typeof === l || x.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      x.$$typeof === L || x.getModuleId !== void 0));
    }
    function y(x, ue, we) {
      var Be = x.displayName;
      if (Be)
        return Be;
      var rt = ue.displayName || ue.name || "";
      return rt !== "" ? we + "(" + rt + ")" : we;
    }
    function A(x) {
      return x.displayName || "Context";
    }
    function k(x) {
      if (x == null)
        return null;
      if (typeof x.tag == "number" && b("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof x == "function")
        return x.displayName || x.name || null;
      if (typeof x == "string")
        return x;
      switch (x) {
        case o:
          return "Fragment";
        case n:
          return "Portal";
        case s:
          return "Profiler";
        case i:
          return "StrictMode";
        case d:
          return "Suspense";
        case c:
          return "SuspenseList";
      }
      if (typeof x == "object")
        switch (x.$$typeof) {
          case l:
            var ue = x;
            return A(ue) + ".Consumer";
          case a:
            var we = x;
            return A(we._context) + ".Provider";
          case u:
            return y(x, x.render, "ForwardRef");
          case p:
            var Be = x.displayName || null;
            return Be !== null ? Be : k(x.type) || "Memo";
          case h: {
            var rt = x, mt = rt._payload, tt = rt._init;
            try {
              return k(tt(mt));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var T = Object.assign, N = 0, F, $, re, fe, le, Ae, Re;
    function Se() {
    }
    Se.__reactDisabledLog = !0;
    function ye() {
      {
        if (N === 0) {
          F = console.log, $ = console.info, re = console.warn, fe = console.error, le = console.group, Ae = console.groupCollapsed, Re = console.groupEnd;
          var x = {
            configurable: !0,
            enumerable: !0,
            value: Se,
            writable: !0
          };
          Object.defineProperties(console, {
            info: x,
            log: x,
            warn: x,
            error: x,
            group: x,
            groupCollapsed: x,
            groupEnd: x
          });
        }
        N++;
      }
    }
    function Oe() {
      {
        if (N--, N === 0) {
          var x = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: T({}, x, {
              value: F
            }),
            info: T({}, x, {
              value: $
            }),
            warn: T({}, x, {
              value: re
            }),
            error: T({}, x, {
              value: fe
            }),
            group: T({}, x, {
              value: le
            }),
            groupCollapsed: T({}, x, {
              value: Ae
            }),
            groupEnd: T({}, x, {
              value: Re
            })
          });
        }
        N < 0 && b("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ue = C.ReactCurrentDispatcher, Ve;
    function U(x, ue, we) {
      {
        if (Ve === void 0)
          try {
            throw Error();
          } catch (rt) {
            var Be = rt.stack.trim().match(/\n( *(at )?)/);
            Ve = Be && Be[1] || "";
          }
        return `
` + Ve + x;
      }
    }
    var j = !1, P;
    {
      var Z = typeof WeakMap == "function" ? WeakMap : Map;
      P = new Z();
    }
    function H(x, ue) {
      if (!x || j)
        return "";
      {
        var we = P.get(x);
        if (we !== void 0)
          return we;
      }
      var Be;
      j = !0;
      var rt = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var mt;
      mt = Ue.current, Ue.current = null, ye();
      try {
        if (ue) {
          var tt = function() {
            throw Error();
          };
          if (Object.defineProperty(tt.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(tt, []);
            } catch (Do) {
              Be = Do;
            }
            Reflect.construct(x, [], tt);
          } else {
            try {
              tt.call();
            } catch (Do) {
              Be = Do;
            }
            x.call(tt.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Do) {
            Be = Do;
          }
          x();
        }
      } catch (Do) {
        if (Do && Be && typeof Do.stack == "string") {
          for (var Ke = Do.stack.split(`
`), jr = Be.stack.split(`
`), jt = Ke.length - 1, Ft = jr.length - 1; jt >= 1 && Ft >= 0 && Ke[jt] !== jr[Ft]; )
            Ft--;
          for (; jt >= 1 && Ft >= 0; jt--, Ft--)
            if (Ke[jt] !== jr[Ft]) {
              if (jt !== 1 || Ft !== 1)
                do
                  if (jt--, Ft--, Ft < 0 || Ke[jt] !== jr[Ft]) {
                    var _n = `
` + Ke[jt].replace(" at new ", " at ");
                    return x.displayName && _n.includes("<anonymous>") && (_n = _n.replace("<anonymous>", x.displayName)), typeof x == "function" && P.set(x, _n), _n;
                  }
                while (jt >= 1 && Ft >= 0);
              break;
            }
        }
      } finally {
        j = !1, Ue.current = mt, Oe(), Error.prepareStackTrace = rt;
      }
      var Fs = x ? x.displayName || x.name : "", mg = Fs ? U(Fs) : "";
      return typeof x == "function" && P.set(x, mg), mg;
    }
    function me(x, ue, we) {
      return H(x, !1);
    }
    function Ce(x) {
      var ue = x.prototype;
      return !!(ue && ue.isReactComponent);
    }
    function _e(x, ue, we) {
      if (x == null)
        return "";
      if (typeof x == "function")
        return H(x, Ce(x));
      if (typeof x == "string")
        return U(x);
      switch (x) {
        case d:
          return U("Suspense");
        case c:
          return U("SuspenseList");
      }
      if (typeof x == "object")
        switch (x.$$typeof) {
          case u:
            return me(x.render);
          case p:
            return _e(x.type, ue, we);
          case h: {
            var Be = x, rt = Be._payload, mt = Be._init;
            try {
              return _e(mt(rt), ue, we);
            } catch {
            }
          }
        }
      return "";
    }
    var Me = Object.prototype.hasOwnProperty, je = {}, Ne = C.ReactDebugCurrentFrame;
    function Le(x) {
      if (x) {
        var ue = x._owner, we = _e(x.type, x._source, ue ? ue.type : null);
        Ne.setExtraStackFrame(we);
      } else
        Ne.setExtraStackFrame(null);
    }
    function Qe(x, ue, we, Be, rt) {
      {
        var mt = Function.call.bind(Me);
        for (var tt in x)
          if (mt(x, tt)) {
            var Ke = void 0;
            try {
              if (typeof x[tt] != "function") {
                var jr = Error((Be || "React class") + ": " + we + " type `" + tt + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof x[tt] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw jr.name = "Invariant Violation", jr;
              }
              Ke = x[tt](ue, tt, Be, we, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (jt) {
              Ke = jt;
            }
            Ke && !(Ke instanceof Error) && (Le(rt), b("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Be || "React class", we, tt, typeof Ke), Le(null)), Ke instanceof Error && !(Ke.message in je) && (je[Ke.message] = !0, Le(rt), b("Failed %s type: %s", we, Ke.message), Le(null));
          }
      }
    }
    var Ye = Array.isArray;
    function Ze(x) {
      return Ye(x);
    }
    function Rt(x) {
      {
        var ue = typeof Symbol == "function" && Symbol.toStringTag, we = ue && x[Symbol.toStringTag] || x.constructor.name || "Object";
        return we;
      }
    }
    function ct(x) {
      try {
        return vt(x), !1;
      } catch {
        return !0;
      }
    }
    function vt(x) {
      return "" + x;
    }
    function Sr(x) {
      if (ct(x))
        return b("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Rt(x)), vt(x);
    }
    var Xt = C.ReactCurrentOwner, oi = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ii, il, sl;
    sl = {};
    function Q_(x) {
      if (Me.call(x, "ref")) {
        var ue = Object.getOwnPropertyDescriptor(x, "ref").get;
        if (ue && ue.isReactWarning)
          return !1;
      }
      return x.ref !== void 0;
    }
    function Y_(x) {
      if (Me.call(x, "key")) {
        var ue = Object.getOwnPropertyDescriptor(x, "key").get;
        if (ue && ue.isReactWarning)
          return !1;
      }
      return x.key !== void 0;
    }
    function X_(x, ue) {
      if (typeof x.ref == "string" && Xt.current && ue && Xt.current.stateNode !== ue) {
        var we = k(Xt.current.type);
        sl[we] || (b('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', k(Xt.current.type), x.ref), sl[we] = !0);
      }
    }
    function eR(x, ue) {
      {
        var we = function() {
          ii || (ii = !0, b("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ue));
        };
        we.isReactWarning = !0, Object.defineProperty(x, "key", {
          get: we,
          configurable: !0
        });
      }
    }
    function tR(x, ue) {
      {
        var we = function() {
          il || (il = !0, b("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ue));
        };
        we.isReactWarning = !0, Object.defineProperty(x, "ref", {
          get: we,
          configurable: !0
        });
      }
    }
    var rR = function(x, ue, we, Be, rt, mt, tt) {
      var Ke = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: x,
        key: ue,
        ref: we,
        props: tt,
        // Record the component responsible for creating this element.
        _owner: mt
      };
      return Ke._store = {}, Object.defineProperty(Ke._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Ke, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Be
      }), Object.defineProperty(Ke, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: rt
      }), Object.freeze && (Object.freeze(Ke.props), Object.freeze(Ke)), Ke;
    };
    function nR(x, ue, we, Be, rt) {
      {
        var mt, tt = {}, Ke = null, jr = null;
        we !== void 0 && (Sr(we), Ke = "" + we), Y_(ue) && (Sr(ue.key), Ke = "" + ue.key), Q_(ue) && (jr = ue.ref, X_(ue, rt));
        for (mt in ue)
          Me.call(ue, mt) && !oi.hasOwnProperty(mt) && (tt[mt] = ue[mt]);
        if (x && x.defaultProps) {
          var jt = x.defaultProps;
          for (mt in jt)
            tt[mt] === void 0 && (tt[mt] = jt[mt]);
        }
        if (Ke || jr) {
          var Ft = typeof x == "function" ? x.displayName || x.name || "Unknown" : x;
          Ke && eR(tt, Ft), jr && tR(tt, Ft);
        }
        return rR(x, Ke, jr, rt, Be, Xt.current, tt);
      }
    }
    var pp = C.ReactCurrentOwner, dg = C.ReactDebugCurrentFrame;
    function Hs(x) {
      if (x) {
        var ue = x._owner, we = _e(x.type, x._source, ue ? ue.type : null);
        dg.setExtraStackFrame(we);
      } else
        dg.setExtraStackFrame(null);
    }
    var hp;
    hp = !1;
    function fp(x) {
      return typeof x == "object" && x !== null && x.$$typeof === r;
    }
    function cg() {
      {
        if (pp.current) {
          var x = k(pp.current.type);
          if (x)
            return `

Check the render method of \`` + x + "`.";
        }
        return "";
      }
    }
    function oR(x) {
      {
        if (x !== void 0) {
          var ue = x.fileName.replace(/^.*[\\\/]/, ""), we = x.lineNumber;
          return `

Check your code at ` + ue + ":" + we + ".";
        }
        return "";
      }
    }
    var pg = {};
    function iR(x) {
      {
        var ue = cg();
        if (!ue) {
          var we = typeof x == "string" ? x : x.displayName || x.name;
          we && (ue = `

Check the top-level render call using <` + we + ">.");
        }
        return ue;
      }
    }
    function hg(x, ue) {
      {
        if (!x._store || x._store.validated || x.key != null)
          return;
        x._store.validated = !0;
        var we = iR(ue);
        if (pg[we])
          return;
        pg[we] = !0;
        var Be = "";
        x && x._owner && x._owner !== pp.current && (Be = " It was passed a child from " + k(x._owner.type) + "."), Hs(x), b('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', we, Be), Hs(null);
      }
    }
    function fg(x, ue) {
      {
        if (typeof x != "object")
          return;
        if (Ze(x))
          for (var we = 0; we < x.length; we++) {
            var Be = x[we];
            fp(Be) && hg(Be, ue);
          }
        else if (fp(x))
          x._store && (x._store.validated = !0);
        else if (x) {
          var rt = g(x);
          if (typeof rt == "function" && rt !== x.entries)
            for (var mt = rt.call(x), tt; !(tt = mt.next()).done; )
              fp(tt.value) && hg(tt.value, ue);
        }
      }
    }
    function sR(x) {
      {
        var ue = x.type;
        if (ue == null || typeof ue == "string")
          return;
        var we;
        if (typeof ue == "function")
          we = ue.propTypes;
        else if (typeof ue == "object" && (ue.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        ue.$$typeof === p))
          we = ue.propTypes;
        else
          return;
        if (we) {
          var Be = k(ue);
          Qe(we, x.props, "prop", Be, x);
        } else if (ue.PropTypes !== void 0 && !hp) {
          hp = !0;
          var rt = k(ue);
          b("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", rt || "Unknown");
        }
        typeof ue.getDefaultProps == "function" && !ue.getDefaultProps.isReactClassApproved && b("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function aR(x) {
      {
        for (var ue = Object.keys(x.props), we = 0; we < ue.length; we++) {
          var Be = ue[we];
          if (Be !== "children" && Be !== "key") {
            Hs(x), b("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Be), Hs(null);
            break;
          }
        }
        x.ref !== null && (Hs(x), b("Invalid attribute `ref` supplied to `React.Fragment`."), Hs(null));
      }
    }
    function vg(x, ue, we, Be, rt, mt) {
      {
        var tt = R(x);
        if (!tt) {
          var Ke = "";
          (x === void 0 || typeof x == "object" && x !== null && Object.keys(x).length === 0) && (Ke += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var jr = oR(rt);
          jr ? Ke += jr : Ke += cg();
          var jt;
          x === null ? jt = "null" : Ze(x) ? jt = "array" : x !== void 0 && x.$$typeof === r ? (jt = "<" + (k(x.type) || "Unknown") + " />", Ke = " Did you accidentally export a JSX literal instead of a component?") : jt = typeof x, b("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", jt, Ke);
        }
        var Ft = nR(x, ue, we, rt, mt);
        if (Ft == null)
          return Ft;
        if (tt) {
          var _n = ue.children;
          if (_n !== void 0)
            if (Be)
              if (Ze(_n)) {
                for (var Fs = 0; Fs < _n.length; Fs++)
                  fg(_n[Fs], x);
                Object.freeze && Object.freeze(_n);
              } else
                b("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              fg(_n, x);
        }
        return x === o ? aR(Ft) : sR(Ft), Ft;
      }
    }
    function lR(x, ue, we) {
      return vg(x, ue, we, !0);
    }
    function uR(x, ue, we) {
      return vg(x, ue, we, !1);
    }
    var dR = uR, cR = lR;
    ul.Fragment = o, ul.jsx = dR, ul.jsxs = cR;
  }(), ul;
}
var RR = {};
RR.NODE_ENV === "production" ? r1.exports = AR() : r1.exports = _R();
var pc = r1.exports, zu = {};
function OR(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function TR(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var kR = /* @__PURE__ */ function() {
  function e(r) {
    var n = this;
    this._insertTag = function(o) {
      var i;
      n.tags.length === 0 ? n.insertionPoint ? i = n.insertionPoint.nextSibling : n.prepend ? i = n.container.firstChild : i = n.before : i = n.tags[n.tags.length - 1].nextSibling, n.container.insertBefore(o, i), n.tags.push(o);
    }, this.isSpeedy = r.speedy === void 0 ? zu.NODE_ENV === "production" : r.speedy, this.tags = [], this.ctr = 0, this.nonce = r.nonce, this.key = r.key, this.container = r.container, this.prepend = r.prepend, this.insertionPoint = r.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(n) {
    n.forEach(this._insertTag);
  }, t.insert = function(n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(TR(this));
    var o = this.tags[this.tags.length - 1];
    if (zu.NODE_ENV !== "production") {
      var i = n.charCodeAt(0) === 64 && n.charCodeAt(1) === 105;
      i && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + n + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !i;
    }
    if (this.isSpeedy) {
      var s = OR(o);
      try {
        s.insertRule(n, s.cssRules.length);
      } catch (a) {
        zu.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(n) && console.error('There was a problem inserting the following rule: "' + n + '"', a);
      }
    } else
      o.appendChild(document.createTextNode(n));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(n) {
      return n.parentNode && n.parentNode.removeChild(n);
    }), this.tags = [], this.ctr = 0, zu.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), Pr = "-ms-", hc = "-moz-", nt = "-webkit-", Ev = "comm", Iv = "rule", Av = "decl", MR = "@import", Wb = "@keyframes", PR = "@layer", DR = Math.abs, x0 = String.fromCharCode, LR = Object.assign;
function NR(e, t) {
  return Rr(e, 0) ^ 45 ? (((t << 2 ^ Rr(e, 0)) << 2 ^ Rr(e, 1)) << 2 ^ Rr(e, 2)) << 2 ^ Rr(e, 3) : 0;
}
function Zb(e) {
  return e.trim();
}
function xR(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function ot(e, t, r) {
  return e.replace(t, r);
}
function n1(e, t) {
  return e.indexOf(t);
}
function Rr(e, t) {
  return e.charCodeAt(t) | 0;
}
function tu(e, t, r) {
  return e.slice(t, r);
}
function mo(e) {
  return e.length;
}
function _v(e) {
  return e.length;
}
function Wu(e, t) {
  return t.push(e), e;
}
function VR(e, t) {
  return e.map(t).join("");
}
var V0 = 1, Va = 1, Gb = 0, an = 0, Gt = 0, tl = "";
function j0(e, t, r, n, o, i, s) {
  return { value: e, root: t, parent: r, type: n, props: o, children: i, line: V0, column: Va, length: s, return: "" };
}
function dl(e, t) {
  return LR(j0("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function jR() {
  return Gt;
}
function UR() {
  return Gt = an > 0 ? Rr(tl, --an) : 0, Va--, Gt === 10 && (Va = 1, V0--), Gt;
}
function Cn() {
  return Gt = an < Gb ? Rr(tl, an++) : 0, Va++, Gt === 10 && (Va = 1, V0++), Gt;
}
function Ao() {
  return Rr(tl, an);
}
function Ed() {
  return an;
}
function Tu(e, t) {
  return tu(tl, e, t);
}
function ru(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function qb(e) {
  return V0 = Va = 1, Gb = mo(tl = e), an = 0, [];
}
function Kb(e) {
  return tl = "", e;
}
function Id(e) {
  return Zb(Tu(an - 1, o1(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function BR(e) {
  for (; (Gt = Ao()) && Gt < 33; )
    Cn();
  return ru(e) > 2 || ru(Gt) > 3 ? "" : " ";
}
function $R(e, t) {
  for (; --t && Cn() && !(Gt < 48 || Gt > 102 || Gt > 57 && Gt < 65 || Gt > 70 && Gt < 97); )
    ;
  return Tu(e, Ed() + (t < 6 && Ao() == 32 && Cn() == 32));
}
function o1(e) {
  for (; Cn(); )
    switch (Gt) {
      case e:
        return an;
      case 34:
      case 39:
        e !== 34 && e !== 39 && o1(Gt);
        break;
      case 40:
        e === 41 && o1(e);
        break;
      case 92:
        Cn();
        break;
    }
  return an;
}
function HR(e, t) {
  for (; Cn() && e + Gt !== 57; )
    if (e + Gt === 84 && Ao() === 47)
      break;
  return "/*" + Tu(t, an - 1) + "*" + x0(e === 47 ? e : Cn());
}
function FR(e) {
  for (; !ru(Ao()); )
    Cn();
  return Tu(e, an);
}
function zR(e) {
  return Kb(Ad("", null, null, null, [""], e = qb(e), 0, [0], e));
}
function Ad(e, t, r, n, o, i, s, a, l) {
  for (var u = 0, d = 0, c = s, p = 0, h = 0, v = 0, f = 1, m = 1, g = 1, C = 0, b = "", E = o, w = i, _ = n, I = b; m; )
    switch (v = C, C = Cn()) {
      case 40:
        if (v != 108 && Rr(I, c - 1) == 58) {
          n1(I += ot(Id(C), "&", "&\f"), "&\f") != -1 && (g = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        I += Id(C);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        I += BR(v);
        break;
      case 92:
        I += $R(Ed() - 1, 7);
        continue;
      case 47:
        switch (Ao()) {
          case 42:
          case 47:
            Wu(WR(HR(Cn(), Ed()), t, r), l);
            break;
          default:
            I += "/";
        }
        break;
      case 123 * f:
        a[u++] = mo(I) * g;
      case 125 * f:
      case 59:
      case 0:
        switch (C) {
          case 0:
          case 125:
            m = 0;
          case 59 + d:
            g == -1 && (I = ot(I, /\f/g, "")), h > 0 && mo(I) - c && Wu(h > 32 ? Cg(I + ";", n, r, c - 1) : Cg(ot(I, " ", "") + ";", n, r, c - 2), l);
            break;
          case 59:
            I += ";";
          default:
            if (Wu(_ = bg(I, t, r, u, d, o, a, b, E = [], w = [], c), i), C === 123)
              if (d === 0)
                Ad(I, t, _, _, E, i, c, a, w);
              else
                switch (p === 99 && Rr(I, 3) === 110 ? 100 : p) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Ad(e, _, _, n && Wu(bg(e, _, _, 0, 0, o, a, b, o, E = [], c), w), o, w, c, a, n ? E : w);
                    break;
                  default:
                    Ad(I, _, _, _, [""], w, 0, a, w);
                }
        }
        u = d = h = 0, f = g = 1, b = I = "", c = s;
        break;
      case 58:
        c = 1 + mo(I), h = v;
      default:
        if (f < 1) {
          if (C == 123)
            --f;
          else if (C == 125 && f++ == 0 && UR() == 125)
            continue;
        }
        switch (I += x0(C), C * f) {
          case 38:
            g = d > 0 ? 1 : (I += "\f", -1);
            break;
          case 44:
            a[u++] = (mo(I) - 1) * g, g = 1;
            break;
          case 64:
            Ao() === 45 && (I += Id(Cn())), p = Ao(), d = c = mo(b = I += FR(Ed())), C++;
            break;
          case 45:
            v === 45 && mo(I) == 2 && (f = 0);
        }
    }
  return i;
}
function bg(e, t, r, n, o, i, s, a, l, u, d) {
  for (var c = o - 1, p = o === 0 ? i : [""], h = _v(p), v = 0, f = 0, m = 0; v < n; ++v)
    for (var g = 0, C = tu(e, c + 1, c = DR(f = s[v])), b = e; g < h; ++g)
      (b = Zb(f > 0 ? p[g] + " " + C : ot(C, /&\f/g, p[g]))) && (l[m++] = b);
  return j0(e, t, r, o === 0 ? Iv : a, l, u, d);
}
function WR(e, t, r) {
  return j0(e, t, r, Ev, x0(jR()), tu(e, 2, -2), 0);
}
function Cg(e, t, r, n) {
  return j0(e, t, r, Av, tu(e, 0, n), tu(e, n + 1, -1), n);
}
function ba(e, t) {
  for (var r = "", n = _v(e), o = 0; o < n; o++)
    r += t(e[o], o, e, t) || "";
  return r;
}
function ZR(e, t, r, n) {
  switch (e.type) {
    case PR:
      if (e.children.length)
        break;
    case MR:
    case Av:
      return e.return = e.return || e.value;
    case Ev:
      return "";
    case Wb:
      return e.return = e.value + "{" + ba(e.children, n) + "}";
    case Iv:
      e.value = e.props.join(",");
  }
  return mo(r = ba(e.children, n)) ? e.return = e.value + "{" + r + "}" : "";
}
function GR(e) {
  var t = _v(e);
  return function(r, n, o, i) {
    for (var s = "", a = 0; a < t; a++)
      s += e[a](r, n, o, i) || "";
    return s;
  };
}
function qR(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function KR(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(r) {
    return t[r] === void 0 && (t[r] = e(r)), t[r];
  };
}
var cl = {}, JR = function(t, r, n) {
  for (var o = 0, i = 0; o = i, i = Ao(), o === 38 && i === 12 && (r[n] = 1), !ru(i); )
    Cn();
  return Tu(t, an);
}, QR = function(t, r) {
  var n = -1, o = 44;
  do
    switch (ru(o)) {
      case 0:
        o === 38 && Ao() === 12 && (r[n] = 1), t[n] += JR(an - 1, r, n);
        break;
      case 2:
        t[n] += Id(o);
        break;
      case 4:
        if (o === 44) {
          t[++n] = Ao() === 58 ? "&\f" : "", r[n] = t[n].length;
          break;
        }
      default:
        t[n] += x0(o);
    }
  while (o = Cn());
  return t;
}, YR = function(t, r) {
  return Kb(QR(qb(t), r));
}, wg = /* @__PURE__ */ new WeakMap(), XR = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var r = t.value, n = t.parent, o = t.column === n.column && t.line === n.line; n.type !== "rule"; )
      if (n = n.parent, !n)
        return;
    if (!(t.props.length === 1 && r.charCodeAt(0) !== 58 && !wg.get(n)) && !o) {
      wg.set(t, !0);
      for (var i = [], s = YR(r, i), a = n.props, l = 0, u = 0; l < s.length; l++)
        for (var d = 0; d < a.length; d++, u++)
          t.props[u] = i[l] ? s[l].replace(/&\f/g, a[d]) : a[d] + " " + s[l];
    }
  }
}, e8 = function(t) {
  if (t.type === "decl") {
    var r = t.value;
    // charcode for l
    r.charCodeAt(0) === 108 && // charcode for b
    r.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
}, t8 = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", r8 = function(t) {
  return t.type === "comm" && t.children.indexOf(t8) > -1;
}, n8 = function(t) {
  return function(r, n, o) {
    if (!(r.type !== "rule" || t.compat)) {
      var i = r.value.match(/(:first|:nth|:nth-last)-child/g);
      if (i) {
        for (var s = !!r.parent, a = s ? r.parent.children : (
          // global rule at the root level
          o
        ), l = a.length - 1; l >= 0; l--) {
          var u = a[l];
          if (u.line < r.line)
            break;
          if (u.column < r.column) {
            if (r8(u))
              return;
            break;
          }
        }
        i.forEach(function(d) {
          console.error('The pseudo class "' + d + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + d.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, Jb = function(t) {
  return t.type.charCodeAt(1) === 105 && t.type.charCodeAt(0) === 64;
}, o8 = function(t, r) {
  for (var n = t - 1; n >= 0; n--)
    if (!Jb(r[n]))
      return !0;
  return !1;
}, Eg = function(t) {
  t.type = "", t.value = "", t.return = "", t.children = "", t.props = "";
}, i8 = function(t, r, n) {
  Jb(t) && (t.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), Eg(t)) : o8(r, n) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), Eg(t)));
};
function Qb(e, t) {
  switch (NR(e, t)) {
    case 5103:
      return nt + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return nt + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return nt + e + hc + e + Pr + e + e;
    case 6828:
    case 4268:
      return nt + e + Pr + e + e;
    case 6165:
      return nt + e + Pr + "flex-" + e + e;
    case 5187:
      return nt + e + ot(e, /(\w+).+(:[^]+)/, nt + "box-$1$2" + Pr + "flex-$1$2") + e;
    case 5443:
      return nt + e + Pr + "flex-item-" + ot(e, /flex-|-self/, "") + e;
    case 4675:
      return nt + e + Pr + "flex-line-pack" + ot(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return nt + e + Pr + ot(e, "shrink", "negative") + e;
    case 5292:
      return nt + e + Pr + ot(e, "basis", "preferred-size") + e;
    case 6060:
      return nt + "box-" + ot(e, "-grow", "") + nt + e + Pr + ot(e, "grow", "positive") + e;
    case 4554:
      return nt + ot(e, /([^-])(transform)/g, "$1" + nt + "$2") + e;
    case 6187:
      return ot(ot(ot(e, /(zoom-|grab)/, nt + "$1"), /(image-set)/, nt + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return ot(e, /(image-set\([^]*)/, nt + "$1$`$1");
    case 4968:
      return ot(ot(e, /(.+:)(flex-)?(.*)/, nt + "box-pack:$3" + Pr + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + nt + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return ot(e, /(.+)-inline(.+)/, nt + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (mo(e) - 1 - t > 6)
        switch (Rr(e, t + 1)) {
          case 109:
            if (Rr(e, t + 4) !== 45)
              break;
          case 102:
            return ot(e, /(.+:)(.+)-([^]+)/, "$1" + nt + "$2-$3$1" + hc + (Rr(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~n1(e, "stretch") ? Qb(ot(e, "stretch", "fill-available"), t) + e : e;
        }
      break;
    case 4949:
      if (Rr(e, t + 1) !== 115)
        break;
    case 6444:
      switch (Rr(e, mo(e) - 3 - (~n1(e, "!important") && 10))) {
        case 107:
          return ot(e, ":", ":" + nt) + e;
        case 101:
          return ot(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + nt + (Rr(e, 14) === 45 ? "inline-" : "") + "box$3$1" + nt + "$2$3$1" + Pr + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (Rr(e, t + 11)) {
        case 114:
          return nt + e + Pr + ot(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return nt + e + Pr + ot(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return nt + e + Pr + ot(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return nt + e + Pr + e + e;
  }
  return e;
}
var s8 = function(t, r, n, o) {
  if (t.length > -1 && !t.return)
    switch (t.type) {
      case Av:
        t.return = Qb(t.value, t.length);
        break;
      case Wb:
        return ba([dl(t, {
          value: ot(t.value, "@", "@" + nt)
        })], o);
      case Iv:
        if (t.length)
          return VR(t.props, function(i) {
            switch (xR(i, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return ba([dl(t, {
                  props: [ot(i, /:(read-\w+)/, ":" + hc + "$1")]
                })], o);
              case "::placeholder":
                return ba([dl(t, {
                  props: [ot(i, /:(plac\w+)/, ":" + nt + "input-$1")]
                }), dl(t, {
                  props: [ot(i, /:(plac\w+)/, ":" + hc + "$1")]
                }), dl(t, {
                  props: [ot(i, /:(plac\w+)/, Pr + "input-$1")]
                })], o);
            }
            return "";
          });
    }
}, a8 = [s8], l8 = function(t) {
  var r = t.key;
  if (cl.NODE_ENV !== "production" && !r)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (r === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function(f) {
      var m = f.getAttribute("data-emotion");
      m.indexOf(" ") !== -1 && (document.head.appendChild(f), f.setAttribute("data-s", ""));
    });
  }
  var o = t.stylisPlugins || a8;
  if (cl.NODE_ENV !== "production" && /[^a-z-]/.test(r))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + r + '" was passed');
  var i = {}, s, a = [];
  s = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + r + ' "]'),
    function(f) {
      for (var m = f.getAttribute("data-emotion").split(" "), g = 1; g < m.length; g++)
        i[m[g]] = !0;
      a.push(f);
    }
  );
  var l, u = [XR, e8];
  cl.NODE_ENV !== "production" && u.push(n8({
    get compat() {
      return v.compat;
    }
  }), i8);
  {
    var d, c = [ZR, cl.NODE_ENV !== "production" ? function(f) {
      f.root || (f.return ? d.insert(f.return) : f.value && f.type !== Ev && d.insert(f.value + "{}"));
    } : qR(function(f) {
      d.insert(f);
    })], p = GR(u.concat(o, c)), h = function(m) {
      return ba(zR(m), p);
    };
    l = function(m, g, C, b) {
      d = C, cl.NODE_ENV !== "production" && g.map !== void 0 && (d = {
        insert: function(w) {
          C.insert(w + g.map);
        }
      }), h(m ? m + "{" + g.styles + "}" : g.styles), b && (v.inserted[g.name] = !0);
    };
  }
  var v = {
    key: r,
    sheet: new kR({
      key: r,
      container: s,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: i,
    registered: {},
    insert: l
  };
  return v.sheet.hydrate(a), v;
}, i1 = { exports: {} }, st = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ig;
function u8() {
  if (Ig)
    return st;
  Ig = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, c = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, f = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, g = e ? Symbol.for("react.responder") : 60118, C = e ? Symbol.for("react.scope") : 60119;
  function b(w) {
    if (typeof w == "object" && w !== null) {
      var _ = w.$$typeof;
      switch (_) {
        case t:
          switch (w = w.type, w) {
            case l:
            case u:
            case n:
            case i:
            case o:
            case c:
              return w;
            default:
              switch (w = w && w.$$typeof, w) {
                case a:
                case d:
                case v:
                case h:
                case s:
                  return w;
                default:
                  return _;
              }
          }
        case r:
          return _;
      }
    }
  }
  function E(w) {
    return b(w) === u;
  }
  return st.AsyncMode = l, st.ConcurrentMode = u, st.ContextConsumer = a, st.ContextProvider = s, st.Element = t, st.ForwardRef = d, st.Fragment = n, st.Lazy = v, st.Memo = h, st.Portal = r, st.Profiler = i, st.StrictMode = o, st.Suspense = c, st.isAsyncMode = function(w) {
    return E(w) || b(w) === l;
  }, st.isConcurrentMode = E, st.isContextConsumer = function(w) {
    return b(w) === a;
  }, st.isContextProvider = function(w) {
    return b(w) === s;
  }, st.isElement = function(w) {
    return typeof w == "object" && w !== null && w.$$typeof === t;
  }, st.isForwardRef = function(w) {
    return b(w) === d;
  }, st.isFragment = function(w) {
    return b(w) === n;
  }, st.isLazy = function(w) {
    return b(w) === v;
  }, st.isMemo = function(w) {
    return b(w) === h;
  }, st.isPortal = function(w) {
    return b(w) === r;
  }, st.isProfiler = function(w) {
    return b(w) === i;
  }, st.isStrictMode = function(w) {
    return b(w) === o;
  }, st.isSuspense = function(w) {
    return b(w) === c;
  }, st.isValidElementType = function(w) {
    return typeof w == "string" || typeof w == "function" || w === n || w === u || w === i || w === o || w === c || w === p || typeof w == "object" && w !== null && (w.$$typeof === v || w.$$typeof === h || w.$$typeof === s || w.$$typeof === a || w.$$typeof === d || w.$$typeof === m || w.$$typeof === g || w.$$typeof === C || w.$$typeof === f);
  }, st.typeOf = b, st;
}
var at = {}, Ag;
function d8() {
  if (Ag)
    return at;
  Ag = 1;
  var e = {};
  /** @license React v16.13.1
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  return e.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, r = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, o = t ? Symbol.for("react.fragment") : 60107, i = t ? Symbol.for("react.strict_mode") : 60108, s = t ? Symbol.for("react.profiler") : 60114, a = t ? Symbol.for("react.provider") : 60109, l = t ? Symbol.for("react.context") : 60110, u = t ? Symbol.for("react.async_mode") : 60111, d = t ? Symbol.for("react.concurrent_mode") : 60111, c = t ? Symbol.for("react.forward_ref") : 60112, p = t ? Symbol.for("react.suspense") : 60113, h = t ? Symbol.for("react.suspense_list") : 60120, v = t ? Symbol.for("react.memo") : 60115, f = t ? Symbol.for("react.lazy") : 60116, m = t ? Symbol.for("react.block") : 60121, g = t ? Symbol.for("react.fundamental") : 60117, C = t ? Symbol.for("react.responder") : 60118, b = t ? Symbol.for("react.scope") : 60119;
    function E(H) {
      return typeof H == "string" || typeof H == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      H === o || H === d || H === s || H === i || H === p || H === h || typeof H == "object" && H !== null && (H.$$typeof === f || H.$$typeof === v || H.$$typeof === a || H.$$typeof === l || H.$$typeof === c || H.$$typeof === g || H.$$typeof === C || H.$$typeof === b || H.$$typeof === m);
    }
    function w(H) {
      if (typeof H == "object" && H !== null) {
        var me = H.$$typeof;
        switch (me) {
          case r:
            var Ce = H.type;
            switch (Ce) {
              case u:
              case d:
              case o:
              case s:
              case i:
              case p:
                return Ce;
              default:
                var _e = Ce && Ce.$$typeof;
                switch (_e) {
                  case l:
                  case c:
                  case f:
                  case v:
                  case a:
                    return _e;
                  default:
                    return me;
                }
            }
          case n:
            return me;
        }
      }
    }
    var _ = u, I = d, D = l, B = a, L = r, R = c, y = o, A = f, k = v, T = n, N = s, F = i, $ = p, re = !1;
    function fe(H) {
      return re || (re = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), le(H) || w(H) === u;
    }
    function le(H) {
      return w(H) === d;
    }
    function Ae(H) {
      return w(H) === l;
    }
    function Re(H) {
      return w(H) === a;
    }
    function Se(H) {
      return typeof H == "object" && H !== null && H.$$typeof === r;
    }
    function ye(H) {
      return w(H) === c;
    }
    function Oe(H) {
      return w(H) === o;
    }
    function Ue(H) {
      return w(H) === f;
    }
    function Ve(H) {
      return w(H) === v;
    }
    function U(H) {
      return w(H) === n;
    }
    function j(H) {
      return w(H) === s;
    }
    function P(H) {
      return w(H) === i;
    }
    function Z(H) {
      return w(H) === p;
    }
    at.AsyncMode = _, at.ConcurrentMode = I, at.ContextConsumer = D, at.ContextProvider = B, at.Element = L, at.ForwardRef = R, at.Fragment = y, at.Lazy = A, at.Memo = k, at.Portal = T, at.Profiler = N, at.StrictMode = F, at.Suspense = $, at.isAsyncMode = fe, at.isConcurrentMode = le, at.isContextConsumer = Ae, at.isContextProvider = Re, at.isElement = Se, at.isForwardRef = ye, at.isFragment = Oe, at.isLazy = Ue, at.isMemo = Ve, at.isPortal = U, at.isProfiler = j, at.isStrictMode = P, at.isSuspense = Z, at.isValidElementType = E, at.typeOf = w;
  }(), at;
}
var c8 = {};
c8.NODE_ENV === "production" ? i1.exports = u8() : i1.exports = d8();
var p8 = i1.exports, Yb = p8, h8 = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, f8 = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, Xb = {};
Xb[Yb.ForwardRef] = h8;
Xb[Yb.Memo] = f8;
var v8 = !0;
function m8(e, t, r) {
  var n = "";
  return r.split(" ").forEach(function(o) {
    e[o] !== void 0 ? t.push(e[o] + ";") : n += o + " ";
  }), n;
}
var e3 = function(t, r, n) {
  var o = t.key + "-" + r.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (n === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  v8 === !1) && t.registered[o] === void 0 && (t.registered[o] = r.styles);
}, g8 = function(t, r, n) {
  e3(t, r, n);
  var o = t.key + "-" + r.name;
  if (t.inserted[r.name] === void 0) {
    var i = r;
    do
      t.insert(r === i ? "." + o : "", i, t.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function y8(e) {
  for (var t = 0, r, n = 0, o = e.length; o >= 4; ++n, o -= 4)
    r = e.charCodeAt(n) & 255 | (e.charCodeAt(++n) & 255) << 8 | (e.charCodeAt(++n) & 255) << 16 | (e.charCodeAt(++n) & 255) << 24, r = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), r ^= /* k >>> r: */
    r >>> 24, t = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      t ^= (e.charCodeAt(n + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(n + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(n) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var S8 = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Nn = {}, _g = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, b8 = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", C8 = /[A-Z]|^ms/g, t3 = /_EMO_([^_]+?)_([^]*?)_EMO_/g, Rv = function(t) {
  return t.charCodeAt(1) === 45;
}, Rg = function(t) {
  return t != null && typeof t != "boolean";
}, vp = /* @__PURE__ */ KR(function(e) {
  return Rv(e) ? e : e.replace(C8, "-$&").toLowerCase();
}), fc = function(t, r) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof r == "string")
        return r.replace(t3, function(n, o, i) {
          return qn = {
            name: o,
            styles: i,
            next: qn
          }, o;
        });
  }
  return S8[t] !== 1 && !Rv(t) && typeof r == "number" && r !== 0 ? r + "px" : r;
};
if (Nn.NODE_ENV !== "production") {
  var w8 = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, E8 = ["normal", "none", "initial", "inherit", "unset"], I8 = fc, A8 = /^-ms-/, _8 = /-(.)/g, Og = {};
  fc = function(t, r) {
    if (t === "content" && (typeof r != "string" || E8.indexOf(r) === -1 && !w8.test(r) && (r.charAt(0) !== r.charAt(r.length - 1) || r.charAt(0) !== '"' && r.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + r + "\"'`");
    var n = I8(t, r);
    return n !== "" && !Rv(t) && t.indexOf("-") !== -1 && Og[t] === void 0 && (Og[t] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + t.replace(A8, "ms-").replace(_8, function(o, i) {
      return i.toUpperCase();
    }) + "?")), n;
  };
}
var r3 = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function nu(e, t, r) {
  if (r == null)
    return "";
  if (r.__emotion_styles !== void 0) {
    if (Nn.NODE_ENV !== "production" && r.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(r3);
    return r;
  }
  switch (typeof r) {
    case "boolean":
      return "";
    case "object": {
      if (r.anim === 1)
        return qn = {
          name: r.name,
          styles: r.styles,
          next: qn
        }, r.name;
      if (r.styles !== void 0) {
        var n = r.next;
        if (n !== void 0)
          for (; n !== void 0; )
            qn = {
              name: n.name,
              styles: n.styles,
              next: qn
            }, n = n.next;
        var o = r.styles + ";";
        return Nn.NODE_ENV !== "production" && r.map !== void 0 && (o += r.map), o;
      }
      return R8(e, t, r);
    }
    case "function": {
      if (e !== void 0) {
        var i = qn, s = r(e);
        return qn = i, nu(e, t, s);
      } else
        Nn.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (Nn.NODE_ENV !== "production") {
        var a = [], l = r.replace(t3, function(d, c, p) {
          var h = "animation" + a.length;
          return a.push("const " + h + " = keyframes`" + p.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + h + "}";
        });
        a.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(a, ["`" + l + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + l + "`"));
      }
      break;
  }
  if (t == null)
    return r;
  var u = t[r];
  return u !== void 0 ? u : r;
}
function R8(e, t, r) {
  var n = "";
  if (Array.isArray(r))
    for (var o = 0; o < r.length; o++)
      n += nu(e, t, r[o]) + ";";
  else
    for (var i in r) {
      var s = r[i];
      if (typeof s != "object")
        t != null && t[s] !== void 0 ? n += i + "{" + t[s] + "}" : Rg(s) && (n += vp(i) + ":" + fc(i, s) + ";");
      else {
        if (i === "NO_COMPONENT_SELECTOR" && Nn.NODE_ENV !== "production")
          throw new Error(r3);
        if (Array.isArray(s) && typeof s[0] == "string" && (t == null || t[s[0]] === void 0))
          for (var a = 0; a < s.length; a++)
            Rg(s[a]) && (n += vp(i) + ":" + fc(i, s[a]) + ";");
        else {
          var l = nu(e, t, s);
          switch (i) {
            case "animation":
            case "animationName": {
              n += vp(i) + ":" + l + ";";
              break;
            }
            default:
              Nn.NODE_ENV !== "production" && i === "undefined" && console.error(b8), n += i + "{" + l + "}";
          }
        }
      }
    }
  return n;
}
var Tg = /label:\s*([^\s;\n{]+)\s*(;|$)/g, n3;
Nn.NODE_ENV !== "production" && (n3 = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var qn, kg = function(t, r, n) {
  if (t.length === 1 && typeof t[0] == "object" && t[0] !== null && t[0].styles !== void 0)
    return t[0];
  var o = !0, i = "";
  qn = void 0;
  var s = t[0];
  s == null || s.raw === void 0 ? (o = !1, i += nu(n, r, s)) : (Nn.NODE_ENV !== "production" && s[0] === void 0 && console.error(_g), i += s[0]);
  for (var a = 1; a < t.length; a++)
    i += nu(n, r, t[a]), o && (Nn.NODE_ENV !== "production" && s[a] === void 0 && console.error(_g), i += s[a]);
  var l;
  Nn.NODE_ENV !== "production" && (i = i.replace(n3, function(p) {
    return l = p, "";
  })), Tg.lastIndex = 0;
  for (var u = "", d; (d = Tg.exec(i)) !== null; )
    u += "-" + // $FlowFixMe we know it's not null
    d[1];
  var c = y8(i) + u;
  return Nn.NODE_ENV !== "production" ? {
    name: c,
    styles: i,
    map: l,
    next: qn,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: c,
    styles: i,
    next: qn
  };
}, O8 = function(t) {
  return t();
}, T8 = Zo.useInsertionEffect ? Zo.useInsertionEffect : !1, k8 = T8 || O8, Ts = {}, U0 = {}.hasOwnProperty, Ov = /* @__PURE__ */ Zo.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement != "undefined" ? /* @__PURE__ */ l8({
    key: "css"
  }) : null
);
Ts.NODE_ENV !== "production" && (Ov.displayName = "EmotionCacheContext");
Ov.Provider;
var M8 = function(t) {
  return /* @__PURE__ */ Bb(function(r, n) {
    var o = wv(Ov);
    return t(r, o, n);
  });
}, o3 = /* @__PURE__ */ Zo.createContext({});
Ts.NODE_ENV !== "production" && (o3.displayName = "EmotionThemeContext");
var Mg = function(t) {
  var r = t.split(".");
  return r[r.length - 1];
}, P8 = function(t) {
  var r = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(t);
  if (r || (r = /^([A-Za-z0-9$.]+)@/.exec(t), r))
    return Mg(r[1]);
}, D8 = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), L8 = function(t) {
  return t.replace(/\$/g, "-");
}, N8 = function(t) {
  if (t)
    for (var r = t.split(`
`), n = 0; n < r.length; n++) {
      var o = P8(r[n]);
      if (o) {
        if (D8.has(o))
          break;
        if (/^[A-Z]/.test(o))
          return L8(o);
      }
    }
}, s1 = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", a1 = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", i3 = function(t, r) {
  if (Ts.NODE_ENV !== "production" && typeof r.css == "string" && // check if there is a css declaration
  r.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + r.css + "`");
  var n = {};
  for (var o in r)
    U0.call(r, o) && (n[o] = r[o]);
  if (n[s1] = t, Ts.NODE_ENV !== "production" && r.css && (typeof r.css != "object" || typeof r.css.name != "string" || r.css.name.indexOf("-") === -1)) {
    var i = N8(new Error().stack);
    i && (n[a1] = i);
  }
  return n;
}, x8 = function(t) {
  var r = t.cache, n = t.serialized, o = t.isStringTag;
  return e3(r, n, o), k8(function() {
    return g8(r, n, o);
  }), null;
}, s3 = /* @__PURE__ */ M8(function(e, t, r) {
  var n = e.css;
  typeof n == "string" && t.registered[n] !== void 0 && (n = t.registered[n]);
  var o = e[s1], i = [n], s = "";
  typeof e.className == "string" ? s = m8(t.registered, i, e.className) : e.className != null && (s = e.className + " ");
  var a = kg(i, void 0, Zo.useContext(o3));
  if (Ts.NODE_ENV !== "production" && a.name.indexOf("-") === -1) {
    var l = e[a1];
    l && (a = kg([a, "label:" + l + ";"]));
  }
  s += t.key + "-" + a.name;
  var u = {};
  for (var d in e)
    U0.call(e, d) && d !== "css" && d !== s1 && (Ts.NODE_ENV === "production" || d !== a1) && (u[d] = e[d]);
  return u.ref = r, u.className = s, /* @__PURE__ */ Zo.createElement(Zo.Fragment, null, /* @__PURE__ */ Zo.createElement(x8, {
    cache: t,
    serialized: a,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ Zo.createElement(o, u));
});
Ts.NODE_ENV !== "production" && (s3.displayName = "EmotionCssPropInternal");
var a3 = s3;
function S(e, t, r) {
  return U0.call(t, "css") ? pc.jsx(a3, i3(e, t), r) : pc.jsx(e, t, r);
}
function ie(e, t, r) {
  return U0.call(t, "css") ? pc.jsxs(a3, i3(e, t), r) : pc.jsxs(e, t, r);
}
const V8 = {
  API_CORE: "https://api.conexasaude.com.br",
  APP_ENV_NAME: "PROD"
}, j8 = {
  API_CORE: "https://hml-api.conexasaude.com.br",
  APP_ENV_NAME: "HML"
}, U8 = {
  PROD: V8,
  HML: j8
};
let l3 = class {
  constructor(t, r) {
    this.operator = t, this.value = r, Object.defineProperty(this, "t", { writable: !0 });
  }
  get notes() {
    return this.t;
  }
  addNote(t) {
    this.t = this.t || [], this.t.push(t);
  }
}, Tv = class extends l3 {
}, B0 = class extends Tv {
  constructor(t, r) {
    if (!Array.isArray(r))
      throw new Error(`"${t}" operator expects to receive an array of conditions`);
    super(t, r);
  }
};
const ku = "__itself__";
let $0 = class extends l3 {
  constructor(t, r, n) {
    super(t, n), this.field = r;
  }
};
const u3 = new Tv("__null__", null), l1 = Object.prototype.hasOwnProperty.call.bind(Object.prototype.hasOwnProperty);
function B8(e, t) {
  return t instanceof B0 && t.operator === e;
}
function d3(e, t) {
  return t.length === 1 ? t[0] : new B0(e, function r(n, o, i) {
    const s = i || [];
    for (let a = 0, l = o.length; a < l; a++) {
      const u = o[a];
      B8(n, u) ? r(n, u.value, s) : s.push(u);
    }
    return s;
  }(e, t));
}
const $8 = (e) => e, c3 = () => /* @__PURE__ */ Object.create(null), p3 = Object.defineProperty(c3(), "__@type@__", { value: "ignore value" });
function H8(e, t, r = !1) {
  if (!e || e && e.constructor !== Object)
    return !1;
  for (const n in e)
    if (l1(e, n) && l1(t, n) && (!r || e[n] !== p3))
      return !0;
  return !1;
}
function F8(e) {
  const t = [];
  for (const r in e)
    l1(e, r) && e[r] !== p3 && t.push(r);
  return t;
}
function mp(e, t) {
  t !== u3 && e.push(t);
}
const h3 = (e) => d3("and", e), f3 = { compound(e, t, r) {
  const n = (Array.isArray(t) ? t : [t]).map((o) => r.parse(o));
  return new B0(e.name, n);
}, field: (e, t, r) => new $0(e.name, r.field, t), document: (e, t) => new Tv(e.name, t) };
let z8 = class {
  constructor(t, r = c3()) {
    this.o = void 0, this.s = void 0, this.i = void 0, this.u = void 0, this.h = void 0, this.parse = this.parse.bind(this), this.u = { operatorToConditionName: r.operatorToConditionName || $8, defaultOperatorName: r.defaultOperatorName || "eq", mergeFinalConditions: r.mergeFinalConditions || h3 }, this.o = Object.keys(t).reduce((n, o) => (n[o] = Object.assign({ name: this.u.operatorToConditionName(o) }, t[o]), n), {}), this.s = Object.assign({}, r.fieldContext, { field: "", query: {}, parse: this.parse, hasOperators: (n) => H8(n, this.o, r.useIgnoreValue) }), this.i = Object.assign({}, r.documentContext, { parse: this.parse, query: {} }), this.h = r.useIgnoreValue ? F8 : Object.keys;
  }
  setParse(t) {
    this.parse = t, this.s.parse = t, this.i.parse = t;
  }
  parseField(t, r, n, o) {
    const i = this.o[r];
    if (!i)
      throw new Error(`Unsupported operator "${r}"`);
    if (i.type !== "field")
      throw new Error(`Unexpected ${i.type} operator "${r}" at field level`);
    return this.s.field = t, this.s.query = o, this.parseInstruction(i, n, this.s);
  }
  parseInstruction(t, r, n) {
    return typeof t.validate == "function" && t.validate(t, r), (t.parse || f3[t.type])(t, r, n);
  }
  parseFieldOperators(t, r) {
    const n = [], o = this.h(r);
    for (let i = 0, s = o.length; i < s; i++) {
      const a = o[i];
      if (!this.o[a])
        throw new Error(`Field query for "${t}" may contain only operators or a plain object as a value`);
      mp(n, this.parseField(t, a, r[a], r));
    }
    return n;
  }
  parse(t) {
    const r = [], n = this.h(t);
    this.i.query = t;
    for (let o = 0, i = n.length; o < i; o++) {
      const s = n[o], a = t[s], l = this.o[s];
      if (l) {
        if (l.type !== "document" && l.type !== "compound")
          throw new Error(`Cannot use parsing instruction for operator "${s}" in "document" context as it is supposed to be used in  "${l.type}" context`);
        mp(r, this.parseInstruction(l, a, this.i));
      } else
        this.s.hasOperators(a) ? r.push(...this.parseFieldOperators(s, a)) : mp(r, this.parseField(s, this.u.defaultOperatorName, a, t));
    }
    return this.u.mergeFinalConditions(r);
  }
};
function gp(e, t) {
  const r = e[t];
  if (typeof r != "function")
    throw new Error(`Unable to interpret "${t}" condition. Did you forget to register interpreter for it?`);
  return r;
}
function W8(e) {
  return e.operator;
}
function Z8(e, t) {
  const r = t, n = r && r.getInterpreterName || W8;
  let o;
  switch (r ? r.numberOfArguments : 0) {
    case 1:
      o = (s) => {
        const a = n(s, r);
        return gp(e, a)(s, i);
      };
      break;
    case 3:
      o = (s, a, l) => {
        const u = n(s, r);
        return gp(e, u)(s, a, l, i);
      };
      break;
    default:
      o = (s, a) => {
        const l = n(s, r);
        return gp(e, l)(s, a, i);
      };
  }
  const i = Object.assign({}, r, { interpret: o });
  return i.interpret;
}
function G8(e, t) {
  return (r, ...n) => {
    const o = e(r, ...n), i = t.bind(null, o);
    return i.ast = o, i;
  };
}
function v3(e, t) {
  if (!Array.isArray(t))
    throw new Error(`"${e.name}" expects value to be an array`);
}
function m3(e, t) {
  if (v3(e, t), !t.length)
    throw new Error(`"${e.name}" expects to have at least one element in array`);
}
const kv = (e) => (t, r) => {
  if (typeof r !== e)
    throw new Error(`"${t.name}" expects value to be a "${e}"`);
}, g3 = { type: "compound", validate: m3, parse(e, t, { parse: r }) {
  const n = t.map((o) => r(o));
  return d3(e.name, n);
} }, q8 = g3, K8 = { type: "compound", validate: m3 }, J8 = { type: "field", validate(e, t) {
  if (!(t && (t instanceof RegExp || t.constructor === Object)))
    throw new Error(`"${e.name}" expects to receive either regular expression or object of field operators`);
}, parse(e, t, r) {
  const n = t instanceof RegExp ? new $0("regex", r.field, t) : r.parse(t, r);
  return new B0(e.name, [n]);
} }, y3 = { type: "field", validate(e, t) {
  if (!t || t.constructor !== Object)
    throw new Error(`"${e.name}" expects to receive an object with nested query or field level operators`);
}, parse(e, t, { parse: r, field: n, hasOperators: o }) {
  const i = o(t) ? r(t, { field: ku }) : r(t);
  return new $0(e.name, n, i);
} }, S3 = { type: "field", validate: kv("number") }, H0 = { type: "field", validate: v3 }, b3 = H0, C3 = H0, Q8 = { type: "field", validate(e, t) {
  if (!Array.isArray(t) || t.length !== 2)
    throw new Error(`"${e.name}" expects an array with 2 numeric elements`);
} }, w3 = { type: "field", validate: kv("boolean") }, Mv = { type: "field", validate: function(e, t) {
  if (!(typeof t == "string" || typeof t == "number" || t instanceof Date))
    throw new Error(`"${e.name}" expects value to be comparable (i.e., string, number or date)`);
} }, F0 = Mv, E3 = F0, I3 = F0, Pv = { type: "field" }, A3 = Pv, _3 = { type: "field", validate(e, t) {
  if (!(t instanceof RegExp) && typeof t != "string")
    throw new Error(`"${e.name}" expects value to be a regular expression or a string that represents regular expression`);
}, parse(e, t, r) {
  const n = typeof t == "string" ? new RegExp(t, r.query.$options || "") : t;
  return new $0(e.name, r.field, n);
} }, R3 = { type: "field", parse: () => u3 }, Y8 = { type: "document", validate: kv("function") };
var X8 = Object.freeze({ __proto__: null, $and: g3, $or: q8, $nor: K8, $not: J8, $elemMatch: y3, $size: S3, $in: H0, $nin: b3, $all: C3, $mod: Q8, $exists: w3, $gte: Mv, $gt: F0, $lt: E3, $lte: I3, $eq: Pv, $ne: A3, $regex: _3, $options: R3, $where: Y8 });
let e6 = class extends z8 {
  constructor(t) {
    super(t, { defaultOperatorName: "$eq", operatorToConditionName: (r) => r.slice(1) });
  }
  parse(t, r) {
    return r && r.field ? h3(this.parseFieldOperators(r.field, t)) : super.parse(t);
  }
};
const u1 = X8;
function Dv(e, t, r) {
  for (let n = 0, o = e.length; n < o; n++)
    if (r(e[n], t) === 0)
      return !0;
  return !1;
}
function Lv(e, t) {
  return Array.isArray(e) && Number.isNaN(Number(t));
}
function Pg(e, t, r) {
  if (!Lv(e, t))
    return r(e, t);
  let n = [];
  for (let o = 0; o < e.length; o++) {
    const i = r(e[o], t);
    i !== void 0 && (n = n.concat(i));
  }
  return n;
}
function Vs(e) {
  return (t, r, n) => {
    const o = n.get(r, t.field);
    return Array.isArray(o) ? o.some((i) => e(t, i, n)) : e(t, o, n);
  };
}
const t6 = (e, t) => e[t];
function O3(e, t, r) {
  const n = t.lastIndexOf(".");
  return n === -1 ? [e, t] : [r(e, t.slice(0, n)), t.slice(n + 1)];
}
function r6(e, t, r = t6) {
  if (t === ku)
    return e;
  if (!e)
    throw new Error(`Unable to get field "${t}" out of ${String(e)}.`);
  return function(n, o, i) {
    if (o.indexOf(".") === -1)
      return Pg(n, o, i);
    const s = o.split(".");
    let a = n;
    for (let l = 0, u = s.length; l < u; l++)
      if (a = Pg(a, s[l], i), !a || typeof a != "object")
        return a;
    return a;
  }(e, t, r);
}
function T3(e, t) {
  return e === t ? 0 : e > t ? 1 : -1;
}
function k3(e, t = {}) {
  return Z8(e, Object.assign({ get: r6, compare: T3 }, t));
}
const M3 = (e, t, { interpret: r }) => e.value.some((n) => r(n, t)), n6 = (e, t, r) => !M3(e, t, r), P3 = (e, t, { interpret: r }) => e.value.every((n) => r(n, t)), o6 = (e, t, { interpret: r }) => !r(e.value[0], t), Nv = (e, t, { compare: r, get: n }) => {
  const o = n(t, e.field);
  return Array.isArray(o) && !Array.isArray(e.value) ? Dv(o, e.value, r) : r(o, e.value) === 0;
}, D3 = (e, t, r) => !Nv(e, t, r), L3 = Vs((e, t, r) => {
  const n = r.compare(t, e.value);
  return n === 0 || n === -1;
}), N3 = Vs((e, t, r) => r.compare(t, e.value) === -1), x3 = Vs((e, t, r) => r.compare(t, e.value) === 1), V3 = Vs((e, t, r) => {
  const n = r.compare(t, e.value);
  return n === 0 || n === 1;
}), j3 = (e, t, { get: r }) => {
  if (e.field === ku)
    return t !== void 0;
  const [n, o] = O3(t, e.field, r), i = (s) => s == null ? !!s === e.value : s.hasOwnProperty(o) === e.value;
  return Lv(n, o) ? n.some(i) : i(n);
}, i6 = Vs((e, t) => typeof t == "number" && t % e.value[0] === e.value[1]), U3 = (e, t, { get: r }) => {
  const [n, o] = O3(t, e.field, r), i = (s) => {
    const a = r(s, o);
    return Array.isArray(a) && a.length === e.value;
  };
  return e.field !== ku && Lv(n, o) ? n.some(i) : i(n);
}, B3 = Vs((e, t) => typeof t == "string" && e.value.test(t)), z0 = Vs((e, t, { compare: r }) => Dv(e.value, t, r)), $3 = (e, t, r) => !z0(e, t, r), H3 = (e, t, { compare: r, get: n }) => {
  const o = n(t, e.field);
  return Array.isArray(o) && e.value.every((i) => Dv(o, i, r));
}, F3 = (e, t, { interpret: r, get: n }) => {
  const o = n(t, e.field);
  return Array.isArray(o) && o.some((i) => r(e.value, i));
}, s6 = (e, t) => e.value.call(t);
var a6 = Object.freeze({ __proto__: null, or: M3, nor: n6, and: P3, not: o6, eq: Nv, ne: D3, lte: L3, lt: N3, gt: x3, gte: V3, exists: j3, mod: i6, size: U3, regex: B3, within: z0, nin: $3, all: H3, elemMatch: F3, where: s6 });
const xv = Object.assign({}, a6, { in: z0 });
k3(xv);
function Dg(e) {
  return e instanceof Date ? e.getTime() : e && typeof e.toJSON == "function" ? e.toJSON() : e;
}
const l6 = (e, t) => T3(Dg(e), Dg(t));
function Vv(e, t, r) {
  const n = new e6(e), o = k3(t, Object.assign({ compare: l6 }, r));
  if (r && r.forPrimitives) {
    const i = { field: ku }, s = n.parse;
    n.setParse((a) => s(a, i));
  }
  return G8(n.parse, o);
}
Vv(u1, xv);
Vv(["$and", "$or"].reduce((e, t) => (e[t] = Object.assign({}, e[t], { type: "field" }), e), Object.assign({}, u1, { $nor: Object.assign({}, u1.$nor, { type: "field", parse: f3.compound }) })), xv, { forPrimitives: !0 });
function d1(e) {
  return Array.isArray(e) ? e : [e];
}
const Lg = "__caslSubjectType__", _d = (e) => {
  const t = typeof e;
  return t === "string" || t === "function";
}, u6 = (e) => e.modelName || e.name;
function z3(e) {
  return Object.hasOwn(e, Lg) ? e[Lg] : u6(e.constructor);
}
const Ng = { function: (e) => e.constructor, string: z3 };
function xg(e, t, r) {
  for (let n = r; n < t.length; n++)
    e.push(t[n]);
}
function Vg(e, t) {
  if (!e || !e.length)
    return t || [];
  if (!t || !t.length)
    return e || [];
  let r = 0, n = 0;
  const o = [];
  for (; r < e.length && n < t.length; )
    e[r].priority < t[n].priority ? (o.push(e[r]), r++) : (o.push(t[n]), n++);
  return xg(o, e, r), xg(o, t, n), o;
}
function Zu(e, t, r) {
  let n = e.get(t);
  return n || (n = r(), e.set(t, n)), n;
}
const d6 = (e) => e;
function c6(e, t) {
  if (Array.isArray(e.fields) && !e.fields.length)
    throw new Error("`rawRule.fields` cannot be an empty array. https://bit.ly/390miLa");
  if (e.fields && !t.fieldMatcher)
    throw new Error('You need to pass "fieldMatcher" option in order to restrict access by fields');
  if (e.conditions && !t.conditionsMatcher)
    throw new Error('You need to pass "conditionsMatcher" option in order to restrict access by conditions');
}
let p6 = class {
  constructor(t, r, n = 0) {
    c6(t, r), this.action = r.resolveAction(t.action), this.subject = t.subject, this.inverted = !!t.inverted, this.conditions = t.conditions, this.reason = t.reason, this.origin = t, this.fields = t.fields ? d1(t.fields) : void 0, this.priority = n, this.t = r;
  }
  i() {
    return this.conditions && !this.o && (this.o = this.t.conditionsMatcher(this.conditions)), this.o;
  }
  get ast() {
    const t = this.i();
    return t ? t.ast : void 0;
  }
  matchesConditions(t) {
    return this.conditions ? !t || _d(t) ? !this.inverted : this.i()(t) : !0;
  }
  matchesField(t) {
    return this.fields ? t ? (this.fields && !this.u && (this.u = this.t.fieldMatcher(this.fields)), this.u(t)) : !this.inverted : !0;
  }
};
function h6(e, t) {
  const r = { value: e, prev: t, next: null };
  return t && (t.next = r), r;
}
function f6(e) {
  e.next && (e.next.prev = e.prev), e.prev && (e.prev.next = e.next), e.next = e.prev = null;
}
const v6 = (e) => ({ value: e.value, prev: e.prev, next: e.next }), jg = () => ({ rules: [], merged: !1 }), Ug = () => /* @__PURE__ */ new Map();
let m6 = class {
  constructor(t = [], r = {}) {
    this.h = !1, this.l = /* @__PURE__ */ new Map(), this.p = { conditionsMatcher: r.conditionsMatcher, fieldMatcher: r.fieldMatcher, resolveAction: r.resolveAction || d6 }, this.$ = r.anyAction || "manage", this.A = r.anySubjectType || "all", this.m = t, this.M = !!r.detectSubjectType, this.j = r.detectSubjectType || z3, this.v(t);
  }
  get rules() {
    return this.m;
  }
  detectSubjectType(t) {
    return _d(t) ? t : t ? this.j(t) : this.A;
  }
  update(t) {
    const r = { rules: t, ability: this, target: this };
    return this._("update", r), this.m = t, this.v(t), this._("updated", r), this;
  }
  v(t) {
    const r = /* @__PURE__ */ new Map();
    let n;
    for (let o = t.length - 1; o >= 0; o--) {
      const i = t.length - o - 1, s = new p6(t[o], this.p, i), a = d1(s.action), l = d1(s.subject || this.A);
      !this.h && s.fields && (this.h = !0);
      for (let u = 0; u < l.length; u++) {
        const d = Zu(r, l[u], Ug);
        n === void 0 && (n = typeof l[u]), typeof l[u] !== n && n !== "mixed" && (n = "mixed");
        for (let c = 0; c < a.length; c++)
          Zu(d, a[c], jg).rules.push(s);
      }
    }
    if (this.l = r, n !== "mixed" && !this.M) {
      const o = Ng[n] || Ng.string;
      this.j = o;
    }
  }
  possibleRulesFor(t, r = this.A) {
    if (!_d(r))
      throw new Error('"possibleRulesFor" accepts only subject types (i.e., string or class) as the 2nd parameter');
    const n = Zu(this.l, r, Ug), o = Zu(n, t, jg);
    if (o.merged)
      return o.rules;
    const i = t !== this.$ && n.has(this.$) ? n.get(this.$).rules : void 0;
    let s = Vg(o.rules, i);
    return r !== this.A && (s = Vg(s, this.possibleRulesFor(t, this.A))), o.rules = s, o.merged = !0, s;
  }
  rulesFor(t, r, n) {
    const o = this.possibleRulesFor(t, r);
    if (n && typeof n != "string")
      throw new Error("The 3rd, `field` parameter is expected to be a string. See https://stalniy.github.io/casl/en/api/casl-ability#can-of-pure-ability for details");
    return this.h ? o.filter((i) => i.matchesField(n)) : o;
  }
  actionsFor(t) {
    if (!_d(t))
      throw new Error('"actionsFor" accepts only subject types (i.e., string or class) as a parameter');
    const r = /* @__PURE__ */ new Set(), n = this.l.get(t);
    n && Array.from(n.keys()).forEach((i) => r.add(i));
    const o = t !== this.A ? this.l.get(this.A) : void 0;
    return o && Array.from(o.keys()).forEach((i) => r.add(i)), Array.from(r);
  }
  on(t, r) {
    this.F = this.F || /* @__PURE__ */ new Map();
    const n = this.F, o = n.get(t) || null, i = h6(r, o);
    return n.set(t, i), () => {
      const s = n.get(t);
      !i.next && !i.prev && s === i ? n.delete(t) : i === s && n.set(t, i.prev), f6(i);
    };
  }
  _(t, r) {
    if (!this.F)
      return;
    let n = this.F.get(t) || null;
    for (; n !== null; ) {
      const o = n.prev ? v6(n.prev) : null;
      n.value(r), n = o;
    }
  }
};
class g6 extends m6 {
  can(t, r, n) {
    const o = this.relevantRuleFor(t, r, n);
    return !!o && !o.inverted;
  }
  relevantRuleFor(t, r, n) {
    const o = this.detectSubjectType(r), i = this.rulesFor(t, o, n);
    for (let s = 0, a = i.length; s < a; s++)
      if (i[s].matchesConditions(r))
        return i[s];
    return null;
  }
  cannot(t, r, n) {
    return !this.can(t, r, n);
  }
}
const y6 = { $eq: Pv, $ne: A3, $lt: E3, $lte: I3, $gt: F0, $gte: Mv, $in: H0, $nin: b3, $all: C3, $size: S3, $regex: _3, $options: R3, $elemMatch: y3, $exists: w3 }, S6 = { eq: Nv, ne: D3, lt: N3, lte: L3, gt: x3, gte: V3, in: z0, nin: $3, all: H3, size: U3, regex: B3, elemMatch: F3, exists: j3, and: P3 }, b6 = Vv(y6, S6), C6 = /[-/\\^$+?.()|[\]{}]/g, w6 = /\.?\*+\.?/g, E6 = /\*+/, I6 = /\./g;
function A6(e, t, r) {
  const n = r[0] === "*" || e[0] === "." && e[e.length - 1] === "." ? "+" : "*", o = e.indexOf("**") === -1 ? "[^.]" : ".", i = e.replace(I6, "\\$&").replace(E6, o + n);
  return t + e.length === r.length ? `(?:${i})?` : i;
}
function _6(e, t, r) {
  return e === "." && (r[t - 1] === "*" || r[t + 1] === "*") ? e : `\\${e}`;
}
function R6(e) {
  const t = e.map((n) => n.replace(C6, _6).replace(w6, A6)), r = t.length > 1 ? `(?:${t.join("|")})` : t[0];
  return new RegExp(`^${r}$`);
}
const O6 = (e) => {
  let t;
  return (r) => (typeof t == "undefined" && (t = e.every((n) => n.indexOf("*") === -1) ? null : R6(e)), t === null ? e.indexOf(r) !== -1 : t.test(r));
};
function T6(e = [], t = {}) {
  return new g6(e, Object.assign({ conditionsMatcher: b6, fieldMatcher: O6 }, t));
}
function k6(e) {
  return typeof e.prototype.possibleRulesFor == "function";
}
let M6 = class {
  constructor(t) {
    this.O = t;
  }
  because(t) {
    return this.O.reason = t, this;
  }
};
class P6 {
  constructor(t) {
    this.rules = [], this.C = t, this.can = (r, n, o, i) => this.R(r, n, o, i, !1), this.cannot = (r, n, o, i) => this.R(r, n, o, i, !0), this.build = (r) => k6(this.C) ? new this.C(this.rules, r) : this.C(this.rules, r);
  }
  R(t, r, n, o, i) {
    const s = { action: t };
    return i && (s.inverted = i), r && (s.subject = r, Array.isArray(n) || typeof n == "string" ? s.fields = n : typeof n != "undefined" && (s.conditions = n), typeof o != "undefined" && (s.conditions = o)), this.rules.push(s), new M6(s);
  }
}
const Bg = {
  PROFESSIONAL(e, {
    can: t
  }) {
    t("all", "Controls"), t("expand", "Controls"), t("finish-meet", "Meet"), t(["send-transcription", "transcription"], "Meet", {
      enableTranscription: {
        $eq: !!e.enableTranscription
      }
    });
  },
  PATIENT(e, {
    can: t,
    cannot: r
  }) {
    t("all", "Controls"), t("expand", "Controls"), t(["transcription"], "Meet", {
      enableTranscription: {
        $eq: !!e.enableTranscription
      }
    }), r("change-background", "Controls");
  },
  GUEST(e, {
    can: t,
    cannot: r
  }) {
    t(["toggle-audio", "toggle-video", "chat"], "Controls"), r("change-background", "Controls");
  }
}, D6 = T6;
function L6(e) {
  const t = new P6(D6);
  if (typeof Bg[e.role] != "function")
    throw new Error(`Permissions for role ${e.role} is not defined`);
  return Bg[e.role](e, t), t.build({
    detectSubjectType(n) {
      return n.__typename;
    }
  });
}
const N6 = () => {
};
let x6 = class extends pR {
  constructor(...t) {
    super(...t), this.t = !1, this.i = null, this.o = N6;
  }
  componentWillUnmount() {
    this.o();
  }
  u(t) {
    t !== this.i && (this.o(), this.i = null, t && (this.i = t, this.o = t.on("updated", () => this.forceUpdate())));
  }
  get allowed() {
    return this.t;
  }
  h() {
    const t = this.props, r = t.of || t.a || t.an || t.this || t.on, n = t.not ? "cannot" : "can";
    return t.ability[n](t.I || t.do, r, t.field);
  }
  render() {
    return this.u(this.props.ability), this.t = this.h(), this.props.passThrough || this.t ? this.l() : null;
  }
  l() {
    const { children: t, ability: r } = this.props;
    return typeof t == "function" ? t(this.t, r) : t;
  }
};
function V6(e) {
  return (t) => gg(e, { children: (r) => gg(x6, Object.assign({ ability: r }, t)) });
}
const jv = $b(null), $g = V6(jv.Consumer), j6 = ({
  participant: e,
  children: t
}) => {
  const r = N0(() => L6(e), [e]);
  return /* @__PURE__ */ S(jv.Provider, { value: r, children: t });
}, U6 = () => {
  const e = wv(jv);
  if (!e)
    throw new Error("usePermissionsContext must be used within a PermissionsProvider");
  return e;
};
function Hg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function en(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Hg(Object(r), !0).forEach(function(n) {
      p1(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Hg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function c1(e) {
  return c1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, c1(e);
}
function so(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Fg(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, W3(n.key), n);
  }
}
function ao(e, t, r) {
  return t && Fg(e.prototype, t), r && Fg(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function p1(e, t, r) {
  return (t = W3(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function ou(e, t) {
  if (e == null)
    return {};
  var r, n, o = function(s, a) {
    if (s == null)
      return {};
    var l, u, d = {}, c = Object.keys(s);
    for (u = 0; u < c.length; u++)
      l = c[u], a.indexOf(l) >= 0 || (d[l] = s[l]);
    return d;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (n = 0; n < i.length; n++)
      r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
  }
  return o;
}
function W3(e) {
  var t = function(r, n) {
    if (typeof r != "object" || r === null)
      return r;
    var o = r[Symbol.toPrimitive];
    if (o !== void 0) {
      var i = o.call(r, n || "default");
      if (typeof i != "object")
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (n === "string" ? String : Number)(r);
  }(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
var h1 = function(e, t) {
  return h1 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var o in n)
      Object.prototype.hasOwnProperty.call(n, o) && (r[o] = n[o]);
  }, h1(e, t);
};
function ln(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  function r() {
    this.constructor = e;
  }
  h1(e, t), e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
var Bl = function() {
  return Bl = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++)
      for (var o in t = arguments[r])
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    return e;
  }, Bl.apply(this, arguments);
};
function Z3(e, t) {
  var r, n, o, i, s = { label: 0, sent: function() {
    if (1 & o[0])
      throw o[1];
    return o[1];
  }, trys: [], ops: [] };
  return i = { next: a(0), throw: a(1), return: a(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function a(l) {
    return function(u) {
      return function(d) {
        if (r)
          throw new TypeError("Generator is already executing.");
        for (; i && (i = 0, d[0] && (s = 0)), s; )
          try {
            if (r = 1, n && (o = 2 & d[0] ? n.return : d[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, d[1])).done)
              return o;
            switch (n = 0, o && (d = [2 & d[0], o.value]), d[0]) {
              case 0:
              case 1:
                o = d;
                break;
              case 4:
                return s.label++, { value: d[1], done: !1 };
              case 5:
                s.label++, n = d[1], d = [0];
                continue;
              case 7:
                d = s.ops.pop(), s.trys.pop();
                continue;
              default:
                if (!((o = (o = s.trys).length > 0 && o[o.length - 1]) || d[0] !== 6 && d[0] !== 2)) {
                  s = 0;
                  continue;
                }
                if (d[0] === 3 && (!o || d[1] > o[0] && d[1] < o[3])) {
                  s.label = d[1];
                  break;
                }
                if (d[0] === 6 && s.label < o[1]) {
                  s.label = o[1], o = d;
                  break;
                }
                if (o && s.label < o[2]) {
                  s.label = o[2], s.ops.push(d);
                  break;
                }
                o[2] && s.ops.pop(), s.trys.pop();
                continue;
            }
            d = t.call(e, s);
          } catch (c) {
            d = [6, c], n = 0;
          } finally {
            r = o = 0;
          }
        if (5 & d[0])
          throw d[1];
        return { value: d[0] ? d[1] : void 0, done: !0 };
      }([l, u]);
    };
  }
}
function ja(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r)
    return r.call(e);
  if (e && typeof e.length == "number")
    return { next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    } };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function ro(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n, o, i = r.call(e), s = [];
  try {
    for (; (t === void 0 || t-- > 0) && !(n = i.next()).done; )
      s.push(n.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      n && !n.done && (r = i.return) && r.call(i);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return s;
}
function To(e, t, r) {
  if (r || arguments.length === 2)
    for (var n, o = 0, i = t.length; o < i; o++)
      !n && o in t || (n || (n = Array.prototype.slice.call(t, 0, o)), n[o] = t[o]);
  return e.concat(n || Array.prototype.slice.call(t));
}
function ua(e) {
  return this instanceof ua ? (this.v = e, this) : new ua(e);
}
function B6(e) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var t, r = e[Symbol.asyncIterator];
  return r ? r.call(e) : (e = ja(e), t = {}, n("next"), n("throw"), n("return"), t[Symbol.asyncIterator] = function() {
    return this;
  }, t);
  function n(o) {
    t[o] = e[o] && function(i) {
      return new Promise(function(s, a) {
        (function(l, u, d, c) {
          Promise.resolve(c).then(function(p) {
            l({ value: p, done: d });
          }, u);
        })(s, a, (i = e[o](i)).done, i.value);
      });
    };
  }
}
function it(e) {
  return typeof e == "function";
}
function Mu(e) {
  var t = e(function(r) {
    Error.call(r), r.stack = new Error().stack;
  });
  return t.prototype = Object.create(Error.prototype), t.prototype.constructor = t, t;
}
var yp = Mu(function(e) {
  return function(t) {
    e(this), this.message = t ? t.length + ` errors occurred during unsubscription:
` + t.map(function(r, n) {
      return n + 1 + ") " + r.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = t;
  };
});
function vc(e, t) {
  if (e) {
    var r = e.indexOf(t);
    0 <= r && e.splice(r, 1);
  }
}
var Pu = function() {
  function e(r) {
    this.initialTeardown = r, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  var t;
  return e.prototype.unsubscribe = function() {
    var r, n, o, i, s;
    if (!this.closed) {
      this.closed = !0;
      var a = this._parentage;
      if (a)
        if (this._parentage = null, Array.isArray(a))
          try {
            for (var l = ja(a), u = l.next(); !u.done; u = l.next())
              u.value.remove(this);
          } catch (f) {
            r = { error: f };
          } finally {
            try {
              u && !u.done && (n = l.return) && n.call(l);
            } finally {
              if (r)
                throw r.error;
            }
          }
        else
          a.remove(this);
      var d = this.initialTeardown;
      if (it(d))
        try {
          d();
        } catch (f) {
          s = f instanceof yp ? f.errors : [f];
        }
      var c = this._finalizers;
      if (c) {
        this._finalizers = null;
        try {
          for (var p = ja(c), h = p.next(); !h.done; h = p.next()) {
            var v = h.value;
            try {
              zg(v);
            } catch (f) {
              s = s != null ? s : [], f instanceof yp ? s = To(To([], ro(s)), ro(f.errors)) : s.push(f);
            }
          }
        } catch (f) {
          o = { error: f };
        } finally {
          try {
            h && !h.done && (i = p.return) && i.call(p);
          } finally {
            if (o)
              throw o.error;
          }
        }
      }
      if (s)
        throw new yp(s);
    }
  }, e.prototype.add = function(r) {
    var n;
    if (r && r !== this)
      if (this.closed)
        zg(r);
      else {
        if (r instanceof e) {
          if (r.closed || r._hasParent(this))
            return;
          r._addParent(this);
        }
        (this._finalizers = (n = this._finalizers) !== null && n !== void 0 ? n : []).push(r);
      }
  }, e.prototype._hasParent = function(r) {
    var n = this._parentage;
    return n === r || Array.isArray(n) && n.includes(r);
  }, e.prototype._addParent = function(r) {
    var n = this._parentage;
    this._parentage = Array.isArray(n) ? (n.push(r), n) : n ? [n, r] : r;
  }, e.prototype._removeParent = function(r) {
    var n = this._parentage;
    n === r ? this._parentage = null : Array.isArray(n) && vc(n, r);
  }, e.prototype.remove = function(r) {
    var n = this._finalizers;
    n && vc(n, r), r instanceof e && r._removeParent(this);
  }, e.EMPTY = ((t = new e()).closed = !0, t), e;
}(), G3 = Pu.EMPTY;
function q3(e) {
  return e instanceof Pu || e && "closed" in e && it(e.remove) && it(e.add) && it(e.unsubscribe);
}
function zg(e) {
  it(e) ? e() : e.unsubscribe();
}
var $6 = void 0, H6 = !1, F6 = { setTimeout: function(e, t) {
  for (var r = [], n = 2; n < arguments.length; n++)
    r[n - 2] = arguments[n];
  return setTimeout.apply(void 0, To([e, t], ro(r)));
}, clearTimeout: function(e) {
  return clearTimeout(e);
}, delegate: void 0 };
function K3(e) {
  F6.setTimeout(function() {
    throw e;
  });
}
function iu() {
}
function Rd(e) {
  e();
}
var Uv = function(e) {
  function t(r) {
    var n = e.call(this) || this;
    return n.isStopped = !1, r ? (n.destination = r, q3(r) && r.add(n)) : n.destination = Z6, n;
  }
  return ln(t, e), t.create = function(r, n, o) {
    return new mc(r, n, o);
  }, t.prototype.next = function(r) {
    this.isStopped || this._next(r);
  }, t.prototype.error = function(r) {
    this.isStopped || (this.isStopped = !0, this._error(r));
  }, t.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, t.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, e.prototype.unsubscribe.call(this), this.destination = null);
  }, t.prototype._next = function(r) {
    this.destination.next(r);
  }, t.prototype._error = function(r) {
    try {
      this.destination.error(r);
    } finally {
      this.unsubscribe();
    }
  }, t.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, t;
}(Pu), z6 = Function.prototype.bind;
function Sp(e, t) {
  return z6.call(e, t);
}
var W6 = function() {
  function e(t) {
    this.partialObserver = t;
  }
  return e.prototype.next = function(t) {
    var r = this.partialObserver;
    if (r.next)
      try {
        r.next(t);
      } catch (n) {
        Gu(n);
      }
  }, e.prototype.error = function(t) {
    var r = this.partialObserver;
    if (r.error)
      try {
        r.error(t);
      } catch (n) {
        Gu(n);
      }
    else
      Gu(t);
  }, e.prototype.complete = function() {
    var t = this.partialObserver;
    if (t.complete)
      try {
        t.complete();
      } catch (r) {
        Gu(r);
      }
  }, e;
}(), mc = function(e) {
  function t(r, n, o) {
    var i, s, a = e.call(this) || this;
    return it(r) || !r ? i = { next: r != null ? r : void 0, error: n != null ? n : void 0, complete: o != null ? o : void 0 } : a && H6 ? ((s = Object.create(r)).unsubscribe = function() {
      return a.unsubscribe();
    }, i = { next: r.next && Sp(r.next, s), error: r.error && Sp(r.error, s), complete: r.complete && Sp(r.complete, s) }) : i = r, a.destination = new W6(i), a;
  }
  return ln(t, e), t;
}(Uv);
function Gu(e) {
  K3(e);
}
var Z6 = { closed: !0, next: iu, error: function(e) {
  throw e;
}, complete: iu }, Bv = typeof Symbol == "function" && Symbol.observable || "@@observable";
function W0(e) {
  return e;
}
function ks() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return J3(e);
}
function J3(e) {
  return e.length === 0 ? W0 : e.length === 1 ? e[0] : function(t) {
    return e.reduce(function(r, n) {
      return n(r);
    }, t);
  };
}
var Vt = function() {
  function e(t) {
    t && (this._subscribe = t);
  }
  return e.prototype.lift = function(t) {
    var r = new e();
    return r.source = this, r.operator = t, r;
  }, e.prototype.subscribe = function(t, r, n) {
    var o, i = this, s = (o = t) && o instanceof Uv || function(a) {
      return a && it(a.next) && it(a.error) && it(a.complete);
    }(o) && q3(o) ? t : new mc(t, r, n);
    return Rd(function() {
      var a = i, l = a.operator, u = a.source;
      s.add(l ? l.call(s, u) : u ? i._subscribe(s) : i._trySubscribe(s));
    }), s;
  }, e.prototype._trySubscribe = function(t) {
    try {
      return this._subscribe(t);
    } catch (r) {
      t.error(r);
    }
  }, e.prototype.forEach = function(t, r) {
    var n = this;
    return new (r = Wg(r))(function(o, i) {
      var s = new mc({ next: function(a) {
        try {
          t(a);
        } catch (l) {
          i(l), s.unsubscribe();
        }
      }, error: i, complete: o });
      n.subscribe(s);
    });
  }, e.prototype._subscribe = function(t) {
    var r;
    return (r = this.source) === null || r === void 0 ? void 0 : r.subscribe(t);
  }, e.prototype[Bv] = function() {
    return this;
  }, e.prototype.pipe = function() {
    for (var t = [], r = 0; r < arguments.length; r++)
      t[r] = arguments[r];
    return J3(t)(this);
  }, e.prototype.toPromise = function(t) {
    var r = this;
    return new (t = Wg(t))(function(n, o) {
      var i;
      r.subscribe(function(s) {
        return i = s;
      }, function(s) {
        return o(s);
      }, function() {
        return n(i);
      });
    });
  }, e.create = function(t) {
    return new e(t);
  }, e;
}();
function Wg(e) {
  var t;
  return (t = e != null ? e : $6) !== null && t !== void 0 ? t : Promise;
}
function yr(e) {
  return function(t) {
    if (function(r) {
      return it(r == null ? void 0 : r.lift);
    }(t))
      return t.lift(function(r) {
        try {
          return e(r, this);
        } catch (n) {
          this.error(n);
        }
      });
    throw new TypeError("Unable to lift unknown Observable type");
  };
}
function Ht(e, t, r, n, o) {
  return new G6(e, t, r, n, o);
}
var bp, G6 = function(e) {
  function t(r, n, o, i, s, a) {
    var l = e.call(this, r) || this;
    return l.onFinalize = s, l.shouldUnsubscribe = a, l._next = n ? function(u) {
      try {
        n(u);
      } catch (d) {
        r.error(d);
      }
    } : e.prototype._next, l._error = i ? function(u) {
      try {
        i(u);
      } catch (d) {
        r.error(d);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._error, l._complete = o ? function() {
      try {
        o();
      } catch (u) {
        r.error(u);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._complete, l;
  }
  return ln(t, e), t.prototype.unsubscribe = function() {
    var r;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var n = this.closed;
      e.prototype.unsubscribe.call(this), !n && ((r = this.onFinalize) === null || r === void 0 || r.call(this));
    }
  }, t;
}(Uv), q6 = Mu(function(e) {
  return function() {
    e(this), this.name = "ObjectUnsubscribedError", this.message = "object unsubscribed";
  };
}), xn = function(e) {
  function t() {
    var r = e.call(this) || this;
    return r.closed = !1, r.currentObservers = null, r.observers = [], r.isStopped = !1, r.hasError = !1, r.thrownError = null, r;
  }
  return ln(t, e), t.prototype.lift = function(r) {
    var n = new Zg(this, this);
    return n.operator = r, n;
  }, t.prototype._throwIfClosed = function() {
    if (this.closed)
      throw new q6();
  }, t.prototype.next = function(r) {
    var n = this;
    Rd(function() {
      var o, i;
      if (n._throwIfClosed(), !n.isStopped) {
        n.currentObservers || (n.currentObservers = Array.from(n.observers));
        try {
          for (var s = ja(n.currentObservers), a = s.next(); !a.done; a = s.next())
            a.value.next(r);
        } catch (l) {
          o = { error: l };
        } finally {
          try {
            a && !a.done && (i = s.return) && i.call(s);
          } finally {
            if (o)
              throw o.error;
          }
        }
      }
    });
  }, t.prototype.error = function(r) {
    var n = this;
    Rd(function() {
      if (n._throwIfClosed(), !n.isStopped) {
        n.hasError = n.isStopped = !0, n.thrownError = r;
        for (var o = n.observers; o.length; )
          o.shift().error(r);
      }
    });
  }, t.prototype.complete = function() {
    var r = this;
    Rd(function() {
      if (r._throwIfClosed(), !r.isStopped) {
        r.isStopped = !0;
        for (var n = r.observers; n.length; )
          n.shift().complete();
      }
    });
  }, t.prototype.unsubscribe = function() {
    this.isStopped = this.closed = !0, this.observers = this.currentObservers = null;
  }, Object.defineProperty(t.prototype, "observed", { get: function() {
    var r;
    return ((r = this.observers) === null || r === void 0 ? void 0 : r.length) > 0;
  }, enumerable: !1, configurable: !0 }), t.prototype._trySubscribe = function(r) {
    return this._throwIfClosed(), e.prototype._trySubscribe.call(this, r);
  }, t.prototype._subscribe = function(r) {
    return this._throwIfClosed(), this._checkFinalizedStatuses(r), this._innerSubscribe(r);
  }, t.prototype._innerSubscribe = function(r) {
    var n = this, o = this, i = o.hasError, s = o.isStopped, a = o.observers;
    return i || s ? G3 : (this.currentObservers = null, a.push(r), new Pu(function() {
      n.currentObservers = null, vc(a, r);
    }));
  }, t.prototype._checkFinalizedStatuses = function(r) {
    var n = this, o = n.hasError, i = n.thrownError, s = n.isStopped;
    o ? r.error(i) : s && r.complete();
  }, t.prototype.asObservable = function() {
    var r = new Vt();
    return r.source = this, r;
  }, t.create = function(r, n) {
    return new Zg(r, n);
  }, t;
}(Vt), Zg = function(e) {
  function t(r, n) {
    var o = e.call(this) || this;
    return o.destination = r, o.source = n, o;
  }
  return ln(t, e), t.prototype.next = function(r) {
    var n, o;
    (o = (n = this.destination) === null || n === void 0 ? void 0 : n.next) === null || o === void 0 || o.call(n, r);
  }, t.prototype.error = function(r) {
    var n, o;
    (o = (n = this.destination) === null || n === void 0 ? void 0 : n.error) === null || o === void 0 || o.call(n, r);
  }, t.prototype.complete = function() {
    var r, n;
    (n = (r = this.destination) === null || r === void 0 ? void 0 : r.complete) === null || n === void 0 || n.call(r);
  }, t.prototype._subscribe = function(r) {
    var n, o;
    return (o = (n = this.source) === null || n === void 0 ? void 0 : n.subscribe(r)) !== null && o !== void 0 ? o : G3;
  }, t;
}(xn), K6 = function(e) {
  function t(r) {
    var n = e.call(this) || this;
    return n._value = r, n;
  }
  return ln(t, e), Object.defineProperty(t.prototype, "value", { get: function() {
    return this.getValue();
  }, enumerable: !1, configurable: !0 }), t.prototype._subscribe = function(r) {
    var n = e.prototype._subscribe.call(this, r);
    return !n.closed && r.next(this._value), n;
  }, t.prototype.getValue = function() {
    var r = this, n = r.hasError, o = r.thrownError, i = r._value;
    if (n)
      throw o;
    return this._throwIfClosed(), i;
  }, t.prototype.next = function(r) {
    e.prototype.next.call(this, this._value = r);
  }, t;
}(xn), $v = { now: function() {
  return ($v.delegate || Date).now();
}, delegate: void 0 }, J6 = function(e) {
  function t(r, n, o) {
    r === void 0 && (r = 1 / 0), n === void 0 && (n = 1 / 0), o === void 0 && (o = $v);
    var i = e.call(this) || this;
    return i._bufferSize = r, i._windowTime = n, i._timestampProvider = o, i._buffer = [], i._infiniteTimeWindow = !0, i._infiniteTimeWindow = n === 1 / 0, i._bufferSize = Math.max(1, r), i._windowTime = Math.max(1, n), i;
  }
  return ln(t, e), t.prototype.next = function(r) {
    var n = this, o = n.isStopped, i = n._buffer, s = n._infiniteTimeWindow, a = n._timestampProvider, l = n._windowTime;
    o || (i.push(r), !s && i.push(a.now() + l)), this._trimBuffer(), e.prototype.next.call(this, r);
  }, t.prototype._subscribe = function(r) {
    this._throwIfClosed(), this._trimBuffer();
    for (var n = this._innerSubscribe(r), o = this._infiniteTimeWindow, i = this._buffer.slice(), s = 0; s < i.length && !r.closed; s += o ? 1 : 2)
      r.next(i[s]);
    return this._checkFinalizedStatuses(r), n;
  }, t.prototype._trimBuffer = function() {
    var r = this, n = r._bufferSize, o = r._timestampProvider, i = r._buffer, s = r._infiniteTimeWindow, a = (s ? 1 : 2) * n;
    if (n < 1 / 0 && a < i.length && i.splice(0, i.length - a), !s) {
      for (var l = o.now(), u = 0, d = 1; d < i.length && i[d] <= l; d += 2)
        u = d;
      u && i.splice(0, u + 1);
    }
  }, t;
}(xn), Q6 = function(e) {
  function t(r, n) {
    return e.call(this) || this;
  }
  return ln(t, e), t.prototype.schedule = function(r, n) {
    return this;
  }, t;
}(Pu), f1 = { setInterval: function(e, t) {
  for (var r = [], n = 2; n < arguments.length; n++)
    r[n - 2] = arguments[n];
  var o = f1.delegate;
  return o != null && o.setInterval ? o.setInterval.apply(o, To([e, t], ro(r))) : setInterval.apply(void 0, To([e, t], ro(r)));
}, clearInterval: function(e) {
  return clearInterval(e);
}, delegate: void 0 }, Hv = function(e) {
  function t(r, n) {
    var o = e.call(this, r, n) || this;
    return o.scheduler = r, o.work = n, o.pending = !1, o;
  }
  return ln(t, e), t.prototype.schedule = function(r, n) {
    var o;
    if (n === void 0 && (n = 0), this.closed)
      return this;
    this.state = r;
    var i = this.id, s = this.scheduler;
    return i != null && (this.id = this.recycleAsyncId(s, i, n)), this.pending = !0, this.delay = n, this.id = (o = this.id) !== null && o !== void 0 ? o : this.requestAsyncId(s, this.id, n), this;
  }, t.prototype.requestAsyncId = function(r, n, o) {
    return o === void 0 && (o = 0), f1.setInterval(r.flush.bind(r, this), o);
  }, t.prototype.recycleAsyncId = function(r, n, o) {
    if (o === void 0 && (o = 0), o != null && this.delay === o && this.pending === !1)
      return n;
    n != null && f1.clearInterval(n);
  }, t.prototype.execute = function(r, n) {
    if (this.closed)
      return new Error("executing a cancelled action");
    this.pending = !1;
    var o = this._execute(r, n);
    if (o)
      return o;
    this.pending === !1 && this.id != null && (this.id = this.recycleAsyncId(this.scheduler, this.id, null));
  }, t.prototype._execute = function(r, n) {
    var o, i = !1;
    try {
      this.work(r);
    } catch (s) {
      i = !0, o = s || new Error("Scheduled action threw falsy error");
    }
    if (i)
      return this.unsubscribe(), o;
  }, t.prototype.unsubscribe = function() {
    if (!this.closed) {
      var r = this.id, n = this.scheduler, o = n.actions;
      this.work = this.state = this.scheduler = null, this.pending = !1, vc(o, this), r != null && (this.id = this.recycleAsyncId(n, r, null)), this.delay = null, e.prototype.unsubscribe.call(this);
    }
  }, t;
}(Q6), Y6 = 1, v1 = {};
function Q3(e) {
  return e in v1 && (delete v1[e], !0);
}
var X6 = function(e) {
  var t = Y6++;
  return v1[t] = !0, bp || (bp = Promise.resolve()), bp.then(function() {
    return Q3(t) && e();
  }), t;
}, m1 = { setImmediate: function() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var r = m1.delegate;
  return ((r == null ? void 0 : r.setImmediate) || X6).apply(void 0, To([], ro(e)));
}, clearImmediate: function(e) {
  return function(t) {
    Q3(t);
  }(e);
}, delegate: void 0 }, e9 = function(e) {
  function t(r, n) {
    var o = e.call(this, r, n) || this;
    return o.scheduler = r, o.work = n, o;
  }
  return ln(t, e), t.prototype.requestAsyncId = function(r, n, o) {
    return o === void 0 && (o = 0), o !== null && o > 0 ? e.prototype.requestAsyncId.call(this, r, n, o) : (r.actions.push(this), r._scheduled || (r._scheduled = m1.setImmediate(r.flush.bind(r, void 0))));
  }, t.prototype.recycleAsyncId = function(r, n, o) {
    var i;
    if (o === void 0 && (o = 0), o != null ? o > 0 : this.delay > 0)
      return e.prototype.recycleAsyncId.call(this, r, n, o);
    var s = r.actions;
    n != null && ((i = s[s.length - 1]) === null || i === void 0 ? void 0 : i.id) !== n && (m1.clearImmediate(n), r._scheduled === n && (r._scheduled = void 0));
  }, t;
}(Hv), Gg = function() {
  function e(t, r) {
    r === void 0 && (r = e.now), this.schedulerActionCtor = t, this.now = r;
  }
  return e.prototype.schedule = function(t, r, n) {
    return r === void 0 && (r = 0), new this.schedulerActionCtor(this, t).schedule(n, r);
  }, e.now = $v.now, e;
}(), Fv = function(e) {
  function t(r, n) {
    n === void 0 && (n = Gg.now);
    var o = e.call(this, r, n) || this;
    return o.actions = [], o._active = !1, o;
  }
  return ln(t, e), t.prototype.flush = function(r) {
    var n = this.actions;
    if (this._active)
      n.push(r);
    else {
      var o;
      this._active = !0;
      do
        if (o = r.execute(r.state, r.delay))
          break;
      while (r = n.shift());
      if (this._active = !1, o) {
        for (; r = n.shift(); )
          r.unsubscribe();
        throw o;
      }
    }
  }, t;
}(Gg), Du = new (function(e) {
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return ln(t, e), t.prototype.flush = function(r) {
    this._active = !0;
    var n = this._scheduled;
    this._scheduled = void 0;
    var o, i = this.actions;
    r = r || i.shift();
    do
      if (o = r.execute(r.state, r.delay))
        break;
    while ((r = i[0]) && r.id === n && i.shift());
    if (this._active = !1, o) {
      for (; (r = i[0]) && r.id === n && i.shift(); )
        r.unsubscribe();
      throw o;
    }
  }, t;
}(Fv))(e9), ri = new Fv(Hv), t9 = ri, r9 = function(e) {
  function t(r, n) {
    var o = e.call(this, r, n) || this;
    return o.scheduler = r, o.work = n, o;
  }
  return ln(t, e), t.prototype.schedule = function(r, n) {
    return n === void 0 && (n = 0), n > 0 ? e.prototype.schedule.call(this, r, n) : (this.delay = n, this.state = r, this.scheduler.flush(this), this);
  }, t.prototype.execute = function(r, n) {
    return n > 0 || this.closed ? e.prototype.execute.call(this, r, n) : this._execute(r, n);
  }, t.prototype.requestAsyncId = function(r, n, o) {
    return o === void 0 && (o = 0), o != null && o > 0 || o == null && this.delay > 0 ? e.prototype.requestAsyncId.call(this, r, n, o) : (r.flush(this), 0);
  }, t;
}(Hv), qg = new (function(e) {
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return ln(t, e), t;
}(Fv))(r9), oe = new Vt(function(e) {
  return e.complete();
});
function Y3(e) {
  return e && it(e.schedule);
}
function zv(e) {
  return e[e.length - 1];
}
function X3(e) {
  return it(zv(e)) ? e.pop() : void 0;
}
function Z0(e) {
  return Y3(zv(e)) ? e.pop() : void 0;
}
var Wv = function(e) {
  return e && typeof e.length == "number" && typeof e != "function";
};
function e4(e) {
  return it(e == null ? void 0 : e.then);
}
function t4(e) {
  return it(e[Bv]);
}
function r4(e) {
  return Symbol.asyncIterator && it(e == null ? void 0 : e[Symbol.asyncIterator]);
}
function n4(e) {
  return new TypeError("You provided " + (e !== null && typeof e == "object" ? "an invalid object" : "'" + e + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
var o4 = typeof Symbol == "function" && Symbol.iterator ? Symbol.iterator : "@@iterator";
function i4(e) {
  return it(e == null ? void 0 : e[o4]);
}
function s4(e) {
  return function(t, r, n) {
    if (!Symbol.asyncIterator)
      throw new TypeError("Symbol.asyncIterator is not defined.");
    var o, i = n.apply(t, r || []), s = [];
    return o = {}, a("next"), a("throw"), a("return"), o[Symbol.asyncIterator] = function() {
      return this;
    }, o;
    function a(p) {
      i[p] && (o[p] = function(h) {
        return new Promise(function(v, f) {
          s.push([p, h, v, f]) > 1 || l(p, h);
        });
      });
    }
    function l(p, h) {
      try {
        (function(v) {
          v.value instanceof ua ? Promise.resolve(v.value.v).then(u, d) : c(s[0][2], v);
        })(i[p](h));
      } catch (v) {
        c(s[0][3], v);
      }
    }
    function u(p) {
      l("next", p);
    }
    function d(p) {
      l("throw", p);
    }
    function c(p, h) {
      p(h), s.shift(), s.length && l(s[0][0], s[0][1]);
    }
  }(this, arguments, function() {
    var t, r, n;
    return Z3(this, function(o) {
      switch (o.label) {
        case 0:
          t = e.getReader(), o.label = 1;
        case 1:
          o.trys.push([1, , 9, 10]), o.label = 2;
        case 2:
          return [4, ua(t.read())];
        case 3:
          return r = o.sent(), n = r.value, r.done ? [4, ua(void 0)] : [3, 5];
        case 4:
          return [2, o.sent()];
        case 5:
          return [4, ua(n)];
        case 6:
          return [4, o.sent()];
        case 7:
          return o.sent(), [3, 2];
        case 8:
          return [3, 10];
        case 9:
          return t.releaseLock(), [7];
        case 10:
          return [2];
      }
    });
  });
}
function a4(e) {
  return it(e == null ? void 0 : e.getReader);
}
function vr(e) {
  if (e instanceof Vt)
    return e;
  if (e != null) {
    if (t4(e))
      return o = e, new Vt(function(i) {
        var s = o[Bv]();
        if (it(s.subscribe))
          return s.subscribe(i);
        throw new TypeError("Provided object does not correctly implement Symbol.observable");
      });
    if (Wv(e))
      return n = e, new Vt(function(i) {
        for (var s = 0; s < n.length && !i.closed; s++)
          i.next(n[s]);
        i.complete();
      });
    if (e4(e))
      return r = e, new Vt(function(i) {
        r.then(function(s) {
          i.closed || (i.next(s), i.complete());
        }, function(s) {
          return i.error(s);
        }).then(null, K3);
      });
    if (r4(e))
      return Kg(e);
    if (i4(e))
      return t = e, new Vt(function(i) {
        var s, a;
        try {
          for (var l = ja(t), u = l.next(); !u.done; u = l.next()) {
            var d = u.value;
            if (i.next(d), i.closed)
              return;
          }
        } catch (c) {
          s = { error: c };
        } finally {
          try {
            u && !u.done && (a = l.return) && a.call(l);
          } finally {
            if (s)
              throw s.error;
          }
        }
        i.complete();
      });
    if (a4(e))
      return Kg(s4(e));
  }
  var t, r, n, o;
  throw n4(e);
}
function Kg(e) {
  return new Vt(function(t) {
    (function(r, n) {
      var o, i, s, a;
      return function(l, u, d, c) {
        return new (d || (d = Promise))(function(p, h) {
          function v(g) {
            try {
              m(c.next(g));
            } catch (C) {
              h(C);
            }
          }
          function f(g) {
            try {
              m(c.throw(g));
            } catch (C) {
              h(C);
            }
          }
          function m(g) {
            var C;
            g.done ? p(g.value) : (C = g.value, C instanceof d ? C : new d(function(b) {
              b(C);
            })).then(v, f);
          }
          m((c = c.apply(l, u || [])).next());
        });
      }(this, void 0, void 0, function() {
        var l, u;
        return Z3(this, function(d) {
          switch (d.label) {
            case 0:
              d.trys.push([0, 5, 6, 11]), o = B6(r), d.label = 1;
            case 1:
              return [4, o.next()];
            case 2:
              if ((i = d.sent()).done)
                return [3, 4];
              if (l = i.value, n.next(l), n.closed)
                return [2];
              d.label = 3;
            case 3:
              return [3, 1];
            case 4:
              return [3, 11];
            case 5:
              return u = d.sent(), s = { error: u }, [3, 11];
            case 6:
              return d.trys.push([6, , 9, 10]), i && !i.done && (a = o.return) ? [4, a.call(o)] : [3, 8];
            case 7:
              d.sent(), d.label = 8;
            case 8:
              return [3, 10];
            case 9:
              if (s)
                throw s.error;
              return [7];
            case 10:
              return [7];
            case 11:
              return n.complete(), [2];
          }
        });
      });
    })(e, t).catch(function(r) {
      return t.error(r);
    });
  });
}
function Pi(e, t, r, n, o) {
  n === void 0 && (n = 0), o === void 0 && (o = !1);
  var i = t.schedule(function() {
    r(), o ? e.add(this.schedule(null, n)) : this.unsubscribe();
  }, n);
  if (e.add(i), !o)
    return i;
}
function Fr(e, t) {
  return t === void 0 && (t = 0), yr(function(r, n) {
    r.subscribe(Ht(n, function(o) {
      return Pi(n, e, function() {
        return n.next(o);
      }, t);
    }, function() {
      return Pi(n, e, function() {
        return n.complete();
      }, t);
    }, function(o) {
      return Pi(n, e, function() {
        return n.error(o);
      }, t);
    }));
  });
}
function g1(e, t) {
  return t === void 0 && (t = 0), yr(function(r, n) {
    n.add(e.schedule(function() {
      return r.subscribe(n);
    }, t));
  });
}
function Jg(e, t) {
  if (!e)
    throw new Error("Iterable cannot be null");
  return new Vt(function(r) {
    Pi(r, t, function() {
      var n = e[Symbol.asyncIterator]();
      Pi(r, t, function() {
        n.next().then(function(o) {
          o.done ? r.complete() : r.next(o.value);
        });
      }, 0, !0);
    });
  });
}
function ne(e, t) {
  return t ? function(r, n) {
    if (r != null) {
      if (t4(r))
        return function(o, i) {
          return vr(o).pipe(g1(i), Fr(i));
        }(r, n);
      if (Wv(r))
        return function(o, i) {
          return new Vt(function(s) {
            var a = 0;
            return i.schedule(function() {
              a === o.length ? s.complete() : (s.next(o[a++]), s.closed || this.schedule());
            });
          });
        }(r, n);
      if (e4(r))
        return function(o, i) {
          return vr(o).pipe(g1(i), Fr(i));
        }(r, n);
      if (r4(r))
        return Jg(r, n);
      if (i4(r))
        return function(o, i) {
          return new Vt(function(s) {
            var a;
            return Pi(s, i, function() {
              a = o[o4](), Pi(s, i, function() {
                var l, u, d;
                try {
                  u = (l = a.next()).value, d = l.done;
                } catch (c) {
                  return void s.error(c);
                }
                d ? s.complete() : s.next(u);
              }, 0, !0);
            }), function() {
              return it(a == null ? void 0 : a.return) && a.return();
            };
          });
        }(r, n);
      if (a4(r))
        return function(o, i) {
          return Jg(s4(o), i);
        }(r, n);
    }
    throw n4(r);
  }(e, t) : vr(e);
}
function Je() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return ne(e, Z0(e));
}
function cs(e, t) {
  var r = it(e) ? e : function() {
    return e;
  }, n = function(o) {
    return o.error(r());
  };
  return new Vt(t ? function(o) {
    return t.schedule(n, 0, o);
  } : n);
}
var n9 = Mu(function(e) {
  return function() {
    e(this), this.name = "EmptyError", this.message = "no elements in sequence";
  };
});
function gr(e, t) {
  var r = typeof t == "object";
  return new Promise(function(n, o) {
    var i = new mc({ next: function(s) {
      n(s), i.unsubscribe();
    }, error: o, complete: function() {
      r ? n(t.defaultValue) : o(new n9());
    } });
    e.subscribe(i);
  });
}
function l4(e) {
  return e instanceof Date && !isNaN(e);
}
var o9 = Mu(function(e) {
  return function(t) {
    t === void 0 && (t = null), e(this), this.message = "Timeout has occurred", this.name = "TimeoutError", this.info = t;
  };
});
function u4(e, t) {
  var r = l4(e) ? { first: e } : typeof e == "number" ? { each: e } : e, n = r.first, o = r.each, i = r.with, s = i === void 0 ? i9 : i, a = r.scheduler, l = a === void 0 ? t != null ? t : ri : a, u = r.meta, d = u === void 0 ? null : u;
  if (n == null && o == null)
    throw new TypeError("No timeout provided.");
  return yr(function(c, p) {
    var h, v, f = null, m = 0, g = function(C) {
      v = Pi(p, l, function() {
        try {
          h.unsubscribe(), vr(s({ meta: d, lastValue: f, seen: m })).subscribe(p);
        } catch (b) {
          p.error(b);
        }
      }, C);
    };
    h = c.subscribe(Ht(p, function(C) {
      v == null || v.unsubscribe(), m++, p.next(f = C), o > 0 && g(o);
    }, void 0, void 0, function() {
      v != null && v.closed || v == null || v.unsubscribe(), f = null;
    })), !m && g(n != null ? typeof n == "number" ? n : +n - l.now() : o);
  });
}
function i9(e) {
  throw new o9(e);
}
function ae(e, t) {
  return yr(function(r, n) {
    var o = 0;
    r.subscribe(Ht(n, function(i) {
      n.next(e.call(t, i, o++));
    }));
  });
}
var s9 = Array.isArray;
function Zv(e) {
  return ae(function(t) {
    return function(r, n) {
      return s9(n) ? r.apply(void 0, To([], ro(n))) : r(n);
    }(e, t);
  });
}
var a9 = Array.isArray, l9 = Object.getPrototypeOf, u9 = Object.prototype, d9 = Object.keys;
function G(e, t, r) {
  return r === void 0 && (r = 1 / 0), it(t) ? G(function(n, o) {
    return ae(function(i, s) {
      return t(n, i, o, s);
    })(vr(e(n, o)));
  }, r) : (typeof t == "number" && (r = t), yr(function(n, o) {
    return function(i, s, a, l, u, d, c, p) {
      var h = [], v = 0, f = 0, m = !1, g = function() {
        !m || h.length || v || s.complete();
      }, C = function(E) {
        return v < l ? b(E) : h.push(E);
      }, b = function(E) {
        v++;
        var w = !1;
        vr(a(E, f++)).subscribe(Ht(s, function(_) {
          s.next(_);
        }, function() {
          w = !0;
        }, void 0, function() {
          if (w)
            try {
              v--;
              for (var _ = function() {
                var I = h.shift();
                b(I);
              }; h.length && v < l; )
                _();
              g();
            } catch (I) {
              s.error(I);
            }
        }));
      };
      return i.subscribe(Ht(s, C, function() {
        m = !0, g();
      })), function() {
      };
    }(n, o, e, r);
  }));
}
function d4(e) {
  return e === void 0 && (e = 1 / 0), G(W0, e);
}
function Ua() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return d4(1)(ne(e, Z0(e)));
}
function G0() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var r = X3(e), n = function(a) {
    if (a.length === 1) {
      var l = a[0];
      if (a9(l))
        return { args: l, keys: null };
      if ((d = l) && typeof d == "object" && l9(d) === u9) {
        var u = d9(l);
        return { args: u.map(function(c) {
          return l[c];
        }), keys: u };
      }
    }
    var d;
    return { args: a, keys: null };
  }(e), o = n.args, i = n.keys, s = new Vt(function(a) {
    var l = o.length;
    if (l)
      for (var u = new Array(l), d = l, c = l, p = function(v) {
        var f = !1;
        vr(o[v]).subscribe(Ht(a, function(m) {
          f || (f = !0, c--), u[v] = m;
        }, function() {
          return d--;
        }, void 0, function() {
          d && f || (c || a.next(i ? function(m, g) {
            return m.reduce(function(C, b, E) {
              return C[b] = g[E], C;
            }, {});
          }(i, u) : u), a.complete());
        }));
      }, h = 0; h < l; h++)
        p(h);
    else
      a.complete();
  });
  return r ? s.pipe(Zv(r)) : s;
}
var c9 = ["addListener", "removeListener"], p9 = ["addEventListener", "removeEventListener"], h9 = ["on", "off"];
function Ct(e, t, r, n) {
  if (it(r) && (n = r, r = void 0), n)
    return Ct(e, t, r).pipe(Zv(n));
  var o = ro(function(a) {
    return it(a.addEventListener) && it(a.removeEventListener);
  }(e) ? p9.map(function(a) {
    return function(l) {
      return e[a](t, l, r);
    };
  }) : function(a) {
    return it(a.addListener) && it(a.removeListener);
  }(e) ? c9.map(Qg(e, t)) : function(a) {
    return it(a.on) && it(a.off);
  }(e) ? h9.map(Qg(e, t)) : [], 2), i = o[0], s = o[1];
  if (!i && Wv(e))
    return G(function(a) {
      return Ct(a, t, r);
    })(vr(e));
  if (!i)
    throw new TypeError("Invalid event target");
  return new Vt(function(a) {
    var l = function() {
      for (var u = [], d = 0; d < arguments.length; d++)
        u[d] = arguments[d];
      return a.next(1 < u.length ? u : u[0]);
    };
    return i(l), function() {
      return s(l);
    };
  });
}
function Qg(e, t) {
  return function(r) {
    return function(n) {
      return e[r](t, n);
    };
  };
}
function _i(e, t, r) {
  return r ? _i(e, t).pipe(Zv(r)) : new Vt(function(n) {
    var o = function() {
      for (var s = [], a = 0; a < arguments.length; a++)
        s[a] = arguments[a];
      return n.next(s.length === 1 ? s[0] : s);
    }, i = e(o);
    return it(t) ? function() {
      return t(o, i);
    } : void 0;
  });
}
function nr(e, t, r) {
  e === void 0 && (e = 0), r === void 0 && (r = t9);
  var n = -1;
  return t != null && (Y3(t) ? r = t : n = t), new Vt(function(o) {
    var i = l4(e) ? +e - r.now() : e;
    i < 0 && (i = 0);
    var s = 0;
    return r.schedule(function() {
      o.closed || (o.next(s++), 0 <= n ? this.schedule(void 0, n) : o.complete());
    }, i);
  });
}
function ps(e, t) {
  return e === void 0 && (e = 0), t === void 0 && (t = ri), e < 0 && (e = 0), nr(e, e, t);
}
function Kt() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var r = Z0(e), n = function(i, s) {
    return typeof zv(i) == "number" ? i.pop() : 1 / 0;
  }(e), o = e;
  return o.length ? o.length === 1 ? vr(o[0]) : d4(n)(ne(o, r)) : oe;
}
var f9 = Array.isArray;
function v9(e, t) {
  return function(r, n) {
    return !e.call(t, r, n);
  };
}
function z(e, t) {
  return yr(function(r, n) {
    var o = 0;
    r.subscribe(Ht(n, function(i) {
      return e.call(t, i, o++) && n.next(i);
    }));
  });
}
function Vn() {
  for (var e, t = [], r = 0; r < arguments.length; r++)
    t[r] = arguments[r];
  return (t = (e = t).length === 1 && f9(e[0]) ? e[0] : e).length === 1 ? vr(t[0]) : new Vt(/* @__PURE__ */ function(n) {
    return function(o) {
      for (var i = [], s = function(l) {
        i.push(vr(n[l]).subscribe(Ht(o, function(u) {
          if (i) {
            for (var d = 0; d < i.length; d++)
              d !== l && i[d].unsubscribe();
            i = null;
          }
          o.next(u);
        })));
      }, a = 0; i && !o.closed && a < n.length; a++)
        s(a);
    };
  }(t));
}
function Xn(e) {
  return yr(function(t, r) {
    var n, o = null, i = !1;
    o = t.subscribe(Ht(r, void 0, void 0, function(s) {
      n = vr(e(s, Xn(e)(t))), o ? (o.unsubscribe(), o = null, n.subscribe(r)) : i = !0;
    })), i && (o.unsubscribe(), o = null, n.subscribe(r));
  });
}
function Ge(e) {
  return e <= 0 ? function() {
    return oe;
  } : yr(function(t, r) {
    var n = 0;
    t.subscribe(Ht(r, function(o) {
      ++n <= e && (r.next(o), e <= n && r.complete());
    }));
  });
}
function tn(e) {
  return ae(function() {
    return e;
  });
}
function c4(e, t) {
  return t ? function(r) {
    return Ua(t.pipe(Ge(1), yr(function(n, o) {
      n.subscribe(Ht(o, iu));
    })), r.pipe(c4(e)));
  } : G(function(r, n) {
    return vr(e(r, n)).pipe(Ge(1), tn(r));
  });
}
function Ba(e, t) {
  t === void 0 && (t = ri);
  var r = nr(e, t);
  return c4(function() {
    return r;
  });
}
function Ie(e, t, r) {
  return r === void 0 && (r = 1 / 0), it(t) ? G(function() {
    return e;
  }, t, r) : (typeof t == "number" && (r = t), G(function() {
    return e;
  }, r));
}
function m9(e, t) {
  return yr(/* @__PURE__ */ function(r, n, o, i, s) {
    return function(a, l) {
      var u = o, d = n, c = 0;
      a.subscribe(Ht(l, function(p) {
        var h = c++;
        d = u ? r(d, p, h) : (u = !0, p), l.next(d);
      }, void 0));
    };
  }(e, t, arguments.length >= 2));
}
function p4(e) {
  return yr(function(t, r) {
    var n = !1, o = 0;
    t.subscribe(Ht(r, function(i) {
      return (n || (n = !e(i, o++))) && r.next(i);
    }));
  });
}
function jn() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var r = Z0(e);
  return yr(function(n, o) {
    (r ? Ua(e, n, r) : Ua(e, n)).subscribe(o);
  });
}
function ze(e, t) {
  return yr(function(r, n) {
    var o = null, i = 0, s = !1, a = function() {
      return s && !o && n.complete();
    };
    r.subscribe(Ht(n, function(l) {
      o == null || o.unsubscribe();
      var u = 0, d = i++;
      vr(e(l, d)).subscribe(o = Ht(n, function(c) {
        return n.next(t ? t(l, c, d, u++) : c);
      }, function() {
        o = null, a();
      }));
    }, function() {
      s = !0, a();
    }));
  });
}
function da(e) {
  return yr(function(t, r) {
    vr(e).subscribe(Ht(r, function() {
      return r.complete();
    }, iu)), !r.closed && t.subscribe(r);
  });
}
function hs(e, t) {
  return t === void 0 && (t = !1), yr(function(r, n) {
    var o = 0;
    r.subscribe(Ht(n, function(i) {
      var s = e(i, o++);
      (s || t) && n.next(i), !s && n.complete();
    }));
  });
}
function he(e, t, r) {
  var n = it(e) || t || r ? { next: e, error: t, complete: r } : e;
  return n ? yr(function(o, i) {
    var s;
    (s = n.subscribe) === null || s === void 0 || s.call(n);
    var a = !0;
    o.subscribe(Ht(i, function(l) {
      var u;
      (u = n.next) === null || u === void 0 || u.call(n, l), i.next(l);
    }, function() {
      var l;
      a = !1, (l = n.complete) === null || l === void 0 || l.call(n), i.complete();
    }, function(l) {
      var u;
      a = !1, (u = n.error) === null || u === void 0 || u.call(n, l), i.error(l);
    }, function() {
      var l, u;
      a && ((l = n.unsubscribe) === null || l === void 0 || l.call(n)), (u = n.finalize) === null || u === void 0 || u.call(n);
    }));
  }) : W0;
}
function pe() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var r = X3(e);
  return yr(function(n, o) {
    for (var i = e.length, s = new Array(i), a = e.map(function() {
      return !1;
    }), l = !1, u = function(c) {
      vr(e[c]).subscribe(Ht(o, function(p) {
        s[c] = p, l || a[c] || (a[c] = !0, (l = a.every(W0)) && (a = null));
      }, iu));
    }, d = 0; d < i; d++)
      u(d);
    n.subscribe(Ht(o, function(c) {
      if (l) {
        var p = To([c], ro(s));
        o.next(r ? r.apply(void 0, To([], ro(p))) : p);
      }
    }));
  });
}
function $l(e) {
  return $l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, $l(e);
}
function g9(e, t, r) {
  return (t = function(n) {
    var o = function(i, s) {
      if ($l(i) !== "object" || i === null)
        return i;
      var a = i[Symbol.toPrimitive];
      if (a !== void 0) {
        var l = a.call(i, "string");
        if ($l(l) !== "object")
          return l;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return String(i);
    }(n);
    return $l(o) === "symbol" ? o : String(o);
  }(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Yg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Xg(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Yg(Object(r), !0).forEach(function(n) {
      g9(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Yg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Dr(e) {
  return "Minified Redux error #" + e + "; visit https://redux.js.org/Errors?code=" + e + " for the full message or use the non-minified dev environment for full errors. ";
}
var e2 = typeof Symbol == "function" && Symbol.observable || "@@observable", Cp = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, gc = { INIT: "@@redux/INIT" + Cp(), REPLACE: "@@redux/REPLACE" + Cp(), PROBE_UNKNOWN_ACTION: function() {
  return "@@redux/PROBE_UNKNOWN_ACTION" + Cp();
} };
function h4(e, t, r) {
  var n;
  if (typeof t == "function" && typeof r == "function" || typeof r == "function" && typeof arguments[3] == "function")
    throw new Error(Dr(0));
  if (typeof t == "function" && r === void 0 && (r = t, t = void 0), r !== void 0) {
    if (typeof r != "function")
      throw new Error(Dr(1));
    return r(h4)(e, t);
  }
  if (typeof e != "function")
    throw new Error(Dr(2));
  var o = e, i = t, s = [], a = s, l = !1;
  function u() {
    a === s && (a = s.slice());
  }
  function d() {
    if (l)
      throw new Error(Dr(3));
    return i;
  }
  function c(h) {
    if (typeof h != "function")
      throw new Error(Dr(4));
    if (l)
      throw new Error(Dr(5));
    var v = !0;
    return u(), a.push(h), function() {
      if (v) {
        if (l)
          throw new Error(Dr(6));
        v = !1, u();
        var f = a.indexOf(h);
        a.splice(f, 1), s = null;
      }
    };
  }
  function p(h) {
    if (!function(m) {
      if (typeof m != "object" || m === null)
        return !1;
      for (var g = m; Object.getPrototypeOf(g) !== null; )
        g = Object.getPrototypeOf(g);
      return Object.getPrototypeOf(m) === g;
    }(h))
      throw new Error(Dr(7));
    if (h.type === void 0)
      throw new Error(Dr(8));
    if (l)
      throw new Error(Dr(9));
    try {
      l = !0, i = o(i, h);
    } finally {
      l = !1;
    }
    for (var v = s = a, f = 0; f < v.length; f++)
      (0, v[f])();
    return h;
  }
  return p({ type: gc.INIT }), (n = { dispatch: p, subscribe: c, getState: d, replaceReducer: function(h) {
    if (typeof h != "function")
      throw new Error(Dr(10));
    o = h, p({ type: gc.REPLACE });
  } })[e2] = function() {
    var h, v = c;
    return (h = { subscribe: function(f) {
      if (typeof f != "object" || f === null)
        throw new Error(Dr(11));
      function m() {
        f.next && f.next(d());
      }
      return m(), { unsubscribe: v(m) };
    } })[e2] = function() {
      return this;
    }, h;
  }, n;
}
function f4() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return t.length === 0 ? function(n) {
    return n;
  } : t.length === 1 ? t[0] : t.reduce(function(n, o) {
    return function() {
      return n(o.apply(void 0, arguments));
    };
  });
}
var y1 = function(e, t) {
  return y1 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var o in n)
      Object.prototype.hasOwnProperty.call(n, o) && (r[o] = n[o]);
  }, y1(e, t);
}, y9 = function(e) {
  function t(r, n) {
    var o = e.call(this, function(i) {
      var s = o.__notifier.subscribe(i);
      return s && !s.closed && i.next(o.value), s;
    }) || this;
    return o.__notifier = new xn(), o.value = n, r.subscribe(function(i) {
      i !== o.value && (o.value = i, o.__notifier.next(i));
    }), o;
  }
  return function(r, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    function o() {
      this.constructor = r;
    }
    y1(r, n), r.prototype = n === null ? Object.create(n) : (o.prototype = n.prototype, new o());
  }(t, e), t;
}(Vt), t2 = function(e, t) {
  return e === t || typeof t == "function" && e === t.toString();
};
function ge() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var r = e.length;
  return z(r === 1 ? function(n) {
    return t2(n.type, e[0]);
  } : function(n) {
    for (var o = 0; o < r; o++)
      if (t2(n.type, e[o]))
        return !0;
    return !1;
  });
}
var S9 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
  return typeof e;
} : function(e) {
  return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
};
function qu(e, t) {
  e.super_ = t, e.prototype = Object.create(t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } });
}
function Ku(e, t) {
  Object.defineProperty(this, "kind", { value: e, enumerable: !0 }), t && t.length && Object.defineProperty(this, "path", { value: t, enumerable: !0 });
}
(typeof global == "undefined" ? "undefined" : S9(global)) === "object" && global && global, qu(function e(t, r, n) {
  e.super_.call(this, "E", t), Object.defineProperty(this, "lhs", { value: r, enumerable: !0 }), Object.defineProperty(this, "rhs", { value: n, enumerable: !0 });
}, Ku), qu(function e(t, r) {
  e.super_.call(this, "N", t), Object.defineProperty(this, "rhs", { value: r, enumerable: !0 });
}, Ku), qu(function e(t, r) {
  e.super_.call(this, "D", t), Object.defineProperty(this, "lhs", { value: r, enumerable: !0 });
}, Ku), qu(function e(t, r, n) {
  e.super_.call(this, "A", t), Object.defineProperty(this, "index", { value: r, enumerable: !0 }), Object.defineProperty(this, "item", { value: n, enumerable: !0 });
}, Ku);
const xi = !1;
var fs = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function r2(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function v4(e) {
  if (e.__esModule)
    return e;
  var t = Object.defineProperty({}, "__esModule", { value: !0 });
  return Object.keys(e).forEach(function(r) {
    var n = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(t, r, n.get ? n : { enumerable: !0, get: function() {
      return e[r];
    } });
  }), t;
}
var Ca = function(e, t, r, n, o, i, s, a) {
  if (!e) {
    var l;
    if (t === void 0)
      l = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var u = [r, n, o, i, s, a], d = 0;
      (l = new Error(t.replace(/%s/g, function() {
        return u[d++];
      }))).name = "Invariant Violation";
    }
    throw l.framesToPop = 1, l;
  }
}, Ss = function(e) {
  return typeof e == "function";
}, b9 = function(e) {
  return e.length === 0;
}, n2 = function(e) {
  return e.toString();
}, wp = function(e) {
  return typeof e == "string";
}, Gv = "/", Od = "||", bs = function(e) {
  return e;
}, o2 = function(e) {
  return e === null;
};
function wt(e, t, r) {
  t === void 0 && (t = bs), Ca(Ss(t) || o2(t), "Expected payloadCreator to be a function, undefined or null");
  var n = o2(t) || t === bs ? bs : function(a) {
    for (var l = arguments.length, u = new Array(l > 1 ? l - 1 : 0), d = 1; d < l; d++)
      u[d - 1] = arguments[d];
    return a instanceof Error ? a : t.apply(void 0, [a].concat(u));
  }, o = Ss(r), i = e.toString(), s = function() {
    var a = n.apply(void 0, arguments), l = { type: e };
    return a instanceof Error && (l.error = !0), a !== void 0 && (l.payload = a), o && (l.meta = r.apply(void 0, arguments)), l;
  };
  return s.toString = function() {
    return i;
  }, s;
}
var $a = function(e) {
  if (typeof e != "object" || e === null)
    return !1;
  for (var t = e; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}, i2 = function(e) {
  return Array.isArray(e);
}, m4 = function(e) {
  return e == null;
}, C9 = /\s/, w9 = /(_|-|\.|:)/, E9 = /([a-z][A-Z]|[A-Z][a-z])/, I9 = /[\W_]+(.|$)/g, A9 = /(.)([A-Z]+)/g, _9 = function(e) {
  return C9.test(e) ? e.toLowerCase() : w9.test(e) ? (function(t) {
    return t.replace(I9, function(r, n) {
      return n ? " " + n : "";
    });
  }(e) || e).toLowerCase() : E9.test(e) ? function(t) {
    return t.replace(A9, function(r, n, o) {
      return n + " " + o.toLowerCase().split("").join(" ");
    });
  }(e).toLowerCase() : e.toLowerCase();
}, s2 = function(e) {
  return function(t) {
    return _9(t).replace(/[\W_]+(.|$)/g, function(r, n) {
      return n ? " " + n : "";
    }).trim();
  }(e).replace(/\s(\w)/g, function(t, r) {
    return r.toUpperCase();
  });
}, g4 = function(e) {
  return e.indexOf("/") === -1 ? s2(e) : e.split("/").map(s2).join("/");
}, S1 = function(e, t) {
  return e.reduce(function(r, n) {
    return t(r, n);
  }, {});
}, q0 = function(e) {
  return typeof Map != "undefined" && e instanceof Map;
};
function qv(e) {
  if (q0(e))
    return Array.from(e.keys());
  if (typeof Reflect != "undefined" && typeof Reflect.ownKeys == "function")
    return Reflect.ownKeys(e);
  var t = Object.getOwnPropertyNames(e);
  return typeof Object.getOwnPropertySymbols == "function" && (t = t.concat(Object.getOwnPropertySymbols(e))), t;
}
function y4(e, t) {
  return q0(t) ? t.get(e) : t[e];
}
var S4 = function(e) {
  return function t(r, n, o, i) {
    var s = n === void 0 ? {} : n, a = s.namespace, l = a === void 0 ? Gv : a, u = s.prefix;
    return o === void 0 && (o = {}), i === void 0 && (i = ""), qv(r).forEach(function(d) {
      var c = function(h) {
        return i || !u || u && new RegExp("^" + u + l).test(h) ? h : "" + u + l + h;
      }(function(h) {
        var v;
        if (!i)
          return h;
        var f = h.toString().split(Od), m = i.split(Od);
        return (v = []).concat.apply(v, m.map(function(g) {
          return f.map(function(C) {
            return "" + g + l + C;
          });
        })).join(Od);
      }(d)), p = y4(d, r);
      e(p) ? t(p, { namespace: l, prefix: u }, o, c) : o[c] = p;
    }), o;
  };
}, R9 = S4($a);
function yc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {}, n = Object.keys(r);
    typeof Object.getOwnPropertySymbols == "function" && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function(o) {
      return Object.getOwnPropertyDescriptor(r, o).enumerable;
    }))), n.forEach(function(o) {
      O9(e, o, r[o]);
    });
  }
  return e;
}
function O9(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Yt(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    r[n - 1] = arguments[n];
  var o, i = $a((o = r)[o.length - 1]) ? r.pop() : {};
  return Ca(r.every(wp) && (wp(e) || $a(e)), "Expected optional object followed by string action types"), wp(e) ? a2([e].concat(r), i) : yc({}, function(s, a) {
    return function(l, u) {
      var d = u === void 0 ? {} : u, c = d.namespace, p = c === void 0 ? Gv : c, h = d.prefix;
      function v(m, g, C) {
        var b = g4(C.shift());
        b9(C) ? g[b] = l[m] : (g[b] || (g[b] = {}), v(m, g[b], C));
      }
      var f = {};
      return Object.getOwnPropertyNames(l).forEach(function(m) {
        var g = h ? m.replace("" + h + p, "") : m;
        return v(m, f, g.split(p));
      }), f;
    }(b4(R9(s, a)), a);
  }(e, i), a2(r, i));
}
function b4(e, t) {
  var r = t === void 0 ? {} : t, n = r.prefix, o = r.namespace, i = o === void 0 ? Gv : o;
  return S1(Object.keys(e), function(s, a) {
    var l, u = e[a];
    Ca(function(p) {
      if (Ss(p) || m4(p))
        return !0;
      if (i2(p)) {
        var h = p[0], v = h === void 0 ? bs : h, f = p[1];
        return Ss(v) && Ss(f);
      }
      return !1;
    }(u), "Expected function, undefined, null, or array with payload and meta functions for " + a);
    var d = n ? "" + n + i + a : a, c = i2(u) ? wt.apply(void 0, [d].concat(u)) : wt(d, u);
    return yc({}, s, ((l = {})[a] = c, l));
  });
}
function a2(e, t) {
  var r = b4(S1(e, function(n, o) {
    var i;
    return yc({}, n, ((i = {})[o] = bs, i));
  }), t);
  return S1(Object.keys(r), function(n, o) {
    var i;
    return yc({}, n, ((i = {})[g4(o)] = r[o], i));
  });
}
var T9 = function() {
  for (var e = arguments.length, t = Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  var n = typeof t[t.length - 1] != "function" && t.pop(), o = t;
  if (n === void 0)
    throw new TypeError("The initial state may not be undefined. If you do not want to set a value for this reducer, you can use null instead of undefined.");
  return function(i, s) {
    for (var a = arguments.length, l = Array(a > 2 ? a - 2 : 0), u = 2; u < a; u++)
      l[u - 2] = arguments[u];
    var d = i === void 0, c = s === void 0;
    return d && c && n ? n : o.reduce(function(p, h) {
      return h.apply(void 0, [p, s].concat(l));
    }, d && !c && n ? n : i);
  };
}, k9 = S4(function(e) {
  return ($a(e) || q0(e)) && !function(t) {
    var r = qv(t), n = r.every(function(o) {
      return o === "next" || o === "throw";
    });
    return r.length && r.length <= 2 && n;
  }(e);
});
function zr(e, t, r) {
  r === void 0 && (r = {}), Ca($a(e) || q0(e), "Expected handlers to be a plain object.");
  var n = k9(e, r), o = qv(n).map(function(s) {
    return function(a, l, u) {
      l === void 0 && (l = bs);
      var d = n2(a).split(Od);
      Ca(!/* @__PURE__ */ function(v) {
        return v === void 0;
      }(u), "defaultState for reducer handling " + d.join(", ") + " should be defined"), Ca(Ss(l) || $a(l), "Expected reducer to be a function or object with next and throw reducers");
      var c = Ss(l) ? [l, l] : [l.next, l.throw].map(function(v) {
        return m4(v) ? bs : v;
      }), p = c[0], h = c[1];
      return function(v, f) {
        v === void 0 && (v = u);
        var m = f.type;
        return m && d.indexOf(n2(m)) !== -1 ? (f.error === !0 ? h : p)(v, f) : v;
      };
    }(s, y4(s, n), t);
  }), i = T9.apply(void 0, o.concat([t]));
  return function(s, a) {
    return s === void 0 && (s = t), i(s, a);
  };
}
const Td = wt("CONNECT_ZOOM_SOCKET"), Ep = wt("CONNECT_XMPP_SOCKET"), ko = wt("CLOSE_ZOOM_SOCKET"), C4 = wt("CLOSE_XMPP_SOCKET"), js = wt("RECEIVE_MESSAGE_FROM_ZOOM_SOCKET"), M9 = wt("RECEIVE_SHARING_PAYLOAD_FROM_ZOOM_SOCKET"), w4 = wt("RECEIVE_MESSAGE_FROM_XMPP_SOCKET"), b1 = wt("CONNECT_MAIN_SESSION_SOCKET"), E4 = wt("CLOSE_MAIN_SESSION_SOCKET"), Yo = wt("RECEIVE_MESSAGE_FROM_MAIN_SESSION_SOCKET"), { setZoomSocketStatus: ca, setRwgServersList: I4, setRwgRetryCount: A4, setXmppSocketStatus: kd, setMainSessionSocketStatus: Md, resetSocket: _4 } = Yt("SET_ZOOM_SOCKET_STATUS", "SET_RWG_SERVERS_LIST", "SET_RWG_RETRY_COUNT", "SET_XMPP_SOCKET_STATUS", "SET_MAIN_SESSION_SOCKET_STATUS", "RESET_SOCKET"), Kv = wt("CONNECT_TO_MEDIA_STREAM"), R4 = wt("RECEIVE_PAYLOAD_FROM_MEDIA_SDK"), { setAudioEncodeStatus: C1, setAudioDecodeStatus: w1, setVideoEncodeStatus: E1, setVideoDecodeStatus: I1, setSharingEncodeStatus: A1, setSharingDecodeStatus: Pd, setMediaConstraints: Jv, setMediaEncryptKey: O4, setIsEnableDecoderInWorklet: T4, setPatchedMediaSdkStatus: Dd, setMediaAssetsPath: k4, setIsEnableVideoAudioQos: M4, setIsAudioBridgeReceiveReady: P4, setIsAudioBridgeSendReady: D4, setIsMediaAgentInitialized: Qv, setAdaptedAbOptionForMediaSdk: L4, resetMedia: N4 } = Yt("SET_AUDIO_ENCODE_STATUS", "SET_AUDIO_DECODE_STATUS", "SET_VIDEO_ENCODE_STATUS", "SET_VIDEO_DECODE_STATUS", "SET_SHARING_ENCODE_STATUS", "SET_SHARING_DECODE_STATUS", "SET_MEDIA_CONSTRAINTS", "SET_MEDIA_ENCRYPT_KEY", "SET_IS_ENABLE_DECODER_IN_WORKLET", "SET_PATCHED_MEDIA_SDK_STATUS", "SET_MEDIA_ASSETS_PATH", "SET_IS_ENABLE_VIDEO_AUDIO_QOS", "SET_IS_AUDIO_BRIDGE_RECEIVE_READY", "SET_IS_AUDIO_BRIDGE_SEND_READY", "SET_IS_MEDIA_AGENT_INITIALIZED", "SET_ADAPTED_AB_OPTION_FOR_MEDIA_SDK", "RESET_MEDIA");
function P9(e, t) {
  for (var r = arguments.length, n = new Array(r > 2 ? r - 2 : 0), o = 2; o < r; o++)
    n[o - 2] = arguments[o];
  return e(Je(...n || []), t, null);
}
function x4() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  const n = function() {
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return Kt(...t.map((a) => {
      const l = a(...i);
      if (!l)
        throw new TypeError(`combineEpics: one of the provided Epics "${a.name || "<anonymous>"}" does not return a stream. Double check you're not missing a return statement!`);
      return l.pipe(Xn((u, d) => (setTimeout(() => {
        throw u;
      }, 0), d)));
    }));
  };
  try {
    Object.defineProperty(n, "name", { value: `combineEpics(${t.map((o) => o.name || "<anonymous>").join(", ")})` });
  } catch {
  }
  return n;
}
function Wr() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return x4(...t.flatMap((n) => Object.values(n)));
}
function se(e, t) {
  return e.pipe(ge(`${js}`), z((r) => r.payload.evt === t));
}
function vs(e, t) {
  return e.pipe(ge(`${Yo}`), z((r) => r.payload.evt === t));
}
function wa(e, t) {
  return e.pipe(ge(`${w4}`), z((r) => r.payload.evt === t));
}
function to(e, t) {
  return e.pipe(ge(`${js}`, `${Yo}`), z((r) => r.payload.evt === t));
}
function Pe(e, t) {
  return e.pipe(ge(`${R4}`), z((r) => Array.isArray(t) ? t.indexOf(r.payload.type) > -1 : r.payload.type === t));
}
function Yv(e, t) {
  return e.pipe(ge(`${Kv}`), z(() => {
    const { media: { assetsPath: r, mediaConstraints: n } } = t.value;
    return r !== void 0 && n !== void 0;
  }), ze(() => {
    const { media: { isMediaAgentInitialized: r } } = t.value;
    return r ? ne([0]) : e.pipe(ge(`${Qv}`), z((n) => !!n.payload), Ge(1));
  }));
}
const V4 = "3.7.5", D9 = V4, L9 = typeof atob == "function", N9 = typeof btoa == "function", rl = typeof Buffer == "function", l2 = typeof TextDecoder == "function" ? new TextDecoder() : void 0, u2 = typeof TextEncoder == "function" ? new TextEncoder() : void 0, kl = Array.prototype.slice.call("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="), Ju = ((e) => {
  let t = {};
  return kl.forEach((r, n) => t[r] = n), t;
})(), x9 = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/, Ar = String.fromCharCode.bind(String), d2 = typeof Uint8Array.from == "function" ? Uint8Array.from.bind(Uint8Array) : (e) => new Uint8Array(Array.prototype.slice.call(e, 0)), j4 = (e) => e.replace(/=/g, "").replace(/[+\/]/g, (t) => t == "+" ? "-" : "_"), U4 = (e) => e.replace(/[^A-Za-z0-9\+\/]/g, ""), B4 = (e) => {
  let t, r, n, o, i = "";
  const s = e.length % 3;
  for (let a = 0; a < e.length; ) {
    if ((r = e.charCodeAt(a++)) > 255 || (n = e.charCodeAt(a++)) > 255 || (o = e.charCodeAt(a++)) > 255)
      throw new TypeError("invalid character found");
    t = r << 16 | n << 8 | o, i += kl[t >> 18 & 63] + kl[t >> 12 & 63] + kl[t >> 6 & 63] + kl[63 & t];
  }
  return s ? i.slice(0, s - 3) + "===".substring(s) : i;
}, Xv = N9 ? (e) => btoa(e) : rl ? (e) => Buffer.from(e, "binary").toString("base64") : B4, _1 = rl ? (e) => Buffer.from(e).toString("base64") : (e) => {
  let t = [];
  for (let r = 0, n = e.length; r < n; r += 4096)
    t.push(Ar.apply(null, e.subarray(r, r + 4096)));
  return Xv(t.join(""));
}, Ld = (e, t = !1) => t ? j4(_1(e)) : _1(e), V9 = (e) => {
  if (e.length < 2)
    return (t = e.charCodeAt(0)) < 128 ? e : t < 2048 ? Ar(192 | t >>> 6) + Ar(128 | 63 & t) : Ar(224 | t >>> 12 & 15) + Ar(128 | t >>> 6 & 63) + Ar(128 | 63 & t);
  var t = 65536 + 1024 * (e.charCodeAt(0) - 55296) + (e.charCodeAt(1) - 56320);
  return Ar(240 | t >>> 18 & 7) + Ar(128 | t >>> 12 & 63) + Ar(128 | t >>> 6 & 63) + Ar(128 | 63 & t);
}, j9 = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g, $4 = (e) => e.replace(j9, V9), c2 = rl ? (e) => Buffer.from(e, "utf8").toString("base64") : u2 ? (e) => _1(u2.encode(e)) : (e) => Xv($4(e)), Ea = (e, t = !1) => t ? j4(c2(e)) : c2(e), p2 = (e) => Ea(e, !0), U9 = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g, B9 = (e) => {
  switch (e.length) {
    case 4:
      var t = ((7 & e.charCodeAt(0)) << 18 | (63 & e.charCodeAt(1)) << 12 | (63 & e.charCodeAt(2)) << 6 | 63 & e.charCodeAt(3)) - 65536;
      return Ar(55296 + (t >>> 10)) + Ar(56320 + (1023 & t));
    case 3:
      return Ar((15 & e.charCodeAt(0)) << 12 | (63 & e.charCodeAt(1)) << 6 | 63 & e.charCodeAt(2));
    default:
      return Ar((31 & e.charCodeAt(0)) << 6 | 63 & e.charCodeAt(1));
  }
}, H4 = (e) => e.replace(U9, B9), F4 = (e) => {
  if (e = e.replace(/\s+/g, ""), !x9.test(e))
    throw new TypeError("malformed base64.");
  e += "==".slice(2 - (3 & e.length));
  let t, r, n, o = "";
  for (let i = 0; i < e.length; )
    t = Ju[e.charAt(i++)] << 18 | Ju[e.charAt(i++)] << 12 | (r = Ju[e.charAt(i++)]) << 6 | (n = Ju[e.charAt(i++)]), o += r === 64 ? Ar(t >> 16 & 255) : n === 64 ? Ar(t >> 16 & 255, t >> 8 & 255) : Ar(t >> 16 & 255, t >> 8 & 255, 255 & t);
  return o;
}, em = L9 ? (e) => atob(U4(e)) : rl ? (e) => Buffer.from(e, "base64").toString("binary") : F4, z4 = rl ? (e) => d2(Buffer.from(e, "base64")) : (e) => d2(em(e).split("").map((t) => t.charCodeAt(0))), W4 = (e) => z4(Z4(e)), $9 = rl ? (e) => Buffer.from(e, "base64").toString("utf8") : l2 ? (e) => l2.decode(z4(e)) : (e) => H4(em(e)), Z4 = (e) => U4(e.replace(/[-_]/g, (t) => t == "-" ? "+" : "/")), R1 = (e) => $9(Z4(e)), G4 = (e) => ({ value: e, enumerable: !1, writable: !0, configurable: !0 }), h2 = function() {
  const e = (t, r) => Object.defineProperty(String.prototype, t, G4(r));
  e("fromBase64", function() {
    return R1(this);
  }), e("toBase64", function(t) {
    return Ea(this, t);
  }), e("toBase64URI", function() {
    return Ea(this, !0);
  }), e("toBase64URL", function() {
    return Ea(this, !0);
  }), e("toUint8Array", function() {
    return W4(this);
  });
}, f2 = function() {
  const e = (t, r) => Object.defineProperty(Uint8Array.prototype, t, G4(r));
  e("toBase64", function(t) {
    return Ld(this, t);
  }), e("toBase64URI", function() {
    return Ld(this, !0);
  }), e("toBase64URL", function() {
    return Ld(this, !0);
  });
}, K0 = { version: V4, VERSION: D9, atob: em, atobPolyfill: F4, btoa: Xv, btoaPolyfill: B4, fromBase64: R1, toBase64: Ea, encode: Ea, encodeURI: p2, encodeURL: p2, utob: $4, btou: H4, decode: R1, isValid: (e) => {
  if (typeof e != "string")
    return !1;
  const t = e.replace(/\s+/g, "").replace(/={0,2}$/, "");
  return !/[^\s0-9a-zA-Z\+/]/.test(t) || !/[^\s0-9a-zA-Z\-_]/.test(t);
}, fromUint8Array: Ld, toUint8Array: W4, extendString: h2, extendUint8Array: f2, extendBuiltins: () => {
  h2(), f2();
} };
function kt(e) {
  return K0.encode(e, !0);
}
function no(e) {
  return K0.decode(e);
}
function q4(e) {
  return K0.encode(e, !1);
}
const H9 = { "-": "+", _: "/", ".": "=" };
function wn(e) {
  const t = e.replace(/[-_.]/g, (r) => H9[r]);
  return Uint8Array.from(window.atob(t), (r) => r.charCodeAt(0));
}
const K4 = (e) => {
  const t = e.charCodeAt(0);
  return t <= parseInt("0x7F", 16) ? 1 : t <= parseInt("0x7FF", 16) ? 2 : t <= parseInt("0xFFFF", 16) ? 3 : t <= parseInt("0x1FFFFF", 16) ? 4 : t <= parseInt("0x3FFFFFF", 16) ? 5 : 6;
}, Sc = (e, t) => {
  const r = e.split(".").map((i) => Number(i)).slice(0, 3), n = t.split(".").map((i) => Number(i)).slice(0, 3);
  let o = 0;
  for (let i = 0; i < 3; i++) {
    const s = i < r.length ? r[i] : 0, a = i < n.length ? n[i] : 0;
    if (s < a) {
      o = -1;
      break;
    }
    if (s > a) {
      o = 1;
      break;
    }
  }
  return o;
}, bc = (e) => {
  var t;
  let r = (/* @__PURE__ */ new Date()).getTime(), n = 1e3 * ((t = performance) === null || t === void 0 ? void 0 : t.now()) || 0;
  const o = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (i) => {
    let s = 16 * Math.random();
    return r > 0 ? (s = (r + s) % 16 | 0, r = Math.floor(r / 16)) : (s = (n + s) % 16 | 0, n = Math.floor(n / 16)), (i === "x" ? s : 3 & s | 8).toString(16);
  });
  return typeof e == "string" || typeof e == "number" ? o + ":" + e : o + "";
};
function Lu(e, t) {
  if (e === t)
    return !0;
  if (!e || !t)
    return !1;
  const r = Object.keys(e), n = Object.keys(t), o = r.length;
  if (n.length !== o)
    return !1;
  for (let i = 0; i < o; i++) {
    const s = r[i];
    if (e[s] !== t[s] || !Object.prototype.hasOwnProperty.call(t, s))
      return !1;
  }
  return !0;
}
const Xr = (e, t) => e >> 10 == t >> 10, tm = (e, t) => new Promise((r) => {
  setTimeout(() => {
    r(e());
  }, t);
}), Qo = (e) => {
  const t = `${Math.floor(1e4 * Math.random())}`;
  return e.indexOf("@") > -1 ? e.replace("@", t) : `${e}${t}`;
}, eo = (e) => {
  try {
    const t = new URL(e);
    return !(t.protocol === "data:" && t.origin === "null") && t.origin !== location.origin;
  } catch {
    return !0;
  }
}, nl = (e) => {
  const t = e.split(".")[1];
  if (typeof t == "string") {
    let r = t.replace(/-/g, "+").replace(/_/g, "/");
    switch (r.length % 4) {
      case 0:
        break;
      case 2:
        r += "==";
        break;
      case 3:
        r += "=";
        break;
      default:
        throw new Error("base64 string is not of the correct length");
    }
    try {
      const n = decodeURIComponent(window.atob(r).replace(/(.)/g, function(o, i) {
        let s = i.charCodeAt(0).toString(16).toUpperCase();
        return s.length < 2 && (s = "0" + s), "%" + s;
      }));
      return JSON.parse(n);
    } catch {
      console.error("Invalid token specified: invalid base64");
    }
  }
};
function rm(e) {
  return e && e.endsWith("/") ? e.slice(0, e.length - 1) : e;
}
function J4(e) {
  return [...new Uint8Array(e)].map((t) => t.toString(16).padStart(2, "0")).join("");
}
function v2(e) {
  return `${e.tagName}${e.id ? `#${e.id}` : ""}${e.className ? `.${e.className}` : ""}`;
}
function Q4(e) {
  const t = function(r) {
    const n = r && r.getRootNode();
    if (n && n.nodeName !== "#document" && n.host)
      return v2(n.host);
  }(e);
  return `${t ? `${t}>` : ""}${v2(e)}`;
}
function Cc(e) {
  return typeof e == "object" && e !== null ? e instanceof HTMLElement ? Q4(e) : ArrayBuffer.isView(e) ? J4(e.buffer) : Array.isArray(e) ? e.map((t) => Cc(t)) : Object.keys(e).reduce((t, r) => ({ ...t, [`${r}`]: Cc(e[r]) }), {}) : e;
}
const wc = -3e3;
let fn = function(e) {
  return e[e.Success = 0] = "Success", e[e.MeetingIsOver = 6] = "MeetingIsOver", e[e.UserFull = 9] = "UserFull", e[e.MeetingLocked = 9] = "MeetingLocked", e[e.WebinarBlockedEmail = 3033] = "WebinarBlockedEmail", e[e.MeetingHasClosed = 103003] = "MeetingHasClosed", e[e.UserHasBeenRemoved = 103039] = "UserHasBeenRemoved", e[e.MMRIBReject = 103043] = "MMRIBReject", e[e.MMRConfParticipantExists = 103044] = "MMRConfParticipantExists", e;
}({}), Lo = function(e) {
  return e[e.Unknown = 0] = "Unknown", e[e.Normal = 1] = "Normal", e[e.Userrequest = 2] = "Userrequest", e[e.SdkConnection = 3] = "SdkConnection", e[e.Reconnect = 5] = "Reconnect", e[e.PtRequest = 6] = "PtRequest", e[e.KickedByHost = 7] = "KickedByHost", e[e.EndByHost = 8] = "EndByHost", e[e.EndByHostStartAnotherMeeting = 9] = "EndByHostStartAnotherMeeting", e[e.FreeMeetingTimeout = 10] = "FreeMeetingTimeout", e[e.JBHTimeout = 11] = "JBHTimeout", e[e.EndBySingleStatus = 12] = "EndBySingleStatus", e[e.WebinarNeedRegister = 13] = "WebinarNeedRegister", e[e.ArchiveFail = 14] = "ArchiveFail", e[e.EndByNone = 15] = "EndByNone", e[e.EndByAdmin = 16] = "EndByAdmin", e[e.DuplicateSession = 17] = "DuplicateSession", e[e.MeetingTransfer = 18] = "MeetingTransfer", e;
}({}), F9 = function(e) {
  return e[e.WaitingRoomFailover = 1] = "WaitingRoomFailover", e[e.WebEndAndRejoin = 2] = "WebEndAndRejoin", e;
}({}), pi = function(e) {
  return e[e.Success = 0] = "Success", e[e.CommonError = 200] = "CommonError", e[e.WrongPasscode = 3004] = "WrongPasscode", e[e.RoleTypeMissing = 3010] = "RoleTypeMissing", e[e.InvalidParameter = 4003] = "InvalidParameter", e;
}({}), Et = function(e) {
  return e[e.Success = 0] = "Success", e[e.AnotherMeetingInProgress = 3e3] = "AnotherMeetingInProgress", e[e.MeetingNotExist = 3001] = "MeetingNotExist", e[e.NotHost = 3003] = "NotHost", e[e.WrongPasscode = 3004] = "WrongPasscode", e[e.MissingEmail = 3005] = "MissingEmail", e[e.MeetingNotStarted = 3008] = "MeetingNotStarted", e[e.UserHasBeenRemoved = 3009] = "UserHasBeenRemoved", e[e.RoleTypeMissing = 3010] = "RoleTypeMissing", e[e.WebinarEnforceLogin = 3034] = "WebinarEnforceLogin", e[e.RealNameMissing = 3082] = "RealNameMissing", e[e.RegisterRequired = 3099] = "RegisterRequired", e[e.SsoLoginWindow = 6024] = "SsoLoginWindow", e[e.ZoomLoginWindow = 3051] = "ZoomLoginWindow", e[e.ZoomSpecificLoginWindow = 3052] = "ZoomSpecificLoginWindow", e[e.LoginRequired = 3100] = "LoginRequired", e[e.Reconnecting = 4e3] = "Reconnecting", e[e.Disconnect = 4001] = "Disconnect", e[e.InvalidParameter = 4003] = "InvalidParameter", e[e.DeniedRegisterWithPanelist = 3032] = "DeniedRegisterWithPanelist", e[e.ServiceOffline = 403] = "ServiceOffline", e[e.RwcEmpty = 3621] = "RwcEmpty", e[e.RwcError = 3622] = "RwcError", e[e.FrequentCall = 3633] = "FrequentCall", e[e.FrequentJoin = 3634] = "FrequentJoin", e[e.WasmFail = 3635] = "WasmFail", e[e.CommonError = 200] = "CommonError", e[e.Upgrade = 1e4] = "Upgrade", e;
}({});
Et.Success, Et.RegisterRequired, Et.LoginRequired, Et.SsoLoginWindow, Et.ZoomLoginWindow, Et.ZoomSpecificLoginWindow, Et.MissingEmail, Et.MeetingNotExist, Et.NotHost, Et.WrongPasscode, Et.RoleTypeMissing, Et.AnotherMeetingInProgress, Et.MeetingNotStarted, Et.InvalidParameter, Et.Reconnecting, Et.UserHasBeenRemoved, Et.WebinarEnforceLogin, Et.Disconnect, Et.DeniedRegisterWithPanelist, Et.RwcEmpty, Et.RwcError, Et.FrequentCall, Et.FrequentJoin, Et.WasmFail, Et.Upgrade;
const m2 = { 3004: { "apac.errorcodes_pac_mn_wrong": 3714 }, 3005: { "apac.errorcodes_web_has_in_progress": 3e3 }, 3008: { "apac.errorcodes_not_start": 3008 }, 3027: { "apac.errorcodes_host_email_as_attendee": 3627 }, 3033: { "apac.errorcodes_denied_email": 3620 }, 1005: { "apac.errorcodes_no_response_from_web": 3621 }, 131005: { "apac.errorcodes_no_response_from_web": 3621 }, 1001: { "apac.errorcodes_host_inactive": 3625 }, 131001: { "apac.errorcodes_host_inactive": 3625 }, 131013: { "meeting ended": 4004 }, 103039: { "apac.errorcodes_be_removed": 3009 }, 6: { "meeting ended": 4004 }, 9: { "meeting is at capacity": 4005 }, 12: { "meeting locked": 4006 }, 103043: { "reject for information barriers": 4007 }, 103044: { "participant exist": 4008 } };
function Ml(e, t) {
  let r = { code: 200, i18nKey: "apac.errorcodes_fail" };
  if (m2[e] !== void 0) {
    const n = m2[e], o = Object.keys(n)[0];
    return r = { code: n[o], i18nKey: o }, { reason: o.startsWith("apac") ? "" : o, errorCode: r.code };
  }
  return { code: 200, reason: "connection error" };
}
const z9 = ["bLock", "bHoldUponEntry", "viewOnly", "listenOnlyPhone", "bAllowRaiseHand", "bAllowAttendeeRename", "bBroadcast", "bAllowPlayChimeForEnterOrExit", "bIbDisableShare", "bIbDisableChat", "encryptKey", "bNoHostTimeOut", "bAllowShowCount", "bHasAST", "bHasRMC", "gatewayKey", "encryptKey"], g2 = { bChime: "bAllowPlayChimeForEnterOrExit", bHasAST: "hasAst", bHasRMC: "hasRmc", topic: (e) => ({ meetingTopic: no(e) }), gatewayKey: (e) => {
  const [, t, r] = e.split(".");
  return t && r ? { gatewayUser: { userId: Number(t), sn: r } } : {};
}, encryptKey: (e) => ({ gcmSessinKey: wn(e) }) }, O1 = wt("GET_MEETING_INFO"), su = wt("GET_INSTANT_MEETING_INFO");
wt("LOGON_ZOOM_DOMAIN"), wt("VERIFY_ZOOM_RECAPTCHA"), wt("LOGON_THIRD_PARTY_DOMAIN");
const nm = wt("PING_RWC_SERVER"), Tr = wt("MEETING_FAILOVER"), au = wt("LEAVE_MEETING"), T1 = wt("LEAVE_WAITING_ROOM"), Ha = wt("END_MEETING");
wt("REGISTER_WEBINAR");
const y2 = wt("TRIGGER_IDLE_CHECK"), { setMeetingInfo: Un, setMeetingJoinInfo: W9, setWindownOpen: Z9, setAppidSignature: Y4, setZtk: G9, setZsk: q9, setTkMtkguid: K9, setPingRwcTimestamp: X4, setInMeetingInfo: ti, setMeetingAttribute: Ec, resetMeeting: k1, setIsHost: eC, setIsCohost: tC, setMeetingIsOnHold: pa, setIsMeetingReset: rC, setAudioVideoBeforeOnHold: nC, setCurrentUserAudioBeforeReset: oC, setIsCurrentUserMutedBeforeReset: iC, setMeetingStatus: om, setMeetingRegion: sC, setIsCurrentUserStartVideoBeforeReset: aC, setJoinMeetingTimeStamp: lC, setActiveAppInfo: J9, setMeetingIdleStartTime: Pl, setSessionIdleTimeoutMinutes: uC, setIsAudioBridgeEnabled: dC, addDiscardedRwcHost: cC, setSharePronounType: pC, setIsStayAwakeDuringTheSession: hC, setMeetingJoinSuccessTimestamp: fC, resetFailoverRecord: vC, setFailoverReason: Ic, setIsQuicklyLeaveMeetingAfterRefresh: mC, setMeetingInfoTimestamp: gC, setIsEnableZmkFromRwg: yC } = Yt({ SET_MEETING_INFO: (e) => e, SET_MEETING_JOIN_INFO: (e) => e, SET_WINDOWN_OPEN: (e) => e, SET_APPID_SIGNATURE: (e) => e, SET_ZTK: (e) => e, SET_ZSK: (e) => e, SET_TK_MTKGUID: (e) => e, SET_PING_RWC_TIMESTAMP: (e) => e, SET_IN_MEETING_INFO: (e) => e, SET_MEETING_ATTRIBUTE: (e) => {
  if (z9.some((t) => e && e[t] !== void 0)) {
    let t = e;
    return Object.keys(g2).some((r) => e[r] !== void 0) && (t = Object.keys(e).reduce((r, n) => {
      const o = g2[n];
      return typeof o == "function" ? Object.assign(r, o(e[n])) : typeof o == "string" ? r[o] = e[n] : (r[n], e[n]), r;
    }, {})), t;
  }
  return {};
}, SET_IS_HOST: (e) => e && e.bHost, SET_IS_COHOST: (e) => e && e.bCoHost, RESET_MEETING: (e) => e, SET_MEETING_IS_ON_HOLD: (e) => e, SET_IS_MEETING_RESET: (e) => e, SET_AUDIO_VIDEO_BEFORE_ON_HOLD: (e) => e, SET_CURRENT_USER_AUDIO_BEFORE_RESET: (e) => e, SET_IS_CURRENT_USER_MUTED_BEFORE_RESET: (e) => e, SET_MEETING_STATUS: (e) => e, SET_MEETING_REGION: (e) => e, SET_IS_CURRENT_USER_START_VIDEO_BEFORE_RESET: (e) => e, SET_JOIN_MEETING_TIME_STAMP: (e) => e, SET_ACTIVE_APP_INFO: (e) => e, SET_MEETING_IDLE_START_TIME: (e) => e, SET_SESSION_IDLE_TIMEOUT_MINUTES: (e) => e, SET_IS_AUDIO_BRIDGE_ENABLED: (e) => e, ADD_DISCARDED_RWC_HOST: (e) => e, SET_SHARE_PRONOUN_TYPE: (e) => e, SET_IS_STAY_AWAKE_DURING_THE_SESSION: (e) => e, SET_MEETING_JOIN_SUCCESS_TIMESTAMP: (e) => e, RESET_FAILOVER_RECORD: (e) => e, SET_FAILOVER_REASON: (e) => e, SET_IS_QUICKLY_LEAVE_MEETING_AFTER_REFRESH: (e) => e, SET_MEETING_INFO_TIMESTAMP: (e) => e, SET_IS_ENABLE_ZMK_FROM_RWG: (e) => e });
let hr = function(e) {
  return e.Failover = "failover", e.OnHold = "on hold", e.Promote = "promote", e.Depromote = "depromote", e.JoinBreakoutRoom = "join breakout room", e.MoveToBreakoutRoom = "move to breakout room", e.BackToMainSession = "back to main session", e;
}({});
const ss = "js_media.min.js";
let Ip = function(e) {
  return e.CDN = "CDN", e.Global = "Global", e.CN = "CN", e;
}({}), ha = function(e) {
  return e.Connected = "Connected", e.Reconnecting = "Reconnecting", e.Closed = "Closed", e.Fail = "Fail", e;
}({}), xt = function(e) {
  return e.Initial = "initial", e.Joined = "joined", e.Closed = "closed", e;
}({}), vo = function(e) {
  return e.AudioBridgeEnable = "M:1,2;V:1,2", e.AudioDecodeInWorklet = "M:6;V:3", e.VideoFullHD = "M:8;V:4", e.VideoShareFullHD = "M:9;V:5", e.WebGL2Render = "M:20;V:8", e.WebGPURender = "M:21;V:9", e.ZMKFromRWG = "M:19;V:10", e;
}({}), or = function(e) {
  return e[e.NormalCase = -1] = "NormalCase", e[e.NoHeartbeat = 0] = "NoHeartbeat", e[e.NoHeartbeatMChannel = 1] = "NoHeartbeatMChannel", e[e.NetworkChange = 2] = "NetworkChange", e[e.NotifyUiFailover = 3] = "NotifyUiFailover", e[e.InvalidParameters = 4] = "InvalidParameters", e[e.OnError = 5] = "OnError", e[e.OnErrorMChannel = 6] = "OnErrorMChannel", e[e.Disconnect = 7] = "Disconnect", e[e.DisconnectMChannel = 8] = "DisconnectMChannel", e[e.DisconnectXmpp = 9] = "DisconnectXmpp", e[e.RefreshPage = 10] = "RefreshPage", e;
}({});
const Q9 = ["8-29", "9-21"];
let qe = function(e) {
  return e.LocalStorage = "LocalStorage", e.SessionStorage = "SessionStorage", e.Memory = "Memory", e;
}({});
const S2 = kt("{}");
class xe {
  constructor(t) {
    this.sessionStorageKey = void 0, this.localStorageKey = void 0, this.sessionCache = void 0, this.localCache = void 0, this.memoryCache = void 0, this.sessionStorageKey = kt(`zoom-storage-${t}`), this.localStorageKey = kt("zoom-local-storage"), this.memoryCache = {};
    try {
      this.sessionCache = JSON.parse(no(sessionStorage.getItem(this.sessionStorageKey) || S2)), this.localCache = JSON.parse(no(localStorage.getItem(this.localStorageKey) || S2));
    } catch (r) {
      console.error(r), this.sessionCache = {}, this.localCache = {};
    }
  }
  static init(t) {
    this.instance = new xe(t);
  }
  static get(t) {
    if (this.instance === void 0)
      throw new Error("read before initial");
    return this.instance.getValue(t).value;
  }
  static set(t, r, n) {
    if (this.instance === void 0)
      throw new Error("set before initial");
    return this.instance.setValue(t, r, n);
  }
  static remove(t) {
    if (this.instance === void 0)
      throw new Error("remove before initial");
    return this.instance.removeValue(t);
  }
  static clearSession() {
    if (this.instance === void 0)
      throw new Error("clear before initial");
    return this.instance.memoryCache = {}, this.instance.sessionCache = {}, this.instance.localCache = {}, sessionStorage.removeItem(this.instance.sessionStorageKey);
  }
  getValue(t) {
    return this.sessionCache.hasOwnProperty(t) ? { value: this.sessionCache[t], type: qe.SessionStorage } : this.localCache.hasOwnProperty(t) ? { value: this.localCache[t], type: qe.LocalStorage } : { value: this.memoryCache[t], type: qe.Memory };
  }
  setValue(t, r, n) {
    if (!t)
      throw new Error("key is null");
    switch (n) {
      case qe.SessionStorage: {
        const o = this.sessionCache[t];
        let i = r;
        return typeof r == "function" && (i = r(o)), o !== i && (this.sessionCache[t] = i, this.flushValue(qe.SessionStorage)), i;
      }
      case qe.LocalStorage: {
        const o = this.localCache[t];
        let i = r;
        return typeof r == "function" && (i = r(o)), o !== i && (this.localCache[t] = i, this.flushValue(qe.LocalStorage)), i;
      }
      case qe.Memory: {
        const o = this.memoryCache[t];
        let i = r;
        return typeof r == "function" && (i = r(o)), this.memoryCache[t] = i, i;
      }
      default:
        return null;
    }
  }
  removeValue(t) {
    const { type: r } = this.getValue(t);
    switch (r) {
      case qe.SessionStorage:
        delete this.sessionCache[t], this.flushValue(qe.SessionStorage);
        break;
      case qe.LocalStorage:
        delete this.localCache[t], this.flushValue(qe.LocalStorage);
        break;
      case qe.Memory:
        delete this.memoryCache[t];
    }
  }
  flushValue(t) {
    t === qe.SessionStorage ? sessionStorage.setItem(this.sessionStorageKey, kt(JSON.stringify(this.sessionCache))) : t === qe.LocalStorage && localStorage.setItem(this.localStorageKey, kt(JSON.stringify(this.localCache)));
  }
}
xe.instance = void 0;
let lt = function(e) {
  return e.WebclientOpt = "WEB_CLIENT_OPT", e.WebclientWebinarToken = "WEB_CLIENT_WEBINAR_TOKEN", e.WebclientMeetingToken = "WEB_CLIENT_MEETING_TOKEN", e.WebclientZtk = "WEB_CLIENT_ZTK", e.WebclientZsk = "WEB_CLIENT_ZSK", e.WebclientTk = "WEB_CLIENT_TK", e.WebclientIVState = "WEB_CLIENT_IV_STATE", e.WebclientIsOnHold = "WEB_CLIENT_IS_ON_HOLD", e.WebclientParticipantId = "WEB_CLIENT_PARTICIPANT_ID", e.WebclientZoomId = "WEB_CLIENT_ZOOM_ID", e.WebclientUserName = "WEB_CLIENT_USER_NAME", e.WebclientUserEmail = "WEB_CLIENT_USER_EMAIL", e.WebclientBreakoutRoomAttendeeStatus = "WEB_CLIENT_BO_ATTENDEE_STATUS", e.WebclientBreakoutRoomCommand = "WEB_CLIENT_BO_COMMAND", e.WebclientAudioEncryptKey = "WEB_CLIENT_AUDIO_ENCRYPT_KEY", e.WebclientVideoEncryptKey = "WEB_CLIENT_VIDEO_ENCRYPT_KEY", e.WebclientSharingEncryptKey = "WEB_CLIENT_SHARING_ENCRYPT_KEY", e.WebclientFailoverCount = "WEB_CLIENT_FAILOVER_COUNT", e.WebclientRecordingToken = "WEB_CLIENT_RECORDING_TOKEN", e;
}({}), M1 = function(e) {
  return e.WebclientDeviceId = "WEBCLIENT_DEVICE_ID", e.VSDKLogTrackingId = "ZM_VSDK_LOG_TRACKING_IDS", e;
}({}), im = function(e) {
  return e.EnforceWebRTCAudio = "ENFORCE_WEB_RTC_AUDIO", e;
}({});
function Dt(e, t) {
  const r = t.match(e);
  return r && r.length > 0 && r[1] || "";
}
function SC(e, t) {
  const r = t.match(e);
  return r && r.length > 1 && r[2] || "";
}
const si = /version\/(\d+(\.?_?\d+)+)/i, Y9 = [{ test: [/opera/i], describe: (e) => ["Opera(Legacy)", Dt(si, e) || Dt(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e)] }, { test: [/opr\/|opios/i], describe: (e) => ["Opera", Dt(/(?:opr|opios)[\s/](\S+)/i, e) || Dt(si, e)] }, { test: [/SamsungBrowser/i], describe: (e) => ["Samsung Internet for Android", Dt(si, e) || Dt(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e)] }, { test: [/micromessenger/i], describe: (e) => ["WeChat", Dt(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || Dt(si, e)] }, { test: [/qqbrowser/i], describe: (e) => [/qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser", Dt(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || Dt(si, e)] }, { test: [/msie|trident/i], describe: (e) => ["Internet Explorer", Dt(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e)] }, { test: [/\sedg\//i], describe: (e) => ["Microsoft Edge", Dt(/\sedg\/(\d+(\.?_?\d+)+)/i, e)] }, { test: [/edg([ea]|ios)/i], describe: (e) => ["Microsoft Edge(Legacy)", SC(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e)] }, { test: [/firefox|iceweasel|fxios/i], describe: (e) => ["Firefox", Dt(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e)] }, { test: [/electron/i], describe: (e) => ["Electron", Dt(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e)] }, { test: [/chromium/i], describe: (e) => ["Chromium", Dt(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || Dt(si, e)] }, { test: [/chrome|crios|crmo/i], describe: (e) => ["Chrome", Dt(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e)] }, { test: (e) => !/like android/i.test(e) && /android/i.test(e), describe: (e) => ["Android Browser", Dt(si, e)] }, { test: [/safari|applewebkit/i], describe: (e) => ["Safari", Dt(si, e)] }], X9 = [{ test: [/windows /i], describe: (e) => ["Windows", Dt(/Windows ((NT|XP)( \d\d?.\d)?)/i, e)] }, { test: [/Macintosh(.*?) FxiOS(.*?)\//], describe: (e) => ["iOS", SC(/(Version\/)(\d[\d.]+)/, e)] }, { test: [/macintosh/i], describe: (e) => ["macOS", Dt(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, ".")] }, { test: [/(ipod|iphone|ipad)/i], describe: (e) => ["iOS", Dt(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".")] }, { test: (e) => !/like android/i.test(e) && /android/i.test(e), describe: (e) => ["Android", Dt(/android[\s/-](\d+(\.\d+)*)/i, e)] }, { test: [/linux/i], describe: () => ["Linux"] }, { test: [/CrOS/], describe: () => ["Chrome OS"] }];
class eO {
  constructor() {
    this.value = void 0, this.gpu = void 0;
  }
  get isSupported() {
    if (this.value === void 0)
      if (typeof window.OffscreenCanvas == "function") {
        const t = new OffscreenCanvas(1, 1);
        t.addEventListener("webglcontextlost", (n) => {
          n.preventDefault();
        });
        const r = t.getContext("webgl");
        if (this.value = !!r, r) {
          const n = r.getExtension("WEBGL_debug_renderer_info");
          n && (this.gpu = r.getParameter(n.UNMASKED_RENDERER_WEBGL));
        }
      } else
        this.value = !1;
    return this.value;
  }
}
const ve = new class {
  constructor() {
    this._browser = void 0, this._os = void 0, this._browserVersion = void 0, this._osVersion = void 0, this._offscreenCanvasCapality = void 0, this._clientHintsData = void 0, this._offscreenCanvasCapality = new eO(), "userAgentData" in navigator && navigator.userAgentData.getHighEntropyValues(["architecture", "bitness", "formFactor", "model", "platformVersion", "wow64"]).then((e) => {
      this._clientHintsData = e, this._os && this._osVersion && this._clientHintsData.platform && this._clientHintsData.platformVersion && (this._os = this._clientHintsData.platform, this._osVersion = this._clientHintsData.platformVersion);
    }).catch((e) => {
      console.warn(e);
    });
  }
  _getBrowserVersion() {
    var e, t;
    if ((e = this._clientHintsData) !== null && e !== void 0 && (t = e.brands) !== null && t !== void 0 && t.length) {
      const r = this._clientHintsData.brands.filter((o) => !/(Chromium|Not.*Brand)/i.test(o.brand))[0];
      r && (this._browser = r.brand);
      const n = this._clientHintsData.brands.find((o) => {
        var i;
        return ((i = o.brand) === null || i === void 0 ? void 0 : i.toLowerCase()) === "chromium";
      });
      n ? (this._browserVersion = n.version, this._browser || (this._browser = n.brand)) : this._browserVersion = r.version;
    } else {
      const r = navigator.userAgent, n = Y9.find((o) => typeof o.test == "function" ? o.test(r) : o.test.some((i) => i.test(r)));
      if (n) {
        const o = n.describe(r);
        this._browser = o[0], this._browserVersion = o[1], this.isIOSMobile && (this._browser = "ios-safari");
      } else
        this._browser = "unknown", this._browserVersion = "0";
    }
  }
  _getOSVersion() {
    var e, t;
    if ((e = this._clientHintsData) !== null && e !== void 0 && e.platform && (t = this._clientHintsData) !== null && t !== void 0 && t.platformVersion)
      this._os = this._clientHintsData.platform, this._osVersion = this._clientHintsData.platformVersion;
    else {
      const r = navigator.userAgent, n = X9.find((o) => typeof o.test == "function" ? o.test(r) : o.test.some((i) => i.test(r)));
      if (n) {
        const o = n.describe(r);
        this._os = o[0], this._osVersion = o[1];
      } else
        this._os = "unknown", this._osVersion = "0";
    }
  }
  get browser() {
    return this._browser || this._getBrowserVersion(), this._browser;
  }
  get browserVersion() {
    return this._browserVersion || this._getBrowserVersion(), this._browserVersion;
  }
  get os() {
    return this._os || this._getOSVersion(), this._os;
  }
  get osVersion() {
    return this._osVersion || this._getOSVersion(), this._osVersion;
  }
  get isIE() {
    return this.browser === "Internet Explorer";
  }
  get isLegacyEdge() {
    return this.browser === "Microsoft Edge(Legacy)";
  }
  get isLegacyOpera() {
    return this.browser === "Opera(Legacy)";
  }
  get isFirefox() {
    return this.browser === "Firefox";
  }
  get isSafari() {
    return this.browser === "Safari";
  }
  get isChrome() {
    var e, t, r;
    if ((e = this._clientHintsData) !== null && e !== void 0 && (t = e.brands) !== null && t !== void 0 && t.length)
      return (r = this._clientHintsData) === null || r === void 0 ? void 0 : r.brands.some((o) => {
        var i;
        return ((i = o.brand) === null || i === void 0 ? void 0 : i.toLocaleLowerCase()) === "chromium";
      });
    const { userAgent: n } = navigator;
    return !this.isLegacyOpera && !this.isLegacyEdge && /chrome/i.test(n) && /webkit/i.test(n);
  }
  get isLegacyChrome() {
    var e;
    return this.isChrome && typeof ((e = navigator.mediaDevices) === null || e === void 0 ? void 0 : e.getDisplayMedia) != "function";
  }
  get isMacOS() {
    return this.os === "macOS";
  }
  get isIPad() {
    var e;
    return /iPad/i.test(navigator.userAgent) || this.isMacOS && ((e = navigator) === null || e === void 0 ? void 0 : e.maxTouchPoints) > 2;
  }
  get isIOSMobile() {
    return this.os === "iOS" || this.isIPad;
  }
  get architecture() {
    var e, t;
    return (e = (t = this._clientHintsData) === null || t === void 0 ? void 0 : t.architecture) !== null && e !== void 0 ? e : "";
  }
  get isArm() {
    return this.architecture ? this.architecture === "arm" : /arm/i.test(navigator.userAgent);
  }
  get isChromeOS() {
    return this.os === "Chrome OS";
  }
  get isAndroidBrowser() {
    var e;
    return ((e = this.os) === null || e === void 0 ? void 0 : e.toLowerCase()) === "android";
  }
  get isArmChromeOS() {
    return this.isArm && this.isChromeOS;
  }
  get isAndroidOrIOSBrowser() {
    return this.isAndroidBrowser || this.isIOSMobile;
  }
  get isSupportEssentialAudioAndVideoAbility() {
    return typeof WebAssembly == "object" && typeof Worker == "function";
  }
  get isSupportAudioWorklet() {
    return typeof AudioWorklet == "function";
  }
  get isSupportImageCapture() {
    return "ImageCapture" in window;
  }
  get isSupportMediaStreamTrackProcessor() {
    return "MediaStreamTrackProcessor" in window;
  }
  get isSupportOffscreenCanvas() {
    return this._offscreenCanvasCapality.isSupported;
  }
  get gpu() {
    return this._offscreenCanvasCapality.isSupported ? this._offscreenCanvasCapality.gpu : "";
  }
  get bitness() {
    var e, t;
    return (e = (t = this._clientHintsData) === null || t === void 0 ? void 0 : t.bitness) !== null && e !== void 0 ? e : "";
  }
  get model() {
    var e, t;
    return (e = (t = this._clientHintsData) === null || t === void 0 ? void 0 : t.model) !== null && e !== void 0 ? e : "";
  }
  get wow64() {
    var e;
    if (this.os.toLowerCase() === "windows")
      return (e = this._clientHintsData) === null || e === void 0 ? void 0 : e.wow64;
  }
  get isSupportSendScreenSharing() {
    return "getDisplayMedia" in navigator.mediaDevices && typeof navigator.mediaDevices.getDisplayMedia == "function";
  }
}();
function fr() {
  return ve.isAndroidOrIOSBrowser || !!xe.get(im.EnforceWebRTCAudio);
}
const bC = () => ve.isIE, J0 = () => {
  var e;
  return ve.isSupportOffscreenCanvas && ((e = navigator) === null || e === void 0 ? void 0 : e.hardwareConcurrency) >= 4 && typeof requestAnimationFrame == "function" && typeof SharedArrayBuffer == "function";
}, Ia = (e, t) => {
  var r;
  const { isSafari: n, isIOSMobile: o, isSupportMediaStreamTrackProcessor: i, isAndroidOrIOSBrowser: s, isArmChromeOS: a, isChromeOS: l, isArm: u, isSupportOffscreenCanvas: d, isIPad: c } = ve;
  if (!J0()) {
    const p = n || o, h = typeof window.SharedArrayBuffer != "function" && (!!p || i && d);
    return e && h ? t ? 25 : 4 : 1;
  }
  return s ? t ? 25 : c ? 9 : 4 : a || l && !u ? navigator.hardwareConcurrency >= 4 ? 9 : 4 : ((r = navigator) === null || r === void 0 ? void 0 : r.hardwareConcurrency) < 4 ? 9 : 25;
};
function CC() {
  var e;
  return "webkit" in window && !("chrome" in window) && !((e = window.webkit.messageHandlers) === null || e === void 0 || !e.jsOCHelper);
}
function pl() {
  var e;
  const { isAndroidBrowser: t, isIOSMobile: r, osVersion: n, browserVersion: o, isChrome: i, isFirefox: s, isSafari: a } = ve;
  var l, u;
  if (r)
    return Number((l = n.match(/^\d+/)) === null || l === void 0 ? void 0 : l[0]) >= 15;
  if (t)
    return Number((u = n.match(/^\d+/)) === null || u === void 0 ? void 0 : u[0]) >= 10;
  const d = Number((e = o.match(/^\d+/)) === null || e === void 0 ? void 0 : e[0]);
  return !!(i && d >= 69) || !!(a && d > 14) || !!(s && d >= 76);
}
let qt = function(e) {
  return e.VIDEO_ENCODE = "0", e.VIDEO_DECODE = "1", e.AUDIO_ENCODE = "2", e.AUDIO_DECODE = "3", e.SHARING_ENCODE = "4", e.SHARING_DECODE = "5", e;
}({}), Nu = function(e) {
  return e[e.NONE = 0] = "NONE", e[e.AES_256 = 1] = "AES_256", e[e.AES_GCM = 2] = "AES_GCM", e;
}({});
const mr = Object.freeze({ RWG_CHAT: { gcmType: 1, sessionType: "RWG_CHAT" }, XMPP_CHAT: { gcmType: 1, sessionType: "XMPP_CHAT" }, CC_MESSAGE: { gcmType: 3, sessionType: "CC_MESSAGE" }, BO_BROADCAST: { gcmType: 1, sessionType: "BO_BROADCAST" }, CHAT_FILE: { gcmType: 2, sessionType: "CHAT_FILE" }, CHAT_FILE_INFO: { gcmType: 1, sessionType: "CHAT_FILE_INFO" } }), hl = (window.crypto || window.msCrypto).subtle, zs = lt.WebclientIVState, tO = Object.keys(mr).map((e) => mr[e].sessionType);
class ir {
  constructor(t, r, n) {
    this.isGCMEnabled = void 0, this.gcmSessionKey = void 0, this.gcmMainSessionKey = void 0, this.zoomId = void 0, this.resetParameters(t, r, n), xe.set(zs, {}, qe.SessionStorage);
  }
  static init(t, r, n) {
    this.instance ? this.instance.resetParameters(t, r, n) : this.instance = new ir(t, r, n);
  }
  static destroy() {
    this.instance && (this.instance = void 0);
  }
  resetParameters(t, r, n) {
    this.isGCMEnabled = !(ve.isIE || !ve.isSupportEssentialAudioAndVideoAbility) && n === Nu.AES_GCM, this.gcmSessionKey = wn(r), this.gcmMainSessionKey || (this.gcmMainSessionKey = this.gcmSessionKey), this.zoomId = String(t);
  }
  beginCrypto(t, r, n) {
    const o = new Uint32Array(1);
    o[0] = 9, o[0] += Number(n);
    const i = new Uint8Array(o.buffer);
    let s = new Uint8Array(132);
    const a = wn(r);
    return s.set(a, 0), s.set(i, a.length), s = s.subarray(0, a.length + 4), hl.importKey("raw", t, { name: "HMAC", hash: "SHA-256" }, !0, ["sign"]).then((l) => hl.sign({ name: "HMAC" }, l, s)).then((l) => hl.importKey("raw", l, { name: "AES-GCM", length: 256 }, !0, ["encrypt", "decrypt"]));
  }
  getNextIV(t) {
    const r = xe.get(zs);
    return r[t] === void 0 ? (r[t] = 0, xe.set(zs, r, qe.SessionStorage)) : xe.set(zs, (n) => ({ ...n, [t]: n[t] + 1 }), qe.SessionStorage);
  }
  resetIVState() {
    const t = xe.get(zs);
    if (t !== void 0) {
      const r = Object.keys(t).filter((n) => tO.indexOf(n) > -1);
      r.length > 0 && (r.forEach((n) => {
        t[n] += 1e6;
      }), xe.set(zs, t, qe.SessionStorage));
    }
  }
  static resetIV() {
    if (this.instance === void 0)
      throw new Error("reset before intialize");
    this.instance.resetIVState();
  }
  static beginEncrypt(t) {
    let { text: r, type: n } = t;
    const o = new Uint8Array(0);
    if (this.instance && this.instance.isGCMEnabled) {
      const a = this.instance.getNextIV(n.sessionType), l = new ArrayBuffer(12), u = new Uint8Array(l);
      new DataView(l).setUint32(0, a, !0);
      let d = null;
      return d = n.sessionType === "BO_BROADCAST" || n.sessionType === "XMPP_CHAT" ? this.instance.gcmMainSessionKey : this.instance.gcmSessionKey, this.instance.beginCrypto(d, this.instance.zoomId, n.gcmType).then((c) => {
        const p = ArrayBuffer.isView(r) ? r : new TextEncoder().encode(r);
        return hl.encrypt({ name: "AES-GCM", iv: u, additionalData: o, tagLength: 8 * 16 }, c, p);
      }).then((c) => {
        const p = 1 + u.byteLength + 2 + o.byteLength + 4 + c.byteLength, h = new ArrayBuffer(p);
        if (new Uint8Array(h)[0] = u.length, new Uint8Array(h, 1, u.byteLength).set(u), new DataView(h).setUint16(1 + u.byteLength, o.length, !0), new Uint8Array(h, 3 + u.byteLength).set(o), new DataView(h).setUint32(1 + u.byteLength + 2 + o.byteLength, c.byteLength - 16, !0), new Uint8Array(h, 1 + u.byteLength + 2 + o.byteLength + 4).set(new Uint8Array(c)), n.sessionType === mr.CHAT_FILE.sessionType)
          return h;
        const v = new Uint8Array(h).reduce((f, m) => f + String.fromCharCode(m), "");
        return window.btoa(v).replace(/_/g, "/").replace(/-/g, "+").replace(/\=/g, "");
      });
    }
    return Promise.resolve(ArrayBuffer.isView(r) ? r : kt(r));
  }
  static beginDecrypt(t) {
    let { decryptedText: r, type: n, zoomId: o } = t;
    if (this.instance && this.instance.isGCMEnabled) {
      const i = ArrayBuffer.isView(r) || r instanceof ArrayBuffer ? new Uint8Array(r) : function(m) {
        let g;
        const C = m.length, b = new Array(C);
        for (g = 0; g < C; ++g)
          b[g] = 255 & m.charCodeAt(g);
        return new Uint8Array(b);
      }(atob(r.replace(/_/g, "/").replace(/-/g, "+"))), s = i[0], a = i.slice(1, s + 1), l = i.slice(1 + s, 3 + s), u = new DataView(l.buffer).getUint16(0, !0), d = i.slice(1 + s + 2, 1 + s + 2 + u), c = i.slice(1 + s + 2 + u, 1 + s + 2 + u + 4), p = new DataView(c.buffer).getUint32(0, !0), h = i.slice(1 + s + 2 + u + 4, 1 + s + 2 + u + 4 + p), v = i.slice(1 + s + 2 + u + 4 + p);
      let f = null;
      return f = n.sessionType === "BO_BROADCAST" || n.sessionType === "XMPP_CHAT" ? this.instance.gcmMainSessionKey : this.instance.gcmSessionKey, this.instance.beginCrypto(f, o, n.gcmType).then((m) => {
        const g = function(C, b) {
          C = new Uint8Array(C), b = new Uint8Array(b);
          const E = new Uint8Array(C.length + b.length);
          return E.set(C), E.set(b, C.length), E;
        }(h, v);
        return hl.decrypt({ name: "AES-GCM", iv: a, additionalData: d, tagLength: 8 * v.length }, m, g.buffer);
      }).then((m) => ({ message: n.sessionType === mr.CHAT_FILE.sessionType ? m : new TextDecoder().decode(m), iv: a, aad: d })).catch((m) => ({ message: "[This is an encrypted message]", iv: a, aad: d }));
    }
    {
      const i = new TextDecoder("utf-8");
      return Promise.resolve({ message: ArrayBuffer.isView(r) || r instanceof ArrayBuffer ? r : i.decode(wn(r)) });
    }
  }
}
ir.instance = void 0;
const P1 = 20225, sm = 20234, gt = 7937, En = 7938, D1 = 12039, b2 = 16138, Q0 = 4098, Ap = 4305, Qu = 4343, L1 = 16428;
let bt = function(e) {
  return e[e.NoAttendee = 0] = "NoAttendee", e[e.All = 1] = "All", e[e.AllPanelist = 2] = "AllPanelist", e[e.Host = 3] = "Host", e[e.NoOne = 4] = "NoOne", e[e.EveryonePublicly = 5] = "EveryonePublicly", e;
}({}), Ms = function(e) {
  return e[e.AllPanelist = 1] = "AllPanelist", e[e.Everyone = 2] = "Everyone", e[e.Invalid = 0] = "Invalid", e;
}({}), ut = function(e) {
  return e[e.All = 0] = "All", e[e.Panelist = 1] = "Panelist", e[e.IndividualCcPanelist = 2] = "IndividualCcPanelist", e[e.Individual = 3] = "Individual", e[e.SilentModeUsers = 4] = "SilentModeUsers", e;
}({}), Ac = function(e) {
  return e[e.None = 0] = "None", e[e.Delete = 1] = "Delete", e[e.Modify = 2] = "Modify", e;
}({}), _p = function(e) {
  return e[e.Success = 0] = "Success", e[e.Delete = 1] = "Delete", e[e.Block = 3] = "Block", e;
}({});
const rO = [bt.All, bt.Host, bt.NoOne, bt.EveryonePublicly], nO = [bt.NoOne, bt.All, bt.AllPanelist], _c = { AllPanelist: 11, Everyone: 12 }, oO = { [_c.AllPanelist]: Ms.AllPanelist, [_c.Everyone]: Ms.Everyone }, Dl = { userId: ut.All, displayName: "Everyone", isHost: !1, isCoHost: !1 }, fa = { userId: ut.Panelist, displayName: "All panelists" }, iO = { userId: ut.SilentModeUsers, displayName: "Everyone (in Waiting Room)", isHost: !1, isCoHost: !1 };
let sO = function(e) {
  return e[e.Local = 0] = "Local", e[e.ThirdParty = 1] = "ThirdParty", e;
}({}), lr = function(e) {
  return e[e.ChunkSize = 20971520] = "ChunkSize", e[e.EncodeBlockSize = 32768] = "EncodeBlockSize", e[e.DecodeBlockSize = 32803] = "DecodeBlockSize", e[e.MaxSize = 2147483648] = "MaxSize", e[e.ReaderChunkSize = 1073741824] = "ReaderChunkSize", e;
}({}), $t = function(e) {
  return e[e.Init = 0] = "Init", e[e.InProgress = 1] = "InProgress", e[e.Success = 2] = "Success", e[e.Fail = 3] = "Fail", e[e.Cancel = 4] = "Cancel", e[e.Complete = 5] = "Complete", e;
}({}), Fo = function(e) {
  return e[e.InProgress = 1] = "InProgress", e[e.Success = 2] = "Success", e[e.Fail = 3] = "Fail", e[e.Cancel = 4] = "Cancel", e;
}({});
const aO = { "7z": "application/x-7z-compressed", avi: "video/x-msvideo", bin: "application/octet-stream", bmp: "image/bmp", css: "text/css", csv: "text/csv", doc: "application/msword", docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document", gif: "image/gif", gz: "application/gzip", html: "text/html", ics: "text/calendar", jar: "application/java-archive", jpeg: "image/jpeg", jpg: "image/jpeg", js: "text/javascript", json: "application/json", mid: "audio/midi", mov: "video/*", mp3: "audio/mpeg", mp4: "video/mp4", mpeg: "video/*", mpg: "video/*", pdf: "application/pdf", png: "image/png", ppt: "application/vnd.ms-powerpoint", pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation", rar: "application/vnd.rar", rtf: "application/rtf", tar: "application/x-tar", tif: "image/tiff", tiff: "image/tiff", txt: "text/plain", wav: "audio/wav", webp: "image/webp", wma: "audio/*", wmv: "video/*", xls: "application/vnd.ms-excel", xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", xml: "application/xml", zip: "application/zip" };
let Nr = function(e) {
  return e.Open = "open", e.Message = "message", e.Error = "error", e.Close = "close", e.Inactive = "inactive", e;
}({});
class wC {
  constructor() {
    this.eventHandlers = void 0, this.websocket = void 0, this.seq = void 0, this.intervalsToBeCleardWhenSocketClose = [], this.isAlive = !1, this.eventHandlers = /* @__PURE__ */ new Map(), this.websocket = null, this.seq = 1;
  }
  on(t, r) {
    let n = this.eventHandlers.get(t);
    n || (n = []), n.push(r), this.eventHandlers.set(t, n);
  }
  off(t, r) {
    const n = this.eventHandlers.get(t);
    if (n) {
      const o = n.filter((i) => i !== r);
      this.eventHandlers.set(t, o);
    }
  }
  emit(t, r) {
    const n = this.eventHandlers.get(t);
    n && n instanceof Array && n.slice(0).forEach((o) => {
      try {
        o(r);
      } catch (i) {
        console.error(i);
      }
    });
  }
  sendMessageToRwg(t) {
    this.seq += 1;
    const r = this.seq;
    return this.websocket && this.websocket.readyState === WebSocket.OPEN && this.websocket.send(JSON.stringify(Object.assign(t, { seq: r }))), r;
  }
  connect(t) {
    this.websocket = new WebSocket(t), this.websocket.binaryType = "arraybuffer", this.addWebSocketEventListeners();
  }
  close() {
    var t;
    (t = this.websocket) === null || t === void 0 || t.close();
  }
  addHeartBeat() {
    const t = ve.isAndroidOrIOSBrowser ? 15e3 : 2e4, r = setInterval(() => {
      this.isAlive || this.emit(Nr.Inactive, {}), this.sendMessageToRwg({ evt: 0 }), this.isAlive = !1;
    }, t);
    this.intervalsToBeCleardWhenSocketClose.push(r);
  }
  clearIntervals() {
    this.intervalsToBeCleardWhenSocketClose.forEach((t) => clearInterval(t)), this.isAlive = !1;
  }
  addWebSocketEventListeners() {
    this.websocket && (this.websocket.addEventListener("open", (t) => {
      this.addHeartBeat(), this.emit(Nr.Open, t);
    }), this.websocket.addEventListener("message", (t) => {
      this.isAlive = !0, this.emit(Nr.Message, t);
    }), this.websocket.addEventListener("close", (t) => {
      this.clearIntervals(), this.emit(Nr.Close, t);
    }), this.websocket.addEventListener("error", (t) => {
      this.clearIntervals(), this.emit(Nr.Error, t);
    }));
  }
  sendLaunchParams(t) {
    return { seq: this.sendMessageToRwg({ evt: 4301, body: t }) };
  }
  joinMeeting(t) {
    return { seq: this.sendMessageToRwg({ evt: 4097, body: { meetingtoken: t } }) };
  }
  lockMeeting(t) {
    return { seq: this.sendMessageToRwg({ evt: 4099, body: { bLock: t } }) };
  }
  endMeeting() {
    return { seq: this.sendMessageToRwg({ evt: 4101, body: {} }) };
  }
  leaveMeeting() {
    return { seq: this.sendMessageToRwg({ evt: 4103, body: {} }) };
  }
  recordMeeting(t, r) {
    return { seq: this.sendMessageToRwg({ evt: 4105, body: { bRecord: t, bPause: r } }) };
  }
  localRecordingGrantPermission(t, r, n) {
    return { seq: this.sendMessageToRwg({ evt: Qu, body: { cmdType: "permission_request_answer", userId: t, agreed: r, saveAgreed: n } }) };
  }
  hostGrantPermission(t, r) {
    return { seq: this.sendMessageToRwg({ evt: Qu, body: { cmdType: "grant_permission", userId: t, grant: r } }) };
  }
  localRecordingRequestPermission() {
    return { seq: this.sendMessageToRwg({ evt: Qu, body: { cmdType: "request_permission" } }) };
  }
  localRecordingMeeting(t) {
    return { seq: this.sendMessageToRwg({ evt: Qu, body: { cmdType: "change_recording_status", status: t } }) };
  }
  summaryMeeting(t) {
    return { seq: this.sendMessageToRwg({ evt: 8009, body: { type: t ? "start" : "stop" } }) };
  }
  startMeetingQuery(t) {
    return { seq: this.sendMessageToRwg({ evt: 8017, body: { type: t ? "start" : "stop" } }) };
  }
  allowSelfRecord(t) {
    return { seq: this.sendMessageToRwg({ evt: 4325, body: { bAllowISORecord: t } }) };
  }
  enableZoomIQRecord(t) {
    return { seq: this.sendMessageToRwg({ evt: 4318, body: { check: t } }) };
  }
  expel(t) {
    return { seq: this.sendMessageToRwg({ evt: 4107, body: { id: t } }) };
  }
  expelAttendee(t) {
    return { seq: this.sendMessageToRwg({ evt: 4205, body: { jid: t } }) };
  }
  rename(t, r, n) {
    return { seq: this.sendMessageToRwg({ evt: 4109, body: { id: t, dn2: r, olddn2: n } }) };
  }
  assignHost(t, r) {
    return { seq: this.sendMessageToRwg({ evt: 4111, body: { id: t, bCoHost: r } }) };
  }
  reclaimHost(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
    return { seq: this.sendMessageToRwg({ evt: 4133, body: { id: t, bCoHost: r } }) };
  }
  revokeCoHost(t) {
    return { seq: this.sendMessageToRwg({ evt: 4195, body: { id: t } }) };
  }
  putOnHold(t, r) {
    return { seq: this.sendMessageToRwg({ evt: 4113, body: { id: t, bHold: r } }) };
  }
  setMuteOnEntry(t) {
    return { seq: this.sendMessageToRwg({ evt: 4115, body: { bOn: t } }) };
  }
  setHoldOnEntry(t) {
    return { seq: this.sendMessageToRwg({ evt: 4117, body: { bOn: t } }) };
  }
  inviteCRCDevice(t, r) {
    let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
    return { seq: this.sendMessageToRwg({ evt: 4119, body: { ip: t, type: r, encrypt: n } }) };
  }
  cancelInviteCRCDevice(t) {
    return { seq: this.sendMessageToRwg({ evt: 4121, body: { transID: t } }) };
  }
  sendCloseCaption(t) {
    return { seq: this.sendMessageToRwg({ evt: 4125, body: { ...t } }) };
  }
  allowViewParticipantNumber(t) {
    return { seq: this.sendMessageToRwg({ evt: 4127, body: { bOn: t } }) };
  }
  lowerAllHands() {
    return { seq: this.sendMessageToRwg({ evt: 4129, body: {} }) };
  }
  raiseLowerHand(t, r) {
    return { seq: this.sendMessageToRwg({ evt: 4131, body: { id: t, bOn: r } }) };
  }
  chat(t, r, n, o) {
    const i = { text: t, destNodeID: r };
    return n && Object.assign(i, { sn: n }), o && Object.assign(i, { attendeeNodeID: o }), { seq: this.sendMessageToRwg({ evt: 4135, body: i }) };
  }
  assignCC(t, r) {
    return { seq: this.sendMessageToRwg({ evt: 4137, body: { id: t, bCCEditor: r } }) };
  }
  enableLT(t) {
    return { seq: this.sendMessageToRwg({ evt: 4227, body: { op: t ? 2 : 4 } }) };
  }
  enableNewLLT() {
    return { seq: this.sendMessageToRwg({ evt: 4285 }) };
  }
  disableCaptions(t) {
    return { seq: this.sendMessageToRwg({ evt: Ap, body: { type: 4, disableNewLtt: t } }) };
  }
  enableManualCaption(t) {
    return { seq: this.sendMessageToRwg({ evt: 4291, body: { op: t ? 1 : 0 } }) };
  }
  setTranslationLanguage(t) {
    return t !== void 0 ? { seq: this.sendMessageToRwg({ evt: Ap, body: { type: 1, lang: t } }) } : { seq: this.sendMessageToRwg({ evt: Ap, body: { type: 3 } }) };
  }
  setSpokenLanguage(t) {
    return { seq: this.sendMessageToRwg({ evt: 4287, body: { lang: t } }) };
  }
  allowAskLT(t) {
    return { seq: this.sendMessageToRwg({ evt: 4263, body: { bAnonymous: t } }) };
  }
  approveLT() {
    return { seq: this.sendMessageToRwg({ evt: 4262, body: { bApproved: !0 } }) };
  }
  askLT(t) {
    return { seq: this.sendMessageToRwg({ evt: 4261, body: { bAnonymous: t } }) };
  }
  setChatPriviledge(t) {
    return { seq: this.sendMessageToRwg({ evt: 4141, body: { chatPriviledge: t } }) };
  }
  setPanelistChatPrivilege(t) {
    if (!Object.values(_c).includes(t))
      throw Error("Invalid panelist chat privilege req value");
    return { seq: this.sendMessageToRwg({ evt: 4141, body: { chatPriviledge: t } }) };
  }
  sendFeedback(t) {
    return { seq: this.sendMessageToRwg({ evt: 4143, body: { feedback: t } }) };
  }
  clearFeedback() {
    return { seq: this.sendMessageToRwg({ evt: 4145, body: {} }) };
  }
  allowUnmuteVideo(t) {
    return { seq: this.sendMessageToRwg({ evt: 4147, body: { bOn: t } }) };
  }
  allowUnmuteAudio(t) {
    return { seq: this.sendMessageToRwg({ evt: 4149, body: { bOn: t } }) };
  }
  allowRaiseHand(t) {
    return { seq: this.sendMessageToRwg({ evt: 4151, body: { bOn: t } }) };
  }
  boToken(t) {
    return { seq: this.sendMessageToRwg({ evt: 4173, body: { topic: t } }) };
  }
  startBO(t) {
    return { seq: this.sendMessageToRwg({ evt: 4175, body: { proto: t } }) };
  }
  stopBO(t) {
    return { seq: this.sendMessageToRwg({ evt: 4177, body: { status: t } }) };
  }
  assignToBO(t, r) {
    return { seq: this.sendMessageToRwg({ evt: 4179, body: { targetID: t, targetBID: r } }) };
  }
  switchBO(t, r) {
    return { seq: this.sendMessageToRwg({ evt: 4181, body: { targetID: t, targetBID: r } }) };
  }
  wantJoinBO(t, r) {
    return { seq: this.sendMessageToRwg({ evt: 4183, body: { targetID: t, targetBID: r } }) };
  }
  joinBO(t) {
    return { seq: this.sendMessageToRwg({ evt: 4193, body: { targetBID: t } }) };
  }
  leaveBO() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
    return { seq: this.sendMessageToRwg({ evt: 4185, body: { reason: t } }) };
  }
  broadcastBO(t) {
    return { seq: this.sendMessageToRwg({ evt: 4187, body: { textContent: t } }) };
  }
  askForHelpBO(t) {
    return { seq: this.sendMessageToRwg({ evt: 4189, body: { targetID: t } }) };
  }
  askForHelpResultBO(t, r) {
    return { seq: this.sendMessageToRwg({ evt: 4191, body: { targetID: t, helpResult: r } }) };
  }
  coHostStartBO(t, r) {
    return { seq: this.sendMessageToRwg({ evt: 4241, body: { proto: t, targetID: r } }) };
  }
  coHostStopBO(t, r) {
    return { seq: this.sendMessageToRwg({ evt: 4243, body: { status: t, targetID: r } }) };
  }
  coHostAssignToBO(t, r, n) {
    return { seq: this.sendMessageToRwg({ evt: 4245, body: { userGUID: t, targetID: n, targetBID: r } }) };
  }
  moveToMainSession(t) {
    return { seq: this.sendMessageToRwg({ evt: 4247, body: { userGUID: t } }) };
  }
  coHostMoveToMainSession(t, r) {
    return { seq: this.sendMessageToRwg({ evt: 4249, body: { userGUID: t, targetID: r } }) };
  }
  allowParticipantRename(t) {
    return { seq: this.sendMessageToRwg({ evt: 4163, body: { bOn: t } }) };
  }
  allowMessageFeedbackNotify(t, r) {
    return { seq: this.sendMessageToRwg({ evt: 4171, body: { bOn: t, id: r } }) };
  }
  setPlayChime(t, r) {
    return { seq: this.sendMessageToRwg({ evt: 4197, body: { bOn: t, id: r } }) };
  }
  admitAllSilentUsers() {
    return { seq: this.sendMessageToRwg({ evt: 4199, body: {} }) };
  }
  bindTeleUser(t, r, n) {
    return { seq: this.sendMessageToRwg({ evt: 4201, body: { teleUserID: t, targetUserID: r, bBind: n } }) };
  }
  practiceSession() {
    return { seq: this.sendMessageToRwg({ evt: 4207, body: null }) };
  }
  roleChangeWebinar(t, r, n, o) {
    return { seq: this.sendMessageToRwg({ evt: 4209, body: { jid: r, userID: n, clientCap: o, bPromote: t } }) };
  }
  sendPromoteConsent(t, r) {
    return { seq: this.sendMessageToRwg({ evt: 4254, body: { agreed: t, req_id: r } }) };
  }
  batchCreateBOToken(t) {
    const r = t.map((n, o) => ({ topic: n, index: o }));
    return { seq: this.sendMessageToRwg({ evt: 4211, body: r }) };
  }
  mute(t, r) {
    return { seq: this.sendMessageToRwg({ evt: 8193, body: { bMute: r, id: t } }) };
  }
  audioDrop(t) {
    return { seq: this.sendMessageToRwg({ evt: 8195, body: { id: t } }) };
  }
  audioDialout(t, r, n, o, i) {
    return { seq: this.sendMessageToRwg({ evt: 8197, body: { pn: t, dn2: kt(r), bCallme: n, bPressOne: o, bGreeting: i } }) };
  }
  audioCancelDialout(t, r) {
    return { seq: this.sendMessageToRwg({ evt: 8199, body: { pn: t, bCallme: r } }) };
  }
  audioMuteAll(t) {
    return { seq: this.sendMessageToRwg({ evt: 8201, body: { bMute: t } }) };
  }
  allowToTalk(t, r) {
    return { seq: this.sendMessageToRwg({ evt: 8204, body: { id: t, bAllowTalk: r } }) };
  }
  subscribeVideo() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, r = arguments.length > 1 ? arguments[1] : void 0, n = arguments.length > 2 ? arguments[2] : void 0;
    return { seq: this.sendMessageToRwg({ evt: 12289, body: { id: t, size: r, bOn: n } }) };
  }
  unsubscribeVideo() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
    return { seq: this.sendMessageToRwg({ evt: 12291, body: { id: t } }) };
  }
  muteAttendeeVideo(t, r) {
    return { seq: this.sendMessageToRwg({ evt: 12297, body: { id: t, bOn: r } }) };
  }
  notifyRwgIsMuteVideo(t, r) {
    return this.muteAttendeeVideo(t, r);
  }
  pauseSharing() {
    return { seq: this.sendMessageToRwg({ evt: 16385, body: {} }) };
  }
  resumeSharing() {
    return { seq: this.sendMessageToRwg({ evt: 16387, body: {} }) };
  }
  allowAnonymousQuestion(t, r) {
    return { seq: this.sendMessageToRwg({ evt: 4155, body: { userId: t, bOn: r } }) };
  }
  allowViewAll(t, r) {
    return { seq: this.sendMessageToRwg({ evt: 4157, body: { userId: t, bOn: r } }) };
  }
  allowVote(t, r) {
    return { seq: this.sendMessageToRwg({ evt: 4159, body: { userId: t, bOn: r } }) };
  }
  allowComment(t, r) {
    return { seq: this.sendMessageToRwg({ evt: 4161, body: { userId: t, bOn: r } }) };
  }
  sharingRequestRemoteControl(t, r) {
    return { seq: this.sendMessageToRwg({ evt: 16389, body: { id: t, bOn: r } }) };
  }
  subscribeGrabRemoteControl(t, r) {
    return { seq: this.sendMessageToRwg({ evt: 16393, body: { id: t, bOn: r } }) };
  }
  subscribeSharing(t, r, n, o) {
    const i = { id: t, size: r };
    return n && Object.assign(i, { bShareToBO: !0 }), o !== void 0 && Object.assign(i, { bVideoShare: o }), { seq: this.sendMessageToRwg({ evt: 16415, body: i }) };
  }
  unsubscribeSharing(t, r) {
    const n = { id: t };
    return r && Object.assign(n, { bShareToBO: !0 }), { seq: this.sendMessageToRwg({ evt: 16417, body: n }) };
  }
  sendRWGConnectionPerformance(t) {
    return { seq: this.sendMessageToRwg({ evt: 4167, body: { data: t } }) };
  }
  sendSdkKeyToMonitor(t, r, n) {
    return { seq: this.sendMessageToRwg({ evt: 4167, body: { data: `ZoomConferenceClient,videoapp_HTML5_sdk_web_join,${n},2,${r},${t}` } }) };
  }
  sendDatachannelOffer(t) {
    return { seq: this.sendMessageToRwg({ evt: 24321, offer: t }) };
  }
  joinOrLeaveVoip(t) {
    return { seq: this.sendMessageToRwg({ evt: 8203, body: { bOn: t } }) };
  }
  startSharing(t, r) {
    return { seq: this.sendMessageToRwg({ evt: 16409, body: { id: t, boOn: !1, ...r != null ? r : {} } }) };
  }
  stopSharing(t) {
    return { seq: this.sendMessageToRwg({ evt: 16409, body: { id: t, bOn: !0 } }) };
  }
  lockSharing(t) {
    return { seq: this.sendMessageToRwg({ evt: 4169, body: { lockShare: t } }) };
  }
  startShareToBreakoutRoom(t) {
    return { seq: this.sendMessageToRwg({ evt: 16425, body: { id: t, bShareToBO: !0 } }) };
  }
  stopShareToBreakoutRoom(t) {
    return { seq: this.sendMessageToRwg({ evt: 16425, body: { id: t, bShareToBO: !1 } }) };
  }
  preAssignBreakoutRoom() {
    return { seq: this.sendMessageToRwg({ evt: 4213, body: {} }) };
  }
  claimHost(t) {
    return { seq: this.sendMessageToRwg({ evt: 4215, body: { hostKey: t } }) };
  }
  allowMultiplePin(t, r) {
    return { seq: this.sendMessageToRwg({ evt: 4217, body: { userID: t, bOn: r } }) };
  }
  spotlightVideo(t, r) {
    return { seq: this.sendMessageToRwg({ evt: 4219, body: { id: t, ...r } }) };
  }
  connectCamera(t, r) {
    const n = { evt: 12307, body: { id: t, bOn: r } };
    return { seq: this.sendMessageToRwg(n) };
  }
  followHostLayout(t) {
    return { seq: this.sendMessageToRwg({ evt: 4223, body: { bFollowHostVideo: t } }) };
  }
  setVideoDragLayout(t) {
    return { seq: this.sendMessageToRwg({ evt: 4218, body: { drag_list: t } }) };
  }
  chatCmdReq(t, r) {
    return { seq: this.sendMessageToRwg({ evt: 4237, body: { msgID: t, cmd: r } }) };
  }
  activeAppLinkReq(t) {
    return { seq: this.sendMessageToRwg({ evt: 4257, body: { appId: t } }) };
  }
  activeAppInfoReq() {
    return { seq: this.sendMessageToRwg({ evt: 4255, body: {} }) };
  }
  muteShareAudio(t, r) {
    const n = { bOn: !0, bShareAudio: !t };
    return r && Object.assign(n, { bShareAudioOnly: !0 }), { seq: this.sendMessageToRwg({ evt: 16423, body: n }) };
  }
  localMuteAudio(t, r) {
    return { seq: this.sendMessageToRwg({ evt: 8209, body: { id: t, bMute: r } }) };
  }
  changeSharePronoun(t, r) {
    return { seq: this.sendMessageToRwg({ evt: 4264, body: { bPronoun: t, strPronoun: r } }) };
  }
  sendReceivingSharingReady(t) {
    return { seq: this.sendMessageToRwg({ evt: 16421, body: { ssrc: t } }) };
  }
  sendManualCaption(t) {
    return { seq: this.sendMessageToRwg({ evt: 4289, body: { ...t } }) };
  }
  sendPollingAction(t, r, n) {
    return { seq: this.sendMessageToRwg({ evt: 4224, body: { action: t, PollingId: r, ...n } }) };
  }
  broadcastUserNetworkQuality(t) {
    const r = { type: t.isUplink, level: t.level, bwLevel: t.bwLevel };
    return { seq: this.sendMessageToRwg({ evt: 4331, body: r }) };
  }
  sendFarEndCameraControl(t, r, n) {
    return { seq: this.sendMessageToRwg({ evt: 4329, body: { cmd: t, userID: r, buttonID: n } }) };
  }
  sendCameraAblity(t) {
    return { seq: this.sendMessageToRwg({ evt: 4330, body: { ...t, focus: !1 } }) };
  }
  sendReaction(t) {
    return { seq: this.sendMessageToRwg({ evt: 4259, body: { ...t } }) };
  }
  remoteControlConsent(t, r, n, o) {
    let i = arguments.length > 4 && arguments[4] !== void 0 && arguments[4];
    const { deviceId: s, ...a } = o;
    return { seq: this.sendMessageToRwg({ evt: 16427, body: { DeviceID: s, op: t, SendUserID: n, AssignUserID: r, ...a, bAutoDelete: i } }) };
  }
  takeBackRemoteControlPermission(t, r) {
    return { seq: this.sendMessageToRwg({ evt: 16431, body: { SendUserID: t, ReceiverUserID: r } }) };
  }
  syncSharedContentMetaWithRcApp(t) {
    const { deviceId: r, ...n } = t;
    return { seq: this.sendMessageToRwg({ evt: 16429, body: { DeviceID: r, ...n } }) };
  }
  startLiveStream(t, r, n) {
    return { seq: this.sendMessageToRwg({ evt: 7977, body: { action: 1, streamingURL: t, streamingKey: r, broadcastURL: n } }) };
  }
  stopLiveStream() {
    return { seq: this.sendMessageToRwg({ evt: 7977, body: { action: 0 } }) };
  }
  sendRemoteControlAuth(t) {
    return { seq: this.sendMessageToRwg({ evt: 16433, body: { auth: t } }) };
  }
  chatFileTransfer(t) {
    return { seq: this.sendMessageToRwg({ evt: 4307, body: { ...t, fileType: 0, receiverType: 0 } }) };
  }
  broadcastVoiceReq(t) {
    return { seq: this.sendMessageToRwg({ evt: 4314, body: { broadcastVoice: t } }) };
  }
}
class We extends wC {
  static createAgent() {
    return this.rwgInstance || (this.rwgInstance = new We()), this.rwgInstance;
  }
}
We.rwgInstance = null;
class Y0 extends wC {
  static getInstance() {
    return this.instance || (this.instance = new Y0()), this.instance;
  }
}
Y0.instance = null;
const EC = [{ name: "audio_simd.min.js", category: "audio", type: "worker", tag: "simd", alias: "audioSIMDWorkletPath" }, { name: "audio.simd.wasm", category: "audio", type: "wasm", tag: "simd", alias: "audioSIMDWasm" }, { name: "js_audio_process.min.js", category: "audio", type: "worker", tag: "", alias: "audioWorkerPath" }, { name: "audio.encode.wasm", category: "audio", type: "wasm", tag: "", alias: "audioWasm" }, { name: "js_audio_worklet.min.js", category: "audio", type: "worklet", tag: "", alias: "audioWorkletPath" }, { name: "js_audio_worklet_simd.min.js", category: "audio", type: "worklet", tag: "simd", alias: "audioWorkletSIMDPath" }, { name: "js_audio_worklet_process.min.js", category: "audio", type: "worklet", tag: "", alias: "audioWorkletProcessPath" }, { name: "js_sharing_audio_worklet.min.js", category: "audio", type: "worklet", tag: "", alias: "sharingAudioWorkletPath" }, { name: "js_audio_level_worklet_process.min.js", category: "audio", type: "worklet", tag: "", alias: "audioLevelWorkletPath" }, { name: "video_mtsimd.min.js", category: "video", type: "worker", tag: "simd,thread", alias: "videoMSIMDWorkerPath" }, { name: "video.mtsimd.wasm", category: "video", type: "wasm", tag: "simd,thread,videoShare", alias: "videoMSIMDWasm" }, { name: "video_m.min.js", category: "video", type: "worker", tag: "thread", alias: "videoMtWorkerPath" }, { name: "video.mt.wasm", category: "video", type: "wasm", tag: "thread", alias: "videoMtWasm" }, { name: "video_simd.min.js", category: "video", type: "worker", tag: "simd", alias: "videoSIMDWorkerPath" }, { name: "video.simd.wasm", category: "video", type: "wasm", tag: "simd", alias: "videoSIMDWasm" }, { name: "video_s.min.js", category: "video", type: "worker", tag: "", alias: "videoWorkerPath" }, { name: "video.decode.wasm", category: "video", type: "wasm", tag: "", alias: "videoWasm" }, { name: "video_share_mtsimd.min.js", category: "video", type: "worker", tag: "videoShare", alias: "vsmiworkerpath" }, { name: "sharing_mtsimd.min.js", category: "sharing", type: "worker", tag: "simd,thread", alias: "sharingMSIMDWorkerPath" }, { name: "sharing_m.min.js", category: "sharing", type: "worker", tag: "thread", alias: "sharingMtWorkerPath" }, { name: "sharing_simd.min.js", category: "sharing", type: "worker", tag: "simd", alias: "sharingSIMDWorkerPath" }, { name: "sharing_s.min.js", category: "sharing", type: "worker", tag: "", alias: "sharingWorkerPath" }], C2 = "1505", IC = (e, t) => EC.reduce((r, n) => {
  const { name: o, alias: i } = n;
  return Object.assign(r, { [`${i}`]: `${e}/${t && C2 ? `${C2}_` : ""}${o}` }), r;
}, {});
let ur = function(e) {
  return e.VideoEncode = "0", e.VideoDecode = "1", e.AudioEncode = "2", e.AudioDecode = "3", e.SharingEncode = "4", e.SharingDecode = "5", e;
}({});
const Ws = lt.WebclientIVState;
class ke {
  static getInstance() {
    return this.agentInstance === void 0 && (this.agentInstance = new ke()), this.agentInstance;
  }
  constructor() {
    this.assetsPath = void 0, this.instance = void 0, this.callbackList = void 0, this.mediaWorkersPath = void 0, this.constraints = void 0, this.svcUrl = void 0, this.meetingNumber = void 0, this.confId = void 0, this.mediaSocketAddress = void 0, this.currentUserId = void 0, this.receivedSharingCanvas = void 0, this.sharingCanvas = void 0, this.mediaOptions = void 0, this.inProgress = void 0, this.callbackList = [];
  }
  init(t) {
    if (!this.instance && window.JsMediaSDK_Instance) {
      const r = { ivObj: { [qt.AUDIO_ENCODE]: xe.get(Ws) && xe.get(Ws)[qt.AUDIO_ENCODE], [qt.VIDEO_ENCODE]: xe.get(Ws) && xe.get(Ws)[qt.VIDEO_ENCODE], [qt.SHARING_ENCODE]: xe.get(Ws) && xe.get(Ws)[qt.SHARING_ENCODE] }, globalTracingLogger: t };
      this.instance = new window.JsMediaSDK_Instance(r), this.instance.setRWGAgent(We.createAgent());
    }
  }
  setAssetsAndConstraint(t, r, n, o) {
    var i;
    this.assetsPath = t, this.constraints = r, this.mediaWorkersPath = IC(this.assetsPath, !!n), this.onMediaSDKCallback = this.onMediaSDKCallback.bind(this), this.mediaOptions = o, (i = this.instance) === null || i === void 0 || i.JsMediaSDK_PreLoad(this.mediaWorkersPath, this.onMediaSDKCallback, o);
  }
  onMediaSDKCallback(t, r) {
    this.callbackList.length > 0 && this.callbackList.forEach((n) => n(t, r));
  }
  registerCallback(t) {
    this.callbackList.push(t);
  }
  unregisterCallback(t) {
    this.callbackList = this.callbackList.filter((r) => r !== t);
  }
  static isSupportVideoEncodeHardwareAcceleration() {
    return window.JsMediaSDK_Instance.util.IsSupportVideoEncodeHardwareAcceleration();
  }
  static isSupportVideoDecodeHardwareAcceleration() {
    return window.JsMediaSDK_Instance.util.IsSupportVideoDecodeHardwareAcceleration();
  }
  static isCompatibleHardwareForEncode() {
    var t;
    return ve.isSupportOffscreenCanvas && ((t = window.JsMediaSDK_Instance) === null || t === void 0 ? void 0 : t.util.AdapterWhiteListCheckForEncoder()) == 0;
  }
  static getPTZCapability() {
    var t, r, n, o, i, s, a, l, u;
    return { pan: !((t = window.JsMediaSDK_Instance) === null || t === void 0 || (r = t.util) === null || r === void 0 || (n = r.isSupportCameraPan) === null || n === void 0 || !n.call(r)), tilt: !((o = window.JsMediaSDK_Instance) === null || o === void 0 || (i = o.util) === null || i === void 0 || (s = i.isSupportCameraTilt) === null || s === void 0 || !s.call(i)), zoom: !((a = window.JsMediaSDK_Instance) === null || a === void 0 || (l = a.util) === null || l === void 0 || (u = l.isSupportCameraZoom) === null || u === void 0 || !u.call(l)) };
  }
  static isSupportVideoShare() {
    var t, r, n;
    return !((t = window.JsMediaSDK_Instance) === null || t === void 0 || (r = t.util) === null || r === void 0 || (n = r.isSupportVideoShareReceive) === null || n === void 0 || !n.call(r));
  }
  static isSupportVideoShareSend() {
    var t, r, n;
    return !((t = window.JsMediaSDK_Instance) === null || t === void 0 || (r = t.util) === null || r === void 0 || (n = r.isSupportVideoShareSend) === null || n === void 0 || !n.call(r));
  }
  static isSupportSending720P() {
    var t, r;
    return !((t = window.JsMediaSDK_Instance) === null || t === void 0 || (r = t.util) === null || r === void 0 || !r.get720pcapacity());
  }
  static isSupportSubscribing1080P() {
    var t, r;
    return !((t = window.JsMediaSDK_Instance) === null || t === void 0 || (r = t.util) === null || r === void 0 || !r.getsub1080pcapacity());
  }
  static isSupportOpenMicWhenShareAudio() {
    var t;
    return !((t = window.JsMediaSDK_Instance) === null || t === void 0 || !t.util.isSupportOpenMicWhenShareAudio());
  }
  static isSupportMediaPlaybackAsVideoInput() {
    var t, r;
    return !((t = window.JsMediaSDK_Instance) === null || t === void 0 || (r = t.util.videoToMediaStreamManager) === null || r === void 0 || !r.isSupported());
  }
  static isSupportMediaPlaybackAsAudioInput() {
    var t, r;
    return !((t = window.JsMediaSDK_Instance) === null || t === void 0 || (r = t.util.audioToMediaStreamMananger) === null || r === void 0 || !r.isSupported());
  }
  static isSupportAudioDenoise(t) {
    var r;
    return !((r = window.JsMediaSDK_Instance) === null || r === void 0 || !r.util.isSupportAudioDenoise(t));
  }
  static isSupportAudioBridgeAVSync() {
    var t;
    return !((t = window.JsMediaSDK_Instance) === null || t === void 0 || !t.util.isSupportAudioBridgeAvsync());
  }
  static getAudioFeatureFlag() {
    var t;
    return (t = window.JsMediaSDK_Instance) === null || t === void 0 ? void 0 : t.util.getAudioFeatureFlags();
  }
  static isSupportShareMultiStream() {
    var t;
    return (t = window.JsMediaSDK_Instance) === null || t === void 0 ? void 0 : t.util.isSupportShareMultiStream();
  }
  static isSupportVideoLTR() {
    var t;
    return (t = window.JsMediaSDK_Instance) === null || t === void 0 ? void 0 : t.util.isSupportVideoLTR();
  }
  static isSupportStereoAudio() {
    var t;
    return !((t = window.JsMediaSDK_Instance) === null || t === void 0 || !t.util.isBrowserSupportStereo());
  }
  static isSupportFullHDVideo() {
    var t;
    return !((t = window.JsMediaSDK_Instance) === null || t === void 0 || !t.util.isSupportSendVideoFullHD());
  }
  static isSupportFullHDVideoShare() {
    var t;
    return !((t = window.JsMediaSDK_Instance) === null || t === void 0 || !t.util.isSupportSendVideoShareFullHD());
  }
  static isSupportShare2ndAudioDevice(t) {
    var r;
    return !((r = window.JsMediaSDK_Instance) === null || r === void 0 || !r.util.isSupportShare2ndAudioDevice(t));
  }
  connect(t) {
    var r, n, o, i, s, a;
    let { svcUrl: l, meetingNumber: u, conId: d, e2eEncrypt: c, isViewOnly: p, currentUserId: h, isWebinar: v, enableAudioQos: f, enableVideoQos: m = !1, enableWebtransport: g = !1, webtransportPort: C, rendererType: b, adaptedABOptionForMediaSDK: E } = t;
    const { isSupportEssentialAudioAndVideoAbility: w, isSupportAudioWorklet: _, isSupportSendScreenSharing: I } = ve;
    this.svcUrl = l, this.meetingNumber = u, this.confId = d;
    const D = ((fe, le, Ae) => ({ videoSocketAddress: `wss://${fe}/wc/media/${le}?type=v&cid=${Ae}`, audioSocketAddress: `wss://${fe}/wc/media/${le}?type=a&cid=${Ae}`, sharingSocketAddress: `wss://${fe}/wc/media/${le}?type=${bC() ? "j" : "s"}&cid=${Ae}` }))(l, u, d);
    this.mediaSocketAddress = D, this.currentUserId = h;
    const B = Ia((r = this.mediaOptions) === null || r === void 0 ? void 0 : r.enableMultiDecodeVideoWithoutSAB);
    var L, R, y, A, k, T, N, F, $, re;
    (n = this.instance) === null || n === void 0 || n.setPropsBeforeInit({ callback: this.onMediaSDKCallback, audioWorkerPath: w ? (o = this.mediaWorkersPath) === null || o === void 0 ? void 0 : o.audioWorkletPath : void 0, e2eEncrypt: c, isEnableListenInitEvent: !0, enableWebtransport: g, webtransportPort: C, featureOptions: E, rendererType: b }), ((i = this.constraints) === null || i === void 0 ? void 0 : i.audio) === !0 && w && !fr() && ((v || _) && ((L = this.instance) === null || L === void 0 || L.initAudioDecode(this.mediaWorkersPath, D.audioSocketAddress, h, xi, d, u, B, f)), !_ || v && p || (R = this.instance) === null || R === void 0 || R.initAudioEncode(this.mediaWorkersPath, D.audioSocketAddress, h, xi, d, u, B, f)), ((s = this.constraints) === null || s === void 0 ? void 0 : s.video) === !0 && w && ((y = this.instance) === null || y === void 0 || y.initVideoDecode(this.mediaWorkersPath, D.videoSocketAddress, h, xi, d, u, B, (A = (k = window.JsMediaSDK_Instance) === null || k === void 0 || (T = k.util) === null || T === void 0 ? void 0 : T.isGraphicShouldUseHardwareAccelerationDecode()) === null || A === void 0 || A, m), v && p || (N = this.instance) === null || N === void 0 || N.initVideoEncode(this.mediaWorkersPath, D.videoSocketAddress, h, xi, d, u, B, !1, m, !0, !0)), ((a = this.constraints) === null || a === void 0 ? void 0 : a.screen) === !0 && (w ? ((F = this.instance) === null || F === void 0 || F.initSharingDecode(this.mediaWorkersPath, D.sharingSocketAddress, h, xi, d, u, B), !I || v && p || ($ = this.instance) === null || $ === void 0 || $.initSharingEncode(this.mediaWorkersPath, D.sharingSocketAddress, h, xi, d, u, B)) : (re = this.instance) === null || re === void 0 || re.initSharingDecode(D.sharingSocketAddress)), this.inProgress = !0;
  }
  async destroy() {
    var t;
    this.callbackList = [], [ur.AudioDecode, ur.AudioEncode, ur.VideoDecode, ur.VideoEncode].forEach((r) => {
      var n;
      (n = this.instance) === null || n === void 0 || n.updateQosSubscription(!1, r);
    }), await ((t = this.instance) === null || t === void 0 ? void 0 : t.destroy()), this.instance = null, this.inProgress = !1;
  }
  disconnect() {
    var t, r;
    (t = this.instance) === null || t === void 0 || t.Notify_MeidaSDK(17, {}), (r = this.instance) === null || r === void 0 || r.JsMediaSDK_UnInit();
  }
  muteAudio() {
    var t;
    (t = this.instance) === null || t === void 0 || t.Notify_MeidaSDK(8, { ssrc: 0 });
  }
  unmuteAudio() {
    var t;
    (t = this.instance) === null || t === void 0 || t.Notify_MeidaSDK(7, { ssrc: 0, AudioSelectValue: 0 });
  }
  joinComputerAudio(t, r, n, o, i, s, a) {
    var l;
    const u = a ? { ...a, enableHID: !0 } : { enableHID: !1 };
    return (l = this.instance) === null || l === void 0 ? void 0 : l.Notify_MeidaSDK(22, { CaptureAudio: o, CaptureAudioInfo: { ssrc: t, AudioSelectValue: r === "default" ? null : r, ...u, audioProfile: i }, speakerInfo: { defaultDeviceId: n }, ...s ? { useAudioBridge: !0, audioBridge: s } : {} });
  }
  leaveComputerAudio() {
    var t;
    return (t = this.instance) === null || t === void 0 ? void 0 : t.Notify_MeidaSDK(21, null);
  }
  joinSharingAudio(t) {
    var r;
    let { ssrc: n, microphoneDeviceId: o, speakerDeviceId: i, isCaptureAudio: s, audioBridge: a } = t;
    return (r = this.instance) === null || r === void 0 ? void 0 : r.Notify_MeidaSDK(72, { CaptureAudio: s, CaptureAudioInfo: { ssrc: n, AudioSelectValue: o === "default" ? null : o }, speakerInfo: { defaultDeviceId: i }, checkAutoplay: !1, ...a ? { useAudioBridge: !0, audioBridge: a } : {} });
  }
  leaveSharingAudio(t) {
    var r;
    return (r = this.instance) === null || r === void 0 ? void 0 : r.Notify_MeidaSDK(73, { isPause: t ? 1 : 0 });
  }
  changeSpeaker(t) {
    var r;
    (r = this.instance) === null || r === void 0 || r.Notify_MeidaSDK(11, { ssrc: 0, AudioSelectValue: t });
  }
  changeMicrophone(t, r, n) {
    var o;
    (o = this.instance) === null || o === void 0 || o.Notify_MeidaSDK(18, { ssrc: 0, AudioSelectValue: t === "default" ? null : t, microphoneLabel: r != null ? r : "default", defaultMuted: n });
  }
  restoreWebRTC(t) {
    var r;
    (r = this.instance) === null || r === void 0 || r.Notify_MeidaSDK(19, { ssrc: 0, AudioSelectValue: t === "default" ? null : t });
  }
  renderVideo(t, r, n, o, i, s, a, l, u, d, c) {
    var p;
    const h = { userId: r, width: o, height: i, x: s, y: a, quality: l, isMyself: u, canvas: t, enableWaterMark: c, waterMarkText: d, zone: n };
    t instanceof HTMLVideoElement && Object.assign(h, { videodom: t }), (p = this.instance) === null || p === void 0 || p.Notify_MeidaSDK(1, h);
  }
  stopRenderVideo(t, r, n, o) {
    var i;
    let s = arguments.length > 4 && arguments[4] !== void 0 && arguments[4];
    (i = this.instance) === null || i === void 0 || i.Notify_MeidaSDK(2, { canvas: t, userId: r, RGBA: o, doNotClean: s, zone: n });
  }
  startCaptureVideo(t, r, n, o, i, s) {
    var a;
    let l = arguments.length > 6 && arguments[6] !== void 0 && arguments[6], u = arguments.length > 8 ? arguments[8] : void 0;
    const d = arguments.length > 7 && arguments[7] ? ke.getPTZCapability() : void 0;
    (a = this.instance) === null || a === void 0 || a.Notify_MeidaSDK(3, { ssid: t, width: n, height: o, fps: u, video: i, usingFacingMode: s, VideoSelectValue: r === "default" ? null : r, disableOriginalRatio: l, ...d });
  }
  stopCaptureVideo() {
    var t;
    (t = this.instance) === null || t === void 0 || t.Notify_MeidaSDK(4, { ssrc: 0 });
  }
  changeCamera(t, r) {
    var n;
    (n = this.instance) === null || n === void 0 || n.Notify_MeidaSDK(12, { VideoSelectValue: t === "default" ? null : t, ...r || {} });
  }
  switchCanvasForVideoCapture(t) {
    var r;
    let n = t;
    typeof t == "string" && (n = [t]), (r = this.instance) === null || r === void 0 || r.Notify_MeidaSDK(25, n);
  }
  renderSharing(t, r) {
    var n;
    let o = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", s = arguments.length > 4 && arguments[4] !== void 0 && arguments[4];
    this.receivedSharingCanvas = r, (n = this.instance) === null || n === void 0 || n.Notify_MeidaSDK(23, { width: 0, height: 0, ssrc: t, canvas: r, enableWaterMark: o, waterMarkText: i, isFromMainSession: s });
  }
  stopRenderSharing() {
    var t;
    (t = this.instance) === null || t === void 0 || t.Notify_MeidaSDK(24, {});
  }
  switchSharingSource(t) {
    var r;
    let n = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
    (r = this.instance) === null || r === void 0 || r.Notify_MeidaSDK(36, { ssrc: t, isFromMainSession: Number(n) });
  }
  ajustmentReceivedSharingCanvas(t, r) {
    if (this.receivedSharingCanvas)
      try {
        this.receivedSharingCanvas.width = t, this.receivedSharingCanvas.height = r;
      } catch {
      }
  }
  startRemoteControl(t, r, n) {
    var o;
    (o = this.instance) === null || o === void 0 || o.Notify_MeidaSDK(26, { socketURL: `wss://${this.svcUrl}`, meetingID: this.meetingNumber, condID: this.confId, os: r, dom: t, ...n });
  }
  stopRemoteControl() {
    var t;
    (t = this.instance) === null || t === void 0 || t.Notify_MeidaSDK(28);
  }
  resendRemoteControlPositionPDU() {
    var t;
    (t = this.instance) === null || t === void 0 || t.Notify_MeidaSDK(41);
  }
  updateRemoteControlProperties(t) {
    var r;
    const { dimension: n, ...o } = t;
    (r = this.instance) === null || r === void 0 || r.Notify_MeidaSDK(27, { ...n, ...o });
  }
  startDesktopSharing(t, r, n, o) {
    var i;
    let s = !(arguments.length > 4 && arguments[4] !== void 0) || arguments[4], a = arguments.length > 5 ? arguments[5] : void 0, l = arguments.length > 6 ? arguments[6] : void 0, u = arguments.length > 7 ? arguments[7] : void 0;
    this.sharingCanvas = document.querySelector(`#${r}`);
    const d = {};
    o && Object.assign(d, { share2ndCamera: !0, share2ndCameraParams: { VideoSelectValue: o.cameraId === "default" ? null : o.cameraId, width: o.width, height: o.height } }), a !== void 0 && Object.assign(d, { videoParams: { displaySurface: a } }), u !== void 0 && Object.assign(d, { otherParams: { ...u } }), (i = this.instance) === null || i === void 0 || i.Notify_MeidaSDK(30, { ssid: t, canvas: r, video: n, ...d, showShareAudioOption: s, sourceId: l });
  }
  stopDesktopSharing() {
    var t;
    (t = this.instance) === null || t === void 0 || t.Notify_MeidaSDK(31, {});
  }
  pauseDesktopSharing() {
    var t;
    (t = this.instance) === null || t === void 0 || t.Notify_MeidaSDK(32, {});
  }
  resumeDesktopSharing() {
    var t;
    (t = this.instance) === null || t === void 0 || t.Notify_MeidaSDK(33, {});
  }
  selectLanguageChannelForNewLTT(t) {
    var r;
    (r = this.instance) === null || r === void 0 || r.Notify_MeidaSDK(57, { lang: t });
  }
  changeSharingSecondCamera(t) {
    var r;
    (r = this.instance) === null || r === void 0 || r.Notify_MeidaSDK(49, { VideoSelectValue: t });
  }
  ajustmentSharingCanvas(t, r) {
    if (this.sharingCanvas)
      try {
        this.sharingCanvas.width = t, this.sharingCanvas.height = r;
      } catch {
      }
  }
  checkChromeSharingExtension() {
    var t;
    (t = this.instance) === null || t === void 0 || t.Notify_MeidaSDK(34, {});
  }
  enableAudioEncode() {
    var t, r;
    (t = this.instance) === null || t === void 0 || t.initAudioEncode(this.mediaWorkersPath, this.mediaSocketAddress.audioSocketAddress, this.currentUserId, xi, this.confId, this.meetingNumber, Ia((r = this.mediaOptions) === null || r === void 0 ? void 0 : r.enableMultiDecodeVideoWithoutSAB));
  }
  sendUserNodeList(t, r) {
    var n;
    (n = this.instance) === null || n === void 0 || n.Notify_MeidaSDK(43, { userList: t, encryptKey: r });
  }
  updateRenderedSharingDimension(t, r) {
    var n;
    (n = this.instance) === null || n === void 0 || n.Notify_MeidaSDK(44, { width: t, height: r });
  }
  pauseOrResumeAudio(t) {
    var r;
    (r = this.instance) === null || r === void 0 || r.Notify_MeidaSDK(45, { bPause: t });
  }
  updateRenderedVideoCanvasDimension(t, r, n) {
    var o;
    (o = this.instance) === null || o === void 0 || o.Notify_MeidaSDK(46, { canvas: t, width: r, height: n });
  }
  clearVideoCanvas(t, r) {
    var n;
    (n = this.instance) === null || n === void 0 || n.Notify_MeidaSDK(47, { id: t, RGBA: r });
  }
  adjustRenderedVideoPosition(t, r, n, o, i, s, a, l) {
    var u;
    (u = this.instance) === null || u === void 0 || u.Notify_MeidaSDK(48, { userId: r, x: o, y: i, width: s, height: a, canvas: t, zone: n, RGBA: l });
  }
  mirrorVideo(t) {
    var r;
    (r = this.instance) === null || r === void 0 || r.Notify_MeidaSDK(75, { isMirrorMyVideo: t });
  }
  updateUserMediaSN(t) {
    var r, n, o;
    (r = this.instance) === null || r === void 0 || r.Notify_MeidaSDK(80, { isFromMainSession: Number(t.isFromMainSession), mediaActionType: t.iVType, body: { add: (n = t.added) !== null && n !== void 0 ? n : [], remove: (o = t.removed) !== null && o !== void 0 ? o : [] } });
  }
  updateMediaParams(t) {
    var r;
    const { iVType: n, isFromMainSession: o, updateParams: i } = t;
    (r = this.instance) === null || r === void 0 || r.Notify_MeidaSDK(81, { mediaActionType: n, isFromMainSession: Number(o), updateParams: i });
  }
  createMainSessionChannel(t, r) {
    var n, o;
    t === "sharing" ? (n = this.instance) === null || n === void 0 || n.Notify_MeidaSDK(84, r) : (o = this.instance) === null || o === void 0 || o.Notify_MeidaSDK(85, r);
  }
  addReceivedSharingChannelType(t) {
    var r;
    const { isFromMainSession: n, ...o } = t;
    (r = this.instance) === null || r === void 0 || r.Notify_MeidaSDK(82, { isFromMainSession: Number(n), ...o });
  }
  removeReceivedSharingChannelType(t) {
    var r;
    (r = this.instance) === null || r === void 0 || r.Notify_MeidaSDK(83, { isFromMainSession: Number(t.isFromMainSession), ssrc: t.ssrc });
  }
  enableHardwareAccelerationForVideoDecode(t) {
    var r;
    (r = this.instance) === null || r === void 0 || r.Notify_MeidaSDK(70, { enable: t });
  }
  enableHardwareAccelerationForVideoEncode(t) {
    var r;
    (r = this.instance) === null || r === void 0 || r.Notify_MeidaSDK(71, { enable: t });
  }
  setSharingAudioVolume(t, r, n) {
    var o;
    (o = this.instance) === null || o === void 0 || o.Notify_MeidaSDK(74, { userid: t >> 10, shareVolume: r ? 0 : 100, isFromMainSession: n });
  }
  subscribeToQos(t, r) {
    t.forEach((n) => {
      var o;
      (o = this.instance) === null || o === void 0 || o.updateQosSubscription(!0, n, r);
    });
  }
  unsubscribeFromQos(t) {
    t.forEach((r) => {
      var n;
      (n = this.instance) === null || n === void 0 || n.updateQosSubscription(!1, r);
    });
  }
  passThroughRWGMessage(t) {
    var r;
    (r = this.instance) === null || r === void 0 || r.Notify_MeidaSDK(40, t);
  }
  startVirtualBackgroundSetting(t, r, n, o, i, s) {
    var a;
    let l = arguments.length > 6 && arguments[6] !== void 0 && arguments[6];
    (a = this.instance) === null || a === void 0 || a.Notify_MeidaSDK(91, { canvas: t, bgdom: r, width: i, height: s, ssid: n, VideoSelectValue: o === "default" ? null : o, disableOriginalRatio: l });
  }
  updateVirtualBackgroundImage(t) {
    var r;
    (r = this.instance) === null || r === void 0 || r.Notify_MeidaSDK(92, { bgdom: t });
  }
  stopVirtualBackgroundSetting() {
    var t;
    let r = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
    (t = this.instance) === null || t === void 0 || t.Notify_MeidaSDK(93, { isSwitch: r });
  }
  startMaskSetting(t, r, n, o, i, s, a, l, u) {
    var d;
    (d = this.instance) === null || d === void 0 || d.Notify_MeidaSDK(62, { canvas: t, maskdom: n, bgdom: r, dx: 0, dy: 0, dWidth: s, dHeight: a, width: l, height: u, ssid: o, VideoSelectValue: i === "default" ? null : i });
  }
  updateMaskBackgroundImage(t) {
    var r;
    (r = this.instance) === null || r === void 0 || r.Notify_MeidaSDK(63, { bgdom: t });
  }
  updateMaskClip(t, r, n) {
    var o;
    (o = this.instance) === null || o === void 0 || o.Notify_MeidaSDK(64, { maskdom: t, dx: 0, dy: 0, dWidth: r, dHeight: n });
  }
  stopMaskSetting() {
    var t;
    let r = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
    (t = this.instance) === null || t === void 0 || t.Notify_MeidaSDK(65, { isSwitch: r });
  }
  enableVideoObserver(t) {
    var r;
    let n = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
    (r = this.instance) === null || r === void 0 || r.Notify_MeidaSDK(99, { enable: t, fpsdisbale: n });
  }
  enableShareAudioToBreakoutRoom(t) {
    var r;
    (r = this.instance) === null || r === void 0 || r.Notify_MeidaSDK(86, { enable: t });
  }
  sendUserAudioStatus(t) {
    var r;
    (r = this.instance) === null || r === void 0 || r.Notify_MeidaSDK(51, t);
  }
  muteOrUnmuteOtherAudio(t, r) {
    var n;
    (n = this.instance) === null || n === void 0 || n.Notify_MeidaSDK(50, { userId: t, volume: r ? 0 : 100 });
  }
  adjustOtherAudioVolume(t, r) {
    var n;
    (n = this.instance) === null || n === void 0 || n.Notify_MeidaSDK(50, { userId: t, volume: r });
  }
  notifySDKMeetingReady() {
    var t;
    (t = this.instance) === null || t === void 0 || t.Notify_MeidaSDK(113);
  }
  movePTZCamera(t) {
    var r, n;
    return (r = window.JsMediaSDK_Instance) === null || r === void 0 || (n = r.util) === null || n === void 0 ? void 0 : n.queryPTZPermisson().then((o) => {
      var i;
      return o ? ((i = this.instance) === null || i === void 0 || i.Notify_MeidaSDK(53, t), Promise.resolve("")) : Promise.reject("Cannot move camera without permission granted");
    });
  }
  switchSharingMode(t) {
    var r;
    (r = this.instance) === null || r === void 0 || r.Notify_MeidaSDK(101, { mode: t });
  }
  updateVideoHDValue(t) {
    var r;
    (r = this.instance) === null || r === void 0 || r.Notify_MeidaSDK("update_videohd_value", { videohd: t });
  }
  updateVideoFullhdValue(t) {
    var r;
    (r = this.instance) === null || r === void 0 || r.Notify_MeidaSDK("update_videofullhd_value", { videofullhd: t });
  }
  changeAudioProfile(t) {
    var r;
    (r = this.instance) === null || r === void 0 || r.Notify_MeidaSDK(126, t);
  }
  enableSyncButtonsOnHeadset(t, r, n) {
    var o;
    (o = this.instance) === null || o === void 0 || o.Notify_MeidaSDK(100, { enable: t, microphoneLabel: r, defaultMuted: n });
  }
  stopAllIncomingAudio(t) {
    var r;
    (r = this.instance) === null || r === void 0 || r.Notify_MeidaSDK(123, t);
  }
  isSharingEntireScreen() {
    var t, r;
    const n = (t = this.instance) === null || t === void 0 || (r = t.getShareStreamInfo) === null || r === void 0 ? void 0 : r.call(t);
    if (n) {
      const { displaySurface: o } = n;
      return !o || o === "monitor";
    }
    return !1;
  }
  getShareStreamInfo() {
    var t, r;
    const n = (t = this.instance) === null || t === void 0 || (r = t.getShareStreamInfo) === null || r === void 0 ? void 0 : r.call(t);
    if (n) {
      const { deviceId: o, width: i, height: s } = n;
      return { deviceId: o, width: i, height: s };
    }
    return {};
  }
  preInitAudioBridge(t) {
    var r;
    (r = this.instance) === null || r === void 0 || r.previewInit({ audioBridge: { ...t } });
  }
  prefetchVideoSsrc(t) {
    var r;
    (r = this.instance) === null || r === void 0 || r.Notify_MeidaSDK(110, { ssrc: t });
  }
  cancelPrefetchVideoSsrc(t) {
    var r;
    (r = this.instance) === null || r === void 0 || r.Notify_MeidaSDK(112, { ssrc: t, haddata: !1 });
  }
  setMobileRotateMode(t) {
    var r;
    (r = this.instance) === null || r === void 0 || r.Notify_MeidaSDK(124, { isLandScape: t });
  }
  changeActiveVideoSsrc(t) {
    var r;
    (r = this.instance) === null || r === void 0 || r.Notify_MeidaSDK(13, { ssrc: t });
  }
  setAudioCodecMode(t) {
    var r;
    (r = this.instance) === null || r === void 0 || r.Notify_MeidaSDK(122, { mode: t });
  }
  startRemoteControlQRCheck(t) {
    var r;
    (r = this.instance) === null || r === void 0 || r.Notify_MeidaSDK(54, { enable: t });
  }
  broadcastVoiceToBreakoutRoom(t) {
    var r;
    (r = this.instance) === null || r === void 0 || r.Notify_MeidaSDK(87, { enable: t });
  }
  share2ndAudio(t, r) {
    var n;
    const o = { audioOnly: !0, deviceId: t === "default" ? null : t };
    r && Object.assign(o, r), (n = this.instance) === null || n === void 0 || n.Notify_MeidaSDK(129, o);
  }
}
ke.agentInstance = void 0;
const xu = "ADD_CURRENT_USER_PARTICIPANT_ATTRIBUTE", Qr = "UPDATE_CURRENT_USER_PARTICIPANT_ATTRIBUTE", AC = "ADD_USER_PARTICIPANT_ATTRIBUTE", Mo = "UPDATE_USER_PARTICIPANT_ATTRIBUTE", am = "REMOVE_USER_PARTICIPANT_ATTRIBUTE", yi = "UPDATE_WEBINAR_PARTICIPANT_ATTRIBUTE", _C = "REMOVE_WEBINAR_ATTENDEE_ATTRIBUTE", RC = "JOIN_MEETING_SUCCESS", cr = "JOIN_MEETING_FAILED", Hr = "RECONNECTING_MEETING", Qi = "LEAVING_MEETING", lm = "MEETING_IN_WAITING_ROOM", um = "UPDATE_MEETING_ATTRIBUTE", OC = "SHARE_PRONOUN_TYPE_UPDATE";
var Wn = function(e) {
  return e.ConnectionChange = "connection-change", e.OnHoldChange = "on-hold-change", e.UserAdd = "user-added", e.UserUpdate = "user-updated", e.UserRemove = "user-removed", e.AttendeeUpdate = "attendee-updated", e.MeetingAttributeUpdate = "meeting-attribute-updated", e.PromoteAttendeeConsent = "promote-attendee-consent", e.ActiveAppsUpdate = "active-apps-updated", e.SharePronounTypeUpdate = "share-pronoun-type-update", e;
}(Wn || {});
const lO = { JoinMeeting: { success: xu, fail: [cr] } }, uO = { [Wn.ConnectionChange]: [{ event: RC, payload: () => ({ state: ha.Connected }) }, { event: cr, payload: (e) => ({ state: ha.Fail, ...e }) }, { event: Hr, payload: (e) => ({ state: ha.Reconnecting, ...e }) }, { event: Qi, payload: (e) => ({ state: ha.Closed, ...e }) }], [Wn.OnHoldChange]: [{ event: lm, payload: (e) => ({ isOnHold: e }) }], [Wn.UserAdd]: [{ event: xu, payload: (e) => [e] }, { event: AC, payload: (e) => e }], [Wn.UserUpdate]: [{ event: Qr, payload: (e) => [e] }, { event: Mo, payload: (e) => e }], [Wn.UserRemove]: [{ event: am, payload: (e) => e }], [Wn.AttendeeUpdate]: [{ event: yi, payload: (e) => e }, { event: _C, payload: (e) => e }], [Wn.MeetingAttributeUpdate]: [{ event: um, payload: (e) => "bNoHostTimeOut" in e ? { isHostLost: e.bNoHostTimeOut } : null }], [Wn.PromoteAttendeeConsent]: [{ event: "MEETING_WEBINAR_PROMOTE_CONSENT_REQ", payload: (e) => {
  let { req_id: t, sender_id: r } = e;
  return { reqId: t, senderId: r };
} }], [Wn.ActiveAppsUpdate]: [{ event: "ACTIVE_APPS_UPDATE", payload: () => {
} }], [Wn.SharePronounTypeUpdate]: [{ event: OC, payload: (e) => e }] }, Hl = "LIVE_TRANSCRIPTION_RECEIVE_MESSAGE", Jn = "LIVE_TRANSCRIPTION_CAPTION_STATUS_CHANGE_RESPONSE", TC = "LIVE_TRANSCRIPTION_STATUS_CHANGE", Rc = "LIVE_TRANSCRIPTION_HOST_DISABLE_CHANGE", dO = { "caption-message": [{ event: Hl, payload: (e) => e }], "caption-status": [{ event: Jn, payload: (e) => e }], "caption-enable": [{ event: TC, payload: (e) => e }], "caption-host-disable": [{ event: Rc, payload: (e) => e }] }, Cs = "CHAT_RECEIVE_MESSAGE_EVENTS", Aa = "CHAT_PRIVILEGE_CHANGE", kC = "CHAT_MESSAGE_RESPONSE", Oc = "CHAT_DELETE_MESSAGE_REPONSE", Ps = "CHAT_FILE_CHAT_UPLOAD_PROGRESS", Nd = "CHAT_FILE_CHAT_DOWNLOAD_PROGRESS";
let fl = function(e) {
  return e.ChatOnMessage = "chat-on-message", e.ChatPrivilegeChange = "chat-privilege-change", e.ChatDeleteMessage = "chat-delete-message", e.ChatFileUploadProgress = "chat-file-upload-progress", e.ChatFileDownloadProgress = "chat-file-download-progress", e;
}({});
const cO = { [fl.ChatOnMessage]: [{ event: Cs, payload: (e) => e }], [fl.ChatPrivilegeChange]: [{ event: Aa, payload: (e) => e }], [fl.ChatDeleteMessage]: [{ event: Oc, payload: (e) => e }], [fl.ChatFileUploadProgress]: [{ event: Ps, payload: (e) => e }], [fl.ChatFileDownloadProgress]: [{ event: Nd, payload: (e) => e }] }, MC = "COMMAND_RECEIVE_MESSAGE_EVENTS", dm = "COMMAND_STATUS_EVENTS";
let w2 = function(e) {
  return e.CommandChannelStatus = "command-channel-status", e.CommandChannelMessage = "command-channel-message", e;
}({});
const pO = { [w2.CommandChannelStatus]: [{ event: dm, payload: (e) => e }], [w2.CommandChannelMessage]: [{ event: MC, payload: (e) => e }] };
let Qn = function(e) {
  return e.Recording = "Recording", e.Paused = "Paused", e.Stopped = "Stopped", e.Ask = "Ask", e.Accept = "Accept", e.Decline = "Decline", e;
}({}), Zt = function(e) {
  return e[e.None = 0] = "None", e[e.Init = 1] = "Init", e[e.Start = 2] = "Start", e[e.Pause = 3] = "Pause", e[e.Stop = 4] = "Stop", e;
}({}), lu = function(e) {
  return e[e.Stop = 0] = "Stop", e[e.Start = 1] = "Start", e[e.Pause = 2] = "Pause", e;
}({}), $r = function(e) {
  return e[e.None = 0] = "None", e[e.Deny = 1] = "Deny", e[e.Allow = 2] = "Allow", e;
}({}), hO = function(e) {
  return e[e.None = 0] = "None", e[e.DenyAllRequest = 1] = "DenyAllRequest", e[e.AllowAllRequest = 2] = "AllowAllRequest", e;
}({});
const Fl = "CLOUD_RECORDING_STATUS_CHANGE", Tc = "CLOUD_RECORDING_ISO_STATUS_CHANGE", kc = "LOCAL_RECORDING_CHANGE", go = "LOCAL_RECORDING_PERMISSION_CHANGE", PC = "RECORDING_FOR_IQ_STATUS_CHANGE", DC = "RECORDING_FOR_IQ_OPERATION_CHANGE";
let Vi = function(e) {
  return e.RecordingChange = "recording-change", e.IndividualRecordingChange = "individual-recording-change", e.LocalRecordingChange = "local-recording-change", e.LocalRecordingPermissionChange = "local-recording-permission-change", e.MediaCaptureStatusChange = "media-capture-status-change", e.MediaCapturePermissionChange = "media-capture-permission-change", e.RecordingIqChange = "recording-iq-change", e;
}({});
const fO = { [Vi.RecordingChange]: [{ event: Fl, payload: (e) => {
  const { cmrServerStatus: t } = e;
  return t === Zt.Start ? Qn.Recording : t === Zt.Pause ? Qn.Paused : Qn.Stopped;
} }], [Vi.IndividualRecordingChange]: [{ event: Tc, payload: (e) => e }], [Vi.LocalRecordingChange]: [{ event: kc, payload: (e) => e }], [Vi.LocalRecordingPermissionChange]: [{ event: go, payload: (e) => e }], [Vi.MediaCaptureStatusChange]: [{ event: kc, payload: (e) => e }], [Vi.MediaCapturePermissionChange]: [{ event: go, payload: (e) => e }], [Vi.RecordingIqChange]: [{ event: PC, payload: (e) => e }] };
let X = function(e) {
  return e[e.InitSuccess = 1] = "InitSuccess", e[e.InitSuccessVideo = 1.1] = "InitSuccessVideo", e[e.InitSuccessAudio = 1.2] = "InitSuccessAudio", e[e.InitSuccessSharing = 1.3] = "InitSuccessSharing", e[e.UserGrantCaptureAudio = 2] = "UserGrantCaptureAudio", e[e.CurrentVideoResolution = 3] = "CurrentVideoResolution", e[e.JpegDecThreadOk = 4] = "JpegDecThreadOk", e[e.JpegData = 5] = "JpegData", e[e.SharingPara = 6] = "SharingPara", e[e.VideoDecodeMaxSize = 7] = "VideoDecodeMaxSize", e[e.CurrentCaptureVideoWidthHeight = 8] = "CurrentCaptureVideoWidthHeight", e[e.StartVideoCaptureSuccess = 9] = "StartVideoCaptureSuccess", e[e.StopVideoCaptureSuccess = 10] = "StopVideoCaptureSuccess", e[e.StartRemoteControlSuccess = 11] = "StartRemoteControlSuccess", e[e.CancelRemoteControlSuccess = 12] = "CancelRemoteControlSuccess", e[e.RemoteControlCopiedTextNotify = 13] = "RemoteControlCopiedTextNotify", e[e.MonitorLog = 14] = "MonitorLog", e[e.CurrentDesktopSharingWidthHeight = 15] = "CurrentDesktopSharingWidthHeight", e[e.DesktopSharingCaptureSuccess = 16] = "DesktopSharingCaptureSuccess", e[e.CheckChromeSharingExtensionResponse = 17] = "CheckChromeSharingExtensionResponse", e[e.SharingDecodeMaxSize = 18] = "SharingDecodeMaxSize", e[e.DataChannelOffer = 19] = "DataChannelOffer", e[e.AesGcmIvResponse = 21] = "AesGcmIvResponse", e[e.SharingDesktopStreamHaveAudio = 23] = "SharingDesktopStreamHaveAudio", e[e.JoinComputerAudioComplete = 24] = "JoinComputerAudioComplete", e[e.JoinSharingAudioComplete = 25] = "JoinSharingAudioComplete", e[e.LeaveComputerAudioComplete = 26] = "LeaveComputerAudioComplete", e[e.LeaveSharingAudioComplete = 27] = "LeaveSharingAudioComplete", e[e.HidStatusMute = 28] = "HidStatusMute", e[e.AudioStreamFailed = 31] = "AudioStreamFailed", e[e.VideoStreamFailed = 32] = "VideoStreamFailed", e[e.AudioSpeakerSetSuccess = 33] = "AudioSpeakerSetSuccess", e[e.AudiobridgeSetCcLangSuccess = 36] = "AudiobridgeSetCcLangSuccess", e[e.SyncRendererTypeResponse = 39] = "SyncRendererTypeResponse", e[e.SendRemoteControlQrCode = 55] = "SendRemoteControlQrCode", e[e.StartVideoStreamInMaskSettingSuccess = 66] = "StartVideoStreamInMaskSettingSuccess", e[e.CurrentDecodeVideoQuality = 66.5] = "CurrentDecodeVideoQuality", e[e.CurrentDecodeVideoFps = 66.6] = "CurrentDecodeVideoFps", e[e.SharingFirstDecodeFrameReceivedSsrc = 70] = "SharingFirstDecodeFrameReceivedSsrc", e[e.StartVideoStreamInVbSettingSuccess = 94] = "StartVideoStreamInVbSettingSuccess", e[e.VbModelPreloading_3S = 96] = "VbModelPreloading_3S", e[e.VbModelPreloading_10S = 97] = "VbModelPreloading_10S", e[e.VbModelPreloadingOk = 98] = "VbModelPreloadingOk", e[e.NewActiveSpeakerFirstFrameCallback = 111] = "NewActiveSpeakerFirstFrameCallback", e[e.AudioBridgeFirstRecvData = 114] = "AudioBridgeFirstRecvData", e[e.AudioBridgeCanSendData = 115] = "AudioBridgeCanSendData", e[e.InitFailed = -1] = "InitFailed", e[e.InitFailedVideo = -1.1] = "InitFailedVideo", e[e.InitFailedAudio = -1.2] = "InitFailedAudio", e[e.InitFailedSharing = -1.3] = "InitFailedSharing", e[e.UserForbiddedCaptureAudio = -2] = "UserForbiddedCaptureAudio", e[e.AudioWebsocketBroken = -3] = "AudioWebsocketBroken", e[e.VideoWebsocketBroken = -4] = "VideoWebsocketBroken", e[e.SharingDecThreadFailed = -5] = "SharingDecThreadFailed", e[e.AudioZeroData = -6] = "AudioZeroData", e[e.AudioCtxSamplerate = -7] = "AudioCtxSamplerate", e[e.UserForbiddedCaptureVideo = -8] = "UserForbiddedCaptureVideo", e[e.UserCameraIsTakenByOtherPrograms = -9] = "UserCameraIsTakenByOtherPrograms", e[e.StopVideoCaptureFailed = -10] = "StopVideoCaptureFailed", e[e.StartRemoteControlFailed = -11] = "StartRemoteControlFailed", e[e.CancelRemoteControlFailed = -12] = "CancelRemoteControlFailed", e[e.RemoteControlPasteTextLengthOverflow = -14] = "RemoteControlPasteTextLengthOverflow", e[e.UserStopDesktopSharing = -15] = "UserStopDesktopSharing", e[e.UserCancelPermissionRequest = -16] = "UserCancelPermissionRequest", e[e.DesktopSharingChromeExtensionUninstalled = -17] = "DesktopSharingChromeExtensionUninstalled", e[e.DesktopSharingPermissionDenied = -18] = "DesktopSharingPermissionDenied", e[e.DesktopSharingTimeOut = -19] = "DesktopSharingTimeOut", e[e.DesktopSharingError = -20] = "DesktopSharingError", e[e.AudioSpeakerSetError = -21] = "AudioSpeakerSetError", e[e.DesktopSharingSystemError = -22] = "DesktopSharingSystemError", e[e.SharingDesktopStreamHaveNoAudio = -27] = "SharingDesktopStreamHaveNoAudio", e.AudioQosData = "AUDIO_QOS_DATA", e.VideoQosData = "VIDEO_QOS_DATA", e.ShareQosData = "VIDEOSHARE_QOS_DATA", e.NetworkQualityChange = "NETWORK_QUALITY_CHANGE", e[e.AudioBridgeReconnectStart = -29] = "AudioBridgeReconnectStart", e[e.AudioBridgeReconnectEnd = -31] = "AudioBridgeReconnectEnd", e[e.WebglLostInMultiView = -32] = "WebglLostInMultiView", e[e.MaskSettingParaError = -33] = "MaskSettingParaError", e[e.VbSettingParaError = -34] = "VbSettingParaError", e[e.NotifyUIFailover = -35] = "NotifyUIFailover", e[e.RecoverWebrtcAudio = -36] = "RecoverWebrtcAudio", e[e.AudiobridgeSetCcLangFailure = -39] = "AudiobridgeSetCcLangFailure", e;
}({}), Br = function(e) {
  return e[e.EncodeSuccess = 1] = "EncodeSuccess", e[e.DecodeSuccess = 2] = "DecodeSuccess", e[e.EncodeFailed = -1] = "EncodeFailed", e[e.DecodeFailed = -2] = "DecodeFailed", e;
}({}), Rp = function(e) {
  return e.Spotlight = "Spotlight", e.Unmute = "Unmute", e.AllowToTalk = "Allow to talk", e;
}({}), Gn = function(e) {
  return e.Inherited = "inherited", e.Active = "active", e.PassiveByMuteOne = "passive(mute one)", e.PassiveByMuteAll = "passive(mute all)", e.SharingAudio = "sharing audio", e;
}({}), zl = function(e) {
  return e.Inherited = "inherited", e.Active = "active", e.Passive = "passive", e.SharingAudio = "sharing audio", e;
}({}), uu = function(e) {
  return e.Active = "active", e.Failover = "failover", e.EndedBySystem = "audio stream is ended by system", e.Pstn = "pstn", e.MicrophoneError = "microphone error", e;
}({}), Go = function(e) {
  return e.Join = "join", e.Leave = "leave", e.Muted = "muted", e.Unmuted = "unmuted", e;
}({}), lo = function(e) {
  return e[e.Calling = 1] = "Calling", e[e.Ringing = 2] = "Ringing", e[e.Accepted = 3] = "Accepted", e[e.Busy = 4] = "Busy", e[e.NotAvailable = 5] = "NotAvailable", e[e.HangUp = 6] = "HangUp", e[e.Fail = 7] = "Fail", e[e.Success = 8] = "Success", e[e.Timeout = 9] = "Timeout", e[e.Canceling = 10] = "Canceling", e[e.Canceled = 11] = "Canceled", e[e.CancelFailed = 12] = "CancelFailed", e;
}({});
const vO = (() => {
  const e = new ArrayBuffer(684), t = new Uint32Array(e);
  return t.set([1179011410, 676, 1163280727, 544501094, 16, 65539, 16e3, 64e3, 2097156, 1635017060, 640], 0), new Blob([t], { type: "audio/wav" });
})(), mO = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 2, 1, 0, 5, 4, 1, 3, 1, 1, 10, 11, 1, 9, 0, 65, 0, 254, 16, 2, 0, 26, 11]), gO = new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 2, 1, 0, 10, 9, 1, 7, 0, 65, 0, 253, 15, 26, 11]);
let vn = function(e) {
  return e[e.HostGrab = 0] = "HostGrab", e[e.OnlyHost = 1] = "OnlyHost", e[e.AnyoneGrab = 2] = "AnyoneGrab", e[e.MultipleShare = 3] = "MultipleShare", e;
}({}), Fe = function(e) {
  return e.Sharing = "sharing", e.Paused = "paused", e.End = "ended", e;
}({}), gn = function(e) {
  return e[e.Video_90P = 0] = "Video_90P", e[e.Video_180P = 1] = "Video_180P", e[e.Video_360P = 2] = "Video_360P", e[e.Video_720P = 3] = "Video_720P", e[e.Video_1080P = 4] = "Video_1080P", e;
}({}), E2 = function(e) {
  return e.Active = "Active", e.Inactive = "Inactive", e;
}({}), Yu = function(e) {
  return e.Muted = "Muted", e.Unmuted = "Unmuted", e;
}({}), Op = function(e) {
  return e.Started = "Started", e.Stopped = "Stopped", e.Failed = "Failed", e;
}({}), I2 = function(e) {
  return e.Approved = "Approved", e.Rejected = "Rejected", e;
}({}), Tp = function(e) {
  return e.PrivilegeChange = "PrivilegeChange", e.StopScreenCapture = "StopScreenCapture", e.ShareFromMainSession = "ShareFromMainSession", e;
}({}), LC = function(e) {
  return e[e.ImageNotMatch = 2] = "ImageNotMatch", e[e.CanvasNotMatch = 3] = "CanvasNotMatch", e[e.VBModelNotMatch = 4] = "VBModelNotMatch", e;
}({});
const Fa = "blur";
let Ll = function(e) {
  return e.User = "user", e.Environment = "environment", e.Left = "left", e.Right = "right", e;
}({});
const fi = 1e3, kp = "__ZOOM_SDK_SHARING_VIDEO__", Yi = "__ZOOM_SDK_VIDEO_ZONE__", yO = "__ZOOM_SDK_VIRTUAL_BACKGROUND_CANVAS_@__", SO = "__ZOOM_SDK_VIRTUAL_BACKGROUND_IMAGE_@__", bO = "__ZOOM_SDK_MASK_CLIP_@__", A2 = "__ZOOM_SDK_MEDIA_PLAYBACK_SOURCE_VIDEO__", Wl = "__ZOOM_SDK_DYMMY_VIDEO_PLAYER_CANVAS_ID__", Mp = "__ZOOM_SDK_DUMMY_HIDDEN_SELF_VIEW_VIDEO_ID__", Mc = { data: { sample_rate: 0, rtt: 0, jitter: 0, avg_loss: 0, max_loss: 0, rate: 0, bandwidth: 0 } }, Ri = { data: { sample_rate: 0, rtt: 0, jitter: 0, avg_loss: 0, max_loss: 0, width: 0, height: 0, fps: 0, rate: 0, bandwidth: 0 } };
let Lr = function(e) {
  return e[e.Request = 11] = "Request", e[e.Decline = 12] = "Decline", e[e.Approve = 13] = "Approve", e[e.GiveUp = 14] = "GiveUp", e[e.StartControl = 15] = "StartControl", e[e.ContinueControl = 16] = "ContinueControl", e[e.StopControl = 17] = "StopControl", e[e.SwitchCamera = 20] = "SwitchCamera", e;
}({}), vi = function(e) {
  return e[e.Bk = 0] = "Bk", e[e.Center = 1] = "Center", e[e.ZoomIn = 2] = "ZoomIn", e[e.ZoomOut = 3] = "ZoomOut", e[e.Left = 4] = "Left", e[e.Right = 5] = "Right", e[e.Up = 6] = "Up", e[e.Down = 7] = "Down", e[e.SwitchCamera = 8] = "SwitchCamera", e;
}({}), Zs = function(e) {
  return e[e.Pan = 192] = "Pan", e[e.Tilt = 48] = "Tilt", e[e.Zoom = 12] = "Zoom", e[e.Focus = 3] = "Focus", e;
}({});
(function(e) {
  return e[e.ZoomIn = 2] = "ZoomIn", e[e.ZoomOut = 3] = "ZoomOut", e[e.Left = 4] = "Left", e[e.Right = 5] = "Right", e[e.Up = 6] = "Up", e[e.Down = 7] = "Down", e[e.SwitchCamera = 8] = "SwitchCamera", e;
})({});
(function(e) {
  return e[e.None = 0] = "None", e[e.ApproveAnother = 3] = "ApproveAnother", e[e.Stop = 5] = "Stop", e;
})({});
let Zl = function(e) {
  return e[e.Null = 0] = "Null", e[e.Normal = 1] = "Normal", e[e.VideoMode = 2] = "VideoMode", e;
}({}), oo = function(e) {
  return e[e.Null = 0] = "Null", e[e.VirtualBackground = 1] = "VirtualBackground", e[e.Mask = 2] = "Mask", e;
}({}), et = function(e) {
  return e.Computer = "computer", e.Phone = "phone", e;
}({}), Pc = function(e) {
  return e[e.Decline = 0] = "Decline", e[e.Approve = 1] = "Approve", e[e.CacheClean = 2] = "CacheClean", e;
}({}), dr = function(e) {
  return e.Unknown = "unknown", e.Uninstalled = "uninstalled", e.Installed = "installed", e;
}({}), Dc = function(e) {
  return e.Unlaunched = "unlaunched", e.Launched = "launched", e;
}({}), Pp = function(e) {
  return e.Started = "started", e.Ended = "ended", e;
}({}), Dp = function(e) {
  return e[e.Max = 30] = "Max", e[e.Min = 10] = "Min", e[e.Default = 24] = "Default", e;
}({}), Nl = function(e) {
  return e[e.Loading = 1] = "Loading", e[e.Done = 2] = "Done", e;
}({}), _2 = function(e) {
  return e.Browser = "Browser", e.Zoom = "Zoom", e;
}({}), R2 = function(e) {
  return e.Denoise = "backgroundNoiseSuppression", e.OriginalSound = "originalSound", e;
}({}), N1 = function(e) {
  return e[e.Undefined = 0] = "Undefined", e[e.WebGL = 1] = "WebGL", e[e.WebGPU = 2] = "WebGPU", e[e.WebGL2 = 3] = "WebGL2", e;
}({});
(function(e) {
  return e[e.H323 = 1] = "H323", e[e.SIP = 2] = "SIP", e;
})({});
let xd = function(e) {
  return e[e.Success = 0] = "Success", e[e.Ringing = 1] = "Ringing", e[e.Timeout = 2] = "Timeout", e[e.Busy = 101] = "Busy", e[e.Fail = 104] = "Fail", e;
}({});
const NC = "RECEIVE_VIDEO_ACTIVE_INDICATION", xC = "RECEIVE_VIDEO_MUTE_INDICATION", VC = "ASK_FOR_START_VIDEO_CONSENT", x1 = "RECEIVE_VIDEO_DIMENSION_CHANGE", jC = "CAPTURED_VIDEO_DIMENSION_CHANGE", V1 = "CAN_NOT_DETECT_CAMERA", j1 = "CAN_NOT_FIND_CAMERA", U1 = "VIDEO_USER_FORBIDDEN_CAPTURE", B1 = "VIDEO_CAMERA_IS_TAKEN", UC = "VIDEO_BACKGROUND_FAILED", BC = "VIDEO_ESTABLISH_STREAM_ERROR", cm = "VIDEO_CAPTURE_START_SUCCESS", ws = "VIDEO_CAPTURE_STOP_RESULT", $1 = "VIDEO_SPOTLIGHT_CHANGE", $C = "VIDEO_FOLLOW_HOST_ORDER_CHANGE", HC = "VIDEO_HOST_DRAG_LAYOUT_CHANGE", FC = "VIDEO_NEW_USER_START", Vd = "VIDEO_OLD_USER_STOP", Lc = "VIDEO_VIRTUAL_BACKGROUND_PRELOAD_READY", H1 = "VIDEO_VIRTUAL_BACKGROUND_SETTING_SUCCESS", F1 = "VIDEO_STATISTIC_DATA", z1 = "VIDEO_CELL_DETAILED_DATA", W1 = "VIDEO_NETWORK_QUALITY_CHANGE", zC = "VIDEO_FAR_END_CAMERA_CONTROL_REQUEST", Z1 = "VIDEO_FAR_END_CAMERA_CONTROL_RESPONSE", Nc = "VIDEO_FAR_END_CAMERA_IN_CONTROL_CHANGE", WC = "VIDEO_FAR_END_CAMERA_CAPABILITY_CHANGE", G1 = "VIDEO_MASK_SETTING_SUCCESS", ZC = "VIDEO_CAPTURE_SDK_SUCCESS", GC = "VIDEO_PREFETCH_VIDEO_FRAME_CALLBACK", qC = "VIDEO_CURRENT_USER_SSRC", KC = "VIDEO_RENDER_ASPECT_RATIO_CHANGE", O2 = { startCaptureVideo: { success: cm, fail: [V1, j1, U1, BC, B1, UC] }, switchCameraVideo: { success: ZC, fail: [V1, j1, U1, B1] }, stopCaptureVideo: { success: ws } };
let sr = function(e) {
  return e.VideoActiveChange = "video-active-change", e.PeerVideoStateChange = "peer-video-state-change", e.VideoSpotlightChange = "video-spotlight-change", e.VideoMutedChange = "video-muted-change", e.VideoCapturingChange = "video-capturing-change", e.AskForStartVideoConsent = "ask-for-start-video-consent", e.VideoDimensionChange = "video-dimension-change", e.VideoFollowHostOrder = "video-follow-host-order-change", e.VideoHostLayoutChange = "video-host-layout-change", e.VideoVBPreloadChange = "video-virtual-background-preload-change", e.VideoStatisticDataChange = "video-statistic-data-change", e.VideoDetailedDataChange = "video-detailed-data-change", e.VideoAspectRatioChange = "video-aspect-ratio-change", e.NetworkQualityChange = "network-quality-change", e.FarEndCameraRequestControl = "far-end-camera-request-control", e.FarEndCameraResponseControl = "far-end-camera-response-control", e.FarEndCameraInControlChange = "far-end-camera-in-control-change", e.FarEndCameraCapabilityChange = "far-end-camera-capability-change", e;
}({});
const CO = { [sr.VideoActiveChange]: [{ event: NC, payload: (e) => ({ state: e.bVideoOn ? E2.Active : E2.Inactive, userId: e.userId }) }], [sr.VideoCapturingChange]: [{ event: cm, payload: () => ({ state: Op.Started }) }, { event: ws, payload: (e) => ({ state: e != null && e.failed ? Op.Failed : Op.Stopped }) }], [sr.VideoMutedChange]: [{ event: xC, payload: (e) => ({ state: e.isVideoMuted ? Yu.Muted : Yu.Unmuted, userId: e.id }) }], [sr.AskForStartVideoConsent]: [{ event: VC, payload: (e) => ({ state: e.isVideoMuted ? Yu.Muted : Yu.Unmuted, userId: e.id }) }], [sr.VideoSpotlightChange]: [{ event: $1, payload: (e) => ({ spotlightList: e.spotlightList && e.spotlightList.map((t) => ({ userId: t })) }) }], [sr.VideoDimensionChange]: [{ event: x1, payload: (e) => ({ type: "received", width: e.width, height: e.height }) }, { event: jC, payload: (e) => ({ type: "captured", width: e.width, height: e.height }) }], [sr.VideoFollowHostOrder]: [{ event: $C, payload: (e) => ({ isFollowHostOrder: e.bOn }) }], [sr.VideoHostLayoutChange]: [{ event: HC, payload: (e) => Array.isArray(e.layout) ? e.layout.map((t) => ({ userId: t })) : [] }], [sr.PeerVideoStateChange]: [{ event: FC, payload: (e) => ({ action: "Start", ...e }) }, { event: Vd, payload: (e) => ({ action: "Stop", ...e }) }], [sr.VideoVBPreloadChange]: [{ event: Lc, payload: (e) => ({ isReady: e }) }], [sr.VideoStatisticDataChange]: [{ event: F1, payload: (e) => {
  const { data: { rate: t, ...r }, ...n } = e != null ? e : { data: {} };
  return { data: { bitrate: t, ...r }, ...n };
} }], [sr.VideoDetailedDataChange]: [{ event: z1, payload: (e) => e }], [sr.VideoAspectRatioChange]: [{ event: KC, payload: (e) => e }], [sr.NetworkQualityChange]: [{ event: W1, payload: (e) => e }], [sr.FarEndCameraRequestControl]: [{ event: zC, payload: (e) => e }], [sr.FarEndCameraResponseControl]: [{ event: Z1, payload: (e) => e }], [sr.FarEndCameraInControlChange]: [{ event: Nc, payload: (e) => e }], [sr.FarEndCameraCapabilityChange]: [{ event: WC, payload: (e) => e }] }, JC = "AUDIO_ACTIVE_SPEAKER", jd = "AUDIO_UNMUTE_CONSENT", va = "AUDIO_CURRENT_USER_JOIN_BY_VOIP", q1 = "AUDIO_CURRENT_USER_JOIN_BY_PHONE", du = "AUDIO_CURRENT_USER_LEAVE_AUDIO", pm = "AUDIO_CURRENT_USER_MUTED", hm = "AUDIO_CURRENT_USER_UNMUTED", QC = "AUDIO_PARTICIPANT_AUDIO_UPDATE", YC = "AUDIO_DIALOUT_RESULT_CODE", XC = "AUDIO_DIALOUT_RESULT_SUCCESS", ew = "AUDIO_DIALOUT_RESULT_FAIL", tw = "AUDIO_DIALOUT_CANCEL_SUCCESS", rw = "DIALOUT_CANCEL_FAIL", nw = "AUDIO_MERGE_AUDIO_INDICATION", ow = "USER_FORBIDDEN_MICROPHONE", iw = "ESTABLISH_AUDIO_STREAM_ERROR", sw = "AUDIO_AUTO_PLAY_FAILED", T2 = "INVALID_DEVICE_ID", aw = "AUDIO_ALLOW_TALK_CHANGE", za = "SHARE_AUDIO_STATE_CHANGE", K1 = "AUDIO_STATISTIC_DATA", lw = "AUDIO_CURRENT_USER_SSRC", J1 = "AUDIO_SET_SPEAKER_RESULT", uw = "AUDIO_SHARE_SECONDARY_AUDIO_SUCCESS", dw = "AUDIO_CRC_CALL_OUT_RESULT_CODE", cw = "AUDIO_CRC_CALL_OUT_RESULT_SUCCESS", pw = "AUDIO_CRC_CALL_OUT_RESULT_FAIL";
let uo = function(e) {
  return e.ActiveSpeaker = "active-speaker", e.UnmuteAudioConsent = "unmute-audio-consent", e.CurrentAudioChange = "current-audio-change", e.DialoutStateChange = "dialout-state-change", e.MergeAudio = "merged-audio", e.AutoPlayFailed = "auto-play-audio-failed", e.AllowTalkChange = "allow-talk-change", e.ShareAudioChange = "share-audio-change", e.AudioStatisticDataChange = "audio-statistic-data-change", e.CrcCallOutStateChange = "crc-call-out-state-change", e;
}({});
const ji = { JoinComputerAudio: { success: va, fail: [ow, iw] }, LeaveComputerAudio: { success: du }, JoinAudioByCallMe: { success: XC, fail: [ew] }, cancelDialOut: { success: tw, fail: [rw] }, hangup: { success: du }, crcCallOut: { success: cw, fail: [pw] } }, wO = { [uo.ActiveSpeaker]: [{ event: JC, payload: (e) => e }], [uo.UnmuteAudioConsent]: [{ event: jd, payload: (e) => ({ reason: e }) }], [uo.CurrentAudioChange]: [{ event: q1, payload: () => ({ action: Go.Join, type: et.Phone }) }, { event: va, payload: () => ({ action: Go.Join, type: et.Computer }) }, { event: du, payload: (e) => {
  let { source: t } = e;
  return { action: Go.Leave, source: t };
} }, { event: pm, payload: (e) => {
  let { source: t } = e;
  return { action: Go.Muted, source: t };
} }, { event: hm, payload: (e) => {
  let { source: t } = e;
  return { action: Go.Unmuted, source: t };
} }], [uo.DialoutStateChange]: [{ event: YC, payload: (e) => e }], [uo.MergeAudio]: [{ event: nw, payload: (e) => e }], [uo.AutoPlayFailed]: [{ event: sw, payload: () => {
} }], [uo.AllowTalkChange]: [{ event: aw, payload: (e) => ({ enabled: e }) }], [uo.ShareAudioChange]: [{ event: za, payload: (e) => e }], [uo.AudioStatisticDataChange]: [{ event: K1, payload: (e) => {
  const { data: { rate: t, ...r }, ...n } = e != null ? e : { data: {} };
  return { data: { bitrate: t, ...r }, ...n };
} }], [uo.CrcCallOutStateChange]: [{ event: dw, payload: (e) => e }] }, Q1 = "SHARE_ACTIVE_INDICATION", Y1 = "SHARE_CHECK_CHROME_SHARING_EXTENSION", hw = "SHARE_START_DESKTOP_SHARE_FAILED", fw = "SHARE_DIMENSION_CHANGE", xc = "SHARE_RECEIVED_DIMENSION_CHANGE", vw = "SHARE_VIDEO_STREAMS_END", mw = "SHARE_PASSIVE_STOP_SHARE", gw = "SHARE_PASSIVE_BO_STOP", fm = "SHARE_NEW_USER_ADD", vm = "SHARE_USER_REMOVE", yw = "SHARE_USER_PAUSED", Sw = "SHARE_USER_RESUMED", Vc = "SHARE_AUTO_CHANGE_SOURCE", jc = "SHARE_REMOTE_CONTROL_APPROVE", Es = "SHARE_GRAB_REMOTE_CONTROL_CHANGE", X1 = "SHARE_REMOTE_CONTROL_CLIPBOARD_CHANGE", bw = "SHARE_REMOTE_CONTROL_SUCCESS", Cw = "SHARE_REMOTE_CONTROL_FAILED", ww = "SHARE_PRIVILEGE_CHANGE", Ew = "SHARE_READ_RECEIPT", ef = "SHARE_STATISTIC_DATA", Iw = "SHARE_REMOTE_CONTROL_REQUEST", Xi = "SHARE_REMOTE_CONTROL_APP_STATUS", Ud = "SHARE_REMOTE_CONTROL_SESSION_STATUS", Aw = "SHARE_REMOTE_CONTROL_APP_SCHEME";
let Gr = function(e) {
  return e.ShareActiveChange = "active-share-change", e.ShareDimensionChange = "share-content-dimension-change", e.SharePassiveStop = "passively-stop-share", e.SharePeerStateChange = "peer-share-state-change", e.ShareContentChange = "share-content-change", e.SharePrivilegeChange = "share-privilege-change", e.ShareReadReceipt = "share-can-see-screen", e.ShareStatisticDataChange = "share-statistic-data-change", e.RemoteControlApprovedChange = "remote-control-approved-change", e.RemoteControlInControlChange = "remote-control-in-control-change", e.RemoteControlClipboardChange = "remote-control-clipboard-change", e.RemoteControlRequestChange = "remote-control-request-change", e.RemoteControlAppStatusChange = "remote-control-app-status-change", e.RemoteControlControlledStatusChange = "remote-control-controlled-status-change", e;
}({});
const EO = { [Gr.ShareActiveChange]: [{ event: Q1, payload: (e) => {
  const { isActive: t, activeUserId: r, ...n } = e;
  return { state: t ? "Active" : "Inactive", userId: r, ...n };
} }], [Gr.ShareDimensionChange]: [{ event: fw, payload: (e) => ({ type: "sended", width: e.width, height: e.height }) }, { event: xc, payload: (e) => ({ type: "received", width: e.width, height: e.height }) }], [Gr.SharePassiveStop]: [{ event: vw, payload: () => ({ reason: Tp.StopScreenCapture }) }, { event: mw, payload: () => ({ reason: Tp.PrivilegeChange }) }, { event: gw, payload: () => ({ reason: Tp.ShareFromMainSession }) }], [Gr.SharePeerStateChange]: [{ event: fm, payload: (e) => ({ userId: e.id, action: "Start" }) }, { event: vm, payload: (e) => ({ userId: e.id, action: "Stop" }) }, { event: yw, payload: (e) => ({ userId: e.id, action: "Pause" }) }, { event: Sw, payload: (e) => ({ userId: e.id, action: "Resume" }) }], [Gr.ShareContentChange]: [{ event: Vc, payload: (e) => e }], [Gr.SharePrivilegeChange]: [{ event: ww, payload: (e) => ({ privilege: e }) }], [Gr.ShareReadReceipt]: [{ event: Ew, payload: () => {
} }], [Gr.ShareStatisticDataChange]: [{ event: ef, payload: (e) => {
  const { data: { rate: t, ...r }, ...n } = e != null ? e : { data: {} };
  return { data: { bitrate: t, ...r }, ...n };
} }], [Gr.RemoteControlApprovedChange]: [{ event: jc, payload: (e) => ({ state: e ? I2.Approved : I2.Rejected }) }], [Gr.RemoteControlInControlChange]: [{ event: Es, payload: (e) => ({ isControlling: e }) }], [Gr.RemoteControlClipboardChange]: [{ event: X1, payload: (e) => e }], [Gr.RemoteControlRequestChange]: [{ event: Iw, payload: (e) => e }], [Gr.RemoteControlAppStatusChange]: [{ event: Xi, payload: (e) => e }], [Gr.RemoteControlControlledStatusChange]: [{ event: Ud, payload: (e) => e }] };
let No = function(e) {
  return e.Question = "question", e.UpdateQuestion = "updateQuestion", e.Answer = "answer", e.DeleteComment = "deleteComment", e.DeleteQuestion = "deleteQuestion", e.Dismiss = "dismiss", e.Reopen = "reopen", e.Upvote = "upvote", e.AnswerLive = "answerLive", e;
}({}), k2 = function(e) {
  return e.QaSettingChange = "qa-setting-change", e.QaActionChange = "qa-action-change", e;
}({});
const IO = { [k2.QaSettingChange]: [{ event: "QA_SETTING_OPTION_CHANGE", payload: (e) => e }], [k2.QaActionChange]: [{ event: "QA_NEW_ASK_QUESTION", payload: (e) => ({ action: No.Question, data: e }) }, { event: "QA_UPDATE_ANONYMOUS_QUESTION", payload: (e) => ({ action: No.UpdateQuestion, data: e }) }, { event: "QA_ANSWER_QUESTION", payload: (e) => ({ action: No.Answer, data: e }) }, { event: "QA_ANSWER_REMOVE_COMMENT", payload: (e) => ({ action: No.DeleteComment, data: e }) }, { event: "QA_ANSWER_REMOVE_QUESTION", payload: (e) => ({ action: No.DeleteQuestion, data: e }) }, { event: "QA_ANSWER_DISMISS_QUESTION", payload: (e) => ({ action: No.Dismiss, data: e }) }, { event: "QA_ANSWER_REOPEN_QUESTION", payload: (e) => ({ action: No.Reopen, data: e }) }, { event: "QA_ANSWER_VOTE_QUESTION", payload: (e) => ({ action: No.Upvote, data: e }) }, { event: "QA_ANSWER_QUESTION_LIVE", payload: (e) => ({ action: No.AnswerLive, data: e }) }] }, W = "INVALID_OPERATION", Eo = "INTERNAL_ERROR", mm = "OPERATION_TIMEOUT", Or = "INSUFFICIENT_PRIVILEGES", _a = "IMPROPER_MEETING_STATE", De = "INVALID_PARAMETERS", _w = "AUDIO_ENCODE_SUCCESS", Rw = "AUDIO_DECODE_SUCCESS", Ow = "VIDEO_ENCODE_SUCCESS", Tw = "VIDEO_DECODE_SUCCESS", kw = "SHARING_ENCODE_SUCCESS", tf = "SHARING_DECODE_SUCCESS", Mw = "AUDIO_ENCODE_FAIL", Pw = "AUDIO_DECODE_FAIL", Dw = "VIDEO_ENCODE_FAIL", Lw = "VIDEO_DECODE_FAIL", Nw = "SHARING_ENCODE_FAIL", xw = "SHARING_DECODE_FAIL", Vw = "MEDIA_DEVICE_CHANGE", Bd = "MEDIS_SDK_PATHCH_LOADED", jw = "AUDIO_BRIDGE_PEER_CONNECTION_RECEIVE_READY", Uw = "AUDIO_BRIDGE_PEER_CONNECTION_SEND_READY", Bw = "DEVICE_PERMISSION_CHANGE";
let Lp = function(e) {
  return e.DeviceChange = "device-change", e.MediaSDKChange = "media-sdk-change", e.DevicePermissionChange = "device-permission-change", e;
}({});
const AO = { [Lp.DeviceChange]: [{ event: Vw, payload: () => ({}) }], [Lp.MediaSDKChange]: [{ event: _w, payload: () => ({ type: "audio", action: "encode", result: "success" }) }, { event: Mw, payload: () => ({ type: "audio", action: "encode", result: "fail" }) }, { event: Rw, payload: () => ({ type: "audio", action: "decode", result: "success" }) }, { event: Pw, payload: () => ({ type: "audio", action: "decode", result: "fail" }) }, { event: Ow, payload: () => ({ type: "video", action: "encode", result: "success" }) }, { event: Dw, payload: () => ({ type: "video", action: "encode", result: "fail" }) }, { event: Tw, payload: () => ({ type: "video", action: "decode", result: "success" }) }, { event: Lw, payload: () => ({ type: "video", action: "decode", result: "fail" }) }, { event: kw, payload: () => ({ type: "share", action: "encode", result: "success" }) }, { event: Nw, payload: () => ({ type: "share", action: "encode", result: "fail" }) }, { event: tf, payload: () => ({ type: "share", action: "decode", result: "success" }) }, { event: xw, payload: () => ({ type: "share", action: "decode", result: "fail" }) }], [Lp.DevicePermissionChange]: [{ event: Bw, payload: (e) => e }] }, $w = "BREAKOUT_ROOM_ADD_TOKEN", $d = "BREAKOUT_ROOM_INVITE_TO_JOIN_NOTIFICATION", rf = "BREAKOUT_ROOM_ROOM_CLOSING_COUNTDOWN", nf = "BREAKOUT_ROOM_ROOM_COUTDOWN", Hw = "BREAKOUT_ROOM_BROADCAST_MESSAGE", Fw = "BREAKOUT_ROOM_ASK_HELP_REQUEST", gm = "BREAKOUT_ROOM_ASK_HELP_RESPONSE", as = "BREAKOUT_ROOM_ATTRIBUTE_INDICATION", Hd = "BREAKOUT_ROOM_JOIN_BO_RESPONSE", zw = "BREAKOUT_ROOM_ROOM_COUNTDOWN_TIME_UP", of = "BREAKOUT_ROOM_CURRENT_USER_PARTICIPANT_ROLE", Ww = "BREAKOUT_ROOM_LOAD_PRE_ASSIGNED_ROOMS", Zw = "BREAKOUT_ROOM_MAIN_SESSION_USER_UPDATE", Gw = "BREAKOUT_ROOM_INVITE_TO_BACK_NOTIFICATION", qw = "BREAKOUT_ROOM_IN_ROOM_USER_STATUS_UPDATE", Kw = "BREAKOUT_ROOM_BROADCAST_VOICE";
let Rn = function(e) {
  return e.InviteToJoin = "invite-to-join", e.RoomCountdown = "room-countdown", e.RoomTimeUp = "room-time-up", e.ClosingRoomCountdown = "closing-room-countdown", e.BroadcastMessage = "broadcast-message", e.AskForHelp = "ask-for-help", e.AskForHelpResponse = "ask-for-help-response", e.RoomStateChange = "room-state-change", e.MainSessionUserUpdate = "main-session-user-updated", e.InviteToBack = "invite-back-to-main-session", e.RoomUserUpdate = "room-user-update", e.BroadcastVoice = "broadcast-voice", e;
}({});
const _O = { [Rn.InviteToJoin]: [{ event: $d, payload: (e) => e }], [Rn.RoomCountdown]: [{ event: nf, payload: (e) => e }], [Rn.RoomTimeUp]: [{ event: zw, payload: (e) => e }], [Rn.ClosingRoomCountdown]: [{ event: rf, payload: (e) => e }], [Rn.BroadcastMessage]: [{ event: Hw, payload: (e) => e }], [Rn.AskForHelp]: [{ event: Fw, payload: (e) => e }], [Rn.AskForHelpResponse]: [{ event: gm, payload: (e) => e }], [Rn.RoomStateChange]: [{ event: as, payload: (e) => ({ status: e.controlStatus }) }], [Rn.MainSessionUserUpdate]: [{ event: Zw, payload: () => ({}) }], [Rn.InviteToBack]: [{ event: Gw, payload: (e) => e }], [Rn.RoomUserUpdate]: [{ event: qw, payload: (e) => e }], [Rn.BroadcastVoice]: [{ event: Kw, payload: (e) => e }] };
var sf = function(e) {
  return e.StatusUpdate = "archiving-status-update", e.OptionsUpdate = "archiving-options-update", e;
}(sf || {});
const RO = { [sf.StatusUpdate]: [{ event: "ARCHIVING_STATUS_UPDATE", payload: (e) => e }], [sf.OptionsUpdate]: [{ event: "ARCHIVING_OPTIONS_UPDATE", payload: (e) => e }] };
let Np = function(e) {
  return e.PollDataChange = "poll-data-change", e.PollSizeUpdate = "poll-size-update", e.PollStatusUpdate = "poll-status-update", e;
}({});
const OO = { [Np.PollDataChange]: [{ event: "POLL_DATA_CHANGE", payload: (e) => e }], [Np.PollSizeUpdate]: [{ event: "POLL_SIZE_UPDATE", payload: (e) => e }], [Np.PollStatusUpdate]: [{ event: "POLL_STATUS_UPDATE", payload: (e) => e }] };
let M2 = function(e) {
  return e.ReactionReceived = "reaction-received", e.ReactionRemoved = "reaction-removed", e;
}({});
const TO = { [M2.ReactionReceived]: [{ event: "REACTION_RECEIVED", payload: (e) => e }], [M2.ReactionRemoved]: [{ event: "REACTION_REMOVED", payload: (e) => e }] }, Si = "SMART_SUMMARY_STATUS_CHANGE", bi = "MEETING_QUERY_STATUS_CHANGE";
let P2 = function(e) {
  return e.SummaryChange = "summary-status-change", e.MeetingQueryChang = "meeting-query-status-change", e;
}({});
const kO = { [P2.SummaryChange]: [{ event: Si, payload: (e) => e }], [P2.MeetingQueryChang]: [{ event: bi, payload: (e) => e }] }, Gl = "LIVE_STREAM_STATUS_CHANGE", MO = { "live-stream-status": [{ event: Gl, payload: (e) => e }] }, D2 = { ...uO, ...dO, ...cO, ...pO, ...fO, ...wO, ...CO, ...IO, ...EO, ...AO, ..._O, ...RO, "closed-caption-message": [{ event: "CC_RECEIVE_MESSAGE", payload: (e) => e }], "closed-caption-lt-status": [{ event: "LT_STATUS_CHANGE", payload: (e) => e }], "closed-caption-lt-message": [{ event: "LT_RECEIVE_MESSAGE", payload: (e) => e }], "closed-caption-status": [{ event: "CC_ASSIGN_CC_EDITOR_SUCCESS", payload: (e) => e }, { event: "CC_STATUS_CHANGE", payload: (e) => e }], ...OO, ...TO, ...kO, ...MO }, Xo = function(e) {
  return { all: e = e || /* @__PURE__ */ new Map(), on: function(t, r) {
    var n = e.get(t);
    n ? n.push(r) : e.set(t, [r]);
  }, off: function(t, r) {
    var n = e.get(t);
    n && (r ? n.splice(n.indexOf(r) >>> 0, 1) : e.set(t, []));
  }, emit: function(t, r) {
    var n = e.get(t);
    n && n.slice().map(function(o) {
      o(r);
    }), (n = e.get("*")) && n.slice().map(function(o) {
      o(t, r);
    });
  } };
}(), es = /* @__PURE__ */ new Map(), af = new Array(), O = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0;
  Xo.emit(e, t);
}, $o = (e) => new Promise((t, r) => {
  e.fail && e.fail.length > 0 ? Vn(Ct(Xo, e.success).pipe(Ge(1)), Kt(...e.fail.map((n) => Ct(Xo, n).pipe(Ge(1), G((o) => cs({ type: n, payload: o })))))).subscribe((n) => t(n), (n) => {
    typeof n.payload == "object" ? r({ type: n.type, ...n.payload }) : n.payload === void 0 ? r({ type: n.type }) : r(n);
  }) : Ct(Xo, e.success).pipe(Ge(1)).subscribe((n) => t(n));
}), Te = function(e, t) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1e4;
  return new Promise((n, o) => {
    let i = oe;
    typeof e == "string" ? i = Ct(Xo, e).pipe(Ge(1)) : (i = Ct(Xo, e.event), e.operations && (i = e.operations.reduce((s, a) => s.pipe(a), i))), Vn(i, nr(r).pipe(Ie(cs("timeout")))).subscribe((s) => {
      if (t) {
        const a = t(s);
        typeof a == "boolean" ? a ? n("") : o({ type: Eo }) : a.ret === 0 ? n(a.body) : o({ type: Eo, reason: a.body });
      } else
        n(s);
    }, () => {
      o({ type: mm });
    });
  });
}, ht = (e, t) => t !== void 0 ? Ct(Xo, e).pipe(Ge(t)) : Ct(Xo, e), ym = () => {
  af.forEach((e) => {
    e.unsubscribe();
  }), af.length = 0, es.clear();
}, { setAttendeesList: Uc, setAssistantList: aF, setIsAdmitAllSilentUsers: Jw, resetParticipants: Qw, addFailoverAttendees: lf, removeFailoverAttendees: Yw, setClearRaiseHand: Xw, setClearAttendeeFeedback: eE, updateAttendeeDisplayName: tE, removeXmppAttendeeUser: rE, updateXmppAttendeeList: nE, setAttendeeExtraKey: cu } = Yt({ SET_ATTENDEES_LIST: (e) => e, SET_ASSISTANT_LIST: (e) => e, UPDATE_XMPP_ATTENDEE_LIST: (e) => e, RESET_PARTICIPANTS: () => ({}), SET_IS_ADMIT_ALL_SILENT_USERS: (e) => e, REMOVE_FAILOVER_ATTENDEES: (e) => e, ADD_FAILOVER_ATTENDEES: (e) => e, SET_CLEAR_RAISE_HAND: () => ({}), SET_CLEAR_ATTENDEE_FEEDBACK: () => ({}), UPDATE_ATTENDEE_DISPLAY_NAME: (e) => e, REMOVE_XMPP_ATTENDEE_USER: (e) => e, SET_ATTENDEE_EXTRA_KEY: (e) => e });
var Xu = "NOT_FOUND", PO = function(e, t) {
  return e === t;
};
function oE(e, t) {
  var r, n, o = typeof t == "object" ? t : { equalityCheck: t }, i = o.equalityCheck, s = i === void 0 ? PO : i, a = o.maxSize, l = a === void 0 ? 1 : a, u = o.resultEqualityCheck, d = /* @__PURE__ */ function(h) {
    return function(v, f) {
      if (v === null || f === null || v.length !== f.length)
        return !1;
      for (var m = v.length, g = 0; g < m; g++)
        if (!h(v[g], f[g]))
          return !1;
      return !0;
    };
  }(s), c = l === 1 ? (r = d, { get: function(h) {
    return n && r(n.key, h) ? n.value : Xu;
  }, put: function(h, v) {
    n = { key: h, value: v };
  }, getEntries: function() {
    return n ? [n] : [];
  }, clear: function() {
    n = void 0;
  } }) : /* @__PURE__ */ function(h, v) {
    var f = [];
    function m(g) {
      var C = f.findIndex(function(E) {
        return v(g, E.key);
      });
      if (C > -1) {
        var b = f[C];
        return C > 0 && (f.splice(C, 1), f.unshift(b)), b.value;
      }
      return Xu;
    }
    return { get: m, put: function(g, C) {
      m(g) === Xu && (f.unshift({ key: g, value: C }), f.length > h && f.pop());
    }, getEntries: function() {
      return f;
    }, clear: function() {
      f = [];
    } };
  }(l, d);
  function p() {
    var h = c.get(arguments);
    if (h === Xu) {
      if (h = e.apply(null, arguments), u) {
        var v = c.getEntries().find(function(f) {
          return u(f.value, h);
        });
        v && (h = v.value);
      }
      c.put(arguments, h);
    }
    return h;
  }
  return p.clearCache = function() {
    return c.clear();
  }, p;
}
function iE(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    r[n - 1] = arguments[n];
  return function() {
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    var a, l = 0, u = { memoizeOptions: void 0 }, d = i.pop();
    if (typeof d == "object" && (u = d, d = i.pop()), typeof d != "function")
      throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof d + "]");
    var c = u.memoizeOptions, p = c === void 0 ? r : c, h = Array.isArray(p) ? p : [p], v = function(g) {
      var C = Array.isArray(g[0]) ? g[0] : g;
      if (!C.every(function(E) {
        return typeof E == "function";
      })) {
        var b = C.map(function(E) {
          return typeof E == "function" ? "function " + (E.name || "unnamed") + "()" : typeof E;
        }).join(", ");
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + b + "]");
      }
      return C;
    }(i), f = e.apply(void 0, [function() {
      return l++, d.apply(null, arguments);
    }].concat(h)), m = e(function() {
      for (var g = [], C = v.length, b = 0; b < C; b++)
        g.push(v[b].apply(null, arguments));
      return a = f.apply(null, g);
    });
    return Object.assign(m, { resultFunc: d, memoizedResultFunc: f, dependencies: v, lastResult: function() {
      return a;
    }, recomputations: function() {
      return l;
    }, resetRecomputations: function() {
      return l = 0;
    } }), m;
  };
}
var Mt = iE(oE);
const Vu = (e) => {
  let { participants: { attendeesList: t } } = e;
  return t;
}, sE = (e) => {
  let { meeting: { userId: t } } = e;
  return t;
}, uf = (e) => {
  let { participants: { xmppAttendeeList: t } } = e;
  return t;
};
let Ds = function(e) {
  return e[e.Attendee = 0] = "Attendee", e[e.Host = 1] = "Host", e[e.Owner = 4] = "Owner", e[e.ViewOnly = 8] = "ViewOnly", e[e.HostOwner = 5] = "HostOwner", e[e.ViewOnlyCanTalk = 24] = "ViewOnlyCanTalk", e;
}({}), DO = function(e) {
  return e[e.Host = 10] = "Host", e[e.Panelist = 20] = "Panelist", e[e.Attendee = 30] = "Attendee", e;
}({}), df = function(e) {
  return e[e.Client = 9] = "Client", e[e.Phone = 5] = "Phone", e[e.H323 = 15] = "H323", e[e.Assitant = 51] = "Assitant", e;
}({});
const aE = (e) => (e & Ds.Host) === Ds.Host, Wa = (e) => (e & df.Phone) === df.Phone, Bc = (e) => e === Ds.ViewOnlyCanTalk, Jt = (e) => (e & Ds.ViewOnly) === Ds.ViewOnly;
let pu = function(e) {
  return e[e.Automatically = 1] = "Automatically", e[e.Manually = 2] = "Manually", e[e.SelfSelect = 3] = "SelfSelect", e;
}({}), $e = function(e) {
  return e[e.NotStarted = 1] = "NotStarted", e[e.InProgress = 2] = "InProgress", e[e.Closing = 3] = "Closing", e[e.Closed = 4] = "Closed", e;
}({}), lE = function(e) {
  return e[e.NoToken = 1] = "NoToken", e[e.GotToken = 2] = "GotToken", e[e.Started = 3] = "Started", e[e.Closing = 4] = "Closing", e[e.Closed = 5] = "Closed", e;
}({}), Ee = function(e) {
  return e.Initial = "initial", e.Invited = "invited", e.Joining = "joining", e.InRoom = "in room", e.Leaving = "leaving", e.TimeUp = "time up", e.MainSession = "main session", e;
}({}), Ui = function(e) {
  return e.Join = "joinRequest", e.Switch = "switchRequest", e.Leave = "leaveRequest", e.Broadcast = "messageText", e.HelpReq = "helpRequest", e.HelpRes = "helpResponse", e.CoHostWantJoinThisBo = "wantJoinThisBO", e.BOActivity = "BOActivity", e;
}({}), Ci = function(e) {
  return e[e.Received = 0] = "Received", e[e.Busy = 1] = "Busy", e[e.Ignore = 2] = "Ignore", e[e.AlreadyInRoom = 3] = "AlreadyInRoom", e;
}({}), L2 = function(e) {
  return e[e.AskToLeave = 0] = "AskToLeave", e[e.ClosingRoom = 1] = "ClosingRoom", e;
}({}), LO = function(e) {
  return e[e.Active = 0] = "Active", e[e.Ask = 1] = "Ask", e;
}({}), xp = function(e) {
  return e[e.Connect = 1] = "Connect", e[e.Muted = 2] = "Muted", e[e.Voip = 4] = "Voip", e;
}({}), N2 = function(e) {
  return e[e.Connect = 8] = "Connect", e[e.On = 16] = "On", e;
}({}), x2 = function(e) {
  return e[e.Share = 32] = "Share", e[e.ShareAudio = 64] = "ShareAudio", e;
}({});
const be = Mt([sE, Vu], (e, t) => t.find((r) => r.userId === e)), Sn = Mt([be], (e) => (e == null ? void 0 : e.isHost) || (e == null ? void 0 : e.bCoHost)), NO = Mt([be], (e) => e == null ? void 0 : e.isHost), ju = Mt([uf], (e) => e.filter((t) => t.userRole === DO.Attendee)), xO = Mt([Vu], (e) => e.filter((t) => t.bHold && !t.bid)), ft = Mt([Vu, (e) => {
  let { breakoutRoom: t } = e;
  return t && t.controlStatus;
}, (e) => {
  let { breakoutRoom: t } = e;
  return t && t.currentRoom.status;
}], (e, t, r) => t !== $e.InProgress && t !== $e.Closing || r !== Ee.InRoom ? e.filter((n) => !n.bHold && !n.bid) : e.filter((n) => !n.bHold)), VO = Mt([(e) => {
  let { participants: { assistantList: t } } = e;
  return t;
}], (e) => e), cf = Mt([ft], (e) => e.find((t) => t.isHost)), V2 = Mt([ft], (e) => e.filter((t) => t.bCoHost)), Sm = Mt([be, ft], (e, t) => t.filter((r) => r.userId !== (e == null ? void 0 : e.userId)));
Mt([uf], (e) => e.reduce((t, r) => {
  const { jid: n } = r;
  return Object.assign(t, { [n]: r }), t;
}, {})), Mt([uf, (e) => {
  let { meeting: { jid: t } } = e;
  return t;
}], (e, t) => {
  var r;
  return (r = e.find((n) => n.jid === t)) === null || r === void 0 ? void 0 : r.userId;
});
const jO = Mt([Vu], function() {
  return (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : []).some((e) => (e == null ? void 0 : e.bLocalRecord) === lu.Start);
});
let dt = function(e) {
  return e.Closed = "closed", e.Connecting = "connecting", e.Connected = "connected", e;
}({});
function er(e) {
  return 1 << e - 1;
}
let qr = function(e) {
  return e[e.SupportASL = er(1)] = "SupportASL", e[e.SidecarPhase2 = er(2)] = "SidecarPhase2", e[e.SupportBroadcastVoice = er(4)] = "SupportBroadcastVoice", e[e.SendMeetingTokenSeparately = er(5)] = "SendMeetingTokenSeparately", e[e.SupportPreview = er(6)] = "SupportPreview", e[e.WebCameraIndication = er(7)] = "WebCameraIndication", e[e.SupportFarEndCameraControl = er(9)] = "SupportFarEndCameraControl", e[e.SupportVideoShare = er(10)] = "SupportVideoShare", e[e.UnifyErrorType = er(11)] = "UnifyErrorType", e[e.WhiteBoard = er(12)] = "WhiteBoard", e[e.RequestRemoteControl = er(14)] = "RequestRemoteControl", e[e.SmartSummary = er(15)] = "SmartSummary", e[e.LocalRecording = er(16)] = "LocalRecording", e[e.LocalRecordingGrantPermission = er(17)] = "LocalRecordingGrantPermission", e[e.ShareMultiStream = er(18)] = "ShareMultiStream", e[e.VideoLTR = er(19)] = "VideoLTR", e[e.WebrtcAudioRtcpTime = er(20)] = "WebrtcAudioRtcpTime", e[e.SupportSend1080PVideo = er(29)] = "SupportSend1080PVideo", e[e.SupportSend1080PVideoShare = er(30)] = "SupportSend1080PVideoShare", e;
}({});
const { setAsnIds: uE, setIsCanUnmute: dE, setDialoutSequence: cE, setDialoutResultCode: pE, setIsAllowToTalk: pf, setAudioSsrc: hE, setIsMutedUponEntry: fE, setIsUserGrantCaptureAudio: vE, setIsMicrophoneForbidden: bm, setWebrtcRestartCount: Uu, setMicrophoneList: mE, setSpeakerList: gE, setActiveMicrophone: hu, setActiveSpeaker: X0, setCanPlayAudio: Za, resetAudio: yE, setIsComputerAudioLoading: ts, setIsAllowToTalkAttendeeConnected: hf, setIsMuteBeforeSharingAudio: ei, addLocalShareAudioUser: SE, updateLocalShareAudioUser: bE, setIsJoinComputerAudioBeforeSharingAudio: Ga, setIsShareAudioEnabled: ep, setIsShareAudioMuted: $c, setIsSharingAudio: qa, setAudioDataEncoding: Hc, setAudioDataDecoding: Fc, addLocallyMutedAudio: CE, removeLocallyMutedAudio: zc, updateUserAudioVolumeLocally: wE, removeLocalUserAudioVolume: EE, setCustomizedAudioOption: Cm, setIsBackgroundNoiseSuppression: ff, setIsHidEnabled: IE, setAudioMediaPlaybackFile: vf, setIsStopAllIncomingAudio: mf, setIsVerifiedAudioPermissionOnIosMobile: AE, setIsAudioBridgeSignalReconnecting: wm, setAudioMutedSource: zo, setAudioUnmutedSource: fu, setAudioOriginalSound: gf, setLeaveAudioSource: Ls, setSecondaryAudioMicrophoneId: Wc, setCrcCallOutSequence: _E, setCrcCallOutReturnCode: RE } = Yt("SET_ASN_IDS", "SET_IS_CAN_UNMUTE", "SET_DIALOUT_SEQUENCE", "SET_DIALOUT_RESULT_CODE", "SET_IS_ALLOW_TO_TALK", "SET_AUDIO_SSRC", "SET_IS_MUTED_UPON_ENTRY", "SET_IS_USER_GRANT_CAPTURE_AUDIO", "SET_IS_MICROPHONE_FORBIDDEN", "SET_WEBRTC_RESTART_COUNT", "SET_MICROPHONE_LIST", "SET_SPEAKER_LIST", "SET_ACTIVE_MICROPHONE", "SET_ACTIVE_SPEAKER", "SET_CAN_PLAY_AUDIO", "RESET_AUDIO", "SET_IS_COMPUTER_AUDIO_LOADING", "SET_IS_ALLOW_TO_TALK_ATTENDEE_CONNECTED", "SET_IS_MUTE_BEFORE_SHARING_AUDIO", "SET_IS_SHARING_AUDIO", "ADD_LOCAL_SHARE_AUDIO_USER", "UPDATE_LOCAL_SHARE_AUDIO_USER", "SET_IS_JOIN_COMPUTER_AUDIO_BEFORE_SHARING_AUDIO", "SET_IS_SHARE_AUDIO_ENABLED", "SET_IS_SHARE_AUDIO_MUTED", "SET_AUDIO_DATA_ENCODING", "SET_AUDIO_DATA_DECODING", "ADD_LOCALLY_MUTED_AUDIO", "REMOVE_LOCALLY_MUTED_AUDIO", "UPDATE_USER_AUDIO_VOLUME_LOCALLY", "REMOVE_LOCAL_USER_AUDIO_VOLUME", "SET_CUSTOMIZED_AUDIO_OPTION", "SET_IS_BACKGROUND_NOISE_SUPPRESSION", "SET_IS_HID_ENABLED", "SET_AUDIO_MEDIA_PLAYBACK_FILE", "SET_IS_STOP_ALL_INCOMING_AUDIO", "SET_IS_VERIFIED_AUDIO_PERMISSION_ON_IOS_MOBILE", "SET_IS_AUDIO_BRIDGE_SIGNAL_RECONNECTING", "SET_AUDIO_MUTED_SOURCE", "SET_AUDIO_UNMUTED_SOURCE", "SET_AUDIO_ORIGINAL_SOUND", "SET_LEAVE_AUDIO_SOURCE", "SET_SECONDARY_AUDIO_MICROPHONE_ID", "SET_CRC_CALL_OUT_SEQUENCE", "SET_CRC_CALL_OUT_RETURN_CODE"), { setSharePrivilege: Em, setShareActiveNode: Zc, setIsReceiveSharing: Gc, setIsChromeExtensionInstalled: OE, setIsScreenShareForbidden: j2, setShareDimension: TE, setShareStatus: bn, setShareSsrc: kE, setShareQuality: Im, setReceivedShareDimension: yf, setIsGrabRemoteControl: Fd, setIsSdkGrabControl: Sf, setIsReceiveSharingFromMainSession: ME, setIsSharingToBreakoutRoom: xl, setIsSharingWithSecondCamera: PE, setShringSecondCameraId: DE, setIsRequireReadReceipt: LE, setIsOptimizedForSharedVideo: qc, setShareDataEncoding: bf, setShareDataDecoding: vu, addShareCapturedEnsuredCanvas: NE, addShareRenderedEnsuredCanvas: xE, setRemoteControlCurrentSsrc: lF, setRemoteControllingSsrc: ql, setApprovedRemoteControlSsrc: Ra, setRemoteControlAppDownloadUrl: VE, setRemoteControlAppInstallStatus: ls, remoteControlAppStatusFallbackCheck: U2, remoteControlAppLaunchedCheck: Vp, setIsEnableAutoDeleteRcApp: uF, setRemoteControlAppLaunchSheme: Co, addSharingUserIdSsrcMapping: Cf, addRemoteControlledUser: jE, removeRemoteControlledUser: wf, setRemoteControlSetting: Am, setRemoteControlViewportDomSelector: UE, setIsFullHdVideoShareEnabled: BE, resetShare: $E } = Yt("SET_SHARE_PRIVILEGE", "SET_SHARE_ACTIVE_NODE", "SET_IS_RECEIVE_SHARING", "SET_IS_CHROME_EXTENSION_INSTALLED", "SET_IS_SCREEN_SHARE_FORBIDDEN", "SET_SHARE_DIMENSION", "SET_SHARE_STATUS", "SET_SHARE_SSRC", "SET_SHARE_QUALITY", "SET_RECEIVED_SHARE_DIMENSION", "SET_IS_GRAB_REMOTE_CONTROL", "SET_IS_SDK_GRAB_CONTROL", "SET_IS_RECEIVE_SHARING_FROM_MAIN_SESSION", "SET_IS_SHARING_TO_BREAKOUT_ROOM", "SET_IS_SHARING_WITH_SECOND_CAMERA", "SET_SHRING_SECOND_CAMERA_ID", "SET_IS_REQUIRE_READ_RECEIPT", "SET_IS_OPTIMIZED_FOR_SHARED_VIDEO", "SET_SHARE_DATA_ENCODING", "SET_SHARE_DATA_DECODING", "ADD_SHARE_CAPTURED_ENSURED_CANVAS", "ADD_SHARE_RENDERED_ENSURED_CANVAS", "SET_REMOTE_CONTROL_CURRENT_SSRC", "SET_REMOTE_CONTROLLING_SSRC", "SET_APPROVED_REMOTE_CONTROL_SSRC", "SET_REMOTE_CONTROL_APP_DOWNLOAD_URL", "SET_REMOTE_CONTROL_APP_INSTALL_STATUS", "REMOTE_CONTROL_APP_STATUS_FALLBACK_CHECK", "REMOTE_CONTROL_APP_LAUNCHED_CHECK", "SET_IS_ENABLE_AUTO_DELETE_RC_APP", "SET_REMOTE_CONTROL_APP_LAUNCH_SHEME", "ADD_SHARING_USER_ID_SSRC_MAPPING", "ADD_REMOTE_CONTROLLED_USER", "REMOVE_REMOTE_CONTROLLED_USER", "SET_REMOTE_CONTROL_SETTING", "SET_REMOTE_CONTROL_VIEWPORT_DOM_SELECTOR", "SET_IS_FULL_HD_VIDEO_SHARE_ENABLED", "RESET_SHARE"), { setVideoSsrc: HE, setActiveVideoId: FE, setCameraList: _m, setActiveCamera: Kc, setIsCurrentUserStartedVideo: zE, setSpotlightVideo: Ef, setIsCaptureForbidden: Jc, setVideoMaxQuality: WE, setIsVideoMuted: ZE, setIsCaptureCameraLoading: Vl, setIsCameraTaken: Qc, resetVideo: GE, setReceivedVideoDimension: If, addSubscribedVideoId: zd, removeSubscribedVideoId: Wd, setIsFollowHostVideoLayout: qE, setHostDragLayout: KE, addRenderedVideoId: Oa, removeRenderedVideoId: Yc, setIsSupportHdVideo: JE, setMaximumNumbeOfHdSubscriptions: QE, setIsCanUnmuteVideo: YE, setIsVbPreloadReady: Af, setIsVbConfiged: Xc, setVbImageSrc: Zd, setVideoDataEncoding: e0, setVideoDataDecoding: t0, setHardwareAccelerationState: ia, setVideoCaptureCustomizedOption: XE, setNetworkQuality: _f, setVideoCameraPtzCapabilities: eI, setIsCurrentUserRequestCameraControlled: r0, setIsCurrentUserCameraInControl: n0, addVideoFarEndCameraControlUser: tI, removeVideoFarEndCameraControlUser: o0, setVideoPtzCameraMoving: Rf, setVideoPtzCameraValue: Rm, setIsControllingFarEndCamera: Of, setNetworkQualityBroadcastTime: rI, setIsMaskConfiged: i0, setVideoBackgroundMode: UO, setVideoMask: Gd, setVideoCapturedDimension: nI, addVideoRenderedEnsuredCanvas: oI, setVideoMediaPlaybackFile: Tf, setPrefetchedVideoUser: Ta, setVideoQosSubscriptionStatus: kf, setIsSupportFullHdVideo: iI, addVideoPlayerAttachment: sI, removeVideoPlayerAttachment: qd, setIsWebGl2RendererType: aI, setIsWebGpuRendererType: lI, setVideoRendererType: uI } = Yt("SET_VIDEO_SSRC", "SET_ACTIVE_VIDEO_ID", "SET_CAMERA_LIST", "SET_ACTIVE_CAMERA", "SET_IS_CURRENT_USER_STARTED_VIDEO", "SET_SPOTLIGHT_VIDEO", "SET_IS_CAPTURE_FORBIDDEN", "SET_VIDEO_MAX_QUALITY", "SET_IS_VIDEO_MUTED", "SET_IS_CAPTURE_CAMERA_LOADING", "SET_IS_CAMERA_TAKEN", "RESET_VIDEO", "SET_RECEIVED_VIDEO_DIMENSION", "ADD_SUBSCRIBED_VIDEO_ID", "REMOVE_SUBSCRIBED_VIDEO_ID", "SET_IS_FOLLOW_HOST_VIDEO_LAYOUT", "SET_HOST_DRAG_LAYOUT", "ADD_RENDERED_VIDEO_ID", "REMOVE_RENDERED_VIDEO_ID", "SET_IS_SUPPORT_HD_VIDEO", "SET_MAXIMUM_NUMBE_OF_HD_SUBSCRIPTIONS", "SET_IS_CAN_UNMUTE_VIDEO", "SET_IS_VB_PRELOAD_READY", "SET_IS_VB_CONFIGED", "SET_VB_IMAGE_SRC", "SET_VIDEO_DATA_ENCODING", "SET_VIDEO_DATA_DECODING", "SET_HARDWARE_ACCELERATION_STATE", "SET_VIDEO_CAPTURE_CUSTOMIZED_OPTION", "SET_NETWORK_QUALITY", "SET_VIDEO_CAMERA_PTZ_CAPABILITIES", "SET_IS_CURRENT_USER_REQUEST_CAMERA_CONTROLLED", "SET_IS_CURRENT_USER_CAMERA_IN_CONTROL", "ADD_VIDEO_FAR_END_CAMERA_CONTROL_USER", "REMOVE_VIDEO_FAR_END_CAMERA_CONTROL_USER", "SET_VIDEO_PTZ_CAMERA_MOVING", "SET_VIDEO_PTZ_CAMERA_VALUE", "SET_IS_CONTROLLING_FAR_END_CAMERA", "SET_NETWORK_QUALITY_BROADCAST_TIME", "SET_IS_MASK_CONFIGED", "SET_VIDEO_BACKGROUND_MODE", "SET_VIDEO_MASK", "SET_VIDEO_CAPTURED_DIMENSION", "ADD_VIDEO_RENDERED_ENSURED_CANVAS", "SET_VIDEO_MEDIA_PLAYBACK_FILE", "SET_PREFETCHED_VIDEO_USER", "SET_VIDEO_QOS_SUBSCRIPTION_STATUS", "SET_IS_SUPPORT_FULL_HD_VIDEO", "ADD_VIDEO_PLAYER_ATTACHMENT", "REMOVE_VIDEO_PLAYER_ATTACHMENT", "SET_IS_WEB_GL2_RENDERER_TYPE", "SET_IS_WEB_GPU_RENDERER_TYPE", "SET_VIDEO_RENDERER_TYPE"), { setQaSetting: dF, addQaQuestion: cF, addQaAnswer: pF, removeQaComment: hF, removeQaQuestion: fF, dismissQaQuestion: vF, reopenQaQuestion: mF, voteQaQuestion: gF, answerQaQuestionLive: yF, updateAttendeeAnonymousQuestion: SF, setQaEnabled: bF, resetQa: BO } = Yt("SET_QA_SETTING", "ADD_QA_QUESTION", "ADD_QA_ANSWER", "REMOVE_QA_COMMENT", "REMOVE_QA_QUESTION", "DISMISS_QA_QUESTION", "REOPEN_QA_QUESTION", "VOTE_QA_QUESTION", "ANSWER_QA_QUESTION_LIVE", "UPDATE_ATTENDEE_ANONYMOUS_QUESTION", "SET_QA_ENABLED", "RESET_QA"), { setChatPrivilege: Om, setPanelistChatPrivilege: dI, addChatMessageHistory: mu, resetChat: cI, setIsAllowAttendeeChat: pI, setLatestChatMessageId: hI, removeChatMessage: Kd, setFileChatSetting: fI, addChatFileRecord: Tm, updateChatFileRecord: tr, cancelSendFileChat: gu, addFailedChatFileTransfer: km, setChatFileMessageId: vI, cancelDownloadFileChat: Mm } = Yt("SET_CHAT_PRIVILEGE", "SET_PANELIST_CHAT_PRIVILEGE", "ADD_CHAT_MESSAGE_HISTORY", "RESET_CHAT", "SET_IS_ALLOW_ATTENDEE_CHAT", "SET_LATEST_CHAT_MESSAGE_ID", "REMOVE_CHAT_MESSAGE", "SET_FILE_CHAT_SETTING", "ADD_CHAT_FILE_RECORD", "UPDATE_CHAT_FILE_RECORD", "CANCEL_SEND_FILE_CHAT", "ADD_FAILED_CHAT_FILE_TRANSFER", "SET_CHAT_FILE_MESSAGE_ID", "CANCEL_DOWNLOAD_FILE_CHAT"), { setCcEditorInfo: mI, setTempSendCcText: CF, setCcLtMessage: wF, setTempReceiveLtText: EF, setTempReceiveCcText: IF, setGatewayInfoList: AF, setLtEnable: _F, setIsListenClosedCaption: RF, setCcEnable: OF, allowParticipantAskLt: TF, receiveAskStartLt: kF, setMeetingEnabledLtFeature: MF, updateLtStatus: PF, deleteMessage: DF, updateMessage: LF, resetClosedCaption: $O } = Yt("SET_CC_EDITOR_INFO", "SET_CC_LT_MESSAGE", "SET_TEMP_SEND_CC_TEXT", "SET_TEMP_RECEIVE_LT_TEXT", "SET_TEMP_RECEIVE_CC_TEXT", "SET_GATEWAY_INFO_LIST", "SET_LT_ENABLE", "SET_IS_LISTEN_CLOSED_CAPTION", "SET_CC_ENABLE", "ALLOW_PARTICIPANT_ASK_LT", "RECEIVE_ASK_START_LT", "SET_MEETING_ENABLED_LT_FEATURE", "UPDATE_LT_STATUS", "DELETE_MESSAGE", "UPDATE_MESSAGE", "RESET_CLOSED_CAPTION"), { addBreakoutRooms: gI, setBreakoutRoomAllocationPattern: yI, setBreakoutRoomSequenceId: Pm, setMeetingElapsedTime: Mf, setStartRoomElapsedTime: SI, setBreakoutRoomOptions: bI, setBreakoutRoomControlStatus: CI, setBreakoutRooms: Jd, setCurrentBreakoutRoom: s0, setBreakoutRoomAttendeeStatus: Is, setBreakoutRoomConfId: Pf, setBreakoutRoomToken: Df, resetBreakoutRoom: wI, setBreakoutRoomClosingRoomTime: Lf, setBreakoutRoomBroadcastMessage: EI, setBreakoutRoomHostReplyType: Dm, setBreakoutRoomHostReplyRequestId: II, setMainSessionAttendeeList: AI, setIsHugeBreakoutRoom: _I, setBreakoutRoomPreAssignedRoomList: Nf, setBreakoutRoomUserRoleUpdated: xf, setBreakoutRoomMeetingOptions: RI, setBreakoutRoomUserActivityStatus: OI, setBreakoutRoomIsBroadcastVoice: a0 } = Yt("ADD_BREAKOUT_ROOMS", "SET_BREAKOUT_ROOM_ALLOCATION_PATTERN", "SET_BREAKOUT_ROOM_SEQUENCE_ID", "SET_MEETING_ELAPSED_TIME", "SET_START_ROOM_ELAPSED_TIME", "SET_BREAKOUT_ROOM_OPTIONS", "SET_BREAKOUT_ROOM_CONTROL_STATUS", "SET_BREAKOUT_ROOMS", "SET_CURRENT_BREAKOUT_ROOM", "SET_BREAKOUT_ROOM_ATTENDEE_STATUS", "SET_BREAKOUT_ROOM_CONF_ID", "SET_BREAKOUT_ROOM_TOKEN", "RESET_BREAKOUT_ROOM", "SET_BREAKOUT_ROOM_CLOSING_ROOM_TIME", "SET_BREAKOUT_ROOM_BROADCAST_MESSAGE", "SET_BREAKOUT_ROOM_HOST_REPLY_TYPE", "SET_BREAKOUT_ROOM_HOST_REPLY_REQUEST_ID", "SET_MAIN_SESSION_ATTENDEE_LIST", "SET_IS_HUGE_BREAKOUT_ROOM", "SET_BREAKOUT_ROOM_PRE_ASSIGNED_ROOM_LIST", "SET_BREAKOUT_ROOM_USER_ROLE_UPDATED", "SET_BREAKOUT_ROOM_MEETING_OPTIONS", "SET_BREAKOUT_ROOM_USER_ACTIVITY_STATUS", "SET_BREAKOUT_ROOM_IS_BROADCAST_VOICE"), { setCloudRecordingStatus: TI, setCloudRecordingEnable: kI, setCloudIsoRecordingEnable: MI, setAllowStopAutoRecording: PI, setAutomaticCloudRecordingEnable: DI, setIsZoomIQ: Lm, setZoomIQChanging: Nm, setLocalRecordStatus: xm, setSupportLocalRecording: Vf, setLocalGrantPermissionOption: LI, setLocalPermissionUserList: ka, resetRecording: NI } = Yt("SET_CLOUD_RECORDING_STATUS", "SET_CLOUD_RECORDING_ENABLE", "SET_CLOUD_ISO_RECORDING_ENABLE", "SET_ALLOW_STOP_AUTO_RECORDING", "SET_AUTOMATIC_CLOUD_RECORDING_ENABLE", "SET_IS_ZOOM_I_Q", "SET_ZOOM_I_Q_CHANGING", "SET_LOCAL_RECORD_STATUS", "SET_SUPPORT_LOCAL_RECORDING", "SET_LOCAL_GRANT_PERMISSION_OPTION", "SET_LOCAL_PERMISSION_USER_LIST", "RESET_RECORDING"), { updateCmdJid: xI, removeCmdJid: VI, setCmdChannelConnectionStatus: jI, resetCmdChannel: UI } = Yt("UPDATE_CMD_JID", "REMOVE_CMD_JID", "SET_CMD_CHANNEL_CONNECTION_STATUS", "RESET_CMD_CHANNEL"), { setArchivingStatus: NF, setArchivingSessionReady: xF, setArchivingOptions: VF, resetArchiving: HO } = Yt({ SET_ARCHIVING_STATUS: (e) => e, SET_ARCHIVING_SESSION_READY: (e) => e, SET_ARCHIVING_OPTIONS: (e) => e, RESET_ARCHIVING: () => {
} }), { setIsLiveTranscriptionEnabled: BI, setLiveTranscriptionMeetingOptions: $I, setIsLiveTranscriptionManualCaptionerEnabled: jf, setLiveTranscriptionGatewayId: HI, setLiveTranscriptionSupportedLanguage: FI, setIsLiveTranscriptionSubscribed: Uf, setCurrentTranscriptionLang: ms, setCurrentTranslationLang: l0, addLiveTranscriptionMessage: Bf, updateLiveTranscriptionMessage: zI, reduceLiveTranscriptionMessages: WI, setLiveTranscriptionEngineType: ZI, removeLiveTranscriptionFailoverState: GI, setLiveTranscriptionLastCaptionMessage: qI, resetLiveTranscription: KI, setIsHostDisableCaptions: JI } = Yt("SET_IS_LIVE_TRANSCRIPTION_ENABLED", "SET_LIVE_TRANSCRIPTION_MEETING_OPTIONS", "SET_IS_LIVE_TRANSCRIPTION_MANUAL_CAPTIONER_ENABLED", "SET_LIVE_TRANSCRIPTION_GATEWAY_ID", "SET_LIVE_TRANSCRIPTION_SUPPORTED_LANGUAGE", "SET_IS_LIVE_TRANSCRIPTION_SUBSCRIBED", "SET_CURRENT_TRANSCRIPTION_LANG", "SET_CURRENT_TRANSLATION_LANG", "ADD_LIVE_TRANSCRIPTION_MESSAGE", "UPDATE_LIVE_TRANSCRIPTION_MESSAGE", "REDUCE_LIVE_TRANSCRIPTION_MESSAGES", "SET_LIVE_TRANSCRIPTION_ENGINE_TYPE", "REMOVE_LIVE_TRANSCRIPTION_FAILOVER_STATE", "SET_LIVE_TRANSCRIPTION_LAST_CAPTION_MESSAGE", "RESET_LIVE_TRANSCRIPTION", " SET_IS_HOST_DISABLE_CAPTIONS"), { setPollData: jF, setPollingId: UF, setPollingWebLinks: BF, setPollingDocMaxSize: $F, setPollingDocSize: HF, setPollingDocLibraryMaxSize: FF, setPollingDocLibrarySize: zF, resetPoll: FO } = Yt("SET_POLL_DATA", "SET_POLLING_ID", "SET_POLLING_WEB_LINKS", "SET_POLLING_DOC_MAX_SIZE", "SET_POLLING_DOC_SIZE", "SET_POLLING_DOC_LIBRARY_MAX_SIZE", "SET_POLLING_DOC_LIBRARY_SIZE", "RESET_POLL"), { setLoggerInitOptions: Vm, setIsLaplaceInitialized: u0, resetLogger: QI } = Yt("SET_LOGGER_INIT_OPTIONS", "SET_IS_LAPLACE_INITIALIZED", "RESET_LOGGER"), { setIsLiveStreamEnable: YI, setLiveStreamStatus: d0, resetLiveStream: XI } = Yt("SET_IS_LIVE_STREAM_ENABLE", "SET_LIVE_STREAM_STATUS", "RESET_LIVE_STREAM");
var $f = { exports: {} }, jp = {};
(function(e, t) {
  var r = function(U, j) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(P, Z) {
      P.__proto__ = Z;
    } || function(P, Z) {
      for (var H in Z)
        Z.hasOwnProperty(H) && (P[H] = Z[H]);
    }, r(U, j);
  };
  function n(U, j) {
    function P() {
      this.constructor = U;
    }
    r(U, j), U.prototype = j === null ? Object.create(j) : (P.prototype = j.prototype, new P());
  }
  var o = function() {
    return o = Object.assign || function(U) {
      for (var j, P = 1, Z = arguments.length; P < Z; P++)
        for (var H in j = arguments[P])
          Object.prototype.hasOwnProperty.call(j, H) && (U[H] = j[H]);
      return U;
    }, o.apply(this, arguments);
  }, i, s = function(U, j) {
    var P = new Uint8Array(U.byteLength + j.byteLength);
    return P.set(new Uint8Array(U), 0), P.set(new Uint8Array(j), U.byteLength), P.buffer;
  }, a = "/";
  (i = e.TransformDataFormat || (e.TransformDataFormat = {})).STRING = "string", i.BLOB = "blob", i.ARRAY_BUFFER = "arraybuffer";
  var l = function(U) {
    return Blob && U instanceof Blob ? "blob" : ArrayBuffer && U instanceof ArrayBuffer ? "arrayBuffer" : typeof U;
  }, u = [], d = function() {
    for (var U = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"], j = "", P = 0; P < 32; P++)
      j += U[Math.round(61 * Math.random())];
    return u.indexOf(j) !== -1 ? d() : (u.push(j), j);
  }, c = function(U) {
    return U.arrayBuffer ? U.arrayBuffer() : new Promise(function(j, P) {
      var Z = new FileReader();
      Z.readAsArrayBuffer(U), Z.onload = function(H) {
        j(H.target && H.target.result);
      }, Z.onerror = function(H) {
        P(H);
      };
    });
  }, p = function(U) {
    return U.text ? U.text() : new Promise(function(j, P) {
      var Z = new FileReader();
      Z.readAsText(U), Z.onload = function(H) {
        j(H.target && H.target.result);
      }, Z.onerror = function(H) {
        P(H);
      };
    });
  }, h = function(U, j) {
    return Promise.resolve(new Blob([new Uint8Array(U)], { type: j }));
  }, v = function(U, j) {
    var P = new Blob([U], { type: j || "text/plain" });
    return p(P);
  }, f = function(U, j) {
    return Promise.resolve(new Blob([U], { type: j || "text/plain" }));
  }, m = function(U, j) {
    return c(new Blob([U], { type: j || "text/plain" }));
  };
  function g(U) {
    var j = (U || "").split(".");
    return j[j.length - 1] || "";
  }
  function C(U) {
    var j = (U || "").lastIndexOf(a);
    return j < 0 ? "" : U.slice(0, j);
  }
  function b(U) {
    var j = (U || "").lastIndexOf(a), P = j < 0 ? U : U.slice(j + 1), Z = (P || "").lastIndexOf(".");
    return Z < 0 ? P : P.slice(0, Z);
  }
  function E(U) {
    return ["png", "jpg", "jpeg", "svg"].includes(g(U));
  }
  function w(U) {
    return g(U) === "json";
  }
  function _(U) {
    return g(U) === "version";
  }
  function I(U, j) {
    return U.reduce(function(P, Z) {
      var H, me = Z.data, Ce = Z.file, _e = g(Ce.name), Me = C(Ce.name), je = b(Ce.name), Ne = ((j == null ? void 0 : j.combineExtNames) || []).includes(_e) && typeof me == "string", Le = Ne ? "" + (Me ? "" + Me + a + _e : _e) : Ce.name;
      return Ne && P.some(function(Qe) {
        return Qe.path === Le && (Qe.data[je] = me, !0);
      }) || P.push({ path: Le, extName: _e, data: Ne ? (H = {}, H[je] = me, H) : me, shouldCombine: Ne }), P;
    }, []).map(function(P) {
      var Z = P.data, H = P.shouldCombine, me = function(Ce, _e) {
        var Me = {};
        for (var je in Ce)
          Object.prototype.hasOwnProperty.call(Ce, je) && _e.indexOf(je) < 0 && (Me[je] = Ce[je]);
        if (Ce != null && typeof Object.getOwnPropertySymbols == "function") {
          var Ne = 0;
          for (je = Object.getOwnPropertySymbols(Ce); Ne < je.length; Ne++)
            _e.indexOf(je[Ne]) < 0 && Object.prototype.propertyIsEnumerable.call(Ce, je[Ne]) && (Me[je[Ne]] = Ce[je[Ne]]);
        }
        return Me;
      }(P, ["data", "shouldCombine"]);
      return o(o({}, me), { data: H ? JSON.stringify(Z) : Z });
    });
  }
  function D(U, j) {
    return t.loadAsync(U).then(function(P) {
      return Promise.all(P.filter(function(Z, H) {
        return !H.dir;
      }).map(function(Z) {
        var H = function(me) {
          return w(me.name) ? "string" : E(me.name) ? "base64" : _(me.name) ? "text" : "blob";
        }(Z);
        return j != null && j.setUnZipFormat && (H = j.setUnZipFormat(Z) || H), Z.async(H).then(function(me) {
          var Ce = me, _e = g(Z.name), Me = _e === "svg" ? "svg+xml" : _e;
          return H === "base64" && E(Z.name) && !me.startsWith("data") && (Ce = "data:image/" + Me + ";base64," + Ce), { data: Ce, file: Z };
        });
      }));
    }).then(function(P) {
      return I(P, j);
    });
  }
  function B(U, j) {
    var P = j || {}, Z = P.encoding, H = P.blobType, me = P.unZipOptions;
    if (function(Ye) {
      return l(Ye) === "blob" && (Ye.type.includes("compressed") || Ye.type.includes("zip"));
    }(U) && !(me != null && me.disableUnZip))
      return D(U, me);
    if (!Z)
      return Promise.resolve(U);
    var Ce = l(U), _e = Ce === "string", Me = Ce === "blob", je = Ce === "arrayBuffer";
    if (Z === e.TransformDataFormat.BLOB) {
      var Ne = U;
      if (_e)
        return p(Ne);
      if (je)
        return c(Ne);
    } else if (Z === e.TransformDataFormat.ARRAY_BUFFER) {
      var Le = U;
      if (_e)
        return v(Le, H);
      if (Me)
        return h(Le, H);
    } else if (Z === e.TransformDataFormat.STRING) {
      var Qe = U;
      if (Me)
        return f(Qe, H);
      if (je)
        return m(Qe, H);
    }
    return Promise.resolve(U);
  }
  function L(U) {
    var j = 0, P = !1, Z = function() {
      j > 90 || P || (U(j += (100 - j) / 50), requestAnimationFrame(Z));
    };
    return Z(), { finish: function() {
      j === 100 || P || (j = 100, U(100));
    }, abort: function() {
      j === 100 || P || (P = !0);
    }, get curProgress() {
      return j;
    } };
  }
  function R() {
  }
  function y() {
    y.init.call(this);
  }
  function A(U) {
    return U._maxListeners === void 0 ? y.defaultMaxListeners : U._maxListeners;
  }
  function k(U, j, P, Z) {
    var H, me, Ce;
    if (typeof P != "function")
      throw new TypeError('"listener" argument must be a function');
    if ((me = U._events) ? (me.newListener && (U.emit("newListener", j, P.listener ? P.listener : P), me = U._events), Ce = me[j]) : (me = U._events = new R(), U._eventsCount = 0), Ce) {
      if (typeof Ce == "function" ? Ce = me[j] = Z ? [P, Ce] : [Ce, P] : Z ? Ce.unshift(P) : Ce.push(P), !Ce.warned && (H = A(U)) && H > 0 && Ce.length > H) {
        Ce.warned = !0;
        var _e = new Error("Possible EventEmitter memory leak detected. " + Ce.length + " " + j + " listeners added. Use emitter.setMaxListeners() to increase limit");
        _e.name = "MaxListenersExceededWarning", _e.emitter = U, _e.type = j, _e.count = Ce.length, function(Me) {
          typeof console.warn == "function" ? console.warn(Me) : console.log(Me);
        }(_e);
      }
    } else
      Ce = me[j] = P, ++U._eventsCount;
    return U;
  }
  function T(U, j, P) {
    var Z = !1;
    function H() {
      U.removeListener(j, H), Z || (Z = !0, P.apply(U, arguments));
    }
    return H.listener = P, H;
  }
  function N(U) {
    var j = this._events;
    if (j) {
      var P = j[U];
      if (typeof P == "function")
        return 1;
      if (P)
        return P.length;
    }
    return 0;
  }
  function F(U, j) {
    for (var P = new Array(j); j--; )
      P[j] = U[j];
    return P;
  }
  R.prototype = /* @__PURE__ */ Object.create(null), y.EventEmitter = y, y.usingDomains = !1, y.prototype.domain = void 0, y.prototype._events = void 0, y.prototype._maxListeners = void 0, y.defaultMaxListeners = 10, y.init = function() {
    this.domain = null, y.usingDomains && (void 0).active, this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = new R(), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, y.prototype.setMaxListeners = function(U) {
    if (typeof U != "number" || U < 0 || isNaN(U))
      throw new TypeError('"n" argument must be a positive number');
    return this._maxListeners = U, this;
  }, y.prototype.getMaxListeners = function() {
    return A(this);
  }, y.prototype.emit = function(U) {
    var j, P, Z, H, me, Ce, _e, Me = U === "error";
    if (Ce = this._events)
      Me = Me && Ce.error == null;
    else if (!Me)
      return !1;
    if (_e = this.domain, Me) {
      if (j = arguments[1], !_e) {
        if (j instanceof Error)
          throw j;
        var je = new Error('Uncaught, unspecified "error" event. (' + j + ")");
        throw je.context = j, je;
      }
      return j || (j = new Error('Uncaught, unspecified "error" event')), j.domainEmitter = this, j.domain = _e, j.domainThrown = !1, _e.emit("error", j), !1;
    }
    if (!(P = Ce[U]))
      return !1;
    var Ne = typeof P == "function";
    switch (Z = arguments.length) {
      case 1:
        (function(Le, Qe, Ye) {
          if (Qe)
            Le.call(Ye);
          else
            for (var Ze = Le.length, Rt = F(Le, Ze), ct = 0; ct < Ze; ++ct)
              Rt[ct].call(Ye);
        })(P, Ne, this);
        break;
      case 2:
        (function(Le, Qe, Ye, Ze) {
          if (Qe)
            Le.call(Ye, Ze);
          else
            for (var Rt = Le.length, ct = F(Le, Rt), vt = 0; vt < Rt; ++vt)
              ct[vt].call(Ye, Ze);
        })(P, Ne, this, arguments[1]);
        break;
      case 3:
        (function(Le, Qe, Ye, Ze, Rt) {
          if (Qe)
            Le.call(Ye, Ze, Rt);
          else
            for (var ct = Le.length, vt = F(Le, ct), Sr = 0; Sr < ct; ++Sr)
              vt[Sr].call(Ye, Ze, Rt);
        })(P, Ne, this, arguments[1], arguments[2]);
        break;
      case 4:
        (function(Le, Qe, Ye, Ze, Rt, ct) {
          if (Qe)
            Le.call(Ye, Ze, Rt, ct);
          else
            for (var vt = Le.length, Sr = F(Le, vt), Xt = 0; Xt < vt; ++Xt)
              Sr[Xt].call(Ye, Ze, Rt, ct);
        })(P, Ne, this, arguments[1], arguments[2], arguments[3]);
        break;
      default:
        for (H = new Array(Z - 1), me = 1; me < Z; me++)
          H[me - 1] = arguments[me];
        (function(Le, Qe, Ye, Ze) {
          if (Qe)
            Le.apply(Ye, Ze);
          else
            for (var Rt = Le.length, ct = F(Le, Rt), vt = 0; vt < Rt; ++vt)
              ct[vt].apply(Ye, Ze);
        })(P, Ne, this, H);
    }
    return !0;
  }, y.prototype.addListener = function(U, j) {
    return k(this, U, j, !1);
  }, y.prototype.on = y.prototype.addListener, y.prototype.prependListener = function(U, j) {
    return k(this, U, j, !0);
  }, y.prototype.once = function(U, j) {
    if (typeof j != "function")
      throw new TypeError('"listener" argument must be a function');
    return this.on(U, T(this, U, j)), this;
  }, y.prototype.prependOnceListener = function(U, j) {
    if (typeof j != "function")
      throw new TypeError('"listener" argument must be a function');
    return this.prependListener(U, T(this, U, j)), this;
  }, y.prototype.removeListener = function(U, j) {
    var P, Z, H, me, Ce;
    if (typeof j != "function")
      throw new TypeError('"listener" argument must be a function');
    if (!(Z = this._events))
      return this;
    if (!(P = Z[U]))
      return this;
    if (P === j || P.listener && P.listener === j)
      --this._eventsCount == 0 ? this._events = new R() : (delete Z[U], Z.removeListener && this.emit("removeListener", U, P.listener || j));
    else if (typeof P != "function") {
      for (H = -1, me = P.length; me-- > 0; )
        if (P[me] === j || P[me].listener && P[me].listener === j) {
          Ce = P[me].listener, H = me;
          break;
        }
      if (H < 0)
        return this;
      if (P.length === 1) {
        if (P[0] = void 0, --this._eventsCount == 0)
          return this._events = new R(), this;
        delete Z[U];
      } else
        (function(_e, Me) {
          for (var je = Me, Ne = je + 1, Le = _e.length; Ne < Le; je += 1, Ne += 1)
            _e[je] = _e[Ne];
          _e.pop();
        })(P, H);
      Z.removeListener && this.emit("removeListener", U, Ce || j);
    }
    return this;
  }, y.prototype.removeAllListeners = function(U) {
    var j, P;
    if (!(P = this._events))
      return this;
    if (!P.removeListener)
      return arguments.length === 0 ? (this._events = new R(), this._eventsCount = 0) : P[U] && (--this._eventsCount == 0 ? this._events = new R() : delete P[U]), this;
    if (arguments.length === 0) {
      for (var Z, H = Object.keys(P), me = 0; me < H.length; ++me)
        (Z = H[me]) !== "removeListener" && this.removeAllListeners(Z);
      return this.removeAllListeners("removeListener"), this._events = new R(), this._eventsCount = 0, this;
    }
    if (typeof (j = P[U]) == "function")
      this.removeListener(U, j);
    else if (j)
      do
        this.removeListener(U, j[j.length - 1]);
      while (j[0]);
    return this;
  }, y.prototype.listeners = function(U) {
    var j, P = this._events;
    return P && (j = P[U]) ? typeof j == "function" ? [j.listener || j] : function(Z) {
      for (var H = new Array(Z.length), me = 0; me < H.length; ++me)
        H[me] = Z[me].listener || Z[me];
      return H;
    }(j) : [];
  }, y.listenerCount = function(U, j) {
    return typeof U.listenerCount == "function" ? U.listenerCount(j) : N.call(U, j);
  }, y.prototype.listenerCount = N, y.prototype.eventNames = function() {
    return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
  };
  var $ = function(U) {
    function j(P) {
      var Z = U.call(this) || this;
      return Z.timeout = (P == null ? void 0 : P.timeout) || 3e4, Z;
    }
    return n(j, U), j.prototype.clearTimeoutCheck = function() {
      this.timeoutTimer && (clearTimeout(this.timeoutTimer), this.timeoutTimer = null);
    }, j.prototype.startTimeoutCheck = function() {
      var P = this;
      !this.timeoutTimer && !this.finished && this.timeout > 0 && (this.timeoutTimer = setTimeout(function() {
        P.finished || (P.finished = !0, P.data = null, P.emit("timeout")), P.clearTimeoutCheck();
      }, this.timeout));
    }, j;
  }(y), re = function(U) {
    function j(P) {
      var Z = U.call(this, P) || this;
      return Z.uuid = d(), Z.domParams = P || {}, Z;
    }
    return n(j, U), j.prototype.jsonp = function() {
      var P = this;
      if (!this.finished) {
        var Z = this.domParams, H = Z.url, me = Z.jsonpCallbackName, Ce = me === void 0 ? "callback" : me, _e = Z.body, Me = Z.integrity;
        this.script = document.createElement("script"), Me && (this.script.integrity = Me, this.script.crossOrigin = "anonymous");
        var je = "";
        _e && Object.entries(_e).forEach(function(Ne) {
          var Le = Ne[0], Qe = Ne[1];
          je += (je ? "&" : "") + Le + "=" + Qe;
        }), je += (je ? "&" : "") + Ce + "=" + this.uuid, this.script.src = H + (H.includes("?") ? "" : "?") + je, this.jsonpCallback(), this.progressMonitory = L(function(Ne) {
          P.finished || P.emit("progressUpdated", Ne);
        }), document.body.appendChild(this.script);
      }
    }, j.prototype.clearSideEffect = function(P) {
      if (P === void 0 && (P = !1), document.body.removeChild(this.script), P) {
        var Z = this.uuid;
        window[this.uuid] = function() {
          window[Z] && delete window[Z];
        };
      } else
        delete window[this.uuid];
      this.script = null, this.uuid = null, this.finished = !0, this.data = null, this.clearTimeoutCheck();
    }, j.prototype.jsonpCallback = function() {
      var P = this;
      this.script.onerror = function(Z) {
        var H;
        P.finished || (P.clearSideEffect(), (H = P.progressMonitory) === null || H === void 0 || H.abort(), P.emit("error", new Error(typeof Z == "string" ? Z : "load jsonp script failed")));
      }, window[this.uuid] = function(Z) {
        var H;
        if (!P.finished) {
          var me = P.domParams, Ce = me.encoding, _e = me.blobType, Me = me.unZipOptions, je = me.beforeTransformData, Ne = me.afterTransformData;
          (H = P.progressMonitory) === null || H === void 0 || H.finish(), P.clearSideEffect(), (je ? je(Z || "") : Promise.resolve(Z || "")).then(function(Le) {
            return B(Le, { encoding: Ce, blobType: _e, unZipOptions: Me }).then(function(Qe) {
              return (Ne ? Ne(Qe) : Promise.resolve(Qe)).then(function(Ye) {
                return P.emit("finished", Ye);
              });
            });
          }).catch(function(Le) {
            return P.emit("error", Le);
          });
        }
      };
    }, j.prototype.abort = function() {
      this.clearSideEffect(!0);
    }, j;
  }($), fe = function(U) {
    function j(P) {
      var Z = U.call(this, P) || this;
      return Z.socketParams = P || {}, Z;
    }
    return n(j, U), j.prototype.write = function(P, Z) {
      P && !this.finished && (P instanceof Error ? this.handleError(P) : (this.data ? this.appendData(P) : this.data = P, this.handlePerCentUpdate(Z)));
    }, j.prototype.handlePerCentUpdate = function(P) {
      P === void 0 || this.finished || this.emit("progressUpdated", P);
    }, j.prototype.handleError = function(P) {
      this.data = null, this.finished = !0, this.clearTimeoutCheck(), this.emit("error", P);
    }, j.prototype.appendData = function(P) {
      l(P) === l(this.data) ? typeof P == "string" ? this.data += P : Blob && P instanceof Blob ? this.data = new Blob([this.data, P], { type: P.type }) : ArrayBuffer && P instanceof ArrayBuffer && (this.data = s(this.data, P)) : this.handleError(new Error("every piece of the data format must be the same"));
    }, j.prototype.end = function(P) {
      var Z = this;
      if (!this.finished) {
        this.handlePerCentUpdate(100), P && this.write(P);
        var H = this.socketParams, me = H.encoding, Ce = H.blobType, _e = H.unZipOptions, Me = H.beforeTransformData, je = H.afterTransformData;
        (Me ? Me(this.data) : Promise.resolve(this.data)).then(function(Ne) {
          return B(Ne, { encoding: me, blobType: Ce, unZipOptions: _e }).then(function(Le) {
            return (je ? je(Le) : Promise.resolve(Le)).then(function(Qe) {
              return Z.emit("finished", Qe);
            });
          });
        }).catch(function(Ne) {
          return Z.emit("error", Ne);
        }), this.data = null, this.finished = !0, this.clearTimeoutCheck();
      }
    }, j.prototype.abort = function() {
      this.data = null, this.finished = !0, this.clearTimeoutCheck();
    }, j;
  }($), le = function(U) {
    function j(P) {
      var Z = U.call(this, P) || this;
      return Z.xhrParams = P || {}, Z.xhrParams.headers = o({}, Z.xhrParams.headers || {}), Z;
    }
    return n(j, U), j.prototype.supportFetch = function() {
      return !!window.fetch && window.AbortController && window.Request;
    }, j.prototype.ajax = function() {
      var P = this;
      if (!this.finished)
        if (this.xhrParams.url) {
          var Z = this.xhrParams, H = Z.headers, me = H === void 0 ? {} : H, Ce = Z.url, _e = Z.body, Me = _e === void 0 ? {} : _e, je = Z.method, Ne = je === void 0 ? "POST" : je, Le = Z.encoding, Qe = Z.integrity;
          this.controller = this.supportFetch() ? new AbortController() : new XMLHttpRequest();
          var Ye = this.supportFetch() ? L(function(Ze) {
            P.finished || P.emit("progressUpdated", Ze);
          }) : null;
          (this.supportFetch() ? fetch(new Request(Ce, o({ method: Ne, headers: me, body: Ne === "GET" ? void 0 : JSON.stringify(Me), signal: this.controller.signal }, Qe ? { integrity: Qe, mode: "cors" } : {}))).then(function(Ze) {
            return Ze.ok ? Le === e.TransformDataFormat.STRING ? Ze.text() : Le === e.TransformDataFormat.ARRAY_BUFFER ? Ze.arrayBuffer() : Ze.blob() : Promise.reject(new Error("xhr download " + Ce + " failed!"));
          }) : new Promise(function(Ze, Rt) {
            var ct = new XMLHttpRequest();
            P.controller = ct, ct.open(Ne, Ce), ct.responseType = Le === e.TransformDataFormat.STRING ? "text" : Le === e.TransformDataFormat.ARRAY_BUFFER ? "arraybuffer" : "blob", Object.entries(me).forEach(function(vt) {
              var Sr = vt[0], Xt = vt[1];
              ct.setRequestHeader(Sr, Xt);
            }), ct.onload = function() {
              var vt = ct.status, Sr = ct.response, Xt = ct.statusText;
              vt >= 200 && vt < 300 || vt === 304 ? Ze(Sr) : Rt(new Error(vt + ": " + Xt));
            }, ct.onprogress = function(vt) {
              var Sr = vt || {}, Xt = Sr.total, oi = Sr.loaded;
              oi === void 0 || P.finished || (Xt ? P.emit("progressUpdated", oi / Xt * 100) : oi && !Ye && (Ye = L(function(ii) {
                P.finished || P.emit("progressUpdated", ii);
              })));
            }, ct.onerror = function() {
              Rt(new Error("xhr download " + Ce + " failed!"));
            }, ct.send(JSON.stringify(Me));
          })).then(function(Ze) {
            if (!P.finished) {
              var Rt = P.xhrParams, ct = Rt.encoding, vt = Rt.blobType, Sr = Rt.unZipOptions, Xt = Rt.beforeTransformData, oi = Rt.afterTransformData;
              Ye == null || Ye.finish(), P.finished = !0, P.clearTimeoutCheck(), (Xt ? Xt(Ze) : Promise.resolve(Ze)).then(function(ii) {
                return B(ii, { encoding: ct, blobType: vt, unZipOptions: Sr }).then(function(il) {
                  return (oi ? oi(il) : Promise.resolve(il)).then(function(sl) {
                    return P.emit("finished", sl);
                  });
                });
              }).catch(function(ii) {
                return P.emit("error", ii);
              });
            }
          }).catch(function(Ze) {
            P.finished || (P.finished = !0, P.clearTimeoutCheck(), Ye == null || Ye.abort(), P.emit("error", Ze));
          });
        } else
          this.emit("error", new Error("xhrDownloader url params invalid!"));
    }, j.prototype.abort = function() {
      this.data = null, this.finished = !0, this.clearTimeoutCheck(), this.controller.abort();
    }, j;
  }($), Ae = 0;
  y.defaultMaxListeners = 500;
  var Re, Se = new y(), ye = "ThreadPoolReady", Oe = function() {
    Ae -= 1, Se.emit(ye);
  };
  (Re = e.DownloaderType || (e.DownloaderType = {})).XHR = "xhr", Re.DOM = "dom", Re.SOCKET = "socket";
  var Ue = function(U) {
    function j(P) {
      var Z = U.call(this) || this;
      return Z.aborted = !1, Z.downloadParmas = o({ type: e.DownloaderType.XHR }, P), Z.id = d(), Z;
    }
    return n(j, U), j.prototype.start = function() {
      var P = this;
      Ae += 1, this.progress = 0, this.emit("downloadStart"), this.onDownloadStartCallback && this.onDownloadStartCallback();
      var Z = this.downloadParmas, H = Z.type, me = Z.xhrParams, Ce = Z.domParams, _e = Z.socketParams;
      switch (H) {
        case e.DownloaderType.DOM:
          this.downloader = new re(Ce), this.downloader.jsonp();
          break;
        case e.DownloaderType.SOCKET:
          this.downloader = new fe(_e);
          break;
        default:
          this.downloader = new le(me), this.downloader.ajax();
      }
      return this.downloader.startTimeoutCheck(), this.downloader.on("error", function(Me) {
        P.emit("error", Me), P.onErrorCallback && P.onErrorCallback(Me), Oe();
      }).on("finished", function(Me) {
        P.emit("complete", Me), P.onCompleteCallback && P.onCompleteCallback(Me), Oe();
      }).on("progressUpdated", function(Me) {
        P.progress = Me, P.emit("progressUpdated", Me), P.onProgressUpdatedCallback && P.onProgressUpdatedCallback(Me);
      }).on("timeout", function() {
        P.emit("timeout"), P.onTimeoutCallback && P.onTimeoutCallback(), Oe();
      }), this;
    }, j.prototype.abort = function() {
      if (this.aborted)
        return this;
      this.aborted = !0, this.downloader && !this.downloader.finished && this.downloader.abort();
      var P = new Error("file download has been aborted");
      return this.emit("abort", P), this.onAbortCallback && this.onAbortCallback(P), Oe(), this;
    }, j.prototype.onDownloadStart = function(P) {
      return this.onDownloadStartCallback = P, this;
    }, j.prototype.onProgressUpdated = function(P) {
      return this.onProgressUpdatedCallback = P, this;
    }, j.prototype.onError = function(P) {
      return this.onErrorCallback = P, this;
    }, j.prototype.onComplete = function(P) {
      return this.onCompleteCallback = P, this;
    }, j.prototype.onAbort = function(P) {
      return this.onAbortCallback = P, this;
    }, j.prototype.onTimeout = function(P) {
      return this.onTimeoutCallback = P, this;
    }, j.prototype.isInProgress = function() {
      return this.progress !== void 0;
    }, j.prototype.isFinished = function() {
      return this.progress === 100;
    }, j;
  }(y), Ve = function() {
    function U(j) {
      this.taskList = [], this.options = j || {};
      var P = this.options.threadLimit;
      if ((P === void 0 ? 6 : P) > 6)
        throw new Error("threadLimit must be lower than 6");
      Se.on(ye, this.startNextTask.bind(this));
    }
    return U.prototype.download = function(j) {
      var P = new Ue(j), Z = this.removeTask.bind(this, P);
      return P.on("abort", Z), this.taskList.push(P), this.checkTaskReady(P), P;
    }, U.prototype.startNextTask = function() {
      var j = this.taskList.find(function(P) {
        return !P.isInProgress();
      });
      j && this.checkTaskReady(j);
    }, U.prototype.checkTaskReady = function(j) {
      var P = this.options.threadLimit, Z = P === void 0 ? 6 : P;
      if (!(this.taskList.findIndex(function(me) {
        return !me.isInProgress();
      }) >= Z || Ae + 1 > 6)) {
        var H = this.removeTask.bind(this, j);
        j.on("complete", H), j.on("error", H), j.on("timeout", H), setTimeout(function() {
          return j.start();
        }, 0);
      }
    }, U.prototype.removeTask = function(j) {
      var P = this;
      this.taskList.some(function(Z, H) {
        return Z === j && (setTimeout(function() {
          return j.removeAllListeners();
        }, 0), P.taskList.splice(H, 1), !0);
      });
    }, U;
  }();
  e.DownloadTask = Ue, e.IDownloadManager = Ve, e.appendBuffer = s, e.arrayBufferToBlob = h, e.arrayBufferToString = v, e.blobToArrayBuffer = c, e.blobToText = p, e.genUuid = d, e.getDataFormat = l, e.getExtName = g, e.getFileName = b, e.getFullPathName = C, e.isImgFile = E, e.isJsonFile = w, e.isVersionFile = _, e.monitorProgress = L, e.sep = a, e.stringToArrayBuffer = m, e.stringToBlob = f, e.transformData = B, Object.defineProperty(e, "__esModule", { value: !0 });
})(jp, v4(Object.freeze({ __proto__: null, default: {} }))), r2(jp), function(e, t) {
  var r = function(L, R) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(y, A) {
      y.__proto__ = A;
    } || function(y, A) {
      for (var k in A)
        A.hasOwnProperty(k) && (y[k] = A[k]);
    }, r(L, R);
  };
  function n(L, R) {
    function y() {
      this.constructor = L;
    }
    r(L, R), L.prototype = R === null ? Object.create(R) : (y.prototype = R.prototype, new y());
  }
  var o = function() {
    return o = Object.assign || function(L) {
      for (var R, y = 1, A = arguments.length; y < A; y++)
        for (var k in R = arguments[y])
          Object.prototype.hasOwnProperty.call(R, k) && (L[k] = R[k]);
      return L;
    }, o.apply(this, arguments);
  };
  function i() {
  }
  function s() {
    s.init.call(this);
  }
  function a(L) {
    return L._maxListeners === void 0 ? s.defaultMaxListeners : L._maxListeners;
  }
  function l(L, R, y, A) {
    var k, T, N;
    if (typeof y != "function")
      throw new TypeError('"listener" argument must be a function');
    if ((T = L._events) ? (T.newListener && (L.emit("newListener", R, y.listener ? y.listener : y), T = L._events), N = T[R]) : (T = L._events = new i(), L._eventsCount = 0), N) {
      if (typeof N == "function" ? N = T[R] = A ? [y, N] : [N, y] : A ? N.unshift(y) : N.push(y), !N.warned && (k = a(L)) && k > 0 && N.length > k) {
        N.warned = !0;
        var F = new Error("Possible EventEmitter memory leak detected. " + N.length + " " + R + " listeners added. Use emitter.setMaxListeners() to increase limit");
        F.name = "MaxListenersExceededWarning", F.emitter = L, F.type = R, F.count = N.length, function($) {
          typeof console.warn == "function" ? console.warn($) : console.log($);
        }(F);
      }
    } else
      N = T[R] = y, ++L._eventsCount;
    return L;
  }
  function u(L, R, y) {
    var A = !1;
    function k() {
      L.removeListener(R, k), A || (A = !0, y.apply(L, arguments));
    }
    return k.listener = y, k;
  }
  function d(L) {
    var R = this._events;
    if (R) {
      var y = R[L];
      if (typeof y == "function")
        return 1;
      if (y)
        return y.length;
    }
    return 0;
  }
  function c(L, R) {
    for (var y = new Array(R); R--; )
      y[R] = L[R];
    return y;
  }
  i.prototype = /* @__PURE__ */ Object.create(null), s.EventEmitter = s, s.usingDomains = !1, s.prototype.domain = void 0, s.prototype._events = void 0, s.prototype._maxListeners = void 0, s.defaultMaxListeners = 10, s.init = function() {
    this.domain = null, s.usingDomains && (void 0).active, this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = new i(), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, s.prototype.setMaxListeners = function(L) {
    if (typeof L != "number" || L < 0 || isNaN(L))
      throw new TypeError('"n" argument must be a positive number');
    return this._maxListeners = L, this;
  }, s.prototype.getMaxListeners = function() {
    return a(this);
  }, s.prototype.emit = function(L) {
    var R, y, A, k, T, N, F, $ = L === "error";
    if (N = this._events)
      $ = $ && N.error == null;
    else if (!$)
      return !1;
    if (F = this.domain, $) {
      if (R = arguments[1], !F) {
        if (R instanceof Error)
          throw R;
        var re = new Error('Uncaught, unspecified "error" event. (' + R + ")");
        throw re.context = R, re;
      }
      return R || (R = new Error('Uncaught, unspecified "error" event')), R.domainEmitter = this, R.domain = F, R.domainThrown = !1, F.emit("error", R), !1;
    }
    if (!(y = N[L]))
      return !1;
    var fe = typeof y == "function";
    switch (A = arguments.length) {
      case 1:
        (function(le, Ae, Re) {
          if (Ae)
            le.call(Re);
          else
            for (var Se = le.length, ye = c(le, Se), Oe = 0; Oe < Se; ++Oe)
              ye[Oe].call(Re);
        })(y, fe, this);
        break;
      case 2:
        (function(le, Ae, Re, Se) {
          if (Ae)
            le.call(Re, Se);
          else
            for (var ye = le.length, Oe = c(le, ye), Ue = 0; Ue < ye; ++Ue)
              Oe[Ue].call(Re, Se);
        })(y, fe, this, arguments[1]);
        break;
      case 3:
        (function(le, Ae, Re, Se, ye) {
          if (Ae)
            le.call(Re, Se, ye);
          else
            for (var Oe = le.length, Ue = c(le, Oe), Ve = 0; Ve < Oe; ++Ve)
              Ue[Ve].call(Re, Se, ye);
        })(y, fe, this, arguments[1], arguments[2]);
        break;
      case 4:
        (function(le, Ae, Re, Se, ye, Oe) {
          if (Ae)
            le.call(Re, Se, ye, Oe);
          else
            for (var Ue = le.length, Ve = c(le, Ue), U = 0; U < Ue; ++U)
              Ve[U].call(Re, Se, ye, Oe);
        })(y, fe, this, arguments[1], arguments[2], arguments[3]);
        break;
      default:
        for (k = new Array(A - 1), T = 1; T < A; T++)
          k[T - 1] = arguments[T];
        (function(le, Ae, Re, Se) {
          if (Ae)
            le.apply(Re, Se);
          else
            for (var ye = le.length, Oe = c(le, ye), Ue = 0; Ue < ye; ++Ue)
              Oe[Ue].apply(Re, Se);
        })(y, fe, this, k);
    }
    return !0;
  }, s.prototype.addListener = function(L, R) {
    return l(this, L, R, !1);
  }, s.prototype.on = s.prototype.addListener, s.prototype.prependListener = function(L, R) {
    return l(this, L, R, !0);
  }, s.prototype.once = function(L, R) {
    if (typeof R != "function")
      throw new TypeError('"listener" argument must be a function');
    return this.on(L, u(this, L, R)), this;
  }, s.prototype.prependOnceListener = function(L, R) {
    if (typeof R != "function")
      throw new TypeError('"listener" argument must be a function');
    return this.prependListener(L, u(this, L, R)), this;
  }, s.prototype.removeListener = function(L, R) {
    var y, A, k, T, N;
    if (typeof R != "function")
      throw new TypeError('"listener" argument must be a function');
    if (!(A = this._events))
      return this;
    if (!(y = A[L]))
      return this;
    if (y === R || y.listener && y.listener === R)
      --this._eventsCount == 0 ? this._events = new i() : (delete A[L], A.removeListener && this.emit("removeListener", L, y.listener || R));
    else if (typeof y != "function") {
      for (k = -1, T = y.length; T-- > 0; )
        if (y[T] === R || y[T].listener && y[T].listener === R) {
          N = y[T].listener, k = T;
          break;
        }
      if (k < 0)
        return this;
      if (y.length === 1) {
        if (y[0] = void 0, --this._eventsCount == 0)
          return this._events = new i(), this;
        delete A[L];
      } else
        (function(F, $) {
          for (var re = $, fe = re + 1, le = F.length; fe < le; re += 1, fe += 1)
            F[re] = F[fe];
          F.pop();
        })(y, k);
      A.removeListener && this.emit("removeListener", L, N || R);
    }
    return this;
  }, s.prototype.removeAllListeners = function(L) {
    var R, y;
    if (!(y = this._events))
      return this;
    if (!y.removeListener)
      return arguments.length === 0 ? (this._events = new i(), this._eventsCount = 0) : y[L] && (--this._eventsCount == 0 ? this._events = new i() : delete y[L]), this;
    if (arguments.length === 0) {
      for (var A, k = Object.keys(y), T = 0; T < k.length; ++T)
        (A = k[T]) !== "removeListener" && this.removeAllListeners(A);
      return this.removeAllListeners("removeListener"), this._events = new i(), this._eventsCount = 0, this;
    }
    if (typeof (R = y[L]) == "function")
      this.removeListener(L, R);
    else if (R)
      do
        this.removeListener(L, R[R.length - 1]);
      while (R[0]);
    return this;
  }, s.prototype.listeners = function(L) {
    var R, y = this._events;
    return y && (R = y[L]) ? typeof R == "function" ? [R.listener || R] : function(A) {
      for (var k = new Array(A.length), T = 0; T < k.length; ++T)
        k[T] = A[T].listener || A[T];
      return k;
    }(R) : [];
  }, s.listenerCount = function(L, R) {
    return typeof L.listenerCount == "function" ? L.listenerCount(R) : d.call(L, R);
  }, s.prototype.listenerCount = d, s.prototype.eventNames = function() {
    return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
  };
  var p = "ZipInfo:";
  function h(L) {
    var R;
    return (R = L == null ? void 0 : L.path) === null || R === void 0 ? void 0 : R.startsWith(p);
  }
  function v(L) {
    return typeof L == "string" && L.startsWith(p);
  }
  function f(L, R) {
    return (Array.isArray(L) ? L : [L]).some(function(y) {
      if (typeof y.version != "number")
        throw new Error("file version must be an int number");
      return y.version < R;
    });
  }
  function m(L, R) {
    return L.reduce(function(y, A) {
      return y.then(function(k) {
        return R(k, A);
      }).catch(function() {
        return R(void 0, A);
      });
    }, Promise.resolve(void 0));
  }
  var g, C = function(L) {
    function R() {
      return L !== null && L.apply(this, arguments) || this;
    }
    return n(R, L), R;
  }(s), b = "resource", E = function(L) {
    function R(y) {
      var A = L.call(this) || this;
      if (A.ready = !1, A.openError = !1, A.isEnable()) {
        var k = y || {}, T = k.nameSpaceId, N = k.indexDbVersion;
        A.dbName = function($) {
          return "resource-manager" + ($ ? "-" + $ : "");
        }(T);
        var F = indexedDB.open(A.dbName, N || 1);
        F.addEventListener("error", function() {
          A.openError = !0, A.checkReady(), A.emit("error", new Error("failed to open indexedDB"));
        }), F.addEventListener("success", function() {
          A.db = F.result, A.checkReady();
        }), F.addEventListener("upgradeneeded", function() {
          A.db = F.result, A.handleSuccess();
        }), setTimeout(function() {
          A.checkReady();
        }, 5e3);
      } else
        A.checkReady();
      return A;
    }
    return n(R, L), R.prototype.checkReady = function() {
      this.ready || (this.ready = !0, this.emit("ready"));
    }, R.prototype.handleSuccess = function() {
      if (!this.db.objectStoreNames || this.db.objectStoreNames.length === 0 || !this.db.objectStoreNames.contains(b)) {
        var y = this.db.createObjectStore(b, { keyPath: "path", autoIncrement: !1 });
        y.createIndex("path", "path"), y.createIndex("sourceURL", "sourceURL", { unique: !1 });
      }
    }, R.prototype.createAction = function(y) {
      var A = this.db.transaction([b], y || "readonly");
      return { trans: A, store: A.objectStore(b) };
    }, R.prototype.handleAction = function(y, A) {
      return new Promise(function(k, T) {
        var N = A();
        y.addEventListener("complete", function() {
          k(N.result);
        }), y.addEventListener("error", function() {
          T(y.error || new Error("transaction error"));
        }), y.addEventListener("abort", function() {
          T(y.error || new Error("transaction aborted"));
        });
      });
    }, R.prototype.put = function() {
      for (var y = [], A = 0; A < arguments.length; A++)
        y[A] = arguments[A];
      var k = this.createAction("readwrite"), T = k.trans, N = k.store;
      return this.handleAction(T, function() {
        return N.put.apply(N, y);
      });
    }, R.prototype.getAllKeysFromIndex = function(y) {
      for (var A = [], k = 1; k < arguments.length; k++)
        A[k - 1] = arguments[k];
      if (IDBObjectStore.prototype.getAllKeys) {
        var T = this.createAction(), N = T.trans, F = T.store;
        return this.handleAction(N, function() {
          var $;
          return ($ = F.index(y)).getAllKeys.apply($, A);
        });
      }
      return this.openKeyCursor(y);
    }, R.prototype.getAllFromIndex = function(y) {
      for (var A = [], k = 1; k < arguments.length; k++)
        A[k - 1] = arguments[k];
      var T = this.createAction(), N = T.trans, F = T.store;
      return IDBObjectStore.prototype.getAll ? this.handleAction(N, function() {
        var $;
        return ($ = F.index(y)).getAll.apply($, A);
      }) : this.openCursor(y);
    }, R.prototype.getFromIndex = function(y) {
      for (var A = [], k = 1; k < arguments.length; k++)
        A[k - 1] = arguments[k];
      var T = this.createAction(), N = T.trans, F = T.store;
      return this.handleAction(N, function() {
        var $;
        return ($ = F.index(y)).get.apply($, A);
      });
    }, R.prototype.deleteKey = function() {
      for (var y = [], A = 0; A < arguments.length; A++)
        y[A] = arguments[A];
      var k = this.createAction("readwrite"), T = k.trans, N = k.store;
      return this.handleAction(T, function() {
        return N.delete.apply(N, y);
      });
    }, R.prototype.handleCursorAction = function(y, A, k, T) {
      return new Promise(function(N, F) {
        A.addEventListener("success", function() {
          A.result ? (k(T, A.result), A.result.continue()) : N(T);
        }), A.addEventListener("error", function() {
          F(y.error || new Error("transaction error"));
        });
      });
    }, R.prototype.openKeyCursor = function(y) {
      for (var A, k = [], T = 1; T < arguments.length; T++)
        k[T - 1] = arguments[T];
      var N = this.createAction("readwrite"), F = N.trans, $ = N.store;
      return this.handleCursorAction(F, (A = $.index(y)).openKeyCursor.apply(A, k), function(re, fe) {
        return re.push(fe.key), re;
      }, []);
    }, R.prototype.openCursor = function(y) {
      for (var A, k = [], T = 1; T < arguments.length; T++)
        k[T - 1] = arguments[T];
      var N = this.createAction("readwrite"), F = N.trans, $ = N.store;
      return this.handleCursorAction(F, (A = $.index(y)).openCursor.apply(A, k), function(re, fe) {
        return re.push(fe.value), re;
      }, []);
    }, R.prototype.isEnable = function() {
      return !!window.indexedDB && !this.openError;
    }, R.prototype.saveFile = function(y) {
      return this.db ? this.put(y).then(function() {
        return !0;
      }) : Promise.resolve(!1);
    }, R.prototype.removeFile = function(y) {
      var A = this;
      return this.db ? typeof y == "string" ? this.getAllKeysFromIndex("path").then(function(k) {
        var T = (k || []).filter(function(N) {
          return N === y || N.startsWith("" + y + t.sep);
        });
        return Promise.all(T.map(function(N) {
          return A.deleteKey(N);
        }));
      }).then(function() {
        return !0;
      }) : this.deleteKey(y.path).then(function() {
        return !0;
      }) : Promise.resolve(!1);
    }, R.prototype.clear = function() {
      if (!this.db)
        return Promise.resolve(!1);
      var y = this.createAction("readwrite"), A = y.trans, k = y.store;
      return this.handleAction(A, function() {
        return k.clear();
      }).then(function() {
        return !0;
      });
    }, R.prototype.findFileByPath = function(y) {
      return this.db && y ? this.getFromIndex("path", y) : Promise.resolve(void 0);
    }, R.prototype.findFileBySourceURL = function(y) {
      return this.db && y ? this.getAllFromIndex("sourceURL", y) : Promise.resolve([]);
    }, R.prototype.isDirectory = function(y) {
      var A = this;
      return this.db ? new Promise(function(k) {
        v(y) ? k(!1) : A.getAllKeysFromIndex("path").then(function(T) {
          return (T || []).some(function(N) {
            return N.startsWith("" + y + t.sep);
          });
        }).then(k).catch(function() {
          return k(!1);
        });
      }) : Promise.resolve(!1);
    }, R.prototype.ls = function(y) {
      var A = this;
      return this.db ? this.getAllKeysFromIndex("path").then(function(k) {
        var T = [];
        return Promise.all((k || []).map(function(N) {
          if (v(N))
            return Promise.resolve(void 0);
          if (y) {
            if (N.startsWith("" + y + t.sep)) {
              var F = N.split("" + y + t.sep)[1] || "";
              if (F.includes(t.sep)) {
                var $ = "" + y + t.sep + F.split(t.sep)[0];
                return $ && !T.includes($) ? (T.push($), Promise.resolve($)) : Promise.resolve(void 0);
              }
              return A.getFromIndex("path", N);
            }
            return Promise.resolve(void 0);
          }
          if (N.includes(t.sep)) {
            var re = N.split(t.sep)[0] || "";
            return re && !T.includes(re) ? (T.push(re), Promise.resolve(re)) : Promise.resolve(void 0);
          }
          return A.getFromIndex("path", N);
        })).then(function(N) {
          return N.filter(function(F) {
            return !!F;
          });
        });
      }) : Promise.resolve([]);
    }, R;
  }(C), w = function(L) {
    function R() {
      var y = L !== null && L.apply(this, arguments) || this;
      return y.memoryFiles = [], y;
    }
    return n(R, L), R.prototype.isEnable = function() {
      return !0;
    }, R.prototype.saveFile = function(y) {
      var A = this;
      return new Promise(function(k) {
        A.memoryFiles.some(function(T, N) {
          return T.path === y.path && (A.memoryFiles.splice(N, 1, y), !0);
        }) || A.memoryFiles.push(y), k(!0);
      });
    }, R.prototype.removeFile = function(y) {
      var A = this;
      return new Promise(function(k) {
        for (var T = A.memoryFiles.length - 1; T >= 0; T--) {
          var N = A.memoryFiles[T];
          (typeof y == "string" && (N.path === y || N.path.startsWith("" + y + t.sep)) || y.path === N.path) && A.memoryFiles.splice(T, 1);
        }
        k(!0);
      });
    }, R.prototype.clear = function() {
      var y = this;
      return new Promise(function(A) {
        y.memoryFiles = [], A(!0);
      });
    }, R.prototype.findFileByPath = function(y) {
      var A = this;
      return new Promise(function(k) {
        k(A.memoryFiles.filter(function(T) {
          return T.path === y;
        })[0]);
      });
    }, R.prototype.findFileBySourceURL = function(y) {
      var A = this;
      return new Promise(function(k) {
        k(A.memoryFiles.filter(function(T) {
          return T.sourceURL === y;
        }));
      });
    }, R.prototype.isDirectory = function(y) {
      var A = this;
      return new Promise(function(k) {
        v(y) ? k(!1) : k(A.memoryFiles.some(function(T) {
          return T.path.startsWith("" + y + t.sep);
        }));
      });
    }, R.prototype.ls = function(y) {
      var A = this;
      return new Promise(function(k) {
        var T = [];
        A.memoryFiles.forEach(function(N) {
          if (!h(N))
            if (y) {
              if (N.path.startsWith("" + y + t.sep)) {
                var F = N.path.split("" + y + t.sep)[1] || "";
                if (F.includes(t.sep)) {
                  var $ = "" + y + t.sep + F.split(t.sep)[0];
                  return void ($ && !T.includes($) && T.push($));
                }
                T.push(N);
              }
            } else if (N.path.includes(t.sep)) {
              var re = N.path.split(t.sep)[0] || "";
              re && !T.includes(re) && T.push(re);
            } else
              T.push(N);
        }), k(T);
      });
    }, R;
  }(C), _ = function(L) {
    function R(y) {
      var A = L.call(this) || this;
      if (A.isLocalAvaliable = void 0, A.isEnable()) {
        var k = (y || {}).nameSpaceId;
        A.storageName = function(T) {
          return "resource-manager" + (T ? "-" + T : "");
        }(k);
      }
      return A;
    }
    return n(R, L), R.prototype.isEnable = function() {
      if (this.isLocalAvaliable !== void 0)
        return this.isLocalAvaliable;
      try {
        this.isLocalAvaliable = !0, localStorage.setItem("privateTest", "");
      } catch {
        this.isLocalAvaliable = !1;
      }
      return this.isLocalAvaliable;
    }, R.prototype.saveFile = function(y) {
      var A = this;
      return this.isEnable() ? new Promise(function(k) {
        var T = A.getLocalFile();
        T.some(function(N, F) {
          return N.path === y.path && (T.splice(F, 1, y), !0);
        }) || T.push(y), localStorage.setItem(A.storageName, JSON.stringify(T)), k(!0);
      }) : Promise.resolve(!1);
    }, R.prototype.getLocalFile = function() {
      var y = localStorage.getItem(this.storageName), A = [];
      if (y)
        try {
          A = JSON.parse(y) || "[]";
        } catch (k) {
          console.log(k);
        }
      return A;
    }, R.prototype.removeFile = function(y) {
      var A = this;
      return this.isEnable() ? new Promise(function(k) {
        for (var T = A.getLocalFile(), N = T.length - 1; N >= 0; N--) {
          var F = T[N];
          (typeof y == "string" && (F.path === y || F.path.startsWith("" + y + t.sep)) || y.path === F.path) && T.splice(N, 1);
        }
        localStorage.setItem(A.storageName, JSON.stringify(T)), k(!0);
      }) : Promise.resolve(!1);
    }, R.prototype.clear = function() {
      var y = this;
      return this.isEnable() ? new Promise(function(A) {
        localStorage.removeItem(y.storageName), A(!0);
      }) : Promise.resolve(!1);
    }, R.prototype.findFileByPath = function(y) {
      var A = this;
      return this.isEnable() ? new Promise(function(k) {
        k(A.getLocalFile().filter(function(T) {
          return T.path === y;
        })[0]);
      }) : Promise.resolve(void 0);
    }, R.prototype.findFileBySourceURL = function(y) {
      var A = this;
      return this.isEnable() ? new Promise(function(k) {
        k(A.getLocalFile().filter(function(T) {
          return T.sourceURL === y;
        }));
      }) : Promise.resolve([]);
    }, R.prototype.isDirectory = function(y) {
      var A = this;
      return this.isEnable() ? new Promise(function(k) {
        v(y) ? k(!1) : k(A.getLocalFile().some(function(T) {
          return T.path.startsWith("" + y + t.sep);
        }));
      }) : Promise.resolve(!1);
    }, R.prototype.ls = function(y) {
      var A = this;
      return this.isEnable() ? new Promise(function(k) {
        var T = [];
        A.getLocalFile().forEach(function(N) {
          if (!h(N))
            if (y) {
              if (N.path.startsWith("" + y + t.sep)) {
                var F = N.path.split("" + y + t.sep)[1] || "";
                if (F.includes(t.sep)) {
                  var $ = "" + y + t.sep + F.split(t.sep)[0];
                  return void ($ && !T.includes($) && T.push($));
                }
                T.push(N);
              }
            } else if (N.path.includes(t.sep)) {
              var re = N.path.split(t.sep)[0] || "";
              re && !T.includes(re) && T.push(re);
            } else
              T.push(N);
        }), k(T);
      }) : Promise.resolve([]);
    }, R;
  }(C);
  (g = e.FileStoreEnum || (e.FileStoreEnum = {})).MEMORY = "memoryStore", g.INDEX_DB = "indexedDBStore", g.STORAGE = "storageStore";
  var I = function(L) {
    function R(y) {
      var A = L.call(this) || this;
      return A.indexedDBStore = new E(y), A.memoryStore = new w(), A.storageStore = new _(y), A;
    }
    return n(R, L), R.prototype.saveFile = function(y, A, k) {
      var T = this;
      A === void 0 && (A = !0);
      var N = (k || {}).forceSpecifyStore;
      return (A ? this.findFileByPath(y.path, k) : Promise.resolve(void 0)).then(function(F) {
        if (F != null && F.version && f(y, F.version))
          throw new Error("there is an higher version file existed already");
        var $ = o(o({}, y), { createTime: F && F.createTime || Date.now(), updateTime: Date.now() });
        return N && T[N] && T[N].isEnable() && (N !== e.FileStoreEnum.STORAGE || T.isLocalStorageAvaliable($)) ? T[N].saveFile($) : T[T.saveToTargetStoreRule($)].saveFile($);
      });
    }, R.prototype.isLocalStorageAvaliable = function(y) {
      var A = y.data;
      return t.getDataFormat(A) === "string" && A.length <= 102400 && this.storageStore.isEnable();
    }, R.prototype.saveToTargetStoreRule = function(y) {
      return this.indexedDBStore.isEnable() ? e.FileStoreEnum.INDEX_DB : this.isLocalStorageAvaliable(y) ? e.FileStoreEnum.STORAGE : e.FileStoreEnum.MEMORY;
    }, R.prototype.removeFile = function(y, A) {
      var k = (A || {}).forceSpecifyStore;
      return k && this[k] ? this[k].removeFile(y) : Promise.all([this.indexedDBStore.removeFile(y), this.storageStore.removeFile(y), this.memoryStore.removeFile(y)]).then(function() {
        return !0;
      });
    }, R.prototype.clear = function(y) {
      var A = (y || {}).forceSpecifyStore;
      return A && this[A] ? this[A].clear() : Promise.all([this.indexedDBStore.clear(), this.storageStore.clear(), this.memoryStore.clear()]).then(function() {
        return !0;
      });
    }, R.prototype.findFileByPath = function(y, A) {
      var k = this, T = (A || {}).forceSpecifyStore;
      return T && this[T] ? this[T].findFileByPath(y) : m(this.searchInTargetStoreRule(), function(N, F) {
        return N ? Promise.resolve(N) : k[F].findFileByPath(y);
      });
    }, R.prototype.findFileBySourceURL = function(y, A) {
      var k = this, T = (A || {}).forceSpecifyStore;
      return T && this[T] ? this[T].findFileBySourceURL(y) : m(this.searchInTargetStoreRule(), function(N, F) {
        return k[F].findFileBySourceURL(y).then(function($) {
          return N ? N.filter(function(re) {
            return !$.some(function(fe) {
              return fe.path === re.path;
            });
          }).concat($ || []) : $ || [];
        });
      });
    }, R.prototype.searchInTargetStoreRule = function() {
      return [e.FileStoreEnum.INDEX_DB, e.FileStoreEnum.STORAGE, e.FileStoreEnum.MEMORY];
    }, R.prototype.isDirectory = function(y) {
      var A = this;
      return y ? m(this.searchInTargetStoreRule(), function(k, T) {
        return k ? Promise.resolve(!0) : A[T].isDirectory(y);
      }) : Promise.resolve(!0);
    }, R.prototype.ls = function(y) {
      var A = this;
      return this.isDirectory(y).then(function(k) {
        if (!k)
          throw new Error("path: " + y + " is an invalid directory path");
        return m(A.searchInTargetStoreRule(), function(T, N) {
          return A[N].ls(y).then(function(F) {
            return T ? (F || []).concat(T.filter(function($) {
              return !F.some(function(re) {
                return typeof $ == "string" ? re === $ : typeof re != "string" && re.path === $.path;
              });
            })) : F;
          });
        });
      });
    }, R;
  }(s), D = function(L) {
    function R() {
      return L !== null && L.apply(this, arguments) || this;
    }
    return n(R, L), R;
  }(s), B = function(L) {
    function R(y) {
      var A = L.call(this) || this, k = y || {}, T = k.storeOptions, N = k.downloadManagerOptions;
      return A.downloadManager = new t.IDownloadManager(N), A.store = new I(T), A.store.indexedDBStore.on("ready", function() {
        return A.emit("ready");
      }), A;
    }
    return n(R, L), R.prototype.getFile = function(y, A, k) {
      var T = this, N = new D(), F = Promise.resolve(void 0), $ = A || {}, re = $.downloadOptions, fe = $.forceDownload, le = $.saveRootPath;
      fe ? F = Promise.resolve(void 0) : typeof y == "string" ? F = this.store.findFileByPath(y, k) : y != null && y.sourceURL ? F = this.store.findFileBySourceURL(y.sourceURL) : re && (re.domParams || re.socketParams || re.xhrParams) && (F = this.store.findFileBySourceURL(this.genSourceURL(re)));
      var Ae = null, Re = new Promise(function(Se) {
        Ae = Se;
      });
      return N.getDownloadTask = function() {
        return Re;
      }, F = F.then(function(Se) {
        if (Se && (!Array.isArray(Se) || Se.length)) {
          var ye = Se;
          if (Array.isArray(ye)) {
            var Oe = ye.find(function(Ve) {
              return h(Ve);
            });
            if (!Oe)
              return;
            ye = ye.filter(function(Ve) {
              return !h(Ve);
            });
            var Ue = Oe.data;
            if (typeof Ue != "string" || !JSON.parse(Ue || "[]").every(function(Ve) {
              return ye.some(function(U) {
                return U.path === Ve;
              });
            }))
              return;
          }
          if (!(k != null && k.targetVersion) || !f(ye, k.targetVersion))
            return N.emit("checkExpire", !1), ye;
          N.emit("checkExpire", !0);
        }
      }).then(function(Se) {
        if (!Se && re) {
          var ye = T.downloadManager.download(re);
          return Ae(ye), new Promise(function(Oe, Ue) {
            ye.on("complete", function(Ve) {
              setTimeout(function() {
                var U = Array.isArray(Ve) ? Ve.map(function(P) {
                  var Z = P.data, H = P.path, me = P.extName;
                  return { path: T.genFilePath(le, H), sourceURL: T.genSourceURL(re), data: Z, fileFormat: me || T.getFileFormat(re), version: (k == null ? void 0 : k.targetVersion) || 1 };
                }) : { path: T.genFilePath(le, void 0), sourceURL: T.genSourceURL(re), data: Ve, fileFormat: T.getFileFormat(re), version: (k == null ? void 0 : k.targetVersion) || 1 };
                if (Array.isArray(U) && typeof y == "string" && y) {
                  var j = U.find(function(P) {
                    return P.path === y;
                  });
                  Oe(j || U);
                } else
                  Oe(U);
                N.emit("beforeSet", U), T.beforeWrite(U, k).then(function() {
                  N.emit("afterSet");
                }).catch(function(P) {
                  return N.emit("afterSet", P);
                });
              }, 0);
            }), ye.on("abort", Ue), ye.on("error", Ue), ye.on("timeout", function() {
              return Ue(new Error("download timeout"));
            });
          });
        }
        return Ae(void 0), Se;
      }).catch(function(Se) {
        return Ae(void 0), Promise.reject(Se);
      }), N.getResult = function() {
        return F;
      }, N;
    }, R.prototype.genSourceURL = function(y) {
      var A = y.domParams, k = y.type, T = y.xhrParams;
      if (k === t.DownloaderType.SOCKET)
        return null;
      var N = (k === t.DownloaderType.DOM ? A : T) || {}, F = N.url, $ = F === void 0 ? "" : F, re = N.body;
      return re && Object.keys(re).length ? $ + ($.includes("?") ? "&" : "?") + "downloadBodyParams=" + JSON.stringify(re) : $;
    }, R.prototype.updateFile = function(y, A) {
      return this.saveStore(y, !0, A);
    }, R.prototype.beforeWrite = function(y, A) {
      var k = this;
      return Array.isArray(y) ? Promise.all(y.concat(function(T) {
        var N = T[0].sourceURL || "";
        return { path: "" + p + N, sourceURL: N, data: JSON.stringify(T.map(function(F) {
          return F.path;
        })) };
      }(y)).map(function(T) {
        return k.saveStore(T, !1, A);
      })).then(function(T) {
        return T.filter(function(N) {
          return !h(N);
        });
      }) : this.saveStore(y, !0, A);
    }, R.prototype.getFileFormat = function(y) {
      var A = y || {}, k = A.xhrParams, T = A.domParams, N = A.socketParams, F = A.type;
      return F === t.DownloaderType.DOM && (T != null && T.fileFormat) ? T.fileFormat : F === t.DownloaderType.SOCKET && (N != null && N.fileFormat) ? N.fileFormat : k != null && k.fileFormat ? k.fileFormat : "unknow";
    }, R.prototype.genFilePath = function(y, A) {
      return A ? "" + (y || "") + (y ? t.sep : "") + A : y || "";
    }, R.prototype.saveStore = function(y, A, k) {
      return A === void 0 && (A = !0), this.store.saveFile(y, A, k).then(function(T) {
        if (T)
          return y;
        throw new Error("fail to save file in local store");
      });
    }, R.prototype.remove = function(y, A) {
      return this.store.removeFile(y, A);
    }, R.prototype.clear = function(y) {
      return this.store.clear(y);
    }, R.prototype.list = function(y) {
      return this.store.ls(y);
    }, R.prototype.updateVersion = function(y, A) {
      var k = this;
      return this.store.findFileByPath(y).then(function(T) {
        if (T)
          return k.saveStore(o(o({}, T), { version: A })).then(function() {
          });
        throw new Error("the target path: " + y + " isn't existed");
      });
    }, R.prototype.updateSourceURL = function(y, A) {
      var k = this;
      return this.store.findFileByPath(y).then(function(T) {
        if (T)
          return k.saveStore(o(o({}, T), { sourceURL: A })).then(function() {
          });
        throw new Error("the target path: " + y + " isn't existed");
      });
    }, R;
  }(s);
  e.IResourceManager = B, Object.defineProperty(e, "__esModule", { value: !0 });
}($f.exports, jp), r2($f.exports);
class eA {
  constructor(t) {
    this._cancelError = new Error("request for lock canceled"), this._locked = void 0, this._queue = [], this._waiters = [], this._currentReleaser = void 0, t && (this._cancelError = t), this._locked = !1;
  }
  acquire() {
    const t = this.isLocked(), r = new Promise((n, o) => this._queue.push({ resolve: n, reject: o }));
    return t || this._dispatch(), r;
  }
  async runExclusive(t) {
    const r = await this.acquire();
    try {
      return await t();
    } finally {
      r();
    }
  }
  async waitForUnlock() {
    return this.isLocked() ? new Promise((t) => this._waiters.push({ resolve: t })) : Promise.resolve();
  }
  isLocked() {
    return this._locked;
  }
  release() {
    if (this._currentReleaser) {
      const t = this._currentReleaser;
      this._currentReleaser = void 0, t();
    }
  }
  cancel() {
    this._queue.forEach((t) => t.reject(this._cancelError)), this._queue = [];
  }
  _dispatch() {
    const t = this._queue.shift();
    if (!t)
      return;
    let r = !1;
    this._currentReleaser = () => {
      r || (r = !0, this._locked = !1, this._resolveWaiters(), this._dispatch());
    }, this._locked = !0, t.resolve(this._currentReleaser);
  }
  _resolveWaiters() {
    this._waiters.forEach((t) => t.resolve()), this._waiters = [];
  }
}
function jm(e, t, r) {
  const n = document.createElement("script");
  n.type = "text/javascript", n.readyState ? n.onreadystatechange = () => {
    n.readyState !== "loaded" && n.readyState !== "complete" || (n.onreadystatechange = null, t());
  } : (n.onload = () => {
    t();
  }, n.onerror = () => {
    r();
  }), n.src = e, window.crossOriginIsolated && (n.crossOrigin = "anonymous"), typeof document.body.append == "function" ? document.getElementsByTagName("head")[0].append(n) : document.getElementsByTagName("head")[0].appendChild(n);
}
function tA(e, t) {
  let r = e;
  /^https?:\/\//.test(r) || (r = `https://${e}`);
  try {
    const n = new URL(r);
    if (!t)
      return n.href;
    if (t.hostname)
      return n.hostname;
    if (t.path)
      return n.pathname;
  } catch {
    return "";
  }
  return "";
}
function yu(e) {
  if (e) {
    var t;
    const r = document.getElementById(e);
    r == null || (t = r.parentNode) === null || t === void 0 || t.removeChild(r);
  }
}
let Su = "zoom.us";
const tp = "3.6.0", Qd = `https://dmogdx0jrul3u.cloudfront.net/${tp}/lib/av`, us = `https://source.zoom.us/${tp}/lib/av`, Yd = `https://jssdk.zoomus.cn/${tp}/lib/av`, _r = (e, t, r) => G0([t, r].map((n, o) => {
  if (n !== "initial")
    return ne([n === "success"]);
  {
    const i = o === 0 ? "ENCODE" : "DECODE";
    return Vn(ht(`${e.toUpperCase()}_${i}_SUCCESS`, 1).pipe(ae(() => !0)), ht(`${e.toUpperCase()}_${i}_FAIL`, 1).pipe(ae(() => !1)));
  }
})), Ns = (e) => {
  const t = be(e.value);
  return t ? Je(t) : ht(xu, 1).pipe(Fr(Du), pe(e), ae((r) => {
    let [, n] = r;
    return be(n);
  }));
};
function B2(e, t) {
  var r, n;
  const o = e === "audio" ? (r = t.audio) === null || r === void 0 ? void 0 : r.audioSsrc : (n = t.video) === null || n === void 0 ? void 0 : n.videoSsrc, i = e === "audio" ? lw : qC;
  return e === "audio" && fr() || o ? Promise.resolve() : Te(i);
}
const c0 = () => ne(navigator.mediaDevices.enumerateDevices()).pipe(ae((e) => {
  const t = [], r = [], n = [];
  return e.forEach((o) => {
    const { kind: i, deviceId: s, label: a } = o, l = a.replace(/\([\w,\d]+:[\w,\d]+\)/i, "").trim();
    switch (i) {
      case "audioinput":
        s === "communications" || /ZoomAudioDevice/i.test(l) || /Zoom-\S*/.test(l) || /CubebAggregateDevice\S*/.test(l) || /Microsoft Teams Audio/i.test(l) || t.push({ deviceId: s, label: l });
        break;
      case "audiooutput":
        s === "communications" || /ZoomAudioDevice/i.test(l) || /Microsoft Teams Audio/i.test(l) || r.push({ deviceId: s, label: l });
        break;
      case "videoinput":
        n.push({ deviceId: s, label: l });
    }
  }), { microphones: t, speakers: r, cameras: n };
}));
function Hf(e) {
  const { x: t, y: r, width: n, height: o } = e.getBoundingClientRect();
  return { scaleWidth: n, scaleHeight: o, srcOffsetX: t, srcOffsetY: r };
}
function Xd(e) {
  if (e) {
    let r = e;
    try {
      const n = e.width;
      e.width = n;
    } catch {
      var t;
      r = e.cloneNode(!0), (t = e.parentNode) === null || t === void 0 || t.replaceChild(r, e);
    }
    return r;
  }
  return e;
}
function Ff() {
  try {
    return typeof MessageChannel != "undefined" && new MessageChannel().port1.postMessage(new SharedArrayBuffer(1)), WebAssembly.validate(mO);
  } catch {
    return !1;
  }
}
function ed() {
  var e;
  return (e = WebAssembly) === null || e === void 0 ? void 0 : e.validate(gO);
}
const rA = (() => {
  const e = new eA();
  return { withAudioAction: (t) => function() {
    for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++)
      n[o] = arguments[o];
    return new Promise(async (i, s) => {
      let a = !1;
      const l = setTimeout(() => {
        a = !0, e.release();
      }, 3e4);
      try {
        await e.acquire(), a || clearTimeout(l), i(t(...n));
      } catch (u) {
        a || (clearTimeout(l), s(u));
      }
    });
  }, processAudioAction: (t) => e.acquire().then(() => t()), completeAudioAction: () => {
    e.release();
  }, cancelAllAudioAction: () => {
    e.cancel();
  } };
})();
function rp(e) {
  const t = ["joinComputerAudio", "joinSharingAudio", "leaveComputerAudio", "leaveSharingAudio"];
  return new Proxy(e, { get: (r, n) => typeof n == "string" && t.includes(n) ? function() {
    return rA.withAudioAction(r[n].bind(r))(...arguments);
  } : Reflect.get(r, n) });
}
function zf(e) {
  var t;
  const { browserVersion: r, isChrome: n, isFirefox: o, isAndroidBrowser: i, isSupportMediaStreamTrackProcessor: s, isSupportOffscreenCanvas: a } = ve, l = Number(r == null || (t = r.match(/^\d+/)) === null || t === void 0 ? void 0 : t[0]), u = n && l >= 91, d = o && l >= 89, c = navigator.hardwareConcurrency > 2;
  let p = J0();
  return e && !p && (p = a && s), !i && p && (u || d) && c;
}
const Up = (e, t) => {
  const r = document.createElement("link");
  return r.rel = "preload", r.href = e, r.as = t, r.crossOrigin = "anonymous", r;
}, Bi = (e, t, r) => {
  const n = [], o = [], i = Array.isArray(e) ? e : [e];
  return EC.filter((s) => {
    var a;
    return i.includes(s.category) && (s.tag === t || ((a = s.tag) === null || a === void 0 ? void 0 : a.split(",").includes(t)));
  }).forEach((s) => {
    s.type === "worker" ? n.push(`${r}${s.name}`) : s.type === "wasm" && o.push(`${r}${s.name}`);
  }), { workers: n, wasms: o };
};
function nA(e, t, r) {
  const n = {};
  if (typeof window.SharedArrayBuffer != "function") {
    const { isIOSMobile: o, isSafari: i, isSupportOffscreenCanvas: s, isSupportMediaStreamTrackProcessor: a } = ve;
    Object.assign(n, { enableMultiDecodeVideoWithoutSAB: !!t && (o || i || s && a) }), s && a && Object.assign(n, { enableVirtualBackgroundWithoutSAB: !!r });
  }
  return zf(r) && Object.assign(n, { resourceManager: $f.exports.IResourceManager, file: [{ path: `${e}/vb-resource/dualModel.bin`, type: "bin" }, { path: `${e}/vb-resource/tf.min.js`, type: "js" }] }), n;
}
function oA(e, t) {
  const { media: { isAudioBridgeReceiveReady: r, isAudioBridgeSendReady: n }, audio: { customizeAudioOption: o } } = e, i = t !== void 0 ? t : !(o == null || !o.speakerOnly);
  return G0([r ? ne([!0]) : ht(jw, 1).pipe(tn(!0)), n || i ? ne([!0]) : ht(Uw, 1).pipe(tn(!0))]);
}
function $2(e, t, r) {
  if (e.deviceId === t)
    return !0;
  if (t === "default") {
    const n = r.find((o) => o.deviceId === t);
    if (n)
      return n.label.indexOf(e.label) > -1;
  }
  return !1;
}
function vl(e) {
  return e.find((t) => t.deviceId === "default");
}
const Wf = /* @__PURE__ */ (() => {
  let e, t = !1;
  return { watch: function(r) {
    t = !0, e = r, Promise.race([e, tm(() => !0, 1e4)]).then(() => {
      e = void 0, t = !1;
    }).finally(() => {
      e = void 0, t = !1;
    });
  }, acquire: function() {
    return t && e ? e : Promise.resolve();
  } };
})(), ma = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
  const { socket: { zoomSocketStatus: r, xmppSocketStatus: n, mainSessionSocketStatus: o }, meeting: { meetingStatus: i } } = e, s = [];
  if (i === xt.Joined) {
    var a;
    const l = ke.getInstance(), u = We.createAgent();
    if (((a = be(e)) === null || a === void 0 ? void 0 : a.audio) === et.Computer && l.leaveComputerAudio(), l.disconnect(), Wf.watch(l.destroy()), e.video && (e.video.subscribedVideoList.length > 0 && e.video.subscribedVideoList.forEach((d) => {
      u.unsubscribeVideo(d);
    }), e.video.isCurrentUserStartedVideo && O(ws)), e.share && e.share.isReceiveSharing) {
      const d = e.share.activeNodeId;
      e.share.remoteControlledUserList.length > 0 && e.share.remoteControlledUserList.forEach((c) => {
        u.sharingRequestRemoteControl(c, !1);
      }), u.unsubscribeSharing(d);
    }
  }
  if (t || (xe.clearSession(), [lt.WebclientTk, lt.WebclientZsk, lt.WebclientZtk, lt.WebclientRecordingToken].forEach((l) => {
    sessionStorage.removeItem(l);
  }), ir.destroy()), r !== dt.Closed && s.push(ko()), n !== dt.Closed && s.push(C4()), o !== dt.Closed && s.push(E4()), t) {
    const l = be(e);
    s.push(k1({ audio: l == null ? void 0 : l.audio, muted: l == null ? void 0 : l.muted, video: l == null ? void 0 : l.bVideoOn, isFailover: t }));
  } else
    s.push(k1({ audio: !1, muted: void 0, video: !1, isFailover: t }));
  return s.push(_4(), N4(), Qw(), yE(t), $E(), GE(t), BO(), cI(), NI(), $O(), wI(), UI(), HO(), KI(t), FO(), QI(t), XI(t), om(xt.Closed)), s;
}, td = function(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    r[n - 1] = arguments[n];
  return Te({ event: Mo, operations: [ae((o) => o.find((i) => i.userId === e)), z((o) => !!o), Ge(1)] }, ...r);
}, zO = { [`${vo.AudioBridgeEnable}`]: { mask: 240, action: dC }, [`${vo.AudioDecodeInWorklet}`]: { mask: 15, action: T4 }, [`${vo.VideoFullHD}`]: { mask: 15, action: iI }, [`${vo.VideoShareFullHD}`]: { mask: 15, action: BE }, [`${vo.WebGL2Render}`]: { mask: 15, action: aI }, [`${vo.WebGPURender}`]: { mask: 15, action: lI }, [`${vo.ZMKFromRWG}`]: { mask: 15, action: yC } };
function xs(e) {
  return ks(ae((t, r) => e(t, r)), z((t) => t != null));
}
function iA(e) {
  return ks(G((t, r) => e(t, r) || oe));
}
function Di(e) {
  return ks(G((t, r) => e(t, r)), G((t) => Array.isArray(t) ? ne(t) : Je(t)));
}
const WO = { period: 500, rules: [{ peak: 50, throttle: 300 }, { peak: 60, throttle: 400 }] }, Bp = { [`${gt}`]: () => ({ payloads: { add: [], update: [], remove: [] }, onThrottle(e) {
  e.add && this.payloads.add.push(...e.add), e.update && this.payloads.update.push(...e.update), e.remove && this.payloads.remove.push(...e.remove);
} }) };
function sA() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : WO;
  return (t) => new Vt((r) => {
    const n = /* @__PURE__ */ new Map();
    let o = 0, i = null;
    const { period: s, rules: a } = e;
    let l = null;
    i || (i = ((c, p) => {
      const h = performance.now();
      let v = 0, f = !1;
      return setTimeout(function m() {
        v += p, c();
        const g = performance.now() - h - v, C = setTimeout(m, Math.max(p - g, 0));
        f && clearTimeout(C);
      }, p), () => {
        f = !0;
      };
    })(() => {
      o = 0;
    }, s));
    const u = Object.keys(Bp), d = t.subscribe({ next(c) {
      if (c && c.evt && i !== null) {
        o += 1;
        const { evt: p, body: h } = c, v = String(p);
        if (u.indexOf(v) >= 0)
          if (l) {
            const f = n.get(v);
            if (f)
              f.onThrottle(h);
            else {
              const m = Bp[v]();
              m.onThrottle(h), n.set(v, m);
            }
          } else {
            let f = 0;
            if (a.forEach((m) => {
              o > m.peak && (f = m.throttle);
            }), f > 0) {
              const m = Bp[v]();
              m.onThrottle(h), n.set(v, m), l = setTimeout(() => {
                n.forEach((g, C) => {
                  const b = { evt: Number(C), body: g.payloads };
                  r.next(b);
                }), n.clear(), l = null;
              }, f);
            } else
              r.next(c);
          }
        else
          r.next(c);
      } else
        r.next(c);
    }, error(c) {
      r.error(c);
    }, complete() {
      r.complete();
    } });
    return () => {
      d.unsubscribe(), i && (i(), i = null), o = 0;
    };
  });
}
let H2 = function(e) {
  return e[e.Unknown = 0] = "Unknown", e[e.Windows = 1] = "Windows", e[e.Mac = 2] = "Mac", e[e.Pad = 3] = "Pad", e[e.Mobile = 4] = "Mobile", e[e.CallIn = 5] = "CallIn", e[e.Linux = 6] = "Linux", e[e.WebClient = 7] = "WebClient", e[e.ChromeOs = 8] = "ChromeOs", e;
}({});
const F2 = 262144, z2 = 1048576, rd = (e) => (e & z2) === z2, aA = (e) => {
  let { share: { isReceiveSharing: t } } = e;
  return t;
}, lA = (e) => {
  let { share: { activeNodeId: t } } = e;
  return t;
}, ZO = Mt([ft, aA, lA], function() {
  let e = arguments.length > 2 ? arguments[2] : void 0;
  if (arguments.length > 1 && arguments[1]) {
    const t = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : []).find((r) => r.userId === e && r.sharerOn === !0);
    if (t) {
      let { os: r } = t;
      const { pwaOS: n } = t;
      return n === "mac" ? r = H2.Mac : n === "win" && (r = H2.Windows), { ...t, os: r };
    }
  }
  return null;
}), gs = Mt([ft], (e) => e.filter((t) => t.sharerOn)), uA = Mt([gs], (e) => e.some((t) => !!t.bVideoShare)), rs = Mt([(e) => {
  let { share: { remoteControlledUserList: t } } = e;
  return t;
}, aA, lA], (e, t, r) => !!t && e.some((n) => Xr(n, r)));
var $p, GO = new Uint8Array(16);
function qO() {
  if (!$p && !($p = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto)))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return $p(GO);
}
for (var ar, Tt, p0, Io, KO = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i, Er = [], Hp = 0; Hp < 256; ++Hp)
  Er.push((Hp + 256).toString(16).substr(1));
function h0(e, t, r) {
  var n = (e = e || {}).random || (e.rng || qO)();
  if (n[6] = 15 & n[6] | 64, n[8] = 63 & n[8] | 128, t) {
    r = r || 0;
    for (var o = 0; o < 16; ++o)
      t[r + o] = n[o];
    return t;
  }
  return function(i) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, a = (Er[i[s + 0]] + Er[i[s + 1]] + Er[i[s + 2]] + Er[i[s + 3]] + "-" + Er[i[s + 4]] + Er[i[s + 5]] + "-" + Er[i[s + 6]] + Er[i[s + 7]] + "-" + Er[i[s + 8]] + Er[i[s + 9]] + "-" + Er[i[s + 10]] + Er[i[s + 11]] + Er[i[s + 12]] + Er[i[s + 13]] + Er[i[s + 14]] + Er[i[s + 15]]).toLowerCase();
    if (!function(l) {
      return typeof l == "string" && KO.test(l);
    }(a))
      throw TypeError("Stringified UUID is invalid");
    return a;
  }(n);
}
(function(e) {
  e[e.PLAIN = 0] = "PLAIN", e[e.RSA = 1] = "RSA", e[e.AESGCM256 = 2] = "AESGCM256";
})(ar || (ar = {})), function(e) {
  e[e.info = 0] = "info", e[e.debug = 1] = "debug", e[e.log = 2] = "log", e[e.warn = 3] = "warn", e[e.error = 4] = "error";
}(Tt || (Tt = {})), function(e) {
  e[e.PROTECT_LOCAL_KEY = 0] = "PROTECT_LOCAL_KEY";
}(p0 || (p0 = {})), function(e) {
  e.beforeInit = "beforeInit", e.afterInit = "afterInit", e.beforeLog = "beforeLog", e.hitSizeLimit = "hitSizeLimit", e.afterLog = "afterLog", e.beforeReport = "beforeReport", e.afterReport = "afterReport";
}(Io || (Io = {}));
class Um {
  constructor() {
  }
}
var Fp, Bm = { exports: {} }, Zf = { exports: {} }, JO = v4(Object.freeze({ __proto__: null, default: {} }));
Zf.exports = (Fp = Fp || function(e, t) {
  var r;
  if (typeof window != "undefined" && window.crypto && (r = window.crypto), typeof self != "undefined" && self.crypto && (r = self.crypto), typeof globalThis != "undefined" && globalThis.crypto && (r = globalThis.crypto), !r && typeof window != "undefined" && window.msCrypto && (r = window.msCrypto), !r && fs !== void 0 && fs.crypto && (r = fs.crypto), !r)
    try {
      r = JO;
    } catch {
    }
  var n = function() {
    if (r) {
      if (typeof r.getRandomValues == "function")
        try {
          return r.getRandomValues(new Uint32Array(1))[0];
        } catch {
        }
      if (typeof r.randomBytes == "function")
        try {
          return r.randomBytes(4).readInt32LE();
        } catch {
        }
    }
    throw new Error("Native crypto module could not be used to get secure random number.");
  }, o = Object.create || /* @__PURE__ */ function() {
    function f() {
    }
    return function(m) {
      var g;
      return f.prototype = m, g = new f(), f.prototype = null, g;
    };
  }(), i = {}, s = i.lib = {}, a = s.Base = { extend: function(f) {
    var m = o(this);
    return f && m.mixIn(f), m.hasOwnProperty("init") && this.init !== m.init || (m.init = function() {
      m.$super.init.apply(this, arguments);
    }), m.init.prototype = m, m.$super = this, m;
  }, create: function() {
    var f = this.extend();
    return f.init.apply(f, arguments), f;
  }, init: function() {
  }, mixIn: function(f) {
    for (var m in f)
      f.hasOwnProperty(m) && (this[m] = f[m]);
    f.hasOwnProperty("toString") && (this.toString = f.toString);
  }, clone: function() {
    return this.init.prototype.extend(this);
  } }, l = s.WordArray = a.extend({ init: function(f, m) {
    f = this.words = f || [], this.sigBytes = m != null ? m : 4 * f.length;
  }, toString: function(f) {
    return (f || d).stringify(this);
  }, concat: function(f) {
    var m = this.words, g = f.words, C = this.sigBytes, b = f.sigBytes;
    if (this.clamp(), C % 4)
      for (var E = 0; E < b; E++) {
        var w = g[E >>> 2] >>> 24 - E % 4 * 8 & 255;
        m[C + E >>> 2] |= w << 24 - (C + E) % 4 * 8;
      }
    else
      for (var _ = 0; _ < b; _ += 4)
        m[C + _ >>> 2] = g[_ >>> 2];
    return this.sigBytes += b, this;
  }, clamp: function() {
    var f = this.words, m = this.sigBytes;
    f[m >>> 2] &= 4294967295 << 32 - m % 4 * 8, f.length = e.ceil(m / 4);
  }, clone: function() {
    var f = a.clone.call(this);
    return f.words = this.words.slice(0), f;
  }, random: function(f) {
    for (var m = [], g = 0; g < f; g += 4)
      m.push(n());
    return new l.init(m, f);
  } }), u = i.enc = {}, d = u.Hex = { stringify: function(f) {
    for (var m = f.words, g = f.sigBytes, C = [], b = 0; b < g; b++) {
      var E = m[b >>> 2] >>> 24 - b % 4 * 8 & 255;
      C.push((E >>> 4).toString(16)), C.push((15 & E).toString(16));
    }
    return C.join("");
  }, parse: function(f) {
    for (var m = f.length, g = [], C = 0; C < m; C += 2)
      g[C >>> 3] |= parseInt(f.substr(C, 2), 16) << 24 - C % 8 * 4;
    return new l.init(g, m / 2);
  } }, c = u.Latin1 = { stringify: function(f) {
    for (var m = f.words, g = f.sigBytes, C = [], b = 0; b < g; b++) {
      var E = m[b >>> 2] >>> 24 - b % 4 * 8 & 255;
      C.push(String.fromCharCode(E));
    }
    return C.join("");
  }, parse: function(f) {
    for (var m = f.length, g = [], C = 0; C < m; C++)
      g[C >>> 2] |= (255 & f.charCodeAt(C)) << 24 - C % 4 * 8;
    return new l.init(g, m);
  } }, p = u.Utf8 = { stringify: function(f) {
    try {
      return decodeURIComponent(escape(c.stringify(f)));
    } catch {
      throw new Error("Malformed UTF-8 data");
    }
  }, parse: function(f) {
    return c.parse(unescape(encodeURIComponent(f)));
  } }, h = s.BufferedBlockAlgorithm = a.extend({ reset: function() {
    this._data = new l.init(), this._nDataBytes = 0;
  }, _append: function(f) {
    typeof f == "string" && (f = p.parse(f)), this._data.concat(f), this._nDataBytes += f.sigBytes;
  }, _process: function(f) {
    var m, g = this._data, C = g.words, b = g.sigBytes, E = this.blockSize, w = b / (4 * E), _ = (w = f ? e.ceil(w) : e.max((0 | w) - this._minBufferSize, 0)) * E, I = e.min(4 * _, b);
    if (_) {
      for (var D = 0; D < _; D += E)
        this._doProcessBlock(C, D);
      m = C.splice(0, _), g.sigBytes -= I;
    }
    return new l.init(m, I);
  }, clone: function() {
    var f = a.clone.call(this);
    return f._data = this._data.clone(), f;
  }, _minBufferSize: 0 });
  s.Hasher = h.extend({ cfg: a.extend(), init: function(f) {
    this.cfg = this.cfg.extend(f), this.reset();
  }, reset: function() {
    h.reset.call(this), this._doReset();
  }, update: function(f) {
    return this._append(f), this._process(), this;
  }, finalize: function(f) {
    return f && this._append(f), this._doFinalize();
  }, blockSize: 16, _createHelper: function(f) {
    return function(m, g) {
      return new f.init(g).finalize(m);
    };
  }, _createHmacHelper: function(f) {
    return function(m, g) {
      return new v.HMAC.init(f, g).finalize(m);
    };
  } });
  var v = i.algo = {};
  return i;
}(Math), Fp), Bm.exports = Zf.exports.enc.Utf8;
var $m = { exports: {} };
$m.exports = function(e) {
  return function() {
    var t = e, r = t.lib.WordArray;
    function n(o, i, s) {
      for (var a = [], l = 0, u = 0; u < i; u++)
        if (u % 4) {
          var d = s[o.charCodeAt(u - 1)] << u % 4 * 2 | s[o.charCodeAt(u)] >>> 6 - u % 4 * 2;
          a[l >>> 2] |= d << 24 - l % 4 * 8, l++;
        }
      return r.create(a, l);
    }
    t.enc.Base64 = { stringify: function(o) {
      var i = o.words, s = o.sigBytes, a = this._map;
      o.clamp();
      for (var l = [], u = 0; u < s; u += 3)
        for (var d = (i[u >>> 2] >>> 24 - u % 4 * 8 & 255) << 16 | (i[u + 1 >>> 2] >>> 24 - (u + 1) % 4 * 8 & 255) << 8 | i[u + 2 >>> 2] >>> 24 - (u + 2) % 4 * 8 & 255, c = 0; c < 4 && u + 0.75 * c < s; c++)
          l.push(a.charAt(d >>> 6 * (3 - c) & 63));
      var p = a.charAt(64);
      if (p)
        for (; l.length % 4; )
          l.push(p);
      return l.join("");
    }, parse: function(o) {
      var i = o.length, s = this._map, a = this._reverseMap;
      if (!a) {
        a = this._reverseMap = [];
        for (var l = 0; l < s.length; l++)
          a[s.charCodeAt(l)] = l;
      }
      var u = s.charAt(64);
      if (u) {
        var d = o.indexOf(u);
        d !== -1 && (i = d);
      }
      return n(o, i, a);
    }, _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=" };
  }(), e.enc.Base64;
}(Zf.exports);
var f0 = function(e, t, r, n) {
  return new (r || (r = Promise))(function(o, i) {
    function s(u) {
      try {
        l(n.next(u));
      } catch (d) {
        i(d);
      }
    }
    function a(u) {
      try {
        l(n.throw(u));
      } catch (d) {
        i(d);
      }
    }
    function l(u) {
      var d;
      u.done ? o(u.value) : (d = u.value, d instanceof r ? d : new r(function(c) {
        c(d);
      })).then(s, a);
    }
    l((n = n.apply(e, t || [])).next());
  });
};
const QO = (e) => {
  try {
    const t = $m.exports.parse(e);
    return Bm.exports.stringify(t);
  } catch {
    return e;
  }
}, v0 = (e) => {
  for (var t = e.length, r = e.length - 1; r >= 0; r--) {
    var n = e.charCodeAt(r);
    n > 127 && n <= 2047 ? t++ : n > 2047 && n <= 65535 && (t += 2), n >= 56320 && n <= 57343 && r--;
  }
  return t;
}, dA = () => f0(void 0, void 0, void 0, function* () {
  return yield self.crypto.subtle.generateKey({ name: "AES-GCM", length: 256 }, !0, ["encrypt", "decrypt"]);
}), YO = (e, t, r) => f0(void 0, void 0, void 0, function* () {
  try {
    return yield self.crypto.subtle.encrypt({ name: "AES-GCM", iv: r }, t, e);
  } catch (n) {
    throw n;
  }
}), XO = (e, t) => {
  const r = typeof e == "string" ? function(n) {
    const o = new ArrayBuffer(n.length), i = new Uint8Array(o);
    for (let s = 0, a = n.length; s < a; s++)
      i[s] = n.charCodeAt(s);
    return o;
  }(e) : e;
  return self.crypto.subtle.encrypt({ name: "RSA-OAEP" }, t, r);
}, cA = {}, m0 = (e, t) => {
  cA[t] = e;
}, eT = cA, Hm = (e) => {
  try {
    return JSON.stringify(e);
  } catch {
    return "json stringify failed";
  }
}, tT = (e) => {
  try {
    return JSON.parse(e);
  } catch {
    return e;
  }
}, W2 = (e) => {
  let t = 0;
  return t += v0(e.message), e.tags.forEach((r) => {
    t += v0(r);
  }), t;
};
class rT {
  constructor(t) {
    this.uuid = "randomUUID" in self.crypto ? self.crypto.randomUUID() : "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (p) => (p ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> p / 4).toString(16));
    const { databaseName: r, maxSize: n, publicKey: o, reportUrl: i, plugins: s, idbManager: a, logManager: l, currentSize: u, externalKeys: d, codecWorkerFilePath: c } = t;
    this.databaseName = r, this.maxSize = n, this.publicKey = o != null ? o : "", this.reportUrl = i != null ? i : "", this.plugins = s != null ? s : [], this.idbManager = a, this.logManager = l, this.currentSize = u != null ? u : 0, this.externalKeys = d, this.commonMethods = Object.assign({}, eT);
  }
  getLocalAESGCM256Key() {
    var t;
    return function(r, n, o, i) {
      return new (o || (o = Promise))(function(s, a) {
        function l(c) {
          try {
            d(i.next(c));
          } catch (p) {
            a(p);
          }
        }
        function u(c) {
          try {
            d(i.throw(c));
          } catch (p) {
            a(p);
          }
        }
        function d(c) {
          var p;
          c.done ? s(c.value) : (p = c.value, p instanceof o ? p : new o(function(h) {
            h(p);
          })).then(l, u);
        }
        d((i = i.apply(r, n || [])).next());
      });
    }(this, void 0, void 0, function* () {
      if (this.localAESGCM256Key)
        return this.localAESGCM256Key;
      this.localAESGCM256Key = yield dA();
      const r = this.externalKeys ? (t = this.externalKeys.filter((n) => n.usage === p0.PROTECT_LOCAL_KEY)[0]) === null || t === void 0 ? void 0 : t.key : void 0;
      return yield this.idbManager.saveAESGCM256Key(this.uuid, this.localAESGCM256Key, r), this.localAESGCM256Key;
    });
  }
  updateCurrentSize(t) {
    var r;
    let n = (r = this.currentSize) !== null && r !== void 0 ? r : 0;
    if (t instanceof Map)
      for (const [o, i] of t)
        n += W2(i);
    else
      n += W2(t);
    return this.currentSize = n, n >= this.maxSize;
  }
}
const zp = (...e) => {
  const t = {}, r = [];
  for (const o of e)
    o.forEach((i) => {
      t[i.id] || (t[i.id] = !0, r.push(i));
    });
  const n = /* @__PURE__ */ new Map();
  return r.sort((o, i) => (o == null ? void 0 : o.id) - (i == null ? void 0 : i.id)).forEach((o) => {
    n.set(o.id, o);
  }), n;
}, nd = (e, t) => {
  const r = /* @__PURE__ */ new Map();
  return t.forEach((n) => {
    e(n) && r.set(n.id, n);
  }), r;
};
class nT {
  constructor() {
    this.getStore = () => ({ byTag: Object.assign({}, this.store.byTag), byTime: new Map(this.store.byTime) }), this.pushByTime = (t) => {
      for (const r of t)
        this.store.byTime.set(r.id, r);
    }, this.pushByTag = (t) => {
      t.forEach((r) => {
        const n = r.tags;
        Array.isArray(n) && n.forEach((o) => {
          this.store.byTag[o] || (this.store.byTag[o] = /* @__PURE__ */ new Map()), this.store.byTag[o].set(r.id, r);
        });
      });
    }, this.addLog = (t) => {
      let r = t;
      Array.isArray(t) || (r = [t]), this.pushByTime(r), this.pushByTag(r);
    }, this.syncFromIDB = (t) => function(r, n, o, i) {
      return new (o || (o = Promise))(function(s, a) {
        function l(c) {
          try {
            d(i.next(c));
          } catch (p) {
            a(p);
          }
        }
        function u(c) {
          try {
            d(i.throw(c));
          } catch (p) {
            a(p);
          }
        }
        function d(c) {
          var p;
          c.done ? s(c.value) : (p = c.value, p instanceof o ? p : new o(function(h) {
            h(p);
          })).then(l, u);
        }
        d((i = i.apply(r, n || [])).next());
      });
    }(this, void 0, void 0, function* () {
      const r = yield t.getAllLogs();
      this.addLog(r);
    }), this.reset = () => {
      this.store = { byTag: {}, byTime: /* @__PURE__ */ new Map() };
    }, this.deleteLogs = (t) => {
      for (const r of t) {
        const n = this.store.byTime.get(r);
        if (!n)
          continue;
        const { tags: o } = n;
        for (const i of o)
          this.store.byTag[i].delete(r);
        this.store.byTime.delete(r);
      }
    }, this.filterStore = (t) => {
      const r = ((o, i) => {
        if (!i)
          return o.byTime;
        if (typeof i == "string")
          return o.byTag[i] || /* @__PURE__ */ new Map();
        if (Array.isArray(i)) {
          if (i.every((s) => typeof s == "string"))
            return zp(...i.map((s) => o.byTag[s]).filter((s) => !!s));
        } else {
          if (typeof i == "function")
            return nd(i, o.byTime);
          if (typeof i == "object")
            if (i.tags && i.filter) {
              if (typeof i.tags == "string")
                return nd(i.filter, o.byTag[i.tags]);
              if (Array.isArray(i.tags) && i.tags.every((s) => typeof s == "string"))
                return zp(...i.tags.map((s) => {
                  const a = o.byTag[s];
                  return a ? nd(i.filter, a) : /* @__PURE__ */ new Map();
                }));
            } else {
              if (i.filter)
                return nd(i.filter, o.byTime);
              if (i.tags) {
                if (typeof i == "string")
                  return o.byTag[i] || /* @__PURE__ */ new Map();
                if (Array.isArray(i) && i.every((s) => typeof s == "string"))
                  return zp(...i.map((s) => o.byTag[s]));
              }
            }
          else
            console.error("Wrong filter type");
        }
        return /* @__PURE__ */ new Map();
      })(this.store, t), n = /* @__PURE__ */ new Map();
      for (const [o, i] of r) {
        const s = Object.assign(Object.assign({}, i), { message: tT(QO(i.message)) });
        n.set(o, s);
      }
      return n;
    }, this.store = { byTag: {}, byTime: /* @__PURE__ */ new Map() };
  }
}
function Oi(e, t, r) {
  const n = e.plugins;
  if (!Array.isArray(n))
    return r;
  let o = r;
  return n.forEach((i) => {
    const s = i[t];
    if (typeof s == "function") {
      const a = s(e, o);
      a && (o = a);
    }
  }), o;
}
const pA = (e, t, r, n, o, i = {}) => function(s, a, l, u) {
  return new (l || (l = Promise))(function(d, c) {
    function p(f) {
      try {
        v(u.next(f));
      } catch (m) {
        c(m);
      }
    }
    function h(f) {
      try {
        v(u.throw(f));
      } catch (m) {
        c(m);
      }
    }
    function v(f) {
      var m;
      f.done ? d(f.value) : (m = f.value, m instanceof l ? m : new l(function(g) {
        g(m);
      })).then(p, h);
    }
    v((u = u.apply(s, a || [])).next());
  });
}(void 0, void 0, void 0, function* () {
  const { noCache: s, extraProperties: a = {} } = i, l = ((d, c, p, h, v, f) => {
    const m = Array.isArray(c) ? c : [c], g = Date.now();
    return Object.assign({ message: d, logLevel: p, tags: m, encryptMode: h, timestamp: g, laplaceSessionId: v }, f);
  })(`${t}`, r, n, o, e.uuid, a), u = Oi(e, Io.beforeLog, l);
  if (s)
    Oi(e, Io.afterLog, l);
  else {
    const { idbManager: d, logManager: c } = e, p = yield d.makeNextId();
    u.message = ((v) => {
      try {
        const f = Bm.exports.parse(v);
        return $m.exports.stringify(f);
      } catch {
        return v;
      }
    })(u.message);
    const h = Object.assign(Object.assign({}, u), { id: p });
    e.updateCurrentSize(h) && Oi(e, Io.hitSizeLimit, h), c.addLog(h), yield d.addLog(h), Oi(e, Io.afterLog, h);
  }
});
m0(pA, "commonLog");
const oT = (e) => new Promise((t) => {
  const r = new XMLHttpRequest();
  r.open(e.type || "GET", e.url, !0), r.withCredentials = e.withCredentials, r.onerror = (n) => {
    t({ error: n, report: e.reportItem });
  }, r.onreadystatechange = function() {
    if (r.readyState === 4) {
      const n = r.status;
      t(n >= 200 && n < 300 ? { report: e.reportItem } : { error: `Request failed, status: ${n}, responseText: ${r.responseText}`, report: e.reportItem });
    }
  }, Object.entries(e.headers).forEach(([n, o]) => {
    o && n && r.setRequestHeader(n, o);
  }), r.send(e.data);
}), Gs = (e, t = 2) => {
  let r = `${e}`;
  for (; r.length < t; )
    r = `0${r}`;
  return r;
}, hA = (e) => {
  const t = new Date(e);
  return `${t.getUTCFullYear()}-${Gs(t.getUTCMonth() + 1)}-${Gs(t.getUTCDate())} ${Gs(t.getUTCHours())}:${Gs(t.getUTCMinutes())}:${Gs(t.getUTCSeconds())}.${Gs(t.getUTCMilliseconds(), 3)}`;
}, fA = { version: "000001", flag: "0" }, iT = (e, t) => Array.from(e.values()).reduce((r, n) => {
  const o = ((a, l) => {
    const { message: u, logLevel: d, tags: c, timestamp: p, encryptMode: h, id: v } = a, f = function(g, C) {
      var b = {};
      for (var E in g)
        Object.prototype.hasOwnProperty.call(g, E) && C.indexOf(E) < 0 && (b[E] = g[E]);
      if (g != null && typeof Object.getOwnPropertySymbols == "function") {
        var w = 0;
        for (E = Object.getOwnPropertySymbols(g); w < E.length; w++)
          C.indexOf(E[w]) < 0 && Object.prototype.propertyIsEnumerable.call(g, E[w]) && (b[E[w]] = g[E[w]]);
      }
      return b;
    }(a, ["message", "logLevel", "tags", "timestamp", "encryptMode", "id"]), m = Object.assign(Object.assign({ time: hA(p), logLevel: Tt[d], message: u, tags: c }, l), f);
    return Hm(m);
  })(n, t), i = v0(o), s = r[r.length - 1];
  return s.currentSize + i > 30720 ? r.push({ messages: [o], ids: [n.id], currentSize: i }) : (s.messages.push(o), s.ids.push(n.id), s.currentSize += i), r;
}, [{ messages: [], ids: [], currentSize: 0 }]).filter((r) => r.currentSize > 0).map((r) => ({ messages: r.messages.join(`
`), ids: r.ids, meta: fA })), vA = (e, t, r) => ((n, o, i) => Promise.all(n.map((s) => Object.assign({ url: o || "", type: "POST", withCredentials: !1, headers: {}, data: Hm({ messages: s.messages, meta: s.meta }), reportItem: s }, i)).map(oT)))(e, t.reportUrl, r).then((n) => {
  n.forEach((o) => {
    var i;
    Oi(t, Io.afterReport, { report: o.report, error: (i = o.error) !== null && i !== void 0 ? i : null });
  });
}), mA = (e, t, r) => function(n, o, i, s) {
  return new (i || (i = Promise))(function(a, l) {
    function u(p) {
      try {
        c(s.next(p));
      } catch (h) {
        l(h);
      }
    }
    function d(p) {
      try {
        c(s.throw(p));
      } catch (h) {
        l(h);
      }
    }
    function c(p) {
      var h;
      p.done ? a(p.value) : (h = p.value, h instanceof i ? h : new i(function(v) {
        v(h);
      })).then(u, d);
    }
    c((s = s.apply(n, o || [])).next());
  });
}(void 0, void 0, void 0, function* () {
  const n = e.logManager.filterStore(t);
  if (!n || (n == null ? void 0 : n.size) === 0 || !r)
    return;
  const { xhrOptions: o = {}, additionalContext: i } = r, s = Oi(e, Io.beforeReport, n), a = iT(s, i);
  vA(a, e, o);
});
m0(mA, "commonReport");
var gA = function(e, t, r, n) {
  return new (r || (r = Promise))(function(o, i) {
    function s(u) {
      try {
        l(n.next(u));
      } catch (d) {
        i(d);
      }
    }
    function a(u) {
      try {
        l(n.throw(u));
      } catch (d) {
        i(d);
      }
    }
    function l(u) {
      var d;
      u.done ? o(u.value) : (d = u.value, d instanceof r ? d : new r(function(c) {
        c(d);
      })).then(s, a);
    }
    l((n = n.apply(e, t || [])).next());
  });
};
const yA = (e, t, r) => gA(void 0, void 0, void 0, function* () {
  const { idbManager: n, logManager: o } = e;
  if (Array.isArray(r) && (yield n.deleteLogs(r), o.deleteLogs(r), !t))
    return;
  const i = e.logManager.filterStore(t), s = [];
  for (const [l, u] of i)
    s.push(u.id);
  let a = s;
  Array.isArray(s) || (a = [s]), yield n.deleteLogs(a), o.deleteLogs(a);
}), SA = (e) => gA(void 0, void 0, void 0, function* () {
  const { idbManager: t, logManager: r } = e;
  yield t.reset(), r.reset();
});
function Z2(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Li(e) {
  return new Promise(function(t, r) {
    e.oncomplete = e.onsuccess = function() {
      return t(e.result);
    }, e.onabort = e.onerror = function() {
      return r(e.error);
    };
  });
}
function bA(e, t) {
  var r = indexedDB.open(e);
  r.onupgradeneeded = function() {
    return r.result.createObjectStore(t);
  };
  var n = Li(r);
  return function(o, i) {
    return n.then(function(s) {
      return i(s.transaction(t, o).objectStore(t));
    });
  };
}
var Wp;
function Kl() {
  return Wp || (Wp = bA("keyval-store", "keyval")), Wp;
}
function G2(e) {
  return (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Kl())("readwrite", function(t) {
    return e.forEach(function(r) {
      return t.delete(r);
    }), Li(t.transaction);
  });
}
function sT() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Kl();
  return e("readonly", function(t) {
    if (t.getAll && t.getAllKeys)
      return Promise.all([Li(t.getAllKeys()), Li(t.getAll())]).then(function(n) {
        var o = function(a, l) {
          return function(u) {
            if (Array.isArray(u))
              return u;
          }(a) || function(u, d) {
            var c = u == null ? null : typeof Symbol != "undefined" && u[Symbol.iterator] || u["@@iterator"];
            if (c != null) {
              var p, h, v = [], f = !0, m = !1;
              try {
                for (c = c.call(u); !(f = (p = c.next()).done) && (v.push(p.value), !d || v.length !== d); f = !0)
                  ;
              } catch (g) {
                m = !0, h = g;
              } finally {
                try {
                  f || c.return == null || c.return();
                } finally {
                  if (m)
                    throw h;
                }
              }
              return v;
            }
          }(a, l) || function(u, d) {
            if (u) {
              if (typeof u == "string")
                return Z2(u, d);
              var c = Object.prototype.toString.call(u).slice(8, -1);
              return c === "Object" && u.constructor && (c = u.constructor.name), c === "Map" || c === "Set" ? Array.from(u) : c === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(c) ? Z2(u, d) : void 0;
            }
          }(a, l) || function() {
            throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
          }();
        }(n, 2), i = o[0], s = o[1];
        return i.map(function(a, l) {
          return [a, s[l]];
        });
      });
    var r = [];
    return e("readonly", function(n) {
      return function(o, i) {
        return o.openCursor().onsuccess = function() {
          this.result && (function(s) {
            r.push([s.key, s.value]);
          }(this.result), this.result.continue());
        }, Li(o.transaction);
      }(n).then(function() {
        return r;
      });
    });
  });
}
m0(yA, "commonDelete"), m0(SA, "commonReset");
var aT = function(e, t, r, n) {
  return new (r || (r = Promise))(function(o, i) {
    function s(u) {
      try {
        l(n.next(u));
      } catch (d) {
        i(d);
      }
    }
    function a(u) {
      try {
        l(n.throw(u));
      } catch (d) {
        i(d);
      }
    }
    function l(u) {
      var d;
      u.done ? o(u.value) : (d = u.value, d instanceof r ? d : new r(function(c) {
        c(d);
      })).then(s, a);
    }
    l((n = n.apply(e, t || [])).next());
  });
};
const q2 = { default: { queue: [], isRunning: !1, listeners: [] } }, Fm = (e) => {
  let t = q2[e];
  return t || (t = { queue: [], isRunning: !1, listeners: [] }, q2[e] = t), t;
};
function CA(e) {
  return aT(this, void 0, void 0, function* () {
    const t = Fm(e), { queue: r, listeners: n } = t;
    for (; r.length > 0 && !t.isRunning; ) {
      const o = r.shift();
      t.isRunning = !0;
      try {
        const i = yield o.task();
        o.resolution(i);
      } catch (i) {
        o.rejection(i);
      }
      t.isRunning = !1, CA(e);
    }
    n.length && n.forEach((o) => {
      o();
    });
  });
}
function od(e, t) {
  const r = Fm(t);
  try {
    return new Promise((n, o) => {
      r.queue.push({ task: e, resolution: n, rejection: o }), CA(t);
    });
  } catch (n) {
    return Promise.reject(n);
  }
}
const K2 = (e, t) => {
  Fm(e).listeners.push(t);
};
var un = function(e, t, r, n) {
  return new (r || (r = Promise))(function(o, i) {
    function s(u) {
      try {
        l(n.next(u));
      } catch (d) {
        i(d);
      }
    }
    function a(u) {
      try {
        l(n.throw(u));
      } catch (d) {
        i(d);
      }
    }
    function l(u) {
      var d;
      u.done ? o(u.value) : (d = u.value, d instanceof r ? d : new r(function(c) {
        c(d);
      })).then(s, a);
    }
    l((n = n.apply(e, t || [])).next());
  });
};
const Zp = "change_meta", Gp = "change_log", qs = () => Promise.resolve();
class lT {
  constructor(t) {
    this.waitingForReset = !1, this.resetting = !1, this.isChangingMeta = !1, this.isChangingLog = !1, this.dbFailCount = { read: 0, write: 0 }, this.get = (r) => function(n) {
      return (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Kl())("readonly", function(o) {
        return Li(o.get(n));
      });
    }(r, this.store), this.set = (r, n) => un(this, void 0, void 0, function* () {
      try {
        return !(this.dbFailCount.write > 3) && (yield function(o, i) {
          return (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Kl())("readwrite", function(s) {
            return s.put(i, o), Li(s.transaction);
          });
        }(r, n, this.store));
      } catch (o) {
        o instanceof DOMException && (o && o.name === "QuotaExceededError" ? (yield this.deleteOldLogsForSetNewOne(), yield this.set(r, n)) : this.dbFailCount.write += 1), console.error(o);
      }
    }), this.deleteOldLogsForSetNewOne = () => un(this, void 0, void 0, function* () {
      var r;
      const n = yield this.getAllLogs(), o = [];
      for (let i = 0; i < 13; i++) {
        const s = (r = n[i]) === null || r === void 0 ? void 0 : r.id;
        (s || s === 0) && o.push(`${s}`);
      }
      return G2(o, this.store);
    }), this.adjustMaxId = () => un(this, void 0, void 0, function* () {
      return this.resetting ? qs() : (this.isChangingMeta = !0, yield od(() => un(this, void 0, void 0, function* () {
        var r;
        const n = yield this.getAllLogs(), o = n[n.length - 1], i = (r = o == null ? void 0 : o.id) !== null && r !== void 0 ? r : 0;
        return yield this.set("maxId", i), i;
      }), Zp));
    }), this.makeNextId = () => un(this, void 0, void 0, function* () {
      return this.resetting ? qs() : (this.isChangingMeta = !0, yield od(() => un(this, void 0, void 0, function* () {
        const r = yield this.get("maxId");
        if (!r && r !== 0)
          return yield this.set("maxId", 0), 0;
        const n = r + 1;
        return yield this.set("maxId", n), n;
      }), Zp));
    }), this.addLog = (r) => un(this, void 0, void 0, function* () {
      if (this.resetting)
        return qs();
      this.isChangingLog = !0, yield od(() => un(this, void 0, void 0, function* () {
        const { id: n } = r;
        return this.set(`${n}`, r);
      }), Gp);
    }), this.getAllLogs = () => un(this, void 0, void 0, function* () {
      return (yield sT(this.store)).filter(([r]) => r !== "maxId").sort((r, n) => {
        var o, i;
        return ((o = r[1]) === null || o === void 0 ? void 0 : o.id) - ((i = n[1]) === null || i === void 0 ? void 0 : i.id);
      }).map(([, r]) => r);
    }), this.deleteLogs = (r) => un(this, void 0, void 0, function* () {
      if (this.resetting)
        return qs();
      this.isChangingLog = !0, yield od(() => un(this, void 0, void 0, function* () {
        return G2(r.map((n) => `${n}`), this.store);
      }), Gp), yield this.adjustMaxId();
    }), this.saveAESGCM256Key = (r, n, o) => un(this, void 0, void 0, function* () {
      if (o) {
        const i = yield self.crypto.subtle.exportKey("raw", n), s = yield ((a, l, u) => f0(void 0, void 0, void 0, function* () {
          return new Promise((d, c) => {
            requestAnimationFrame(() => f0(void 0, void 0, void 0, function* () {
              var p;
              const h = (p = l == null ? void 0 : l.algorithm) === null || p === void 0 ? void 0 : p.name;
              let v;
              if (h === "RSA-OAEP" ? v = XO : h === "AES-GCM" && (v = YO), !v)
                throw new Error("Unsupported encrypt key type");
              if (typeof a == "string") {
                const f = new TextEncoder(), m = yield v(f.encode(a), l, u);
                d(m);
              } else {
                const f = yield v(a, l, u);
                d(f);
              }
            }));
          });
        }))(i, o, new Uint8Array(16));
        yield this.set(`aes-gcm-256-${r}`, s);
      } else
        yield this.set(`aes-gcm-256-${r}`, n);
    }), this.reset = () => un(this, void 0, void 0, function* () {
      return this.resetting ? qs() : (this.waitingForReset = !0, this.isChangingLog || this.isChangingMeta ? qs() : (this.resetting = !0, yield function() {
        return (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Kl())("readwrite", function(r) {
          return r.clear(), Li(r.transaction);
        });
      }(this.store), this.resetting = !1, void (this.waitingForReset = !1)));
    }), this.store = bA(t, t + "-store"), K2(Zp, () => {
      if (this.isChangingMeta = !1, this.waitingForReset)
        return this.reset();
    }), K2(Gp, () => {
      if (this.isChangingLog = !1, this.waitingForReset)
        return this.reset();
    });
  }
}
var Ot = function(e, t, r, n) {
  return new (r || (r = Promise))(function(o, i) {
    function s(u) {
      try {
        l(n.next(u));
      } catch (d) {
        i(d);
      }
    }
    function a(u) {
      try {
        l(n.throw(u));
      } catch (d) {
        i(d);
      }
    }
    function l(u) {
      var d;
      u.done ? o(u.value) : (d = u.value, d instanceof r ? d : new r(function(c) {
        c(d);
      })).then(s, a);
    }
    l((n = n.apply(e, t || [])).next());
  });
};
const uT = { databaseName: "laplace-default-db", maxSize: 49283072 };
class Gf {
  constructor(t) {
    this.commonLogWithContext = (n, o, i, s, a) => Ot(this, void 0, void 0, function* () {
      yield pA(this.runtimeMetaManager, n, o, i, s, a);
    }), this.commonReportWithContext = (n, o) => Ot(this, void 0, void 0, function* () {
      yield mA(this.runtimeMetaManager, n, o);
    }), this.commonDeleteWithContext = (n) => Ot(this, void 0, void 0, function* () {
      yield yA(this.runtimeMetaManager, n);
    }), this.resetWithContext = () => Ot(this, void 0, void 0, function* () {
      yield SA(this.runtimeMetaManager);
    }), this.initLocalAESGCM256Key = () => Ot(this, void 0, void 0, function* () {
      return yield dA();
    }), this.doNotUseDirtyGetStore = () => this.runtimeMetaManager.logManager.getStore(), this.log = (n, o, i) => Ot(this, void 0, void 0, function* () {
      yield this.commonLogWithContext(n, o, Tt.log, ar.PLAIN, { extraProperties: i });
    }), this.info = (n, o, i) => Ot(this, void 0, void 0, function* () {
      yield this.commonLogWithContext(n, o, Tt.info, ar.PLAIN, { extraProperties: i });
    }), this.warn = (n, o, i) => Ot(this, void 0, void 0, function* () {
      yield this.commonLogWithContext(n, o, Tt.warn, ar.PLAIN, { extraProperties: i });
    }), this.debug = (n, o, i) => Ot(this, void 0, void 0, function* () {
      yield this.commonLogWithContext(n, o, Tt.debug, ar.PLAIN, { extraProperties: i });
    }), this.error = (n, o, i) => Ot(this, void 0, void 0, function* () {
      yield this.commonLogWithContext(n, o, Tt.error, ar.PLAIN, { extraProperties: i });
    }), this.logWithEncryption = (n, o, i) => Ot(this, void 0, void 0, function* () {
      yield this.commonLogWithContext(n, o, Tt.log, ar.AESGCM256, { extraProperties: i });
    }), this.infoWithEncryption = (n, o, i) => Ot(this, void 0, void 0, function* () {
      yield this.commonLogWithContext(n, o, Tt.info, ar.AESGCM256, { extraProperties: i });
    }), this.debugWithEncryption = (n, o, i) => Ot(this, void 0, void 0, function* () {
      yield this.commonLogWithContext(n, o, Tt.debug, ar.AESGCM256, { extraProperties: i });
    }), this.warnWithEncryption = (n, o, i) => Ot(this, void 0, void 0, function* () {
      yield this.commonLogWithContext(n, o, Tt.warn, ar.AESGCM256, { extraProperties: i });
    }), this.errorWithEncryption = (n, o, i) => Ot(this, void 0, void 0, function* () {
      yield this.commonLogWithContext(n, o, Tt.error, ar.AESGCM256, { extraProperties: i });
    }), this.logWithoutCache = (n, o, i) => Ot(this, void 0, void 0, function* () {
      yield this.commonLogWithContext(n, o, Tt.log, ar.PLAIN, { extraProperties: i, noCache: !0 });
    }), this.infoWithoutCache = (n, o, i) => Ot(this, void 0, void 0, function* () {
      yield this.commonLogWithContext(n, o, Tt.info, ar.PLAIN, { extraProperties: i, noCache: !0 });
    }), this.warnWithoutCache = (n, o, i) => Ot(this, void 0, void 0, function* () {
      yield this.commonLogWithContext(n, o, Tt.warn, ar.PLAIN, { extraProperties: i, noCache: !0 });
    }), this.debugWithoutCache = (n, o, i) => Ot(this, void 0, void 0, function* () {
      yield this.commonLogWithContext(n, o, Tt.debug, ar.PLAIN, { extraProperties: i, noCache: !0 });
    }), this.errorWithoutCache = (n, o, i) => Ot(this, void 0, void 0, function* () {
      yield this.commonLogWithContext(n, o, Tt.error, ar.PLAIN, { extraProperties: i, noCache: !0 });
    }), this.getLogs = (n) => {
      const o = this.runtimeMetaManager.logManager;
      return o ? o.filterStore(n) : /* @__PURE__ */ new Map();
    }, this.report = (...n) => ((o, i, s = {}) => function(a, l, u, d) {
      return new (u || (u = Promise))(function(c, p) {
        function h(m) {
          try {
            f(d.next(m));
          } catch (g) {
            p(g);
          }
        }
        function v(m) {
          try {
            f(d.throw(m));
          } catch (g) {
            p(g);
          }
        }
        function f(m) {
          var g;
          m.done ? c(m.value) : (g = m.value, g instanceof u ? g : new u(function(C) {
            C(g);
          })).then(h, v);
        }
        f((d = d.apply(a, l || [])).next());
      });
    }(void 0, void 0, void 0, function* () {
      var a, l;
      const u = (a = s.sampleRate) !== null && a !== void 0 ? a : 1;
      if (Math.random() > u)
        return;
      if (v0(i) > 30720)
        throw new Error("ERROR: Laplace .report(strMsg) size bigger than 30KB is NOT allowed.");
      const d = Object.assign({ message: Object.assign({ strMsg: i }, s.extraMsg), time: hA(Date.now()) }, s.extraData);
      return !((l = s == null ? void 0 : s.tags) === null || l === void 0) && l.length && (d.tags = s == null ? void 0 : s.tags), vA([{ messages: JSON.stringify(d), meta: fA }], o, s.xhrOptions);
    }))(this.runtimeMetaManager, ...n), this.reportByHttps = (n, o) => Ot(this, void 0, void 0, function* () {
      yield this.commonReportWithContext(n, o);
    }), this.deleteLog = (n) => Ot(this, void 0, void 0, function* () {
      yield this.commonDeleteWithContext(n);
    }), this.deleteAll = () => Ot(this, void 0, void 0, function* () {
      yield this.resetWithContext();
    });
    const { runtimeMetaManager: r } = t;
    this.runtimeMetaManager = r;
  }
}
Gf.init = (e) => Ot(void 0, void 0, void 0, function* () {
  const { databaseName: t = "laplace-default-db" } = e, r = new lT(t), n = new nT(), o = new rT(Object.assign(Object.assign(Object.assign({}, uT), e), { idbManager: r, logManager: n }));
  Oi(o, Io.beforeInit), yield n.syncFromIDB(o.idbManager);
  const i = new Gf({ runtimeMetaManager: o });
  return Oi(o, Io.afterInit), i;
});
class dT extends Um {
  constructor(t) {
    super(), this.config = { verbose: !1 }, this.beforeLog = (r, n) => {
      const { verbose: o } = this.config;
      switch (o && console.log("beforeLog, ", "state: ", n, "meta: ", r), n.logLevel) {
        case Tt.error:
          console.error(n.message);
          break;
        case Tt.warn:
          console.warn(n.message);
          break;
        case Tt.log:
          console.log(n.message);
          break;
        case Tt.debug:
          console.debug(n.message);
          break;
        case Tt.info:
          console.info(n.message);
      }
    }, this.afterLog = (r, n) => {
      const { verbose: o } = this.config;
      o && console.log("afterLog, ", "state: ", n, "meta: ", r);
    }, this.beforeReport = (r, n) => {
      const { verbose: o } = this.config;
      o && console.log("beforeReport, ", "pluginParams: ", n, "meta: ", r);
    }, this.afterReport = (r, n) => {
      const { verbose: o } = this.config;
      o && console.log("afterReport, ", "pluginParams: ", n, "runtimeMetaManager: ", r);
    }, t && (this.config = t);
  }
}
const J2 = (e) => {
  const t = [];
  for (const [r, n] of e)
    t.push(n);
  return t;
};
class cT extends Um {
  constructor(t) {
    super(), this.config = { debug: !1 }, this.debugLog = (r) => {
      const { debug: n } = this.config;
      n && console.log(`[AutoCleanLogPlugin]: ${r}`);
    }, this.afterInit = (r) => {
      const { expireBefore: n } = this.config;
      if (!n)
        return void this.debugLog("early return on beforeInit because expireBefore is falsy");
      const { logManager: o, commonMethods: { commonDelete: i } } = r, s = o.getStore().byTime, a = (typeof n == "function" ? J2(s).filter(n) : J2(s).filter((l) => l.timestamp < n)).map((l) => l.id);
      i(r, void 0, a), this.debugLog(`afterInit, clean log id: ${a}`);
    }, this.afterReport = (r, { report: n, error: o }) => {
      if (o)
        return this.debugLog("error"), void console.error(o);
      const { cleanAfterReport: i } = this.config;
      if (!i)
        return void this.debugLog("early return on afterReport because cleanAfterReport is falsy");
      const { commonMethods: { commonDelete: s } } = r;
      s(r, void 0, n.ids), this.debugLog(`afterReport, clean log id: ${n.ids}`);
    }, t && (this.config = t);
  }
}
var Q2 = "Expected a function", Y2 = NaN, pT = "[object Symbol]", hT = /^\s+|\s+$/g, fT = /^[-+]0x[0-9a-f]+$/i, vT = /^0b[01]+$/i, mT = /^0o[0-7]+$/i, gT = parseInt, yT = typeof fs == "object" && fs && fs.Object === Object && fs, ST = typeof self == "object" && self && self.Object === Object && self, bT = yT || ST || Function("return this")(), CT = Object.prototype.toString, wT = Math.max, ET = Math.min, qp = function() {
  return bT.Date.now();
};
function g0(e) {
  var t = typeof e;
  return !!e && (t == "object" || t == "function");
}
function X2(e) {
  if (typeof e == "number")
    return e;
  if (function(n) {
    return typeof n == "symbol" || /* @__PURE__ */ function(o) {
      return !!o && typeof o == "object";
    }(n) && CT.call(n) == pT;
  }(e))
    return Y2;
  if (g0(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = g0(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = e.replace(hT, "");
  var r = vT.test(e);
  return r || mT.test(e) ? gT(e.slice(2), r ? 2 : 8) : fT.test(e) ? Y2 : +e;
}
var IT = function(e, t, r) {
  var n = !0, o = !0;
  if (typeof e != "function")
    throw new TypeError(Q2);
  return g0(r) && (n = "leading" in r ? !!r.leading : n, o = "trailing" in r ? !!r.trailing : o), function(i, s, a) {
    var l, u, d, c, p, h, v = 0, f = !1, m = !1, g = !0;
    if (typeof i != "function")
      throw new TypeError(Q2);
    function C(I) {
      var D = l, B = u;
      return l = u = void 0, v = I, c = i.apply(B, D);
    }
    function b(I) {
      var D = I - h;
      return h === void 0 || D >= s || D < 0 || m && I - v >= d;
    }
    function E() {
      var I = qp();
      if (b(I))
        return w(I);
      p = setTimeout(E, function(D) {
        var B = s - (D - h);
        return m ? ET(B, d - (D - v)) : B;
      }(I));
    }
    function w(I) {
      return p = void 0, g && l ? C(I) : (l = u = void 0, c);
    }
    function _() {
      var I = qp(), D = b(I);
      if (l = arguments, u = this, h = I, D) {
        if (p === void 0)
          return function(B) {
            return v = B, p = setTimeout(E, s), f ? C(B) : c;
          }(h);
        if (m)
          return p = setTimeout(E, s), C(h);
      }
      return p === void 0 && (p = setTimeout(E, s)), c;
    }
    return s = X2(s) || 0, g0(a) && (f = !!a.leading, d = (m = "maxWait" in a) ? wT(X2(a.maxWait) || 0, s) : d, g = "trailing" in a ? !!a.trailing : g), _.cancel = function() {
      p !== void 0 && clearTimeout(p), v = 0, l = h = u = p = void 0;
    }, _.flush = function() {
      return p === void 0 ? c : w(qp());
    }, _;
  }(e, t, { leading: n, maxWait: t, trailing: o });
};
const AT = ["RESOURCE_ERROR", "JS_ERROR", "UNHANDLED_PROMISE_REJECTION"];
class _T extends Um {
  constructor(t) {
    super(), this.config = { debug: !1, publicTags: [] }, this.errorCount = 0, this.hashErrors = {}, this.runtimeMetaManager = null, this.addPublicTags = (r) => {
      var n;
      return (n = this.config.publicTags) === null || n === void 0 ? void 0 : n.concat(r).filter((o) => o);
    }, this.debugLog = (r) => {
      const { debug: n } = this.config;
      n && console.log("[AutoLogErrorPlugin]:", r);
    }, this.ignore = (r) => {
      var n, o, i, s, a;
      return ((n = this.config) === null || n === void 0 ? void 0 : n.maxErrorCount) !== void 0 && this.errorCount >= ((o = this.config) === null || o === void 0 ? void 0 : o.maxErrorCount) || !!(!((i = this.config) === null || i === void 0) && i.ignoredErrorMsgKeywords) && r && ((a = (s = this.config) === null || s === void 0 ? void 0 : s.ignoredErrorMsgKeywords) === null || a === void 0 ? void 0 : a.some((l) => r == null ? void 0 : r.includes(l)));
    }, this.report = IT(() => {
      if (this.runtimeMetaManager === null)
        return;
      const { autoReport: r } = this.config, { commonMethods: { commonReport: n } } = this.runtimeMetaManager;
      return n(this.runtimeMetaManager, AT, r);
    }, 600, { trailing: !0, leading: !1 }), this.afterInit = (r) => {
      if (this.runtimeMetaManager = r, !self.addEventListener)
        return;
      const { commonMethods: { commonLog: n } } = r, o = (i, s, a) => {
        this.debugLog(a), this.errorCount += 1;
        try {
          return function(l) {
            const u = new TextEncoder().encode(l);
            return crypto.subtle.digest("SHA-1", u).then((d) => Array.from(new Uint8Array(d)).map((c) => c.toString(16).padStart(2, "0")).join(""));
          }(i).then((l) => this.hashErrors[l] ? "dismissed" : (this.hashErrors[l] = !0, n(r, i, this.addPublicTags([].concat(s)), Tt.error, ar.PLAIN, { extraProperties: { messageHash: l } }).then(this.report))).catch(console.error);
        } catch (l) {
          return console.error(l), Promise.resolve(l);
        }
      };
      try {
        self.addEventListener("error", (i) => {
          var s, a, l, u, d, c, p;
          if (!this.ignore(i == null ? void 0 : i.message)) {
            if (i != null && i.target && (!((s = i == null ? void 0 : i.target) === null || s === void 0) && s.src || !((a = i == null ? void 0 : i.target) === null || a === void 0) && a.href)) {
              const h = `Load Resource Error in ${(l = i == null ? void 0 : i.target) === null || l === void 0 ? void 0 : l.tagName} element: ${((u = i == null ? void 0 : i.target) === null || u === void 0 ? void 0 : u.src) || ((d = i == null ? void 0 : i.target) === null || d === void 0 ? void 0 : d.href)}`;
              return o(h, "RESOURCE_ERROR", i);
            }
            {
              const h = `Javascript Runtime Error in ${i == null ? void 0 : i.filename} (${i == null ? void 0 : i.lineno}:${i == null ? void 0 : i.colno}): ${i == null ? void 0 : i.message}
Stack: ${(p = (c = i == null ? void 0 : i.error) === null || c === void 0 ? void 0 : c.stack) !== null && p !== void 0 ? p : i == null ? void 0 : i.stack}`;
              return o(h, "JS_ERROR", i);
            }
          }
        }), self.addEventListener("unhandledrejection", (i) => {
          var s;
          if (this.ignore((s = i == null ? void 0 : i.reason) === null || s === void 0 ? void 0 : s.message))
            return;
          let a;
          const l = i == null ? void 0 : i.reason;
          return a = typeof l == "string" ? `Promise Error: ${l}` : l instanceof Error ? `Promise Error: ${l.message} ${l.name} ${l.stack}` : typeof l == "object" ? `Promise Error with reason: ${Hm(l)}` : `Promise Error with unrecognized reason: ${l}`, o(a, "UNHANDLED_PROMISE_REJECTION", i);
        });
      } catch (i) {
        console.error(i);
      }
      this.debugLog("afterInit, add listener");
    }, t && (this.config = t), this.config.publicTags = [].concat(t == null ? void 0 : t.publicTags);
  }
}
let $i = function(e) {
  return e.DeviceAudioStreamCaptured = "device audio stream captured", e.AudioJoinComplete = "audio join complete", e.AudioLeaveComplete = "audio leave complete", e.SharingAudioStartComplete = "sharing audio start complete", e.SharingAudioStopComplete = "sharing audio stop complete", e.AudioBridgeReconnectStart = "audio bridge reconnect start", e.AudioBridgeReconnectEnd = "audio bridge reconnect end", e;
}({}), Hi = function(e) {
  return e.VBSettingSuccess = "video VB setting success", e.VBSettingFailed = "init video VB failed", e.VBPreloadSuccess = "preload video VB success", e.VBPreloading3S = "preload video VB 3s", e.VBPreloading10S = "preload video VB 10s", e.StartCaptureVideoSuccess = "start capture video success", e.StopCaptureVideoSuccess = "stop capture video success", e;
}({});
function xr(e) {
  return `{E}${e}{/E}`;
}
const RT = { enable: !1, enableReport: !1, gatewayEndPoint: "", logLevel: { debug: !1, log: !1, info: !1, print: !1, warn: !1, error: !1 }, performanceReportRatio: 0.25, trackingCount: 7 }, e7 = ["debug", "log", "info", "print", "warn", "error"], Ks = (e, t) => [...e, ...t].filter((r) => !!r);
class Zr {
  static getInstance() {
    return this.agentInstance || (this.agentInstance = new Zr()), this.agentInstance;
  }
  constructor() {
    var t = this;
    this.laplace = void 0, this.trackingId = void 0, this.logConfig = void 0, this.reportUrl = void 0, this.publicTags = void 0, this.accountId = void 0, this.initConfig = async (r) => {
      let n, o = RT;
      try {
        r.logConfig && (o = JSON.parse(r.logConfig), o.gatewayEndPoint && (this.reportUrl = o.gatewayEndPoint));
        const { enable: l, enableReport: u, reportUrl: d, logLevel: c, encryptKeys: p, trackingId: h, accountId: v } = r;
        if (l !== void 0 && (o = { ...o, enable: !!l }), u !== void 0 && (o = { ...o, enableReport: !!u }), d && (this.reportUrl = d), typeof c == "string") {
          const f = e7.indexOf(c), m = e7.reduce((g, C, b) => b < f ? { ...g, [`${C}`]: !1 } : { ...g, [`${C}`]: !0 }, {});
          o = { ...o, logLevel: m };
        } else
          c !== void 0 && (o = { ...o, logLevel: c });
        if (h && (this.trackingId = h, o = { ...o, enable: !0, enableReport: !0 }), p !== void 0) {
          const f = Array.isArray(p) ? p : [p];
          n = await Promise.all(f.map((m) => function(g) {
            return window.crypto.subtle.importKey("raw", new TextEncoder().encode(g.slice(0, 32)), "AES-GCM", !1, ["encrypt", "decrypt"]);
          }(m).then((g) => ({ usage: p0.PROTECT_LOCAL_KEY, key: g }))));
        }
        v !== void 0 && (this.accountId = v);
      } catch (l) {
        console.error("parse log config error", l);
      }
      const i = (/* @__PURE__ */ new Date()).getTime() - 6048e5, s = o.enableReport && this.reportUrl ? { gzip: !1, encrypt: !1, additionalContext: { trackingId: this.trackingId } } : void 0;
      this.publicTags = ["VideoSDK", this.trackingId];
      const a = [r.debugMode && new dT({ verbose: !1 }), new cT({ debug: !1, cleanAfterReport: !0, expireBefore: i }), new _T({ debug: !1, autoReport: s, ignoredErrorMsgKeywords: ["table index is out of bounds"], maxErrorCount: 223, publicTags: this.accountId ? [...this.publicTags, xr(this.accountId)] : this.publicTags })].filter(Boolean);
      return { laplaceConfig: { databaseName: "ZM-VSDK-LOG-DATABASE", maxSize: 49283072, publicKey: r.logEncryptionPubKey, reportUrl: this.reportUrl, externalKeys: n, plugins: a }, logConfig: o };
    }, this.handleInitLaplaceSuccess = (r, n) => {
      var o;
      this.laplace = r;
      const i = xe.get(M1.VSDKLogTrackingId);
      let s = [];
      try {
        s = JSON.parse(i ? window.atob(i) : "[]");
      } catch {
      }
      ((o = s.length >= (n == null ? void 0 : n.trackingCount)) === null || o === void 0 || o) && s.shift();
      const a = s.reduce((l, u) => ({ ...l, [`${u}`]: !0 }), {});
      r.deleteLog((l) => {
        var u;
        return !((u = l.tags) !== null && u !== void 0 && u.some((d) => a[d]));
      }), s.push(this.trackingId), xe.set(M1.VSDKLogTrackingId, window.btoa(JSON.stringify(s)), qe.LocalStorage);
    }, this.init = async (r) => {
      const { laplaceConfig: n, logConfig: o } = await this.initConfig(r);
      return o.enable ? (this.logConfig = o, Gf.init(n).then((i) => {
        this.handleInitLaplaceSuccess(i, o);
      }).catch((i) => {
        throw { type: Eo, reason: "Logger init failed.", error: i };
      })) : Promise.reject({ type: W, reason: "Logger feature is not enabled." });
    }, this.check = (r) => {
      var n, o;
      return !(!this.checkLaplace() || ((n = this.logConfig) === null || n === void 0 || (o = n.logLevel) === null || o === void 0 || !o[r]) && (console.warn(`Logger ${r} is not enabled.`), 1));
    }, this.log = (r, n, o) => {
      if (this.check("log"))
        try {
          var i;
          return (i = this.laplace.logWithEncryption(r, Ks(n, o))) === null || i === void 0 ? void 0 : i.catch(() => {
          });
        } catch {
          return;
        }
    }, this.warn = (r, n, o) => {
      if (this.check("warn"))
        try {
          var i;
          return (i = this.laplace.warnWithEncryption(r, Ks(n, o))) === null || i === void 0 ? void 0 : i.catch(() => {
          });
        } catch {
          return;
        }
    }, this.info = (r, n, o) => {
      if (this.check("info"))
        try {
          var i;
          return (i = this.laplace.infoWithEncryption(r, Ks(n, o))) === null || i === void 0 ? void 0 : i.catch(() => {
          });
        } catch {
          return;
        }
    }, this.debug = (r, n, o) => {
      if (this.check("debug"))
        try {
          var i;
          return (i = this.laplace.debugWithEncryption(r, Ks(n, o))) === null || i === void 0 ? void 0 : i.catch(() => {
          });
        } catch {
          return;
        }
    }, this.error = (r, n, o) => {
      if (this.check("error"))
        try {
          var i;
          return (i = this.laplace.errorWithEncryption(r, Ks(n, o))) === null || i === void 0 ? void 0 : i.catch(() => {
          });
        } catch {
          return;
        }
    }, this.checkLaplace = () => {
      var r;
      return !((r = this.laplace) === null || r === void 0 || !r.log);
    }, this.makeLogger = (r) => {
      var n;
      const o = Ks((n = this.publicTags) !== null && n !== void 0 ? n : [], r);
      return { log: (i, s) => this.log(i, o, s != null ? s : []), warn: (i, s) => this.warn(i, o, s != null ? s : []), info: (i, s) => this.info(i, o, s != null ? s : []), debug: (i, s) => this.debug(i, o, s != null ? s : []), error: (i, s) => this.error(i, o, s != null ? s : []) };
    }, this.reportToGlobalTracing = (r) => {
      var n;
      return this.checkLaplace() ? (n = this.logConfig) !== null && n !== void 0 && n.enableReport && this.reportUrl ? this.laplace.reportByHttps(r, { gzip: !1, encrypt: !1, xhrOptions: { url: this.reportUrl }, additionalContext: { trackingId: this.trackingId } }) : Promise.reject({ type: W, reason: "Please use getLogs to obtain log data and report by yourself." }) : Promise.reject({ type: W, reason: "Logger has not been enabled or initialized." });
    }, this.report = function(r, n) {
      let o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "warn";
      if (t.checkLaplace() && t.logConfig.enableReport && t.reportUrl) {
        var i, s;
        const a = Array.isArray(n) ? n : [n], l = t.accountId ? [...a, xr(t.accountId)] : a;
        (i = (s = t.makeLogger(l))[`${o}`]) === null || i === void 0 || i.call(s, r).then(() => {
          t.reportToGlobalTracing(a);
        });
      }
    }, this.getLogs = (r, n) => {
      if (!this.checkLaplace())
        return console.warn("Logger has not been enabled or initialized."), [];
      const o = r.getState(), { meeting: { meetingNumber: i, userId: s, userEmail: a, userName: l } } = o, u = { meetingNumber: i, userId: s, userEmail: a, userName: l }, d = this.laplace.getLogs(n), c = [];
      for (const [, p] of d)
        c.push({ ...p, ...u });
      return c;
    }, this.doNotUseDirtyGetStore = () => this.checkLaplace() ? this.laplace.doNotUseDirtyGetStore() : (console.warn("Logger has not been enabled or initialized."), { byTag: {}, byTime: /* @__PURE__ */ new Map() }), this.trackingId = h0();
  }
}
Zr.agentInstance = void 0;
const wA = Zr.getInstance(), EA = [{ type: "MediaMeta", methods: ["sendUserNodeList", "updateUserMediaSN", "updateMediaParams", "subscribeToQos", "unsubscribeFromQos", "sendUserAudioStatus", "destroy", "createMainSessionChannel", "notifySDKMeetingReady"] }, { type: "Audio", methods: ["joinComputerAudio", "leaveComputerAudio", "joinSharingAudio", "leaveSharingAudio", "changeSpeaker", "changeMicrophone", "enableAudioEncode", "pauseOrResumeAudio", "setSharingAudioVolume", "enableShareAudioToBreakoutRoom", "enableAudioDenoise", "enableSyncButtonsOnHeadset", "stopAllIncomingAudio", "preInitAudioBridge", "setAudioCodecMode", "muteOrUnmuteOtherAudio", "adjustOtherAudioVolume", "changeAudioProfile", "unmuteAudio", "muteAudio"] }, { type: "Video", methods: ["startCaptureVideo", "stopCaptureVideo", "renderVideo", "stopRenderVideo", "changeCamera", "updateRenderedVideoCanvasDimension", "adjustRenderedVideoPosition", "mirrorVideo", "enableHardwareAccelerationForVideoDecode", "enableHardwareAccelerationForVideoEncode", "startVirtualBackgroundSetting", "updateVirtualBackgroundImage", "stopVirtualBackgroundSetting", "startMaskSetting", "updateMaskBackgroundImage", "updateMaskClip", "stopMaskSetting", "enableVideoObserver", "prefetchVideoSsrc", "cancelPrefetchVideoSsrc", "setMobileRotateMode", "changeActiveVideoSsrc", "updateVideoHDValue", "updateVideoFullhdValue", "clearVideoCanvas"] }, { type: "Sharing", methods: ["stopDesktopSharing", "startDesktopSharing", "pauseDesktopSharing", "resumeDesktopSharing", "renderSharing", "stopRenderSharing", "switchSharingSource", "ajustmentReceivedSharingCanvas", "changeSharingSecondCamera", "updateRenderedSharingDimension", "addReceivedSharingChannelType", "removeReceivedSharingChannelType", "switchSharingMode", "ajustmentSharingCanvas"] }, { type: "RemoteControl", methods: ["startRemoteControl", "stopRemoteControl", "resendRemoteControlPositionPDU", "updateRemoteControlProperties", "ajustmentReceivedSharingCanvas", "startRemoteControlQRCheck"] }, { type: "LiveTranscription", methods: ["selectLanguageChannelForNewLTT"] }, { type: "RemoteCamera", methods: ["movePTZCamera"] }].reduce((e, t) => {
  const { type: r, methods: n } = t;
  return [...e, ...n.map((o) => ({ name: o, type: r }))];
}, []), OT = EA.map((e) => e.name), TT = function(e) {
  const t = EA.find((i) => i.name === e);
  if (t) {
    const { type: i } = t;
    for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)
      n[o - 1] = arguments[o];
    const s = n == null ? void 0 : n.map((a) => Cc(a));
    wA.makeLogger([i, `${i} Media SDK`]).info(`${e},params:${JSON.stringify(s)}`);
  }
};
function Vr(e) {
  return new Proxy(e, { get: (t, r) => typeof r == "string" && OT.includes(r) ? function() {
    for (var n = arguments.length, o = new Array(n), i = 0; i < n; i++)
      o[i] = arguments[i];
    try {
      Reflect.apply(TT, void 0, [r, ...o]);
    } catch {
    }
    return Reflect.apply(Reflect.get(t, r), t, o);
  } : Reflect.get(t, r) });
}
const ec = Zr.getInstance().makeLogger(["Remote Control"]), kT = Vr(ke.getInstance());
function Ma(e, t, r, n) {
  let { share: { activeNodeId: o, shareQuality: i } } = t;
  const { share: { isReceiveSharingFromMainSession: s } } = t;
  r && (o = r), n !== void 0 && (i = n);
  const a = uA(t);
  e.subscribeSharing(o, i, s, a);
}
class IA {
  constructor() {
    this.checkerSubject = void 0, this.checkerSubscription = void 0;
  }
  startCheck(t) {
    return this.checkerSubject && this.stopCheck(), this.checkerSubject = new xn(), this.checkerSubscription = nr(t).subscribe(this.checkerSubject), this.checkerSubject;
  }
  stopCheck() {
    var t;
    this.checkerSubject && (this.checkerSubject.complete(), (t = this.checkerSubscription) === null || t === void 0 || t.unsubscribe(), this.checkerSubject = void 0);
  }
}
const AA = new IA(), _A = new IA();
function jl() {
  return AA.stopCheck();
}
function qf() {
  return _A.stopCheck();
}
function y0(e, t) {
  jl(), qf();
  const { share: { remoteControllingSsrc: r }, meeting: { userId: n } } = e;
  r && (RA(), t.takeBackRemoteControlPermission(n, r));
}
async function t7(e, t, r, n, o) {
  const { share: { isSDKGrabControl: i, isGrabRemoteControl: s } } = r;
  s || (n.subscribeGrabRemoteControl(e, !0), await gr(ht(Es, 1).pipe(z((l) => !!l))));
  const a = ZO(r);
  a && (i ? (o.resendRemoteControlPositionPDU(), o.updateRemoteControlProperties({ os: a.os, isControllerNow: !0, dimension: t && Hf(t) })) : t && o.startRemoteControl(t, a.os, Hf(t)));
}
function RA() {
  ec.log("qr scanning stop"), kT.startRemoteControlQRCheck(!1);
}
const Bn = We.createAgent(), br = Vr(ke.getInstance()), xo = We.createAgent(), Vo = Vr(ke.getInstance());
function Kn(e) {
  for (var t = arguments.length, r = Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    r[n - 1] = arguments[n];
  throw Error("[Immer] minified error nr: " + e + (r.length ? " " + r.map(function(o) {
    return "'" + o + "'";
  }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function Pa(e) {
  return !!e && !!e[In];
}
function As(e) {
  var t;
  return !!e && (function(r) {
    if (!r || typeof r != "object")
      return !1;
    var n = Object.getPrototypeOf(r);
    if (n === null)
      return !0;
    var o = Object.hasOwnProperty.call(n, "constructor") && n.constructor;
    return o === Object || typeof o == "function" && Function.toString.call(o) === NT;
  }(e) || Array.isArray(e) || !!e[u7] || !!(!((t = e.constructor) === null || t === void 0) && t[u7]) || zm(e) || Wm(e));
}
function bu(e, t, r) {
  r === void 0 && (r = !1), Ka(e) === 0 ? (r ? Object.keys : Jm)(e).forEach(function(n) {
    r && typeof n == "symbol" || t(n, e[n], e);
  }) : e.forEach(function(n, o) {
    return t(o, n, e);
  });
}
function Ka(e) {
  var t = e[In];
  return t ? t.i > 3 ? t.i - 4 : t.i : Array.isArray(e) ? 1 : zm(e) ? 2 : Wm(e) ? 3 : 0;
}
function Kf(e, t) {
  return Ka(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function OA(e, t, r) {
  var n = Ka(e);
  n === 2 ? e.set(t, r) : n === 3 ? (e.delete(t), e.add(r)) : e[t] = r;
}
function zm(e) {
  return DT && e instanceof Map;
}
function Wm(e) {
  return LT && e instanceof Set;
}
function ns(e) {
  return e.o || e.t;
}
function Zm(e) {
  if (Array.isArray(e))
    return Array.prototype.slice.call(e);
  var t = xT(e);
  delete t[In];
  for (var r = Jm(t), n = 0; n < r.length; n++) {
    var o = r[n], i = t[o];
    i.writable === !1 && (i.writable = !0, i.configurable = !0), (i.get || i.set) && (t[o] = { configurable: !0, writable: !0, enumerable: i.enumerable, value: e[o] });
  }
  return Object.create(Object.getPrototypeOf(e), t);
}
function Gm(e, t) {
  return t === void 0 && (t = !1), qm(e) || Pa(e) || !As(e) || (Ka(e) > 1 && (e.set = e.add = e.clear = e.delete = MT), Object.freeze(e), t && bu(e, function(r, n) {
    return Gm(n, !0);
  }, !0)), e;
}
function MT() {
  Kn(2);
}
function qm(e) {
  return e == null || typeof e != "object" || Object.isFrozen(e);
}
function _o(e) {
  var t = VT[e];
  return t || Kn(18, e), t;
}
function r7() {
  return Cu;
}
function Kp(e, t) {
  t && (_o("Patches"), e.u = [], e.s = [], e.v = t);
}
function S0(e) {
  Jf(e), e.p.forEach(PT), e.p = null;
}
function Jf(e) {
  e === Cu && (Cu = e.l);
}
function n7(e) {
  return Cu = { p: [], l: Cu, h: e, m: !0, _: 0 };
}
function PT(e) {
  var t = e[In];
  t.i === 0 || t.i === 1 ? t.j() : t.O = !0;
}
function Jp(e, t) {
  t._ = t.p.length;
  var r = t.p[0], n = e !== void 0 && e !== r;
  return t.h.g || _o("ES5").S(t, e, n), n ? (r[In].P && (S0(t), Kn(4)), As(e) && (e = b0(t, e), t.l || C0(t, e)), t.u && _o("Patches").M(r[In].t, e, t.u, t.s)) : e = b0(t, r, []), S0(t), t.u && t.v(t.u, t.s), e !== TA ? e : void 0;
}
function b0(e, t, r) {
  if (qm(t))
    return t;
  var n = t[In];
  if (!n)
    return bu(t, function(i, s) {
      return o7(e, n, t, i, s, r);
    }, !0), t;
  if (n.A !== e)
    return t;
  if (!n.P)
    return C0(e, n.t, !0), n.t;
  if (!n.I) {
    n.I = !0, n.A._--;
    var o = n.i === 4 || n.i === 5 ? n.o = Zm(n.k) : n.o;
    bu(n.i === 3 ? new Set(o) : o, function(i, s) {
      return o7(e, n, o, i, s, r);
    }), C0(e, o, !1), r && e.u && _o("Patches").R(n, r, e.u, e.s);
  }
  return n.o;
}
function o7(e, t, r, n, o, i) {
  if (Pa(o)) {
    var s = b0(e, o, i && t && t.i !== 3 && !Kf(t.D, n) ? i.concat(n) : void 0);
    if (OA(r, n, s), !Pa(s))
      return;
    e.m = !1;
  }
  if (As(o) && !qm(o)) {
    if (!e.h.F && e._ < 1)
      return;
    b0(e, o), t && t.A.l || C0(e, o);
  }
}
function C0(e, t, r) {
  r === void 0 && (r = !1), e.h.F && e.m && Gm(t, r);
}
function Qp(e, t) {
  var r = e[In];
  return (r ? ns(r) : e)[t];
}
function i7(e, t) {
  if (t in e)
    for (var r = Object.getPrototypeOf(e); r; ) {
      var n = Object.getOwnPropertyDescriptor(r, t);
      if (n)
        return n;
      r = Object.getPrototypeOf(r);
    }
}
function Qf(e) {
  e.P || (e.P = !0, e.l && Qf(e.l));
}
function Yp(e) {
  e.o || (e.o = Zm(e.t));
}
function Yf(e, t, r) {
  var n = zm(t) ? _o("MapSet").N(t, r) : Wm(t) ? _o("MapSet").T(t, r) : e.g ? function(o, i) {
    var s = Array.isArray(o), a = { i: s ? 1 : 0, A: i ? i.A : r7(), P: !1, I: !1, D: {}, l: i, t: o, k: null, o: null, j: null, C: !1 }, l = a, u = Xf;
    s && (l = [a], u = Ul);
    var d = Proxy.revocable(l, u), c = d.revoke, p = d.proxy;
    return a.k = p, a.j = c, p;
  }(t, r) : _o("ES5").J(t, r);
  return (r ? r.A : r7()).p.push(n), n;
}
function s7(e, t) {
  switch (t) {
    case 2:
      return new Map(e);
    case 3:
      return Array.from(e);
  }
  return Zm(e);
}
var a7, Cu, Km = typeof Symbol != "undefined" && typeof Symbol("x") == "symbol", DT = typeof Map != "undefined", LT = typeof Set != "undefined", l7 = typeof Proxy != "undefined" && Proxy.revocable !== void 0 && typeof Reflect != "undefined", TA = Km ? Symbol.for("immer-nothing") : ((a7 = {})["immer-nothing"] = !0, a7), u7 = Km ? Symbol.for("immer-draftable") : "__$immer_draftable", In = Km ? Symbol.for("immer-state") : "__$immer_state", NT = "" + Object.prototype.constructor, Jm = typeof Reflect != "undefined" && Reflect.ownKeys ? Reflect.ownKeys : Object.getOwnPropertySymbols !== void 0 ? function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : Object.getOwnPropertyNames, xT = Object.getOwnPropertyDescriptors || function(e) {
  var t = {};
  return Jm(e).forEach(function(r) {
    t[r] = Object.getOwnPropertyDescriptor(e, r);
  }), t;
}, VT = {}, Xf = { get: function(e, t) {
  if (t === In)
    return e;
  var r = ns(e);
  if (!Kf(r, t))
    return function(o, i, s) {
      var a, l = i7(i, s);
      return l ? "value" in l ? l.value : (a = l.get) === null || a === void 0 ? void 0 : a.call(o.k) : void 0;
    }(e, r, t);
  var n = r[t];
  return e.I || !As(n) ? n : n === Qp(e.t, t) ? (Yp(e), e.o[t] = Yf(e.A.h, n, e)) : n;
}, has: function(e, t) {
  return t in ns(e);
}, ownKeys: function(e) {
  return Reflect.ownKeys(ns(e));
}, set: function(e, t, r) {
  var n = i7(ns(e), t);
  if (n != null && n.set)
    return n.set.call(e.k, r), !0;
  if (!e.P) {
    var o = Qp(ns(e), t), i = o == null ? void 0 : o[In];
    if (i && i.t === r)
      return e.o[t] = r, e.D[t] = !1, !0;
    if (function(s, a) {
      return s === a ? s !== 0 || 1 / s == 1 / a : s != s && a != a;
    }(r, o) && (r !== void 0 || Kf(e.t, t)))
      return !0;
    Yp(e), Qf(e);
  }
  return e.o[t] === r && typeof r != "number" && (r !== void 0 || t in e.o) || (e.o[t] = r, e.D[t] = !0, !0);
}, deleteProperty: function(e, t) {
  return Qp(e.t, t) !== void 0 || t in e.t ? (e.D[t] = !1, Yp(e), Qf(e)) : delete e.D[t], e.o && delete e.o[t], !0;
}, getOwnPropertyDescriptor: function(e, t) {
  var r = ns(e), n = Reflect.getOwnPropertyDescriptor(r, t);
  return n && { writable: !0, configurable: e.i !== 1 || t !== "length", enumerable: n.enumerable, value: r[t] };
}, defineProperty: function() {
  Kn(11);
}, getPrototypeOf: function(e) {
  return Object.getPrototypeOf(e.t);
}, setPrototypeOf: function() {
  Kn(12);
} }, Ul = {};
bu(Xf, function(e, t) {
  Ul[e] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
}), Ul.deleteProperty = function(e, t) {
  return Ul.set.call(this, e, t, void 0);
}, Ul.set = function(e, t, r) {
  return Xf.set.call(this, e[0], t, r, e[0]);
};
var jT = function() {
  function e(r) {
    var n = this;
    this.g = l7, this.F = !0, this.produce = function(o, i, s) {
      if (typeof o == "function" && typeof i != "function") {
        var a = i;
        i = o;
        var l = n;
        return function(f) {
          var m = this;
          f === void 0 && (f = a);
          for (var g = arguments.length, C = Array(g > 1 ? g - 1 : 0), b = 1; b < g; b++)
            C[b - 1] = arguments[b];
          return l.produce(f, function(E) {
            var w;
            return (w = i).call.apply(w, [m, E].concat(C));
          });
        };
      }
      var u;
      if (typeof i != "function" && Kn(6), s !== void 0 && typeof s != "function" && Kn(7), As(o)) {
        var d = n7(n), c = Yf(n, o, void 0), p = !0;
        try {
          u = i(c), p = !1;
        } finally {
          p ? S0(d) : Jf(d);
        }
        return typeof Promise != "undefined" && u instanceof Promise ? u.then(function(f) {
          return Kp(d, s), Jp(f, d);
        }, function(f) {
          throw S0(d), f;
        }) : (Kp(d, s), Jp(u, d));
      }
      if (!o || typeof o != "object") {
        if ((u = i(o)) === void 0 && (u = o), u === TA && (u = void 0), n.F && Gm(u, !0), s) {
          var h = [], v = [];
          _o("Patches").M(o, u, h, v), s(h, v);
        }
        return u;
      }
      Kn(21, o);
    }, this.produceWithPatches = function(o, i) {
      if (typeof o == "function")
        return function(u) {
          for (var d = arguments.length, c = Array(d > 1 ? d - 1 : 0), p = 1; p < d; p++)
            c[p - 1] = arguments[p];
          return n.produceWithPatches(u, function(h) {
            return o.apply(void 0, [h].concat(c));
          });
        };
      var s, a, l = n.produce(o, i, function(u, d) {
        s = u, a = d;
      });
      return typeof Promise != "undefined" && l instanceof Promise ? l.then(function(u) {
        return [u, s, a];
      }) : [l, s, a];
    }, typeof (r == null ? void 0 : r.useProxies) == "boolean" && this.setUseProxies(r.useProxies), typeof (r == null ? void 0 : r.autoFreeze) == "boolean" && this.setAutoFreeze(r.autoFreeze);
  }
  var t = e.prototype;
  return t.createDraft = function(r) {
    As(r) || Kn(8), Pa(r) && (r = function(i) {
      return Pa(i) || Kn(22, i), function s(a) {
        if (!As(a))
          return a;
        var l, u = a[In], d = Ka(a);
        if (u) {
          if (!u.P && (u.i < 4 || !_o("ES5").K(u)))
            return u.t;
          u.I = !0, l = s7(a, d), u.I = !1;
        } else
          l = s7(a, d);
        return bu(l, function(c, p) {
          u && function(h, v) {
            return Ka(h) === 2 ? h.get(v) : h[v];
          }(u.t, c) === p || OA(l, c, s(p));
        }), d === 3 ? new Set(l) : l;
      }(i);
    }(r));
    var n = n7(this), o = Yf(this, r, void 0);
    return o[In].C = !0, Jf(n), o;
  }, t.finishDraft = function(r, n) {
    var o = (r && r[In]).A;
    return Kp(o, n), Jp(void 0, o);
  }, t.setAutoFreeze = function(r) {
    this.F = r;
  }, t.setUseProxies = function(r) {
    r && !l7 && Kn(20), this.g = r;
  }, t.applyPatches = function(r, n) {
    var o;
    for (o = n.length - 1; o >= 0; o--) {
      var i = n[o];
      if (i.path.length === 0 && i.op === "replace") {
        r = i.value;
        break;
      }
    }
    o > -1 && (n = n.slice(o + 1));
    var s = _o("Patches").$;
    return Pa(r) ? s(r, n) : this.produce(r, function(a) {
      return s(a, n);
    });
  }, e;
}(), pn = new jT(), M = pn.produce;
pn.produceWithPatches.bind(pn), pn.setAutoFreeze.bind(pn), pn.setUseProxies.bind(pn), pn.applyPatches.bind(pn), pn.createDraft.bind(pn), pn.finishDraft.bind(pn);
const d7 = { ssrc: 0, status: Fe.End, shareDimension: { width: 0, height: 0 }, receivedShareDimension: { width: 1920, height: 1080, logicWidth: 1920, logicHeight: 1080 }, sharePrivilege: vn.OnlyHost, activeNodeId: 0, activeSsrc: 0, shareQuality: 1, isRemoteSharingActive: !1, isReceiveSharing: !1, isGrabRemoteControl: !1, isSDKGrabControl: !1, isChromeExtensionInstalled: !1, isScreenShareForbidden: !1, isReceiveSharingFromMainSession: !1, isSharingToBreakoutRoom: !1, isSharingWithSecondCamera: !1, secondCameraId: "default", isRequireReadReceipt: !1, capturedEnsuredCanvas: [], renderedEnsuredCanvas: [], remoteControllingSsrc: 0, remoteControlApprovedSsrc: 0, remoteControlAppDownloadUrl: "", remoteControlAppInstallStatus: dr.Unknown, isEnableAutoDeleteRcApp: !1, remoteControlledUserList: [], isRemoteControlEnabled: !1, isFullHDVideoShareEnabled: !1, userSsrcMapping: {}, statistic: { encode: { sample_rate: 0, rtt: 0, jitter: 0, avg_loss: 0, max_loss: 0, width: 0, height: 0, fps: 0, bandwidth: 0, bitrate: 0 }, decode: { sample_rate: 0, rtt: 0, jitter: 0, avg_loss: 0, max_loss: 0, width: 0, height: 0, fps: 0, bandwidth: 0, bitrate: 0 } } }, UT = zr({ [`${Em}`]: M((e, t) => {
  let { payload: r } = t;
  e.sharePrivilege = r;
}), [`${Zc}`]: M((e, t) => {
  let { payload: r } = t;
  e.isRemoteSharingActive = r.bStatus === 1, e.activeNodeId = r.activeNodeID, e.activeSsrc = r.ssrc;
}), [`${Gc}`]: M((e, t) => {
  let { payload: r } = t;
  e.isReceiveSharing = r;
}), [`${OE}`]: M((e, t) => {
  let { payload: r } = t;
  e.isChromeExtensionInstalled = r;
}), [`${TE}`]: M((e, t) => {
  let { payload: r } = t;
  e.shareDimension = { ...r };
}), [`${bn}`]: M((e, t) => {
  let { payload: r } = t;
  e.status = r;
}), [`${kE}`]: M((e, t) => {
  let { payload: r } = t;
  e.ssrc = r;
}), [`${Im}`]: M((e, t) => {
  let { payload: r } = t;
  e.shareQuality = r;
}), [`${yf}`]: M((e, t) => {
  let { payload: r } = t;
  e.receivedShareDimension = { ...r };
}), [`${jE}`]: M((e, t) => {
  let { payload: r } = t;
  e.remoteControlledUserList.includes(r) || e.remoteControlledUserList.push(r);
}), [`${wf}`]: M((e, t) => {
  let { payload: r } = t;
  const n = e.remoteControlledUserList.indexOf(r);
  n >= 0 && e.remoteControlledUserList.splice(n, 1);
}), [`${Fd}`]: M((e, t) => {
  let { payload: r } = t;
  e.isGrabRemoteControl = r, r === !1 && (e.remoteControlViewportDomSelector = void 0);
}), [`${Sf}`]: M((e, t) => {
  let { payload: r } = t;
  e.isSDKGrabControl = r;
}), [`${ME}`]: M((e, t) => {
  let { payload: r } = t;
  e.isReceiveSharingFromMainSession = r;
}), [`${xl}`]: M((e, t) => {
  let { payload: r } = t;
  e.isSharingToBreakoutRoom = r;
}), [`${PE}`]: M((e, t) => {
  let { payload: r } = t;
  e.isSharingWithSecondCamera = r;
}), [`${DE}`]: M((e, t) => {
  let { payload: r } = t;
  e.secondCameraId = r;
}), [`${LE}`]: M((e, t) => {
  let { payload: r } = t;
  e.isRequireReadReceipt = r;
}), [`${qc}`]: M((e, t) => {
  let { payload: r } = t;
  e.isOptimizedForSharedVideo = r;
}), [`${bf}`]: M((e, t) => {
  let { payload: r } = t;
  const { data: { encoding: n, rate: o, ...i } } = r;
  e.statistic.encode = { bitrate: o, ...i };
}), [`${vu}`]: M((e, t) => {
  let { payload: r } = t;
  const { data: { encoding: n, rate: o, ...i } } = r;
  e.statistic.decode = { bitrate: o, ...i };
}), [`${NE}`]: M((e, t) => {
  let { payload: r } = t;
  e.capturedEnsuredCanvas.includes(r) || e.capturedEnsuredCanvas.push(r);
}), [`${xE}`]: M((e, t) => {
  let { payload: r } = t;
  e.renderedEnsuredCanvas.includes(r) || e.renderedEnsuredCanvas.push(r);
}), [`${ql}`]: M((e, t) => {
  let { payload: r } = t;
  e.remoteControllingSsrc = r;
}), [`${Ra}`]: M((e, t) => {
  let { payload: r } = t;
  e.remoteControlApprovedSsrc = r;
}), [`${VE}`]: M((e, t) => {
  let { payload: r } = t;
  e.remoteControlAppDownloadUrl = r;
}), [`${ls}`]: M((e, t) => {
  let { payload: r } = t;
  (e.remoteControlAppInstallStatus !== dr.Installed || dr.Unknown) && (e.remoteControlAppInstallStatus = r);
}), [`${Co}`]: M((e, t) => {
  let { payload: r } = t;
  e.remoteControlAppLaunchSheme = r;
}), [`${Cf}`]: M((e, t) => {
  let { payload: r } = t;
  const { userId: n, ssrc: o } = r;
  Object.assign(e.userSsrcMapping, { [`${n}`]: o });
}), [`${Am}`]: M((e, t) => {
  let { payload: r } = t;
  Object.assign(e, r);
}), [`${UE}`]: M((e, t) => {
  let { payload: r } = t;
  e.remoteControlViewportDomSelector = r;
}), [`${BE}`]: M((e, t) => {
  let { payload: r } = t;
  e.isFullHDVideoShareEnabled = r;
}), [`${$E}`]: () => ({ ...d7 }) }, d7), BT = { remoteControlEpics0: (e) => e.pipe(ge(`${Un}`), ae((t) => {
  const { payload: { meetingOptions: r, rcAutoDelete: n, jwtRc: o, opRc: i } } = t, s = (r == null ? void 0 : r.isRemoteControlEnbaled) && i && o === 1;
  return Am({ isRemoteControlEnabled: s, isEnableAutoDeleteRcApp: n === 1 });
})), remoteControlEpics1: (e, t) => se(e, 16391).pipe(G((r) => {
  const { payload: { body: { bOn: n, sendID: o, receiveID: i } } } = r, { meeting: { userId: s }, share: { status: a, activeNodeId: l, isGrabRemoteControl: u } } = t.value, d = [];
  if (a === Fe.End && d.push(ql(0)), a !== Fe.End)
    if (Xr(s, o))
      if (n) {
        jl(), qf(), a === Fe.Paused && (xo.resumeSharing(), Vo.resumeDesktopSharing(), d.push(bn(Fe.Sharing))), d.push(ql(i));
        const p = ft(t.value).find((h) => Xr(h.userId, i));
        p && d.push(Cf({ userId: p.userId, ssrc: i }));
      } else
        d.push(ql(0));
    else {
      var c;
      const p = (c = ft(t.value)) === null || c === void 0 ? void 0 : c.find((h) => Xr(h.userId, o));
      p && (d.push(Cf({ userId: p.userId, ssrc: o })), O(Iw, { userId: p.userId, displayName: p.displayName, isSharingEntireScreen: Vo.isSharingEntireScreen() }));
    }
  else if (!i || Xr(i, s)) {
    const p = be(t.value);
    if (!Jt(p.userRole) && !ve.isAndroidOrIOSBrowser) {
      const h = o && Xr(l, o);
      n ? (d.push(jE(l)), h && (u || xo.subscribeGrabRemoteControl(l, !0))) : (d.push(wf(l)), h && (u && (xo.subscribeGrabRemoteControl(l, !1), d.push(Fd(!1)), O(Es, !1)), Vo.updateRemoteControlProperties({ isControllerNow: !1 }))), O(jc, n);
    }
  }
  return ne(d);
})), remoteControlEpics2: (e, t) => se(e, 16395).pipe(pe(t), z((r) => {
  let [n, o] = r;
  return n.payload.body.id === o.meeting.userId;
}), ae((r) => {
  let [n] = r;
  const { payload: { body: { bOn: o } } } = n;
  return Vo.updateRemoteControlProperties({ isControllerNow: o }), O(Es, o), Fd(o);
})), remoteControlEpics3: (e) => Pe(e, [X.StartRemoteControlSuccess, X.StartRemoteControlFailed, X.CancelRemoteControlSuccess]).pipe(xs((t) => t.payload.type === X.StartRemoteControlSuccess ? (O(bw), Sf(!0)) : t.payload.type === X.CancelRemoteControlSuccess ? Sf(!1) : void (t.payload.type === X.StartRemoteControlFailed && O(Cw)))), remoteControlEpics4: (e) => Pe(e, [X.RemoteControlCopiedTextNotify, X.RemoteControlPasteTextLengthOverflow]).pipe(he((t) => {
  if (t.payload.type === X.RemoteControlCopiedTextNotify) {
    const { payload: { data: r } } = t;
    O(X1, { content: r.data, x: r.x, y: r.y });
  } else
    O(X1, { error: "length of pasted text is too long" });
}), Ie(oe)), remoteControlEpics5: (e, t) => se(e, 4342).pipe(z((r) => r.payload.body.result === 0), G((r) => {
  const { payload: { body: { downloadUrl: n, ssrc: o, urlScheme: i } } } = r, { share: { remoteControlApprovedSsrc: s, status: a } } = t.value, l = [], { isMacOS: u } = ve;
  if (a !== Fe.End) {
    if (!s || s === o) {
      jl();
      try {
        const v = JSON.parse(n || "{}"), f = u ? v.macDownloadUrl : v.winDownloadUrl;
        l.push(VE(f));
      } catch (v) {
        console.warn("unsupported JSON string", v);
      }
    }
    const d = {};
    u || Object.assign(d, { runAsAdmin: 1 });
    const c = ft(t.value).find((v) => Xr(v.userId, o));
    c && Object.assign(d, { controllerName: kt(c.displayName) }), Object.assign(d, { ssrc: o });
    const { deviceId: p } = Vo.getShareStreamInfo();
    p && Object.assign(d, { DeviceID: p });
    const h = `${i}&${new URLSearchParams(d).toString()}`;
    l.push(Co(h), ls(dr.Unknown)), O(Aw, h);
  }
  return ne(l);
})), remoteControlEpics6: (e) => e.pipe(ge(`${U2}`), G(() => AA.startCheck(1e4).pipe(ae(() => (O(Xi, dr.Unknown), ls(dr.Unknown)))))), remoteControlEpics7: (e, t) => e.pipe(ge(`${Vp}`), z(() => {
  const { share: { remoteControlAppInstallStatus: r } } = t.value;
  return r === dr.Installed;
}), G(() => _A.startCheck(6e4).pipe(G(() => {
  O(Xi, Dc.Unlaunched);
  const { share: { remoteControlApprovedSsrc: r, isEnableAutoDeleteRcApp: n }, meeting: { userId: o } } = t.value, i = [], { isMacOS: s } = ve;
  return r && (xo.remoteControlConsent(Pc.CacheClean, r, o, { ...Vo.getShareStreamInfo(), platform: s ? "mac" : "win" }, n), i.push(Co(""), Ra(0))), ne(i);
})))), remoteControlEpics8: (e, t) => e.pipe(ge(`${Co}`), z((r) => !!r.payload), G((r) => {
  const { payload: n } = r, o = [];
  let i;
  if (n) {
    (function(a) {
      if (!a.startsWith("zoomprc://"))
        return;
      const l = Qo("__ZOOM_SDK_RC_APP_SCHEME_@__");
      let u = document.getElementById(l);
      u || (u = document.createElement("iframe"), u.id = l, u.style.display = "none", document.body.appendChild(u)), u.contentWindow.location.href = a;
    })(n), o.push(Vp());
    const s = performance.now();
    document.hasFocus() ? i = ps(25).pipe(hs(() => {
      const a = performance.now() - s < 500;
      return a || O(Xi, dr.Uninstalled), a && t.value.share.remoteControlAppInstallStatus === dr.Unknown;
    }), ze(() => {
      const a = performance.now() - s, l = [];
      return document.hasFocus() || (a > 75 ? l.push(U2()) : jl(), O(Xi, dr.Installed), l.push(ls(dr.Installed), Vp())), ne(l);
    }), function() {
      for (var a = [], l = 0; l < arguments.length; l++)
        a[l] = arguments[l];
      return function(u) {
        return Ua(u, Je.apply(void 0, To([], ro(a))));
      };
    }(ls(dr.Uninstalled))) : (O(Xi, dr.Unknown), o.push(ls(dr.Unknown)));
  }
  return i ? Kt(i, ne(o)) : ne(o);
})), remoteControlEpics9: (e, t) => se(e, L1).pipe(G(() => (O(Ud, Pp.Ended), y0(t.value, xo), ne([Co(""), Ra(0)])))), remoteControlEpics10: (e, t) => e.pipe(ge(`${bn}`), z((r) => {
  const { share: { remoteControllingSsrc: n, remoteControlApprovedSsrc: o } } = t.value;
  return !(r.payload !== Fe.End || !n && !o);
}), he(() => {
  const { share: { remoteControllingSsrc: r, remoteControlApprovedSsrc: n, isEnableAutoDeleteRcApp: o }, meeting: { userId: i } } = t.value, { isMacOS: s } = ve;
  r && y0(t.value, xo), n !== r && xo.remoteControlConsent(Pc.Decline, n, i, { ...Vo.getShareStreamInfo(), platform: s ? "mac" : "win" }, o);
}), Ie(oe)), remoteControlEpics11: (e, t) => se(e, 16430).pipe(G(() => (jl(), qf(), O(Xi, Dc.Launched), t.value.share.status !== Fe.End && function(r, n) {
  (async function(o) {
    const { media: { assetsPath: i } } = o, s = `${i}/qrscanner.min.js`;
    return "WebQrscanner" in window ? Promise.resolve("") : new Promise((a, l) => {
      ec.log(`load qr scanner script start. url:${s}`), jm(s, () => {
        ec.log("load qr scanner script done."), a("");
      }, l);
    });
  })(r).then(() => {
    ec.log("qr scanning start"), n.startRemoteControlQRCheck(!0);
  });
}(t.value, Vo), ne([Co(""), Ra(0)])))), remoteControlEpics12: (e) => Pe(e, X.CurrentDesktopSharingWidthHeight).pipe(he(() => {
  xo.syncSharedContentMetaWithRcApp(Vo.getShareStreamInfo());
}), Ie(oe)), remoteControlEpics13: (e, t) => Pe(e, X.SendRemoteControlQrCode).pipe(he((r) => {
  const { payload: { data: n } } = r, { share: { status: o } } = t.value;
  o !== Fe.End && Array.isArray(n) && n.length > 0 && n.forEach((i) => {
    i != null && i.startsWith("zrc_") && xo.sendRemoteControlAuth(i);
  });
}), Ie(oe)), remoteControlEpics14: (e) => se(e, 16434).pipe(he((t) => {
  const { payload: { body: { result: r } } } = t;
  r === 0 && (RA(), O(Ud, Pp.Started));
}), Ie(oe)), remoteControlEpics15: (e, t) => se(e, gt).pipe(z((r) => {
  var n, o;
  const { meeting: { userId: i }, share: { remoteControlledUserList: s } } = t.value, { payload: { body: a } } = r;
  return s.length > 0 && (((n = a.update) === null || n === void 0 ? void 0 : n.some((l) => l.id !== i && l.bShareOn === !1)) || ((o = a.remove) === null || o === void 0 ? void 0 : o.some((l) => l.id !== i)));
}), G((r) => {
  var n, o, i, s;
  const { payload: { body: a } } = r, { share: { remoteControlledUserList: l, activeNodeId: u, isGrabRemoteControl: d }, meeting: { userId: c } } = t.value, p = ((n = (o = a.update) === null || o === void 0 ? void 0 : o.filter((v) => v.id !== c && v.bShareOn === !1)) !== null && n !== void 0 ? n : []).concat((i = (s = a.remove) === null || s === void 0 ? void 0 : s.filter((v) => v.id !== c)) !== null && i !== void 0 ? i : []), h = [];
  return l.forEach((v) => {
    p.find((f) => f.id === v) && (h.push(wf(v)), v === u && d && (h.push(Fd(!1)), O(Es, !1)));
  }), ne(h);
})), remoteControlEpics16: (e, t) => e.pipe(ge(`${Tr}`), he(() => {
  const { share: { remoteControllingSsrc: r, status: n } } = t.value;
  n === Fe.Sharing && r && O(Ud, Pp.Ended);
}), Ie(oe)) }, $T = { epics0: (e, t) => se(e, En).pipe(z((r) => {
  var n;
  return ((n = r.payload.body) === null || n === void 0 ? void 0 : n.lockShare) !== void 0;
}), pe(t), he((r) => {
  let [n, o] = r;
  const { share: { sharePrivilege: i } } = o, { payload: { body: { lockShare: s } } } = n;
  i !== s && O(ww, s);
}), ae((r) => {
  let [n] = r;
  return Em(n.payload.body.lockShare);
})), epics1: (e) => se(e, 20227).pipe(ae((t) => kE(t.payload.body.ssrc))), epics2: (e, t) => se(e, P1).pipe(pe(t), z((r) => {
  let [n, o] = r;
  const { payload: { body: i } } = n, { share: { isReceiveSharingFromMainSession: s } } = o;
  return !s || s && i.fromMainSession;
}), ae((r) => {
  let [n, o] = r;
  const { share: { isReceiveSharing: i, activeNodeId: s, isReceiveSharingFromMainSession: a }, breakoutRoom: l } = o, { payload: { body: u } } = n;
  if (i && u.bStatus === 1) {
    let d = !1;
    (l == null ? void 0 : l.currentRoom.status) === Ee.InRoom && l.mainSessionAttendeeList.length > 0 && (d = l.mainSessionAttendeeList.findIndex((c) => c.userId === s) > -1), Bn.unsubscribeSharing(s, d), Ma(Bn, o, u.activeNodeID), br.switchSharingSource(u.ssrc, a), O(Vc, { userId: u.activeNodeID });
  } else if (u.bStatus === 1) {
    const d = { activeUserId: u.activeNodeID, isActive: !0 };
    a && Object.assign(d, { isFromMainSession: !0 }), O(Q1, d);
  } else if (i) {
    const d = { activeUserId: u.activeNodeID, isActive: !1 };
    a && Object.assign(d, { isFromMainSession: !0 }), O(Q1, d);
  }
  return Zc(u);
})), epics3: (e) => Pe(e, X.CheckChromeSharingExtensionResponse).pipe(ae((t) => (O(Y1, t.payload.data), OE(t.payload.data)))), epics4: (e, t) => Pe(e, [X.SharingDesktopStreamHaveAudio, X.SharingDesktopStreamHaveNoAudio]).pipe(z((r) => r.payload.type !== X.SharingDesktopStreamHaveAudio || !t.value.audio.secondaryAudioMicrophoneId), pe(t), ae((r) => {
  let [n, o] = r;
  const { meeting: { userId: i }, share: { isSharingToBreakoutRoom: s, isOptimizedForSharedVideo: a } } = o, { payload: { type: l } } = n, u = l === X.SharingDesktopStreamHaveAudio;
  return Bn.startSharing(i, { bShareToBO: s, bShareAudio: u, bShareVideo: !!a }), br.switchSharingMode(a ? Zl.VideoMode : Zl.Normal), j2(!1);
})), epics5: (e) => Pe(e, [X.DesktopSharingError, X.DesktopSharingChromeExtensionUninstalled, X.DesktopSharingPermissionDenied, X.DesktopSharingSystemError]).pipe(G((t) => {
  const r = [];
  let n = "";
  return [X.DesktopSharingPermissionDenied, X.DesktopSharingSystemError].includes(t.payload.type) && (r.push(j2(!0)), t.payload.type === X.DesktopSharingSystemError ? ve.isMacOS && (n = "To use screen share on Chrome, please allow screen recording access in system setting.") : n = "To use screen share, please allow the permission request."), O(hw, { reason: n }), ne(r);
})), epics6: (e) => Pe(e, X.CurrentDesktopSharingWidthHeight).pipe(z((t) => !!t.payload.data), ae((t) => {
  O(fw, t.payload.data);
  const { payload: { data: { width: r, height: n } } } = t;
  return br.ajustmentSharingCanvas(r, n), TE(t.payload.data);
})), epics7: (e, t) => Pe(e, X.SharingDecodeMaxSize).pipe(z((r) => !!r.payload.data), pe(t), xs((r) => {
  let [n, o] = r;
  const { share: { shareQuality: i, activeNodeId: s } } = o, { payload: { data: { fps: a } } } = n, l = Number(a);
  if (i !== l)
    return Ma(Bn, o, s, l), Im(l);
})), epics8: (e) => se(e, 20226).pipe(he((t) => {
  var r, n;
  if (O(xc, (r = t.payload) === null || r === void 0 ? void 0 : r.body), (n = t.payload) !== null && n !== void 0 && n.body) {
    const { payload: { body: { width: o, height: i } } } = t;
    br.ajustmentReceivedSharingCanvas(o, i);
  }
}), ae((t) => yf(t.payload.body))), epics9: (e) => Pe(e, X.SharingPara).pipe(he((t) => {
  var r, n;
  if (O(xc, (r = t.payload.data) === null || r === void 0 ? void 0 : r.body), (n = t.payload.data) !== null && n !== void 0 && n.body) {
    const { payload: { data: { body: { width: o, height: i } } } } = t;
    br.ajustmentReceivedSharingCanvas(o, i);
  }
}), ae((t) => {
  var r;
  return yf((r = t.payload.data) === null || r === void 0 ? void 0 : r.body);
})), epics10: (e, t) => Pe(e, X.UserStopDesktopSharing).pipe(pe(t), ae((r) => {
  let [, n] = r;
  const { meeting: { userId: o }, share: { status: i } } = n;
  return i !== Fe.End && (Bn.stopSharing(o), br.stopDesktopSharing(), O(vw)), bn(Fe.End);
})), epics11: (e, t) => se(e, gt).pipe(pe(t), z((r) => {
  let [n, o] = r;
  const { meeting: { userId: i } } = o, s = n.payload.body.update;
  return s && s.length > 0 && s.findIndex((a) => a.id === i && a.bShareOn !== void 0) > -1;
}), G((r) => {
  let [n, o] = r;
  const { meeting: { userId: i }, share: { status: s, isReceiveSharing: a, activeNodeId: l } } = o, { payload: { body: { update: u } } } = n, d = u.find((h) => h.id === i && h.bShareOn === !1), c = u.find((h) => h.id === i && h.bShareOn === !0), p = [];
  return d && s !== Fe.End && (Bn.stopSharing(i), br.stopDesktopSharing(), p.push(bn(Fe.End)), O(mw)), c && s === Fe.End && (a && (br.stopRenderSharing(), Bn.unsubscribeSharing(l), p.push(Gc(!1))), p.push(bn(Fe.Sharing))), ne(p);
})), epics12: (e, t) => se(e, gt).pipe(pe(t), z((r) => {
  let [n, o] = r;
  const { meeting: { userId: i } } = o, s = n.payload.body.update;
  return s && s.length > 0 && s.findIndex((a) => a.id !== i && a.bShareOn !== void 0) > -1;
}), G((r) => {
  let [n, o] = r;
  const { payload: { body: { update: i } } } = n, { share: { activeNodeId: s, isReceiveSharing: a } } = o, l = gs(o), u = i.filter((p) => p.bShareOn === !0 && p.bSharePause === !1), d = i.filter((p) => p.bShareOn === !0 && p.bSharePause === !0), c = i.filter((p) => p.bShareOn === !1);
  return u.length > 0 && u.forEach((p) => {
    l.findIndex((h) => h.userId === p.id) === -1 ? O(fm, p) : O(Sw, p);
  }), d.length > 0 && d.forEach((p) => {
    O(yw, p);
  }), c.length > 0 && (c.forEach((p) => {
    O(vm, p);
  }), a && c.some((p) => p.id === s)) ? Vn(se(e, P1).pipe(Ge(1), Ie(oe)), nr(50).pipe(Ie(cs("timeout")))).pipe(Xn(() => {
    const { share: { activeNodeId: p, isReceiveSharingFromMainSession: h }, audio: v } = t.value, f = l.filter((m) => m.userId !== p);
    if (f.length > 0) {
      const m = f[0], { userId: g } = m;
      return Bn.unsubscribeSharing(p, h), Ma(Bn, t.value, g), br.switchSharingSource(g, h), v == null || v.localShareAudioUserMutedList.forEach((C) => {
        br.setSharingAudioVolume(g, C.userId !== g || C.muted, C.isFromMainSession);
      }), O(Vc, { userId: g }), Je(Zc({ activeNodeID: g, bStatus: 1, ssrc: g }));
    }
    return oe;
  })) : oe;
})), epics13: (e, t) => se(e, sm).pipe(pe(t), ze((r) => {
  let [n, o] = r;
  const { payload: { body: { encryptKey: i, additionalType: s } } } = n, { media: { sharingDecodeStatus: a, sharingEncodeStatus: l }, meeting: { confId: u, userId: d, zoomId: c, meetingId: p, meetingNumber: h, isWebinar: v } } = o;
  return Ns(t).pipe(ze((f) => {
    let m = l;
    return (!ve.isSupportSendScreenSharing || v && f && Jt(f.userRole)) && (m = "failed"), _r("sharing", m, a).pipe(he((g) => {
      let [C, b] = g;
      const E = { userId: d, sn: wn(c), confId: u, encryptKey: wn(i), encryptType: s, meetingId: p, meetingNumber: h };
      if (C && (br == null || br.updateMediaParams({ iVType: qt.SHARING_ENCODE, isFromMainSession: !1, updateParams: E })), b) {
        br.updateMediaParams({ iVType: qt.SHARING_DECODE, isFromMainSession: !1, updateParams: E });
        const { participants: { attendeesList: w } } = t.value;
        if (w.length > 0) {
          const _ = w.map((I) => ({ userid: I.userId, sn: I.zoomID && wn(I.zoomID) }));
          br.updateUserMediaSN({ added: _, isFromMainSession: !1, iVType: qt.SHARING_DECODE });
        }
      }
    }), Ie(oe));
  }));
})), epics14: (e, t) => to(e, 20235).pipe(pe(t), he((r) => {
  let [n, o] = r;
  const { media: { sharingDecodeStatus: i } } = o, { type: s, payload: { body: a } } = n, l = s === `${Yo}`;
  _r("sharing", "success", i).subscribe((u) => {
    let [, d] = u;
    d && br.addReceivedSharingChannelType({ isFromMainSession: l, ...a });
  });
}), Ie(oe)), epics15: (e, t) => to(e, 20236).pipe(pe(t), he((r) => {
  let [n, o] = r;
  const { media: { sharingDecodeStatus: i } } = o, { type: s, payload: { body: { ssrc: a } } } = n, l = s === `${Yo}`;
  _r("sharing", "success", i).subscribe((u) => {
    let [, d] = u;
    d && br.removeReceivedSharingChannelType({ isFromMainSession: l, ssrc: a });
  });
}), Ie(oe)), epics16: (e) => Pe(e, X.SharingFirstDecodeFrameReceivedSsrc).pipe(z((t) => !!t.payload.data), he((t) => {
  const { payload: { data: { ssrc: r } } } = t;
  Bn.sendReceivingSharingReady(r);
}), Ie(oe)), epics17: (e, t) => se(e, 20233).pipe(z(() => !!t.value.share.isRequireReadReceipt), he((r) => {
  const { payload: { body: { bReceiveOk: n } } } = r;
  n && O(Ew);
}), Ie(oe)), epics18: (e, t) => se(e, En).pipe(z((r) => {
  var n;
  return ((n = r.payload.body) === null || n === void 0 ? void 0 : n.lockShare) !== void 0;
}), G((r) => {
  const { payload: { body: { lockShare: n } } } = r, { share: { isOptimizedForSharedVideo: o, isSharingToBreakoutRoom: i }, audio: { isSharingAudio: s }, meeting: { userId: a } } = t.value, l = [];
  return n === vn.MultipleShare && o && (Bn.startSharing(a, { bShareAudio: s, bShareToBO: i, bShareVideo: !1 }), br.switchSharingMode(Zl.Normal), l.push(qc(!1))), ne(l);
})), epics19: (e, t) => Pe(e, X.ShareQosData).pipe(pe(t), ae((r) => {
  var n;
  let [o, i] = r;
  const { meeting: { isWebinar: s }, media: { sharingEncodeStatus: a, sharingDecodeStatus: l }, share: { status: u, isReceiveSharing: d }, participants: { xmppAttendeeList: c } } = i;
  let p = Sm(i).length > 0;
  s && (p = p || !!c.length);
  const h = u !== Fe.End && a === "success" && p, v = d && l === "success";
  return (n = o.payload.data) !== null && n !== void 0 && n.encoding ? h ? (O(ef, o.payload), bf(o.payload)) : bf(Ri) : v ? (O(ef, o.payload), vu(o.payload)) : vu(Ri);
})) }, HT = Wr($T, BT), On = We.createAgent();
let Fi, c7, yo = function(e) {
  return e.Add = "add", e.List = "list", e.Remove = "memberremove", e.rename = "rename", e.update = "UPDATE", e;
}({}), qo = function(e) {
  return e.Open = "open", e.Message = "message", e.Error = "error", e.Close = "close", e;
}({});
class Us {
  constructor() {
    this.eventHandlers = void 0, this.websocket = void 0, this.seq = void 0, this.eventHandlers = /* @__PURE__ */ new Map(), this.websocket = null, this.seq = 1;
  }
  static getInstance() {
    return this.xmppInstance || (this.xmppInstance = new Us()), this.xmppInstance;
  }
  on(t, r) {
    let n = this.eventHandlers.get(t);
    n || (n = []), n.push(r), this.eventHandlers.set(t, n);
  }
  off(t, r) {
    const n = this.eventHandlers.get(t);
    if (n) {
      const o = n.filter((i) => i !== r);
      this.eventHandlers.set(t, o);
    }
  }
  emit(t, r) {
    const n = this.eventHandlers.get(t);
    n && n instanceof Array && n.slice(0).forEach((o) => {
      try {
        o(r);
      } catch (i) {
        console.error(i);
      }
    });
  }
  sendMessageToRwg(t) {
    this.seq += 1;
    const r = this.seq;
    return this.websocket && this.websocket.readyState === WebSocket.OPEN && this.websocket.send(JSON.stringify(Object.assign(t, { seq: r }))), r;
  }
  connect(t) {
    this.websocket = new WebSocket(t), this.websocket.binaryType = "arraybuffer", this.addWebSocketEventListeners();
  }
  close() {
    var t;
    (t = this.websocket) === null || t === void 0 || t.close();
  }
  addWebSocketEventListeners() {
    this.websocket && (this.websocket.addEventListener("open", (t) => {
      this.emit(qo.Open, t);
    }), this.websocket.addEventListener("message", (t) => {
      const { data: r } = t;
      var n;
      if (r instanceof ArrayBuffer)
        new Uint8Array(r)[0] === 0 && ((n = this.websocket) === null || n === void 0 || n.send(r));
      else
        try {
          this.emit(qo.Message, JSON.parse(r));
        } catch {
          console.warn("Unsupported format", r);
        }
    }), this.websocket.addEventListener("close", (t) => {
      this.emit(qo.Close, t);
    }), this.websocket.addEventListener("error", (t) => {
      this.emit(qo.Error, t);
    }));
  }
  join(t) {
    return { seq: this.sendMessageToRwg({ evt: 24576, body: { clientCap: t } }) };
  }
  raiseHand() {
    return { seq: this.sendMessageToRwg({ evt: 24580, body: null }) };
  }
  lowerHand(t) {
    return { seq: this.sendMessageToRwg({ evt: 24578, jids: t || [] }) };
  }
  sendWebinarMseeage(t, r, n) {
    const o = { msg: t, jid: r ? [r] : [], type: n, bcm: arguments.length > 3 && arguments[3] !== void 0 && arguments[3] };
    return { seq: this.sendMessageToRwg({ evt: 24582, body: o }) };
  }
  sendAnswer(t, r, n) {
    return { seq: this.sendMessageToRwg({ evt: 24584, body: { question_attendeejid: r.jid, question_attendeename: r.displayName, question_text: r.questionText, question_id: r.questionId, question_anonymous: r.isAnonymous, question_time: r.questionTime, text: t, isPrivate: n } }) };
  }
  answerOnline(t, r) {
    return { seq: this.sendMessageToRwg({ evt: 24586, body: { question_attendeejid: t.jid, question_attendeename: t.displayName, question_text: t.questionText, question_id: t.questionId, question_anonymous: t.isAnonymous, question_time: t.questionTime, isLiveStart: r } }) };
  }
  dismissQuestion(t) {
    return { seq: this.sendMessageToRwg({ evt: 24590, body: { question_attendeejid: t.jid, question_attendeename: t.displayName, question_text: t.questionText, question_id: t.questionId, question_anonymous: t.isAnonymous, question_time: t.questionTime, bOpen: !1 } }) };
  }
  deleteQuestion(t) {
    return { seq: this.sendMessageToRwg({ evt: 24614, body: { question_id: t, bDelete: !0 } }) };
  }
  deleteComment(t) {
    return { seq: this.sendMessageToRwg({ body: { comment_id: t, bDelete: !0 }, evt: 24616 }) };
  }
  reopenQuestion(t) {
    return { seq: this.sendMessageToRwg({ body: { question_attendeejid: t.jid, question_attendeename: t.displayName, question_text: t.questionText, question_id: t.questionId, question_anonymous: t.isAnonymous, question_time: t.questionTime, bOpen: !0 }, evt: 24590 }) };
  }
  askQuestion(t, r) {
    let n = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], o = arguments.length > 3 ? arguments[3] : void 0;
    const i = bc();
    return { seq: this.sendMessageToRwg({ body: { id: i, text: t, isAnonymous: n, bAllowAttendeeViewAllQuestion: o, name: r }, evt: 24592 }), questionId: i };
  }
  upOrDownVote(t, r) {
    return { seq: this.sendMessageToRwg({ body: { question_attendeejid: t.jid, question_attendeename: t.displayName, question_text: t.questionText, question_id: t.questionId, question_anonymous: t.isAnonymous, question_time: t.questionTime, bUpVote: r }, evt: 24598 }) };
  }
  rename(t, r) {
    return { seq: this.sendMessageToRwg({ body: { jid: t, displayName: r }, evt: 24600 }) };
  }
  setSkinTome(t) {
    return { seq: this.sendMessageToRwg({ body: { skinTone: t }, evt: 24618 }) };
  }
}
Us.xmppInstance = null;
const FT = We.createAgent();
let Ur = null;
function kA(e) {
  switch (e.responseType) {
    case "json":
      if ("response" in e)
        return e.response;
      var t = e;
      return JSON.parse(t.responseText);
    case "document":
      return e.responseXML;
    default:
      return "response" in e ? e.response : (t = e).responseText;
  }
}
var zT = function(e, t, r, n) {
  n === void 0 && (n = "download_load"), this.originalEvent = e, this.xhr = t, this.request = r, this.type = n;
  var o = t.status, i = t.responseType;
  this.status = o != null ? o : 0, this.responseType = i != null ? i : "";
  var s = t.getAllResponseHeaders();
  this.responseHeaders = s ? s.split(`
`).reduce(function(u, d) {
    var c = d.indexOf(": ");
    return u[d.slice(0, c)] = d.slice(c + 2), u;
  }, {}) : {}, this.response = kA(t);
  var a = e.loaded, l = e.total;
  this.loaded = a, this.total = l;
}, w0 = Mu(function(e) {
  return function(t, r, n) {
    var o;
    this.message = t, this.name = "AjaxError", this.xhr = r, this.request = n, this.status = r.status, this.responseType = r.responseType;
    try {
      o = kA(r);
    } catch {
      o = r.responseText;
    }
    this.response = o;
  };
}), WT = function() {
  function e(t, r) {
    return w0.call(this, "ajax timeout", t, r), this.name = "AjaxTimeoutError", this;
  }
  return e.prototype = Object.create(w0.prototype), e;
}(), ZT = ae(function(e) {
  return e.response;
}), ai, Dn = (ai = function(e) {
  var t;
  return t = typeof e == "string" ? { url: e } : e, new Vt(function(r) {
    var n, o, i, s = Bl({ async: !0, crossDomain: !1, withCredentials: !1, method: "GET", timeout: 0, responseType: "json" }, t), a = s.queryParams, l = s.body, u = s.headers, d = s.url;
    if (!d)
      throw new TypeError("url is required");
    if (a)
      if (d.includes("?")) {
        var c = d.split("?");
        if (2 < c.length)
          throw new TypeError("invalid url");
        i = new URLSearchParams(c[1]), new URLSearchParams(a).forEach(function($, re) {
          return i.set(re, $);
        }), d = c[0] + "?" + i;
      } else
        d = d + "?" + (i = new URLSearchParams(a));
    var p = {};
    if (u)
      for (var h in u)
        u.hasOwnProperty(h) && (p[h.toLowerCase()] = u[h]);
    var v = s.crossDomain;
    v || "x-requested-with" in p || (p["x-requested-with"] = "XMLHttpRequest");
    var f = s.withCredentials, m = s.xsrfCookieName, g = s.xsrfHeaderName;
    if ((f || !v) && m && g) {
      var C = (o = (n = document == null ? void 0 : document.cookie.match(new RegExp("(^|;\\s*)(" + m + ")=([^;]*)"))) === null || n === void 0 ? void 0 : n.pop()) !== null && o !== void 0 ? o : "";
      C && (p[g] = C);
    }
    var b, E = function($, re) {
      var fe;
      if (!$ || typeof $ == "string" || function(le) {
        return typeof FormData != "undefined" && le instanceof FormData;
      }($) || function(le) {
        return typeof URLSearchParams != "undefined" && le instanceof URLSearchParams;
      }($) || function(le) {
        return th(le, "ArrayBuffer");
      }($) || function(le) {
        return th(le, "File");
      }($) || function(le) {
        return th(le, "Blob");
      }($) || function(le) {
        return typeof ReadableStream != "undefined" && le instanceof ReadableStream;
      }($))
        return $;
      if (function(le) {
        return typeof ArrayBuffer != "undefined" && ArrayBuffer.isView(le);
      }($))
        return $.buffer;
      if (typeof $ == "object")
        return re["content-type"] = (fe = re["content-type"]) !== null && fe !== void 0 ? fe : "application/json;charset=utf-8", JSON.stringify($);
      throw new TypeError("Unknown body type");
    }(l, p), w = Bl(Bl({}, s), { url: d, headers: p, body: E });
    b = t.createXHR ? t.createXHR() : new XMLHttpRequest();
    var _ = t.progressSubscriber, I = t.includeDownloadProgress, D = I !== void 0 && I, B = t.includeUploadProgress, L = B !== void 0 && B, R = function($, re) {
      b.addEventListener($, function() {
        var fe, le = re();
        (fe = _ == null ? void 0 : _.error) === null || fe === void 0 || fe.call(_, le), r.error(le);
      });
    };
    R("timeout", function() {
      return new WT(b, w);
    }), R("abort", function() {
      return new w0("aborted", b, w);
    });
    var y = function($, re) {
      return new zT(re, b, w, $ + "_" + re.type);
    }, A = function($, re, fe) {
      $.addEventListener(re, function(le) {
        r.next(y(fe, le));
      });
    };
    L && [Xp, eh, h7].forEach(function($) {
      return A(b.upload, $, GT);
    }), _ && [Xp, eh].forEach(function($) {
      return b.upload.addEventListener($, function(re) {
        var fe;
        return (fe = _ == null ? void 0 : _.next) === null || fe === void 0 ? void 0 : fe.call(_, re);
      });
    }), D && [Xp, eh].forEach(function($) {
      return A(b, $, p7);
    });
    var k = function($) {
      var re = "ajax error" + ($ ? " " + $ : "");
      r.error(new w0(re, b, w));
    };
    b.addEventListener("error", function($) {
      var re;
      (re = _ == null ? void 0 : _.error) === null || re === void 0 || re.call(_, $), k();
    }), b.addEventListener(h7, function($) {
      var re, fe, le = b.status;
      if (le < 400) {
        (re = _ == null ? void 0 : _.complete) === null || re === void 0 || re.call(_);
        var Ae = void 0;
        try {
          Ae = y(p7, $);
        } catch (Re) {
          return void r.error(Re);
        }
        r.next(Ae), r.complete();
      } else
        (fe = _ == null ? void 0 : _.error) === null || fe === void 0 || fe.call(_, $), k(le);
    });
    var T = w.user, N = w.method, F = w.async;
    for (var h in T ? b.open(N, d, F, T, w.password) : b.open(N, d, F), F && (b.timeout = w.timeout, b.responseType = w.responseType), "withCredentials" in b && (b.withCredentials = w.withCredentials), p)
      p.hasOwnProperty(h) && b.setRequestHeader(h, p[h]);
    return E ? b.send(E) : b.send(), function() {
      b && b.readyState !== 4 && b.abort();
    };
  });
}, ai.get = function(e, t) {
  return Dn({ method: "GET", url: e, headers: t });
}, ai.post = function(e, t, r) {
  return Dn({ method: "POST", url: e, body: t, headers: r });
}, ai.delete = function(e, t) {
  return Dn({ method: "DELETE", url: e, headers: t });
}, ai.put = function(e, t, r) {
  return Dn({ method: "PUT", url: e, body: t, headers: r });
}, ai.patch = function(e, t, r) {
  return Dn({ method: "PATCH", url: e, body: t, headers: r });
}, ai.getJSON = function(e, t) {
  return ZT(Dn({ method: "GET", url: e, headers: t }));
}, ai), GT = "upload", p7 = "download", Xp = "loadstart", eh = "progress", h7 = "load", qT = Object.prototype.toString;
function th(e, t) {
  return qT.call(e) === "[object " + t + "]";
}
const f7 = Zr.getInstance(), rh = (e) => {
  const { meeting: { encryptedRWC: t, encryptedGEORWC: r, discardedRwcList: n, meetingOptions: o } } = e;
  let i = [];
  return o != null && o.isEnableGeoFenceRWC && r && (r == null ? void 0 : r.length) > 0 ? i = r.filter((s) => !n.includes(s.rwc)).reduce((s, a) => {
    const { dl: l, rwc: u, rwcToken: d } = a, c = s.find((p) => p.dl === l);
    if (c)
      c.items.push({ rwc: u, rwcToken: d });
    else {
      const p = { dl: l, items: [] };
      p.items.push({ rwc: u, rwcToken: d }), s.push(p);
    }
    return s;
  }, []) : t && (i = [{ dl: 0, items: Object.keys(t).map((s) => ({ rwc: s, rwcToken: t[s] })) }]), i;
}, nh = (e) => Kt(...e.map((t) => t.dl === 0 ? ne(t.items) : nr(t.dl).pipe(G(() => ne(t.items))))), v7 = (e, t) => e.pipe(ge(`${nm}`), pe(t), z((r) => {
  let [, n] = r;
  return n.meeting.encryptedRWC !== void 0 || n.meeting.encryptedGEORWC !== void 0 && n.meeting.encryptedGEORWC.length > 0;
}), ze((r) => {
  let [, n] = r;
  const { meeting: { ts: o, auth: i, meetingNumber: s, meetingOptions: a, meetingId: l, userName: u }, breakoutRoom: d } = n, c = a == null ? void 0 : a.isEnableGeoFenceRWC, p = rh(n);
  if (p.length > 0) {
    const h = { serversLength: p.reduce((f, m) => f + m.items.length, 0), pingFailedServerList: [], pingRwcServerCounts: 0, retryCounts: 0 };
    let v;
    return c && (v = new J6(), nh(p).subscribe((f) => {
      var m;
      return (m = v) === null || m === void 0 ? void 0 : m.next(f);
    })), (c ? v : nh(p)).pipe(hs(() => {
      const { meeting: { meetingStatus: f } } = t.value, m = f === xt.Initial && h.pingFailedServerList.length < h.serversLength && h.serversLength > 0;
      return !m && v && v.complete(), m;
    }), he(() => {
      if (h.pingRwcServerCounts = h.pingRwcServerCounts + 1, c && h.pingRwcServerCounts === h.serversLength) {
        const f = 1e3 * Math.floor(5 * Math.pow(2, h.retryCounts));
        h.retryCounts = h.retryCounts + 1, f7.makeLogger(["Join Meeting Flow"]).info(`ping rwc retry,current rwc list:${JSON.stringify(rh(t.value))},retry counts:${h.retryCounts}, ${JSON.stringify({ meetingId: l, meetingNumber: xr(s), userName: xr(u) })}`, ["Ping RWC Retry"]), nr(f).pipe(ae(() => {
          const m = rh(t.value);
          return Object.assign(h, { serversLength: m.reduce((g, C) => g + C.items.length, 0), pingFailedServerList: [], pingRwcServerCounts: 0 }), m;
        })).subscribe((m) => {
          nh(m).subscribe((g) => {
            v.next(g);
          });
        });
      }
    }), G((f) => {
      const { rwc: m, rwcToken: g } = f, C = ((b, E, w, _, I, D) => {
        const B = { ts: _, auth: I, rwcToken: w, dmz: 1 };
        return D && Object.assign(B, { confID: D }), `https://${b}/wc/ping/${E}?${new URLSearchParams(B).toString()}`;
      })(m, s, g, o, i, d == null ? void 0 : d.currentRoom.boConfId);
      return Dn({ url: C, crossDomain: eo(C) }).pipe(G((b) => {
        let E = {};
        return E = b.response ? { ...b.response, rwc: m, fromNginx: !1 } : { rwc: m, rwg: m, rwcToken: g, fromNginx: !0 }, ne([I4(E), Td()]);
      }), Xn(() => {
        const { pingFailedServerList: b, serversLength: E } = h;
        return b.push(C), b.length === E && (c && v && v.complete(), f7.report(`ping rwc error, ${JSON.stringify({ meetingId: l, meetingNumber: xr(s), userName: xr(u) })}`, ["Join Meeting Flow", "Ping RWC Error"], "error"), O(cr, { reason: "connection error", errorCode: wc })), oe;
      }));
    }), jn(X4(performance.now())));
  }
  return oe;
}));
let m7 = 0;
const KT = Zr.getInstance(), oh = { meetingStatus: xt.Initial, isWindowOpen: !1, apiKey: "", signature: "", signatureType: "", lang: "en-US", tk: "", customerKey: "", mtkGuid: "", pingRWCTimestamp: 0, meetingInfoTimestamp: 0, passWord: "", meetingNumber: 0, userName: "", userEmail: "", sdkUrl: "", sdkOrigin: "", proxy: 1, cv: "", meetingId: "", tid: "", ts: "", auth: "", sign: "", isSupportCallOut: !1, tollNumbers: void 0, recordingEnable: !1, callOutCountry: void 0, inviteEmail: "", xmppConfig: null, isSupportH323: !1, h323GatewayInfo: "", h323Password: "", trackAuth: "", isOriginHost: !1, isWebinar: !1, encryptedRWC: void 0, meetingOptions: {}, meetingTopic: "", bLock: !1, bHoldUponEntry: !1, viewOnly: 0, listenOnlyPhone: 0, bAllowRaiseHand: !1, bAllowAttendeeRename: !1, bBroadcast: void 0, bAllowPlayChimeForEnterOrExit: !1, bIbDisableShare: !1, bIbDisableChat: !1, bAllowShowCount: !1, encryptKey: "", bNoHostTimeOut: !1, confId: "", conId: "", e2eEncrypt: !1, zoomId: "", jid: "", xtoken: "", groups: void 0, svcUrl: "", encType: NaN, userGUID: "", userId: NaN, isHost: !1, isCoHost: !1, participantID: 0, isOnHold: !1, isMeetingReset: !1, bRecord: !1, audioVideoBeforeOnHold: void 0, region: void 0, network: void 0, joinMeetingTimeStamp: 0, activeAppInfo: void 0, recordingDisclaimerForRecorder: {}, recordingDisclaimer: {}, ccUrl: "", sessionIdleTimeoutMins: 40, reportDomain: "", isAudioBridgeEnabled: !0, discardedRwcList: [], sharePronounType: void 0, stayAwake: !1, wrInfo: {}, meetingInfo: {}, isNewJoinFlow: !1, gatewayUserList: [], logConfig: "", logEncryptionPubKey: "", failover: { count: 0, isCurrentFailoverRecorded: !1, reason: -1, interval: 0, joinMeetingSuccessTimestamp: 0 } }, JT = zr({ [`${Un}`]: M((e, t) => {
  let { payload: r } = t;
  r.customerKey = e.customerKey || r.customerKey || "", Object.assign(e, r), e.meetingStatus = xt.Initial;
}), [`${W9}`]: M((e, t) => {
  let { payload: r } = t;
  r.customerKey = e.customerKey || r.customerKey || "", Object.assign(e, r);
}), [`${Z9}`]: M((e, t) => {
  let { payload: r } = t;
  e.isWindowOpen = r;
}), [`${Y4}`]: M((e, t) => {
  let { payload: r } = t;
  r.useSDK ? e.signatureType = "sdk" : e.signatureType = "api", e.apiKey = r.apiKey, e.signature = r.signature, e.lang = r.language;
}), [`${G9}`]: M((e, t) => {
  let { payload: r } = t;
  e.ztk = r;
}), [`${q9}`]: M((e, t) => {
  let { payload: r } = t;
  e.zsk = r;
}), [`${K9}`]: M((e, t) => {
  let { payload: r } = t;
  e.tk = r.tk, e.mtkGuid = r.mtkGuid;
}), [`${X4}`]: M((e, t) => {
  let { payload: r } = t;
  e.pingRWCTimestamp = r;
}), [`${gC}`]: M((e, t) => {
  let { payload: r } = t;
  e.meetingInfoTimestamp = r;
}), [`${ti}`]: M((e, t) => {
  let { payload: r } = t;
  e.confId = r.confID, e.conId = r.conID, e.e2eEncrypt = r.e2eEncrypt, e.meetingNumber = parseInt(r.mn, 10), e.zoomId = r.zoomID, e.meetingStatus = xt.Joined, e.jid = r.jid, e.xtoken = r.xtoken, e.groups = r.groups, e.svcUrl = r.svcUrl, e.encType = r.encType, e.userGUID = r.userGUID, e.userId = r.userID, e.role = r.role, e.participantID = r.participantID, e.reportDomain = r.reportDomain, e.abToken = r.ABtoken, e.supportLocalAB = !!r.supportLocalAB, r.enableWebTransport && (e.enableWebtransport = r.enableWebTransport, e.webtransportPort = r.WebTransportPort);
}), [`${Ec}`]: M((e, t) => {
  let { payload: r } = t;
  if (r.gatewayUser) {
    var n;
    const { userId: i, sn: s } = r.gatewayUser, a = (n = e.gatewayUserList) === null || n === void 0 ? void 0 : n.find((l) => l.userId === i);
    var o;
    a ? a.sn = s : (o = e.gatewayUserList) === null || o === void 0 || o.push(r.gatewayUser);
  } else
    Object.assign(e, r);
}), [`${eC}`]: M((e, t) => {
  let { payload: r } = t;
  e.isHost = r;
}), [`${tC}`]: M((e, t) => {
  let { payload: r } = t;
  e.isCoHost = r;
}), [`${pa}`]: M((e, t) => {
  let { payload: r } = t;
  e.isOnHold = r;
}), [`${rC}`]: M((e, t) => {
  let { payload: r } = t;
  e.isMeetingReset = r;
}), [`${nC}`]: M((e, t) => {
  let { payload: r } = t;
  e.audioVideoBeforeOnHold = r;
}), [`${oC}`]: M((e, t) => {
  let { payload: r } = t;
  e.currentUserAudioBeforeReset = r;
}), [`${iC}`]: M((e, t) => {
  let { payload: r } = t;
  e.isCurrentUserMutedBeforeReset = r;
}), [`${om}`]: M((e, t) => {
  let { payload: r } = t;
  e.meetingStatus = r;
}), [`${sC}`]: M((e, t) => {
  let { payload: r } = t;
  e.region = r.region, e.network = r.network;
}), [`${aC}`]: M((e, t) => {
  let { payload: r } = t;
  e.isCurrentUserStartVideoBeforeReset = r;
}), [`${lC}`]: M((e, t) => {
  let { payload: r } = t;
  e.joinMeetingTimeStamp = r;
}), [`${J9}`]: M((e, t) => {
  let { payload: r } = t;
  e.activeAppInfo = r;
}), [`${Pl}`]: M((e, t) => {
  let { payload: r } = t;
  e.idleStartTime = r;
}), [`${uC}`]: M((e, t) => {
  let { payload: r } = t;
  e.sessionIdleTimeoutMins = r;
}), [`${dC}`]: M((e, t) => {
  let { payload: r } = t;
  e.isAudioBridgeEnabled = r;
}), [`${cC}`]: M((e, t) => {
  var r, n;
  let { payload: o } = t;
  const i = (r = e.encryptedGEORWC) === null || r === void 0 || (n = r.find((a) => a.rwc === o)) === null || n === void 0 ? void 0 : n.dc;
  if (i) {
    var s;
    const a = (s = e.encryptedGEORWC) === null || s === void 0 ? void 0 : s.filter((l) => l.dc === i);
    a && e.discardedRwcList.some((l) => (a == null ? void 0 : a.findIndex((u) => u.rwc === l)) >= 0) && e.discardedRwcList.push(...a.map((l) => l.rwc)), e.discardedRwcList.push(o);
  }
}), [`${pC}`]: M((e, t) => {
  let { payload: r } = t;
  e.sharePronounType = r;
}), [`${hC}`]: M((e, t) => {
  let { payload: r } = t;
  e.stayAwake = r;
}), [`${fC}`]: M((e, t) => {
  let { payload: r } = t;
  e.failover.joinMeetingSuccessTimestamp = r;
}), [`${vC}`]: M((e) => {
  Object.assign(e.failover, { ...oh.failover, count: e.failover.count, joinMeetingSuccessTimestamp: e.failover.joinMeetingSuccessTimestamp });
}), [`${Ic}`]: M((e, t) => {
  let { payload: r } = t;
  const { count: n, reason: o, interval: i } = r;
  e.failover.count = n, e.failover.reason = o, e.failover.interval = i, e.failover.isCurrentFailoverRecorded = !0;
}), [`${mC}`]: M((e, t) => {
  let { payload: r } = t;
  e.quicklyLeave = r;
}), [`${yC}`]: M((e, t) => {
  let { payload: r } = t;
  e.isEnableZmkFromRWG = r;
}), [`${k1}`]: (e, t) => {
  let { payload: r } = t;
  const { isFailover: n } = r, o = { isMeetingReset: !0, apiKey: e.apiKey, signatureType: e.signatureType, signature: e.signature, lang: e.lang, proxy: 1, stayAwake: e.stayAwake };
  return n && Object.assign(o, { currentUserAudioBeforeReset: e.audioVideoBeforeOnHold ? e.audioVideoBeforeOnHold.audio : r.audio, isCurrentUserMutedBeforeReset: e.audioVideoBeforeOnHold ? e.audioVideoBeforeOnHold.muted : r.muted, isCurrentUserStartVideoBeforeReset: e.audioVideoBeforeOnHold ? e.audioVideoBeforeOnHold.video : r.video, meetingNumber: e.meetingNumber, userName: e.userName, passWord: e.passWord, userEmail: e.userEmail, sdkUrl: e.sdkUrl, sdkOrigin: e.sdkOrigin, cv: e.cv, zsk: e.zsk, ztk: e.ztk, idleStartTime: e.idleStartTime, sessionIdleTimeoutMins: e.sessionIdleTimeoutMins, customerKey: e.customerKey, failover: e.failover, stayAwake: e.stayAwake, quicklyLeave: e.quicklyLeave }), { ...oh, ...o };
} }, oh), QT = { meetingFailoverReportEpic0: (e, t) => e.pipe(ge(`${Un}`), ze(() => {
  const r = t.value.meeting.failover.joinMeetingSuccessTimestamp === 0 && !!xe.get(lt.WebclientZoomId);
  return e.pipe(ge(`${ti}`), Ge(1), G(() => {
    const n = [], o = xe.get(lt.WebclientFailoverCount) || 0;
    let { meeting: { failover: { count: i, reason: s, interval: a } } } = t.value;
    const { meeting: { pingRWCTimestamp: l } } = t.value;
    r && (i = o + 1, s = or.RefreshPage, a = 0, xe.set(lt.WebclientFailoverCount, i, qe.SessionStorage), n.push(Ic({ count: i, reason: s, interval: a })));
    const u = performance.now();
    let d = `WCL_M, JMCT(${u - l})`;
    return i > 0 && s !== or.NormalCase && (d = `${d},FAILOVER(${i},${s},${(a / 1e3).toFixed(1)})`), FT.sendRWGConnectionPerformance(d), n.push(vC(), fC(u)), ne(n);
  }));
})), meetingFailoverReportEpic1: (e, t) => e.pipe(ge(`${Tr}`), G((r) => {
  const { payload: n } = r, { meeting: { failover: { joinMeetingSuccessTimestamp: o, isCurrentFailoverRecorded: i } } } = t.value, s = [];
  if (!i) {
    let a = xe.get(lt.WebclientFailoverCount) || 0;
    n !== or.NormalCase && (a += 1, xe.set(lt.WebclientFailoverCount, a, qe.SessionStorage));
    const l = performance.now() - o;
    s.push(Ic({ reason: n, count: a, interval: l }));
  }
  return ne(s);
})) }, YT = { sessionIdleEpic0: (e, t) => e.pipe(ge(`${ti}`), pe(t), z((r) => {
  let [, n] = r;
  return n.meeting.zlkJwtToken !== void 0;
}), ze(() => (Fi && Fi.complete(), Fi = new xn(), c7 = ps(6e4).pipe(ae(() => performance.now())).subscribe(Fi), Fi.pipe(ae((r) => y2(r)))))), sessionIdleEpic1: (e) => e.pipe(ge(`${ko}`)).pipe(he(() => {
  Fi && (Fi.complete(), c7.unsubscribe());
}), Ie(oe)), sessionIdleEpic2: (e, t) => e.pipe(ge(`${y2}`), pe(t), G((r) => {
  var n;
  let [o, i] = r;
  const { meeting: { idleStartTime: s, sessionIdleTimeoutMins: a, isOriginHost: l }, participants: { attendeesList: u, xmppAttendeeList: d }, recording: c, breakoutRoom: p } = i, h = o.payload, v = [];
  if (u.length === 1 && d.length === 0 && (p == null || (n = p.currentRoom) === null || n === void 0 ? void 0 : n.status) !== Ee.InRoom && (c == null ? void 0 : c.cmrStatus) !== Zt.Start)
    if (s) {
      const f = l && aE(u[0].userRole) ? a : 40;
      h - s > 60 * f * 1e3 && (console.warn(`No active for ${f} minutes, will end the session.`), v.push(Ha()), nr(500).subscribe(() => {
        ym();
      }));
    } else
      v.push(Pl(h));
  else
    v.push(Pl(void 0));
  return ne(v);
})), sessionIdleEpic3: (e, t) => e.pipe(ge(`${js}`), z((r) => [gt, En].includes(r.payload.evt) && t.value.meeting.idleStartTime !== void 0), Fr(ri), G(() => {
  var r;
  const { participants: { attendeesList: n, xmppAttendeeList: o }, recording: i, breakoutRoom: s } = t.value, a = [];
  return (n.length > 1 || o.length > 0 || (i == null ? void 0 : i.cmrStatus) === Zt.Start || (s == null || (r = s.currentRoom) === null || r === void 0 ? void 0 : r.status) === Ee.InRoom) && a.push(Pl(void 0)), ne(a);
})), sessionIdleEpic4: (e) => e.pipe(ge(`${au}`, `${Ha}`), tn(Pl(void 0))) }, XT = { meetingMainEpics0: (e, t) => se(e, 0).pipe(he((r) => {
  var n;
  if (((n = r.payload.body) === null || n === void 0 ? void 0 : n.status) === "READY") {
    const { meeting: { zlkJwtToken: o, signatureType: i, sign: s, passWord: a, isHost: l, isOriginHost: u, ztk: d, zsk: c, tk: p, userEmail: h }, breakoutRoom: v } = t.value, f = o ? { zlkJwtToken: o } : { signType: i, sign: s };
    if (a && a !== "" && (o ? Object.assign(f, { mpwd: kt(a) }) : l && u || Object.assign(f, { mpwd: a })), (v == null ? void 0 : v.currentRoom.status) === Ee.Joining) {
      const { currentRoom: { boId: g, boConfId: C, boToken: b } } = v;
      g && C && b && Object.assign(f, { botk: b });
    }
    if (!o) {
      d && Object.assign(f, { zak: d }), (sessionStorage.getItem(lt.WebclientZsk) || c) && Object.assign(f, { zak: c }), p && Object.assign(f, { tk: p });
      const g = xe.get(lt.WebclientWebinarToken);
      g !== void 0 && Object.assign(f, { tk: g });
      const C = sessionStorage.getItem(lt.WebclientRecordingToken);
      C && Object.assign(f, { localRecordToken: C }), h && Object.assign(f, { email: h });
    }
    On.sendLaunchParams(f);
    const m = xe.get(lt.WebclientMeetingToken);
    m && On.joinMeeting(m);
  }
}), Ie(oe)), meetingMainEpics1: (e, t) => {
  return se(e, Q0).pipe(pe(t), (r = (n) => {
    let [o, i] = n;
    const { payload: { body: { res: s, userID: a, zoomID: l, mn: u, participantID: d, meetingtoken: c, role: p } } } = o, { meeting: { userEmail: h, userName: v, isMeetingReset: f, apiKey: m, zsk: g, signatureType: C } } = i;
    if (fn.Success === s) {
      const { WebclientParticipantId: b, WebclientZoomId: E, WebclientUserEmail: w, WebclientUserName: _, WebclientMeetingToken: I } = lt;
      xe.set(E, l, qe.SessionStorage), xe.set(b, d, qe.SessionStorage), h && xe.set(w, h, qe.SessionStorage), xe.set(_, v, qe.SessionStorage), c && xe.set(I, c, qe.SessionStorage), g && On.sendSdkKeyToMonitor(C, m, a);
      const D = [ti(o.payload.body), lC(performance.now())];
      return f && D.push(rC(!1)), (p & Ds.Owner) === Ds.Owner && (O(cr, { reason: "dont support assisnt join through widget", errorCode: -1 }), On.leaveMeeting()), O(RC, { meetingNumber: u }), ne(D);
    }
    return fn.MeetingLocked === s ? O(cr, Ml(s)) : fn.UserFull === s ? O(cr, Object.assign({}, Ml(s), { lmUrl: o.payload.body.lmURL })) : (fn.MeetingIsOver === s || fn.MMRIBReject === s || fn.MMRConfParticipantExists === s || [fn.UserHasBeenRemoved, fn.WebinarBlockedEmail].includes(s), O(cr, Ml(s))), ne(ma(i, !1));
  }, ks(ze((n, o) => r(n) || oe))));
  var r;
}, meetingMainEpics2: (e, t) => se(e, En).pipe(pe(t), ae((r) => {
  let [n, o] = r;
  const { payload: { body: i } } = n, { meeting: { zoomId: s, encType: a, gcmSessinKey: l } } = o;
  if ((i == null ? void 0 : i.encryptKey) !== void 0 && ir.init(s, i.encryptKey, a), (i == null ? void 0 : i.gatewayKey) !== void 0) {
    const u = ke.getInstance(), [, d, c] = i.gatewayKey.split(".");
    u.sendUserNodeList([{ userid: Number(d), sn: c && wn(c) }], l);
  }
  return O(um, i), Ec(i);
})), meetingMainEpics3: (e, t) => se(e, 7939).pipe(pe(t), G((r) => {
  let [n, o] = r;
  const { payload: { body: i } } = n;
  if (i.reason !== void 0) {
    if (Lo.Reconnect === i.reason)
      return F9.WaitingRoomFailover === i.subReason ? O(Hr, { reason: hr.OnHold }) : O(Hr, { reason: hr.Failover }), Je(Tr(or.NormalCase));
    Lo.KickedByHost === i.reason ? O(Qi, { reason: "kicked by host" }) : [Lo.EndByHost, Lo.EndByNone, Lo.EndByAdmin, Lo.EndByHostStartAnotherMeeting].includes(i.reason) ? O(Qi, { reason: "ended by host" }) : Lo.FreeMeetingTimeout === i.reason ? O(Qi, { reason: "free meeting ended" }) : [Lo.DuplicateSession, Lo.MeetingTransfer].includes(i.reason) && O(Qi, { reason: "duplicated session" });
  }
  return o.meeting.isMeetingReset ? oe : ne(ma(o, !1));
})), meetingMainEpics4: (e, t) => e.pipe(ge(`${Tr}`), pe(t), G((r) => {
  let [, n] = r;
  const o = ma(n, !0);
  let i;
  if (n.meeting.zlkJwtToken) {
    const s = function(l) {
      if (l) {
        const { meeting: { topic: u, passWord: d, userName: c, zlkJwtToken: p, lang: h, cv: v, customerKey: f } } = l;
        return { topic: u, passWord: d, userName: c, zlkJwtToken: p, lang: h, cv: v, customerKey: f };
      }
      return null;
    }(n), a = { topic: s == null ? void 0 : s.topic, password: s == null ? void 0 : s.passWord, userName: s == null ? void 0 : s.userName, zlk: s == null ? void 0 : s.zlkJwtToken, lang: s == null ? void 0 : s.lang, cv: s == null ? void 0 : s.cv, customerKey: s == null ? void 0 : s.customerKey };
    i = Je(su(a)).pipe(Ba(1e3));
  } else {
    const s = function(a) {
      var l;
      const { meeting: { apiKey: u, signature: d, signatureType: c, meetingNumber: p, userName: h, lang: v, passWord: f, userEmail: m, sdkUrl: g, sdkOrigin: C, proxy: b, cv: E, ztk: w, zsk: _, tk: I } } = a;
      let D = w || sessionStorage.getItem(lt.WebclientZtk), B = _ || sessionStorage.getItem(lt.WebclientZsk);
      const L = Number((l = nl(d)) === null || l === void 0 ? void 0 : l.role) === 1;
      return L || (D = B, B = ""), { apiKey: u, signature: d, signatureType: c, meetingNumber: p, userName: h, lang: v, passWord: f, userEmail: m, sdkUrl: g, sdkOrigin: C, proxy: b, cv: E, ztk: D, zsk: B, tk: I || sessionStorage.getItem(lt.WebclientTk), ulsm: L && B ? 1 : 0 };
    }(n);
    i = Je(O1(s)).pipe(Ba(1e3));
  }
  return Ua(ne(o), i);
})), meetingMainEpics5: (e) => to(e, 7940).pipe(he((t) => {
  O("MEETING_HOST_CHANGE_INDICATION", t.payload.body.bHost);
}), ae((t) => eC(t.payload.body))), meetingMainEpics6: (e) => to(e, 7941).pipe(he((t) => {
  O("MEETING_COHOST_CHANGE_INDICATION", t.payload.body.bCoHost);
}), ae((t) => tC(t.payload.body))), meetingMainEpics7: (e) => to(e, 7945).pipe(he((t) => {
  const { payload: { body: { opt: r } } } = t;
  xe.set(lt.WebclientOpt, r, qe.SessionStorage);
}), Ie(oe)), meetingMainEpics8: (e, t) => se(e, 7942).pipe(he((r) => {
  const { payload: { body: { bHold: n } } } = r;
  xe.set(lt.WebclientIsOnHold, n ? 1 : 0, qe.SessionStorage), O(lm, n);
}), pe(t), G((r) => {
  let [n, o] = r;
  const i = [pa(n.payload.body.bHold)];
  if (n.payload.body.bHold) {
    const s = be(o);
    if (s) {
      i.push(nC({ audio: s.audio, video: s.bVideoOn, muted: s.muted }));
      const a = Vr(ke.getInstance());
      if (s.audio === "computer" && (a.leaveComputerAudio(), On.joinOrLeaveVoip(!1)), s.bVideoOn && a.stopCaptureVideo(), s.sharerOn && (On.stopSharing(s.userId), a.stopDesktopSharing(), i.push(bn(Fe.End))), o.video && o.video.subscribedVideoList.length > 0 && o.video.subscribedVideoList.forEach((l) => {
        On.unsubscribeVideo(l);
      }), o.share && o.share.isReceiveSharing) {
        const l = o.share.activeNodeId;
        o.share.remoteControlledUserList.length > 0 && (o.share.remoteControlledUserList.forEach((u) => {
          On.sharingRequestRemoteControl(u, !1);
        }), rs(o) && a.stopRemoteControl()), On.unsubscribeSharing(l), a.stopRenderSharing();
      }
    }
  }
  return ne(i);
})), meetingMainEpics9: (e) => se(e, 7954).pipe(ae((t) => sC(t.payload.body))), meetingMainEpics10: (e) => se(e, 4216).pipe(he((t) => {
  O("MEETING_CLAIM_HOST_KEY_RESPONSE", t.payload.body.bresult);
}), Ie(oe)), meetingMainEpics11: (e, t) => e.pipe(ge(`${au}`, `${Ha}`), pe(t), G((r) => {
  let [n, o] = r;
  return n.type === `${au}` ? (On.leaveMeeting(), O(Qi, {})) : n.type === `${Ha}` && (On.endMeeting(), O(Qi, {})), ne(ma(o, !1));
})), meetingMainEpics12: (e, t) => e.pipe(ge(`${T1}`), pe(t), G((r) => {
  let [n, o] = r;
  if (n.type === `${T1}` && o.meeting.meetingNumber && !o.meeting.zlkJwtToken) {
    const i = { mn: o.meeting.meetingNumber.toString(), name: o.meeting.userName, customerKey: o.meeting.customerKey ? kt(o.meeting.customerKey) : "" }, { jbhLeave: s } = { jbhLeave: `https://${Su}/wc/jbhLeave` }, a = `${s}/?${new URLSearchParams(i).toString()}`;
    fetch(a, { method: "POST", headers: { "Content-type": "application/json; charset=UTF-8" } });
  }
  return oe;
})), meetingMainEpics13: (e) => se(e, 2).pipe(he(() => {
  console.warn("Upgrade to latest version to optimize meeting experience");
}), Ie(oe)), meetingMainEpics14: (e) => se(e, 1).pipe(he((t) => {
  const { payload: { body: { upgradeVersion: r } } } = t, n = Ml(1e4);
  if (n && n.reason) {
    const o = n.reason.replace(/{(\d+)}/g, () => r);
    n.reason = o;
  }
  O(cr, n);
}), Ie(oe)), meetingMainEpics15: (e) => se(e, 4265).pipe(ae((t) => {
  const { payload: { body: r } } = t, { nShareType: n } = r;
  return O(OC, { userSharePronounType: n }), pC(n);
})), meetingMainEpics16: (e) => se(e, 4128).pipe(he((t) => {
  const { payload: { body: { meetingtoken: r } } } = t, { WebclientMeetingToken: n } = lt;
  r && xe.set(n, r, qe.SessionStorage);
}), Ie(oe)), meetingMainEpics17: (e, t) => e.pipe(ge(`${ti}`), z(() => !!t.value.meeting.quicklyLeave), ze(() => Ct(window, "beforeunload").pipe(he(() => {
  On.leaveMeeting();
}), Ie(oe)))), meetingMainEpics18: (e, t) => se(e, 8025).pipe(z((r) => !!r.payload.body.Zmk && !!t.value.meeting.isEnableZmkFromRWG), ae((r) => {
  const { payload: { body: { Zmk: n } } } = r;
  return Ec({ zmk: n });
})) }, ek = Wr(XT, { wakeLockEpic0: (e, t) => e.pipe(ge(`${ti}`), pe(t), z((r) => {
  let [, n] = r;
  return !!n.meeting.stayAwake;
}), he(async () => {
  try {
    const { isSafari: r, isIOSMobile: n } = ve;
    Ur && Ur.release().then(() => {
      Ur = null;
    }), "wakeLock" in navigator && ((r || n) && await gr(Vn(Ct(document, "click").pipe(Ge(1)), Ct(document, "touchend").pipe(Ge(1)))), Ur = await navigator.wakeLock.request("screen"), Ur.addEventListener("release", () => {
    }));
  } catch {
  }
}), ze(() => Ct(document, "visibilitychange").pipe(G(async () => {
  if (document.visibilityState === "visible") {
    const { isSafari: r, isIOSMobile: n } = ve;
    Ur && Ur.release().then(() => {
      Ur = null;
    }), "wakeLock" in navigator && ((r || n) && await gr(Vn(Ct(document, "click").pipe(Ge(1)), Ct(document, "touchend").pipe(Ge(1)))), Ur = await navigator.wakeLock.request("screen"));
  } else
    Ur && Ur.release().then(() => {
      Ur = null;
    });
}), Ie(oe)))), wakeLockEpic1: (e) => e.pipe(ge(`${ko}`)).pipe(he(() => {
  Ur && Ur.release().then(() => {
    Ur = null;
  });
}), Ie(oe)) }, QT, YT, { meetingInfoEpic: (e, t) => e.pipe(ge(`${su}`), ze((r) => {
  const n = Object.assign({}, r.payload, { password: kt(r.payload.password), topic: kt(r.payload.topic) }), { videoSDKUrl: o } = { meetingSDKUrl: `https://${Su}/api/v1/wc/info`, videoSDKUrl: `https://${Su}/wc/lsdk` };
  return function(i, s) {
    let a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "zoomsdkjsonpcallback";
    return new Vt((l) => {
      m7++;
      const u = `${a}${m7}`, d = document.createElement("script");
      Object.keys(s).forEach((c) => (s[c] === void 0 || s[c] === null) && delete s[c]), d.src = `${i}?${new URLSearchParams(Object.assign(s, { callback: u })).toString()}`, d.async = !0, d.onerror = (c) => l.error(c), document.getElementsByTagName("head")[0].appendChild(d), window[u] = (c) => {
        d.parentNode && d.parentNode.removeChild(d), delete window[u], l.next(c), l.complete();
      };
    });
  }(o, n).pipe(Xn((i) => Je({ status: !1, result: i.toString(), errorCode: wc })), G((i) => {
    const [s, a] = (l = Je(i), [z(u = (c) => c.status === !0 && c.result !== void 0, d)(vr(l)), z(v9(u, d))(vr(l))]);
    var l, u, d;
    return a.subscribe((c) => {
      KT.report(`get meeting info error, ${JSON.stringify(c)}`, ["Join Meeting Flow", "Get Meeting Info Error"], "error"), c.state || (c.errorCode === 3e3 && c.errorMessage === "Meeting password is incorrect" ? O(cr, { code: pi.WrongPasscode, reason: "Incorrect passcode." }) : c.errorCode === 3e3 && c.errorMessage === "The role type error" ? O(cr, { code: pi.RoleTypeMissing, reason: "Role type error" }) : c.errorCode === wc ? O(cr, { reason: "connection error" }) : c.errorCode === 3e3 ? O(cr, { reason: c.errorMessage, errorCode: pi.CommonError }) : c.errorCode === 300 ? O(cr, { reason: "This account does not exist or does not belong to you", errorCode: pi.CommonError }) : c.errorCode === 124 && c.errorMessage === "Parse lite sdk topic and pwd fail" ? O(cr, { reason: "Topic is invalid", errorCode: pi.CommonError }) : c.errorCode === 124 && c.errorMessage === "The java web token is expired or more than 2 days or ineffective." ? O(cr, { reason: "The token has expired, is over 2 days old, or is ineffective.", errorCode: pi.CommonError }) : c.errorCode === 124 && O(cr, { reason: "Verify JWT failed", errorCode: pi.CommonError }));
    }), s.pipe(iA((c) => {
      if (c.status === !0) {
        const { result: { mid: h, websdkClientFeatureOptions: v, showRecommendVersion: f } } = c;
        xe.init(h);
        const m = ((E, w) => {
          if (E.result) {
            const { result: { mn: _, ts: I, auth: D, track_auth: B, mid: L, tid: R, encryptedRWC: y, encryptedGEORWC: A, user_identity: k, meetingOptions: T, can_recording: N, wcXMPPConfig: F, call_out_country_json: $, isOriginalHost: re, support_call_out: fe, liveTranscription: le, logConfig: Ae, logEncryptionPubKey: Re, toll_numbers_json: Se, h323Password: ye, liveStreamInfo: Oe, rc_auto_delete: Ue, jwt_rc: Ve, op_rc: U, mediaSDKVersion: j, mediaSDKPathPrefix: P, zmk: Z, fileTransfer: H, fileServerDomain: me, accountId: Ce } } = E, { lang: _e, password: Me, topic: je, zlk: Ne, cv: Le, userName: Qe } = w;
            return { meetingNumber: _, meetingId: L, tid: R, ts: I, auth: D, passWord: Me, trackAuth: B, customerKey: k, encryptedRWC: JSON.parse(y || "{}"), encryptedGEORWC: JSON.parse(A || "{}"), meetingOptions: JSON.parse(T || "{}"), recordingEnable: N === "1", topic: je, userName: xe.get(lt.WebclientUserName) || Qe, cv: Le, zlkJwtToken: Ne, xmppConfig: JSON.parse(F || "{}"), callOutCountry: JSON.parse($ || "{}"), lang: _e, isOriginHost: re, isSupportCallOut: fe === "1", liveTranscription: JSON.parse(le || "{}"), logConfig: Ae, logEncryptionPubKey: Re, tollNumbers: Se === void 0 ? void 0 : JSON.parse(Se), h323Password: ye, liveStreamInfo: JSON.parse(Oe || "{}"), rcAutoDelete: Ue, jwtRc: Ve, opRc: U, mediaSDKPath: j && P ? `${rm(P)}/${j}` : void 0, zmk: Z, fileTransfer: JSON.parse(H || "{}"), fileServerDomain: me, accountId: Ce };
          }
          return E;
        })(c, r.payload);
        var p;
        f && (r == null || (p = r.payload) === null || p === void 0 || p.lang, console.log("Update VideoSDK-Web to the latest version to optimize meeting experience", "https://developers.zoom.us/docs/video-sdk/web/"));
        const g = [Je(Un(m)), P9(v7, t, nm())], C = ((E, w) => {
          const _ = [];
          if (E) {
            const I = E.split("").reverse();
            Object.keys(vo).filter((D) => /M:\d+(,\d+)*;V:\d+(,\d+)*/.test(vo[D])).forEach((D) => {
              const B = vo[D];
              let [L, R] = B.split(";");
              L.startsWith("V:") && ([L, R] = [R, L]);
              const y = R.slice(2).split(",").map((T) => I[Number(T) - 1]).reverse().join(""), A = parseInt(y, 16), k = zO[B];
              k && (Array.isArray(k) ? k : [k]).forEach((T) => {
                const N = T.mask ? (A & T.mask) > 0 : A;
                _.push(Je(T.action(N)));
              });
            });
          }
          return _;
        })(v);
        C.length > 0 && g.unshift(...C);
        const b = ((E, w) => {
          const _ = [];
          if (E) {
            const D = E.split("").reverse(), B = [];
            Q9.forEach((L) => {
              var R;
              const [y, A] = L.split("-"), k = Number(A) - 1;
              B.length < k && (B.length = k + 1), B[k] = (R = D[Number(y) - 1]) !== null && R !== void 0 ? R : "0";
            });
            for (let L = 0; L < B.length; L++) {
              var I;
              B[L] = (I = B[L]) !== null && I !== void 0 ? I : "0";
            }
            _.push(Je(L4(B.reverse().join(""))));
          }
          return _;
        })(v);
        return b.length > 0 && g.unshift(...b), Ua(...g);
      }
    }));
  }), jn(gC(performance.now())));
})), pingRWCEpic: v7 });
var MA = { exports: {} };
MA.exports = function() {
  function e(t) {
    for (var r = 1; r < arguments.length; r++) {
      var n = arguments[r];
      for (var o in n)
        t[o] = n[o];
    }
    return t;
  }
  return function t(r, n) {
    function o(i, s, a) {
      if (typeof document != "undefined") {
        typeof (a = e({}, n, a)).expires == "number" && (a.expires = new Date(Date.now() + 864e5 * a.expires)), a.expires && (a.expires = a.expires.toUTCString()), i = encodeURIComponent(i).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
        var l = "";
        for (var u in a)
          a[u] && (l += "; " + u, a[u] !== !0 && (l += "=" + a[u].split(";")[0]));
        return document.cookie = i + "=" + r.write(s, i) + l;
      }
    }
    return Object.create({ set: o, get: function(i) {
      if (typeof document != "undefined" && (!arguments.length || i)) {
        for (var s = document.cookie ? document.cookie.split("; ") : [], a = {}, l = 0; l < s.length; l++) {
          var u = s[l].split("="), d = u.slice(1).join("=");
          try {
            var c = decodeURIComponent(u[0]);
            if (a[c] = r.read(d, c), i === c)
              break;
          } catch {
          }
        }
        return i ? a[i] : a;
      }
    }, remove: function(i, s) {
      o(i, "", e({}, s, { expires: -1 }));
    }, withAttributes: function(i) {
      return t(this.converter, e({}, this.attributes, i));
    }, withConverter: function(i) {
      return t(e({}, this.converter, i), this.attributes);
    } }, { attributes: { value: Object.freeze(n) }, converter: { value: Object.freeze(r) } });
  }({ read: function(t) {
    return t[0] === '"' && (t = t.slice(1, -1)), t.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  }, write: function(t) {
    return encodeURIComponent(t).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
  } }, { path: "/" });
}();
var tk = MA.exports;
const { WebclientIsOnHold: rk, WebclientOpt: nk, WebclientParticipantId: ok, WebclientZoomId: ik, WebclientMeetingToken: sk } = lt, { WebclientDeviceId: g7 } = M1;
function y7(e) {
  let { retryCount: t, rwgServerList: r, userName: n, auth: o, trackAuth: i, meetingId: s, customerKey: a, tid: l, lang: u, ts: d, bid: c, botk: p, confID: h, zlkJwtToken: v, isAudioBridgeEnabled: f, isMeetingReset: m, cameraDevicesList: g, isFullHDVideoEnabled: C, isFullHDVideoShareEnabled: b } = e;
  const E = tk.get("_zm_mtk_guid");
  let w = xe.get(g7);
  if (w || (w = h0(), xe.set(g7, w, qe.LocalStorage)), r.length > t) {
    var _;
    const I = r[t], D = { dn2: kt(n), auth: o, browser: `${ve.browser}${ve.browserVersion} ${(_ = window) !== null && _ !== void 0 && _.crossOriginIsolated ? "SAB" : ""}`, trackAuth: i, mid: s, tid: l, lang: u, ts: d, "ZM-CID": w, _ZM_MTG_TRACK_ID: E || "", customer_key: kt(a), cfs: 0, islch: 1 };
    if (v)
      try {
        const { vendor: y } = nl(v);
        y && Object.assign(D, { vendor: y });
      } catch (y) {
        console.log(y);
      }
    I.rwcAuth ? Object.assign(D, { rwcAuth: I.rwcAuth }) : I.rwcToken && Object.assign(D, { rwcToken: I.rwcToken });
    const B = bC() ? 1 : ve.isIE || ve.isSupportEssentialAudioAndVideoAbility ? 2 : 0;
    Object.assign(D, { as_type: B }), [{ key: nk, queryKey: "opt" }, { key: ok, queryKey: "participantID" }, { key: ik, queryKey: "zoomid" }].forEach((y) => {
      const A = xe.get(y.key);
      A !== void 0 && (D[y.queryKey] = A);
    });
    const L = c && p && h;
    L && Object.assign(D, { bid: kt(c), confID: h }), xe.get(sk) && Object.assign(D, { isdj: 1 }), fr() && (Object.assign(D, { from: ve.isAndroidBrowser ? "android" : "ios" }), f && Object.assign(D, { useABAudio: 1 })), Object.assign(D, { clientCaps: ak({ isAudioBridgeEnabled: f && fr(), isBO: L, isFullHDVideoEnabled: C, isFullHDVideoShareEnabled: b }) });
    const R = m ? g.length > 0 ? 1 : 0 : 1;
    return Object.assign(D, { isCamera: R }), Object.assign(D, { clientOS: ve.isAndroidOrIOSBrowser ? ve.isIOSMobile ? "ios" : "android" : ve.isMacOS ? "mac" : "win" }), Object.assign(D, { audioFeature: ke.getAudioFeatureFlag() }), { queryObject: { ...D }, rwgServer: I };
  }
  return null;
}
function ak(e) {
  const { isAudioBridgeEnabled: t, isBO: r, isFullHDVideoEnabled: n, isFullHDVideoShareEnabled: o } = e;
  let i = qr.WebCameraIndication | qr.SendMeetingTokenSeparately | qr.SmartSummary | qr.LocalRecording | qr.LocalRecordingGrantPermission | qr.UnifyErrorType;
  const s = ke.getPTZCapability();
  return (s.pan || s.tilt || s.zoom) && (i |= qr.SupportFarEndCameraControl), ke.isSupportVideoShare() && (i |= qr.SupportVideoShare), t && ke.isSupportAudioBridgeAVSync() && (i |= qr.WebrtcAudioRtcpTime), ke.isSupportShareMultiStream() && (i |= qr.ShareMultiStream), ke.isSupportVideoLTR() && (i |= qr.VideoLTR), r || (i |= qr.RequestRemoteControl), n && ke.isSupportFullHDVideo() && (i |= qr.SupportSend1080PVideo), o && ke.isSupportFullHDVideoShare() && (i |= qr.SupportSend1080PVideoShare), i;
}
function ga(e, t) {
  return t ? ks(Ba(t), z(() => {
    const { socket: { zoomSocketStatus: r }, meeting: { meetingStatus: n, isMeetingReset: o } } = e.value;
    return r !== dt.Closed && n === xt.Joined && !o;
  })) : ks(z(() => {
    const { socket: { zoomSocketStatus: r }, meeting: { meetingStatus: n, isMeetingReset: o } } = e.value;
    return r !== dt.Closed && n === xt.Joined && !o;
  }));
}
const Js = We.createAgent();
let id;
const zi = Us.getInstance();
let sd;
const Qs = Y0.getInstance();
let ad;
const S7 = { zoomSocketStatus: dt.Closed, xmppSocketStatus: dt.Closed, mainSessionSocketStatus: dt.Closed, retryCount: 0, rwgServerList: [] }, lk = zr({ [`${ca}`]: M((e, t) => {
  let { payload: r } = t;
  e.zoomSocketStatus = r.status;
}), [`${I4}`]: M((e, t) => {
  let { payload: r } = t;
  const { rwgServerList: n } = e;
  n.find((o) => o.rwg === r.rwg) || n.push(r);
}), [`${A4}`]: M((e, t) => {
  let { payload: r } = t;
  e.retryCount = r;
}), [`${kd}`]: M((e, t) => {
  let { payload: r } = t;
  e.xmppSocketStatus = r;
}), [`${Md}`]: M((e, t) => {
  let { payload: r } = t;
  e.mainSessionSocketStatus = r;
}), [`${_4}`]: () => S7 }, S7), uk = { epics0: (e, t) => e.pipe(ge(`${Td}`), pe(t), z((r) => {
  let [, n] = r;
  return n.socket.zoomSocketStatus === dt.Closed;
}), ze((r) => {
  let [, n] = r;
  const { media: { patchedMediaSDKStatus: o } } = n;
  return (o === Nl.Loading ? ht(Bd, 1) : ne([0])).pipe(ze(() => {
    const { socket: { retryCount: i, rwgServerList: s }, meeting: a, breakoutRoom: l, video: u, share: d } = t.value;
    let c;
    const p = { ...a, retryCount: i, rwgServerList: s };
    if (u) {
      const { cameraDevicesList: v, isFullHDVideoEnabled: f } = u;
      Object.assign(p, { cameraDevicesList: v, isFullHDVideoEnabled: f });
    }
    if (d) {
      const { isFullHDVideoShareEnabled: v } = d;
      Object.assign(p, { isFullHDVideoShareEnabled: v });
    }
    if (l && l.currentRoom.status === Ee.Joining) {
      const { currentRoom: { boId: v, boConfId: f, boToken: m } } = l;
      Object.assign(p, { bid: v, botk: m, confID: f });
    }
    if (c = a.zlkJwtToken ? function(v) {
      const f = y7(v);
      if (f) {
        const { queryObject: m, rwgServer: g } = f, { topic: C, cv: b, meetingNumber: E } = v;
        return Object.assign(m, { topic: kt(C), iccv: b }), `wss://${g.rwg}/instantsdk/${E}?${new URLSearchParams(m).toString()}`;
      }
      return null;
    }(p) : function(v) {
      const f = y7(v);
      if (f) {
        const { queryObject: m, rwgServer: g } = f, { cv: C, meetingNumber: b } = v;
        return Object.assign(m, { jscv: C, browser: m.browser + " ComponentView" }), [{ key: rk, queryKey: "cfs" }].forEach((E) => {
          const w = xe.get(E.key);
          w !== void 0 && (m[E.queryKey] = w);
        }), `wss://${g.rwg}/wc/api/${b}?${new URLSearchParams(m).toString()}`;
      }
      return null;
    }(p), c) {
      const v = (h = c, Js.connect(h), id = new xn(), _i((f) => Js.on(Nr.Message, f), (f) => Js.off(Nr.Message, f), (f) => f.data).subscribe(id), id);
      return Kt(v.pipe(z((f) => typeof f == "string"), ae((f) => {
        try {
          return JSON.parse(f);
        } catch (m) {
          return console.error(m), { evt: 0 };
        }
      }), sA(), xs((f) => {
        if (f.evt !== 0 || !f.body || f.body.test !== "invalid parameters!")
          return js(f);
        O(cr, { code: pi.InvalidParameter, reason: "Invalid parameter" });
      }), jn(ca({ status: dt.Connecting, rwgUrl: c }))), v.pipe(z((f) => f instanceof ArrayBuffer), ae((f) => M9(f))));
    }
    var h;
    return oe;
  }));
})), epics1: (e, t) => e.pipe(ge(`${Td}`), pe(t), z((r) => {
  let [, n] = r;
  return n.socket.zoomSocketStatus === dt.Closed;
}), ze(() => {
  const [r, n, o, i] = [Nr.Open, Nr.Close, Nr.Error, Nr.Inactive].map((s) => _i((a) => Js.on(s, a), (a) => Js.on(s, a)));
  return Kt(r.pipe(G(() => Kt(Je(ca({ status: dt.Connected })), nr(6e4).pipe(pe(t), z((s) => {
    let [, a] = s;
    return a.meeting.meetingStatus === xt.Initial && !a.meeting.isMeetingReset;
  }), ae(() => (O(Hr, { reason: hr.Failover }), Tr(or.NoHeartbeat))))))), n.pipe(ga(t), ae(() => (O(Hr, { reason: hr.Failover }), Tr(or.Disconnect)))), i.pipe(ga(t), ae(() => (O(Hr, { reason: hr.Failover }), Tr(or.NoHeartbeat)))), o.pipe(pe(t), G((s) => {
    let [, a] = s;
    const { meeting: { meetingStatus: l, isMeetingReset: u }, socket: { rwgServerList: d, retryCount: c } } = a, p = [];
    if (l === xt.Initial && d != null && d.length) {
      const h = d[c];
      return nr(5e3).pipe(z(() => t.value.meeting.meetingStatus === xt.Initial), G(() => {
        const { socket: { rwgServerList: v, retryCount: f } } = t.value, m = [];
        return v.length > f + 1 ? m.push(A4(f + 1), ko({ retry: !0 })) : (O(cr, { reason: "connection error", errorCode: wc }), m.push(...ma(t.value))), ne(m);
      }), jn(cC(h == null ? void 0 : h.rwc)));
    }
    return u || l !== xt.Joined || (O(Hr, { reason: hr.Failover }), p.push(Tr(or.OnError))), ne(p);
  })));
})), epics2: (e, t) => e.pipe(ge(`${ko}`), ze((r) => r.payload && r.payload.retry ? Je(Td()).pipe(Ba(1e3), jn(ca({ status: dt.Closed }))) : Je(ca({ status: dt.Closed }))), Ba(100), he(() => {
  var r;
  t.value.socket.zoomSocketStatus === dt.Closed && (Js.close(), (r = id) === null || r === void 0 || r.complete());
})) }, dk = Wr(uk, { xmppEpics0: (e, t) => e.pipe(ge(`${ti}`), G(() => {
  const { meeting: { meetingOptions: r, zlkJwtToken: n, isWebinar: o } } = t.value, i = [];
  return (r.isPollingEnabled || n || o) && i.push(Ep()), ne(i);
})), xmppEpics1: (e, t) => e.pipe(ge(`${Ep}`), pe(t), z((r) => {
  let [, n] = r;
  return n.socket.xmppSocketStatus === "closed";
}), ze((r) => {
  let [, n] = r;
  const { meeting: { svcUrl: o, meetingNumber: i, conId: s } } = n, a = function(l, u, d) {
    return `wss://${l}/wc/media/${u}?type=x&cid=${d}`;
  }(o, i, s);
  return ((l) => (zi.connect(l), sd = new xn(), _i((u) => zi.on(qo.Message, u), (u) => zi.off(qo.Message, u)).subscribe(sd), sd))(a).pipe(z((l) => (l == null ? void 0 : l.evt) !== void 0), ae((l) => w4(l)), jn(kd(dt.Connecting)));
})), xmppEpics2: (e, t) => e.pipe(ge(`${Ep}`), ze(() => {
  const [r, n, o] = [qo.Open, qo.Close, qo.Error].map((i) => _i((s) => zi.on(i, s), (s) => zi.on(i, s)));
  return Kt(r.pipe(he(() => {
    const i = function() {
      const { isSupportEssentialAudioAndVideoAbility: s, isSupportAudioWorklet: a } = ve;
      return s && a ? 11 : 10;
    }();
    zi.join(i);
  }), tn(kd(dt.Connected))), n.pipe(ga(t, 500), ae(() => (O(Hr, { reason: hr.Failover }), Tr(or.DisconnectXmpp)))), o.pipe(ga(t, 500), ae(() => (O(Hr, { reason: hr.Failover }), Tr(or.OnError)))));
})), xmppEpics3: (e) => e.pipe(ge(`${C4}`), tn(kd(dt.Closed)), Ba(100), he(() => {
  var t;
  zi.close(), (t = sd) === null || t === void 0 || t.complete();
})) }, { mainSessionEpics0: (e, t) => e.pipe(ge(`${b1}`), pe(t), z((r) => {
  let [, n] = r;
  return n.socket.mainSessionSocketStatus === "closed";
}), ze((r) => {
  let [, n] = r;
  const { meeting: { svcUrl: o, meetingNumber: i, conId: s } } = n, a = function(l, u, d) {
    return `wss://${l}/wc/media/${u}?type=m&cid=${d}&mode=2`;
  }(o, i, s);
  return ((l) => (Qs.connect(l), ad = new xn(), _i((u) => Qs.on(Nr.Message, u), (u) => Qs.off(Nr.Message, u)).pipe(ae((u) => u.data)).subscribe(ad), ad))(a).pipe(ae((l) => {
    try {
      return JSON.parse(l);
    } catch (u) {
      return console.error(u), { evt: 0 };
    }
  }), z((l) => l.evt !== 0), sA(), ae((l) => Yo(l)), jn(Md(dt.Connecting)));
})), mainSessionEpics1: (e, t) => e.pipe(ge(`${b1}`), ze(() => {
  const [r, n, o] = [Nr.Open, Nr.Close, Nr.Error].map((i) => _i((s) => Qs.on(i, s), (s) => Qs.on(i, s)));
  return Kt(r.pipe(tn(Md(dt.Connected))), n.pipe(ga(t, 500), ae(() => (O(Hr, { reason: hr.Failover }), Tr(or.DisconnectMChannel)))), o.pipe(ga(t, 500), ae(() => (O(Hr, { reason: hr.Failover }), Tr(or.OnErrorMChannel)))));
})), mainSessionEpics2: (e) => e.pipe(ge(`${E4}`), tn(Md(dt.Closed)), he(() => {
  var t;
  Qs.close(), (t = ad) === null || t === void 0 || t.complete();
})) }), ck = { id: "userId", type: (e) => Wa(e) ? { userType: e, avatarBackgroundType: Math.floor(8 * Math.random()) + 1 } : { userType: e }, role: (e) => ({ userRole: e, isHost: aE(e) }), dn2: (e) => ({ displayName: no(e) }), bShareOn: "sharerOn", bSharePause: "sharerPause", bLocalRecordStatus: (e) => ({ bLocalRecord: e }), bGuest: "isGuest", bCapsRequestLT: "isRequestLT", customerKey: "userIdentity" }, E0 = (e) => {
  const t = {};
  return ["add", "remove", "update"].forEach((r) => {
    const n = r, o = e[n];
    o != null && (t[n] = o.reduce((i, s) => {
      const a = Object.keys(s).reduce((u, d) => {
        const c = ck[d];
        return typeof c == "function" ? Object.assign(u, c(s[d])) : typeof c == "string" ? Object.assign(u, { [`${c}`]: s[d] }) : Object.assign(u, { [`${d}`]: s[d] }), u;
      }, {}), l = i.find((u) => u.userId === a.userId);
      return l !== void 0 ? Object.assign(l, a) : i.push(a), i;
    }, []));
  }), t;
}, pk = { name: "displayName", node: (e) => ({ userId: Number(e) }), role: (e) => ({ userRole: Number(e) }) }, ih = (e) => Object.keys(e).reduce((t, r) => {
  const n = pk[r];
  return typeof n == "function" ? Object.assign(t, n(e[r])) : typeof n == "string" ? Object.assign(t, { [`${n}`]: e[r] }) : Object.assign(t, { [`${r}`]: e[r] }), t;
}, {}), b7 = { attendeesList: [], assistantList: [], xmppAttendeeList: [], allowTalkAttendeesList: [], failoverAttendeesList: [], isAdmitAllSilentUsers: !1 }, hk = zr({ [`${Uc}`]: M((e, t) => {
  let { payload: r } = t;
  r.add !== void 0 && r.add.length > 0 && r.add.forEach((n) => {
    if (n.userType === df.Assitant) {
      const o = e.assistantList.find((i) => i.userId === n.userId);
      o !== void 0 ? Object.assign(o, n) : e.assistantList.push(n);
    } else if (Bc(n.userRole)) {
      const o = e.allowTalkAttendeesList.find((i) => i.userId === n.userId);
      o !== void 0 ? Object.assign(o, n) : e.allowTalkAttendeesList.push(n);
    } else {
      const o = e.attendeesList.find((i) => i.userId === n.userId);
      o !== void 0 ? Object.assign(o, n) : e.attendeesList.push(n);
    }
  }), r.update !== void 0 && r.update.length > 0 && r.update.forEach((n) => {
    const o = e.attendeesList.find((i) => i.userId === n.userId);
    if (o !== void 0)
      Object.assign(o, n);
    else {
      const i = e.allowTalkAttendeesList.find((s) => s.userId === n.userId);
      if (i !== void 0)
        Object.assign(i, n);
      else {
        const s = e.assistantList.find((a) => a.userId === n.userId);
        s !== void 0 && Object.assign(s, n);
      }
    }
  }), r.remove !== void 0 && r.remove.length > 0 && r.remove.forEach((n) => {
    const o = e.attendeesList.findIndex((i) => i.userId === n.userId);
    if (o !== -1)
      e.attendeesList.splice(o, 1);
    else {
      const i = e.allowTalkAttendeesList.findIndex((s) => s.userId === n.userId);
      if (i !== -1)
        e.allowTalkAttendeesList.splice(i, 1);
      else {
        const s = e.assistantList.findIndex((a) => a.userId === n.userId);
        s !== -1 && e.assistantList.splice(s, 1);
      }
    }
  });
}), [`${nE}`]: M((e, t) => {
  let { payload: r } = t;
  const { xmppAttendeeList: n } = e, o = n.map((i) => i.jid);
  r.forEach((i) => {
    const { jid: s } = i, a = o.indexOf(s);
    a !== -1 ? Object.assign(n[a], i) : n.push(i);
  });
}), [`${Jw}`]: M((e, t) => {
  let { payload: r } = t;
  e.isAdmitAllSilentUsers = r;
}), [`${Xw}`]: M((e) => {
  e.attendeesList.forEach((t) => {
    t.bRaiseHand && (t.bRaiseHand = !1);
  });
}), [`${eE}`]: M((e) => {
  e.attendeesList.forEach((t) => {
    t.feedback > 0 && (t.feedback = 0);
  });
}), [`${lf}`]: M((e, t) => {
  let { payload: r } = t;
  e.failoverAttendeesList.push(r);
}), [`${Yw}`]: M((e, t) => {
  let { payload: r } = t;
  r.forEach((n) => {
    const o = e.failoverAttendeesList.findIndex((i) => i.zoomID === n.zoomID);
    o !== -1 && e.failoverAttendeesList.splice(o, 1);
  });
}), [`${tE}`]: M((e, t) => {
  let { payload: r } = t;
  const { jid: n, name: o } = r, i = e.xmppAttendeeList.find((s) => s.jid === n);
  i && (i.displayName = o);
}), [`${rE}`]: M((e, t) => {
  let { payload: r } = t;
  const { jid: n } = r, o = e.xmppAttendeeList.findIndex((i) => i.jid === n);
  n !== -1 && e.xmppAttendeeList.splice(o, 1);
}), [`${cu}`]: M((e, t) => {
  let { payload: r } = t;
  const { userId: n, key: o, value: i } = r, s = e.attendeesList.find((a) => a.userId === n);
  s && (s[`${o}`] = i);
}), [`${Qw}`]: () => b7 }, b7), fk = { epics0: (e, t) => se(e, gt).pipe(ae((r) => E0(r.payload.body)), pe(t), G((r) => {
  let [n, o] = r, i = [Uc(n)];
  const { meeting: { userId: s, isWebinar: a, isOnHold: l }, participants: { attendeesList: u, failoverAttendeesList: d, allowTalkAttendeesList: c } } = o, p = c.map((v) => v.userId);
  if (n.add) {
    const v = n.add.filter((m) => m.userId === s);
    v.length > 0 && v.forEach((m) => {
      m.bHold !== void 0 && i.push(pa(m.bHold)), O(xu, m);
    });
    const f = n.add.filter((m) => m.userId !== s);
    if (f.length > 0) {
      const m = f.filter((C) => !Bc(C.userRole)).map((C) => {
        const b = { ...C };
        if (Wa(C.userType)) {
          var E;
          const _ = (E = o.audio) === null || E === void 0 ? void 0 : E.dialout.find((I) => I.phoneNodeId === C.userId);
          _ && Object.assign(b, { phoneNumber: _.phoneNumber });
        }
        const w = d.find((_) => _.zoomID === C.zoomID);
        return w && Object.assign(b, { source: w.isOnHold ? "on hold" : "failover" }), b;
      }), g = m.filter((C) => !!C.source).map((C) => ({ zoomID: C.zoomID }));
      if (i.push(Yw(g)), O(AC, m), a) {
        const C = f.filter((b) => Bc(b.userRole));
        C.length > 0 && O(yi, C.map((b) => ({ userId: b.userId, isAllowToTalk: !0 })));
      }
    }
  }
  if (n.update) {
    const v = n.update.filter((m) => m.userId === s);
    v.length > 0 && v.forEach((m) => {
      O(Qr, m), m.bHold !== void 0 && i.push(pa(m.bHold));
    });
    const f = n.update.filter((m) => !(m.userId === s || p.includes(m.userId)));
    if (f.length > 0 && O(Mo, f), a) {
      const m = n.update.filter((g) => g.userId !== s && p.includes(g.userId));
      m.length > 0 && O(yi, m);
    }
  }
  if (n.remove) {
    const v = n.remove.map((f) => {
      const m = u.find((g) => g.userId === f.userId);
      return m ? f.action === 2 && f.nUserStatus === 1 ? m.bHold ? (i.push(lf({ zoomID: m.zoomID, isOnHold: !0 })), { ...f, ...m, reason: "on hold" }) : (i.push(lf({ zoomID: m.zoomID, isOnHold: !1 })), { ...f, ...m, reason: "failover" }) : { ...f, ...m } : null;
    }).filter((f) => !!f);
    if (O(am, v), a) {
      const f = n.remove.filter((m) => p.includes(m.userId));
      f.length > 0 && O(yi, f.map((m) => ({ userId: m.userId, isAllowToTalk: !1 })));
    }
  }
  const h = i.filter((v) => v.type === `${pa}`);
  if (h.length > 0) {
    const v = h[h.length - 1];
    i = i.filter((f) => f.type !== `${pa}`), v.payload !== l && (i.push(v), O(lm, !l));
  }
  return ne(i);
})), epics1: (e, t) => wa(e, 24595).pipe(G((r) => {
  const { payload: { body: { action: n, data: o } } } = r, { meeting: { jid: i }, participants: { xmppAttendeeList: s } } = t.value, a = [];
  if (n === yo.rename) {
    o.forEach((u) => {
      a.push(tE(u));
    });
    const l = o.map((u) => ih(u));
    O(yi, l);
  }
  if (n === yo.Remove) {
    o.forEach((u) => {
      a.push(rE(u));
    });
    const l = o.map((u) => ({ ...ih(u), removed: !0 }));
    O(_C, l);
  }
  if ([yo.Add, yo.List, yo.update].includes(n)) {
    const l = o.map((u) => {
      const d = ih(u);
      return Object.keys(d).reduce((c, p) => (d[p] !== "" && Object.assign(c, { [p]: d[p] }), c), {});
    });
    if (O(yi, l), a.push(nE(l)), n === yo.update) {
      const u = o.find((d) => d.jid === i);
      if (u && u.bRaiseHand !== void 0) {
        const d = s.find((c) => c.jid === i);
        (d == null ? void 0 : d.bRaiseHand) !== u.bRaiseHand && O("MEETING_WEBINAR_ATTENDEE_RAISE_HAND", { bRaiseHand: u.bRaiseHand });
      }
    }
  }
  return ne(a);
})), epics2: (e) => se(e, 7951).pipe(he((t) => {
  t.payload.body.bStarted === !1 && O("ADMIT_ALL_SILENT_USERS_END", t.payload.body.bStarted);
}), ae((t) => Jw(t.payload.body.bStarted))), epics3: (e) => se(e, 7946).pipe(z((t) => {
  var r;
  return ["bRaiseHand", "feedback"].includes((r = t.payload.body) === null || r === void 0 ? void 0 : r.key) && t.payload.body.value === 0;
}), ae((t) => (O(Mo, {}), t.payload.body.key === "bRaiseHand" ? Xw() : eE()))) }, vk = Wr(fk), C7 = { audioEncodeStatus: "initial", audioDecodeStatus: "initial", videoEncodeStatus: "initial", videoDecodeStatus: "initial", sharingEncodeStatus: "initial", sharingDecodeStatus: "initial", assetsPath: "", mediaConstraints: void 0, fileWithVersion: !1, enforceMultipleVideos: !1, enforceVirtualBackground: !1, enableAudioQos: !0, enableVideoQos: !0, isAudioBridgeReceiveReady: !1, isAudioBridgeSendReady: !1, isMediaAgentInitialized: !1, disableRenderLimits: !1, adaptedABOptionForMediaSDK: "" }, mk = zr({ [`${w1}`]: M((e, t) => {
  let { payload: r } = t;
  e.audioDecodeStatus = r;
}), [`${C1}`]: M((e, t) => {
  let { payload: r } = t;
  e.audioEncodeStatus = r;
}), [`${Pd}`]: M((e, t) => {
  let { payload: r } = t;
  e.sharingDecodeStatus = r;
}), [`${A1}`]: M((e, t) => {
  let { payload: r } = t;
  e.sharingEncodeStatus = r;
}), [`${I1}`]: M((e, t) => {
  let { payload: r } = t;
  e.videoDecodeStatus = r;
}), [`${E1}`]: M((e, t) => {
  let { payload: r } = t;
  e.videoEncodeStatus = r;
}), [`${Jv}`]: M((e, t) => {
  let { payload: r } = t;
  e.mediaConstraints = r.mediaConstraints, e.assetsPath = r.assetsPath, e.fileWithVersion = r.fileWithVersion, e.enforceMultipleVideos = !!r.enforceMultipleVideos, e.enforceVirtualBackground = r.enforceVirtualBackground, e.skipJsMedia = r.skipJsMedia, e.patchJsMedia = r.patchJsMedia, e.alternativeNameForVideoPlayer = r.alternativeNameForVideoPlayer, r.enforceMultipleVideos && typeof r.enforceMultipleVideos == "object" && (e.disableRenderLimits = !!r.enforceMultipleVideos.disableRenderLimits);
}), [`${O4}`]: M((e, t) => {
  let { payload: r } = t;
  const { type: n, encrypeKey: o, additionalType: i } = r, s = { encrypeKey: o, additionalType: i };
  n === "audio" ? e.audioEncrypt = s : n === "video" ? e.videoEncrypt = s : n === "sharing" && (e.sharingEncrypt = s);
}), [`${T4}`]: M((e, t) => {
  let { payload: r } = t;
  e.isEnableDecoderInWorklet = r;
}), [`${Dd}`]: M((e, t) => {
  let { payload: r } = t;
  e.patchedMediaSDKStatus = r;
}), [`${k4}`]: M((e, t) => {
  let { payload: r } = t;
  e.assetsPath = r;
}), [`${M4}`]: M((e, t) => {
  let { payload: r } = t;
  e.enableAudioQos = r.audioQos, e.enableVideoQos = r.videoQos;
}), [`${P4}`]: M((e, t) => {
  let { payload: r } = t;
  e.isAudioBridgeReceiveReady = r;
}), [`${D4}`]: M((e, t) => {
  let { payload: r } = t;
  e.isAudioBridgeSendReady = r;
}), [`${Qv}`]: M((e, t) => {
  let { payload: r } = t;
  e.isMediaAgentInitialized = r;
}), [`${L4}`]: M((e, t) => {
  let { payload: r } = t;
  e.adaptedABOptionForMediaSDK = r;
}), [`${N4}`]: (e) => ({ ...C7, mediaConstraints: e.mediaConstraints, assetsPath: e.assetsPath, fileWithVersion: e.fileWithVersion, enforceMultipleVideos: e.enforceMultipleVideos, disableRenderLimits: e.disableRenderLimits, enforceVirtualBackground: e.enforceVirtualBackground, alternativeNameForVideoPlayer: e.alternativeNameForVideoPlayer }) }, C7), rn = new class {
  constructor() {
    this.state = { mediaSDK: void 0, mediaSDKInstanceMap: /* @__PURE__ */ new Map(), tagName: "video-player" }, this.onceMap = /* @__PURE__ */ new WeakMap(), this.subscribers = [];
  }
  get(e) {
    return this.state[e];
  }
  dispatch(e, t, r) {
    t && Object.assign(this.state, t), e && this.notifySubscribers(e, r);
  }
  subscribe(e) {
    return this.subscribers.push(e), () => {
      const t = this.subscribers.indexOf(e);
      t !== -1 && this.subscribers.splice(t, 1);
    };
  }
  once(e, t) {
    this.onceMap.set(t, { event: e, unSubscribe: this.subscribe(t) });
  }
  notifySubscribers(e, t) {
    const r = [];
    this.subscribers.forEach((n) => {
      n(e, this.state, t);
      const o = this.onceMap.get(n);
      if (o) {
        const { event: i, unSubscribe: s } = o;
        i === e && (r.push(s), this.onceMap.delete(n));
      }
    }), r.forEach((n) => n());
  }
}();
var kr, ev;
(function(e) {
  e[e.ADD_RENDER_VIDEO = 1] = "ADD_RENDER_VIDEO", e[e.STOP_RENDER_VIDEO = 2] = "STOP_RENDER_VIDEO", e[e.START_SHARING = 23] = "START_SHARING", e[e.STOP_SHARING = 24] = "STOP_SHARING", e[e.SWITCH_CANVAS_FOR_VIDEO_CAPTURE = 25] = "SWITCH_CANVAS_FOR_VIDEO_CAPTURE", e[e.UPDATE_SHARING_DECODE_PARAM = 44] = "UPDATE_SHARING_DECODE_PARAM", e[e.UPDATE_CANVAS_SIZE = 46] = "UPDATE_CANVAS_SIZE", e[e.ZOOM_RENDER = 48] = "ZOOM_RENDER", e[e.WEBGL_LOST_REPLACE_CANVAS = 77] = "WEBGL_LOST_REPLACE_CANVAS", e[e.UPDATE_VIDEO_QUALITY = 78] = "UPDATE_VIDEO_QUALITY", e[e.SEND_RENDER_LOG = 79] = "SEND_RENDER_LOG";
})(kr || (kr = {})), function(e) {
  e[e.WEBGL_LOST_IN_MULTI_VIEW = -32] = "WEBGL_LOST_IN_MULTI_VIEW";
}(ev || (ev = {}));
const wu = "default-sesssion-key";
var I0, w7, E7;
function I7(e, t, r, n, o) {
  const i = document.createElement("canvas");
  i.id = n;
  const s = xA(i, e, t);
  return o(`VPISC:${window.devicePixelRatio},${s}`), i.style.pointerEvents = "none", i.style.position = "absolute", i.style.left = "0px", i.style.top = "0px", i.style.width = e + "px", i.width = e * Ti(i), i.style.height = t + "px", i.height = t * Ti(i), i.ariaHidden = "true", i.style.zIndex = r, i;
}
function A7(e, t) {
  const r = LA(() => {
    xA(e, t.clientWidth, t.clientHeight), [kr.UPDATE_CANVAS_SIZE, kr.UPDATE_SHARING_DECODE_PARAM].forEach((i) => {
      var s;
      (s = _s(t.getSessionId())) === null || s === void 0 || s.Notify_MeidaSDK(i, { width: t.clientWidth * Ti(e), height: t.clientHeight * Ti(e), canvas: e });
    }), e.style.width = t.clientWidth + "px", e.style.height = t.clientHeight + "px";
    try {
      e.width = t.clientWidth * Ti(e), e.height = t.clientHeight * Ti(e);
    } catch {
    }
    rn.dispatch("resize", void 0, e.id);
  }, 300), n = matchMedia(`(resolution: ${window.devicePixelRatio}dppx)`), o = new ResizeObserver(r);
  return n.addEventListener("change", r), o.observe(t), () => {
    (function(i) {
      A0.delete(i);
    })(e), o == null || o.disconnect(), n.removeEventListener("change", r);
  };
}
function PA(e, t) {
  Object.defineProperties(e, t.reduce((r, n) => (r[n] = { get: () => e.getAttribute(n), set: (o) => {
    o ? e.setAttribute(n, o) : e.removeAttribute(n);
  } }, r), {}));
}
function DA(e, t) {
  Object.entries(t).forEach(([r, n]) => {
    e.getAttribute(r) || e.setAttribute(r, n);
  });
}
function _7(e, t) {
  const r = e.getAttribute(t);
  return !(!r || r !== "true");
}
function _s(e = wu) {
  var t;
  return (t = rn.get("mediaSDKInstanceMap").get(e)) === null || t === void 0 ? void 0 : t();
}
function Qm() {
  if (typeof crypto.randomUUID == "function")
    return crypto.randomUUID();
  let e = (/* @__PURE__ */ new Date()).getTime(), t = performance && performance.now && 1e3 * performance.now() || 0;
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (r) => {
    let n = 16 * Math.random();
    return e > 0 ? (n = (e + n) % 16 | 0, e = Math.floor(e / 16)) : (n = (t + n) % 16 | 0, t = Math.floor(t / 16)), (r === "x" ? n : 3 & n | 8).toString(16);
  });
}
function LA(e, t) {
  let r;
  return function(...n) {
    clearTimeout(r), r = setTimeout(() => {
      e(...n);
    }, t);
  };
}
function NA(e, t) {
  const r = Object.keys(e), n = Object.keys(t);
  if (r.length !== n.length)
    return !1;
  for (const o of r) {
    const i = e[o], s = t[o];
    if (typeof i == "object" && typeof s == "object") {
      if (!NA(i, s))
        return !1;
    } else if (i !== s)
      return !1;
  }
  return !0;
}
function Wi(e) {
  return !e || e === "0";
}
function ys(e, t) {
  e == null || e.Notify_MeidaSDK(kr.SEND_RENDER_LOG, { message: t });
}
(function(e) {
  e.Video = "video", e.Share = "share";
})(I0 || (I0 = {})), function(e) {
  e.DEFAULT = "", e.MAIN = "main";
}(w7 || (w7 = {})), function(e) {
  e.Video_90P = "0", e.Video_180P = "1", e.Video_360P = "2", e.Video_720P = "3", e.Video_1080P = "4";
}(E7 || (E7 = {}));
const A0 = /* @__PURE__ */ new Map();
function xA(e, t, r) {
  const n = t >= 2 * window.screen.width || r >= 2 * window.screen.height ? 1 : window.devicePixelRatio, o = A0.get(e);
  return A0.set(e, n), o && o !== n && rn.dispatch("scale", void 0, e.id), n;
}
function Ti(e) {
  return A0.get(e) || window.devicePixelRatio;
}
function sh(e, t) {
  const { left: r, top: n, bottom: o, right: i, width: s, height: a } = e.getBoundingClientRect(), l = t.getBoundingClientRect();
  return { left: r - l.left, top: n - l.top, bottom: l.bottom - o, right: l.right - i, width: s, height: a };
}
const VA = [];
for (let e = 0; e <= 1; e += 0.01)
  VA.push(e);
class jA {
  constructor(t, r) {
    if (this.getRenderParams = r, this.el = document.createElement("div"), this.position = null, this.id = "", this.removePositionObserve = null, this.viewId = `${rn.get("tagName")}-${Qm()}`, this.getSDK = () => _s(this.container.getSessionId()), !t)
      throw new Error(`The ${rn.get("tagName")} must have a ${rn.get("tagName")}-container as its ancestor element.`);
    this.container = t, this.el.style.width = "100%", this.el.style.height = "100%";
  }
  getElement() {
    return this.el;
  }
  init() {
    this.removeSubscribe = rn.subscribe((t, r, n) => {
      n === this.getCanvas().id && (t === "resize" ? (this.updateVideoPosition(), setTimeout(() => {
        this.updateVideoPosition();
      }, 300)) : t === "scale" && ys(this.getSDK(), `VPSC:${Ti(this.getCanvas())}`));
    });
  }
  getCanvas() {
    return this.container.getCanvas();
  }
  initObservePosition() {
    this.stopObservePosition(), this.removePositionObserve = function(t, r, n) {
      const { wrapper: o = document.documentElement } = n, i = LA(r, 300);
      let s, a;
      const l = (u = 1, d = !1) => {
        s && (s.disconnect(), s = null);
        const { top: c, left: p, width: h, height: v, right: f, bottom: m } = sh(t, o);
        if (!h || !v)
          return void r({ hide: !0, cross: !1, width: 0, height: 0, top: 0, left: 0, bottom: 0, right: 0 });
        const g = ((_, I, D, B) => _ < 0 || I < 0 || D < 0 || B < 0)(c, m, p, f), C = ((_, I, D, B, L, R) => _ <= 0 && _ + R <= 0 || I <= 0 && I + R <= 0 || D <= 0 && D + L <= 0 || B <= 0 && B + L <= 0)(c, m, p, f, h, v), b = { root: o, threshold: g ? VA : u };
        g || (b.rootMargin = `${-c}px ${-f}px ${-m}px ${-p}px`);
        let E = !0, w = !0;
        d && (w = !1), r({ hide: C, cross: g, top: c, left: p, width: h, height: v, bottom: m, right: f }), i({ hide: C, cross: g, top: c, left: p, width: h, height: v, bottom: m, right: f }, !0), s = new IntersectionObserver(([_]) => {
          if (_.intersectionRatio === 0)
            return w ? l(1, !0) : void 0;
          if (u !== _.intersectionRatio) {
            if (!E)
              return l();
            l(_.intersectionRatio === 0 ? 1e-7 : _.intersectionRatio);
          }
          _.intersectionRatio === 1 && g && l(), E = !1;
        }, b), s.observe(t);
      };
      return l(), a = new ResizeObserver(() => l()), a.observe(t), () => {
        s == null || s.disconnect(), s = null, a == null || a.disconnect(), a = null;
      };
    }(this.el, (t, r) => {
      r ? setTimeout(() => {
        this.updateVideoPosition();
      }, 300) : this.updateVideoPosition(t);
    }, { wrapper: this.container });
  }
  stopObservePosition() {
    this.removePositionObserve && (this.removePositionObserve(), this.removePositionObserve = null);
  }
  getCurrentPosition(t) {
    return this.transformRectToPosition(sh(t, this.container));
  }
  transformRectToPosition(t) {
    const { left: r, width: n, height: o, bottom: i, top: s } = t, a = Ti(this.getCanvas());
    return { x: r * a, y: i * a, width: n * a, height: o * a, left: r * a, bottom: i * a, top: s * a };
  }
  playVideo(t) {
    this.initObservePosition(), this.id = t;
    const r = this.getCurrentPosition(this.el);
    this.addRender(Object.assign(Object.assign(Object.assign({}, r), { canvas: this.getCanvas(), zone: this.viewId, userId: Number(t), ssrc: Number(t) }), this.getRenderParams())), this.position = r;
  }
  updateVideoPosition(t) {
    if (!this.id)
      return;
    const r = this.transformRectToPosition(t || sh(this.el, this.container));
    this.position && NA(r, this.position) || (this.zoomRender(Object.assign(Object.assign(Object.assign({}, r), { userId: Number(this.id), canvas: this.getCanvas(), RGBA: this.container.getRGBA(), zone: this.viewId }), this.getRenderParams())), this.position = r);
  }
  stopVideo() {
    this.stopObservePosition(), this.id && this.position && (this.id && this.stopRender(Object.assign(Object.assign(Object.assign({}, this.position), { userId: Number(this.id), canvas: this.getCanvas(), RGBA: this.container.getRGBA(), zone: this.viewId }), this.getRenderParams())), this.position = null, this.id = "");
  }
  updateVideoQuality(t) {
    this.getSDK().Notify_MeidaSDK(kr.UPDATE_VIDEO_QUALITY, { userId: this.id, videoQuality: t });
  }
  destroy() {
    var t;
    this.stopVideo(), (t = this.removeSubscribe) === null || t === void 0 || t.call(this);
  }
}
class UA {
  constructor(t) {
    this.container = t, this.id = "", this.getSDK = () => {
      var r;
      return _s((r = this.container) === null || r === void 0 ? void 0 : r.getSessionId());
    }, this.el = document.createElement("video"), this.el.style.width = "100%", this.el.style.height = "100%", this.el.setAttribute("autoplay", "true"), this.el.setAttribute("muted", "true"), this.el.setAttribute("playsinline", "true");
  }
  getElement() {
    return this.el;
  }
  init() {
  }
  playVideo(t) {
    this.id = t, this.addRender({ userId: Number(t), videodom: this.el });
  }
  stopVideo() {
    this.id && (this.stopRender({ userId: Number(this.id), videodom: this.el }), this.id = "");
  }
  updateVideoQuality(t) {
  }
  destroy() {
    this.stopVideo();
  }
}
class gk extends jA {
  addRender({ width: t, height: r, x: n, y: o, canvas: i, zone: s, userId: a, left: l, bottom: u, top: d, fillMode: c, videoQuality: p }) {
    this.getSDK().Notify_MeidaSDK(kr.ADD_RENDER_VIDEO, { width: t, height: r, x: n, y: o, canvas: i, zone: s, userId: a, left: l, bottom: u, top: d, fillMode: c, videoQuality: p });
  }
  zoomRender({ width: t, height: r, x: n, y: o, userId: i, canvas: s, RGBA: a, zone: l, left: u, bottom: d, top: c }) {
    this.getSDK().Notify_MeidaSDK(kr.ZOOM_RENDER, { width: t, height: r, x: n, y: o, userId: i, canvas: s, RGBA: a, zone: l, left: u, bottom: d, top: c });
  }
  stopRender({ width: t, height: r, x: n, y: o, userId: i, canvas: s, doNotClean: a, RGBA: l, zone: u, left: d, bottom: c, top: p, videoQuality: h }) {
    this.getSDK().Notify_MeidaSDK(kr.STOP_RENDER_VIDEO, { width: t, height: r, x: n, y: o, userId: i, canvas: s, doNotClean: a, RGBA: l, zone: u, left: d, bottom: c, top: p, videoQuality: h });
  }
}
class yk extends UA {
  addRender({ userId: t, videodom: r }) {
    this.getSDK().Notify_MeidaSDK(kr.ADD_RENDER_VIDEO, { userId: t, videodom: r });
  }
  stopRender({ userId: t, videodom: r }) {
    this.getSDK().Notify_MeidaSDK(kr.STOP_RENDER_VIDEO, { userId: t, videodom: r });
  }
}
class Sk extends jA {
  addRender({ width: t, height: r, userId: n, canvas: o, isFromMainSession: i }) {
    this.getSDK().Notify_MeidaSDK(kr.START_SHARING, { width: t, height: r, canvas: o, ssrc: n, isFromMainSession: i });
  }
  zoomRender() {
  }
  stopRender({ canvas: t }) {
    this.getSDK().Notify_MeidaSDK(kr.STOP_SHARING, { canvas: t });
  }
}
class R7 extends UA {
  addRender({ userId: t, videodom: r }) {
    this.getSDK().Notify_MeidaSDK(kr.SWITCH_CANVAS_FOR_VIDEO_CAPTURE, [r]), this.getSDK().Notify_MeidaSDK(kr.ADD_RENDER_VIDEO, { userId: t, videodom: r });
  }
  stopRender({ userId: t, videodom: r }) {
    this.getSDK().Notify_MeidaSDK(kr.STOP_RENDER_VIDEO, { userId: t, videodom: r });
  }
}
const mi = "node-id", Jl = "media-type", tc = "video-quality", BA = "share-source", $A = "fill-mode", HA = "stop-no-clean";
class Ja extends HTMLElement {
  static get observedAttributes() {
    return [mi, Jl, tc];
  }
  constructor() {
    super(), this.container = null, PA(this, Ja.customAttributes), this.getRenderParams = this.getParsedParams.bind(this), this.attachShadow({ mode: "open" });
  }
  initRender() {
    var t, r, n;
    this.render && this.render.destroy();
    const o = this.getAttribute(mi), i = o && ((t = this.getCurrentMediaSDK()) === null || t === void 0 ? void 0 : t.isPreviewVideotag(o)), s = this.getAttribute(Jl);
    let a = 0;
    i ? (this.render = new R7(this.getContainer()), a = 1) : s === I0.Share ? (this.render = new Sk(this.getContainer(), this.getRenderParams), a = 2) : !((r = this.getCurrentMediaSDK()) === null || r === void 0) && r.getWebRTCFlag() ? (this.render = new yk(this.getContainer()), a = 4) : (this.render = new gk(this.getContainer(), this.getRenderParams), a = 3), this.getCurrentMediaSDK() && ys(this.getCurrentMediaSDK(), `VPREN:${a}`), this.shadowRoot && (this.shadowRoot.innerHTML = "", this.shadowRoot.appendChild(this.render.getElement())), this.render.init();
    const l = this.getAttribute(mi);
    Wi(l) || (n = this.render) === null || n === void 0 || n.playVideo(l);
  }
  getContainer() {
    return this.container || (this.container = this.closest(`${rn.get("tagName")}-container`)), this.container;
  }
  getCurrentMediaSDK() {
    var t;
    return _s((t = this.getContainer()) === null || t === void 0 ? void 0 : t.getSessionId());
  }
  getParsedParams() {
    return { fillMode: _7(this, $A), doNotClean: _7(this, HA), isFromMainSession: this.getAttribute(BA) === "main", videoQuality: this.getAttribute(tc) };
  }
  connectedCallback() {
    this.style.display = "block", DA(this, Ja.defaultValues), this.initRender(), this.removeSubscribe = rn.subscribe((t, r, n) => {
      var o, i;
      t === "failover" && n === (((o = this.getContainer()) === null || o === void 0 ? void 0 : o.getSessionId()) || wu) && (this.initRender(), Wi(this.getAttribute(mi)) || (i = this.render) === null || i === void 0 || i.playVideo(this.getAttribute(mi)));
    });
  }
  disconnectedCallback() {
    var t, r;
    (t = this.removeSubscribe) === null || t === void 0 || t.call(this), (r = this.render) === null || r === void 0 || r.destroy();
  }
  attributeChangedCallback(t, r, n) {
    var o, i;
    if (this.render)
      switch (t) {
        case mi:
          !!(!((o = this.getCurrentMediaSDK()) === null || o === void 0) && o.isPreviewVideotag(n)) != this.render instanceof R7 && this.initRender(), Wi(r) && !Wi(n) ? this.render.playVideo(n) : Wi(r) || Wi(n) ? Wi(r) || this.render.stopVideo() : (this.render.stopVideo(), this.render.playVideo(n));
          break;
        case Jl:
          this.initRender();
          break;
        case tc:
          (i = this.render) === null || i === void 0 || i.updateVideoQuality(n);
      }
  }
}
Ja.customAttributes = [mi, Jl, tc, BA, $A, HA], Ja.defaultValues = { [mi]: "", [Jl]: I0.Video };
const O7 = "session-id", ld = "z-index";
class Qa extends HTMLElement {
  static get observedAttributes() {
    return [O7, ld];
  }
  constructor() {
    super(), this.canvasId = "video-player-canvas-" + Qm(), this.needInitCanvas = !1, this.callback = null, PA(this, Qa.customAttributes);
    const t = this.attachShadow({ mode: "open" }), r = document.createElement("slot");
    this.appendCanvas = (n) => {
      t.insertBefore(n, r);
    }, t.appendChild(r);
  }
  connectedCallback() {
    this.style.display = "block", this.style.position || (this.style.position = "relative"), DA(this, Qa.defaultValues), this.needInitCanvas && this.initCanvasEvents(), this.removeSubscribe = rn.subscribe((t, r, n) => {
      t === "failover" && n === (this.getSessionId() || wu) && (this.replaceCanvas(), this.initCanvasEvents());
    });
  }
  disconnectedCallback() {
    var t, r, n;
    (t = this.removeListener) === null || t === void 0 || t.call(this), (r = this.removeSubscribe) === null || r === void 0 || r.call(this), this.callback && ((n = _s(this.getSessionId())) === null || n === void 0 || n.removeCallback(this.callback));
  }
  attributeChangedCallback(t, r, n) {
    t === ld && this.canvas && n && (this.canvas.style.zIndex = n);
  }
  createCanvas() {
    this.getCurrentMediaSDK() && ys(this.getCurrentMediaSDK(), "VPCC"), this.canvas = I7(this.clientWidth, this.clientHeight, this.getAttribute(ld) || "", this.canvasId, (t) => ys(this.getCurrentMediaSDK(), t)), this.appendCanvas(this.canvas), this.isConnected ? this.initCanvasEvents() : this.needInitCanvas = !0;
  }
  initCanvasEvents() {
    var t;
    this.removeListener = A7(this.canvas, this), this.callback = (r, n) => {
      var o, i;
      r === ev.WEBGL_LOST_IN_MULTI_VIEW && n.replaceCanvas && n.canvasId === ((o = this.canvas) === null || o === void 0 ? void 0 : o.id) && (this.replaceCanvas(), (i = _s(this.getSessionId())) === null || i === void 0 || i.Notify_MeidaSDK(kr.WEBGL_LOST_REPLACE_CANVAS, { canvasId: this.canvasId, canvas: this.canvas }));
    }, (t = this.getCurrentMediaSDK()) === null || t === void 0 || t.addCallback(this.callback);
  }
  replaceCanvas() {
    var t;
    if (this.getCurrentMediaSDK() && ys(this.getCurrentMediaSDK(), "VPRC"), this.canvas) {
      (t = this.removeListener) === null || t === void 0 || t.call(this);
      const r = I7(this.clientWidth, this.clientHeight, this.getAttribute(ld) || "", this.canvasId, (n) => ys(this.getCurrentMediaSDK(), n));
      this.removeListener = A7(r, this), this.shadowRoot && this.shadowRoot.replaceChild(r, this.canvas), this.canvas = r;
    }
  }
  getCanvas() {
    return this.canvas || this.createCanvas(), this.canvas;
  }
  getSessionId() {
    return this.getAttribute(O7) || void 0;
  }
  getCurrentMediaSDK() {
    return _s(this.getSessionId());
  }
  getRGBA() {
    return function(t) {
      let r = 0, n = 0, o = 0, i = 0;
      if (t[0] === "r")
        if (t[3] === "a") {
          const s = t.slice(5, -1).split(",").map((a) => parseInt(a.trim(), 10));
          r = s[0], n = s[1], o = s[2], i = s[3];
        } else {
          const s = t.slice(4, -1).split(",").map((a) => parseInt(a.trim(), 10));
          r = s[0], n = s[1], o = s[2];
        }
      else if (t[0] === "#") {
        let s = t.slice(1);
        s.length === 3 && (s = s.split("").map((l) => l.repeat(2)).join(""));
        const a = parseInt(s, 16);
        r = a >> 16 & 255, n = a >> 8 & 255, o = 255 & a;
      }
      return { R: r / 255, G: n / 255, B: o / 255, A: i };
    }(getComputedStyle(this).getPropertyValue("background-color"));
  }
}
Qa.customAttributes = [], Qa.defaultValues = {};
class mn {
  constructor() {
    this.audioPlaybackUrl = void 0, this.videoPlaybackUrl = void 0, this._audioElement = void 0, this._videoElement = void 0, this.videoSrc = void 0, this.isUsingSameFile = void 0;
  }
  static getInstance() {
    return this.instance === void 0 && (this.instance = new mn()), this.instance;
  }
  setAudioElement(t) {
    return this._audioElement === void 0 && (this._audioElement = new Audio()), new Promise((r, n) => {
      if (this.videoSrc === t.url)
        this._audioElement.pause(), this.isUsingSameFile = !0, this._videoElement.muted = !1, (i = this._videoElement).currentTime > 0 && !i.paused && !i.ended && i.readyState > 2 ? r("") : this._videoElement.play().then(() => {
          r("");
        }).catch(() => {
          n();
        });
      else {
        var o;
        this.isUsingSameFile = !1;
        const s = ve.isFirefox ? "canplay" : "canplaythrough", a = () => {
          this._audioElement.play().then(() => {
            this._audioElement.removeEventListener(s, a), r("");
          });
        }, l = () => {
          this._audioElement.removeEventListener(s, a), this._audioElement.removeEventListener("error", l), n();
        };
        this._audioElement.addEventListener(s, a), this._audioElement.addEventListener("error", l), this._audioElement.src = t.url, this._audioElement.loop = !!t.loop, eo(t.url) && this._audioElement.setAttribute("crossorigin", ""), this._audioElement.currentTime = Math.max((o = t.currentTime) !== null && o !== void 0 ? o : 0, 1e-4);
      }
      var i;
    });
  }
  setVideoElement(t) {
    return this._videoElement === void 0 && (this._videoElement = document.createElement("video")), new Promise((r, n) => {
      var o;
      this.videoSrc = t.url;
      const i = ve.isFirefox ? "canplay" : "canplaythrough", s = () => {
        this._videoElement.play().then(() => {
          this._videoElement.removeEventListener(i, s), r("");
        });
      }, a = () => {
        this._videoElement.removeEventListener(i, s), this._videoElement.removeEventListener("error", a), n();
      };
      this._videoElement.addEventListener(i, s), this._videoElement.addEventListener("error", a), this._videoElement.src = t.url, this.isUsingSameFile || (this._videoElement.muted = !0), this._videoElement.loop = !!t.loop, this._videoElement.currentTime = (o = t.currentTime) !== null && o !== void 0 ? o : 0, eo(t.url) && this._videoElement.setAttribute("crossorigin", ""), ve.isSafari && !document.getElementById(A2) && (this._videoElement.id = A2, this._videoElement.setAttribute("style", "position:fixed;top:-10000px;left:-10000px"), document.body.appendChild(this._videoElement));
    });
  }
  get audioElement() {
    return this.isUsingSameFile ? this._videoElement : this._audioElement;
  }
  get videoElement() {
    return this._videoElement;
  }
  stopAudioElement() {
    this.isUsingSameFile || this._audioElement && (this._audioElement.currentTime = 0, this._audioElement.pause());
  }
  stopVideoElement() {
    this._videoElement && this._videoElement.pause(), this.videoSrc = void 0;
  }
}
function tv(e) {
  const { audio: { isBackgroundNoiseSuppression: t, originalSound: r, highBitrate: n } } = e, o = { currentSelect: R2.Denoise }, i = { highfidelity: !1, stereo: !1 };
  if (r) {
    Object.assign(o, { currentSelect: R2.OriginalSound });
    const s = {};
    typeof r == "boolean" ? Object.assign(s, i) : Object.assign(s, { highfidelity: !!r.hifi, stereo: !!r.stereo }), Object.assign(o, { originalSound: s });
  }
  return Object.assign(o, { backgroundNoiseSuppression: t ? _2.Zoom : _2.Browser, highBitrate: n }), o;
}
function Eu(e, t, r, n) {
  const { meeting: { userId: o }, audio: { localShareAudioUserMutedList: i }, share: { isReceiveSharingFromMainSession: s } } = n;
  return i.filter((a) => a.userId !== t).forEach((a) => {
    e.setSharingAudioVolume(a.userId, !0, a.isFromMainSession);
  }), e.setSharingAudioVolume(t, r, !!s), t === o ? $c(r) : bE({ userId: t, muted: r });
}
async function Rs(e, t, r) {
  var n, o;
  const { audio: { audioSsrc: i, activeMicrophone: s, activeSpeaker: a, isAllowToTalk: l, customizeAudioOption: { speakerOnly: u, mute: d, microphoneId: c, speakerId: p }, isUsingMediaPlayback: h, mediaPlaybackFile: v, isHIDEnabled: f, microphoneDevicesList: m, isVerifiedAudioPermissionOnIOSMobile: g, speakerDevicesList: C }, meeting: { svcUrl: b, conId: E, reportDomain: w, isAudioBridgeEnabled: _, userId: I, supportLocalAB: D, abToken: B } } = t, L = be(t), R = !!u || Jt(L.userRole) && !l, y = r != null ? r : !R;
  fr() && (_ || console.warn("Cannot start audio due to the service is not ready."), await gr(oA(t, !y)).then((T) => {
    let [N, F] = T;
    return N && F ? Promise.resolve() : Promise.reject();
  }));
  let A = s, k = a;
  if (c !== void 0 || p !== void 0) {
    let T = m, N = C;
    if (m.length === 0) {
      const { microphones: F, speakers: $ } = await gr(c0());
      T = F, N = $;
    }
    c && T.findIndex((F) => F.deviceId === c) > -1 && (A = c), p && N.findIndex((F) => F.deviceId === c) > -1 && (k = p);
  }
  if (h && v != null && v.url) {
    const T = mn.getInstance();
    await T.setAudioElement(v), A = T.audioElement;
  } else
    mn.getInstance().stopAudioElement();
  return R && !g && ve.isIOSMobile && await async function() {
    await navigator.mediaDevices.getUserMedia({ audio: !0 });
  }(), (n = e.joinComputerAudio(i, A, k, y, tv(t), fr() ? { rwgHost: b, cid: E, nginxHost: w, abToken: B, supportLocalAB: D, useWebRTCOnDesktop: !ve.isAndroidOrIOSBrowser } : void 0, f ? { microphoneLabel: (o = m.find((T) => T.deviceId === s)) === null || o === void 0 ? void 0 : o.label, defaultMuted: !(L == null || !L.muted) } : void 0)) === null || n === void 0 ? void 0 : n.then(() => {
    d && (We.createAgent().mute(I, !0), e.muteAudio()), L != null && L.muted ? e.muteAudio() : e.unmuteAudio();
  });
}
async function Ym(e, t, r) {
  const n = [], { audio: { isJoinComputerAudioBeforeSharingAudio: o, mutedBeforeSharingAudio: i } } = r, s = be(r);
  return o === !0 && (await Rs(e, r), n.push(Ga(void 0)), i === !1 && (n.push(fu(zl.SharingAudio)), t.mute(s.userId, !1)), n.push(ei(void 0))), n;
}
async function T7(e, t, r) {
  const { audio: { isSharingAudio: n }, meeting: { userId: o } } = r, i = [];
  if (i.push(Eu(e, o, !0, r)), n) {
    await e.leaveSharingAudio(!1), i.push(qa(!1));
    const s = await Ym(e, t, r);
    i.push(...s), setTimeout(() => {
      O(za, { state: "off" });
    }, 0);
  }
  return i.push(ep(!1)), i;
}
async function rv(e, t, r) {
  const { audio: { audioSsrc: n, activeMicrophone: o, activeSpeaker: i }, meeting: { svcUrl: s, conId: a, reportDomain: l, supportLocalAB: u, abToken: d } } = r, c = be(r), p = [];
  if (!wo()) {
    const h = await async function(v, f) {
      const m = [], g = be(f), { audio: { isMicrophoneForbidden: C } } = f;
      return (g == null ? void 0 : g.audio) === et.Computer && (m.push(Ga(!0)), m.push(ei(g.muted)), g.muted || v.muteAudio(), await v.leaveComputerAudio(), m.push(Uu(0)), C && m.push(bm(!1))), m;
    }(e, r);
    p.push(...h);
  }
  return await e.leaveSharingAudio(!0), await e.joinSharingAudio({ ssrc: n, microphoneDeviceId: o, speakerDeviceId: i, isCaptureAudio: Jt(c.userRole), audioBridge: fr() ? { rwgHost: s, cid: a, nginxHost: l, abToken: d, supportLocalAB: u, useWebRTCOnDesktop: !ve.isAndroidOrIOSBrowser } : void 0 }), p.push(ep(!0)), p.push(qa(!0)), p.push(Eu(e, c.userId, !1, r)), p.findIndex((h) => h.type === `${Ga}` && h.payload === !0) > -1 && (p.push(zo(Gn.SharingAudio)), t.mute(r.meeting.userId, !0)), setTimeout(() => {
    O(za, { state: "on" });
  }, 0), p;
}
mn.instance = void 0;
const Iu = () => {
  if (CC())
    return !0;
  {
    var e;
    let { browser: r } = ve;
    if (r = (e = r) === null || e === void 0 ? void 0 : e.toLocaleLowerCase(), r.indexOf("safari") > -1 && r.indexOf("ios-safari") === -1) {
      var t;
      const n = (t = navigator.userAgent.match(/version\/(\d+\.?\d+)/i)) === null || t === void 0 ? void 0 : t[1];
      return Sc(n || "", "15.2") >= 0 && Sc(n || "", "17.1") < 0;
    }
    return !1;
  }
};
function k7(e, t, r) {
  for (let n = 0; n < r.length && t.length !== 0; n++) {
    const { userId: o, displayName: i } = r[n];
    if (t.includes(o)) {
      const s = e.find((a) => a.userId === o);
      s && (s.displayName = i, t.splice(t.indexOf(o), 1));
    }
  }
}
function wo() {
  return ke.isSupportOpenMicWhenShareAudio();
}
function M7(e) {
  return ke.isSupportAudioDenoise(e);
}
function P7() {
  return ke.isSupportStereoAudio();
}
function D7() {
  var e;
  return typeof ((e = window.navigator.hid) === null || e === void 0 ? void 0 : e.requestDevice) == "function";
}
function nv(e, t, r) {
  const { audio: { isAllowToTalk: n, customizeAudioOption: o }, media: { audioDecodeStatus: i, audioEncodeStatus: s } } = e;
  return { encodeInitStatus: Jt(t.userRole) && !n || r || o != null && o.speakerOnly || fr() ? "success" : s, decodeInitStatus: fr() ? "success" : i };
}
function _0(e, t, r) {
  fr() ? oA(t, r).subscribe((n) => {
    let [o, i] = n;
    o && i && e.joinOrLeaveVoip(!0);
  }) : e.joinOrLeaveVoip(!0);
}
const jo = We.createAgent(), Kr = rp(Vr(ke.getInstance())), L7 = (e) => !e.muted, ml = We.createAgent(), Zi = rp(Vr(ke.getInstance())), ah = We.createAgent(), Ys = rp(Vr(ke.getInstance())), ud = { asnIds: { asn1: { userId: 0, displayName: null }, asn2: { userId: 0, displayName: null }, asn3: { userId: 0, displayName: null } }, microphoneDevicesList: [], speakerDevicesList: [], activeMicrophone: "default", activeSpeaker: "default", isMicrophoneForbidden: !1, audioSsrc: 0, bCanUnmute: !1, bMutedUponEntry: !1, isAllowToTalk: void 0, dialout: [], crcDevice: [], canPlayAudio: !1, mutedSource: void 0, unmutedSource: void 0, isUserGrantCaptureAudio: !1, webrtcRestartCount: 0, isComputerAudioLoading: !1, isUsingMediaPlayback: !1, customizeAudioOption: {}, localShareAudioUserMutedList: [], locallyMutedAudioList: [], localUserAudioVolumeList: [], isStopAllImcomingAudio: !1, statistic: { encode: { sample_rate: 0, rtt: 0, jitter: 0, avg_loss: 0, max_loss: 0, bandwidth: 0, bitrate: 0 }, decode: { sample_rate: 0, rtt: 0, jitter: 0, avg_loss: 0, max_loss: 0, bandwidth: 0, bitrate: 0 } } }, bk = zr({ [`${uE}`]: M((e, t) => {
  let { payload: r } = t;
  e.asnIds = { ...r };
}), [`${dE}`]: M((e, t) => {
  let { payload: r } = t;
  e.bCanUnmute = r;
}), [`${cE}`]: M((e, t) => {
  let { payload: r } = t;
  const { sequence: n, phoneNumber: o } = r;
  e.dialout.findIndex((i) => i.sequence === n) === -1 && e.dialout.push({ sequence: n, phoneNumber: o, returnCode: -1, uuid: h0() });
}), [`${pE}`]: M((e, t) => {
  let { payload: r } = t;
  const { sequence: n, code: o, nodeId: i } = r, s = e.dialout.find((a) => a.sequence === n);
  s && (s.returnCode = o, i && (s.phoneNodeId = i));
}), [`${pf}`]: M((e, t) => {
  let { payload: r } = t;
  e.isAllowToTalk = r, e.isAllowToTalkAttendeeConnected = !1;
}), [`${zo}`]: M((e, t) => {
  let { payload: r } = t;
  e.mutedSource = r;
}), [`${fu}`]: M((e, t) => {
  let { payload: r } = t;
  e.unmutedSource = r;
}), [`${hE}`]: M((e, t) => {
  let { payload: r } = t;
  e.audioSsrc = r;
}), [`${fE}`]: M((e, t) => {
  let { payload: r } = t;
  e.bMutedUponEntry = r;
}), [`${vE}`]: M((e, t) => {
  let { payload: r } = t;
  e.isUserGrantCaptureAudio = r;
}), [`${bm}`]: M((e, t) => {
  let { payload: r } = t;
  e.isMicrophoneForbidden = r;
}), [`${Uu}`]: M((e, t) => {
  let { payload: r } = t;
  e.webrtcRestartCount = r;
}), [`${mE}`]: M((e, t) => {
  let { payload: r } = t;
  e.microphoneDevicesList = r;
}), [`${gE}`]: M((e, t) => {
  let { payload: r } = t;
  e.speakerDevicesList = r;
}), [`${hu}`]: M((e, t) => {
  let { payload: r } = t;
  e.activeMicrophone = r;
}), [`${X0}`]: M((e, t) => {
  let { payload: r } = t;
  e.activeSpeaker = r;
}), [`${Za}`]: M((e, t) => {
  let { payload: r } = t;
  e.canPlayAudio = r;
}), [`${ts}`]: M((e, t) => {
  let { payload: r } = t;
  e.isComputerAudioLoading = r;
}), [`${Cm}`]: M((e, t) => {
  let { payload: r } = t;
  if (r) {
    const { speakerOnly: n, mute: o, backgroundNoiseSuppression: i, originalSound: s, syncButtonsOnHeadset: a, mediaFile: l, microphoneId: u, speakerId: d, highBitrate: c } = r;
    e.customizeAudioOption.speakerOnly = n, e.customizeAudioOption.mute = o, e.customizeAudioOption.microphoneId = u, e.customizeAudioOption.speakerId = d, e.isBackgroundNoiseSuppression = !!i, e.isHIDEnabled = !!a, e.originalSound = s, e.highBitrate = !!c, Lu(e.mediaPlaybackFile, l) || (e.mediaPlaybackFile = l, e.isUsingMediaPlayback = !(l == null || !l.url)), o && (e.mutedSource = Gn.Inherited);
  }
}), [`${hf}`]: M((e, t) => {
  let { payload: r } = t;
  e.isAllowToTalkAttendeeConnected = r;
}), [`${ei}`]: M((e, t) => {
  let { payload: r } = t;
  e.mutedBeforeSharingAudio = r;
}), [`${qa}`]: M((e, t) => {
  let { payload: r } = t;
  e.isSharingAudio = r;
}), [`${$c}`]: M((e, t) => {
  let { payload: r } = t;
  e.isShareAudioMuted = r;
}), [`${SE}`]: M((e, t) => {
  let { payload: r } = t;
  const { userId: n, isFromMainSession: o } = r;
  e.localShareAudioUserMutedList.findIndex((i) => i.userId === n) === -1 && e.localShareAudioUserMutedList.push({ userId: n, isFromMainSession: o, muted: !1 });
}), [`${bE}`]: M((e, t) => {
  let { payload: r } = t;
  const n = e.localShareAudioUserMutedList.find((o) => o.userId === r.userId);
  n && (n.muted = r.muted);
}), [`${Ga}`]: M((e, t) => {
  let { payload: r } = t;
  e.isJoinComputerAudioBeforeSharingAudio = r;
}), [`${ep}`]: M((e, t) => {
  let { payload: r } = t;
  e.isShareAudioEnabled = r;
}), [`${Hc}`]: M((e, t) => {
  let { payload: r } = t;
  const { data: { encoding: n, rate: o, ...i } } = r;
  e.statistic.encode = { bitrate: o, ...i };
}), [`${Fc}`]: M((e, t) => {
  let { payload: r } = t;
  const { data: { encoding: n, rate: o, ...i } } = r;
  e.statistic.decode = { bitrate: o, ...i };
}), [`${CE}`]: M((e, t) => {
  let { payload: r } = t;
  e.locallyMutedAudioList.findIndex((n) => n === r) === -1 && e.locallyMutedAudioList.push(r);
}), [`${zc}`]: M((e, t) => {
  let { payload: r } = t;
  const n = e.locallyMutedAudioList.findIndex((o) => o === r);
  n !== -1 && e.locallyMutedAudioList.splice(n, 1);
}), [`${wE}`]: M((e, t) => {
  let { payload: r } = t;
  const n = e.localUserAudioVolumeList.find((o) => o.userId === r.userId);
  n ? n.volume = r.volume : e.localUserAudioVolumeList.push(r);
}), [`${EE}`]: M((e, t) => {
  let { payload: r } = t;
  const n = e.localUserAudioVolumeList.findIndex((o) => o.userId === r.userId);
  n !== -1 && e.localUserAudioVolumeList.splice(n, 1);
}), [`${ff}`]: M((e, t) => {
  let { payload: r } = t;
  e.isBackgroundNoiseSuppression = r;
}), [`${IE}`]: M((e, t) => {
  let { payload: r } = t;
  e.isHIDEnabled = r;
}), [`${vf}`]: M((e, t) => {
  let { payload: r } = t;
  e.mediaPlaybackFile = r, e.isUsingMediaPlayback = !(r == null || !r.url);
}), [`${mf}`]: M((e, t) => {
  let { payload: r } = t;
  e.isStopAllImcomingAudio = r;
}), [`${AE}`]: M((e, t) => {
  let { payload: r } = t;
  e.isVerifiedAudioPermissionOnIOSMobile = r;
}), [`${wm}`]: M((e, t) => {
  let { payload: r } = t;
  e.isAudioBridgeSignalReconnecting = r;
}), [`${gf}`]: M((e, t) => {
  let { payload: r } = t;
  e.originalSound = r;
}), [`${Ls}`]: M((e, t) => {
  let { payload: r } = t;
  e.leaveAudioSource = r;
}), [`${Wc}`]: M((e, t) => {
  let { payload: r } = t;
  e.secondaryAudioMicrophoneId = r;
}), [`${_E}`]: M((e, t) => {
  let { payload: r } = t;
  const { sequence: n, ip: o, protocol: i } = r;
  e.crcDevice.findIndex((s) => s.sequence === n) === -1 && e.crcDevice.push({ sequence: n, ip: o, protocol: i, transId: 0, uuid: h0() });
}), [`${RE}`]: M((e, t) => {
  let { payload: r } = t;
  const { sequence: n, transID: o, result: i } = r, s = e.crcDevice.find((a) => a.sequence === n);
  s && Object.assign(s, { transId: o, returnCode: i });
}), [`${yE}`]: (e, t) => {
  let { dialout: r, crcDevice: n, locallyMutedAudioList: o, localUserAudioVolumeList: i, customizeAudioOption: s, originalSound: a, highBitrate: l, isHIDEnabled: u, isBackgroundNoiseSuppression: d, isStopAllImcomingAudio: c, mediaPlaybackFile: p, isUsingMediaPlayback: h, isVerifiedAudioPermissionOnIOSMobile: v, activeSpeaker: f, activeMicrophone: m } = e, { payload: g } = t;
  return g ? { ...ud, dialout: r, crcDevice: n, locallyMutedAudioList: o, localUserAudioVolumeList: i, customizeAudioOption: { ...ud.customizeAudioOption, speakerOnly: s.speakerOnly }, originalSound: a, highBitrate: l, isHIDEnabled: u, isBackgroundNoiseSuppression: d, isStopAllImcomingAudio: c, mediaPlaybackFile: p, isUsingMediaPlayback: h, isVerifiedAudioPermissionOnIOSMobile: v, activeSpeaker: f, activeMicrophone: m } : { ...ud };
} }, ud), Ck = { dialEpics0: (e, t) => se(e, 8198).pipe(pe(t), z((r) => {
  let [n, o] = r;
  return o.audio.dialout.map((i) => i.sequence).includes(n.payload.seq);
}), G((r) => {
  let [n, o] = r;
  const { payload: { seq: i, body: { phoneNodeID: s, result: a } } } = n, l = [pE({ code: a, sequence: i, nodeId: s })], { audio: { dialout: u } } = o, d = u.find((h) => h.sequence === i), c = { code: a };
  if (d && (Object.assign(c, { phoneNumber: d.phoneNumber, uuid: d.uuid }), s && Object.assign(c, { userId: s })), O(YC, c), a === lo.Success) {
    if (O(XC), s && ft(o).findIndex((h) => h.userId === s) > -1) {
      var p;
      const h = (p = o.audio.dialout.find((v) => v.sequence === i)) === null || p === void 0 ? void 0 : p.phoneNumber;
      h && (l.push(cu({ userId: s, key: "phoneNumber", value: h })), O(Mo, [{ userId: s, phoneNumber: h }]));
    }
  } else
    [lo.Canceling, lo.Canceled, lo.CancelFailed].includes(a) ? a === lo.Canceled ? O(tw) : a === lo.CancelFailed && O(rw) : [lo.Calling, lo.Ringing, lo.Accepted, lo.Success].indexOf(a) === -1 && O(ew);
  return ne(l);
})), dialEpics1: (e, t) => se(e, 4120).pipe(pe(t), z((r) => {
  let [n, o] = r;
  return o.audio.crcDevice.map((i) => i.sequence).includes(n.payload.seq);
}), G((r) => {
  let [n, o] = r;
  const { payload: { seq: i, body: { result: s, transID: a } } } = n, { audio: { crcDevice: l } } = o, u = [], d = l.find((c) => c.sequence === i);
  return d && (O(dw, { code: s, ip: d.ip, protocol: d.protocol, uuid: d.uuid }), u.push(RE({ sequence: i, transID: a, result: s }))), s === xd.Success ? O(cw) : [xd.Success, xd.Ringing].includes(s) || O(pw), ne(u);
})) }, wk = { epics0: (e, t) => se(e, 12033).pipe(pe(t), ae((r) => {
  let [n, o] = r;
  const { participants: { allowTalkAttendeesList: i } } = o, s = n.payload.body;
  let a = {};
  if (s) {
    const l = ft(o), u = Object.keys(s).map((c) => ({ key: c, userId: s[c] })), d = u.map((c) => c.userId);
    k7(u, d, l), i.length > 0 && d.length > 0 && k7(u, d, i), a = u.reduce((c, p) => ({ ...c, [`${p.key}`]: { userId: p.userId, displayName: p.displayName } }), {}), O(JC, Object.values(a));
  }
  return uE(a);
})), epics1: (e, t) => se(e, 16135).pipe(pe(t), he((r) => {
  let [n, o] = r;
  const { payload: { body: { id: i, bLeadershipOn: s } } } = n, { audio: { bCanUnmute: a } } = o, l = be(o);
  if (l) {
    const { isHost: u, bCoHost: d, userId: c, audio: p, muted: h } = l, v = u || d;
    s && Xr(c, i) && (p !== null && p !== "" && h !== !0 || !v && !a || O(jd, Rp.Spotlight));
  }
}), Ie(oe)), epics2: (e, t) => se(e, 12037).pipe(pe(t), he((r) => {
  let [, n] = r;
  const o = be(n);
  (o == null ? void 0 : o.audio) !== null && (o == null ? void 0 : o.audio) !== "" && (o == null ? void 0 : o.muted) == 1 && O(jd, Rp.Unmute);
}), Ie(oe)), epics3: (e, t) => se(e, En).pipe(z((r) => r.payload.body && ["bCanUnmute", "bMutedAll", "bMutedUponEntry"].some((n) => r.payload.body[n] !== void 0)), G((r) => {
  const { payload: { body: { bCanUnmute: n, bMutedAll: o, bMutedUponEntry: i } } } = r, s = [];
  if (n !== void 0 && s.push(dE(r.payload.body.bCanUnmute)), o !== void 0) {
    const a = be(t.value);
    (a == null ? void 0 : a.audio) !== et.Computer && (a == null ? void 0 : a.audio) !== et.Phone || a.muted != 0 || r.payload.body.bMutedAll && s.push(zo(Gn.PassiveByMuteAll));
  }
  return i !== void 0 && s.push(fE(r.payload.body.bMutedUponEntry)), ne(s);
})), epics4: (e, t) => se(e, gt).pipe(pe(t), z((r) => {
  let [, n] = r;
  return n.socket.zoomSocketStatus === dt.Connected;
}), G((r) => {
  let [n, o] = r;
  const { payload: { body: { update: i } } } = n;
  if (i != null && i.some((s) => s.audio !== void 0 || s.muted !== void 0)) {
    const { meeting: { userId: s } } = o, a = i.filter((u) => u.id !== s), l = i.filter((u) => u.id === s);
    if (a && a.forEach((u) => {
      O(QC, u);
    }), l.length > 0)
      return Ns(t).pipe(G((u) => {
        const { audio: { mutedSource: d, unmutedSource: c, isAllowToTalk: p, isShareAudioEnabled: h, isSharingAudio: v, isAudioBridgeSignalReconnecting: f, leaveAudioSource: m, customizeAudioOption: { speakerOnly: g } } } = t.value, C = u;
        return ne(l).pipe(Di(async (b) => {
          const E = [];
          if (b.audio !== C.audio)
            if (b.audio === "")
              O(du, { source: m }), E.push(Ls(void 0));
            else if (b.audio === et.Computer) {
              const w = Jt(C.userRole) && !p || !!g;
              v && O(va), w && (O(va), ve.isIOSMobile && E.push(AE(!0))), f && (O(va), E.push(wm(!1)));
            } else
              b.audio === et.Phone && (C.audio === et.Computer && (await Kr.leaveComputerAudio(), E.push(Ls(uu.Pstn)), jo.joinOrLeaveVoip(!1)), O(q1));
          if (C.audio !== "" && b.muted !== C.muted) {
            if (b.muted !== C.muted) {
              if (b.muted === !0) {
                if (d !== Gn.Inherited) {
                  const w = d != null ? d : Gn.PassiveByMuteOne;
                  O(pm, { source: w });
                }
                C.audio !== et.Computer || h && !wo() || Kr.muteAudio();
              } else if (b.muted === !1) {
                if (c !== zl.Inherited) {
                  const w = c != null ? c : zl.Passive;
                  O(hm, { source: w });
                }
                C.audio === et.Computer && Kr.unmuteAudio();
              }
            }
            b.muted !== void 0 && E.push(zo(void 0), fu(void 0));
          }
          return E;
        }));
      }));
  }
  return oe;
})), epics5: (e, t) => se(e, 12036).pipe(pe(t), G((r) => {
  let [n, o] = r;
  const i = be(o), { media: { audioEncodeStatus: s } } = o, { promoterID: a, bAllowTalk: l } = n.payload.body;
  if ((i == null ? void 0 : i.userId) === a) {
    if (O(aw, l), l)
      return s !== "success" && Kr.enableAudioEncode(), _r("audio", s, "success").pipe(G((u) => (u && O(jd, Rp.AllowToTalk), oe)), jn(pf(!0)));
    if (jo.mute(a, !0), (i == null ? void 0 : i.audio) === et.Computer)
      return Kr.leaveComputerAudio(), nr(300).pipe(he(async () => {
        (Iu() ? gr(Vn(Ct(document, "click").pipe(Ge(1)), Ct(document, "touchend").pipe(Ge(1)))) : Promise.resolve(!0)).then(() => {
          Rs(Kr, o, !1);
        });
      }), Ie(oe), jn(pf(!1), zo(Gn.Inherited)));
  }
  return oe;
})), epics6: (e) => se(e, 8205).pipe(he((t) => {
  O("AUDIO_ALLOW_TO_TALK_RESPONSE", t.payload.body);
}), Ie(oe)), epics7: (e, t) => wa(e, 24597).pipe(pe(t), he((r) => {
  let [n, o] = r;
  const i = be(o);
  (i == null ? void 0 : i.audio) === et.Phone ? jo.audioDrop(i.userId) : (i == null ? void 0 : i.audio) === et.Computer && n.payload.body.bPromote;
}), Ie(oe)), epics8: (e, t) => se(e, 12035).pipe(pe(t), ze((r) => {
  let [n, o] = r;
  const { meeting: { currentUserAudioBeforeReset: i } } = o, { payload: { body: { ssrc: s } } } = n, a = Ns(t).pipe(G((l) => {
    if (i === et.Computer && (l == null || !l.audio)) {
      const { encodeInitStatus: u, decodeInitStatus: d } = nv(t.value, l);
      return _r("audio", u, d).pipe(z((c) => {
        let [p, h] = c;
        return p && h;
      }), he(() => {
        (Iu() ? gr(Vn(Ct(document, "click").pipe(Ge(1)), Ct(document, "touchend").pipe(Ge(1)))) : Promise.resolve(!0)).then(() => {
          _0(jo, t.value), Rs(Kr, t.value);
        });
        const { audio: { locallyMutedAudioList: c, localUserAudioVolumeList: p, isStopAllImcomingAudio: h } } = t.value;
        c.length > 0 && c.forEach((v) => {
          Kr.muteOrUnmuteOtherAudio(v, !0);
        }), p.length > 0 && p.forEach((v) => {
          Kr.adjustOtherAudioVolume(v.userId, v.volume);
        }), h && Kr.stopAllIncomingAudio(!0);
      }), tn(oC(void 0)));
    }
    return oe;
  }));
  return O(lw, s), Kt(Je(hE(s)), a);
})), epics9: (e, t) => se(e, 7952).pipe(ze((r) => ht(q1, 1).pipe(pe(t), he((n) => {
  let [, o] = n;
  const { BindStatus: i, nOperatorUserId: s } = r.payload.body, a = o.participants.attendeesList.find((l) => l.userId === s);
  i === !0 && O(nw, { operatorName: a == null ? void 0 : a.displayName, operatorUserId: s, operatorRole: a == null ? void 0 : a.userRole });
}), Ie(oe)))), epics10: (e, t) => Pe(e, X.UserGrantCaptureAudio).pipe(pe(t), G((r) => {
  let [n, o] = r;
  const i = be(o);
  var s;
  (s = i, (s == null ? void 0 : s.audio) === et.Computer ? Promise.resolve() : Te({ event: Qr, operations: [z((v) => v.audio !== void 0 && v.audio !== ""), Ge(1)] }, (v) => {
    let { audio: f } = v;
    return f === et.Phone || f === et.Computer;
  })).then(() => {
    O(va);
  });
  const { meeting: { isCurrentUserMutedBeforeReset: a }, audio: { bMutedUponEntry: l, isUserGrantCaptureAudio: u, isAllowToTalk: d, activeMicrophone: c } } = o, { payload: { data: p } } = n, h = [vE(!0)];
  if (i) {
    i.muted === !0 && d === !1 && (h.push(zo(Gn.Inherited)), jo.mute(i.userId, !0));
    const v = u || i.isHost || d;
    (a === !0 || !v && l) && (h.push(zo(Gn.Inherited)), jo.mute(i.userId, !0), a && h.push(iC(void 0))), p && c !== p && h.push(hu(p));
  }
  return ne(h);
})), epics11: (e) => Pe(e, X.UserForbiddedCaptureAudio).pipe(he(() => {
  O(ow);
}), tn(bm(!0))), epics12: (e) => Pe(e, X.AudioWebsocketBroken).pipe(he(() => {
  O(iw);
}), Ie(oe)), epics13: (e, t) => Pe(e, X.AudioZeroData).pipe(pe(t), xs((r) => {
  let [, n] = r;
  const { audio: { webrtcRestartCount: o, activeMicrophone: i } } = n;
  if (o < 3)
    return Kr.restoreWebRTC(i), Uu(o + 1);
})), epics14: (e, t) => e.pipe(ge(`${Za}`), z((r) => r.payload === !1), G(() => (O(sw), Vn(Ct(document, "click").pipe(Ge(1)), Ct(document, "touchend").pipe(Ge(1))).pipe(he(() => {
  _0(jo, t.value), Rs(Kr, t.value);
}), tn(Za(!0)))))), epics15: (e) => Pe(e, [X.JoinComputerAudioComplete, X.JoinSharingAudioComplete, X.LeaveComputerAudioComplete, X.LeaveSharingAudioComplete]).pipe(he(() => {
  rA.completeAudioAction();
}), Ie(oe)), epics16: (e, t) => Pe(e, X.AudioQosData).pipe(pe(t), ae((r) => {
  var n;
  let [o, i] = r;
  const { meeting: { isWebinar: s }, media: { audioEncodeStatus: a, audioDecodeStatus: l }, participants: { xmppAttendeeList: u, allowTalkAttendeesList: d } } = i, c = be(i), p = Sm(i);
  let h = p.length > 0, v = p.some(L7);
  s && (h = h || !!u.length, v = v || d.some(L7));
  const f = ((c == null ? void 0 : c.audio) === et.Computer || (c == null ? void 0 : c.audio) === et.Phone) && a === "success" && !(c != null && c.muted) && h, m = ((c == null ? void 0 : c.audio) === et.Computer || (c == null ? void 0 : c.audio) === et.Phone) && l === "success" && h && v;
  return (n = o.payload.data) !== null && n !== void 0 && n.encoding ? f ? (O(K1, o.payload), Hc(o.payload)) : Hc(Mc) : m ? (O(K1, o.payload), Fc(o.payload)) : Fc(Mc);
})), epics17: (e, t) => se(e, gt).pipe(pe(t), z((r) => {
  let [n, o] = r;
  const { payload: { body: i } } = n, { audio: { locallyMutedAudioList: s, localUserAudioVolumeList: a } } = o;
  return (s.length > 0 || a.length > 0) && (i == null ? void 0 : i.remove) && i.remove.length > 0;
}), G((r) => {
  let [n, o] = r;
  const { payload: { body: { remove: i } } } = n, { audio: { locallyMutedAudioList: s, localUserAudioVolumeList: a } } = o, l = s.concat(a.map((u) => u.userId)).filter((u) => i.indexOf((d) => d.id === u) !== -1);
  return l.length > 0 ? (l.forEach((u) => {
    Kr.muteOrUnmuteOtherAudio(u, !1);
  }), ne(l.map((u) => [zc(u), EE({ userId: u })]).flat())) : oe;
})), epics18: (e, t) => Pe(e, X.HidStatusMute).pipe(G((r) => {
  const { payload: { data: n } } = r, o = t.value, { meeting: { userId: i }, audio: { isShareAudioEnabled: s, bCanUnmute: a } } = o, l = [];
  if (n)
    s && !wo() && l.push(ei(!0)), l.push(zo(Gn.Active)), jo.mute(i, !0);
  else if (!s || wo()) {
    s && l.push(ei(!1));
    const u = be(o);
    (a || u != null && u.isHost || u != null && u.bCoHost) && (l.push(fu(zl.Active)), jo.mute(i, !1));
  }
  return ne(l);
})), epics19: (e) => se(e, 12040).pipe(he((t) => {
  const { payload: { body: { mode: r } } } = t;
  Kr.setAudioCodecMode(r);
}), Ie(oe)), epics20: (e, t) => Pe(e, [X.AudioSpeakerSetSuccess, X.JoinComputerAudioComplete, X.AudioSpeakerSetError]).pipe(G((r) => {
  const { payload: { data: n, type: o } } = r, { audio: { activeSpeaker: i, activeMicrophone: s } } = t.value, a = [];
  return o === X.AudioSpeakerSetSuccess && i !== n ? a.push(X0(n)) : o === X.JoinComputerAudioComplete && n !== null && s !== n && a.push(hu(n)), o === X.AudioSpeakerSetSuccess ? O(J1, !0) : o === X.AudioSpeakerSetError && O(J1, !1), ne(a);
})) }, Ek = Wr(wk, { shareAudioEpics0: (e, t) => to(e, gt).pipe(z((r) => {
  const n = r.payload.body.update;
  return n && n.length > 0 && n.findIndex((o) => o.bShareOn !== void 0) > -1;
}), pe(t), G((r) => {
  let [n, o] = r;
  const { payload: { body: { update: i } } } = n, { audio: { localShareAudioUserMutedList: s } } = o, a = i.filter((u) => u.bShareOn === !0 && u.bShareAudioOn === !0), l = [];
  return a.length > 0 && a.forEach((u) => {
    s.findIndex((d) => d.userId === u.id) === -1 && l.push(SE({ userId: u.id, isFromMainSession: !!u.bShareToBORooms }));
  }), ne(l);
})), shareAudioEpics1: (e, t) => Pe(e, X.SharingDesktopStreamHaveAudio).pipe(z(() => !t.value.audio.secondaryAudioMicrophoneId), ze(() => se(e, gt).pipe(z((r) => {
  var n;
  const { payload: { body: o } } = r, { meeting: { userId: i } } = t.value;
  return (o == null || (n = o.update) === null || n === void 0 ? void 0 : n.findIndex((s) => s.id === i && s.bShareOn === !0)) > -1;
}), Ge(1), Di(async () => {
  const r = t.value;
  return await rv(Zi, ml, r);
}), jn(ep(!0))))), shareAudioEpics2: (e, t) => Pe(e, X.SharingDesktopStreamHaveNoAudio).pipe(pe(t), z((r) => {
  var n;
  let [, o] = r;
  return ((n = o.audio) === null || n === void 0 ? void 0 : n.isShareAudioEnabled) === !0;
}), Di(async (r) => {
  let [, n] = r;
  return await T7(Zi, ml, n);
})), shareAudioEpics3: (e, t) => se(e, gt).pipe(pe(t), z((r) => {
  let [, n] = r;
  return n.socket.zoomSocketStatus === dt.Connected && n.audio.isSharingAudio === !0;
}), G((r) => {
  var n;
  let [o, i] = r;
  if ((n = o.payload.body.update) !== null && n !== void 0 && n.some((s) => s.audio !== void 0 || s.muted !== void 0)) {
    const { meeting: { userId: s } } = i, a = o.payload.body.update.filter((l) => l.id === s);
    return Ns(t).pipe(G((l) => {
      const u = [];
      return a.findIndex((d) => d.audio === et.Computer) > -1 && (l == null ? void 0 : l.audio) !== et.Computer && !wo() && (u.push(Ga(!0)), u.push(ei(!0))), ne(u);
    }));
  }
  return oe;
})), shareAudioEpics4: (e, t) => e.pipe(ge(`${bn}`), Fr(ri), pe(t), z((r) => {
  var n;
  let [, o] = r;
  return ((n = o.audio) === null || n === void 0 ? void 0 : n.isShareAudioEnabled) === !0;
}), Di(async (r) => {
  let [n, o] = r;
  const { payload: i } = n, { audio: { isShareAudioMuted: s, isSharingAudio: a } } = o, l = [];
  if (i === Fe.End) {
    const u = await T7(Zi, ml, o);
    l.push(...u);
  } else if (i === Fe.Paused) {
    if (s === !1 && a === !0) {
      await Zi.leaveSharingAudio(!0), l.push(qa(!1));
      const u = await Ym(Zi, ml, o);
      l.push(...u), setTimeout(() => {
        O(za, { state: "off" });
      }, 0);
    }
  } else if (i === Fe.Sharing && s === !1 && a === !1) {
    const u = await rv(Zi, ml, o);
    l.push(...u);
  }
  return l;
})), shareAudioEpics5: (e, t) => Pe(e, X.SharingDesktopStreamHaveAudio).pipe(z(() => !!t.value.audio.secondaryAudioMicrophoneId), he(() => {
  const { audio: { audioSsrc: r, secondaryAudioMicrophoneId: n }, meeting: { svcUrl: o, conId: i, reportDomain: s, supportLocalAB: a, abToken: l } } = t.value;
  Zi.joinSharingAudio({ ssrc: r, microphoneDeviceId: n, speakerDeviceId: null, isCaptureAudio: !0, audioBridge: fr() ? { rwgHost: o, cid: i, nginxHost: s, abToken: l, supportLocalAB: a, useWebRTCOnDesktop: !ve.isAndroidOrIOSBrowser } : void 0 }), O(uw);
}), G(() => oe)) }, { audioBridgEpics0: (e) => se(e, 4299).pipe(he((t) => {
  const { payload: r } = t;
  Ys.passThroughRWGMessage(r);
}), Ie(oe)), audioBridgEpics1: (e) => Pe(e, X.AudioBridgeReconnectStart).pipe(G(() => (ah.joinOrLeaveVoip(!1), ne([wm(!0), Ls(uu.Failover)])))), audioBridgEpics2: (e, t) => Pe(e, X.AudioBridgeReconnectEnd).pipe(he(() => {
  _0(ah, t.value);
}), Ie(oe)), audioBridgEpics3: (e) => se(e, gt).pipe(z((t) => {
  var r, n;
  return fr() && (((r = t.payload.body.update) === null || r === void 0 ? void 0 : r.some((o) => o.muted !== void 0)) || ((n = t.payload.body.remove) === null || n === void 0 ? void 0 : n.length) > 0);
}), he((t) => {
  const { payload: { body: { update: r, remove: n } } } = t;
  Ys.sendUserAudioStatus({ update: (r || []).filter((o) => o.muted !== void 0).map((o) => ({ userId: o.id, muted: o.muted })), remove: (n || []).map((o) => ({ userId: o.id })) });
}), Ie(oe)), audioBridgEpics4: (e, t) => Pe(e, X.NotifyUIFailover).pipe(z(() => !t.value.meeting.isMeetingReset && t.value.meeting.meetingStatus === xt.Joined), ae(() => (O(Hr, { reason: hr.Failover }), Tr(or.NotifyUiFailover)))), audioBridgEpics5: (e, t) => Yv(e, t).pipe(z(() => {
  const { meeting: { isAudioBridgeEnabled: r, abToken: n } } = t.value;
  return r && fr() && !!n;
}), he(() => {
  const { meeting: { abToken: r, svcUrl: n, reportDomain: o, conId: i, supportLocalAB: s } } = t.value;
  Ys.preInitAudioBridge({ abToken: r, rwgHost: n, cid: i, nginxHost: o, supportLocalAB: s, useWebRTCOnDesktop: !ve.isAndroidOrIOSBrowser });
}), Ie(oe)), audioBridgEpics6: (e, t) => se(e, 16129).pipe(z((r) => {
  const { payload: { body: { bVideoOn: n } } } = r, { meeting: { isAudioBridgeEnabled: o } } = t.value;
  return o && fr() && !!n;
}), he((r) => {
  const { payload: { body: { id: n } } } = r;
  Ys.changeActiveVideoSsrc(n);
}), Ie(oe)), audioBridgEpics7: (e, t) => Pe(e, [X.RecoverWebrtcAudio, X.AudioStreamFailed]).pipe(G(() => {
  const r = be(t.value), n = [];
  return (r == null ? void 0 : r.audio) === et.Computer && (Ys.leaveComputerAudio(), Iu() ? (ah.joinOrLeaveVoip(!1), n.push(Ls(uu.EndedBySystem)), n.push(Uu(0))) : Rs(Ys, t.value)), ne(n);
})), audioBridgEpics8: (e) => Pe(e, [X.AudioBridgeFirstRecvData, X.AudioBridgeCanSendData]).pipe(ae((t) => {
  const { payload: { type: r } } = t;
  return r === X.AudioBridgeFirstRecvData ? (O(jw), P4(!0)) : (O(Uw), D4(!0));
})), audioBridgEpics9: (e, t) => e.pipe(ge(`${Un}`), z(() => !!t.value.meeting.zlkJwtToken), he(() => {
  const { meeting: { zlkJwtToken: r } } = t.value;
  if (r) {
    const { enforce_web_rtc_audio: n, audio_compatible_mode: o } = nl(r);
    n === void 0 && o === void 0 || xe.set(im.EnforceWebRTCAudio, Number(n) === 1 || Number(o) === 1, qe.Memory);
  }
}), Ie(oe)) }, Ck);
var FA = typeof global == "object" && global && global.Object === Object && global, Ik = typeof self == "object" && self && self.Object === Object && self, ni = FA || Ik || Function("return this")(), Ya = ni.Symbol, zA = Object.prototype, Ak = zA.hasOwnProperty, _k = zA.toString, gl = Ya ? Ya.toStringTag : void 0, Rk = Object.prototype.toString, Ok = "[object Null]", Tk = "[object Undefined]", N7 = Ya ? Ya.toStringTag : void 0;
function Bu(e) {
  return e == null ? e === void 0 ? Tk : Ok : N7 && N7 in Object(e) ? function(t) {
    var r = Ak.call(t, gl), n = t[gl];
    try {
      t[gl] = void 0;
      var o = !0;
    } catch {
    }
    var i = _k.call(t);
    return o && (r ? t[gl] = n : delete t[gl]), i;
  }(e) : function(t) {
    return Rk.call(t);
  }(e);
}
function Au(e) {
  return e != null && typeof e == "object";
}
var _u = Array.isArray;
function WA(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var kk = "[object AsyncFunction]", Mk = "[object Function]", Pk = "[object GeneratorFunction]", Dk = "[object Proxy]";
function ZA(e) {
  if (!WA(e))
    return !1;
  var t = Bu(e);
  return t == Mk || t == Pk || t == kk || t == Dk;
}
var x7, lh = ni["__core-js_shared__"], V7 = (x7 = /[^.]+$/.exec(lh && lh.keys && lh.keys.IE_PROTO || "")) ? "Symbol(src)_1." + x7 : "", Lk = Function.prototype.toString;
function Bs(e) {
  if (e != null) {
    try {
      return Lk.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Nk = /^\[object .+?Constructor\]$/, xk = Function.prototype, Vk = Object.prototype, jk = xk.toString, Uk = Vk.hasOwnProperty, Bk = RegExp("^" + jk.call(Uk).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function ol(e, t) {
  var r = function(n, o) {
    return n == null ? void 0 : n[o];
  }(e, t);
  return function(n) {
    return !(!WA(n) || (o = n, V7 && V7 in o)) && (ZA(n) ? Bk : Nk).test(Bs(n));
    var o;
  }(r) ? r : void 0;
}
var ov = ol(ni, "WeakMap"), $k = 9007199254740991, Hk = /^(?:0|[1-9]\d*)$/;
function Fk(e, t) {
  var r = typeof e;
  return !!(t = t == null ? $k : t) && (r == "number" || r != "symbol" && Hk.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function GA(e, t) {
  return e === t || e != e && t != t;
}
var zk = 9007199254740991;
function qA(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= zk;
}
function KA(e) {
  return e != null && qA(e.length) && !ZA(e);
}
var Wk = Object.prototype;
function JA(e) {
  var t = e && e.constructor;
  return e === (typeof t == "function" && t.prototype || Wk);
}
function j7(e) {
  return Au(e) && Bu(e) == "[object Arguments]";
}
var QA = Object.prototype, Zk = QA.hasOwnProperty, Gk = QA.propertyIsEnumerable, YA = j7(/* @__PURE__ */ function() {
  return arguments;
}()) ? j7 : function(e) {
  return Au(e) && Zk.call(e, "callee") && !Gk.call(e, "callee");
}, XA = typeof exports == "object" && exports && !exports.nodeType && exports, U7 = XA && typeof module == "object" && module && !module.nodeType && module, B7 = U7 && U7.exports === XA ? ni.Buffer : void 0, R0 = (B7 ? B7.isBuffer : void 0) || function() {
  return !1;
}, It = {};
It["[object Float32Array]"] = It["[object Float64Array]"] = It["[object Int8Array]"] = It["[object Int16Array]"] = It["[object Int32Array]"] = It["[object Uint8Array]"] = It["[object Uint8ClampedArray]"] = It["[object Uint16Array]"] = It["[object Uint32Array]"] = !0, It["[object Arguments]"] = It["[object Array]"] = It["[object ArrayBuffer]"] = It["[object Boolean]"] = It["[object DataView]"] = It["[object Date]"] = It["[object Error]"] = It["[object Function]"] = It["[object Map]"] = It["[object Number]"] = It["[object Object]"] = It["[object RegExp]"] = It["[object Set]"] = It["[object String]"] = It["[object WeakMap]"] = !1;
var $7, e_ = typeof exports == "object" && exports && !exports.nodeType && exports, Ql = e_ && typeof module == "object" && module && !module.nodeType && module, uh = Ql && Ql.exports === e_ && FA.process, H7 = function() {
  try {
    return Ql && Ql.require && Ql.require("util").types || uh && uh.binding && uh.binding("util");
  } catch {
  }
}(), F7 = H7 && H7.isTypedArray, Xm = F7 ? ($7 = F7, function(e) {
  return $7(e);
}) : function(e) {
  return Au(e) && qA(e.length) && !!It[Bu(e)];
}, qk = Object.prototype.hasOwnProperty, Kk = /* @__PURE__ */ function(e, t) {
  return function(r) {
    return e(t(r));
  };
}(Object.keys, Object), Jk = Object.prototype.hasOwnProperty;
function t_(e) {
  if (!JA(e))
    return Kk(e);
  var t = [];
  for (var r in Object(e))
    Jk.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
function Qk(e) {
  return KA(e) ? function(t, r) {
    var n = _u(t), o = !n && YA(t), i = !n && !o && R0(t), s = !n && !o && !i && Xm(t), a = n || o || i || s, l = a ? function(c, p) {
      for (var h = -1, v = Array(c); ++h < c; )
        v[h] = p(h);
      return v;
    }(t.length, String) : [], u = l.length;
    for (var d in t)
      !r && !qk.call(t, d) || a && (d == "length" || i && (d == "offset" || d == "parent") || s && (d == "buffer" || d == "byteLength" || d == "byteOffset") || Fk(d, u)) || l.push(d);
    return l;
  }(e) : t_(e);
}
var yl = ol(Object, "create"), Yk = Object.prototype.hasOwnProperty, Xk = Object.prototype.hasOwnProperty;
function ds(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
function dd(e, t) {
  for (var r = e.length; r--; )
    if (GA(e[r][0], t))
      return r;
  return -1;
}
ds.prototype.clear = function() {
  this.__data__ = yl ? yl(null) : {}, this.size = 0;
}, ds.prototype.delete = function(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}, ds.prototype.get = function(e) {
  var t = this.__data__;
  if (yl) {
    var r = t[e];
    return r === "__lodash_hash_undefined__" ? void 0 : r;
  }
  return Yk.call(t, e) ? t[e] : void 0;
}, ds.prototype.has = function(e) {
  var t = this.__data__;
  return yl ? t[e] !== void 0 : Xk.call(t, e);
}, ds.prototype.set = function(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = yl && t === void 0 ? "__lodash_hash_undefined__" : t, this;
};
var eM = Array.prototype.splice;
function Ko(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Ko.prototype.clear = function() {
  this.__data__ = [], this.size = 0;
}, Ko.prototype.delete = function(e) {
  var t = this.__data__, r = dd(t, e);
  return !(r < 0 || (r == t.length - 1 ? t.pop() : eM.call(t, r, 1), --this.size, 0));
}, Ko.prototype.get = function(e) {
  var t = this.__data__, r = dd(t, e);
  return r < 0 ? void 0 : t[r][1];
}, Ko.prototype.has = function(e) {
  return dd(this.__data__, e) > -1;
}, Ko.prototype.set = function(e, t) {
  var r = this.__data__, n = dd(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
};
var Ru = ol(ni, "Map");
function cd(e, t) {
  var r, n, o = e.__data__;
  return ((n = typeof (r = t)) == "string" || n == "number" || n == "symbol" || n == "boolean" ? r !== "__proto__" : r === null) ? o[typeof t == "string" ? "string" : "hash"] : o.map;
}
function os(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
function wi(e) {
  var t = this.__data__ = new Ko(e);
  this.size = t.size;
}
os.prototype.clear = function() {
  this.size = 0, this.__data__ = { hash: new ds(), map: new (Ru || Ko)(), string: new ds() };
}, os.prototype.delete = function(e) {
  var t = cd(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}, os.prototype.get = function(e) {
  return cd(this, e).get(e);
}, os.prototype.has = function(e) {
  return cd(this, e).has(e);
}, os.prototype.set = function(e, t) {
  var r = cd(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}, wi.prototype.clear = function() {
  this.__data__ = new Ko(), this.size = 0;
}, wi.prototype.delete = function(e) {
  var t = this.__data__, r = t.delete(e);
  return this.size = t.size, r;
}, wi.prototype.get = function(e) {
  return this.__data__.get(e);
}, wi.prototype.has = function(e) {
  return this.__data__.has(e);
}, wi.prototype.set = function(e, t) {
  var r = this.__data__;
  if (r instanceof Ko) {
    var n = r.__data__;
    if (!Ru || n.length < 199)
      return n.push([e, t]), this.size = ++r.size, this;
    r = this.__data__ = new os(n);
  }
  return r.set(e, t), this.size = r.size, this;
};
var tM = Object.prototype.propertyIsEnumerable, z7 = Object.getOwnPropertySymbols, rM = z7 ? function(e) {
  return e == null ? [] : (e = Object(e), function(t, r) {
    for (var n = -1, o = t == null ? 0 : t.length, i = 0, s = []; ++n < o; ) {
      var a = t[n];
      r(a) && (s[i++] = a);
    }
    return s;
  }(z7(e), function(t) {
    return tM.call(e, t);
  }));
} : function() {
  return [];
};
function W7(e) {
  return function(t, r, n) {
    var o = Qk(t);
    return _u(t) ? o : function(i, s) {
      for (var a = -1, l = s.length, u = i.length; ++a < l; )
        i[u + a] = s[a];
      return i;
    }(o, n(t));
  }(e, 0, rM);
}
var iv = ol(ni, "DataView"), sv = ol(ni, "Promise"), av = ol(ni, "Set"), Z7 = "[object Map]", G7 = "[object Promise]", q7 = "[object Set]", K7 = "[object WeakMap]", J7 = "[object DataView]", nM = Bs(iv), oM = Bs(Ru), iM = Bs(sv), sM = Bs(av), aM = Bs(ov), is = Bu;
(iv && is(new iv(new ArrayBuffer(1))) != J7 || Ru && is(new Ru()) != Z7 || sv && is(sv.resolve()) != G7 || av && is(new av()) != q7 || ov && is(new ov()) != K7) && (is = function(e) {
  var t = Bu(e), r = t == "[object Object]" ? e.constructor : void 0, n = r ? Bs(r) : "";
  if (n)
    switch (n) {
      case nM:
        return J7;
      case oM:
        return Z7;
      case iM:
        return G7;
      case sM:
        return q7;
      case aM:
        return K7;
    }
  return t;
});
var lv = is, Q7 = ni.Uint8Array;
function rc(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.__data__ = new os(); ++t < r; )
    this.add(e[t]);
}
function lM(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length; ++r < n; )
    if (t(e[r], r, e))
      return !0;
  return !1;
}
rc.prototype.add = rc.prototype.push = function(e) {
  return this.__data__.set(e, "__lodash_hash_undefined__"), this;
}, rc.prototype.has = function(e) {
  return this.__data__.has(e);
};
var uM = 1, dM = 2;
function Y7(e, t, r, n, o, i) {
  var s = r & uM, a = e.length, l = t.length;
  if (a != l && !(s && l > a))
    return !1;
  var u = i.get(e), d = i.get(t);
  if (u && d)
    return u == t && d == e;
  var c = -1, p = !0, h = r & dM ? new rc() : void 0;
  for (i.set(e, t), i.set(t, e); ++c < a; ) {
    var v = e[c], f = t[c];
    if (n)
      var m = s ? n(f, v, c, t, e, i) : n(v, f, c, e, t, i);
    if (m !== void 0) {
      if (m)
        continue;
      p = !1;
      break;
    }
    if (h) {
      if (!lM(t, function(g, C) {
        if (b = C, !h.has(b) && (v === g || o(v, g, r, n, i)))
          return h.push(C);
        var b;
      })) {
        p = !1;
        break;
      }
    } else if (v !== f && !o(v, f, r, n, i)) {
      p = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), p;
}
function cM(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n, o) {
    r[++t] = [o, n];
  }), r;
}
function pM(e) {
  var t = -1, r = Array(e.size);
  return e.forEach(function(n) {
    r[++t] = n;
  }), r;
}
var hM = 1, fM = 2, vM = "[object Boolean]", mM = "[object Date]", gM = "[object Error]", yM = "[object Map]", SM = "[object Number]", bM = "[object RegExp]", CM = "[object Set]", wM = "[object String]", EM = "[object Symbol]", IM = "[object ArrayBuffer]", AM = "[object DataView]", X7 = Ya ? Ya.prototype : void 0, dh = X7 ? X7.valueOf : void 0, _M = 1, RM = Object.prototype.hasOwnProperty, OM = 1, ey = "[object Arguments]", ty = "[object Array]", pd = "[object Object]", ry = Object.prototype.hasOwnProperty;
function r_(e, t, r, n, o) {
  return e === t || (e == null || t == null || !Au(e) && !Au(t) ? e != e && t != t : function(i, s, a, l, u, d) {
    var c = _u(i), p = _u(s), h = c ? ty : lv(i), v = p ? ty : lv(s), f = (h = h == ey ? pd : h) == pd, m = (v = v == ey ? pd : v) == pd, g = h == v;
    if (g && R0(i)) {
      if (!R0(s))
        return !1;
      c = !0, f = !1;
    }
    if (g && !f)
      return d || (d = new wi()), c || Xm(i) ? Y7(i, s, a, l, u, d) : function(_, I, D, B, L, R, y) {
        switch (D) {
          case AM:
            if (_.byteLength != I.byteLength || _.byteOffset != I.byteOffset)
              return !1;
            _ = _.buffer, I = I.buffer;
          case IM:
            return !(_.byteLength != I.byteLength || !R(new Q7(_), new Q7(I)));
          case vM:
          case mM:
          case SM:
            return GA(+_, +I);
          case gM:
            return _.name == I.name && _.message == I.message;
          case bM:
          case wM:
            return _ == I + "";
          case yM:
            var A = cM;
          case CM:
            var k = B & hM;
            if (A || (A = pM), _.size != I.size && !k)
              return !1;
            var T = y.get(_);
            if (T)
              return T == I;
            B |= fM, y.set(_, I);
            var N = Y7(A(_), A(I), B, L, R, y);
            return y.delete(_), N;
          case EM:
            if (dh)
              return dh.call(_) == dh.call(I);
        }
        return !1;
      }(i, s, h, a, l, u, d);
    if (!(a & OM)) {
      var C = f && ry.call(i, "__wrapped__"), b = m && ry.call(s, "__wrapped__");
      if (C || b) {
        var E = C ? i.value() : i, w = b ? s.value() : s;
        return d || (d = new wi()), u(E, w, a, l, d);
      }
    }
    return !!g && (d || (d = new wi()), function(_, I, D, B, L, R) {
      var y = D & _M, A = W7(_), k = A.length;
      if (k != W7(I).length && !y)
        return !1;
      for (var T = k; T--; ) {
        var N = A[T];
        if (!(y ? N in I : RM.call(I, N)))
          return !1;
      }
      var F = R.get(_), $ = R.get(I);
      if (F && $)
        return F == I && $ == _;
      var re = !0;
      R.set(_, I), R.set(I, _);
      for (var fe = y; ++T < k; ) {
        var le = _[N = A[T]], Ae = I[N];
        if (B)
          var Re = y ? B(Ae, le, N, I, _, R) : B(le, Ae, N, _, I, R);
        if (!(Re === void 0 ? le === Ae || L(le, Ae, D, B, R) : Re)) {
          re = !1;
          break;
        }
        fe || (fe = N == "constructor");
      }
      if (re && !fe) {
        var Se = _.constructor, ye = I.constructor;
        Se == ye || !("constructor" in _) || !("constructor" in I) || typeof Se == "function" && Se instanceof Se && typeof ye == "function" && ye instanceof ye || (re = !1);
      }
      return R.delete(_), R.delete(I), re;
    }(i, s, a, l, u, d));
  }(e, t, r, n, r_, o));
}
var TM = Object.prototype.hasOwnProperty;
const ny = (e) => 4294966272 & e, ch = (e) => {
  let t = { R: 0, G: 0, B: 0, A: 0 };
  if (typeof e == "string" && e.startsWith("#")) {
    const a = e.slice(1);
    try {
      if (a.length === 3) {
        const l = Array.from(a).map((u) => u.repeat(2)).map((u) => parseInt(u, 16));
        t = { R: l[0] / 255, G: l[1] / 255, B: l[2] / 255, A: 1 };
      } else if (a.length === 6 || a.length === 8) {
        var r, n, o, i, s;
        const l = (r = a.match(/\S{2}/g)) === null || r === void 0 ? void 0 : r.map((u) => parseInt(u, 16));
        t = { R: ((n = l == null ? void 0 : l[0]) !== null && n !== void 0 ? n : 0) / 255, G: ((o = l == null ? void 0 : l[1]) !== null && o !== void 0 ? o : 0) / 255, B: ((i = l == null ? void 0 : l[2]) !== null && i !== void 0 ? i : 0) / 255, A: l != null && l[3] ? ((s = l == null ? void 0 : l[3]) !== null && s !== void 0 ? s : 0) / 255 : 1 };
      }
    } catch {
      console.warn("error color representation:", e);
    }
  } else
    typeof e == "object" && (t = { R: e.R / 255, G: e.G / 255, B: e.B / 255, A: e.A || 1 });
  return t;
};
function eg(e) {
  let { captureWidth: t = 0, captureHeight: r = 0 } = e || {};
  const { hd: n } = e || {};
  return t !== 0 && r !== 0 || (n && ke.isSupportSending720P() ? (t = 1280, r = 720) : (t = 640, r = 360)), { captureWidth: t, captureHeight: r };
}
function n_(e, t) {
  return e === "default" || t.some((r) => r.deviceId === e) || [Ll.Environment, Ll.User, Ll.Left, Ll.Right].includes(e);
}
function o_(e, t, r) {
  const n = [], { video: { videoSsrc: o, activeCamera: i } } = t, { cameraId: s = i, videoElement: a, originalRatio: l, ptz: u, hd: d, fullHd: c, mediaFile: p, fps: h } = r || {};
  let v;
  if (a !== void 0) {
    let E = a instanceof HTMLVideoElement ? a : null;
    if (typeof a == "string") {
      let [w, _] = [document.body, a];
      if (a.indexOf(">") > -1) {
        const [I, D] = a.split(">");
        w = document.querySelector(I), _ = D;
      }
      w && (E = w.querySelector(_));
    }
    if (!E)
      return [];
    E.id ? v = E.id : (v = Qo("__ZOOM_SDK_SELF_VIDEO_@__"), E.id = v);
  }
  let f = h != null ? h : Dp.Default;
  f = Math.max(Dp.Min, f), f = Math.min(Dp.Max, f);
  const { captureWidth: m, captureHeight: g } = eg(r), C = !!c && ke.isSupportFullHDVideo();
  e.updateVideoFullhdValue(C);
  let b = Promise.resolve(s);
  if (p && p.url) {
    const E = mn.getInstance();
    b = E.setVideoElement(p).then(() => E.videoElement);
  } else
    mn.getInstance().stopVideoElement();
  return b.then((E) => {
    e.startCaptureVideo(o, E, m, g, v, ve.isAndroidOrIOSBrowser, !l && function() {
      var w, _;
      const { isAndroidOrIOSBrowser: I, isFirefox: D, isSafari: B } = ve;
      return I || !((w = navigator.mediaDevices) !== null && w !== void 0 && (_ = w.getSupportedConstraints) !== null && _ !== void 0 && _.call(w).aspectRatio) || D || B || CC();
    }(), u, f);
  }), n.push(XE({ cameraId: s, captureWidth: m, captureHeight: g, videoElement: typeof a == "string" ? a : a instanceof HTMLVideoElement ? Q4(a) : void 0, originalRatio: l, ptz: u, hd: d, fullHd: c, mediaFile: p, fps: f })), n;
}
function i_(e, t, r) {
  const { max: n, min: o, step: i } = e;
  let s = r / 100 * (n - o);
  i && (s = Math.min(Math.floor(s / i) * i, Math.floor(s)));
  let a = t + s;
  return a = Math.min(n, a), a = Math.max(o, a), a;
}
function s_(e, t) {
  let r = "", n = t;
  switch (e) {
    case vi.Down:
      n = -t, r = "tilt";
      break;
    case vi.Up:
      r = "tilt";
      break;
    case vi.Left:
      n = -t, r = "pan";
      break;
    case vi.Right:
      r = "pan";
      break;
    case vi.ZoomIn:
      r = "zoom";
      break;
    case vi.ZoomOut:
      n = -t, r = "zoom";
  }
  return { key: r, range: n };
}
function tg(e) {
  const t = ["pan", "tilt", "zoom"].reduce((r, n) => e[n] && e[n].value !== 0 ? { ...r, [n]: e[n].value } : r, {});
  return function(r) {
    if (r == null)
      return !0;
    if (KA(r) && (_u(r) || typeof r == "string" || typeof r.splice == "function" || R0(r) || Xm(r) || YA(r)))
      return !r.length;
    var n = lv(r);
    if (n == "[object Map]" || n == "[object Set]")
      return !r.size;
    if (JA(r))
      return !t_(r).length;
    for (var o in r)
      if (TM.call(r, o))
        return !1;
    return !0;
  }(t) ? null : t;
}
function a_(e) {
  return { pan: (e & Zs.Pan) === Zs.Pan, tilt: (e & Zs.Tilt) === Zs.Tilt, zoom: (e & Zs.Zoom) === Zs.Zoom };
}
function Sl(e) {
  const { isAndroidBrowser: t, isIOSMobile: r, isFirefox: n, isSupportImageCapture: o, isSupportMediaStreamTrackProcessor: i, isSupportOffscreenCanvas: s } = ve, a = t && !n, l = typeof window.SharedArrayBuffer != "function" && a;
  return r && typeof VideoFrame == "function" || l || !J0() && !e && !Ff() && (o || i) && s;
}
function oy() {
  var e, t;
  return "orientation" in window.screen ? (e = screen.orientation.type) === null || e === void 0 ? void 0 : e.startsWith("landscape") : "orientation" in window ? Math.abs(window.orientation) === 90 : "matchMedia" in window ? !((t = window.matchMedia("(orientation: landscape)")) === null || t === void 0 || !t.matches) : screen.availWidth > screen.availHeight;
}
function iy(e, t, r) {
  const { meeting: { userId: n }, video: { isSupportHDVideo: o, renderedVideoList: i, maximumNumbeOfHDSubscriptions: s, receivedVideoMaxQuality: a } } = r, l = e === n;
  let u = t;
  if (t >= gn.Video_720P)
    if (o) {
      const c = i.filter((h) => h.videoQuality === gn.Video_720P).map((h) => h.userId), p = s != null ? s : 1;
      c.length >= p && (c.includes(e) || l || (console.warn(`Warning: Web Video SDK currently only supports subscribing to ${p} 720p video stream, so quality has been downgraded to 360p`), u = gn.Video_360P));
    } else
      console.warn("Can not subscribe 720P video stream,will downgrade to 360P stream"), u = gn.Video_360P;
  const d = Math.max(a, gn.Video_360P);
  return [u, Math.min(u, d)];
}
const Xs = We.createAgent(), co = Vr(ke.getInstance());
let So, Da;
async function l_(e, t, r) {
  const n = Qo(e), o = document.createElement("img");
  return o.src = t, o.id = n, o.style.display = "none", eo(t) && o.setAttribute("crossorigin", ""), await new Promise((i, s) => {
    o.onload = () => {
      r && URL.revokeObjectURL(t), i("");
    }, o.onerror = () => {
      r && URL.revokeObjectURL(t), s("Cannot load  image.");
    };
  }), { imageId: n, imgElement: o };
}
async function $u(e, t, r) {
  if (e === Fa)
    return Fa;
  {
    let n = e;
    if (t) {
      const o = await function(i) {
        return new Promise((s, a) => {
          try {
            So && Da || (So = document.createElement("canvas"), Da = So.getContext("2d"));
            const l = So, u = Da;
            if (u) {
              u.clearRect(0, 0, So.width, So.height);
              const d = new Image();
              d.src = i, eo(i) && (d.crossOrigin = "");
              const c = 16 / 9, p = 1280, h = Math.floor(p / c);
              l.width = p, l.height = h, d.onload = () => {
                const { width: v, height: f } = d, m = f * c;
                if (m > v) {
                  const g = v, C = Math.floor(v / c), b = 0, E = (f - C) / 2;
                  u == null || u.drawImage(d, b, E, g, C, 0, 0, p, h);
                } else {
                  const g = m, C = f, b = (v - g) / 2;
                  u.drawImage(d, b, 0, g, C, 0, 0, p, h);
                }
                try {
                  l.toBlob((g) => {
                    s(g);
                  });
                } catch (g) {
                  g instanceof DOMException && g.code === DOMException.SECURITY_ERR && console.error("Image is not from the same origin, add CORS header to solve this issue"), a(g);
                }
              }, d.onerror = (v) => {
                a("Cannot load  image.");
              };
            }
          } catch (l) {
            a(l);
          }
        });
      }(e);
      n = URL.createObjectURL(o);
    }
    if (n) {
      const { imageId: o, imgElement: i } = await l_(SO, n, !!t);
      return (r != null ? r : document.body).appendChild(i), o;
    }
  }
  return null;
}
async function u_(e, t, r) {
  var n;
  const o = (n = r && r.parentNode) !== null && n !== void 0 ? n : document.body, { imageUrl: i, cropped: s, rootWidth: a, rootHeight: l } = e;
  let u = e;
  !t.video.customizedVideoOption || e.captureWidth && e.captureHeight || (u = t.video.customizedVideoOption);
  const { captureWidth: d, captureHeight: c } = eg(u), p = document.createElement("div");
  let h;
  p.style.display = "none", h = i ? await $u(i, s, p) : null;
  let v = Qo(yO);
  if (r) {
    const f = Xd(r);
    f.id ? v = f.id : f.id = v;
    try {
      a && r.width !== a && (r.width = a), l && r.height !== l && (r.height = l);
    } catch {
      console.warn("Cannot set the canvas width/height, and pay attention the canvas dimension is different from the setting");
    }
  } else {
    const f = document.createElement("canvas");
    f.width = a != null ? a : 380, f.height = l != null ? l : 214, f.id = v, p.appendChild(f);
  }
  return o == null || o.appendChild(p), { captureWidth: d, captureHeight: c, imageId: h, canvasId: v, divElement: p };
}
async function sy(e, t, r, n) {
  const o = Array.isArray(e) ? e : e && [e];
  if ((o == null ? void 0 : o.length) > 0) {
    So && Da || (So = document.createElement("canvas"), Da = So.getContext("2d"));
    const i = So, s = Da;
    if (i.width = t, i.height = r, s)
      try {
        s.fillStyle = "#fff", s.clearRect(0, 0, t, r);
        for (let l = 0; l < o.length; l++) {
          const u = o[l], { type: d, x: c, y: p } = u;
          if (d === "rectangle") {
            const { width: h, height: v } = u;
            s.fillRect(c, p, h, v);
          } else if (d === "square") {
            const { length: h } = u;
            s.fillRect(c, p, h, h);
          } else if (d === "circle") {
            const { radius: h } = u;
            s.beginPath(), s.arc(c, p, h, 0, 2 * Math.PI), s.fill();
          } else if (d === "svg") {
            const { svg: h, width: v, height: f } = u, m = new Image();
            m.src = h, eo(h) && (m.crossOrigin = ""), await new Promise((b, E) => {
              m.onload = () => {
                b("");
              }, m.onerror = () => {
                E();
              };
            });
            const { width: g, height: C } = m;
            s.drawImage(m, 0, 0, g, C, c, p, v, f);
          }
        }
        const a = await new Promise((l) => {
          i == null || i.toBlob((u) => {
            l(u);
          });
        });
        if (a) {
          const l = URL.createObjectURL(a), { imageId: u, imgElement: d } = await l_(bO, l, !0);
          return (n != null ? n : document.body).appendChild(d), u;
        }
      } catch (a) {
        a instanceof DOMException && a.code === DOMException.SECURITY_ERR && console.error("Image is not from the same origin, add CORS header to solve this issue");
      }
  }
  return null;
}
function ay(e, t) {
  if (e === t || e == null && t == null)
    return !0;
  const r = Array.isArray(e) ? [...e] : [e], n = Array.isArray(t) ? [...t] : [t];
  if (r.length !== n.length)
    return !1;
  const o = (i, s) => i.type < s.type ? -1 : i.type === s.type ? 0 : 1;
  r.sort(o), n.sort(o);
  for (let i = 0; i < r.length; i++)
    if (!Lu(r[i], n[i]))
      return !1;
  return !0;
}
function nc(e, t, r, n) {
  const { video: { isCurrentUserStartedVideo: o, virtualBackground: { isVBPreloadReady: i, isVBConfigured: s, imageSrc: a }, backgroundMode: l }, meeting: { isCurrentUserStartVideoBeforeReset: u } } = r;
  return gr(function(d) {
    return d !== void 0 ? ne([d]) : ht(Lc, 1).pipe(ae((c) => c));
  }(i)).then((d) => d ? n || !s && e.imageUrl !== Fa && e.imageUrl ? async function(c, p, h, v) {
    const { canvasId: f, imageId: m, captureHeight: g, captureWidth: C, divElement: b } = await u_(c, h, v), { cameraId: E } = c, { video: { videoSsrc: w, activeCamera: _ } } = h;
    return p.startVirtualBackgroundSetting(f, m, w, E != null ? E : _, C, g), b;
  }(e, t, r, n).then((c) => o ? Xc(!0) : gr(ht(H1, 1)).then((p) => {
    var h;
    return n || t.stopVirtualBackgroundSetting(), p ? (c == null || (h = c.parentNode) === null || h === void 0 || h.removeChild(c), !0) : Promise.reject("Cannot access the virtual background image.");
  })) : a === e.imageUrl && l === oo.VirtualBackground && !u || async function(c, p, h) {
    const { imageUrl: v, cropped: f } = c;
    if (v) {
      const m = await $u(v, f);
      m && (h.video.backgroundMode === oo.Mask && (p.stopMaskSetting(!0), await tm(() => {
        p.stopVirtualBackgroundSetting();
      }, 0)), p.updateVirtualBackgroundImage(m), m !== Fa && setTimeout(() => {
        yu(m);
      }, 0));
    } else
      p.updateVirtualBackgroundImage(null);
  }(e, t, r) : Promise.reject("Cannot load virtual background model."));
}
function oc(e, t, r, n) {
  const { video: { mask: { isMaskConfigured: o, imageSrc: i, clip: s }, backgroundMode: a, isCurrentUserStartedVideo: l }, meeting: { isCurrentUserStartVideoBeforeReset: u } } = r;
  return n || !o && e.imageUrl ? async function(d, c, p, h) {
    const { canvasId: v, imageId: f, captureHeight: m, captureWidth: g, divElement: C } = await u_(d, p, h), { cameraId: b, clip: E, rootWidth: w = 1280, rootHeight: _ = 720 } = d, I = E ? await sy(E, w, _, C) : null, { video: { videoSsrc: D, activeCamera: B } } = p;
    return I ? (c.startMaskSetting(v, f, I, D, b != null ? b : B, w, _, g, m), C) : Promise.reject("Clip is empty");
  }(e, t, r, n).then((d) => l ? i0(!0) : gr(ht(G1, 1)).then((c) => {
    var p;
    return n || t.stopMaskSetting(), c ? (d == null || (p = d.parentNode) === null || p === void 0 || p.removeChild(d), !0) : Promise.reject("Cannot set video mask");
  })) : a === oo.Mask && e.imageUrl === i && ay(e.clip, s) && !u ? Promise.resolve(!0) : async function(d, c, p) {
    const { imageUrl: h, cropped: v, clip: f, rootWidth: m, rootHeight: g } = d, { video: { mask: { imageSrc: C, cropped: b, clip: E }, backgroundMode: w } } = p;
    if (h) {
      if (w === oo.VirtualBackground && (c.stopVirtualBackgroundSetting(!0), await tm(() => {
        c.stopMaskSetting();
      }, 0)), h !== C || v !== b) {
        const _ = await $u(h, v);
        _ && (c.updateMaskBackgroundImage(_), setTimeout(() => {
          yu(_);
        }, 0));
      }
      if ((!ay(f, E) || !C) && f && m && g) {
        const _ = await sy(f, m, g);
        _ && (c.updateMaskClip(_, m, g), setTimeout(() => {
          yu(_);
        }, 0));
      }
    } else
      c.updateMaskBackgroundImage(null), c.updateMaskClip(null, m, g);
  }(e, t, r);
}
const hd = We.createAgent(), $n = Vr(ke.getInstance()), kM = We.createAgent(), ly = Vr(ke.getInstance()), uy = { videoSsrc: 0, cameraDevicesList: [], activeCamera: ve.isAndroidOrIOSBrowser ? Ll.User : "default", activeVideoId: 0, isCurrentUserStartedVideo: !1, spotlightUserList: [], isCaptureForbidden: !1, receivedVideoMaxQuality: navigator.hardwareConcurrency >= 8 ? gn.Video_1080P : gn.Video_360P, subscribedVideoList: [], renderedVideoList: [], ensuredCanvas: [], isVideoMuted: !1, isCaptureCameraLoading: !1, isCameraTaken: !1, isUsingMediaPlayback: !1, receivedVideoDimension: { width: 0, height: 0 }, capturedVideoDimension: { width: 0, height: 0 }, isFollowHostVideoLayout: !1, hostDragLayout: [], isSupportHDVideo: !1, isFullHDVideoEnabled: !1, bCanUnmuteVideo: !1, virtualBackground: { isVBConfigured: !1, isVBPreloadReady: void 0, imageSrc: void 0, cropped: void 0 }, mask: { imageSrc: void 0, cropped: void 0, clip: void 0 }, backgroundMode: oo.Null, statistic: { encode: { sample_rate: 0, rtt: 0, jitter: 0, avg_loss: 0, max_loss: 0, width: 0, height: 0, fps: 0, bandwidth: 0, bitrate: 0 }, decode: { sample_rate: 0, rtt: 0, jitter: 0, avg_loss: 0, max_loss: 0, width: 0, height: 0, fps: 0, bandwidth: 0, bitrate: 0 } }, hardwareAcceleration: { encode: !1, decode: !1 }, networkQuality: {}, ptz: {}, currentCameraControlStatus: { isRequested: !1, isInControl: !1, isCameraMoving: !1 }, farEndCameraControlStatus: { controlledUserList: [], isControlling: !1 }, subscriptionStatus: { encode: !1, decode: !1, detailed: !1 }, videoAttachments: {}, rendererType: N1.WebGL }, MM = zr({ [`${HE}`]: M((e, t) => {
  let { payload: r } = t;
  e.videoSsrc = r;
}), [`${_m}`]: M((e, t) => {
  let { payload: r } = t;
  e.cameraDevicesList = r;
}), [`${Kc}`]: M((e, t) => {
  let { payload: r } = t;
  const n = e.activeCamera;
  if (n in e.ptz) {
    const o = e.ptz[n];
    ["pan", "tilt", "zoom"].forEach((i) => {
      o[i] && (o[i].value = 0);
    });
  }
  e.activeCamera = r;
}), [`${FE}`]: M((e, t) => {
  let { payload: r } = t;
  e.activeVideoId = r.userId;
}), [`${zE}`]: M((e, t) => {
  let { payload: r } = t;
  e.isCurrentUserStartedVideo = r;
}), [`${Ef}`]: M((e, t) => {
  let { payload: r } = t;
  e.spotlightUserList = r;
}), [`${Jc}`]: M((e, t) => {
  let { payload: r } = t;
  e.isCaptureForbidden = r;
}), [`${WE}`]: M((e, t) => {
  let { payload: r } = t;
  e.receivedVideoMaxQuality = r;
}), [`${ZE}`]: M((e, t) => {
  let { payload: r } = t;
  e.isVideoMuted = r;
}), [`${Vl}`]: M((e, t) => {
  let { payload: r } = t;
  e.isCaptureCameraLoading = r;
}), [`${Qc}`]: M((e, t) => {
  let { payload: r } = t;
  e.isCameraTaken = r;
}), [`${If}`]: M((e, t) => {
  let { payload: r } = t;
  e.receivedVideoDimension = r;
}), [`${zd}`]: M((e, t) => {
  let { payload: r } = t;
  e.subscribedVideoList.includes(r) || e.subscribedVideoList.push(r);
}), [`${Wd}`]: M((e, t) => {
  let { payload: r } = t;
  const n = e.subscribedVideoList.indexOf(r);
  n >= 0 && e.subscribedVideoList.splice(n, 1);
}), [`${Oa}`]: M((e, t) => {
  let { payload: r } = t;
  const n = e.renderedVideoList.find((o) => o.userId === r.userId && o.key === r.key && o.canvasId === r.canvasId);
  n ? (r.videoQuality !== void 0 && (n.videoQuality = r.videoQuality), r.aspectRatio !== void 0 && (n.aspectRatio = r.aspectRatio)) : e.renderedVideoList.push({ ...r });
}), [`${Yc}`]: M((e, t) => {
  let { payload: r } = t;
  const n = e.renderedVideoList.findIndex((o) => o.userId === r.userId && o.key === r.key && o.canvasId === r.canvasId);
  n >= 0 && e.renderedVideoList.splice(n, 1);
}), [`${qE}`]: M((e, t) => {
  let { payload: r } = t;
  e.isFollowHostVideoLayout = r;
}), [`${KE}`]: M((e, t) => {
  let { payload: r } = t;
  e.hostDragLayout = r;
}), [`${JE}`]: M((e, t) => {
  let { payload: r } = t;
  e.isSupportHDVideo = r;
}), [`${QE}`]: M((e, t) => {
  let { payload: r } = t;
  e.maximumNumbeOfHDSubscriptions = r;
}), [`${YE}`]: M((e, t) => {
  let { payload: r } = t;
  e.bCanUnmuteVideo = r;
}), [`${Af}`]: M((e, t) => {
  let { payload: r } = t;
  e.virtualBackground.isVBPreloadReady = r;
}), [`${Xc}`]: M((e, t) => {
  let { payload: r } = t;
  e.virtualBackground.isVBConfigured = r;
}), [`${Zd}`]: M((e, t) => {
  let { payload: r } = t;
  e.virtualBackground.imageSrc = r.imageUrl, e.virtualBackground.cropped = r.cropped, e.backgroundMode = oo.VirtualBackground;
}), [`${ia}`]: M((e, t) => {
  let { payload: r } = t;
  const { encode: n, decode: o } = r;
  n !== void 0 && (e.hardwareAcceleration.encode = n), o !== void 0 && (e.hardwareAcceleration.decode = o);
}), [`${e0}`]: M((e, t) => {
  let { payload: r } = t;
  const { data: { encoding: n, rate: o, ...i } } = r;
  e.statistic.encode = { bitrate: o, ...i };
}), [`${t0}`]: M((e, t) => {
  let { payload: r } = t;
  const { data: { encoding: n, rate: o, ...i } } = r;
  e.statistic.decode = { bitrate: o, ...i };
}), [`${XE}`]: M((e, t) => {
  let { payload: r } = t;
  const { cameraId: n, captureWidth: o, captureHeight: i, videoElement: s, originalRatio: a, ptz: l, hd: u, fullHd: d, mediaFile: c, fps: p } = r;
  e.activeCamera = n, e.customizedVideoOption = { captureWidth: o, captureHeight: i, videoElement: s, originalRatio: a, ptz: l, hd: u, fullHd: d, fps: p }, Lu(e.mediaPlaybackFile, c) || (e.mediaPlaybackFile = c, e.isUsingMediaPlayback = !(c == null || !c.url));
}), [`${_f}`]: M((e, t) => {
  let { payload: r } = t;
  const { userId: n, level: o, bwLevel: i, type: s } = r;
  if (Object.prototype.hasOwnProperty.call(e.networkQuality, `${n}`))
    e.networkQuality[`${n}`][`${s}`] = { level: o, bwLevel: i };
  else {
    const a = { [s]: { level: o, bwLevel: i } };
    Object.assign(e.networkQuality, { [`${n}`]: a });
  }
}), [`${eI}`]: M((e, t) => {
  let { payload: r } = t;
  const { deviceId: n, ptzRange: o } = r;
  if (Object.prototype.hasOwnProperty.call(e.ptz, n)) {
    const i = e.ptz[n];
    i && ["pan", "tilt", "zoom"].forEach((s) => {
      const a = o[s];
      if (a) {
        var l;
        const u = (l = i[s]) === null || l === void 0 ? void 0 : l.capability;
        u ? Object.assign(u, { ...a }) : i[s] = { capability: { ...a }, value: 0 };
      }
    });
  } else
    Object.assign(e.ptz, { [n]: { pan: o.pan ? { capability: { ...o.pan }, value: 0 } : null, tilt: o.tilt ? { capability: { ...o.tilt }, value: 0 } : null, zoom: o.zoom ? { capability: { ...o.zoom }, value: 0 } : null } });
}), [`${r0}`]: M((e, t) => {
  let { payload: r } = t;
  e.currentCameraControlStatus.isRequested = r;
}), [`${n0}`]: M((e, t) => {
  let { payload: r } = t;
  const { isInControl: n, userId: o } = r;
  e.currentCameraControlStatus.isInControl = n, e.currentCameraControlStatus.controllingUserId = o;
}), [`${tI}`]: M((e, t) => {
  let { payload: r } = t;
  e.farEndCameraControlStatus.controlledUserList.includes(r) || e.farEndCameraControlStatus.controlledUserList.push(r);
}), [`${o0}`]: M((e, t) => {
  let { payload: r } = t;
  const n = e.farEndCameraControlStatus.controlledUserList.indexOf(r);
  n !== -1 && e.farEndCameraControlStatus.controlledUserList.splice(n, 1);
}), [`${Rf}`]: M((e, t) => {
  let { payload: r } = t;
  e.currentCameraControlStatus.isCameraMoving = r.cmd === "start";
}), [`${Rm}`]: M((e, t) => {
  let { payload: r } = t;
  const { constraints: n, deviceId: o } = r, i = e.ptz[o];
  ["pan", "tilt", "zoom"].forEach((s) => {
    n[s] !== void 0 && (i[s].value = n[s]);
  });
}), [`${Of}`]: M((e, t) => {
  let { payload: r } = t;
  e.farEndCameraControlStatus.isControlling = r;
}), [`${rI}`]: M((e, t) => {
  let { payload: r } = t;
  e.networkQualityBroadcastTime = r;
}), [`${i0}`]: M((e, t) => {
  let { payload: r } = t;
  e.mask.isMaskConfigured = r;
}), [`${Gd}`]: M((e, t) => {
  let { payload: r } = t;
  const { imageUrl: n, cropped: o, rootHeight: i, rootWidth: s, clip: a } = r;
  e.mask.imageSrc = n, e.mask.cropped = o, e.mask.clip = a, e.mask.rootWidth = s, e.mask.rootHeight = i, e.backgroundMode = oo.Mask;
}), [`${UO}`]: M((e, t) => {
  let { payload: r } = t;
  e.backgroundMode = r;
}), [`${nI}`]: M((e, t) => {
  let { payload: r } = t;
  e.capturedVideoDimension = r;
}), [`${oI}`]: M((e, t) => {
  let { payload: r } = t;
  e.ensuredCanvas.includes(r) || e.ensuredCanvas.push(r);
}), [`${Tf}`]: M((e, t) => {
  let { payload: r } = t;
  e.mediaPlaybackFile = r, e.isUsingMediaPlayback = !(r == null || !r.url);
}), [`${Ta}`]: M((e, t) => {
  let { payload: r } = t;
  if (r) {
    const { lastCopy: n, ...o } = r;
    e.prefetchedVideo = o;
  } else
    e.prefetchedVideo = r;
}), [`${kf}`]: M((e, t) => {
  let { payload: r } = t;
  Object.assign(e.subscriptionStatus, r);
}), [`${iI}`]: M((e, t) => {
  let { payload: r } = t;
  e.isFullHDVideoEnabled = r;
}), [`${sI}`]: M((e, t) => {
  let { payload: r } = t;
  const { userId: n, element: o } = r, i = e.videoAttachments[`${n}`];
  if (i)
    i.indexOf(o) === -1 && i.push(o);
  else {
    const s = [];
    s.push(o), Object.assign(e.videoAttachments, { [`${n}`]: s });
  }
}), [`${qd}`]: M((e, t) => {
  let { payload: r } = t;
  const { userId: n, element: o } = r, i = e.videoAttachments[`${n}`];
  let s = o;
  Array.isArray(o) || (s = [o]), s.forEach((a) => {
    if (i) {
      const l = i.indexOf(a);
      l !== -1 && i.splice(l, 1);
    }
  });
}), [`${aI}`]: M((e, t) => {
  let { payload: r } = t;
  r && (e.rendererType = N1.WebGL2);
}), [`${lI}`]: M((e, t) => {
  let { payload: r } = t;
  r && (e.rendererType = N1.WebGPU);
}), [`${uI}`]: M((e, t) => {
  let { payload: r } = t;
  e.rendererType = r;
}), [`${GE}`]: (e, t) => {
  let { payload: r } = t;
  const n = { cameraDevicesList: e.cameraDevicesList };
  return r && Object.assign(n, { activeCamera: e.activeCamera, customizedVideoOption: e.customizedVideoOption, virtualBackground: { imageSrc: e.virtualBackground.imageSrc, cropped: e.virtualBackground.cropped }, mask: { imageSrc: e.mask.imageSrc, cropped: e.mask.cropped, rootWidth: e.mask.rootWidth, rootHeight: e.mask.rootHeight, clip: e.mask.clip }, backgroundMode: e.backgroundMode, ptz: e.ptz, subscriptionStatus: e.subscriptionStatus }), { ...uy, ...n };
} }, uy), PM = { cameraPtzEpics0: (e, t) => se(e, 8004).pipe(G((r) => {
  const { payload: { body: { nCmd: n, nUserID: o, nReason: i, nButtonID: s } } } = r, a = t.value, l = ft(a), { video: { currentCameraControlStatus: { isInControl: u, controllingUserId: d }, cameraDevicesList: c, activeCamera: p } } = a, h = l.find((f) => Xr(f.userId, o)), v = [];
  if (v.push(r0(!0)), n === Lr.Request) {
    const f = { userId: h == null ? void 0 : h.userId, displayName: h == null ? void 0 : h.displayName };
    if (u) {
      const m = l.find((g) => g.userId === d);
      Object.assign(f, { currentControllingUserId: m == null ? void 0 : m.userId, currentControllingDisplayName: m == null ? void 0 : m.displayName });
    }
    O(zC, f);
  } else if (n === Lr.Approve)
    v.push(tI(h == null ? void 0 : h.userId)), O(Z1, { isApproved: !0, userId: h == null ? void 0 : h.userId, displayName: h == null ? void 0 : h.displayName });
  else if (n === Lr.Decline)
    v.push(o0(h == null ? void 0 : h.userId)), O(Z1, { isApproved: !1, userId: h == null ? void 0 : h.userId, displayName: h == null ? void 0 : h.displayName, reason: i });
  else if (n === Lr.GiveUp)
    v.push(n0({ isInControl: !1, userId: 0 })), O(Nc, { isControlled: !1 });
  else if (n === Lr.StartControl || n === Lr.StopControl)
    v.push(Rf({ cmd: n === Lr.StartControl ? "start" : "stop", type: s }));
  else if (n === Lr.SwitchCamera) {
    const f = c.findIndex((g) => g.deviceId === p), m = f + 1 === c.length ? 0 : f + 1;
    if (m !== f) {
      const g = c[m].deviceId;
      ly.changeCamera(g);
    }
  }
  return ne(v);
})), cameraPtzEpics1: (e, t) => se(e, gt).pipe(z((r) => {
  var n;
  const { payload: { body: o } } = r;
  return o == null || (n = o.update) === null || n === void 0 ? void 0 : n.some((i) => i.nFECC !== void 0 || i.nFECCExecutive !== void 0);
}), he((r) => {
  const { payload: { body: { update: n } } } = r, o = n.find((i) => i.nFECC !== void 0 || i.nFECCExecutive !== void 0);
  if (o) {
    const { meeting: { userId: i } } = t.value;
    Xr(o.nFECCExecutive, i) && O(WC, { userId: o.id, ptz: a_(o.nFECC) });
  }
}), Ie(oe)), cameraPtzEpics2: (e, t) => se(e, gt).pipe(z((r) => {
  var n;
  const { payload: { body: o } } = r, { video: { farEndCameraControlStatus: { controlledUserList: i } } } = t.value;
  return o == null || (n = o.remove) === null || n === void 0 ? void 0 : n.some((s) => i.includes(s.id));
}), G((r) => {
  var n;
  const { payload: { body: o } } = r, i = [], { video: { farEndCameraControlStatus: { controlledUserList: s } } } = t.value, a = o == null || (n = o.remove) === null || n === void 0 ? void 0 : n.find((l) => s.includes(l.id));
  return a && i.push(o0(a.id)), ne(i);
})), cameraPtzEpics3: (e, t) => e.pipe(ge(`${Rf}`), ze((r) => {
  const { payload: { cmd: n, type: o } } = r;
  return n === "start" ? nr(0, 200).pipe(hs(() => !!t.value.video.currentCameraControlStatus.isCameraMoving), G(() => {
    const { video: { ptz: i, activeCamera: s } } = t.value, a = i[s], l = tg(a) || {}, { key: u, range: d } = s_(o, 2);
    return a[u] ? (Object.assign(l, { [u]: i_(a[u].capability, a[u].value, d) }), ly.movePTZCamera(l).then(() => Rm({ deviceId: s, constraints: l }))) : Promise.resolve(void 0);
  }), G((i) => typeof i == "object" && i.type !== void 0 ? Je(i) : oe)) : oe;
})), cameraPtzEpics4: (e, t) => e.pipe(ge(`${Kc}`), G((r) => {
  const { payload: n } = r, { video: { customizedVideoOption: o, ptz: i } } = t.value;
  if (o != null && o.ptz) {
    const s = i == null ? void 0 : i[n];
    s !== void 0 && kM.sendCameraAblity({ pan: !!s.pan, tilt: !!s.tilt, zoom: !!s.zoom });
  }
  return oe;
})) }, DM = { videoCaptureEpics0: (e, t) => Pe(e, X.StartVideoCaptureSuccess).pipe(G((r) => {
  const { video: { cameraDevicesList: n, activeCamera: o, ptz: i, isCurrentUserStartedVideo: s, isUsingMediaPlayback: a }, meeting: { userId: l } } = t.value, { payload: { data: { currentDeviceID: u, PTZRange: d } } } = r, c = [];
  if (n.length < 1 && !a && (O(V1, { reason: "Cannot detect camera devices" }), $n.stopCaptureVideo()), n_(o, n) || a) {
    if (s || hd.muteAttendeeVideo(l, !1), O(ZC), a)
      c.push(Kc("default"));
    else if (u && d && c.push(eI({ deviceId: u, ptzRange: d })), o !== u && c.push(Kc(u)), Object.prototype.hasOwnProperty.call(i, u)) {
      const p = i[u];
      if (p) {
        const h = tg(p);
        h && $n.movePTZCamera(h);
      }
    }
  } else
    O(j1, { reason: "cannot find target camera" }), $n.stopCaptureVideo();
  return ne(c);
})), videoCaptureEpics1: (e, t) => se(e, gt).pipe(z((r) => {
  const { payload: { body: { update: n } } } = r, { meeting: { userId: o } } = t.value;
  return n == null ? void 0 : n.some((i) => i.id === o && i.bVideoOn !== void 0);
}), ae((r) => {
  const { payload: { body: { update: n } } } = r, { meeting: { userId: o } } = t.value, i = n.find((s) => s.id === o);
  return i.bVideoOn === !0 ? O(cm) : O(ws), zE(!!i.bVideoOn);
})), videoCaptureEpics2: (e) => Pe(e, [X.UserForbiddedCaptureVideo, X.UserCameraIsTakenByOtherPrograms, X.VideoWebsocketBroken, X.StopVideoCaptureFailed]).pipe(G((t) => {
  const { payload: { type: r } } = t, n = [];
  switch (r) {
    case X.UserForbiddedCaptureVideo:
      O(U1), n.push(Jc(!0));
      break;
    case X.UserCameraIsTakenByOtherPrograms:
      O(B1, { reason: "User camera is taken by other programs." }), n.push(Qc(!0));
      break;
    case X.VideoWebsocketBroken:
      O(BC, { reason: "Video websocket broken." });
      break;
    case X.StopVideoCaptureFailed:
      O(ws, { failed: !0, reason: "Unknown." });
  }
  return ne(n);
})), videoCaptureEpics3: (e, t) => Pe(e, X.StopVideoCaptureSuccess).pipe(pe(t), xs((r) => {
  let [, n] = r;
  const { meeting: { userId: o }, video: { isCurrentUserStartedVideo: i } } = n;
  i || O(ws), hd.muteAttendeeVideo(o, !0);
})), videoCaptureEpics4: (e, t) => se(e, 16133).pipe(pe(t), z((r) => {
  var n, o;
  let [i, s] = r;
  return (i == null || (n = i.payload) === null || n === void 0 || (o = n.body) === null || o === void 0 ? void 0 : o.id) === s.meeting.userId;
}), xs((r) => {
  let [n] = r;
  const { id: o, bVideoMute: i } = n.payload.body;
  return O(xC, { id: o, isVideoMuted: i }), i === !0 && $n.stopCaptureVideo(), i === !1 && O(VC, { id: o, isVideoMuted: i }), ZE(i);
})), videoCaptureEpics5: (e, t) => se(e, 16131).pipe(z((r) => r.payload.body.ssrc !== void 0), ze((r) => {
  const { payload: { body: { ssrc: n } } } = r;
  return O(qC, n), Kt(Je(HE(n)), Ns(t).pipe(G((o) => {
    const { meeting: { isCurrentUserStartVideoBeforeReset: i }, media: { videoEncodeStatus: s } } = t.value;
    return (o == null ? void 0 : o.bVideoOn) !== !0 && i === !0 ? _r("video", s, "success").pipe(z((a) => {
      let [l, u] = a;
      return l && u;
    }), ae(() => {
      const a = t.value, { video: { backgroundMode: l, mask: u, virtualBackground: d, activeCamera: c, customizedVideoOption: p } } = a;
      let h = Promise.resolve(!0);
      return l === oo.VirtualBackground && d.imageSrc ? h = nc({ imageUrl: d.imageSrc, cropped: d.cropped }, $n, a) : l === oo.Mask && u.imageSrc && u.clip && (h = oc({ imageUrl: u.imageSrc, cropped: u.cropped, clip: u.clip, rootHeight: u.rootHeight, rootWidth: u.rootWidth }, $n, a)), h.then(() => {
        o_($n, a, { cameraId: c, ...p });
      }), aC(void 0);
    })) : oe;
  })));
})), videoCaptureEpics6: (e, t) => e.pipe(ge(`${_m}`), he((r) => {
  const { payload: n } = r, o = t.value, { meeting: { userId: i } } = o, s = be(o);
  n.length === 0 ? s && !s.bVideoConnect || hd.connectCamera(i, !1) : s != null && s.bVideoConnect || hd.connectCamera(i, !0);
}), Ie(oe)), videoCaptureEpics7: (e) => Pe(e, X.InitSuccessVideo).pipe(z((t) => !ve.isIPad && ve.isAndroidOrIOSBrowser && t.payload.data === Br.EncodeSuccess), ze(() => "orientation" in window.screen ? Ct(screen.orientation, "change").pipe(G(() => ($n.setMobileRotateMode(oy()), oe))) : Ct(window, "orientationchange").pipe(G((t) => {
  var r, n, o;
  const i = (r = t.target) === null || r === void 0 || (n = r.screen) === null || n === void 0 || (o = n.orientation) === null || o === void 0 ? void 0 : o.angle, s = Math.abs(i) === 90;
  return $n.setMobileRotateMode(s), oe;
})))), videoCaptureEpics8: (e) => Pe(e, X.StartVideoCaptureSuccess).pipe(z(() => !ve.isIPad && ve.isAndroidOrIOSBrowser), he(() => {
  $n.setMobileRotateMode(oy());
}), Ie(oe)), videoCaptureEpics9: (e, t) => Pe(e, X.VideoStreamFailed).pipe(z(() => !!t.value.video.isCurrentUserStartedVideo && ve.isIOSMobile), he(() => {
  $n.stopCaptureVideo();
}), Ie(oe)) }, LM = { videoRenderEpics0: (e) => se(e, 16129).pipe(ae((t) => {
  const { payload: { body: { id: r, bVideoOn: n } } } = t, o = ny(r);
  return O(NC, { bVideoOn: n, userId: o }), FE({ bVideoOn: n, userId: o });
})), videoRenderEpics1: (e, t) => Pe(e, X.VideoDecodeMaxSize).pipe(z((r) => {
  var n;
  return r == null || (n = r.payload) === null || n === void 0 ? void 0 : n.data;
}), ae((r) => {
  const { size: n } = r.payload.data, { video: { renderedVideoList: o, receivedVideoMaxQuality: i } } = t.value, s = o.filter((a) => a.videoQuality >= gn.Video_720P);
  return i !== n && s.length > 0 && (n >= gn.Video_720P || i >= gn.Video_720P) && s.forEach((a) => {
    Xs.subscribeVideo(a.userId, a.videoQuality, !1);
  }), WE(n);
})), videoRenderEpics2: (e) => se(e, 16135).pipe(ae((t) => {
  const { payload: { body: { bLeadershipOn: r, id: n } } } = t, o = [];
  return r && o.push(ny(n)), O($1, { spotlightList: o }), Ef(o);
})), videoRenderEpics3: (e, t) => se(e, 7958).pipe(pe(t), ae((r) => {
  let [n, o] = r;
  const { payload: { body: i } } = n;
  let s = [];
  i && i.group_list && i.group_list[0] && (s = i.group_list[0].map((l) => l.id));
  const a = ft(o);
  return s = s.filter((l) => a.findIndex((u) => u.userId === l) >= 0), O($1, { spotlightList: s }), Ef(s);
})), videoRenderEpics4: (e) => Pe(e, X.CurrentVideoResolution).pipe(xs((t) => (O(x1, t.payload.data), If(t.payload.data)))), videoRenderEpics5: (e) => Pe(e, [X.CurrentVideoResolution, X.CurrentCaptureVideoWidthHeight]).pipe(z((t) => !!t.payload.data), ae((t) => {
  const { payload: { data: r, type: n } } = t;
  return n === X.CurrentVideoResolution ? (O(x1, r), If(r)) : (O(jC, r), nI(r));
})), videoRenderEpics6: (e) => se(e, En).pipe(z((t) => {
  const { payload: { body: r } } = t;
  return ["bFollowHostVideo", "VideoHd", "bCanUnmuteVideo"].some((n) => r[n] !== void 0);
}), ae((t) => {
  const { payload: { body: { bFollowHostVideo: r, VideoHd: n, bCanUnmuteVideo: o } } } = t;
  if (r !== void 0)
    return O($C, { bOn: r }), qE(r);
  if (o !== void 0)
    return YE(o);
  {
    const i = n === 1;
    return co.updateVideoHDValue(i), co.enableHardwareAccelerationForVideoEncode(!1), JE(i);
  }
})), videoRenderEpics7: (e, t) => se(e, 7957).pipe(pe(t), ae((r) => {
  let [n, o] = r;
  const { video: { isFollowHostVideoLayout: i } } = o, { payload: { body: s } } = n, a = s && s.drag_list && s.drag_list.map((l) => l.id);
  return i && O(HC, { layout: a }), KE(a);
})), videoRenderEpics8: (e, t) => se(e, gt).pipe(pe(t), z((r) => {
  let [n, o] = r;
  const { meeting: { userId: i }, video: { subscribedVideoList: s } } = o, a = n.payload.body.update, l = n.payload.body.remove;
  return a && a.length > 0 && a.findIndex((u) => u.id !== i && (u.bVideoOn !== void 0 || u.bHold)) > -1 || l && l.some((u) => s.includes(u.id));
}), he((r) => {
  let [n, o] = r;
  const { payload: { body: { remove: i, update: s } } } = n, { video: { subscribedVideoList: a } } = o, l = xO(o);
  if (i && i.length > 0 && i.filter((u) => a.includes(u.id)).forEach((u) => {
    O(Vd, { userId: u.id });
  }), s && s.length > 0) {
    const u = s.filter((c) => c.bVideoOn !== void 0).filter((c) => l.findIndex((p) => p.userId === c.id) === -1), d = s.filter((c) => c.bHold === !0);
    d.length > 0 && d.filter((c) => a.includes(c.id)).forEach((c) => {
      O(Vd, { userId: c.id });
    }), u.forEach((c) => {
      c.bVideoOn ? O(FC, { userId: c.id }) : a.includes(c.id) && O(Vd, { userId: c.id });
    });
  }
}), Ie(oe)), videoRenderEpics9: (e, t) => Pe(e, X.VideoQosData).pipe(pe(t), ae((r) => {
  var n;
  let [o, i] = r;
  const { video: { isCaptureForbidden: s, isCameraTaken: a }, media: { videoEncodeStatus: l, videoDecodeStatus: u } } = i, d = be(i), c = Sm(i), p = c.length > 0, h = (d == null ? void 0 : d.bVideoOn) && !s && !a, v = c.some((g) => g.bVideoOn), f = l === "success" && h && p, m = u === "success" && p && v;
  return (n = o.payload.data) !== null && n !== void 0 && n.encoding ? f ? (O(F1, o.payload), e0(o.payload)) : e0(Ri) : m ? (O(F1, o.payload), t0(o.payload)) : t0(Ri);
})), videoRenderEpics10: (e, t) => Pe(e, [X.CurrentDecodeVideoQuality, X.CurrentDecodeVideoFps]).pipe(he((r) => {
  const { payload: { type: n, data: o } } = r, { video: { subscriptionStatus: i } } = t.value;
  if (i.detailed) {
    if (n === X.CurrentDecodeVideoQuality) {
      const { ssrc: s, width: a, height: l, quality: u } = o;
      O(z1, { userId: s, width: a, height: l, quality: u });
    } else if (n === X.CurrentDecodeVideoFps) {
      const { ssrc: s, fps: a } = o;
      O(z1, { userId: s, fps: a });
    }
  }
}), Ie(oe)), videoRenderEpics11: (e, t) => Yv(e, t).pipe(G(async () => ve.isAndroidOrIOSBrowser ? 1 : await ke.isSupportVideoDecodeHardwareAcceleration() ? 4 : 1), ae((r) => QE(r))), videoRenderEpics12: (e, t) => Pe(e, X.NetworkQualityChange).pipe(z((r) => !!r.payload.data), G((r) => {
  var n;
  const { payload: { data: { bwLevel: o, isUplink: i, networkLevel: s } } } = r, a = [], { meeting: { userId: l }, video: { networkQuality: u, subscribedVideoList: d, networkQualityBroadcastTime: c } } = t.value, p = i ? "uplink" : "downlink";
  a.push(_f({ userId: l, level: s, bwLevel: o, type: p }));
  const h = Lu((n = u[`${l}`]) === null || n === void 0 ? void 0 : n[p], { level: s, bwLevel: o });
  if (!h && s !== -1 && (!i && d.filter((v) => v !== l).length > 0 || i) && O(W1, { userId: l, type: p, level: s }), i) {
    const v = performance.now();
    (!h || v - (c != null ? c : 0) > 3e4) && (Xs.broadcastUserNetworkQuality({ isUplink: i, level: s, bwLevel: o }), a.push(rI(v)));
  }
  return ne(a);
})), videoRenderEpics13: (e, t) => to(e, 8005).pipe(z((r) => {
  var n;
  return !((n = r.payload.body) === null || n === void 0 || !n.nUserID);
}), G((r) => {
  const { payload: { body: { nLevel: n, nUserID: o } } } = r, { video: { networkQuality: i } } = t.value, s = i[`${o}`], a = [];
  return s && s.uplink.level === n || (O(W1, { userId: o, level: n, type: "uplink" }), a.push(_f({ userId: o, level: n, type: "uplink" }))), ne(a);
})), videoRenderEpics14: (e, t) => se(e, gt).pipe(z((r) => {
  const { payload: { body: n } } = r, { video: { prefetchedVideo: o } } = t.value;
  return (o == null ? void 0 : o.userId) && (n.update || n.remove);
}), G((r) => {
  const { payload: { body: n } } = r, o = [], { video: { prefetchedVideo: i } } = t.value;
  let s = !1;
  return n.remove && (s = n.remove.findIndex((a) => a.id === (i == null ? void 0 : i.userId)) !== -1), n.update && (s = n.update.findIndex((a) => a.id === (i == null ? void 0 : i.userId) && a.bVideoOn === !1) !== -1), s && i && (i.loaded || co.cancelPrefetchVideoSsrc(i.userId), Xs.unsubscribeVideo(i.userId), o.push(Ta(void 0))), ne(o);
})), videoRenderEpics15: (e, t) => e.pipe(ge(`${Ta}`), z((r) => !!r.payload), he((r) => {
  const { payload: { lastCopy: n } } = r, { video: { prefetchedVideo: o } } = t.value;
  !o || n && n.userId === o.userId || (n != null && n.userId && (n.loaded && co.cancelPrefetchVideoSsrc(n.userId), Xs.unsubscribeVideo(n.userId)), Xs.subscribeVideo(o.userId, gn.Video_360P, !1), co.prefetchVideoSsrc(o.userId));
}), Ie(oe)), videoRenderEpics16: (e, t) => Pe(e, X.NewActiveSpeakerFirstFrameCallback).pipe(z(() => !!t.value.video.prefetchedVideo), G((r) => {
  const { payload: { data: { ssrc: n } } } = r, { video: { prefetchedVideo: o } } = t.value, i = [];
  return o && (Xr(o.userId, n) ? (i.push(Ta({ userId: o.userId, loaded: !0, lastCopy: o })), O(GC, { userId: o.userId })) : Xs.unsubscribeVideo(o.userId)), ne(i);
})), videoRenderEpics17: (e, t) => se(e, 16131).pipe(z((r) => r.payload.body.ssrc !== void 0), he(() => {
  const { media: { videoDecodeStatus: r, videoEncodeStatus: n } } = t.value;
  _r("video", n, r).subscribe((o) => {
    let [i, s] = o;
    const { video: { subscriptionStatus: a } } = t.value;
    i && a.encode && co.subscribeToQos([ur.VideoEncode], fi), s && (a.decode && co.subscribeToQos([ur.VideoDecode], fi), a.detailed && co.enableVideoObserver(!0));
  });
}), Ie(oe)), videoRenderEpics18: (e, t) => e.pipe(ge(`${Oa}`, `${Yc}`), z(() => {
  const r = t.value.video.renderedVideoList.length;
  return [0, 1].includes(r);
}), he(() => {
  const r = t.value.video.renderedVideoList.length;
  r === 1 ? co.enableVideoObserver(!0, !0) : r === 0 && co.enableVideoObserver(!1);
}), Ie(oe)), videoRenderEpics19: (e, t) => Pe(e, X.CurrentDecodeVideoQuality).pipe(G((r) => {
  const { payload: { data: n } } = r, { video: { renderedVideoList: o, videoAttachments: i } } = t.value, s = [], { ssrc: a, width: l, height: u } = n, d = u ? l / u : 0, c = o.filter((p) => Xr(p.userId, a));
  if (c.some((p) => p.aspectRatio && Math.abs(p.aspectRatio - d) > 0.2)) {
    const p = c.filter((h) => h.canvasId === Wl);
    if (p.length > 0) {
      const h = i[`${a}`];
      h && h.every((v) => {
        if (v) {
          const { clientWidth: f, clientHeight: m } = v, g = m ? f / m : 0;
          return Math.abs(g - d) <= 0.2;
        }
        return !0;
      }) && s.push(Oa({ userId: a, key: Yi, canvasId: Wl, aspectRatio: d }));
    }
    p.length === c.length && s.length !== 0 || O(KC, { userId: a, aspectRatio: d });
  }
  return ne(s);
})), videoRenderEpics20: (e, t) => Pe(e, X.SyncRendererTypeResponse).pipe(G((r) => {
  const { payload: { data: { rendererType: n } } } = r, { video: { rendererType: o } } = t.value, i = [];
  return o !== n && i.push(uI(n)), ne(i);
})) }, NM = Wr(LM, DM, { vbEpics0: (e) => Pe(e, [X.VbModelPreloadingOk, X.VbModelPreloading_3S, X.VbModelPreloading_10S, X.VbSettingParaError]).pipe(G((t) => {
  const { payload: { type: r, data: n } } = t, o = [];
  return [X.VbModelPreloadingOk, X.VbModelPreloading_3S, X.VbModelPreloading_10S].includes(r) ? (o.push(Af(!0)), O(Lc, !0), r === X.VbModelPreloading_10S && console.warn("Virtual Background is taking longer than expected to load.")) : r === X.VbSettingParaError && (n === LC.VBModelNotMatch ? (O(Lc, !1), o.push(Af(!1))) : (O(H1, !1), o.push(Xc(!1)))), ne(o);
})), vbEpics1: (e) => Pe(e, X.StartVideoStreamInVbSettingSuccess).pipe(ae(() => (O(H1, !0), Xc(!0)))), vbEpics2: (e) => Pe(e, X.StartVideoStreamInMaskSettingSuccess).pipe(ae(() => (O(G1, !0), i0(!0)))), vbEpics3: (e) => Pe(e, X.MaskSettingParaError).pipe(ae(() => (O(G1, !1), i0(!1)))) }, PM);
class Yn {
  constructor() {
    this.assetsPath = void 0, this.instance = void 0, this.callbackList = void 0, this.mediaWorkersPath = void 0, this.mediaOptions = void 0, this.inProgress = void 0, this.callbackList = [];
  }
  static getInstance() {
    return this.agentInstance === void 0 && (this.agentInstance = new Yn()), this.agentInstance;
  }
  init(t, r) {
    var n, o, i, s, a;
    if (!this.instance && window.JsMediaSDK_Instance) {
      const u = { ivObj: { [qt.AUDIO_ENCODE]: void 0, [qt.VIDEO_ENCODE]: void 0, [qt.SHARING_ENCODE]: void 0 } };
      this.instance = new window.JsMediaSDK_Instance(u);
    }
    this.mediaWorkersPath = IC(t, !1), this.onMediaSDKCallback = this.onMediaSDKCallback.bind(this), this.mediaOptions = r, (n = this.instance) === null || n === void 0 || n.JsMediaSDK_PreLoad(this.mediaWorkersPath, this.onMediaSDKCallback, r);
    const l = Ia((o = this.mediaOptions) === null || o === void 0 ? void 0 : o.enableMultiDecodeVideoWithoutSAB);
    (i = this.instance) === null || i === void 0 || i.setPropsBeforeInit({ callback: this.onMediaSDKCallback, audioWorkerPath: (s = this.mediaWorkersPath) === null || s === void 0 ? void 0 : s.audioWorkletPath, isEnableListenInitEvent: !0 }), (a = this.instance) === null || a === void 0 || a.initVideoEncode(this.mediaWorkersPath, "", 0, !1, "", 0, l, !1, !1, !0, !0, !1, !0), this.inProgress = !0;
  }
  onMediaSDKCallback(t, r) {
    this.callbackList.length > 0 && this.callbackList.forEach((n) => n(t, r));
  }
  registerCallback(t) {
    this.callbackList.push(t);
  }
  unregisterCallback(t) {
    this.callbackList = this.callbackList.filter((r) => r !== t);
  }
  async destroy() {
    var t;
    this.callbackList = [], await ((t = this.instance) === null || t === void 0 ? void 0 : t.destroy()), this.instance = null, this.inProgress = !1;
  }
  disconnect() {
    var t, r;
    (t = this.instance) === null || t === void 0 || t.Notify_MeidaSDK(17, {}), (r = this.instance) === null || r === void 0 || r.JsMediaSDK_UnInit();
  }
  startVirtualBackgroundSetting(t, r, n, o, i, s) {
    var a;
    let l = arguments.length > 6 && arguments[6] !== void 0 && arguments[6];
    (a = this.instance) === null || a === void 0 || a.Notify_MeidaSDK(91, { canvas: t, bgdom: r, width: i, height: s, ssid: 0, VideoSelectValue: o === "default" ? null : o, disableOriginalRatio: l });
  }
  updateVirtualBackgroundImage(t) {
    var r;
    (r = this.instance) === null || r === void 0 || r.Notify_MeidaSDK(92, { bgdom: t });
  }
  stopVirtualBackgroundSetting() {
    var t;
    let r = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
    (t = this.instance) === null || t === void 0 || t.Notify_MeidaSDK(93, { isSwitch: r });
  }
}
Yn.agentInstance = void 0;
const dy = "PREVIEW_VIDEO_ENCODE_SUCCESS", ph = "PREVIEW_VIDEO_VB_MODEL_READY";
async function cy(e, t, r) {
  const { imageUrl: n, cropped: o, deviceId: i } = r;
  if (n) {
    const s = await $u(n, o);
    if (s) {
      let a = Qo("__ZOOM_SDK_PREVIEW_VIRTUAL_BACKGROUND_CANVAS_@__");
      t.id ? a = t.id : t.id = a;
      let [l, u] = [640, 360];
      ke.isSupportSending720P() && (l = 1280, u = 720), e.startVirtualBackgroundSetting(a, s, 0, i != null ? i : "default", l, u), s !== Fa && setTimeout(() => {
        yu(s);
      }, 0);
    }
  }
}
class Os {
  constructor() {
    this.previewMediaAgent = Yn.getInstance(), this.isInit = void 0, this.isVideoEncoded = void 0, this.isVBModelReady = void 0, this.eventHandler = (t, r) => {
      switch (t) {
        case X.InitSuccessVideo:
          r === Br.EncodeSuccess && (this.isVideoEncoded = !0, O(dy));
          break;
        case X.VbModelPreloadingOk:
        case X.VbModelPreloading_3S:
        case X.VbModelPreloading_10S:
          this.isVBModelReady = !0, O(ph, !0);
          break;
        case X.VbSettingParaError:
          r === LC.VBModelNotMatch && (this.isVBModelReady = !1, O(ph, !1));
      }
    };
  }
  static setMediaOption(t) {
    Os.mediaOption = t;
  }
  setup() {
    if (Os.mediaOption) {
      if (ke.getInstance().inProgress)
        return Promise.resolve("");
      if (!Yn.getInstance().inProgress) {
        this.isVideoEncoded = void 0, this.isVBModelReady = void 0, this.previewMediaAgent.unregisterCallback(this.eventHandler);
        const { assetsPath: t, enforceMultipleVideos: r, enforceVirtualBackground: n } = Os.mediaOption, o = { ...nA(t, r, n) };
        this.previewMediaAgent.init(t, o), this.previewMediaAgent.registerCallback(this.eventHandler);
      }
      return Promise.resolve("");
    }
    return Promise.reject({ type: W, reason: "Cannot preview video with virtual background before `client.init` method." });
  }
  async startPreview(t, r) {
    ke.getInstance().inProgress ? cy(ke.getInstance(), t, r) : (this.isVBModelReady !== void 0 ? ne([this.isVBModelReady]) : ht(ph, 1)).subscribe((n) => {
      n && (this.isVideoEncoded ? ne([!0]) : ht(dy, 1)).subscribe(() => {
        cy(Yn.getInstance(), t, r);
      });
    });
  }
  async stopPreview() {
    ke.getInstance().inProgress ? ke.getInstance().stopVirtualBackgroundSetting() : Yn.getInstance().stopVirtualBackgroundSetting();
  }
  async updatePreview(t, r) {
    const n = ke.getInstance().inProgress ? ke.getInstance() : Yn.getInstance();
    if (t) {
      const o = await $u(t, r);
      o && (n.updateVirtualBackgroundImage(o), o !== Fa && setTimeout(() => {
        yu(o);
      }, 0));
    } else
      n.updateVirtualBackgroundImage(null);
  }
}
Os.mediaOption = void 0;
const { InitSuccessVideo: hh, InitSuccessAudio: fh, InitSuccessSharing: vh, InitFailedVideo: py, InitFailedAudio: hy, InitFailedSharing: fy } = X, Cr = Vr(ke.getInstance()), vy = Zr.getInstance().makeLogger(["Media Agent"]), xM = [Qd, Yd, us].map((e) => tA(e, { hostname: !0 })), fd = [], VM = { epics0: (e, t) => e.pipe(ge(`${Un}`), ze(() => {
  const { meeting: { isMeetingReset: r } } = t.value;
  return e.pipe(ge(`${ti}`), Ge(1), Di((n) => {
    var o;
    const { logger: i, media: { mediaConstraints: s, assetsPath: a }, meeting: { zlkJwtToken: l, cv: u } } = t.value, { payload: { disableAqos: d, disableVqos: c } } = n, p = i != null && (o = i.options) !== null && o !== void 0 && o.enable ? Zr.getInstance().makeLogger(["MEDIA SDK"]) : void 0;
    return function(h) {
      const { media: { patchedMediaSDKStatus: v } } = h;
      return v === Nl.Loading ? gr(ht(Bd, 1)) : Promise.resolve();
    }(t.value).then(() => {
      const h = [];
      let v = !c;
      const f = !d;
      return l && Sc(u, "1.3.0") < 0 && (v = !1), h.push(M4({ audioQos: f, videoQos: v })), Cr.init(function(m) {
        return m && new Proxy(m, { get: (g, C) => typeof C == "string" && C === "error" ? function() {
          try {
            var b;
            wA.report(arguments.length <= 0 ? void 0 : arguments[0], ["MEDIA SDK", ...(b = arguments.length <= 1 ? void 0 : arguments[1]) !== null && b !== void 0 ? b : []], "error");
          } catch {
          }
        } : Reflect.get(g, C) });
      }(p)), h.push(Qv(!0)), r && s !== void 0 && a !== void 0 && h.push(Kv()), h;
    });
  }));
})), epics1: (e, t) => e.pipe(ge(`${Un}`), z((r) => {
  const { payload: { mediaSDKPath: n } } = r, { media: { skipJsMedia: o, patchJsMedia: i, assetsPath: s }, meeting: { isMeetingReset: a } } = t.value;
  return !o && xM.some((l) => new RegExp(`^https://${l}`).test(s != null ? s : "")) && !!i && !!n && !a;
}), ze((r) => {
  const { payload: { mediaSDKPath: n } } = r, o = rm(n);
  return ne(new Promise((i, s) => {
    const a = `${o}/${ss}`;
    "JsMediaSDK_Instance" in window && (window.JsMediaSDK_Instance_backup = window.JsMediaSDK_Instance, delete window.JsMediaSDK_Instance), jm(a, () => {
      "JsMediaSDK_Instance_backup" in window && delete window.JsMediaSDK_Instance_backup, vy.info(`patched media sdk url:${a}`), i("");
    }, () => {
      "JsMediaSDK_Instance_backup" in window && (window.JsMediaSDK_Instance = window.JsMediaSDK_Instance_backup, delete window.JsMediaSDK_Instance_backup), vy.error(`cannot load patched media sdk :${a}`), s();
    });
  })).pipe(G(() => (O(Bd), ne([Dd(Nl.Done), k4(o)]))), Xn(() => (O(Bd), ne([Dd(Nl.Done)]))), jn(Dd(Nl.Loading)));
})), epics2: (e, t) => Yv(e, t).pipe(he(() => {
  const { media: { assetsPath: r, mediaConstraints: n, fileWithVersion: o, enforceMultipleVideos: i, enforceVirtualBackground: s, isEnableDecoderInWorklet: a }, meeting: { isAudioBridgeEnabled: l } } = t.value;
  if (Cr.notifySDKMeetingReady(), r && n) {
    const u = { enableDecoderInWorklet: a, enableAudioBridge: l && fr() };
    Object.assign(u, nA(r, i, s)), Cr.setAssetsAndConstraint(r, n, o, u);
  }
  Ns(t).pipe(ze((u) => ne(Wf.acquire().then(() => u)))).subscribe((u) => {
    const { meeting: { svcUrl: d, meetingNumber: c, conId: p, e2eEncrypt: h, userId: v, isWebinar: f, enableWebtransport: m, webtransportPort: g }, media: { enableAudioQos: C, enableVideoQos: b, alternativeNameForVideoPlayer: E, adaptedABOptionForMediaSDK: w }, video: { rendererType: _ } } = t.value;
    u && (Cr.connect({ svcUrl: d, meetingNumber: c, conId: p, e2eEncrypt: h, isViewOnly: Jt(u.userRole), currentUserId: v, isWebinar: f, enableAudioQos: C, enableVideoQos: b, enableWebtransport: m, webtransportPort: g, rendererType: _, adaptedABOptionForMediaSDK: w }), function(I) {
      var D;
      let B = "video-player";
      I.tagName && (B = I.tagName, rn.dispatch("", { tagName: I.tagName }), ys((D = I.mediaSDK) === null || D === void 0 ? void 0 : D.call(I), `VPTN:${B}`));
      const L = `${B}-container`, R = I.sessionId || Qm();
      rn.get("mediaSDKInstanceMap").set(wu, I.mediaSDK), rn.get("mediaSDKInstanceMap").set(R, I.mediaSDK), I.failover && rn.dispatch("failover", void 0, I.sessionId || wu), customElements.get(L) || customElements.define(L, Qa), customElements.get(B) || customElements.define(B, Ja);
    }({ mediaSDK: () => Cr.instance, tagName: E, failover: "1" }));
  });
}), ze(() => _i((r) => Cr.registerCallback(r), (r) => Cr.unregisterCallback(r), (r, n) => ({ type: r, data: n })).pipe(ae((r) => R4(r))))), epics3: (e) => Pe(e, [hh, fh, vh, py, hy, fy]).pipe(iA((t) => {
  const { payload: { type: r, data: n } } = t;
  if (r === fh || r === hy) {
    if (n === Br.EncodeSuccess)
      return O(_w), Je(C1("success"));
    if (n === Br.DecodeSuccess)
      return O(Rw), Je(w1("success"));
    if (n === Br.EncodeFailed)
      return O(Mw), Je(C1("failed"));
    if (n === Br.DecodeFailed)
      return O(Pw), Je(w1("failed"));
  } else if (r === hh || r === py) {
    if (n === Br.EncodeSuccess)
      return O(Ow), Je(E1("success"));
    if (n === Br.DecodeSuccess)
      return O(Tw), Je(I1("success"));
    if (n === Br.EncodeFailed)
      return O(Dw), Je(E1("failed"));
    if (n === Br.DecodeFailed)
      return O(Lw), Je(I1("failed"));
  } else if (r === vh || r === fy) {
    if (n === Br.EncodeSuccess)
      return O(kw), Je(A1("success"));
    if (n === Br.DecodeSuccess)
      return O(tf), Je(Pd("success"));
    if (n === Br.EncodeFailed)
      return O(Nw), Je(A1("failed"));
    if (n === Br.DecodeFailed)
      return O(xw), Je(Pd("failed"));
    if (r === vh && n === void 0)
      return O(tf), Je(Pd("success"));
  }
})), epics4: (e, t) => Pe(e, [hh, fh]).pipe(ze(() => typeof navigator.mediaDevices == "object" ? Kt(c0(), Kt(Pe(e, X.StartVideoCaptureSuccess), Ct(navigator.mediaDevices, "devicechange"), Pe(e, X.UserGrantCaptureAudio).pipe(z(() => !t.value.audio.isUserGrantCaptureAudio))).pipe(G(() => c0().pipe(he(() => {
  setTimeout(() => {
    O(Vw);
  }, 50);
}))))).pipe(pe(t), G((r) => {
  let [n, o] = r;
  const i = [mE(n.microphones), gE(n.speakers), _m(n.cameras)];
  if (o.audio) {
    const { audio: { activeMicrophone: l, activeSpeaker: u, microphoneDevicesList: d, speakerDevicesList: c } } = o, p = be(o), { microphones: h, speakers: v } = n, f = d.filter((g) => h.findIndex((C) => C.deviceId === g.deviceId) === -1), m = c.filter((g) => v.findIndex((C) => C.deviceId === g.deviceId) === -1);
    if (f.length > 0) {
      if ($2(f[0], l, d)) {
        const g = vl(h);
        Cr.changeMicrophone("default", g == null ? void 0 : g.label, !(p == null || !p.muted)), i.push(hu("default"));
      }
    } else if (l === "default") {
      const g = vl(d), C = vl(h);
      d.length > 0 && (g == null ? void 0 : g.label) !== (C == null ? void 0 : C.label) && Cr.changeMicrophone("default", C == null ? void 0 : C.label, !(p == null || !p.muted));
    }
    var s, a;
    m.length > 0 ? $2(m[0], u, c) && (Cr.changeSpeaker("default"), i.push(X0("default"))) : u === "default" && c.length > 0 && ((s = vl(c)) === null || s === void 0 ? void 0 : s.label) !== ((a = vl(v)) === null || a === void 0 ? void 0 : a.label) && Cr.changeSpeaker("default");
  }
  return ne(i);
})) : oe)), epics5: (e, t) => to(e, gt).pipe(he((r) => {
  const { type: n, payload: { body: o } } = r, i = n === `${Yo}`;
  if (o.add) {
    const s = o.add.map((a) => ({ userid: a.id, sn: a.zoomID && wn(a.zoomID) }));
    if (!i) {
      const { meeting: { gcmSessinKey: a } } = t.value;
      Cr.sendUserNodeList(s, a);
    }
    Cr.updateUserMediaSN({ added: s, isFromMainSession: i, iVType: qt.SHARING_DECODE }), i && Cr.updateUserMediaSN({ added: s, isFromMainSession: i, iVType: qt.AUDIO_DECODE });
  }
  if (o.remove && o.remove.length > 0) {
    if (!i) {
      const { meeting: { gcmSessinKey: s } } = t.value;
      Cr.sendUserNodeList(o.remove.map((a) => ({ userid: a.id, bremove: !0 })), s);
    }
    Cr.updateUserMediaSN({ removed: o.remove.map((s) => s.id), isFromMainSession: i, iVType: qt.SHARING_DECODE }), i && Cr.updateUserMediaSN({ removed: o.remove.map((s) => s.id), isFromMainSession: i, iVType: qt.AUDIO_DECODE });
  }
}), Ie(oe)), epics6: (e) => Pe(e, X.AesGcmIvResponse).pipe(he((t) => {
  const { payload: { data: { workerType: r, iv: n } } } = t, o = xe.get(lt.WebclientIVState);
  if (o) {
    const i = { ...o, [r]: n };
    xe.set(lt.WebclientIVState, i, qe.SessionStorage);
  }
}), Ie(oe)), epics7: (e) => e.pipe(ge(`${js}`), z((t) => [D1, b2, sm].includes(t.payload.evt)), ae((t) => {
  const { payload: { evt: r, body: { encryptKey: n, additionalType: o } } } = t;
  return O4({ type: r === D1 ? "audio" : r === b2 ? "video" : "sharing", encryptKey: n, additionalType: o });
})), epics8: (e) => e.pipe(ge(`${Jv}`), he((t) => {
  const { payload: r } = t;
  Os.setMediaOption({ assetsPath: r.assetsPath, enforceMultipleVideos: r.enforceMultipleVideos, enforceVirtualBackground: r.enforceVirtualBackground });
}), Ie(oe)), epics9: (e) => e.pipe(ge(`${su}`, `${O1}`), he(() => {
  Yn.getInstance().inProgress && (Yn.getInstance().disconnect(), Wf.watch(Yn.getInstance().destroy()));
}), Ie(oe)), epics10: (e) => e.pipe(ge(`${su}`, `${O1}`), ze(() => "permissions" in navigator ? ["microphone", "camera"].map((t) => {
  navigator.permissions.query({ name: t }).then((r) => {
    const n = () => {
      O(Bw, { name: t, state: r.state });
    };
    n(), r.addEventListener("change", n), fd.push(() => {
      r.removeEventListener("change", n);
    });
  }).catch(() => {
  });
}) : oe), Ie(oe)), epics11: (e) => e.pipe(ge(`${om}`), z((t) => t.payload === xt.Closed), he(() => {
  fd.length > 0 && (fd.forEach((t) => t()), fd.length = 0);
}), Ie(oe)) }, jM = Wr(VM), UM = { meeting: JT, socket: lk, participants: hk, media: mk }, BM = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || f4;
function my(e) {
  return function(t) {
    for (var r = Object.keys(t), n = {}, o = 0; o < r.length; o++) {
      var i = r[o];
      typeof t[i] == "function" && (n[i] = t[i]);
    }
    var s, a = Object.keys(n);
    try {
      (function(l) {
        Object.keys(l).forEach(function(u) {
          var d = l[u];
          if (d(void 0, { type: gc.INIT }) === void 0)
            throw new Error(Dr(12));
          if (d(void 0, { type: gc.PROBE_UNKNOWN_ACTION() }) === void 0)
            throw new Error(Dr(13));
        });
      })(n);
    } catch (l) {
      s = l;
    }
    return function(l, u) {
      if (l === void 0 && (l = {}), s)
        throw s;
      for (var d = !1, c = {}, p = 0; p < a.length; p++) {
        var h = a[p], v = n[h], f = l[h], m = v(f, u);
        if (m === void 0)
          throw u && u.type, new Error(Dr(14));
        c[h] = m, d = d || m !== f;
      }
      return (d = d || a.length !== Object.keys(l).length) ? c : l;
    };
  }({ ...UM, ...e });
}
function K(e, t, r, n, o) {
  var i = {};
  return Object.keys(n).forEach(function(s) {
    i[s] = n[s];
  }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function(s, a) {
    return a(e, t, s) || s;
  }, i), o && i.initializer !== void 0 && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), i.initializer === void 0 && (Object.defineProperty(e, t, i), i = null), i;
}
const At = Symbol("store"), ce = Symbol("getState"), Nt = Symbol("dispatch"), O0 = Symbol("additionFeatures"), J = Symbol("mediaContext");
function Y(e, t, r) {
  const n = r.value;
  r.value = function() {
    const o = this[At];
    if (o) {
      const { meeting: { isOnHold: l, isMeetingReset: u, meetingStatus: d } } = o.getState();
      if (d !== xt.Joined)
        return Promise.reject({ type: _a, reason: "closed" });
      if (u)
        return Promise.reject({ type: _a, reason: "reconnecting" });
      if (l)
        return Promise.reject({ type: _a, reason: "on hold" });
    }
    for (var i = arguments.length, s = new Array(i), a = 0; a < i; a++)
      s[a] = arguments[a];
    return n.apply(this, s);
  };
}
function rr(e, t, r) {
  const n = r.value;
  r.value = function() {
    const o = this[At];
    if (o) {
      const l = o.getState();
      if (!Sn(l))
        return Promise.reject({ type: Or, reason: "only host or co-host can do the operation" });
    }
    for (var i = arguments.length, s = new Array(i), a = 0; a < i; a++)
      s[a] = arguments[a];
    return n.apply(this, s);
  };
}
function Qt(e, t, r) {
  const n = r.value;
  r.value = function() {
    const o = this[At];
    if (o) {
      const l = o.getState();
      if (!NO(l))
        return Promise.reject({ type: Or, reason: "only host can do the operation" });
    }
    for (var i = arguments.length, s = new Array(i), a = 0; a < i; a++)
      s[a] = arguments[a];
    return n.apply(this, s);
  };
}
function de(e) {
  return function(t, r, n) {
    const o = n.value;
    n.value = function() {
      const i = this[At];
      if (i && i.getState()[e] === void 0)
        return Promise.reject({ type: W, reason: `Module:${e} is not enabled` });
      for (var s = arguments.length, a = new Array(s), l = 0; l < s; l++)
        a[l] = arguments[l];
      return o.apply(this, a);
    };
  };
}
function gy(e) {
  return function(t, r, n) {
    const o = n.value;
    n.value = function() {
      const i = this[At];
      if (i) {
        const { meeting: { meetingOptions: u } } = i.getState();
        if (u[e] === !0)
          return Promise.reject({ type: "OPERATION_LOCKED", reason: `${e} is locked` });
      }
      for (var s = arguments.length, a = new Array(s), l = 0; l < s; l++)
        a[l] = arguments[l];
      return o.apply(this, a);
    };
  };
}
let Ei = function(e) {
  return e.Self = "Self", e.Other = "Other", e.Client = "Client", e.Phone = "Phone", e.Attendee = "Attendee", e;
}({});
function mh(e) {
  return function(t, r, n) {
    const o = n.value;
    n.value = function(i) {
      const s = this[At];
      if (s) {
        const c = s.getState(), p = Array.isArray(e) ? e : [e];
        let h = ft(c).find((v) => v.userId === i);
        if (p.findIndex((v) => v === Ei.Attendee) > -1 && (h = ju(c).find((v) => v.userId === i)), !h)
          return Promise.reject({ type: De, reason: "no matching user" });
        {
          const { meeting: { userId: v } } = s.getState();
          for (let f = 0; f < p.length; f++) {
            const m = p[f];
            if (m === Ei.Other && i === v)
              return Promise.reject({ type: W, reason: "operation is not applicable to self" });
            if (m === Ei.Self && i !== v)
              return Promise.reject({ type: W, reason: "operation is only applicable to self " });
            if (m === Ei.Client && Wa(h.userType) || m === Ei.Phone && !Wa(h.userType))
              return Promise.reject({ types: W, reason: "improper target client" });
          }
        }
      }
      for (var a = arguments.length, l = new Array(a > 1 ? a - 1 : 0), u = 1; u < a; u++)
        l[u - 1] = arguments[u];
      const d = [i, ...l];
      return o.apply(this, d);
    };
  };
}
const gh = Zr.getInstance();
function nn(e, t) {
  return function(r, n, o) {
    const i = o.value;
    o.value = function() {
      for (var s = arguments.length, a = new Array(s), l = 0; l < s; l++)
        a[l] = arguments[l];
      if (gh.checkLaplace())
        try {
          var u;
          const d = gh.makeLogger([e]), c = (u = t ? a.map((p, h) => t.includes(h + 1) ? xr(p) : p) : a) === null || u === void 0 ? void 0 : u.map((p) => Cc(p));
          return d.info(`${n},params:${JSON.stringify(c)}`), i.apply(this, a).then((p) => (d.info(`${n} success`), p)).catch((p) => {
            let h = `${n},params:${JSON.stringify(c)},return failed,`;
            return typeof p == "object" && (h = `${h},${p.type ? `type:${p.type},` : ""}${p.reason ? `reason:${p.reason}` : ""}`), gh.report(h, `${e} exception flow`, "error"), Promise.reject(p);
          });
        } catch {
        }
      return i.apply(this, a);
    };
  };
}
function np(e, t, r) {
  return function(n, o, i) {
    const s = i.value;
    i.value = function() {
      for (var a, l, u = arguments.length, d = new Array(u), c = 0; c < u; c++)
        d[c] = arguments[c];
      const p = d[t];
      let h = e;
      return Array.isArray(h) || (h = [h]), !h.some((v) => p instanceof v) || r && !r.every((v) => !!p[v]) ? Promise.reject({ type: De, reason: `Expected to accept ${(a = h) === null || a === void 0 ? void 0 : a.map((v) => v.name).join(" or ")}, but actual it is ${typeof p == "object" && p !== null ? (l = Object.getPrototypeOf(p)) === null || l === void 0 ? void 0 : l.constructor.name : p}` }) : s.apply(this, d);
    };
  };
}
class Po {
  constructor(t) {
    this[At] = void 0, this[Nt] = void 0, this[ce] = void 0, this[O0] = void 0, this[At] = t, this[Nt] = t.dispatch, this[ce] = t.getState;
  }
}
const $M = ["userId", "displayName", "audio", "isHost", "avatar", "bRaiseHand", "bHold", "bVideoOn", "sharerOn", "sharerPause", "feedback", "bLocalRecord", "strPronoun", "sdkKey", "audioConnectionStatus", "caps", "bAllowISORecord", "bVideoConnect", "userIdentity", "isSpeakerOnly", "bVideoShare", "bShareAudioOn", "bShareToBORooms", "bid", { from: "bInFailover", to: "isInFailover" }, { from: "userGUID", to: "userGuid" }, { from: "bGuest", to: "isGuest" }, { from: "sharerPause", to: "sharePause" }, { from: "bCoHost", to: (e) => ({ isCoHost: !!e }) }, { from: "muted", to: (e, t) => ({ muted: t != null && t.isSpeakerOnly || (t == null ? void 0 : t.audio) === "" ? void 0 : e }) }, { from: "userType", to: (e, t) => {
  const r = Wa(e), n = { isPhoneUser: r };
  return r && t != null && t.phoneNumber && Object.assign(n, { phoneNumber: t.phoneNumber }), n;
} }];
function La(e) {
  return $M.reduce((t, r) => {
    const n = typeof r == "string" ? r : r.from, o = function(i, s, a) {
      if (typeof i == "string")
        return { [`${i}`]: s };
      if (typeof i == "object" && i.from !== void 0) {
        const { to: l } = i;
        return typeof l == "string" ? { [`${l}`]: s } : l(s, a);
      }
    }(r, e[n], e);
    return { ...t, ...o };
  }, {});
}
function d_() {
  const { isSupportAudioWorklet: e, isSupportEssentialAudioAndVideoAbility: t, isAndroidOrIOSBrowser: r, isSupportSendScreenSharing: n } = ve;
  return { audio: t && e || r, video: t && navigator.mediaDevices !== void 0 && navigator.mediaCapabilities !== void 0, screen: t && n };
}
const c_ = (e) => {
  let { breakoutRoom: { mainSessionAttendeeList: t } } = e;
  return t;
}, Ro = Mt([(e) => {
  let { breakoutRoom: { controlStatus: t } } = e;
  return t;
}, (e) => {
  let { breakoutRoom: { currentRoom: { status: t } } } = e;
  return t;
}, (e) => {
  let { breakoutRoom: { currentRoom: { boId: t } } } = e;
  return t;
}], (e, t, r) => !(e !== $e.InProgress && e !== $e.Closing || t !== Ee.InRoom && t !== Ee.TimeUp || !r)), yh = Mt([(e) => {
  let { breakoutRoom: { rooms: t } } = e;
  return t;
}, Vu, (e) => {
  let { meeting: { zoomId: t } } = e;
  return t;
}, c_, Ro, (e) => {
  let { breakoutRoom: { isHugeBO: t } } = e;
  return t;
}], (e, t, r, n, o, i) => {
  const s = e.reduce((a, l) => {
    const { attendeeGuidList: u } = l;
    return a.concat(u);
  }, []);
  return (o ? n : t).filter((a) => {
    return !(a.bHold || a.isHost || a.zoomID === r || a.bid || s.includes(a.userGUID) || i && (l = a.caps, (4 & l) != 4));
    var l;
  });
}), ea = Mt([Ro, c_, ft], (e, t, r) => e ? t.find((n) => n.isHost) : r.find((n) => n.isHost));
var yy, Sy, by, zt;
const Gi = We.createAgent();
let HM = (yy = mh(Ei.Other), Sy = mh(Ei.Other), by = mh(Ei.Other), zt = class extends Po {
  constructor(e) {
    super(e), this.modules = void 0, this.useSDK = void 0, this.useSDK = !1, this.modules = /* @__PURE__ */ new Map();
  }
  initWithSDK(e, t, r) {
    return this.useSDK = !0, this.init(e, t, r);
  }
  init(e, t, r) {
    const { audio: n, video: o } = d_();
    if (!n || !o)
      return console.error("https://developers.zoom.us/docs/video-sdk/web/browser-support"), Promise.reject({ type: W, reason: "Please update to the latest Chrome, Edge, Safari, or Firefox, as your current browser doesn't support audio/video. Retry after the upgrade." });
    const { [Nt]: i, [At]: s } = this;
    let a = us;
    const l = (r == null ? void 0 : r.fileWithVersion) || !1;
    let u = "en-US", d = `${us}/${ss}`;
    if (r) {
      const { dependentAssets: c, additionalFeatures: p, constraints: h, language: v, webEndpoint: f } = r;
      v && (u = v), f && function(m) {
        Su = tA(m, { hostname: !0 });
      }(f), c === Ip.CDN || c === Qd ? (a = Qd, d = `${Qd}/${ss}`) : c === Ip.Global || c === us ? (a = us, d = `${us}/${ss}`) : c === Ip.CN || c === Yd ? (a = Yd, d = `${Yd}/${ss}`) : c && /^https?:\/\//.test(c) && (a = rm(c), d = l ? `${a}/1505_js_media.min.js` : `${a}/${ss}`), p && Array.isArray(p) && p.forEach((m) => {
        if (this[O0][m] && s.getState()[m] === void 0) {
          const { epic: g, reducer: C, Client: b } = this[O0][m];
          s.injectReducer(m, C), s.injectEpic(g);
          const E = new b(s);
          this.modules.set(m, E);
        }
      }), h != null && h.audio && s.getState().audio === void 0 && (s.injectReducer("audio", bk), s.injectEpic(Ek)), h != null && h.video && s.getState().video === void 0 && (s.injectReducer("video", MM), s.injectEpic(NM)), h != null && h.screen && s.getState().share === void 0 && (s.injectReducer("share", UT), s.injectEpic(HT));
    }
    return i(Y4({ apiKey: e, signature: t, language: u, useSDK: this.useSDK })), i(Jv({ mediaConstraints: r && r.constraints || {}, assetsPath: a, fileWithVersion: l, enforceMultipleVideos: r == null ? void 0 : r.enforceMultipleVideos, enforceVirtualBackground: r == null ? void 0 : r.enforceVirtualBackground, skipJsMedia: r == null ? void 0 : r.skipJsMedia, patchJsMedia: r == null ? void 0 : r.patchJsMedia, alternativeNameForVideoPlayer: r == null ? void 0 : r.alternativeNameForVideoPlayer })), (r == null ? void 0 : r.stayAwake) !== void 0 && i(hC(r.stayAwake)), (r == null ? void 0 : r.quicklyLeaveMeeting) !== void 0 && i(mC(r.quicklyLeaveMeeting)), new Promise((c, p) => {
      r != null && r.skipJsMedia ? c("") : jm(d, () => {
        c("");
      }, () => {
        p({ type: De, reason: "dependent assets are not accessible" });
      });
    });
  }
  on(e, t) {
    ((r, n) => {
      const o = D2[r];
      if (o) {
        const i = es.get(r);
        if (i)
          i.push(n), es.set(r, i);
        else {
          const s = [n];
          es.set(r, s);
          const a = Kt(...o.map((l) => {
            const { event: u, payload: d } = l;
            return Ct(Xo, u).pipe(ae((c) => d(c)), Fr(Du));
          })).subscribe((l) => {
            const u = es.get(r);
            u && u.forEach((d) => {
              d(l);
            });
          });
          af.push(a);
        }
      }
    })(e, t);
  }
  off(e, t) {
    ((r, n) => {
      if (D2[r]) {
        const o = es.get(r);
        if (Array.isArray(o)) {
          const i = o.filter((s) => s !== n);
          es.set(r, i);
        }
      }
    })(e, t);
  }
  getFeatureModule(e) {
    return this.modules.get(e);
  }
  leave() {
    const { [ce]: e, [Nt]: t } = this;
    return e().socket.zoomSocketStatus === "connected" ? t(au()) : t(T1()), gr(nr(500).pipe(tn("")));
  }
  end() {
    const { [ce]: e, [Nt]: t } = this;
    return e().socket.zoomSocketStatus === "connected" ? (t(Ha()), gr(nr(500).pipe(he(() => {
      ym();
    }), tn("")))) : Promise.resolve("");
  }
  changeName(e, t) {
    const r = this[At].getState(), { meeting: { bAllowAttendeeRename: n } } = r, o = be(r), i = Jt(o.userRole), s = Sn(r);
    if (i)
      return Promise.reject({ type: Or });
    if (t && t !== (o == null ? void 0 : o.userId)) {
      if (s) {
        const { participants: { attendeesList: a } } = r, l = a.find((u) => u.userId === t);
        if (l)
          return Gi.rename(t, kt(e), kt(l.displayName)), td(t, (u) => u.displayName === e);
        {
          const u = ju(r).find((d) => d.userId === t);
          if (u) {
            const d = Us.getInstance();
            return Gi.rename(u.userId, kt(e), kt(u.displayName)), d.rename(u.jid, e), Te(yi, (c) => {
              const p = c.find((h) => h.jid === u.jid);
              return p && p.displayName === e;
            });
          }
          return Promise.reject({ type: De, reason: "no matching user" });
        }
      }
      return Promise.reject({ type: Or });
    }
    return e === o.displayName ? Promise.resolve() : s || n ? (Gi.rename(o.userId, kt(e), kt(o.displayName)), Te(Qr, (a) => a.displayName === e)) : Promise.reject({ type: Or, reason: "host disallow rename themselves" });
  }
  makeHost(e) {
    return Gi.assignHost(e, !1), td(e, (t) => t.isHost === !0);
  }
  makeCoHost(e) {
    const t = this[At].getState(), r = ft(t).find((n) => n.userId === e);
    return (r == null ? void 0 : r.bCoHost) === !0 ? Promise.reject({ type: De, reason: `user:[${e}] is already co-host ` }) : (Gi.assignHost(e, !0), td(e, (n) => n.bCoHost === !0));
  }
  revokeCoHost(e) {
    const t = this[At].getState(), r = ft(t).find((n) => n.userId === e);
    return (r == null ? void 0 : r.bCoHost) === !1 ? Promise.reject({ type: De, reason: `user:[${e}] is not a co-host` }) : (Gi.revokeCoHost(e), td(e, (n) => n.bCoHost === !1));
  }
  reclaimHost() {
    const e = this[ce](), { meeting: { isOriginHost: t } } = e, r = be(e);
    return r != null && r.isHost ? Promise.resolve("") : t ? (Gi.reclaimHost(r.userId, !1), Te(Qr, (n) => n.isHost === !0)) : Promise.reject({ type: Or, reason: "You are not the origin host" });
  }
  isHost() {
    const e = this[At].getState(), t = be(e);
    return !!t && t.isHost;
  }
  isCoHost() {
    const e = this[At].getState(), t = be(e);
    return !!t && !!t.bCoHost;
  }
  isOriginHost() {
    const { meeting: { isOriginHost: e } } = this[ce]();
    return e;
  }
  getCurrentUserInfo() {
    const e = this[At].getState(), t = be(e);
    if (t) {
      const r = La(t);
      if (e.meeting.isWebinar && Jt(t.userRole)) {
        const { audio: n } = e, o = n == null ? void 0 : n.isAllowToTalk;
        Object.assign(r, { isAllowToTalk: o });
      }
      if (e.breakoutRoom && Ro(e)) {
        const { breakoutRoom: { currentRoom: { boId: n } } } = e;
        Object.assign(r, { bid: n });
      }
      return r;
    }
    return null;
  }
  getParticipantsList() {
    const e = this[At].getState(), { meeting: { meetingStatus: t } } = e, r = be(e);
    if (t === xt.Joined && r && !r.bHold) {
      var n, o;
      const i = e.breakoutRoom && Ro(e) ? (n = e.breakoutRoom) === null || n === void 0 || (o = n.currentRoom) === null || o === void 0 ? void 0 : o.boId : "";
      return ft(e).map((s) => {
        const a = La(s);
        return i && Object.assign(a, { bid: i }), a;
      });
    }
    return [];
  }
  getAssistantsList() {
    const e = this[At].getState(), { meeting: { meetingStatus: t } } = e, r = be(e);
    return t === xt.Joined && r ? VO(e).map((n) => ({ userId: n.userId, displayName: n.displayName, isNewAst: !0 })) : [];
  }
  getMeetingHost() {
    var e;
    const t = this[ce]();
    let r = cf(t);
    return r || ((e = t.breakoutRoom) === null || e === void 0 ? void 0 : e.currentRoom.status) !== Ee.InRoom || (r = t.breakoutRoom.mainSessionAttendeeList.find((n) => n.isHost)), r !== void 0 ? La(r) : null;
  }
  getMeetingInfo() {
    const { meeting: { meetingStatus: e, isOnHold: t, meetingNumber: r, passWord: n, userName: o, userEmail: i, meetingTopic: s, meetingOptions: a, encType: l, region: u, network: d, topic: c, zlkJwtToken: p, userId: h, lang: v, inviteEmail: f, meetingId: m, participantID: g, h323Password: C, recordingDisclaimer: b, recordingDisclaimerForRecorder: E, wrInfo: w, meetingInfo: _, isNewJoinFlow: I } } = this[ce](), D = e === xt.Joined && !t;
    if (p)
      return { topic: c, password: n, userName: o, isInMeeting: D, userId: h, meetingId: m };
    {
      let B = "";
      return l === 0 ? B = "None" : l === 1 ? B = "AES ECB" : l === 2 && (B = "AES GCM"), { meetingNumber: r, password: n, userName: o, userEmail: i, inviteEmail: f, meetingTopic: s, encryptionType: B, region: u, network: d, isInMeeting: D, userId: h, lang: v, webEndpoint: Su, meetingId: m, participantId: g, telPwd: C, recordingInfo: { recordingDisclaimer: b, recordingDisclaimerForRecorder: E, isUserEnableRecordingReminder: a == null ? void 0 : a.isUserEnableRecordingReminder }, wrInfo: Object.assign({}, w, { isNew: I }), scheduleInfo: _ };
    }
  }
}, K(zt.prototype, "end", [Qt, Y], Object.getOwnPropertyDescriptor(zt.prototype, "end"), zt.prototype), K(zt.prototype, "changeName", [Y], Object.getOwnPropertyDescriptor(zt.prototype, "changeName"), zt.prototype), K(zt.prototype, "makeHost", [yy, Qt, Y], Object.getOwnPropertyDescriptor(zt.prototype, "makeHost"), zt.prototype), K(zt.prototype, "makeCoHost", [Sy, Qt, Y], Object.getOwnPropertyDescriptor(zt.prototype, "makeCoHost"), zt.prototype), K(zt.prototype, "revokeCoHost", [by, Qt, Y], Object.getOwnPropertyDescriptor(zt.prototype, "revokeCoHost"), zt.prototype), K(zt.prototype, "reclaimHost", [Y], Object.getOwnPropertyDescriptor(zt.prototype, "reclaimHost"), zt.prototype), zt);
const FM = We.createAgent(), zM = Us.getInstance(), Cy = (e, t, r) => {
  const n = t == null ? void 0 : t.userId;
  if (e == null || !e.zoomID || t == null || !t.displayName || n === e.userId)
    return { type: De, reason: "invalid target user" };
  const { chat: { chatPrivilege: o, panelistChatPrivilege: i }, meeting: { isWebinar: s } } = r, a = Sn(r), l = t.isHost || t.bCoHost;
  let u = !1;
  if (!a) {
    if (s)
      if (Jt(e.userRole))
        (o === bt.NoAttendee || o === bt.AllPanelist && n !== ut.Panelist || o === bt.All && n !== ut.All && n !== ut.Panelist) && (u = !0);
      else {
        const d = Jt(t == null ? void 0 : t.userRole);
        (i === Ms.Invalid || i === Ms.AllPanelist && (d || n === ut.All)) && (u = !0);
      }
    else
      (o === bt.NoAttendee || o === bt.Host && !l || n === ut.SilentModeUsers || o === bt.EveryonePublicly && n !== ut.All && !l) && (u = !0);
    if (u)
      return { type: Or, reason: "Insufficient chat privilege" };
  }
  return null;
};
function wy(e, t) {
  if (t === ut.All)
    return Dl;
  if (t === ut.Panelist)
    return fa;
  if (t === ut.SilentModeUsers)
    return iO;
  {
    const { meeting: { isWebinar: r }, participants: { xmppAttendeeList: n, attendeesList: o } } = e;
    return r ? o.find((i) => i.userId === t) || n.find((i) => i.userId === t) : o.find((i) => i.userId === t);
  }
}
function bl(e, t, r) {
  if (r != null && r.host)
    return [cf(e), ...V2(e)].filter((n) => (n == null ? void 0 : n.userId) !== t).map((n) => ({ userId: n == null ? void 0 : n.userId, displayName: n == null ? void 0 : n.displayName, isHost: n == null ? void 0 : n.isHost, isCoHost: n == null ? void 0 : n.bCoHost }));
  {
    let n = [cf(e), ...V2(e), ...e.participants.attendeesList.filter((o) => !(o.bCoHost || o.isHost || o.bHold))];
    if (r != null && r.includeAttendee) {
      const o = ju(e).filter((i) => !Wa(i.userType));
      n = [...n, ...o];
    }
    return n.filter((o) => o !== void 0 && o.userId !== t).map((o) => ({ userId: o == null ? void 0 : o.userId, displayName: o == null ? void 0 : o.displayName, isHost: o == null ? void 0 : o.isHost, isCoHost: o == null ? void 0 : o.bCoHost }));
  }
}
function vd(e) {
  const { text: t, destId: r, sn: n, attendeeId: o } = e;
  return ir.beginEncrypt({ text: t, type: mr.RWG_CHAT }).then((i) => {
    FM.chat(i, r, n, o);
  });
}
function ya(e, t) {
  const { chat: { chatHistory: r } } = t;
  return r.find((n) => {
    var o, i;
    return ((o = n.file) === null || o === void 0 || (i = o.upload) === null || i === void 0 ? void 0 : i.uniqueId) === e;
  });
}
function p_(e, t) {
  const { meeting: { isWebinar: r }, participants: { attendeesList: n } } = t, { destNodeID: o, senderName: i, attendeeNodeID: s } = e, a = n.find((p) => p.userId === o), l = e.sn ? e.sn : a == null ? void 0 : a.zoomID, u = i ? no(i) : a == null ? void 0 : a.displayName;
  let d, c = "";
  if (s === ut.SilentModeUsers)
    return { sender: { name: "Host", userId: o }, receiver: { name: "Everyone (in Waiting Room)", userId: s }, timestamp: (/* @__PURE__ */ new Date()).getTime() };
  if (s === ut.All)
    c = r ? "All panelists and attendees" : "Everyone";
  else if (s === ut.Panelist)
    c = "All panelists";
  else {
    if (r) {
      const p = ju(t).find((h) => h.userId === s);
      p && (c = p.displayName);
    }
    if (!c) {
      const p = n.find((h) => h.userId === s);
      p && (c = p.displayName, d = p.userGUID);
    }
  }
  return { sn: l, sender: { name: u, userId: o, userGuid: a == null ? void 0 : a.userGUID, avatar: a == null ? void 0 : a.avatar }, receiver: { name: c, userId: s, userGuid: d }, timestamp: (/* @__PURE__ */ new Date()).getTime() };
}
function WM(e) {
  var t;
  const [r] = e.split(".").reverse();
  return (t = aO[r]) !== null && t !== void 0 ? t : "";
}
function h_(e, t) {
  const r = [];
  for (let n = e.length - 1; n >= 0; n--) {
    const o = e[n];
    if (!o.file && (!o.id && o.sender.userId === t.userId && [ut.All, ut.Panelist, ut.IndividualCcPanelist, t.destNodeID].includes(o.receiver.userId) && r.unshift(o), o.id))
      break;
  }
  return r.length > 0 ? r[0] : null;
}
const f_ = Zr.getInstance(), v_ = f_.makeLogger(["File Transfer"]);
function m_(e, t, r) {
  const { name: n, size: o } = e, { meeting: { reportDomain: i, svcUrl: s, conId: a } } = r;
  return `https://${i}${t}?${new URLSearchParams({ filename: n, filesize: o, rwg: s, cid: a }).toString()}`;
}
function g_(e, t) {
  return t.fileObj ? `${e}/zoomfile/download?objkey=${t.fileObj}` : `${e}/file/${t.fileID}`;
}
function Xa(e, t) {
  return { fileName: e.name, fileSize: e.size, receiverId: t == null ? void 0 : t.userId, receiverGuid: t == null ? void 0 : t.userGuid };
}
function gi(e, t, r) {
  f_.report(`${e}. file name:${xr(t.name)},file size:${t.size}, ${"type" in t ? `file type:${t.type}` : ""}, error:${r.name};${r.message}`, ["File Transfer"]);
}
function Sh(e) {
  var t, r, n;
  return { id: e.id, fileName: (t = e.file) === null || t === void 0 ? void 0 : t.name, fileSize: (r = e.file) === null || r === void 0 ? void 0 : r.size, fileUrl: (n = e.file) === null || n === void 0 ? void 0 : n.fileUrl, senderId: e.sender.userId, senderGuid: e.sender.userGuid };
}
function y_(e, t, r) {
  return new Promise((n, o) => {
    const i = new FileReader();
    i.readAsArrayBuffer(e.slice(t, r)), i.onload = (s) => {
      var a;
      return n((a = s.target) === null || a === void 0 ? void 0 : a.result);
    }, i.onerror = (s) => o(s);
  });
}
async function S_(e, t) {
  let [r, n] = [e.size, 0];
  t != null && (r = Math.min(lr.ChunkSize, e.size - t), n = t);
  const o = e.size - n <= lr.ChunkSize, i = Math.ceil(r / lr.EncodeBlockSize);
  try {
    return function(s) {
      const a = s.reduce((d, c) => d + c.byteLength, 0), l = new Uint8Array(a);
      let u = 0;
      for (const d of s)
        l.set(new Uint8Array(d), u), u += d.byteLength;
      return l;
    }(await Promise.all(Array.from({ length: o ? Math.max(i - 1, 1) : i }, (s, a) => ({ start: a * lr.EncodeBlockSize + n, end: (o && a === i - 2 ? a + 2 : a + 1) * lr.EncodeBlockSize + n })).map(async (s) => {
      let { start: a, end: l } = s;
      try {
        const u = await y_(e, a, l);
        return u ? await ir.beginEncrypt({ text: new Uint8Array(u), type: mr.CHAT_FILE }) : Promise.reject(null);
      } catch (u) {
        return gi(`encrypt file buffer error. offset:${t},`, e, u), Promise.reject(u);
      }
    })));
  } catch (s) {
    console.warn(s);
  }
  return null;
}
function ic(e, t, r, n) {
  return n.pipe(ge(`${gu}`, `${ko}`), z((o) => {
    if (o.type === `${ko}`)
      return !0;
    const { payload: { uniqueId: i, fileName: s, userId: a } } = o;
    return t === i && e.name === s && r.userId === a;
  }), he((o) => {
    v_.info(`Cancel file upload. file name:${xr(e.name)},file size:${e.size},receiver id:${r.userId}`), O(Ps, { ...Xa(e, r), progress: 0, status: $t.Cancel, retryToken: o.type === `${gu}` ? t : void 0 });
  }));
}
function sc(e, t) {
  if (e != null && e.file) {
    const { file: r, receiver: n } = e, { upload: { chunkIndex: o, totalChunks: i, uniqueId: s } } = r;
    return O(Ps, { ...Xa(t, n), progress: Math.floor((o != null ? o : 0) / (i != null ? i : 1) * 100), status: $t.Fail, retryToken: s }), ne([tr({ upload: { status: $t.Fail, progress: 0, uniqueId: s } }), km({ uniqueId: s, file: t })]);
  }
  return oe;
}
function ac(e, t) {
  return O(Ps, { ...Xa(e), progress: 0, status: $t.Fail }), Je(tr({ upload: { status: $t.Fail, progress: 0, uniqueId: t } }));
}
async function Ey(e, t, r, n) {
  const o = m_(e, "/wc/fileupload", n.value), i = new FormData();
  try {
    const s = await S_(e), a = ya(t, n.value);
    if (s && a) {
      i.append("file", new File([s], e.name));
      const { meeting: { zmk: l } } = n.value, { receiver: u } = a;
      return Dn({ url: o, method: "POST", headers: { "Zoom-File-Origin": "redirect=support_auth", zmk: l }, crossDomain: eo(o), body: i, includeUploadProgress: !0 }).pipe(da(ic(e, t, u, r)), G((d) => {
        const { type: c, loaded: p, responseHeaders: h, total: v } = d;
        let f = 0, m = $t.InProgress;
        const g = { upload: { uniqueId: t } }, C = [];
        if (c === "upload_loadstart")
          f = 0;
        else if (c === "upload_progress")
          f = Math.floor(p / v * 100 * 0.9);
        else if (c === "upload_load")
          f = 90;
        else if (c === "download_load") {
          var b, E;
          f = 100, m = $t.Success;
          const { chat: { fileServerDomain: w } } = n.value, _ = (b = h["zoom-file-id"]) === null || b === void 0 ? void 0 : b.trim(), I = (E = h["zoom-file-obj"]) === null || E === void 0 ? void 0 : E.trim(), D = g_(w, { fileObj: I });
          Object.assign(g, { fileID: _, fileObj: I, fileUrl: D });
        }
        return Object.assign(g.upload, { progress: f, status: m }), (f > 0 || c === "upload_loadstart") && (O(Ps, { ...Xa(e, u), progress: f, status: m }), C.push(tr(g))), ne(C);
      }), Xn((d) => (console.warn(d), gi("Upload small file error.", e, d), sc(a, e))));
    }
  } catch (s) {
    console.warn(s);
  }
  return ac(e, t);
}
const ZM = (() => {
  const e = new eA();
  return (t) => async function() {
    await e.acquire(), t(...arguments), setTimeout(() => {
      e.release();
    }, 3e3);
  };
})(), GM = function(e) {
  const t = ["chatFileTransfer"];
  return new Proxy(e, { get: (r, n) => typeof n == "string" && t.includes(n) ? function() {
    return ZM(r[n].bind(r))(...arguments);
  } : Reflect.get(r, n) });
}(We.createAgent()), Iy = { chatHistory: [], chatPrivilege: bt.All, panelistChatPrivilege: Ms.AllPanelist, isAllowAttendeeChat: !0, isFileTransferEnable: !0, isEnableFileTransferEncrypted: !0, fileTransferFileType: [], fileDownloadPromptIgnoreList: [], fileTransferSizeLimit: 0, fileServerDomain: "", failedFileTransfer: {} }, qM = zr({ [`${mu}`]: M((e, t) => {
  let { payload: r } = t;
  e.chatHistory.push(r);
}), [`${Om}`]: M((e, t) => {
  let { payload: r } = t;
  e.chatPrivilege = r;
}), [`${dI}`]: M((e, t) => {
  let { payload: r } = t;
  e.panelistChatPrivilege = r;
}), [`${pI}`]: M((e, t) => {
  let { payload: r } = t;
  e.isAllowAttendeeChat = r;
}), [`${hI}`]: M((e, t) => {
  let { payload: r } = t;
  const { destNodeID: n, msgID: o, userId: i } = r, s = h_(e.chatHistory, { userId: i, destNodeID: n });
  s && Object.assign(s, { id: o });
}), [`${Kd}`]: M((e, t) => {
  let { payload: r } = t;
  const { msgId: n } = r, o = e.chatHistory.findIndex((i) => i.id === n);
  o >= 0 && e.chatHistory.splice(o, 1);
}), [`${fI}`]: M((e, t) => {
  let { payload: r } = t;
  Object.assign(e, r);
}), [`${Tm}`]: M((e, t) => {
  let { payload: r } = t;
  const { originFile: n, ...o } = r;
  e.chatHistory.push(o);
}), [`${tr}`]: M((e, t) => {
  let { payload: r } = t;
  const { upload: n, download: o, originFile: i, ...s } = r;
  if (n) {
    var a;
    const { uniqueId: l, ...u } = n, d = e.chatHistory.find((c) => {
      var p;
      return c.file && ((p = c.file.upload) === null || p === void 0 ? void 0 : p.uniqueId) === l;
    });
    d != null && (a = d.file) !== null && a !== void 0 && a.upload && (Object.assign(d.file.upload, { ...u }), Object.assign(d.file, { ...s }), d.file.upload.status === $t.Success && e.failedFileTransfer[d.file.upload.uniqueId] && delete e.failedFileTransfer[d.file.upload.uniqueId]);
  } else if (o) {
    const { id: l, fileUrl: u } = s, d = e.chatHistory.find((c) => {
      var p;
      return c.id === l && ((p = c.file) === null || p === void 0 ? void 0 : p.fileUrl) === u;
    });
    d != null && d.file && (d.file.download ? Object.assign(d.file.download, { ...o }) : Object.assign(d.file, { download: o }));
  }
}), [`${gu}`]: M((e, t) => {
  let { payload: r } = t;
  const { uniqueId: n, fileName: o, userId: i } = r, s = e.chatHistory.find((l) => l.file && l.file.name == o && l.file.upload.uniqueId === n && l.file.upload.status === $t.InProgress && l.receiver.userId === i);
  var a;
  s != null && s.file && Object.assign((a = s.file) === null || a === void 0 ? void 0 : a.upload, { status: $t.Cancel, progress: 0 });
}), [`${km}`]: M((e, t) => {
  let { payload: r } = t;
  const { uniqueId: n, file: o } = r;
  e.failedFileTransfer[`${n}`] || Object.assign(e.failedFileTransfer, { [`${n}`]: o });
}), [`${vI}`]: M((e, t) => {
  let { payload: r } = t;
  const { fileID: n, msgID: o, senderId: i } = r, s = e.chatHistory.find((a) => {
    var l;
    return ((l = a.file) === null || l === void 0 ? void 0 : l.fileID) === n && a.sender.userId === i;
  });
  s && Object.assign(s, { id: o });
}), [`${Mm}`]: M((e, t) => {
  let { payload: r } = t;
  const { id: n, fileUrl: o } = r, i = e.chatHistory.find((a) => {
    var l, u;
    return a.id === n && ((l = a.file) === null || l === void 0 ? void 0 : l.fileUrl) === o && ((u = a.file) === null || u === void 0 ? void 0 : u.download.status) === Fo.InProgress;
  });
  var s;
  i != null && i.file && Object.assign((s = i.file) === null || s === void 0 ? void 0 : s.download, { status: Fo.Cancel, progress: 0 });
}), [`${cI}`]: () => ({ ...Iy }) }, Iy);
var Pt;
const Cl = We.createAgent();
let KM = (Pt = class extends Po {
  send(e, t) {
    if (!e)
      return Promise.reject({ type: De, reason: "Text is empty" });
    const { [ce]: r, [Nt]: n } = this, o = r(), i = be(o), s = wy(o, t), a = Cy(i, s, o);
    if (a)
      return Promise.reject(a);
    const { meeting: { isWebinar: l, encType: u } } = o, d = u === Nu.AES_GCM;
    let c = Promise.resolve(), p = !1;
    const h = l && Jt(s.userRole);
    return t === ut.SilentModeUsers ? Cl.chat(kt(e), t) : l ? h ? (8 & s.clientCap) == 8 ? c = vd({ text: e, destId: ut.IndividualCcPanelist, sn: i == null ? void 0 : i.zoomID, attendeeId: t }) : (c = vd({ text: e, destId: ut.Panelist, sn: i == null ? void 0 : i.zoomID, attendeeId: t }).then(() => function(v) {
      const { text: f, jid: m, isGCMEnabled: g } = v;
      return ir.beginEncrypt({ text: f, type: mr.XMPP_CHAT }).then((C) => {
        zM.sendWebinarMseeage(C, m, ut.IndividualCcPanelist, g);
      });
    }({ text: e, jid: s.jid, isGCMEnabled: d })), p = !0) : s && (c = vd({ text: e, destId: s.userId, sn: i == null ? void 0 : i.zoomID })) : c = vd({ text: e, destId: s.userId, sn: i == null ? void 0 : i.zoomID }), c.then(() => {
      const v = function(f, m, g, C) {
        const b = (/* @__PURE__ */ new Date()).getTime(), E = performance.now();
        return { message: f, sender: { name: m.displayName, userId: m.userId, userGuid: m.userGUID, avatar: m.avatar }, receiver: { name: g == null ? void 0 : g.displayName, userId: C ? ut.IndividualCcPanelist : g == null ? void 0 : g.userId, userGuid: g == null ? void 0 : g.userGUID }, timestamp: b, highResTimeStampForIdentification: E };
      }(e, i, s, h);
      return n(mu(v)), p ? (O(Cs, v), v) : new Promise((f, m) => {
        ht(kC).pipe(u4(5e3), p4((g) => v.highResTimeStampForIdentification !== g.identification || !([g.receiverId, ut.All, ut.Panelist].includes(t) || g.receiverId === ut.IndividualCcPanelist)), Ge(1)).subscribe((g) => {
          const { msgId: C } = g, { highResTimeStampForIdentification: b, ...E } = v, w = { id: C, ...E, ...h && { receiver: { name: s == null ? void 0 : s.displayName, userId: s == null ? void 0 : s.userId } } };
          O(Cs, w), f(w);
        }, () => {
          m({ type: mm });
        });
      });
    });
  }
  setPrivilege(e) {
    const t = this[ce](), { meeting: { isWebinar: r }, chat: { chatPrivilege: n }, breakoutRoom: o } = t;
    return n === e ? Promise.resolve("") : (o == null ? void 0 : o.controlStatus) === $e.InProgress && Ro(t) ? Promise.reject({ type: W, reason: "Cannot update chat privilege in a subsession" }) : !r && !rO.includes(e) || r && !nO.includes(e) ? Promise.reject({ type: De, reason: "invalid privilege value of parameter" }) : (Cl.setChatPriviledge(e), Te(Aa, (i) => i.chatPrivilege === e));
  }
  setPanelistPrivilege(e) {
    const t = this[ce](), { chat: { panelistChatPrivilege: r } } = t, n = oO[e];
    return r === n ? Promise.resolve("") : Object.values(_c).includes(e) ? (Cl.setPanelistChatPrivilege(e), Te(Aa, (o) => o.panelistChatPrivilege === n)) : Promise.reject({ type: De, reason: "Panelist privilege value is invalid" });
  }
  deleteMessage(e) {
    const t = this[ce](), { chat: { chatHistory: r }, meeting: { meetingOptions: n, userId: o } } = t;
    if (n != null && n.isEnableDeleteChatMsg) {
      const i = Sn(t), s = r.find((a) => a.id === e);
      if (s) {
        const { sender: a } = s;
        if (i)
          Cl.chatCmdReq(e, Ac.Delete);
        else {
          if (a.userId !== o)
            return Promise.reject({ type: Or, reason: "can not delete message" });
          Cl.chatCmdReq(e, Ac.Delete);
        }
        return Te(Oc, (l) => l.id === e).then(() => ({ id: e }));
      }
      return Promise.reject({ type: De, reason: "msgId is wrong" });
    }
    return Promise.reject({ type: W, reason: "can not delete messages" });
  }
  lockChat(e) {
    const t = this[ce](), { meeting: { meetingOptions: r } } = t, n = r != null && r.isPrivateChatEnabled ? bt.All : bt.EveryonePublicly;
    return this.setPrivilege(e ? bt.NoOne : n);
  }
  sendFile(e, t) {
    if (!e)
      return Promise.reject({ type: De, reason: "File is empty" });
    const { [ce]: r, [Nt]: n } = this, o = r(), { chat: { isFileTransferEnable: i, fileTransferFileType: s, fileTransferSizeLimit: a, failedFileTransfer: l } } = o;
    if (!i)
      return Promise.reject({ type: W, reason: "Send files via in-session chat is not enabled" });
    if (typeof e == "string") {
      const u = ya(e, o);
      if (u != null && u.file && l[e]) {
        const { file: { upload: d, ...c } } = u, { file: { name: p, upload: { uniqueId: h } }, receiver: { userId: v } } = u;
        return n(tr({ originFile: l[e], ...c, upload: { ...d, status: $t.InProgress } })), Promise.resolve(() => {
          n(gu({ uniqueId: h, fileName: p, userId: v }));
        });
      }
      return Promise.reject({ type: De, reason: "Retry token is not correct." });
    }
    {
      const { name: u } = e;
      if (s.length > 0) {
        const [v] = u.split(".").reverse();
        if (!s.some((f) => f === v))
          return Promise.reject({ type: W, reason: "File is not in the allow list" });
      }
      if (e.size > a)
        return Promise.reject({ type: W, reason: "File size exceeds the maximum limit." });
      const d = be(o), c = wy(o, t), p = Cy(d, c, o);
      if (p)
        return Promise.reject(p);
      const h = bc();
      return n(Tm(function(v, f, m, g, C) {
        const b = (/* @__PURE__ */ new Date()).getTime();
        return { file: { name: v.name, size: v.size, type: v.type, upload: { progress: 0, uniqueId: f, totalChunks: 0, chunkIndex: 0 } }, originFile: v, sender: { name: m.displayName, userId: m.userId, userGuid: m.userGUID, avatar: m.avatar }, receiver: { name: g == null ? void 0 : g.displayName, userId: g == null ? void 0 : g.userId, attendeeId: void 0, userGuid: g == null ? void 0 : g.userGUID }, timestamp: b };
      }(e, h, d, c))), Promise.resolve(() => {
        n(km({ uniqueId: h, file: e })), n(gu({ uniqueId: h, fileName: u, userId: c == null ? void 0 : c.userId }));
      });
    }
  }
  downloadFile(e, t, r) {
    const { [ce]: n, [Nt]: o } = this, { chat: { chatHistory: i } } = n();
    return !e || !t ? Promise.reject({ type: De, reason: "Invalid message id or file url!" }) : i.find((a) => {
      var l;
      return a.id === e && ((l = a.file) === null || l === void 0 ? void 0 : l.fileUrl) === t;
    }) ? (o(tr({ id: e, fileUrl: t, download: { status: Fo.InProgress, progress: 0, blob: r } })), Promise.resolve(() => o(Mm({ id: e, fileUrl: t })))) : Promise.reject({ type: De, reason: "Invalid message id or file url!" });
  }
  getPrivilege() {
    const { chat: { chatPrivilege: e, isAllowAttendeeChat: t } } = this[ce]();
    return t ? e : bt.NoAttendee;
  }
  getReceivers() {
    const e = this[ce](), { chat: { chatPrivilege: t, panelistChatPrivilege: r, isAllowAttendeeChat: n }, meeting: { isWebinar: o } } = e;
    if (!o && !n)
      return [];
    const i = be(e), s = Sn(e);
    if (i)
      if (o)
        if (Jt(i.userRole)) {
          if (!n)
            return [];
          if (t === bt.All)
            return [fa, Dl];
          if (t === bt.AllPanelist)
            return [fa];
          if (t === bt.NoOne)
            return [];
        } else {
          if (s || r === Ms.Everyone) {
            const a = bl(e, i.userId, { includeAttendee: !0 });
            return [fa, Dl, ...a];
          }
          if (r === Ms.AllPanelist) {
            const a = bl(e, i.userId);
            return [fa, ...a];
          }
        }
      else {
        const a = Sn(e);
        if (t === bt.All || a) {
          const l = bl(e, i.userId);
          return [Dl, ...l];
        }
        if (t === bt.Host)
          return bl(e, i.userId, { host: !0 });
        if (t === bt.EveryonePublicly) {
          const l = bl(e, i.userId, { host: !0 });
          return [Dl, ...l];
        }
        if (t === bt.NoOne)
          return [];
      }
    return [];
  }
  getHistory() {
    return this[ce]().chat.chatHistory.map((e) => {
      const { highResTimeStampForIdentification: t, ...r } = e;
      if (r.file) {
        const { name: n, size: o, type: i, fileUrl: s, upload: a, download: l } = r.file, u = { name: n, size: o, type: i, fileUrl: s };
        return a && Object.assign(u, { upload: { status: a.status, progress: a.progress } }), l && Object.assign(u, { download: { status: l.status, progress: l.progress } }), { ...r, file: u };
      }
      return r;
    });
  }
  isAllowToDeleteMessages() {
    const e = this[ce](), { meeting: { meetingOptions: t } } = e;
    return t == null ? void 0 : t.isEnableDeleteChatMsg;
  }
  isFileTransferEnabled() {
    return this[ce]().chat.isFileTransferEnable;
  }
  getFileTransferSetting() {
    const e = this[ce](), { chat: { fileTransferFileType: t, fileTransferSizeLimit: r } } = e;
    return { typeLimit: (t != null ? t : []).map((n) => `.${n}`).join(","), sizeLimit: r };
  }
}, K(Pt.prototype, "send", [Y], Object.getOwnPropertyDescriptor(Pt.prototype, "send"), Pt.prototype), K(Pt.prototype, "setPrivilege", [rr, Y], Object.getOwnPropertyDescriptor(Pt.prototype, "setPrivilege"), Pt.prototype), K(Pt.prototype, "setPanelistPrivilege", [rr, Y, function(e, t, r) {
  const n = r.value;
  r.value = function() {
    const o = this[At];
    if (o) {
      const { meeting: { isWebinar: l } } = o.getState();
      if (!l)
        return Promise.reject({ type: _a, reason: "non-webinar" });
    }
    for (var i = arguments.length, s = new Array(i), a = 0; a < i; a++)
      s[a] = arguments[a];
    return n.apply(this, s);
  };
}], Object.getOwnPropertyDescriptor(Pt.prototype, "setPanelistPrivilege"), Pt.prototype), K(Pt.prototype, "deleteMessage", [Y], Object.getOwnPropertyDescriptor(Pt.prototype, "deleteMessage"), Pt.prototype), K(Pt.prototype, "lockChat", [rr, Y], Object.getOwnPropertyDescriptor(Pt.prototype, "lockChat"), Pt.prototype), K(Pt.prototype, "sendFile", [Y], Object.getOwnPropertyDescriptor(Pt.prototype, "sendFile"), Pt.prototype), K(Pt.prototype, "downloadFile", [Y], Object.getOwnPropertyDescriptor(Pt.prototype, "downloadFile"), Pt.prototype), Pt);
const JM = { epics0: (e, t) => wa(e, 24583).pipe(pe(t), G((r) => {
  let [n, o] = r;
  if (o.meeting.zlkJwtToken)
    return oe;
  const { payload: { body: { sn: i, senderName: s, senderJid: a, receiver: l, text: u, type: d } } } = n, c = be(o), p = ju(o), { meeting: { jid: h, userId: v }, participants: { xmppAttendeeList: f } } = o;
  return ir.beginDecrypt({ decryptedText: u, type: mr.XMPP_CHAT, zoomId: i }).then((m) => {
    var g;
    let { message: C } = m, b = null, E = 0, w = "";
    c && Jt(c.userRole) && h === l ? (b = f.find((I) => I.jid === a), E = v, w = c.displayName) : d === ut.Panelist && (b = p.find((I) => I.jid === a), E = ut.Panelist, w = fa.displayName);
    const _ = { message: C, sender: { name: s, userId: ((g = b) === null || g === void 0 ? void 0 : g.userId) || 0, avatar: "" }, receiver: { name: w, userId: E }, timestamp: (/* @__PURE__ */ new Date()).getTime() };
    return O(Cs, _), mu(_);
  });
})), epics1: (e, t) => se(e, 7944).pipe(pe(t), G((r) => {
  let [n, o] = r;
  const { meeting: { bIbDisableChat: i } } = o, { payload: { body: { attendeeNodeID: s, sn: a, destNodeID: l, text: u, senderName: d, msgID: c } } } = n, p = be(o);
  if (p) {
    const h = Jt(p == null ? void 0 : p.userRole) && s === p.userId && !c;
    if (!i && !h) {
      const { sn: v, ...f } = p_({ destNodeID: l, attendeeNodeID: s, senderName: d, sn: a }, o);
      return (s === ut.SilentModeUsers ? Promise.resolve({ id: c, message: no(u), ...f }) : ir.beginDecrypt({ decryptedText: u, zoomId: v, type: mr.RWG_CHAT }).then((m) => {
        let { message: g } = m;
        return { id: c, message: g, ...f };
      })).then((m) => (O(Cs, m), mu(m)));
    }
  }
  return oe;
})), epics2: (e, t) => se(e, En).pipe(z((r) => {
  var n, o;
  return ((n = r.payload.body) === null || n === void 0 ? void 0 : n.chatPriviledge) !== void 0 || ((o = r.payload.body) === null || o === void 0 ? void 0 : o.bAllowAttendeeChat) !== void 0;
}), pe(t), ae((r) => {
  let [n, o] = r;
  const { payload: { body: { chatPriviledge: i, bAllowAttendeeChat: s } } } = n, { chat: { chatPrivilege: a } } = o;
  return s !== void 0 ? (O(Aa, s === !0 ? { chatPrivilege: a } : { chatPrivilege: bt.NoAttendee }), pI(s)) : (O(Aa, { chatPrivilege: i }), Om(i));
})), epics3: (e) => se(e, En).pipe(z((t) => {
  var r;
  return ((r = t.payload.body) === null || r === void 0 ? void 0 : r.panelistChatPriviledge) !== void 0;
}), ae((t) => {
  const { payload: { body: { panelistChatPriviledge: r } } } = t;
  return O(Aa, { panelistChatPrivilege: r }), dI(r);
})), epics4: (e, t) => se(e, 4136).pipe(pe(t), G((r) => {
  let [n, o] = r;
  const { payload: { body: { result: i, destNodeID: s, msgID: a, fileID: l } } } = n, { meeting: { userId: u }, chat: { chatHistory: d } } = o, c = [];
  if (i === _p.Success)
    if (l) {
      const h = d.find((v) => {
        var f;
        return ((f = v.file) === null || f === void 0 ? void 0 : f.fileID) === l;
      });
      if (h) {
        const { file: v, receiver: f, ...m } = h, { name: g, size: C, type: b, fileUrl: E } = v != null ? v : {}, { attendeeId: w, ..._ } = f;
        O(Cs, { id: a, file: { name: g, size: C, type: b, fileUrl: E, upload: { status: $t.Complete, progress: 100 } }, receiver: { ..._ }, ...m }), c.push(vI({ fileID: l, msgID: a, senderId: u }));
      }
    } else {
      const h = h_(d, { userId: u, destNodeID: s });
      var p;
      h && (O(kC, { msgId: a, receiverId: s, identification: (p = h.highResTimeStampForIdentification) !== null && p !== void 0 ? p : 0 }), c.push(hI({ destNodeID: s, msgID: a, userId: u })));
    }
  else
    i !== _p.Delete && i !== _p.Block || c.push(Kd({ msgId: a }));
  return ne(c);
})), epics5: (e) => se(e, 4238).pipe(G((t) => {
  const { payload: { body: { bSuccess: r, cmd: n, msgID: o } } } = t, i = [];
  return r && n === Ac.Delete && (i.push(Kd({ msgId: o })), O(Oc, { id: o })), ne(i);
})), epics6: (e) => se(e, 7960).pipe(G((t) => {
  const { payload: { body: { cmd: r, msgID: n } } } = t, o = [];
  return r === Ac.Delete && (o.push(Kd({ msgId: n })), O(Oc, { id: n })), ne(o);
})) }, QM = Wr(JM, { chatFileEpics0: (e) => e.pipe(ge(`${Un}`), ae((t) => {
  var r, n, o;
  const { payload: { fileTransfer: i, fileServerDomain: s } } = t;
  return fI({ isFileTransferEnable: i == null ? void 0 : i.isEnable, isEnableFileTransferEncrypted: i == null ? void 0 : i.isEnableFileTransferEncrypted, fileTransferFileType: ((r = i == null ? void 0 : i.fileType) !== null && r !== void 0 ? r : "").replace(/\./g, "").split(",").filter(Boolean), fileTransferSizeLimit: 1024 * ((n = i == null ? void 0 : i.sizeLimit) !== null && n !== void 0 ? n : 0) * 1024 || lr.MaxSize, fileDownloadPromptIgnoreList: ((o = i == null ? void 0 : i.fileDownloadPromptIgnoreList) !== null && o !== void 0 ? o : "").replace(/\./g, "").split(","), fileServerDomain: `https://${s}` });
})), chatFileEpics1: (e, t) => e.pipe(ge(`${Tm}`), G(async (r) => {
  const { payload: { originFile: n, file: { upload: { uniqueId: o } } } } = r;
  return n.size > lr.ChunkSize ? await async function(i, s, a, l) {
    const u = m_(i, "/wc/multiupload/init", l.value), d = await async function(v) {
      const f = Math.ceil(v.size / lr.ReaderChunkSize);
      return (await Promise.all(Array.from({ length: f }, (m, g) => ({ start: g * lr.ReaderChunkSize, end: (g + 1) * lr.ReaderChunkSize })).map(async (m) => {
        let { start: g, end: C } = m;
        try {
          const b = await y_(v, g, C);
          return J4(await window.crypto.subtle.digest("SHA-256", b));
        } catch (b) {
          return gi("calculate file hash error.", v, b), Promise.reject(b);
        }
      }))).join("");
    }(i), { meeting: { zmk: c, meetingId: p } } = l.value, h = ya(s, l.value);
    if (d && h) {
      const { receiver: v } = h, f = { fileName: i.name, length: i.size, channelType: 4, digest: d, shareJid: p };
      return Dn({ url: u, method: "POST", headers: { "Zoom-File-Origin": "redirect=support_auth", zmk: c }, crossDomain: eo(u), body: f }).pipe(da(ic(i, s, v, a)), ae((m) => {
        var g;
        const { responseHeaders: C, response: b } = m, E = (g = C["x-zm-trackingid"]) === null || g === void 0 ? void 0 : g.trim(), { uploadid: w, path: _, metadata: I } = b, D = Math.ceil(i.size / lr.ChunkSize);
        return tr({ originFile: i, upload: { uniqueId: s, status: $t.InProgress, progress: 0, chunkIndex: 0, totalChunks: D, uploadid: w, trackingId: E, path: _, metadata: I } });
      }), Xn((m) => (console.warn(m), gi("Upload file meta error.", i, m), sc(h, i))), jn(tr({ upload: { uniqueId: s, status: $t.Init } })));
    }
    return ac(i, s);
  }(n, o, e, t) : await Ey(n, o, e, t);
}), G((r) => r)), chatFileEpics2: (e, t) => e.pipe(ge(`${tr}`), z((r) => {
  var n;
  return ((n = r.payload.upload) === null || n === void 0 ? void 0 : n.status) === $t.Success;
}), Di(async (r) => {
  const { payload: { upload: { uniqueId: n } } } = r, { chat: { isEnableFileTransferEncrypted: o, chatHistory: i } } = t.value, s = i.find((l) => {
    var u, d;
    return ((u = l.file) === null || u === void 0 || (d = u.upload) === null || d === void 0 ? void 0 : d.uniqueId) === n;
  }), a = [];
  if (s && s.file) {
    const { file: { name: l, size: u, fileObj: d, fileID: c, type: p }, receiver: { userId: h, attendeeId: v } } = s;
    let [f, m] = ["", ""];
    if (o) {
      const [g, C] = await Promise.all([l, `${u}`].map((b) => ir.beginEncrypt({ text: b, type: mr.RWG_CHAT })));
      [f, m] = [g, C];
    } else
      [f, m] = [l, `${u}`].map((g) => kt(g));
    await GM.chatFileTransfer({ fileID: c, fileSize: m, fileName: f, fileObj: d, type: p, destNodeID: h, attendeeNodeID: v }), a.push(tr({ upload: { uniqueId: n, status: $t.Complete } }));
  }
  return a;
})), chatFileEpics3: (e, t) => e.pipe(ge(`${tr}`), z((r) => {
  const { payload: { upload: n, originFile: o } } = r;
  return !!n && !!n.uniqueId && n.status === $t.InProgress && (o == null ? void 0 : o.size) <= lr.ChunkSize && n.totalChunks === 0;
}), G(async (r) => {
  const { payload: { originFile: n, upload: { uniqueId: o } } } = r;
  return await Ey(n, o, e, t);
}), G((r) => r)), chatFileEpics4: (e, t) => e.pipe(ge(`${tr}`), z((r) => {
  const { payload: { upload: n } } = r;
  return !!n && !!n.uniqueId && n.totalChunks > 0 && n.chunkIndex !== n.totalChunks;
}), G(async (r) => {
  const { payload: { originFile: n, upload: { uniqueId: o } } } = r;
  return await async function(i, s, a, l) {
    const u = ya(s, l.value);
    if (u != null && u.file) {
      const { file: { upload: { chunkIndex: d, totalChunks: c, uploadid: p, path: h, trackingId: v, etags: f }, size: m }, receiver: g } = u, C = d * lr.ChunkSize, b = await S_(i, C);
      if (b) {
        const { chat: { fileServerDomain: E }, meeting: { zmk: w } } = l.value, _ = `${E}/upload/parts?${new URLSearchParams({ uploadid: p, partNumber: d + 1 }).toString()}`, I = new FormData(), D = new File([b], i.name);
        return I.append("file", D), Dn({ url: _, method: "POST", headers: { "Zoom-File-Size": D.size, "Zoom-File-Path": h, "x-zm-trackingid": v, "Zoom-File-Origin": "redirect=support_auth", zmk: w }, crossDomain: eo(_), body: I, includeUploadProgress: !0 }).pipe(da(ic(i, s, g, a)), G((B) => {
          var L;
          const { type: R, loaded: y, total: A, responseHeaders: k } = B;
          let T = 0;
          const N = { upload: { uniqueId: s, status: $t.InProgress } }, F = [], $ = ya(s, l.value), re = $ == null || (L = $.file) === null || L === void 0 ? void 0 : L.upload.progress;
          if (R === "upload_loadstart")
            T = re || Math.floor(d / c * 100);
          else if (R === "upload_progress")
            T = Math.floor((d * lr.ChunkSize + 0.9 * y) / m * 100);
          else if (R === "upload_load")
            T = Math.floor((d * lr.ChunkSize + 0.9 * A) / m * 100);
          else if (R === "download_load") {
            T = re || Math.floor((d + 1) / c * 100);
            const fe = k["x-zm-etag"].trim(), le = f ? { ...f, [`${d + 1}`]: fe } : { [`${d + 1}`]: fe };
            Object.assign(N.upload, { etags: le, chunkIndex: d + 1, totalChunks: c }), Object.assign(N, { originFile: i });
          }
          return (T > 0 || R === "upload_loadstart") && (Object.assign(N.upload, { progress: T }), O(Ps, { ...Xa(i, g), progress: T, status: $t.InProgress }), F.push(tr(N))), ne(F);
        }), Xn((B) => (console.warn(B), gi(`Upload file chunk error. chunk:${d},total chunks:${c},uploadid:${p},trackingId:${v}`, i, B), sc(u, i))));
      }
    }
    return ac(i, s);
  }(n, o, e, t);
}), G((r) => r)), chatFileEpics5: (e, t) => e.pipe(ge(`${tr}`), z((r) => {
  const { payload: { upload: n } } = r;
  return !!n && !!n.uniqueId && n.totalChunks > 0 && n.chunkIndex == n.totalChunks;
}), G((r) => {
  const { payload: { originFile: n, upload: { uniqueId: o } } } = r;
  return function(i, s, a, l) {
    const { chat: { fileServerDomain: u }, meeting: { zmk: d } } = l.value, c = ya(s, l.value);
    if (c != null && c.file) {
      const { file: { upload: { uploadid: p, metadata: h, etags: v, trackingId: f } }, receiver: m } = c, g = `${u}/upload/complete?uploadid=${p}`;
      return Dn({ url: g, method: "POST", headers: { "x-zm-trackingid": f, "Zoom-File-Origin": "redirect=support_auth", zmk: d }, crossDomain: eo(g), body: { metadata: h, etags: v } }).pipe(da(ic(i, s, m, a)), ae((C) => {
        var b, E;
        const { chat: { fileServerDomain: w } } = l.value, { responseHeaders: _ } = C, I = (b = _["zoom-file-id"]) === null || b === void 0 ? void 0 : b.trim(), D = (E = _["zoom-file-obj"]) === null || E === void 0 ? void 0 : E.trim(), B = `${w}/zoomfile/download?objkey=${D}`;
        return O(Ps, { ...Xa(i, m), progress: 100, status: $t.Success }), tr({ fileID: I, fileObj: D, fileUrl: B, upload: { uniqueId: s, progress: 100, status: $t.Success } });
      }), Xn((C) => (console.warn(C), gi(`Upload chunks checksum error.uploadid${p},trackingId${f}`, i, C), sc(c, i))));
    }
    return ac(i, s);
  }(n, o, e, t);
})), chatFileEpics6: (e, t) => se(e, 4308).pipe(Di(async (r) => {
  const { payload: { body: { attendeeNodeID: n, destNodeID: o, fileID: i, fileName: s, fileObj: a, fileSize: l, fileType: u, msgID: d, senderName: c } } } = r, { meeting: { bIbDisableChat: p }, chat: { fileServerDomain: h, isEnableFileTransferEncrypted: v } } = t.value, f = [];
  if (!p) {
    const m = g_(h, { fileObj: a, fileID: i });
    if (u === sO.Local) {
      const { sn: g, ...C } = p_({ destNodeID: o, attendeeNodeID: n, senderName: c }, t.value);
      let [b, E] = ["", 0];
      if (v) {
        const [_, I] = await Promise.all([s, l].map((D) => ir.beginDecrypt({ decryptedText: D, zoomId: g, type: mr.RWG_CHAT })));
        b = _.message, E = Number(I.message);
      } else
        b = no(s), E = Number(no(l));
      const w = { id: d, file: { name: b, size: E, fileUrl: m }, ...C };
      f.push(mu({ ...w, file: { ...w.file, fileID: i, fileObj: a } })), setTimeout(() => {
        O(Cs, w);
      }, 0);
    }
  }
  return f;
})), chatFileEpics7: (e, t) => e.pipe(ge(`${tr}`), z((r) => {
  var n, o;
  const { payload: i } = r;
  return i.id && i.fileUrl && ((n = i.download) === null || n === void 0 ? void 0 : n.status) === Fo.InProgress && ((o = i.download) === null || o === void 0 ? void 0 : o.progress) === 0;
}), G((r) => function(n, o, i) {
  var s;
  const { chat: { chatHistory: a }, meeting: { zmk: l }, participants: { attendeesList: u } } = i.value, d = a.find((c) => c.id === n);
  if (d != null && (s = d.file) !== null && s !== void 0 && s.fileUrl) {
    const { file: { fileUrl: c } } = d;
    return Dn({ url: c, method: "GET", headers: { "Zoom-File-Origin": "redirect=support_auth", zmk: l }, crossDomain: eo(c), responseType: "arraybuffer", includeDownloadProgress: !0 }).pipe(da(function(p, h) {
      return h.pipe(ge(`${Mm}`, `${ko}`), z((v) => {
        if (v.type === `${ko}`)
          return !0;
        const { payload: { id: f } } = v;
        return p.id === f;
      }), he(() => {
        var v, f, m;
        v_.info(`Cancel file download. file name:${xr((v = p.file) === null || v === void 0 ? void 0 : v.name)},file size:${(f = p.file) === null || f === void 0 ? void 0 : f.size},sender id:${(m = p.sender) === null || m === void 0 ? void 0 : m.userId}`), O(Nd, { ...Sh(p), progress: 0, status: Fo.Cancel });
      }));
    }(d, o)), Di(async (p) => {
      const { type: h, loaded: v, total: f } = p, m = [], g = { ...Sh(d), progress: 0, status: Fo.InProgress };
      if (h === "download_loadstart" && Object.assign(g, { progress: 0 }), h === "download_progress") {
        var C;
        const D = Math.floor(v / f * 100);
        m.push(tr({ id: n, fileUrl: (C = d.file) === null || C === void 0 ? void 0 : C.fileUrl, download: { progress: D } })), Object.assign(g, { progress: D });
      } else if (h === "download_load") {
        var b, E, w;
        const B = Fo.Success;
        Object.assign(g, { progress: 100, status: B }), m.push(tr({ id: n, fileUrl: (b = d.file) === null || b === void 0 ? void 0 : b.fileUrl, download: { progress: 100, status: B } }));
        const L = (E = u.find((y) => y.userId === d.sender.userId)) === null || E === void 0 ? void 0 : E.zoomID, R = await async function(y, A, k) {
          const T = Math.ceil(y.byteLength / lr.DecodeBlockSize);
          try {
            const N = await Promise.all(Array.from({ length: Math.max(T - 1, 1) }, (F, $) => ({ start: $ * lr.DecodeBlockSize, end: ($ === T - 2 ? $ + 2 : $ + 1) * lr.DecodeBlockSize })).map(async (F) => {
              let { start: $, end: re } = F;
              try {
                const fe = y.slice($, re), { message: le } = await ir.beginDecrypt({ decryptedText: fe, zoomId: k, type: mr.CHAT_FILE });
                return le;
              } catch (fe) {
                return gi("decrypt file buffer error.", { name: A, size: y.byteLength }, fe), Promise.reject(fe);
              }
            }));
            return new Blob(N, { type: WM(A) });
          } catch {
            return null;
          }
        }(p.response, (w = d.file) === null || w === void 0 ? void 0 : w.name, L);
        var _, I;
        R && ((_ = d.file) !== null && _ !== void 0 && _.download.blob ? Object.assign(g, { fileBlob: R }) : function(y, A) {
          const k = document.createElement("a"), T = window.URL.createObjectURL(y);
          k.href = T, k.download = A, k.click(), window.URL.revokeObjectURL(T);
        }(R, (I = d.file) === null || I === void 0 ? void 0 : I.name));
      }
      return (g.progress > 0 || h === "download_loadstart") && O(Nd, g), m;
    }), Xn((p) => (console.warn(p), gi(`download file error. file url:${c}`, { name: void 0, size: void 0 }, p), O(Nd, { ...Sh(d), progress: 0, status: Fo.Fail }), Je(tr({ id: n, fileUrl: c, download: { status: Fo.Fail, progress: 0 } })))));
  }
  return oe;
}(r.payload.id, e, t))) });
function wl(e) {
  const { meeting: { isMeetingReset: t, meetingId: r, meetingNumber: n, userName: o, userEmail: i, tid: s, userId: a }, breakoutRoom: l } = e;
  let u = "";
  var d;
  return u = t ? l != null && (d = l.currentRoom) !== null && d !== void 0 && d.boConfId ? "join breakout room" : "meeting failover" : "join meeting", { label: u, payload: { meetingId: r, tid: s, userId: a, meetingNumber: xr(n), userName: xr(o), userEmail: xr(i) } };
}
function yn(e, t, r) {
  return ks(ze((n) => {
    let o = !1;
    try {
      var i, s;
      const { logger: { options: a }, meeting: { logConfig: l } } = t.value;
      o = (i = a == null ? void 0 : a.enable) !== null && i !== void 0 ? i : (s = JSON.parse(l || "{}")) === null || s === void 0 ? void 0 : s.enable;
    } catch {
    }
    try {
      if (o) {
        const { logger: { isLaplaceInitialized: a } } = t.value;
        if (!a)
          return e.pipe(ge(`${u0}`), Ge(1), G((l) => (l.payload && r(n), oe)));
        r(n);
      }
    } catch (a) {
      console.warn(a);
    }
    return oe;
  }));
}
function Ho(e, t, r, n) {
  return Pe(e, r).pipe(yn(e, t, n));
}
function Na(e, t, r, n) {
  return se(e, r).pipe(yn(e, t, n));
}
function uv(e) {
  var t, r;
  const { audio: { activeMicrophone: n, activeSpeaker: o, microphoneDevicesList: i, speakerDevicesList: s } } = e;
  return `microphone: [${n} - ${i == null || (t = i.find((a) => a.deviceId === n)) === null || t === void 0 ? void 0 : t.label}]; speaker: [${o} - ${s == null || (r = s.find((a) => a.deviceId === o)) === null || r === void 0 ? void 0 : r.label}]`;
}
function b_(e) {
  var t;
  const { video: { activeCamera: r, cameraDevicesList: n } } = e;
  return `camera: [${r} - ${n == null || (t = n.find((o) => o.deviceId === r)) === null || t === void 0 ? void 0 : t.label}]`;
}
function El(e, t) {
  return t ? ` ,${e}:${t}` : "";
}
const { InitSuccessAudio: YM, InitFailedAudio: XM, InitSuccessVideo: eP, InitFailedVideo: tP, InitSuccessSharing: rP, InitFailedSharing: nP } = X, { DecodeSuccess: Ay, DecodeFailed: _y, EncodeSuccess: Ry, EncodeFailed: Oy } = Br, oP = { [`${YM}`]: { name: "Audio", isException: !1 }, [`${XM}`]: { name: "Audio", isException: !0 }, [`${eP}`]: { name: "Video", isException: !1 }, [`${tP}`]: { name: "Video", isException: !0 }, [`${rP}`]: { name: "Sharing", isException: !1 }, [`${nP}`]: { name: "Sharing", isException: !0 } }, hn = Zr.getInstance(), bh = () => {
  if ("connection" in navigator) {
    const { effectiveType: e, rtt: t, downlink: r } = navigator.connection;
    hn.makeLogger(["Network Connection Type"]).info(`Network connection. ect:${e},rtt:${t},downlink:${r}`);
  }
}, li = Zr.getInstance().makeLogger(["Remote Control"]), Ty = Vr(ke.getInstance()), iP = [{ event: X.AudioBridgeReconnectStart, message: $i.AudioBridgeReconnectStart, logType: "info", additionalTags: ["Audio Join Flow"] }, { event: X.AudioBridgeReconnectEnd, message: $i.AudioBridgeReconnectEnd, logType: "info", additionalTags: ["Audio Join Flow"] }, { event: X.UserGrantCaptureAudio, message: (e) => `${$i.DeviceAudioStreamCaptured},${uv(e)}`, logType: "info", additionalTags: ["Audio Capture Flow"] }, { event: X.JoinComputerAudioComplete, message: $i.AudioJoinComplete, logType: "info", additionalTags: ["Audio Join Flow"] }, { event: X.LeaveComputerAudioComplete, message: $i.AudioLeaveComplete, logType: "info", additionalTags: ["Audio Join Flow"] }, { event: X.JoinSharingAudioComplete, message: $i.SharingAudioStartComplete, logType: "info", additionalTags: ["Audio Sharing Flow"] }, { event: X.LeaveSharingAudioComplete, message: $i.SharingAudioStopComplete, logType: "info", additionalTags: ["Audio Sharing Flow"] }], sP = [{ event: X.StartVideoCaptureSuccess, message: (e) => `${Hi.StartCaptureVideoSuccess}, ${b_(e)}`, logType: "info", additionalTags: ["Video Join Flow"] }, { event: X.StopVideoCaptureSuccess, message: Hi.StopCaptureVideoSuccess, logType: "info", additionalTags: ["Video Join Flow"] }, { event: X.StartVideoStreamInVbSettingSuccess, message: Hi.VBSettingSuccess, logType: "info", additionalTags: ["Video VB Flow"] }, { event: X.VbModelPreloadingOk, message: Hi.VBPreloadSuccess, logType: "info", additionalTags: ["Video VB Flow"] }, { event: X.VbModelPreloading_3S, message: Hi.VBPreloading3S, logType: "warn", additionalTags: ["Video VB Flow"] }, { event: X.VbModelPreloading_10S, message: Hi.VBPreloading10S, logType: "warn", additionalTags: ["Video VB Flow"] }, { event: X.VbSettingParaError, message: Hi.VBSettingFailed, logType: "error", additionalTags: ["Video VB Flow"] }], ky = iP.map((e) => ({ ...e, tag: "Audio" })).concat(sP.map((e) => ({ ...e, tag: "Video" }))), Tn = Zr.getInstance(), { InitSuccessVideo: aP, InitSuccessAudio: lP, InitSuccessSharing: uP, InitFailedVideo: dP, InitFailedAudio: cP, InitFailedSharing: pP, RecoverWebrtcAudio: hP, AudioBridgeFirstRecvData: My, AudioBridgeCanSendData: fP, UserForbiddedCaptureAudio: Py, AudioWebsocketBroken: vP, AudioZeroData: Dy, UserForbiddedCaptureVideo: Ly, UserCameraIsTakenByOtherPrograms: Ny, VideoWebsocketBroken: mP, StopVideoCaptureFailed: gP, DesktopSharingPermissionDenied: yP, DesktopSharingSystemError: xy, AudioSpeakerSetError: Vy, VbSettingParaError: SP, MaskSettingParaError: bP, WebglLostInMultiView: CP, VideoStreamFailed: jy, AudioStreamFailed: Uy } = X, md = Zr.getInstance(), Ch = { options: void 0, isLaplaceInitialized: !1 }, wP = zr({ [`${Vm}`]: M((e, t) => {
  let { payload: r } = t;
  e.options = r;
}), [`${u0}`]: M((e, t) => {
  let { payload: r } = t;
  e.isLaplaceInitialized = r;
}), [`${QI}`]: (e, t) => {
  let { options: r } = e, { payload: n } = t;
  return n ? { ...Ch, options: r } : { ...Ch };
} }, Ch), EP = { mlEpics0: (e, t) => Pe(e, [aP, lP, uP, dP, cP, pP]).pipe(yn(e, t, (r) => {
  const { payload: { type: n, data: o } } = r, { meeting: { userId: i } } = t.value, s = function(a, l) {
    const u = oP[`${a}`];
    if (u) {
      const { name: d, isException: c } = u, p = [d, `${d} Init Flow`];
      c && p.push(`${d} exception flow`);
      let h = "";
      return [Ay, _y].includes(l) && (h = `${h} decode`.trim()), [Ry, Oy].includes(l) && (h = `${h} encode`.trim()), [Ry, Ay].includes(l) && (h = `${h} success`.trim()), [_y, Oy].includes(l) && (h = `${h} failed`.trim()), { message: `init ${d.toLowerCase()} ${h}`, tags: p, isException: c };
    }
    return null;
  }(n, o);
  if (s) {
    const { message: a, tags: l, isException: u } = s;
    u ? Tn.report(`${a}. userId:${i}`, l) : Tn.makeLogger(l).info(a);
  }
})), mlEpics1: (e, t) => Ho(e, t, ky.map((r) => r.event), (r) => {
  const { payload: { type: n } } = r, o = ky.find((i) => i.event === n);
  if (o) {
    const { message: i, logType: s, additionalTags: a, tag: l } = o;
    let u = i;
    typeof i == "function" && (u = i(t.value)), u && Tn.makeLogger([l])[s](u, a);
  }
}), mlEpics2: (e, t) => e.pipe(ge(`${Za}`), z((r) => !r.payload), yn(e, t, () => {
  Tn.makeLogger(["Audio"]).warn(`Auto play audio failed,${uv(t.value)}`);
})), mlEpics3: (e, t) => Ho(e, t, hP, () => {
  Tn.report("Audio bridge, recover audio failed, need to rejoin the audio", ["Audio exception flow"]);
}), mlEpics4: (e, t) => Ho(e, t, [My, fP], (r) => {
  const { payload: { type: n } } = r;
  Tn.makeLogger(["Audio"]).log("Audio bridge connection: " + (n === My ? "first receive data" : "can send data"));
}), mlEpics5: (e, t) => Ho(e, t, [Py, vP, Dy, Vy, Uy], (r) => {
  const { payload: { type: n } } = r;
  let o = `Audio error case:${n}`;
  n === Py ? o = "Audio capture is forbidden by the user" : n === Dy ? t.value.audio.webrtcRestartCount < 3 && (o = "audio capture zero data, auto failover") : n === Vy ? o = "audio change speaker error" : n === Uy && (o = "audio stream ended or muted, stop capture audio"), Tn.report(`${o},${uv(t.value)}`, ["Audio exception flow"]);
}), mlEpics6: (e, t) => Ho(e, t, [Ly, Ny, mP, gP, jy], (r) => {
  const { payload: { type: n } } = r;
  let o = `Video error case:${n}`;
  if (n === Ly)
    o = "Video capture is forbidden by the user";
  else if (n === Ny)
    o = "Camera is taken by other programs";
  else if (n === SP) {
    var i;
    o = `VB setting error, param:${JSON.stringify((i = t.value.video.virtualBackground) !== null && i !== void 0 ? i : {})}`;
  } else if (n === bP) {
    var s;
    o = `Mask setting error, param:${JSON.stringify((s = t.value.video.mask) !== null && s !== void 0 ? s : {})}`;
  } else
    n === jy && (o = `Video stream ended or muted, if it is on iOS platform, will stop capture video.platform:${ve.browser}`);
  Tn.report(`${o},${b_(t.value)}`, ["Video exception flow"]);
}), mlEpics7: (e, t) => Ho(e, t, [yP, xy], (r) => {
  const { payload: { type: n } } = r;
  let o = "";
  n === xy ? ve.isMacOS && (o = "Need to allow screen recording access in system setting on MacOS") : o = "Need to allow the permission request", Tn.report(`${o}`, ["Sharing exception flow"]);
}), mlEpics8: (e, t) => Ho(e, t, CP, (r) => {
  const { payload: { data: n } } = r, { video: { renderedVideoList: o } } = t.value;
  if (n != null && n.canvasId) {
    const i = o.filter((s) => s.canvasId === n.canvasId);
    Tn.report(`WebGl Context lost, canvas ID:${n.canvasId}, affected video node Ids:${i.map((s) => s.userId).join(",")}`, ["Video exception flow"]);
  }
}), mlEpics9: (e, t) => Ct(document, "visibilitychange").pipe(yn(e, t, () => {
  Tn.makeLogger(["Video"]).log(`Page visibility ${document.visibilityState} `), setTimeout(() => {
    const r = document.visibilityState !== "visible", { video: { subscribedVideoList: n }, meeting: { userId: o } } = t.value, i = n.filter((s) => s !== o).length === 0;
    r && i && (We.createAgent().sendRWGConnectionPerformance("VCSV"), Tn.makeLogger(["Video"]).warn("Still subscribing videos after switching to background"));
  }, 1e3);
})) }, IP = { rmclEpics0: (e, t) => e.pipe(ge(`${Am}`), yn(e, t, (r) => {
  const { payload: { isRemoteControlEnabled: n, isEnableAutoDeleteRcApp: o } } = r;
  li.log(`isRemoteControlEnabled:${n},auto delete:${o}`);
})), rmclEpics1: (e, t) => e.pipe(ge(`${Co}`), z((r) => !!r.payload), yn(e, t, (r) => {
  li.log(`Launch Remote control app, scheme:${r.payload}`);
})), rmclEpics2: (e, t) => e.pipe(ge(`${ql}`), z((r) => !!r.payload), yn(e, t, (r) => {
  li.log(`Remote control session starts, controlling ssrc:${r.payload}`);
})), rmclEpics3: (e, t) => Na(e, t, 16430, () => {
  li.log("Remote control app connected to rwg.");
}), rmclEpics4: (e, t) => Na(e, t, L1, () => {
  li.log("Remote control app disconnected to rwg.");
}), rmclEpics5: (e, t) => Na(e, t, L1, (r) => {
  const { share: { status: n, isRemoteControlEnabled: o } } = t.value;
  o && n !== Fe.End && r.payload.body.bOn && li.log(`Remote control sharing device info.${JSON.stringify(Ty.getShareStreamInfo())}`);
}), rmclEpics6: (e, t) => Ho(e, t, X.CurrentDesktopSharingWidthHeight, () => {
  const { share: { isRemoteControlEnabled: r } } = t.value;
  r && li.log(`Remote control sharing device info changes.${JSON.stringify(Ty.getShareStreamInfo())}`);
}), rmclEpics7: (e, t) => Ho(e, t, X.SendRemoteControlQrCode, (r) => {
  const { share: { status: n } } = t.value, { payload: { data: o } } = r;
  li.log(`Remote control QR code result. sharing status:${n}, result${JSON.stringify(o)}`);
}) }, AP = { epics0: (e, t) => e.pipe(ge(`${Un}`), G(async (r) => {
  const { meeting: { logConfig: n, logEncryptionPubKey: o, zlkJwtToken: i, accountId: s }, logger: { options: a } } = t.value;
  let l = a || {};
  if (n)
    try {
      const { enable: u, enableReport: d } = JSON.parse(n);
      l = { ...l, enable: u, enableReport: d };
    } catch {
    }
  if (i) {
    const { telemetry_tracking_id: u } = nl(i), { payload: { meetingId: d } } = r, c = u != null ? u : d;
    l = { ...l, enable: !0, enableReport: !0, trackingId: c };
  }
  return hn.init({ ...l, logConfig: n, logEncryptionPubKey: o, accountId: s }).then(() => [u0(!0), Vm(l)]).catch(() => [u0(!1)]);
}), G((r) => ne(r))), epics1: (e, t) => Na(e, t, Q0, (r) => {
  var n, o, i;
  const { payload: { body: s } } = r;
  if (s && s.res === fn.Success) {
    hn.makeLogger(["A/V Performance Info"]).info(`CPU cores:${navigator.hardwareConcurrency}, SharedArrayBuffer:${!!window.crossOriginIsolated}, browser:${ve.browser} ${ve.browserVersion}, OS:${ve.os} ${ve.osVersion}${El("wow64", ve.wow64)}${El("GPU", ve.gpu)}${El("architecture", ve.architecture)}${El("bitness", ve.bitness)}${El("model", ve.model)}${xe.get(im.EnforceWebRTCAudio) ? "; Enforce WebTRC audio" : ""}`, ["CPU_CORES"]);
    const { media: { enforceMultipleVideos: b, enforceVirtualBackground: E, assetsPath: w, disableRenderLimits: _ }, meeting: { stayAwake: I, quicklyLeave: D } } = t.value;
    hn.makeLogger(["Init Option"]).info(`Init option:${JSON.stringify({ enforceMultipleVideos: b, disableRenderLimits: _, enforceVirtualBackground: E, assetsPath: w, stayAwake: I, leaveOnPageUnload: D })}`), "connection" in navigator && (bh(), navigator.connection.addEventListener("change", bh));
  } else
    hn.report(`join meeting failed, error:${JSON.stringify(Ml(s == null ? void 0 : s.res))}, rwg error code:${s == null ? void 0 : s.res}, rwg conID:${s == null ? void 0 : s.conID}, error message:${s == null ? void 0 : s.error_desc}, rwg url:${s == null ? void 0 : s.svcUrl},mid:${t.value.meeting.meetingId}`, "JOIN_MEETING_FAILED", "error");
  const { meeting: { meetingInfoTimestamp: a, pingRWCTimestamp: l, tid: u, meetingId: d }, socket: { rwgServerList: c, retryCount: p }, video: { rendererType: h } } = t.value;
  let v = ["conID", "confID", "mmrFeature", "mmrFeatureEx", "reportDomain", "res", "role", "svcUrl", "userID"].reduce((b, E) => s[E] !== void 0 ? { ...b, [`${E}`]: s[E] } : b, {});
  v = ["jid", "mn", "participantID", "zoomID"].reduce((b, E) => s[E] !== void 0 ? { ...b, [`${E}`]: xr(s[E]) } : b, v);
  const f = ["connection_info_map"];
  let m;
  if (s.res === fn.Success && f.push("Command Socket Event", "User Info Map"), u) {
    const b = u.match(/clid=(\S+);/);
    b && b.length > 1 && (m = b[1]);
  }
  const g = Math.floor(performance.now() - a), C = Math.floor(performance.now() - l);
  hn.report(JSON.stringify({ ...v, tid: u, mid: d, userRegion: m, rwgUrl: c.length > 0 ? (n = c[p]) === null || n === void 0 ? void 0 : n.rwg : void 0, hardwareConcurrency: navigator.hardwareConcurrency, sharedArrayBuffer: !!window.crossOriginIsolated, browser: `${ve.browser} ${ve.browserVersion}`, os: `${ve.os} ${ve.osVersion}`, gpu: ve.gpu, architecture: ve.architecture, model: ve.model, bitness: ve.bitness, totalDurationOfJoining: g, durationOfRWG: C, rendererType: h }), f, "info"), We.createAgent().sendRWGConnectionPerformance(`WCL_M, conId: ${s == null ? void 0 : s.conID}, trackingId: ${(o = t.value.logger) === null || o === void 0 || (i = o.options) === null || i === void 0 ? void 0 : i.trackingId}, JOINFS(${g}), JOINFRWC(${C})`);
}), epics2: (e, t) => e.pipe(ge(`${nm}`), pe(t), z((r) => {
  let [, n] = r;
  return n.meeting.encryptedRWC === void 0 && (n.meeting.encryptedGEORWC === void 0 || n.meeting.encryptedGEORWC.length === 0);
}), yn(e, t, () => {
  const { label: r, payload: n } = wl(t.value);
  hn.report(`${r} ${JSON.stringify(n)}`, ["Join Meeting Flow", "Ping RWC Domain Empty"], "error");
})), epics3: (e, t) => e.pipe(ge(`${Tr}`), z((r) => r.payload === or.OnError || r.payload === or.Disconnect || r.payload === or.NoHeartbeat), yn(e, t, (r) => {
  const { payload: n } = r, { socket: { rwgServerList: o, retryCount: i } } = t.value, { payload: s } = wl(t.value);
  hn.report(`websocket unexpected disconnected,${JSON.stringify({ code: n, rwgHost: o[i], ...s })}`, ["Join Meeting Flow", "RWG Disconnect"]);
})), epics4: (e, t) => e.pipe(ge(`${Ic}`), yn(e, t, (r) => {
  const { payload: { reason: n, count: o, interval: i } } = r, { payload: s } = wl(t.value);
  hn.report(`meeting failover,${JSON.stringify({ reason: n, count: o, interval: i, ...s })}`, ["Join Meeting Flow", "Failover"]), "connection" in navigator && navigator.connection.removeEventListener("change", bh);
})), epics5: (e, t) => e.pipe(ge(`${ca}`), z((r) => r.payload.status === dt.Connecting), yn(e, t, (r) => {
  const { payload: { rwgUrl: n } } = r;
  let o = n.replace(/(\d+)\?/, `${xr("$1")}?`);
  o = ["email", "zoomid", "participantID", "dn2", "customer_key", "mpwd", "topic"].reduce((s, a) => s.indexOf(a) > -1 ? s.replace(new RegExp(`${a}=([^&]+)`, "g"), `${a}=${xr("$1")}`) : s, o);
  const { payload: i } = wl(t.value);
  hn.makeLogger(["Join Meeting Flow"]).info(`RWG URL,${JSON.stringify({ rwgUrl: o, ...i })}`, ["RWG Url"]);
})), epics6: (e, t) => e.pipe(ge(`${ko}`), z((r) => {
  const { payload: n } = r;
  return n ? n.retry : t.value.meeting.meetingStatus === xt.Initial;
}), yn(e, t, () => {
  const { meeting: { meetingStatus: r }, socket: { rwgServerList: n, retryCount: o } } = t.value;
  if (r !== xt.Joined) {
    const { payload: i } = wl(t.value), s = (n == null ? void 0 : n.length) > 0 ? n[o] : void 0;
    hn.report(JSON.stringify({ ...i, rwc: s == null ? void 0 : s.rwc, rwg: s == null ? void 0 : s.rwg }), ["meeting_connection_details"]);
  }
})), epics7: (e, t) => Na(e, t, 1, (r) => {
  const { payload: { body: n } } = r;
  hn.report(`join meeting failed, version blocked. Current version:${t.value.meeting.cv},upgrade version:${n == null ? void 0 : n.upgradeVersion}`, "JOIN_MEETING_FAILED", "error");
}), epics8: (e, t) => Na(e, t, 2, () => {
  hn.report(`join meeting with low version of SDK. Current version:${t.value.meeting.cv}.`, "Join Meeting Flow", "warn");
}) }, _P = Wr(AP, IP, EP), RP = We.createAgent(), By = { cmrStatus: Zt.Stop, recordingEnable: !1, recordingIsoEnable: !1, allowStopAutoRecording: !1, automaticCloudRecordingEnable: !1, isZoomIQ: !1, zoomIQChanging: !1, localStatus: lu.Stop, supportLocalRecording: $r.None, localGrantPermissionOption: hO.None, localPermissionUserList: [] }, OP = zr({ [`${TI}`]: M((e, t) => {
  let { payload: r } = t;
  e.cmrStatus = r;
}), [`${kI}`]: M((e, t) => {
  let { payload: r } = t;
  e.recordingEnable = r;
}), [`${MI}`]: M((e, t) => {
  let { payload: r } = t;
  e.recordingIsoEnable = r;
}), [`${PI}`]: M((e, t) => {
  let { payload: r } = t;
  e.allowStopAutoRecording = r;
}), [`${DI}`]: M((e, t) => {
  let { payload: r } = t;
  e.automaticCloudRecordingEnable = r;
}), [`${Lm}`]: M((e, t) => {
  let { payload: r } = t;
  e.isZoomIQ = r;
}), [`${Nm}`]: M((e, t) => {
  let { payload: r } = t;
  e.zoomIQChanging = r;
}), [`${xm}`]: M((e, t) => {
  let { payload: r } = t;
  e.localStatus = r;
}), [`${Vf}`]: M((e, t) => {
  let { payload: r } = t;
  e.supportLocalRecording = r;
}), [`${LI}`]: M((e, t) => {
  let { payload: r } = t;
  e.localGrantPermissionOption = r;
}), [`${ka}`]: M((e, t) => {
  let { payload: r } = t;
  e.localPermissionUserList = r;
}), [`${NI}`]: () => ({ ...By }) }, By);
var $y, Hy, Fy, zy, Wy, Zy, Gy, qy, Ky, pt;
const Hn = We.createAgent(), Il = nn("Recording");
let TP = ($y = de("recording"), Hy = de("recording"), Fy = de("recording"), zy = de("recording"), Wy = de("recording"), Zy = de("recording"), Gy = de("recording"), qy = de("recording"), Ky = de("recording"), pt = class extends Po {
  startRecording() {
    const e = this[ce](), { meeting: { bIbDisableRecording: t, recordingEnable: r }, recording: { cmrStatus: n } } = e;
    return t ? Promise.reject({ type: W, reason: "Rejected by Information Barrier" }) : r ? n === Zt.Start ? Promise.resolve("") : (Hn.recordMeeting(!0, !1), Te(Fl, (o) => o.cmrServerStatus === Zt.Start)) : Promise.reject({ type: W, reason: "The account of the meeting disabled the cloud recording" });
  }
  pauseRecording() {
    const e = this[ce](), { recording: { cmrStatus: t } } = e;
    return t === Zt.Pause ? Promise.resolve("") : t !== Zt.Start ? Promise.reject({ type: W, reason: "Recording is not started" }) : (Hn.recordMeeting(!1, !0), Te(Fl, (r) => r.cmrServerStatus === Zt.Pause));
  }
  stopRecording() {
    const e = this[ce](), { recording: { cmrStatus: t } } = e;
    return t === Zt.Stop ? Promise.resolve("") : (Hn.recordMeeting(!1, !1), Te(Fl, (r) => r.cmrServerStatus === Zt.Stop));
  }
  accept() {
    const e = this[ce](), { recording: { cmrStatus: t, recordingIsoEnable: r } } = e, n = be(e);
    return r ? t !== Zt.Start && t !== Zt.Pause ? Promise.reject({ type: W, reason: "Recording is not started" }) : n != null && n.bAllowISORecord ? Promise.resolve("You accepted ISO recording") : (Hn.allowSelfRecord(!0), Te(Tc, (o) => (o == null ? void 0 : o.userId) === (n == null ? void 0 : n.userId) && (o == null ? void 0 : o.status) === Qn.Accept)) : Promise.reject({ type: W, reason: "ISO Recording is not enabled" });
  }
  decline() {
    const e = this[ce](), { recording: { cmrStatus: t, recordingIsoEnable: r } } = e, n = be(e);
    return r ? t !== Zt.Start && t !== Zt.Pause ? Promise.reject({ type: W, reason: "Recording is not started" }) : (n == null ? void 0 : n.bAllowISORecord) === !0 ? Promise.reject({ type: W, reason: "You had accept ISO recording, cant change it" }) : (Hn.allowSelfRecord(!1), Promise.resolve("")) : Promise.reject({ type: W, reason: "ISO Recording is not enabled" });
  }
  getRecordingStatus() {
    const e = this[ce](), { recording: { cmrStatus: t } } = e, r = jO(e);
    return t === Zt.Start ? Qn.Recording : t === Zt.Pause ? Qn.Paused : r ? Qn.Recording : Qn.Stopped;
  }
  isRecordingEnabled() {
    const e = this[ce](), { recording: { recordingEnable: t } } = e;
    return t;
  }
  isAllowedToStopAutoRecording() {
    const e = this[ce](), { recording: { allowStopAutoRecording: t } } = e;
    return t;
  }
  isAutomaticCloudRecordingEnabled() {
    const e = this[ce](), { recording: { automaticCloudRecordingEnable: t } } = e;
    return t;
  }
  enableRecordingWithIQ(e) {
    const { [ce]: t, [Nt]: r } = this, n = t(), { recording: { isZoomIQ: o, zoomIQChanging: i }, meeting: { meetingOptions: s } } = t();
    return s.isEnableKiwiRecording ? Sn(n) ? i ? Promise.reject({ type: W, reason: "We are changing, please wait" }) : e === o ? Promise.reject({ type: W, reason: `You have ${e ? "enable" : "disable"} Zoom IQ, don't need change` }) : (r(Nm(!i)), r(Lm(!o)), Hn.enableZoomIQRecord(e), Te(DC, (a) => a == null ? void 0 : a.success)) : Promise.reject({ type: W, reason: "Only Host or co-host can enable/disable Zoom IQ" }) : Promise.reject({ type: W, reason: "You not have zoom IQ license or not enable zoom IQ, please check and retry" });
  }
  isSupportLocalRecording() {
    const e = this[ce](), { meeting: { meetingOptions: t, isWebinar: r }, breakoutRoom: n } = e;
    if ((n == null ? void 0 : n.currentRoom.status) === Ee.InRoom)
      return !1;
    const o = be(e);
    return (!r || !Jt(o.userRole)) && (t == null ? void 0 : t.isLocalRecordingEnabled);
  }
  isSupportLocalRecordingPermission() {
    const e = this[ce](), { recording: { supportLocalRecording: t } } = e;
    if (!this.isSupportLocalRecording())
      return !1;
    const r = be(e);
    return !(r == null || !r.isHost) || t === $r.Allow;
  }
  askLocalRecordingPermission() {
    const { [ce]: e } = this, { recording: { supportLocalRecording: t } } = e();
    return this.isSupportLocalRecording() ? t === $r.None ? (Hn.localRecordingRequestPermission(), Promise.resolve("")) : t === $r.Allow ? Promise.resolve("") : Promise.reject("permission is denied") : Promise.reject("not support");
  }
  startLocalRecording(e) {
    const { [ce]: t, [Nt]: r } = this, n = t(), { recording: { localStatus: o, supportLocalRecording: i }, meeting: { userId: s } } = n;
    if (!(e in lu))
      return Promise.reject({ type: W, reason: "not support you parameter, only support type are 0(stop)/1(start)/2(pause)." });
    if (!this.isSupportLocalRecording())
      return Promise.reject({ type: W, reason: "not support local recording" });
    if (e === o)
      return Promise.resolve(`you currently status is ${o}, do nothing`);
    const a = be(n);
    return i === $r.Allow || a != null && a.isHost ? (Hn.localRecordingMeeting(e), Te(kc, (l) => (l == null ? void 0 : l.userId) === s && (r(xm(l.bLocalRecord)), l.bLocalRecord === e), 1e3)) : Promise.reject({ type: W, reason: "you not have local recording permission, please use askLocalRecordingPermission request it first" });
  }
  isSupportLocalRecordingGrantPermission() {
    const e = this[ce]();
    if (!this.isSupportLocalRecording())
      return !1;
    const t = be(e);
    return !(t == null || !t.isHost) && !!rd(t.caps);
  }
  grantLocalRecordingPermission(e, t, r) {
    const { [ce]: n, [Nt]: o } = this, i = n(), { recording: { localPermissionUserList: s } } = i;
    if (!this.isSupportLocalRecording())
      return Promise.resolve(!1);
    const a = be(i);
    if (!rd(a.caps))
      return Promise.reject({ type: W, reason: "you can not grant permission" });
    let l = !1;
    if (r && (l = !0), s.filter((u) => u === e).length > 0) {
      if (t === $r.Allow)
        Hn.localRecordingGrantPermission(e, !0, l);
      else {
        if (t !== $r.Deny)
          return Promise.reject({ type: W, reason: "only support DENY(1)/ALLOW(2)" });
        Hn.localRecordingGrantPermission(e, !1, l);
      }
      return o(ka(s.filter((u) => u !== e))), O(go, { type: "answer", value: t === $r.Allow }), Promise.resolve(!1);
    }
    return t !== $r.Deny ? Promise.reject({ type: W, reason: "Direct grant only support DENY(1)" }) : (Hn.hostGrantPermission(e, !1), Te(go, (u) => (u == null ? void 0 : u.value) === e && (t === $r.Allow ? (o(ka([...s, e])), (u == null ? void 0 : u.canRecord) === !0) : (o(ka(s.filter((d) => d !== e))), (u == null ? void 0 : u.canRecord) === !1)), 1e3));
  }
  getLocalRecordingPermissionUserList() {
    const e = this[ce](), { recording: { localPermissionUserList: t } } = e;
    if (!this.isSupportLocalRecording())
      return Promise.resolve(!1);
    const r = be(e);
    return rd(r.caps) ? t : Promise.reject({ type: W, reason: "you can not grant permission" });
  }
  getLocalRecordingPermissionOperation() {
    const e = this[ce](), { recording: { localGrantPermissionOption: t } } = e;
    if (!this.isSupportLocalRecording())
      return null;
    const r = be(e);
    return rd(r.caps) ? t : null;
  }
}, K(pt.prototype, "startRecording", [rr, Y, $y, Il], Object.getOwnPropertyDescriptor(pt.prototype, "startRecording"), pt.prototype), K(pt.prototype, "pauseRecording", [rr, Y, Hy, Il], Object.getOwnPropertyDescriptor(pt.prototype, "pauseRecording"), pt.prototype), K(pt.prototype, "stopRecording", [rr, Y, Fy, Il], Object.getOwnPropertyDescriptor(pt.prototype, "stopRecording"), pt.prototype), K(pt.prototype, "accept", [Y, zy, Il], Object.getOwnPropertyDescriptor(pt.prototype, "accept"), pt.prototype), K(pt.prototype, "decline", [Y, Wy, Il], Object.getOwnPropertyDescriptor(pt.prototype, "decline"), pt.prototype), K(pt.prototype, "askLocalRecordingPermission", [Y, Zy], Object.getOwnPropertyDescriptor(pt.prototype, "askLocalRecordingPermission"), pt.prototype), K(pt.prototype, "startLocalRecording", [Y, Gy], Object.getOwnPropertyDescriptor(pt.prototype, "startLocalRecording"), pt.prototype), K(pt.prototype, "grantLocalRecordingPermission", [Y, Qt, qy], Object.getOwnPropertyDescriptor(pt.prototype, "grantLocalRecordingPermission"), pt.prototype), K(pt.prototype, "getLocalRecordingPermissionUserList", [Y, Qt, Ky], Object.getOwnPropertyDescriptor(pt.prototype, "getLocalRecordingPermissionUserList"), pt.prototype), pt);
const kP = { moduleEpics0: (e) => e.pipe(ge(`${Un}`), ae((t) => {
  const { payload: { recordingEnable: r } } = t;
  return kI(r);
})), moduleEpics1: (e, t) => se(e, En).pipe(z((r) => {
  var n, o, i;
  return ((n = r.payload.body) === null || n === void 0 ? void 0 : n.cmrServerStatus) !== void 0 || ((o = r.payload.body) === null || o === void 0 ? void 0 : o.disAllowClientStopAutoCmr) !== void 0 || ((i = r.payload.body) === null || i === void 0 ? void 0 : i.enableAutomicRecordingCloud) !== void 0;
}), pe(t), G((r) => {
  let [n, o] = r;
  const { cmrServerStatus: i, disAllowClientStopAutoCmr: s, enableAutomicRecordingCloud: a } = n.payload.body, l = [];
  return i !== void 0 && (i !== Zt.Init && (O(Fl, { cmrServerStatus: i }), o.recording.recordingIsoEnable && i === Zt.Start && O(Tc, { status: Qn.Ask })), l.push(TI(i))), s !== void 0 && l.push(PI(!s)), a !== void 0 && l.push(DI(a)), ne(l);
})), moduleEpics2: (e) => se(e, En).pipe(z((t) => {
  var r;
  return ((r = t.payload.body) === null || r === void 0 ? void 0 : r.bCmrIsoEnble) !== void 0;
}), ae((t) => {
  const { bCmrIsoEnble: r } = t.payload.body;
  return MI(r);
})), moduleEpics3: (e, t) => se(e, gt).pipe(pe(t), z((r) => {
  let [n] = r;
  const { payload: { body: { update: o, add: i } } } = n;
  return (o == null ? void 0 : o.some((s) => s.bLocalRecordStatus !== void 0 || s.canRecord !== void 0)) || (i == null ? void 0 : i.some((s) => s.bLocalRecordStatus !== void 0 || s.canRecord !== void 0));
}), G((r) => {
  let [n, o] = r;
  const { payload: { body: { update: i, add: s } } } = n, { meeting: { userId: a, isHost: l }, recording: { supportLocalRecording: u }, participants: { attendeesList: d } } = o, c = [];
  return i == null || i.concat(s || []).filter((p) => p.bLocalRecordStatus !== void 0 || p.canRecord !== void 0).forEach((p) => {
    if (p.canRecord !== void 0) {
      const h = !!p.canRecord;
      if (a === p.id || l) {
        const v = d.find((f) => f.userId === a);
        !h && v != null && v.bLocalRecord && (O(go, { type: "revoke", value: p.id, canRecord: h }), RP.localRecordingMeeting(lu.Stop)), !h || v != null && v.bLocalRecord || O(go, { type: "grant", value: p.id, canRecord: h });
      }
      a === p.id && ((u !== $r.None || h) && c.push(Vf(h ? $r.Allow : $r.Deny)), h || c.push(xm(lu.Stop)));
    } else
      O(kc, { userId: p.id, bLocalRecord: p.bLocalRecordStatus });
  }), ne(c);
})), moduleEpics4: (e, t) => se(e, gt).pipe(ae((r) => E0(r.payload.body)), pe(t), G((r) => {
  let [n, o] = r;
  const i = [], { recording: { localPermissionUserList: s } } = o;
  return n.remove && n.remove.forEach((a) => {
    s.filter((l) => l === (a == null ? void 0 : a.userId)) && (i.push(ka(s.filter((l) => l !== (a == null ? void 0 : a.userId)))), O(go, { type: "remove", value: a == null ? void 0 : a.userId }));
  }), ne(i);
})), moduleEpics5: (e) => se(e, gt).pipe(z((t) => {
  const { payload: { body: { update: r } } } = t;
  return r == null ? void 0 : r.some((n) => n.bAllowISORecord !== void 0);
}), he((t) => {
  const { payload: { body: { update: r } } } = t;
  r.filter((n) => n.bAllowISORecord !== void 0).forEach((n) => {
    O(Tc, { userId: n.id, status: n.bAllowISORecord ? Qn.Accept : Qn.Decline });
  });
}), Ie(oe)), moduleEpics6: (e) => se(e, En).pipe(z((t) => {
  var r;
  return ((r = t.payload.body) === null || r === void 0 ? void 0 : r.SalesRecordingAnalytics) !== void 0;
}), ae((t) => {
  const { SalesRecordingAnalytics: r } = t.payload.body;
  return O(PC, { isZoomIQ: r }), Lm(r);
})), moduleEpics7: (e, t) => se(e, 4319).pipe(pe(t), z((r) => {
  var n;
  let [o] = r;
  return ((n = o.payload.body) === null || n === void 0 ? void 0 : n.success) !== void 0;
}), G((r) => {
  let [n, o] = r;
  const i = [], { success: s } = n.payload.body, { recording: { zoomIQChanging: a } } = o;
  return O(DC, { success: s }), s && i.push(Nm(!a)), ne(i);
})), moduleEpics8: (e, t) => se(e, 4344).pipe(pe(t), z((r) => {
  var n;
  let [o] = r;
  return ((n = o.payload.body) === null || n === void 0 ? void 0 : n.cmdType) !== void 0;
}), G((r) => {
  var n;
  let [o, i] = r;
  const s = [], { cmdType: a } = o.payload.body, { recording: { localPermissionUserList: l }, meeting: { isHost: u } } = i;
  var d, c, p, h;
  return a === "permission_req_option" && (O(go, { type: "option", value: (d = o.payload.body) === null || d === void 0 ? void 0 : d.option }), s.push(LI((c = o.payload.body) === null || c === void 0 ? void 0 : c.option))), a === "request_permission" && (n = o.payload.body) !== null && n !== void 0 && n.userId && (u && O(go, { type: "request", value: (h = o.payload.body) === null || h === void 0 ? void 0 : h.userId }), s.push(ka([...l, (p = o.payload.body) === null || p === void 0 ? void 0 : p.userId]))), a === "permission_request_answer" && (O(go, { type: "answer", value: o.payload.body.agreed }), s.push(Vf(o.payload.body.agreed ? $r.Allow : $r.Deny))), ne(s);
})) }, MP = Wr(kP);
let T0 = function(e) {
  return e[e.All = 1] = "All", e[e.Private = 2] = "Private", e;
}({}), C_ = function(e) {
  return e.SUCCESS = "success", e;
}({}), k0 = function(e) {
  return e.CustomizedKey = "__zoom_internal_message_customized_key__@@", e.SpeakerOnly = "__zoom_internal_message_speaker_only__@@", e;
}({});
const Jy = Us.getInstance(), M0 = (e, t, r) => {
  const { meeting: { encType: n } } = r, o = t, i = q4(e), s = o ? T0.Private : T0.All;
  return n === Nu.AES_GCM ? ir.beginEncrypt({ text: i, type: mr.XMPP_CHAT }).then((a) => {
    Jy.sendWebinarMseeage(a, o, s, !0);
  }) : Jy.sendWebinarMseeage(i, o, s, !1);
};
function w_(e, t) {
  const { cmd: { jids: r } } = t;
  return Object.prototype.hasOwnProperty.call(r, e) ? Promise.resolve() : gr(ht(yi).pipe(p4((n) => n.findIndex((o) => Number(o.userId) === e) === -1), Ge(1), Fr(ri)));
}
function E_(e) {
  const { cmd: { connectionStatus: t } } = e;
  return t === C_.SUCCESS ? Promise.resolve(!0) : gr(ht(dm, 1)).then((r) => r === ha.Connected || Promise.reject({ type: W, reason: "Cannot establish the command channel" }));
}
function dv(e, t) {
  for (const [r, n] of Object.entries(e))
    if (n.jid === t)
      return r;
}
const Qy = { connectionStatus: "initial", jids: {} }, PP = zr({ [`${UI}`]: () => ({ ...Qy }), [`${xI}`]: M((e, t) => {
  let { payload: r } = t;
  const { data: n, attendees: o } = r;
  n.forEach((i) => {
    const { jid: s, node: a } = i;
    if (!e.jids[a] || e.jids[a].jid !== s) {
      const l = o.find((u) => u.userId === Number(a));
      e.jids[a] = { jid: s, userGuid: l == null ? void 0 : l.userGUID };
    }
  });
}), [`${VI}`]: M((e, t) => {
  let { payload: r } = t;
  r.forEach((n) => {
    const { jid: o } = n, i = dv(e.jids, o);
    i && delete e.jids[i];
  });
}), [`${jI}`]: M((e, t) => {
  let { payload: r } = t;
  e.connectionStatus = r;
}) }, Qy);
var Al;
let DP = (Al = class extends Po {
  send(e, t) {
    if (!e)
      return Promise.reject({ type: De, reason: "Text is empty" });
    if (typeof e != "string")
      return Promise.reject({ type: De, reason: "Text is not a string" });
    if (e.length > 512)
      return Promise.reject({ type: De, reason: "Text exceeds the max length(512)." });
    const { [ce]: r } = this, n = r(), { socket: { xmppSocketStatus: o }, meeting: { userId: i } } = n;
    return o !== dt.Connected ? Promise.reject({ type: _a, reason: "Command channel is not ready" }) : E_(n).then(() => t ? ft(r()).findIndex((s) => s.userId === t) !== -1 ? w_(t, n).then(() => {
      const { cmd: { jids: s } } = r();
      return s[t] ? (M0(e, s[t].jid, r()), { timestamp: (/* @__PURE__ */ new Date()).getTime(), text: e, receiverId: t, senderId: i }) : Promise.reject({ type: Eo });
    }) : Promise.reject({ type: De, reason: "Cannot find the user" }) : (M0(e, "", n), { timestamp: (/* @__PURE__ */ new Date()).getTime(), text: e, receiverId: 0, senderId: i }));
  }
  getJids() {
    const { [ce]: e } = this, t = e(), { cmd: { jids: r } } = t;
    return r;
  }
}, K(Al.prototype, "send", [Y], Object.getOwnPropertyDescriptor(Al.prototype, "send"), Al.prototype), Al);
const LP = { extraEpics0: (e, t) => e.pipe(ge(`${Cm}`), ze((r) => {
  const { payload: { speakerOnly: n } } = r, o = be(t.value);
  return ((o == null ? void 0 : o.audio) !== void 0 ? ne([o.audio]) : ht(Qr).pipe(z((i) => i.audio !== void 0), Ge(1))).pipe(he(() => {
    E_(t.value).then(() => {
      M0(`${k0.SpeakerOnly}${n ? 1 : 0}`, "", t.value);
    });
  }), Ie(oe));
})), extraEpics1: (e, t) => se(e, gt).pipe(z((r) => {
  var n, o;
  const { payload: { body: i } } = r;
  return !!i.add && !((n = t.value.audio) === null || n === void 0 || (o = n.customizeAudioOption) === null || o === void 0 || !o.speakerOnly);
}), Fr(ri), he(async (r) => {
  const { payload: { body: { add: n } } } = r, o = t.value, { meeting: { userId: i } } = o;
  for (let s = 0; s < n.length; s++) {
    const { id: a } = n[s];
    if (a !== i) {
      await w_(a, t.value);
      const { cmd: { jids: l }, participants: { attendeesList: u } } = t.value;
      l[a] && setTimeout(() => {
        M0(`${k0.SpeakerOnly}1`, l[a].jid, t.value);
      }, Math.floor(Math.random() * Math.log10(u.length) * 1e3));
    }
  }
}), Ie(oe)) }, NP = { epics0: (e, t) => wa(e, 24577).pipe(pe(t), ae((r) => {
  let [n] = r;
  const { payload: { body: { status: o } } } = n;
  return o === C_.SUCCESS && O(dm, ha.Connected), jI(o);
})), epics1: (e, t) => wa(e, 24583).pipe(pe(t), G((r) => {
  let [n, o] = r;
  const { meeting: { userId: i, encType: s }, cmd: { jids: a } } = o, { payload: { body: { senderName: l, senderJid: u, text: d, type: c, receiver: p, msgid: h, sn: v } } } = n, f = dv(a, p), m = s === Nu.AES_GCM, g = dv(a, u), C = (/* @__PURE__ */ new Date()).getTime();
  let b = Promise.resolve({ message: d });
  return m && (b = ir.beginDecrypt({ decryptedText: d, type: mr.XMPP_CHAT, zoomId: v })), b.then((E) => {
    let { message: w } = E;
    if (c === T0.Private && Number(f) === i || c === T0.All) {
      const I = no(w);
      if (I != null && I.startsWith(k0.SpeakerOnly)) {
        const D = I.substring(k0.SpeakerOnly.length), B = Number(D) === 1;
        return cu({ userId: Number(g), key: "isSpeakerOnly", value: B });
      }
      {
        var _;
        const D = g && ((_ = a[g]) === null || _ === void 0 ? void 0 : _.userGuid);
        O(MC, { senderId: g, senderName: l, senderGuid: D, text: I, timestamp: C, msgid: h });
      }
    }
    return "";
  });
}), z((r) => typeof r == "object" && r !== null && r.type !== void 0), he((r) => {
  const { payload: { userId: n, key: o, value: i } } = r;
  O(Mo, [{ userId: n, [`${o}`]: i }]);
})), epics2: (e, t) => wa(e, 24595).pipe(G((r) => {
  const { payload: { body: { action: n, data: o } } } = r, i = [];
  if ([yo.List, yo.Add, yo.update].includes(n) && o) {
    const { breakoutRoom: s, participants: { attendeesList: a } } = t.value, l = (s == null ? void 0 : s.currentRoom.status) === Ee.InRoom ? a.concat(s.mainSessionAttendeeList) : a;
    i.push(xI({ data: o, attendees: l }));
  }
  return n === yo.Remove && o && i.push(VI(o)), ne(i);
})) }, xP = Wr(NP, LP), Yy = (e, t, r, n) => {
  const { getState: o, dispatch: i } = r, s = o(), { participants: { attendeesList: a }, audio: { localShareAudioUserMutedList: l }, share: { isReceiveSharingFromMainSession: u }, breakoutRoom: d } = s, c = (u ? d == null ? void 0 : d.mainSessionAttendeeList : a).find((p) => p.userId == e);
  if (c) {
    if (c.bShareAudioOn) {
      const p = l.find((h) => h.userId === e);
      return p && p.muted === !t && i(Eu(n, e, t, s)), Promise.resolve("");
    }
    return Promise.reject({ type: W, reason: `Cannot ${t ? "mute" : "unmute"} share audio when the user's share audio is not enable.` });
  }
  return Promise.reject({ type: De, reason: "Cannot find the user" });
}, Xy = (e, t) => {
  const { store: { getState: r }, rwgAgent: n } = e, { share: { sharePrivilege: o } } = r();
  return o === t ? Promise.resolve("") : Object.values(vn).includes(t) ? (n.lockSharing(t), Te(um, (i) => i.lockShare === t)) : Promise.reject({ type: De });
}, lc = Mt([ft], (e) => e.filter((t) => t.bVideoOn)), wh = Mt([lc], (e) => e.filter((t) => (t.caps & F2) === F2)), e5 = (e, t) => {
  const r = e.store.getState(), n = gs(r).find((o) => o.userId === t);
  if (n) {
    const { caps: o } = n;
    return ((i) => (512 & i) == 512)(o);
  }
  return !1;
};
var t5, r5, n5, o5, i5, s5, a5, l5, u5, d5, c5, p5, h5, f5, v5, m5, g5, y5, S5, b5, C5, w5, E5, I5, A5, _5, R5, O5, T5, k5, M5, P5, D5, L5, N5, x5, V5, j5, U5, B5, $5, H5, F5, z5, W5, Z5, G5, q5, K5, J5, Q5, Y5, X5, eS, tS, rS, nS, oS, iS, sS, aS, lS, uS, dS, cS, pS, hS, fS, vS, mS, gS, yS, SS, bS, CS, wS, V;
const Jr = nn("Audio"), Wt = nn("Video"), wr = nn("Sharing"), ta = nn("CameraControl"), Uo = nn("Remote Control"), Eh = np(HTMLCanvasElement, 0), VP = np([HTMLCanvasElement, HTMLVideoElement], 0), ES = np(HTMLCanvasElement, 0, ["id"]), IS = np([HTMLCanvasElement, HTMLVideoElement], 0, ["id"]);
let jP = (t5 = de("audio"), r5 = de("audio"), n5 = de("audio"), o5 = de("audio"), i5 = de("audio"), s5 = nn("Audio", [1, 2, 3]), a5 = de("audio"), l5 = nn("Audio", [1, 2]), u5 = de("audio"), d5 = de("audio"), c5 = de("audio"), p5 = de("audio"), h5 = de("share"), f5 = de("audio"), v5 = de("share"), m5 = de("audio"), g5 = de("audio"), y5 = de("audio"), S5 = de("audio"), b5 = de("audio"), C5 = de("audio"), w5 = nn("Audio", [1, 2]), E5 = de("audio"), I5 = nn("Audio", [1, 2]), A5 = de("video"), _5 = de("video"), R5 = de("video"), O5 = de("video"), T5 = de("video"), k5 = de("video"), M5 = de("video"), P5 = de("video"), D5 = de("video"), L5 = de("video"), N5 = de("video"), x5 = de("video"), V5 = de("video"), j5 = de("video"), U5 = de("video"), B5 = de("video"), $5 = de("video"), H5 = de("video"), F5 = de("video"), z5 = de("video"), W5 = de("video"), Z5 = de("video"), G5 = de("video"), q5 = de("video"), K5 = de("video"), J5 = de("video"), Q5 = de("share"), Y5 = de("share"), X5 = de("share"), eS = de("share"), tS = de("share"), rS = de("share"), nS = de("share"), oS = de("share"), iS = gy("isShareOptionLocked"), sS = gy("isShareOptionLocked"), aS = de("share"), lS = de("share"), uS = de("share"), dS = de("share"), cS = de("share"), pS = de("share"), hS = de("share"), fS = de("share"), vS = de("share"), mS = de("share"), gS = de("share"), yS = de("share"), SS = de("share"), bS = de("share"), CS = de("share"), wS = de("share"), V = class extends Po {
  constructor(e) {
    super(e), this[At].dispatch(Kv()), this[J] = { store: e, mediaAgent: rp(Vr(ke.getInstance())), rwgAgent: We.createAgent() };
  }
  startAudio(e) {
    return ((t, r) => {
      const { store: { getState: n, dispatch: o }, rwgAgent: i, mediaAgent: s } = t, a = n(), l = be(a);
      if ((l == null ? void 0 : l.audio) === et.Computer)
        return Promise.resolve("");
      if ((l == null ? void 0 : l.audio) === et.Phone)
        return Promise.reject({ type: W, reason: "joined by phone" });
      {
        const { audio: { isAllowToTalk: u, isComputerAudioLoading: d, canPlayAudio: c, customizeAudioOption: { speakerOnly: p } }, media: { audioDecodeStatus: h, audioEncodeStatus: v } } = a;
        if (d)
          return Promise.reject({ type: W, reason: "Computer audio has been loading, please wait." });
        const f = function(C) {
          const b = C ? { ...C } : void 0;
          if (M7(fr()) || (b == null ? void 0 : b.backgroundNoiseSuppression) !== !0 || (console.warn("Background noise suppression requires SharedArrayBuffer and is only supported on desktop browser"), Object.assign(b, { backgroundNoiseSuppression: void 0 })), (b == null ? void 0 : b.originalSound) !== void 0) {
            b.backgroundNoiseSuppression && b.originalSound && (console.warn("Enabling original sound will disable background noise suppression."), Object.assign(b, { backgroundNoiseSuppression: !1 }));
            const { originalSound: E } = b;
            typeof E == "object" && E.stereo && !P7() && (console.warn("Cannot enable stereo audio on current platform due to the browser limitation"), Object.assign(E, { stereo: !1 }));
          }
          return D7() || (b == null ? void 0 : b.syncButtonsOnHeadset) !== !0 || (console.warn("Sync buttons on headset is not supported on the current platform"), Object.assign(b, { syncButtonsOnHeadset: void 0 })), b != null && b.mediaFile && !ke.isSupportMediaPlaybackAsVideoInput() && (console.warn("Cannot use media file as audio input due to the browser limitation"), Object.assign(b, { mediaFile: void 0 })), b;
        }(r);
        o(Cm(f != null ? f : {}));
        const { speakerOnly: m, autoStartAudioInSafari: g } = f || {};
        if (!!p != !!m && o(cu({ userId: a.meeting.userId, key: "isSpeakerOnly", value: !!m })), !l)
          return Promise.reject({ type: W, reason: "Please call `startAudio` method after the `join` has been resolved" });
        {
          const C = Jt(l.userRole) && !u || m, { encodeInitStatus: b, decodeInitStatus: E } = nv(a, l, m);
          if (Iu() && (E !== "success" || b !== "success"))
            return Promise.reject({ type: W, reason: "It is required to wait for the audio encoding and decoding to be ready before calling `startAudio` method" });
          o(ts(!0)), _r("audio", b, E).subscribe((w) => {
            let [_, I] = w;
            if (_ && I) {
              let D = c || (Iu() || ve.isIOSMobile) && !g ? Promise.resolve() : function() {
                const B = URL.createObjectURL(vO), L = new Audio(B);
                return L.muted = !1, ve.isIOSMobile ? new Promise((R, y) => {
                  var A;
                  L.addEventListener("canplaythrough", () => {
                    L.play().then(() => {
                      R(!0);
                    }).catch((k) => {
                      y(k);
                    }).finally(() => {
                      URL.revokeObjectURL(B);
                    });
                  }), (A = L.load) === null || A === void 0 || A.call(L);
                }) : Promise.race([L.play(), new Promise((R, y) => {
                  window.setTimeout(() => {
                    y();
                  }, 3e3);
                })]).finally(() => {
                  URL.revokeObjectURL(B);
                });
              }();
              D === void 0 && (D = Promise.resolve()), D.then(() => B2("audio", n())).then(() => {
                const B = n(), { audio: { isSharingAudio: L } } = B;
                _0(i, B, C), L && !wo() || Rs(s, B, !C), Jt(l.userRole) && u && o(hf(!0)), o(Za(!0));
              }).catch(() => {
                o(Za(!1)), o(ts(!1));
              });
            } else
              o(ts(!1));
          });
        }
        return v === "failed" || h === "failed" ? (o(ts(!1)), Promise.reject({ type: Eo, reason: "audio encode or decode error" })) : new Promise((C, b) => {
          Vn(ht(ji.JoinComputerAudio.success, 1), Kt(...ji.JoinComputerAudio.fail.map((E) => ht(E, 1).pipe(G(() => cs({ type: Or, reason: E }))))), nr(45e3).pipe(G(() => cs({ type: mm })))).subscribe({ next: () => {
            o(ts(!1)), C("");
          }, error: (E) => {
            ke.getInstance().leaveComputerAudio();
            const w = be(n());
            (w == null ? void 0 : w.audio) !== et.Phone && (o(Ls(uu.MicrophoneError)), i.joinOrLeaveVoip(!1)), o(ts(!1)), b(E);
          } });
        });
      }
    })(this[J], e);
  }
  stopAudio() {
    return (async (e) => {
      const { store: { getState: t, dispatch: r }, mediaAgent: n, rwgAgent: o } = e, i = t(), { audio: { isComputerAudioLoading: s, isShareAudioEnabled: a, isSharingAudio: l, isUsingMediaPlayback: u, customizeAudioOption: { speakerOnly: d } } } = i, c = be(i);
      if (s)
        return Promise.reject({ type: W, reason: "Computer audio has not finished joining, please wait." });
      if (a) {
        if (l && !wo())
          return Promise.reject({ type: W, reason: "Cannot stop audio during sharing with audio" });
        r(Ga(void 0)), r(ei(void 0));
      }
      return (c == null ? void 0 : c.audio) === et.Computer ? (r(Ls(uu.Active)), await n.leaveComputerAudio(), o.joinOrLeaveVoip(!1), d && r(cu({ userId: i.meeting.userId, key: "isSpeakerOnly", value: void 0 })), u && mn.getInstance().stopAudioElement(), r(Uu(0)), Te(du)) : Promise.resolve("");
    })(this[J]);
  }
  muteAudio(e) {
    return ((t, r) => {
      const { store: { getState: n, dispatch: o }, rwgAgent: i, mediaAgent: s } = t, a = n(), l = be(a);
      if (r == null || r === (l == null ? void 0 : l.userId))
        return (l == null ? void 0 : l.audio) === "" || (l == null ? void 0 : l.audio) === null ? Promise.reject({ type: W, reason: "no audio joined" }) : (l == null ? void 0 : l.muted) === !0 ? Promise.resolve("") : (o(zo(Gn.Active)), i.mute(l.userId, !0), s.muteAudio(), a.audio.isShareAudioEnabled && !wo() && o(ei(!0)), Te(pm).then(() => ""));
      if (Sn(a)) {
        const { participants: { allowTalkAttendeesList: u, attendeesList: d } } = a, c = u.concat(d).find((p) => p.userId === r);
        return c ? c.audio === "" || c === null ? Promise.reject({ type: W, reason: "no audio joined" }) : c.muted === !1 ? (i.mute(r, !0), Te(QC, (p) => p.id === r && p.muted == 1)) : Promise.resolve("") : Promise.reject({ type: De, reason: "no matching user" });
      }
      return Promise.reject({ type: Or });
    })(this[J], e);
  }
  unmuteAudio(e) {
    return (async (t, r) => {
      const { store: { getState: n, dispatch: o }, rwgAgent: i, mediaAgent: s } = t, a = n(), l = be(a);
      if (r === void 0 || r === (l == null ? void 0 : l.userId)) {
        if ((l == null ? void 0 : l.audio) === "" || (l == null ? void 0 : l.audio) === null)
          return Promise.reject({ type: W, reason: "no audio joined" });
        if ((l == null ? void 0 : l.muted) === !1)
          return Promise.resolve("");
        if (a.audio.isShareAudioEnabled && !wo()) {
          if (a.audio.isSharingAudio)
            return Promise.reject({ type: W, reason: "Cannot unmute audio during sharing with audio" });
          o(ei(!1));
        }
        if (a.audio.bCanUnmute || l != null && l.isHost || l != null && l.bCoHost) {
          if (Jt(l.userRole)) {
            const { audio: { isAllowToTalk: u, isAllowToTalkAttendeeConnected: d } } = a;
            u ? d || (await s.leaveComputerAudio(), await Rs(s, a, !0), o(hf(!0))) : Promise.reject({ type: W, reason: "Webinar attendee cannot unmute self audio." });
          }
          return o(fu(zl.Active)), i.mute(l.userId, !1), s.unmuteAudio(), Te(hm).then(() => "");
        }
        return Promise.reject({ type: Or, reason: "host not allow unmute themselves" });
      }
      if (Sn(a)) {
        const { participants: { allowTalkAttendeesList: u, attendeesList: d } } = a, c = u.concat(d).find((p) => p.userId === r);
        return c ? c.audio === "" || c === null ? Promise.reject({ type: W, reason: "no audio joined" }) : (c.muted === !0 && i.mute(r, !1), Promise.resolve("")) : Promise.reject({ type: De, reason: "no matching user" });
      }
      return Promise.reject({ type: Or });
    })(this[J], e);
  }
  dialOut(e, t, r, n) {
    return ((o, i, s, a, l) => {
      const { store: { getState: u, dispatch: d }, rwgAgent: c } = o, p = u(), { meeting: { callOutCountry: h, isSupportCallOut: v } } = p;
      if (v && Array.isArray(h) && h.findIndex((f) => f.code === i) > -1) {
        const { seq: f } = c.audioDialout(i + s, a, !(l == null || !l.callMe), !(l == null || !l.pressingOne), !(l == null || !l.greeting));
        return d(cE({ sequence: f, phoneNumber: i + s })), $o(ji.JoinAudioByCallMe);
      }
      return Promise.reject({ type: De, reason: "no matching country code" });
    })(this[J], e, t, r, n);
  }
  cancelDialOut(e, t, r) {
    return ((n, o, i, s) => {
      const { rwgAgent: a } = n;
      return a.audioCancelDialout(o + i, !(s == null || !s.callMe)), $o(ji.cancelDialOut);
    })(this[J], e, t, r);
  }
  hangup() {
    return ((e) => {
      const { store: { getState: t }, rwgAgent: r } = e, n = t(), o = be(n);
      return (o == null ? void 0 : o.audio) === et.Phone && o.userId !== null ? (r.audioDrop(o.userId), $o(ji.hangup)) : Promise.reject({ type: W, reason: "not joined audio by phone" });
    })(this[J]);
  }
  switchMicrophone(e) {
    return ((t, r) => {
      const { store: { getState: n, dispatch: o }, mediaAgent: i } = t, s = n(), { audio: { microphoneDevicesList: a, activeMicrophone: l, mediaPlaybackFile: u, isUsingMediaPlayback: d } } = s, c = a.find((p) => p.deviceId === r);
      if (r === "default" || typeof r != "string" || c) {
        const p = be(s);
        if ((p == null ? void 0 : p.audio) === et.Computer) {
          let h = !1;
          if (typeof r == "string")
            r !== l && (i.changeMicrophone(r, c == null ? void 0 : c.label, !(p == null || !p.muted)), o(vf(void 0)), mn.getInstance().stopAudioElement(), h = !0);
          else if (r && (!d || (u == null ? void 0 : u.url) !== r.url)) {
            const v = mn.getInstance();
            v.setAudioElement(r).then(() => {
              i.changeMicrophone(v.audioElement, void 0, !(p == null || !p.muted)), o(vf(r));
            }), h = !0;
          }
          if (h)
            return $o(ji.JoinComputerAudio);
        } else
          typeof r == "string" && o(hu(r));
        return Promise.resolve("");
      }
      return Promise.reject({ type: T2 });
    })(this[J], e);
  }
  switchSpeaker(e) {
    return ((t, r) => {
      const { store: { getState: n, dispatch: o }, mediaAgent: i } = t, { audio: { speakerDevicesList: s, activeSpeaker: a } } = n();
      if (r !== "default" && s.findIndex((u) => u.deviceId === r) == -1)
        return Promise.reject({ type: T2 });
      var l;
      if (((l = be(n())) === null || l === void 0 ? void 0 : l.audio) === et.Computer) {
        if (r !== a)
          return i.changeSpeaker(r), Te(J1, (u) => u);
      } else
        o(X0(r));
      return Promise.resolve("");
    })(this[J], e);
  }
  muteShareAudio(e) {
    return ((t, r) => {
      const { mediaAgent: n, rwgAgent: o, store: { getState: i, dispatch: s } } = t, a = i(), { meeting: { userId: l } } = a;
      if (r && r !== l)
        return Yy(r, !0, t.store, n);
      {
        const { audio: { isSharingAudio: d, isShareAudioEnabled: c, isShareAudioMuted: p } } = a;
        if (!c)
          return Promise.reject({ type: W, reason: "Cannot mute sharing audio when sharing audio is not enable" });
        if (p)
          return Promise.resolve("");
        {
          o.muteShareAudio(!0);
          let h = Promise.resolve();
          var u;
          return d && (h = (u = n.leaveSharingAudio(!0)) === null || u === void 0 ? void 0 : u.then(() => Ym(n, o, a).then((v) => {
            v.forEach((f) => s(f));
          }))), Eu(n, l, !0, a), Promise.all([Te({ event: Qr, operations: [z((v) => v.bShareAudioOn !== void 0), Ge(1)] }, (v) => v.bShareAudioOn === !1), h]).then(() => (s($c(!0)), d && (s(qa(!1)), O(za, { state: "off" })), ""));
        }
      }
    })(this[J], e);
  }
  unmuteShareAudio(e) {
    return ((t, r) => {
      const { mediaAgent: n, rwgAgent: o, store: { getState: i, dispatch: s } } = t, a = i(), { meeting: { userId: l } } = a;
      if (r && r !== l)
        return Yy(r, !1, t.store, n);
      {
        const { audio: { isSharingAudio: u, isShareAudioEnabled: d, isShareAudioMuted: c }, share: { status: p } } = a;
        if (!d)
          return Promise.reject({ type: W, reason: "Cannot unmute sharing audio when sharing audio is not enable" });
        if (c === !1)
          return Promise.resolve("");
        {
          o.muteShareAudio(!1);
          let h = Promise.resolve();
          return u === !1 && p === Fe.Sharing && (h = rv(n, o, a).then((v) => {
            v.forEach((f) => s(f));
          })), Eu(n, l, !1, a), Promise.all([Te({ event: Qr, operations: [z((v) => v.bShareAudioOn !== void 0), Ge(1)] }, (v) => v.bShareAudioOn === !0), h]).then(() => (s($c(!1)), u === !1 && p === Fe.Sharing && (s(qa(!0)), O(za, { state: "on" })), ""));
        }
      }
    })(this[J], e);
  }
  subscribeAudioStatisticData(e) {
    return (async (t, r) => {
      const { mediaAgent: n, store: { getState: o } } = t, i = o(), s = be(i), a = !r || r.decode, l = !r || r.encode;
      if (!s)
        return Promise.reject({ type: W, reason: "Call this function after the 'join' method resolved." });
      {
        const { encodeInitStatus: u, decodeInitStatus: d } = nv(i, s);
        _r("audio", u, d).subscribe((c) => {
          let [p, h] = c;
          p && h && (a && n.subscribeToQos([ur.AudioDecode], fi), l && n.subscribeToQos([ur.AudioEncode], fi));
        });
      }
      return "";
    })(this[J], e);
  }
  unsubscribeAudioStatisticData(e) {
    return (async (t, r) => {
      const { mediaAgent: n, store: { dispatch: o } } = t, i = !r || r.decode, s = !r || r.encode;
      return i && (n.unsubscribeFromQos([ur.AudioDecode]), o(Hc(Mc))), s && (n.unsubscribeFromQos([ur.AudioEncode]), o(Fc(Mc))), null;
    })(this[J], e);
  }
  enableBackgroundNoiseSuppression(e) {
    return ((t, r) => {
      const { mediaAgent: n, store: { getState: o, dispatch: i } } = t, { audio: { isBackgroundNoiseSuppression: s, originalSound: a } } = o();
      let l = r;
      return l === !!s || (l && !M7(fr()) ? (console.warn("Background noise suppression requires SharedArrayBuffer and is only supported on desktop browser"), l = !1) : (l && a && (console.warn("Enabling noise suppression will disable original sound."), i(gf(!1))), i(ff(l)), n.changeAudioProfile(tv(o())))), Promise.resolve("");
    })(this[J], e);
  }
  enableSyncButtonsOnHeadset(e) {
    return ((t, r) => {
      const { mediaAgent: n, store: { getState: o, dispatch: i } } = t, s = o(), { audio: { isHIDEnabled: a, microphoneDevicesList: l, activeMicrophone: u } } = s;
      if (r === !!a)
        return Promise.resolve("");
      {
        const c = be(s);
        var d;
        return c ? (r && !D7() ? console.warn("Sync buttons on headset is not supported on the current platform") : (n.enableSyncButtonsOnHeadset(r, (d = l.find((p) => p.deviceId === u)) === null || d === void 0 ? void 0 : d.label, c.muted), i(IE(r))), Promise.resolve("")) : Promise.reject({ type: W, reason: "Please call `enableSyncButtonsOnHeadset` method after the `join` has been resolved" });
      }
    })(this[J], e);
  }
  enableOriginalSound(e) {
    return ((t, r) => {
      const { mediaAgent: n, store: { getState: o, dispatch: i } } = t, { audio: { isBackgroundNoiseSuppression: s, originalSound: a } } = o(), l = r;
      return l === a || typeof r == "object" && Lu(r, a) || (typeof l != "object" || (l == null ? void 0 : l.stereo) !== !0 || P7() || (console.warn("Cannot enable stereo audio on current platform due to the browser limitation"), l.stereo = !1), s && l && (console.warn("Enabling original sound will disable background noise suppression."), i(ff(!1))), i(gf(l)), n.changeAudioProfile(tv(o()))), Promise.resolve("");
    })(this[J], e);
  }
  callCRCDevice(e, t) {
    return ((r, n, o) => {
      const { rwgAgent: i, store: { dispatch: s, getState: a } } = r, { seq: l } = i.inviteCRCDevice(n, o);
      return s(_E({ sequence: l, ip: n, protocol: o })), $o(ji.crcCallOut).then(() => {
        var u;
        const { audio: { crcDevice: d } } = a();
        return (u = d.find((c) => c.ip === n && c.protocol === o && c.sequence === l)) === null || u === void 0 ? void 0 : u.uuid;
      });
    })(this[J], e, t);
  }
  cancelCallCRCDevice(e, t) {
    return ((r, n, o) => {
      const { rwgAgent: i, store: { getState: s } } = r, { audio: { crcDevice: a } } = s(), l = a.find((u) => u.ip === n && u.protocol === o);
      return l && l.returnCode === xd.Ringing ? (i.cancelInviteCRCDevice(l.transId), Promise.resolve("")) : Promise.reject({ type: W, reason: "Cannot cancel call out " });
    })(this[J], e, t);
  }
  getMicList() {
    return ((e) => {
      let { store: { getState: t } } = e;
      const r = t();
      return r.audio ? [...r.audio.microphoneDevicesList] : [];
    })(this[J]);
  }
  getSpeakerList() {
    return ((e) => {
      let { store: { getState: t } } = e;
      const r = t();
      return r.audio ? [...r.audio.speakerDevicesList] : [];
    })(this[J]);
  }
  getAudioState(e) {
    return ((t, r) => {
      let { store: { getState: n } } = t;
      const o = n(), { meeting: { isWebinar: i } } = o;
      let s = null;
      return r == null ? s = be(o) : (s = o.participants.attendeesList.find((a) => a.userId === r), i && !s && (s = o.participants.xmppAttendeeList.find((a) => a.userId === r))), s ? s.audio : null;
    })(this[J], e);
  }
  isAudioMuted(e) {
    return ((t, r) => {
      let { store: { getState: n } } = t;
      const o = n(), { meeting: { isWebinar: i } } = o;
      let s = null;
      return r === void 0 ? s = be(o) : (s = o.participants.attendeesList.find((a) => a.userId === r), i && !s && (s = o.participants.xmppAttendeeList.find((a) => a.userId === r))), !!s && !!s.muted;
    })(this[J], e);
  }
  getActiveMicrophone() {
    return ((e) => {
      let { store: { getState: t } } = e;
      const r = t();
      return r.audio ? r.audio.activeMicrophone : null;
    })(this[J]);
  }
  getActiveSpeaker() {
    return ((e) => {
      let { store: { getState: t } } = e;
      const r = t();
      return r.audio ? r.audio.activeSpeaker : null;
    })(this[J]);
  }
  isSupportCallOut() {
    return ((e) => {
      let { store: { getState: t } } = e;
      const { meeting: { isSupportCallOut: r, callOutCountry: n } } = t();
      return r && Array.isArray(n) && (n == null ? void 0 : n.length) > 0;
    })(this[J]);
  }
  getDialOutStatus() {
    return ((e) => {
      let { store: { getState: t } } = e;
      const { audio: r } = t();
      return r == null ? void 0 : r.dialout[r.dialout.length - 1].returnCode;
    })(this[J]);
  }
  getDialOutCountries() {
    return ((e) => {
      let { store: { getState: t } } = e;
      const { meeting: { callOutCountry: r } } = t();
      return Array.isArray(r) ? r : [];
    })(this[J]);
  }
  getShareAudioStatus() {
    return ((e) => {
      let { store: { getState: t } } = e;
      const { audio: { isShareAudioEnabled: r, isShareAudioMuted: n, isSharingAudio: o } } = t();
      return { isShareAudioEnabled: r, isShareAudioMuted: n, isSharingAudio: o };
    })(this[J]);
  }
  isOthersShareAudioMutedLocally(e) {
    return ((t, r) => {
      var n;
      let { store: { getState: o } } = t;
      const { audio: { localShareAudioUserMutedList: i } } = o();
      return (n = i.find((s) => s.userId === r)) === null || n === void 0 ? void 0 : n.muted;
    })(this[J], e);
  }
  getAudioStatisticData() {
    return ((e) => {
      let { store: { getState: t } } = e;
      const { audio: { statistic: r } } = t();
      return { ...r };
    })(this[J]);
  }
  getDialInInfo() {
    return ((e) => {
      let { store: { getState: t } } = e;
      const { meeting: { meetingNumber: r, tollNumbers: n, participantID: o, h323Password: i } } = t();
      return n === void 0 ? null : { meetingId: r, participantId: o, password: i || "", tollNumbers: n.map((s) => ({ ...s })) };
    })(this[J]);
  }
  isSupportMicrophoneAndShareAudioSimultaneously() {
    return wo();
  }
  startVideo(e) {
    return ((t, r) => {
      const { store: { getState: n, dispatch: o }, mediaAgent: i } = t, s = n(), { media: { videoDecodeStatus: a, videoEncodeStatus: l, enforceVirtualBackground: u }, video: { isCaptureCameraLoading: d, isCurrentUserStartedVideo: c, isVideoMuted: p } } = s, h = r ? { ...r } : void 0;
      if (c)
        return Promise.reject({ type: W, reason: "Video is started" });
      if (d)
        return Promise.reject({ type: W, reason: "Camera is starting,please wait." });
      if (p && !Sn(s))
        return Promise.reject({ type: W, reason: "Video is muted by the host" });
      if (Sl(u) && !((h == null ? void 0 : h.videoElement) instanceof HTMLVideoElement)) {
        console.warn('Rendering self-view on Chromium browser, Android browser without SharedArrayBuffer or iOS browser requires video tag, Please pass a video element instead of a canvas element in the "renderVideo" method');
        let v = document.body.querySelector(`#${Mp}`);
        if (!v) {
          v = document.createElement("video");
          const f = ve.isSafari || ve.isIOSMobile ? "position:fixed;top:-10000px;left:-10000px" : "display:none";
          v.setAttribute("style", f), v.muted = !0, v.playsInline = !0, v.autoplay = !0, v.id = Mp, document.body.appendChild(v);
        }
        h && Object.assign(h, { videoElement: v });
      }
      return !zf(u) && h != null && h.virtualBackground ? Promise.reject({ type: De, reason: "Virtual background only compatible with Chrome and Edge with SharedArrayBuffer enabled." }) : (o(Vl(!0)), _r("video", l, a).subscribe((v) => {
        let [f] = v;
        if (f) {
          const m = n(), { video: { activeCamera: g, isSupportHDVideo: C, virtualBackground: { imageSrc: b }, mask: { imageSrc: E } } } = m, { cameraId: w = g, captureWidth: _ = 0, captureHeight: I = 0, mirrored: D, hd: B, fullHd: L, virtualBackground: R, mask: y } = h || {};
          D && i.mirrorVideo(D), (B || L) && (console.log("HD support is currently limited, and comes with a number of restrictions and limitations. Please visit https://developers.zoom.us/docs/video-sdk/web/video/#720p-video for more details"), C && ke.isCompatibleHardwareForEncode() && ke.isSupportVideoEncodeHardwareAcceleration().then((N) => {
            N && (i.enableHardwareAccelerationForVideoEncode(!0), o(ia({ encode: N })));
          }), C || console.warn("Cannot capture HD video due to either account restriction and/or hardware limitation"));
          const A = R || R === void 0 && !!b && y === void 0, k = y || y === void 0 && !!E;
          let T = Promise.resolve({});
          if (A) {
            const N = R || { imageUrl: void 0, cropped: void 0 };
            T = nc({ ...N, captureWidth: _, captureHeight: I, cameraId: w, hd: B }, i, m).then(() => N);
          } else if (k) {
            const N = y || { imageUrl: void 0, cropped: void 0, clip: void 0, rootWidth: void 0, rootHeight: void 0 };
            N.rootWidth || Object.assign(N, { rootWidth: 1280 }), N.rootHeight || Object.assign(N, { rootHeight: 720 }), T = oc({ ...N, captureWidth: _, captureHeight: I, cameraId: w, hd: B }, i, m).then(() => N);
          }
          h != null && h.mediaFile && !ke.isSupportMediaPlaybackAsVideoInput() && (console.warn("Cannot use media file as video input due to the browser limitation."), Object.assign(h, { mediaFile: void 0 })), T.then((N) => B2("video", n()).then(() => N)).then((N) => {
            o_(i, m, h).forEach((F) => {
              o(F);
            }), A ? o(Zd(N)) : k && o(Gd(N));
          }).catch((N) => {
            o(Vl(!1)), O(UC, { reason: N });
          });
        } else
          o(Vl(!1));
      }), $o(O2.startCaptureVideo).then(() => {
        o(Qc(!1)), o(Jc(!1));
      }).finally(() => {
        o(Vl(!1));
      }));
    })(this[J], e);
  }
  stopVideo() {
    return ((e) => {
      const { store: { getState: t }, mediaAgent: r } = e, { video: { isCaptureCameraLoading: n, isCurrentUserStartedVideo: o, isUsingMediaPlayback: i } } = t();
      return n ? Promise.reject({ type: W, reason: "Camera is starting,please wait." }) : o ? (r.stopCaptureVideo(), i && mn.getInstance().stopVideoElement(), Te(ws, (s) => (s == null ? void 0 : s.failed) !== !0)) : Promise.reject({ type: W, reason: "camera is closed" });
    })(this[J]);
  }
  switchCamera(e) {
    return ((t, r) => {
      const { store: { getState: n, dispatch: o }, mediaAgent: i } = t, s = n(), { video: { cameraDevicesList: a, isCurrentUserStartedVideo: l, virtualBackground: u, mask: d, mediaPlaybackFile: c, isUsingMediaPlayback: p, customizedVideoOption: h } } = s;
      if (typeof r == "string" && !n_(r, a))
        return Promise.reject({ type: De, reason: "Cannot find cameraDeviceId in camera devices list." });
      if (l || u != null && u.isVBConfigured || d.isMaskConfigured) {
        if (typeof r == "string") {
          const { captureWidth: v, captureHeight: f } = eg(h);
          i.changeCamera(r, { width: v, height: f }), o(Tf(void 0)), mn.getInstance().stopVideoElement();
        } else if (r && (!p || (c == null ? void 0 : c.url) !== r.url)) {
          const v = mn.getInstance();
          v.setVideoElement(r).then(() => {
            i.changeCamera(v.videoElement), o(Tf(r));
          });
        }
        return $o(O2.switchCameraVideo).then(() => {
          o(Qc(!1)), o(Jc(!1));
        });
      }
      return Promise.resolve();
    })(this[J], e);
  }
  renderVideo(e, t, r, n, o, i, s, a, l) {
    return ((u, d, c, p, h, v, f, m, g, C) => {
      const { store: { getState: b, dispatch: E }, mediaAgent: w, rwgAgent: _ } = u, I = b(), { meeting: { userId: D }, media: { enforceMultipleVideos: B, enforceVirtualBackground: L, disableRenderLimits: R }, video: { subscribedVideoList: y, renderedVideoList: A } } = I, k = Ia(!!B, R), T = Sl(L) && c === D;
      if (d instanceof HTMLCanvasElement && !y.includes(c) && y.length >= k && new Set(A.map(($) => $.canvasId)).has(d.id))
        return Promise.reject({ type: W, reason: `subscribe video counts greater than maximum size (${k})` });
      if (lc(I).findIndex(($) => $.userId === c) === -1)
        return Promise.reject({ type: De, reason: "user is not send video" });
      if (d.id || (d.id = Qo("__ZOOM_SDK_VIDEO_CANVAS_@__")), T) {
        if (d instanceof HTMLVideoElement) {
          d.playsInline = !0, d.muted = !0, d.autoplay = !0, ve.isIOSMobile && w.switchCanvasForVideoCapture(d), w.renderVideo(d, c, g || Yi, p, h, v, f, m, !0, C || "", !1), E(zd(c));
          const $ = document.querySelector(`#${Mp}`);
          return $ && $.remove(), Promise.resolve("");
        }
        return Promise.reject({ type: De, reason: "You must use a <video> element to render self video for Chromium browser, Android browser without SharedArrayBuffer or iOS browser " });
      }
      const N = !!C, { media: { videoDecodeStatus: F } } = I;
      return _r("video", "success", F).subscribe(async ($) => {
        let [re, fe] = $;
        if (fe) {
          const { video: { ensuredCanvas: le, renderedVideoList: Ae } } = b();
          let Re = d;
          le.includes(d.id) || (Re = Xd(d), E(oI(d.id)));
          const Se = c === D, [ye, Oe] = iy(c, m, b()), Ue = g || Yi, Ve = await async function(U, j) {
            const { video: { prefetchedVideo: P } } = j;
            return (P == null ? void 0 : P.userId) !== U || P.loaded ? "" : gr(Vn(ht(GC, 1), nr(1e3).pipe(tn(""))));
          }(c, b());
          Ae.some((U) => U.userId === c && U.key === Ue && U.canvasId === Re.id) || w.renderVideo(Re, c, Ue, p, h, v, f, Oe, Se, C || "", N), c !== D && _.subscribeVideo(c, Oe, !1), y.includes(c) || E(zd(c)), Ve && E(Ta(void 0)), E(Oa({ userId: c, key: Ue, canvasId: Re.id, videoQuality: ye, aspectRatio: h ? p / h : 0 }));
        }
      }), F === "failed" ? Promise.reject({ type: Eo, reason: "Video  decode status is failed" }) : Promise.resolve("");
    })(this[J], e, t, r, n, o, i, s, a, l);
  }
  stopRenderVideo(e, t, r, n) {
    let o = arguments.length > 4 && arguments[4] !== void 0 && arguments[4], i = arguments.length > 5 ? arguments[5] : void 0;
    return function(s, a, l, u, d) {
      let c = arguments.length > 5 && arguments[5] !== void 0 && arguments[5], p = arguments.length > 6 ? arguments[6] : void 0;
      const { store: { getState: h, dispatch: v }, mediaAgent: f, rwgAgent: m } = s, g = h(), { video: { subscribedVideoList: C, renderedVideoList: b }, meeting: { userId: E }, media: { enforceVirtualBackground: w } } = g;
      if (C.includes(l)) {
        const _ = u || Yi;
        if (Sl(w) && l === E && a instanceof HTMLVideoElement)
          return a.pause(), v(Wd(l)), Promise.resolve("");
        if (b.find((I) => I.userId === l && I.key === _ && I.canvasId === a.id) && (f.stopRenderVideo(a.id, l, _, ch(d), c), b.filter((I) => I.userId === l).length == 1 && (l !== E && m.unsubscribeVideo(l), v(Wd(l))), v(Yc({ userId: l, key: _, canvasId: a.id }))), p) {
          const { video: { subscribedVideoList: I, prefetchedVideo: D } } = h();
          lc(g).find((B) => B.userId === p) && !I.includes(p) && (D == null ? void 0 : D.userId) !== p && v(Ta({ userId: p, lastCopy: D }));
        }
      }
      return Promise.resolve("");
    }(this[J], e, t, r, n, o, i);
  }
  updateVideoCanvasDimension(e, t, r) {
    return ((n, o, i, s) => {
      const { mediaAgent: a } = n;
      return a.updateRenderedVideoCanvasDimension(o.id, i, s), Promise.resolve("");
    })(this[J], e, t, r);
  }
  adjustRenderedVideoPosition(e, t, r, n, o, i, s) {
    return ((a, l, u, d, c, p, h, v) => {
      const { store: { getState: f, dispatch: m }, mediaAgent: g } = a, { video: { subscribedVideoList: C } } = f();
      if (C.includes(u)) {
        if (l instanceof HTMLVideoElement)
          return Promise.resolve("");
        const b = v || Yi;
        g.adjustRenderedVideoPosition(l.id, u, b, p, h, d, c, ch("#000")), m(Oa({ userId: u, key: b, canvasId: l.id, aspectRatio: c ? d / c : 0 }));
      } else
        console.warn("Cannot adjust the size or position of the video as the video has not been rendered yet.");
      return Promise.resolve("");
    })(this[J], e, t, r, n, o, i, s);
  }
  clearVideoCanvas(e, t) {
    return ((r, n, o) => {
      const { mediaAgent: i } = r;
      return i.clearVideoCanvas(n.id, ch(o)), Promise.resolve("");
    })(this[J], e, t);
  }
  mirrorVideo(e) {
    return ((t, r) => {
      const { store: { getState: n }, mediaAgent: o } = t, { video: { isCurrentUserStartedVideo: i, virtualBackground: s } } = n();
      return (i || s != null && s.isVBConfigured) && o.mirrorVideo(r), Promise.resolve("");
    })(this[J], e);
  }
  enableHardwareAcceleration(e) {
    return ((t, r) => {
      const { store: { getState: n, dispatch: o }, mediaAgent: i } = t, { video: { isSupportHDVideo: s } } = n();
      if (typeof r == "boolean" || r.decode !== void 0) {
        const a = typeof r == "boolean" ? r : !!r.decode;
        return a ? ke.isSupportVideoDecodeHardwareAcceleration().then((l) => (l && i.enableHardwareAccelerationForVideoDecode(l), o(ia({ decode: l })), l)) : (i.enableHardwareAccelerationForVideoDecode(a), o(ia({ decode: a })), Promise.resolve(!0));
      }
      if (typeof r == "boolean" || r.encode !== void 0) {
        const a = typeof r == "boolean" ? r : !!r.encode;
        if (s) {
          if (!a)
            return i.enableHardwareAccelerationForVideoEncode(!1), o(ia({ encode: !1 })), Promise.resolve(!0);
          if (ke.isCompatibleHardwareForEncode())
            return ke.isSupportVideoEncodeHardwareAcceleration().then((l) => (l && i.enableHardwareAccelerationForVideoEncode(l), o(ia({ encode: l })), l));
          console.warn("Can not turn on hardware acceleration with your graphic card due to the technical limitation");
        } else
          typeof r != "boolean" && r != null && r.encode && console.warn("Can not use the hardware acceleration for video encoding due to the account restriction");
      }
      return Promise.resolve(!1);
    })(this[J], e);
  }
  subscribeVideoStatisticData(e) {
    return (async (t, r) => {
      const { mediaAgent: n, store: { getState: o, dispatch: i } } = t, { media: { videoDecodeStatus: s, videoEncodeStatus: a }, video: { subscriptionStatus: l } } = o(), u = !r || r.decode, d = !r || r.encode;
      return _r("video", a, s).subscribe((c) => {
        let [p, h] = c;
        const v = {};
        u && h && !l.decode && (n.subscribeToQos([ur.VideoDecode], fi), Object.assign(v, { decode: !0 })), d && p && !l.encode && (n.subscribeToQos([ur.VideoEncode], fi), Object.assign(v, { encode: !0 })), r != null && r.detailed && h && !l.detailed && (n.enableVideoObserver(!0), Object.assign(v, { detailed: !0 })), i(kf(v));
      }), null;
    })(this[J], e);
  }
  unsubscribeVideoStatisticData(e) {
    return (async (t, r) => {
      const { mediaAgent: n, store: { dispatch: o } } = t, i = !r || r.decode, s = !r || r.encode, a = {};
      return i && (n.unsubscribeFromQos([ur.VideoDecode]), o(e0(Ri)), Object.assign(a, { decode: !1 })), s && (n.unsubscribeFromQos([ur.VideoEncode]), o(t0(Ri)), Object.assign(a, { encode: !1 })), r != null && r.detailed && (n.enableVideoObserver(!1), Object.assign(a, { detailed: !1 })), o(kf(a)), null;
    })(this[J], e);
  }
  previewVirtualBackground(e, t, r, n) {
    return ((o, i, s, a, l) => {
      const { store: { getState: u, dispatch: d }, mediaAgent: c } = o, p = u();
      return nc({ imageUrl: s, cropped: a, cameraId: l }, c, p, i).then((h) => (typeof h == "object" && h != null && h.type && d(h), d(Zd({ imageUrl: s, cropped: a })), !0)).catch((h) => Promise.reject({ type: W, reason: h }));
    })(this[J], e, t, r, n);
  }
  updateVirtualBackgroundImage(e, t) {
    return ((r, n, o) => {
      const { store: { getState: i, dispatch: s }, mediaAgent: a } = r, l = i(), { video: { virtualBackground: { imageSrc: u, cropped: d }, backgroundMode: c } } = l;
      return n === u && o === d ? Promise.resolve(!0) : c === oo.Mask ? Promise.reject({ type: W, reason: "Cannot update virtual background in the mask mode" }) : nc({ imageUrl: n, cropped: o }, a, l).then((p) => (typeof p == "object" && p != null && p.type && s(p), s(Zd({ imageUrl: n, cropped: o })), !0)).catch((p) => Promise.reject({ type: W, reason: p }));
    })(this[J], e, t);
  }
  stopPreviewVirtualBackground() {
    return ((e) => {
      const { store: { getState: t }, mediaAgent: r } = e, { video: { virtualBackground: { isVBConfigured: n } } } = t();
      return n ? (r.stopVirtualBackgroundSetting(), Promise.resolve(!0)) : Promise.reject({ type: W, reason: "Cannot stop preview virtual background before start" });
    })(this[J]);
  }
  previewVideoMask(e, t) {
    return ((r, n, o) => {
      const { store: { getState: i, dispatch: s }, mediaAgent: a } = r, l = i();
      return o.rootWidth && o.rootHeight || Object.assign(o, { rootWidth: n.width, rootHeight: n.height }), oc(o, a, l, n).then((u) => (typeof u == "object" && u != null && u.type && s(u), s(Gd(o)), !0)).catch((u) => Promise.reject({ type: W, reason: u }));
    })(this[J], e, t);
  }
  updateVideoMask(e) {
    return ((t, r) => {
      const { store: { getState: n, dispatch: o }, mediaAgent: i } = t, s = n(), { video: { mask: a, backgroundMode: l } } = s, { isMaskConfigured: u } = a;
      if (l === oo.VirtualBackground)
        return Promise.reject({ type: W, reason: "Cannot update mask in the virtual background mode" });
      if (u) {
        const d = { ...r };
        return ["imageUrl", "cropped", "clip", "rootHeight", "rootWidth"].forEach((c) => {
          (r == null ? void 0 : r[c]) === void 0 && (c === "imageUrl" ? Object.assign(d, { imageUrl: a.imageSrc }) : Object.assign(d, { [`${c}`]: a[c] }));
        }), oc(d, i, s).then((c) => (typeof c == "object" && c != null && c.type && o(c), o(Gd(d)), !0)).catch((c) => Promise.reject({ type: W, reason: c }));
      }
      return Promise.reject({ type: W, reason: "Cannot update mask" });
    })(this[J], e);
  }
  stopPreviewVideoMask() {
    return ((e) => {
      const { store: { getState: t }, mediaAgent: r } = e, { video: { mask: { isMaskConfigured: n } } } = t();
      return n ? (r.stopMaskSetting(), Promise.resolve(!0)) : Promise.reject({ type: W, reason: "Cannot stop preview mask before start" });
    })(this[J]);
  }
  requestFarEndCameraControl(e) {
    return ((t, r) => {
      const { store: { getState: n }, rwgAgent: o } = t, i = n(), { meeting: { userId: s }, video: { farEndCameraControlStatus: { controlledUserList: a } } } = i;
      return s === r ? Promise.reject({ type: W, reason: 'Using "stream.controlCamera" method to control self camera' }) : wh(i).findIndex((l) => l.userId === r) !== -1 ? (a.includes(r) || o.sendFarEndCameraControl(Lr.Request, r), Promise.resolve("")) : Promise.reject({ type: De, reason: "Cannot request control camera with video off" });
    })(this[J], e);
  }
  approveFarEndCameraControl(e) {
    return ((t, r) => {
      const { store: { getState: n, dispatch: o }, rwgAgent: i } = t, { video: { currentCameraControlStatus: { isRequested: s, isInControl: a, controllingUserId: l }, ptz: u, activeCamera: d } } = n();
      if (s) {
        if (a && (!l || r === l))
          return Promise.resolve("");
        i.sendFarEndCameraControl(Lr.Approve, r);
        const c = u == null ? void 0 : u[d];
        return c !== void 0 && i.sendCameraAblity({ pan: !!c.pan, tilt: !!c.tilt, zoom: !!c.zoom }), o(r0(!1)), o(n0({ isInControl: !0, userId: r })), O(Nc, { isControlled: !0, userId: r }), Promise.resolve("");
      }
      return Promise.reject({ type: W, reason: "Cannot approve before request" });
    })(this[J], e);
  }
  declineFarEndCameraControl(e) {
    return ((t, r) => {
      const { store: { getState: n, dispatch: o }, rwgAgent: i } = t, { video: { currentCameraControlStatus: { isInControl: s, isRequested: a } } } = n();
      return a || s ? (i.sendFarEndCameraControl(Lr.Decline, r), o(r0(!1)), o(n0({ isInControl: !1, userId: 0 })), O(Nc, { isControlled: !1 }), Promise.resolve("")) : Promise.reject({ type: W, reason: "Cannot decline before request" });
    })(this[J], e);
  }
  giveUpFarEndCameraControl(e) {
    return ((t, r) => {
      const { store: { getState: n, dispatch: o }, rwgAgent: i } = t, { video: { farEndCameraControlStatus: { controlledUserList: s } } } = n();
      return s.includes(r) ? (i.sendFarEndCameraControl(Lr.GiveUp, r), o(o0(r)), Promise.resolve("")) : Promise.reject({ type: W, reason: "Cannot give up control befire aquired" });
    })(this[J], e);
  }
  controlCamera(e) {
    return ((t, r) => {
      const { store: { getState: n, dispatch: o }, mediaAgent: i } = t, { video: { isCurrentUserStartedVideo: s, ptz: a, activeCamera: l } } = n();
      if (s) {
        const { cmd: u, range: d, reset: c } = r, p = a[l];
        if (p) {
          const h = tg(p) || {}, { key: v, range: f } = s_(u, d);
          if (p[v])
            return Object.assign(h, { [v]: c ? 0 : i_(p[v].capability, p[v].value, f) }), i.movePTZCamera(h).then(() => {
              o(Rm({ constraints: h, deviceId: l }));
            }).catch((m) => Promise.reject({ type: W, reason: m }));
        }
        return Promise.resolve("");
      }
      return Promise.reject({ type: W, reason: "Cannot control the camera before it's started" });
    })(this[J], e);
  }
  controlFarEndCamera(e) {
    return ((t, r) => {
      const { store: { getState: n, dispatch: o }, rwgAgent: i } = t, s = n(), { video: { farEndCameraControlStatus: { controlledUserList: a, isControlling: l } } } = s, { userId: u, cmd: d, range: c } = r;
      if (l)
        return Promise.reject({ type: W, reason: "Cannot send new command while the previous control is not done" });
      if (a.includes(u)) {
        if (d === vi.SwitchCamera)
          return i.sendFarEndCameraControl(Lr.SwitchCamera, u, vi.SwitchCamera), Promise.resolve("");
        {
          const p = wh(s).find((h) => h.userId === u);
          if (p == null || !p.nFECC)
            return Promise.reject({ type: W, reason: "The far end camera does not support PTZ" });
          if (c && c > 0) {
            const h = c / 100 * 1e4;
            return i.sendFarEndCameraControl(Lr.StartControl, u, d), o(Of(!0)), ps(200).pipe(da(nr(h - 100))).subscribe(() => {
              i.sendFarEndCameraControl(Lr.ContinueControl, u, d);
            }), gr(nr(h).pipe(he(() => {
              i.sendFarEndCameraControl(Lr.StopControl, u, d), o(Of(!1));
            }))).then(() => "");
          }
          return Promise.reject({ type: De, reason: "Range cannot be negative or 0" });
        }
      }
      return Promise.reject({ type: W, reason: "Cannot control before request granted" });
    })(this[J], e);
  }
  attachVideo(e, t, r) {
    return ((n, o, i, s) => {
      const { store: { getState: a, dispatch: l }, rwgAgent: u } = n, d = a(), { meeting: { userId: c }, media: { enforceMultipleVideos: p, alternativeNameForVideoPlayer: h, enforceVirtualBackground: v, disableRenderLimits: f }, video: { videoAttachments: m, subscribedVideoList: g } } = d, C = Ia(!!p, f);
      if (C > 1 && g.length > C)
        throw Promise.reject({ type: W, reason: `subscribe video counts greater than maximum size (${C})` });
      if (lc(d).findIndex((L) => L.userId === o) === -1)
        return Promise.reject({ type: De, reason: "user is not send video" });
      const { media: { videoDecodeStatus: b } } = d;
      let E;
      const w = h != null ? h : "video-player";
      if (s) {
        var _, I, D;
        if (typeof s == "string") {
          if (E = document.querySelector(s), !E)
            return Promise.reject({ type: "INVALID_PARAMETERS", reason: "Cannot find the element" });
        } else
          E = s;
        if (((_ = E) === null || _ === void 0 || (I = _.tagName) === null || I === void 0 ? void 0 : I.toUpperCase()) !== w.toUpperCase())
          return Promise.reject({ type: "INVALID_PARAMETERS", reason: "Invalid element type" });
        const L = Number((D = E.getAttribute("node-id")) !== null && D !== void 0 ? D : "0");
        if (L !== o && Sl(v) && [L, o].includes(c)) {
          var B;
          const R = document.createElement(w);
          for (const y of E.attributes)
            R.setAttribute(y.name, y.value);
          L && (E.setAttribute("node-id", "0"), l(qd({ userId: L, element: E }))), (B = E.parentElement) === null || B === void 0 || B.replaceChild(R, E), E = R;
        }
      } else
        E = document.createElement(w);
      return _r("video", "success", b).subscribe(async (L) => {
        let [R, y] = L;
        if (y) {
          const [k, T] = iy(o, i, a()), N = m[`${o}`];
          var A;
          E && N && N.findIndex((F) => F === E) !== -1 ? E.setAttribute("video-quality", `${T}`) : (A = E) === null || A === void 0 || A.setAttribute("node-id", `${o}`), l(sI({ userId: o, element: E })), o !== c && u.subscribeVideo(o, T, !1), g.includes(o) || l(zd(o)), l(Oa({ userId: o, key: Yi, canvasId: Wl, videoQuality: k, aspectRatio: 16 / 9 }));
        }
      }), Promise.resolve(E);
    })(this[J], e, t, r);
  }
  detachVideo(e, t) {
    return ((r, n, o) => {
      const { store: { getState: i, dispatch: s }, rwgAgent: a } = r, l = i(), { video: { subscribedVideoList: u, videoAttachments: d }, meeting: { userId: c }, media: { alternativeNameForVideoPlayer: p } } = l;
      if (u.includes(n)) {
        let m;
        const g = p != null ? p : "video-player";
        var h, v;
        o && (m = typeof o == "string" ? document.querySelector(o) : o, ((h = m) === null || h === void 0 || (v = h.tagName) === null || v === void 0 ? void 0 : v.toUpperCase()) !== g.toUpperCase() && (m = void 0));
        const C = d[`${n}`];
        let b;
        if (C && C.length !== 0) {
          var f;
          m ? C.findIndex((_) => _ === m) !== -1 ? (b = m, b.setAttribute("node-id", "0"), s(qd({ userId: n, element: b }))) : console.warn(`${o} has not been attached with userID:${n}`) : (b = [...C], b.forEach((_) => {
            _.setAttribute("node-id", "0");
          }), s(qd({ userId: n, element: b })));
          const { video: { videoAttachments: E, renderedVideoList: w } } = i();
          ((f = E[`${n}`]) === null || f === void 0 ? void 0 : f.length) === 0 && (w.filter((_) => _.userId === n && _.canvasId !== Wl).length === 0 && (n !== c && a.unsubscribeVideo(n), s(Wd(n))), s(Yc({ userId: n, key: Yi, canvasId: Wl })));
        } else
          console.warn(`UserId:${n} has not been attached.`);
        return Promise.resolve(b);
      }
      return Promise.resolve(void 0);
    })(this[J], e, t);
  }
  isCapturingVideo() {
    return ((e) => {
      const { store: { getState: t } } = e, r = t();
      return !!r.video && r.video.isCurrentUserStartedVideo;
    })(this[J]);
  }
  isCameraTaken() {
    return ((e) => {
      const { store: { getState: t } } = e, r = t();
      return !!r.video && r.video.isCameraTaken;
    })(this[J]);
  }
  isCaptureForbidden() {
    return ((e) => {
      const { store: { getState: t } } = e, r = t();
      return !!r.video && r.video.isCaptureForbidden;
    })(this[J]);
  }
  getCameraList() {
    return ((e) => {
      const { store: { getState: t } } = e, r = t();
      if (!r.video)
        return [];
      const { video: { cameraDevicesList: n } } = r;
      return n.map((o) => Object.assign({}, o));
    })(this[J]);
  }
  getActiveCamera() {
    return ((e) => {
      const { store: { getState: t } } = e, r = t();
      return r.video ? r.video.activeCamera : "";
    })(this[J]);
  }
  getActiveVideoId() {
    return ((e) => {
      const { store: { getState: t } } = e, r = t();
      return r.video ? r.video.activeVideoId : 0;
    })(this[J]);
  }
  getVideoMaxQuality() {
    return ((e) => {
      const { store: { getState: t } } = e, r = t();
      return r.video ? r.video.receivedVideoMaxQuality : gn.Video_90P;
    })(this[J]);
  }
  getReceivedVideoDimension() {
    return ((e) => {
      const { store: { getState: t } } = e, r = t();
      return r.video ? r.video.receivedVideoDimension : null;
    })(this[J]);
  }
  getCapturedVideoResolution() {
    return ((e) => {
      const { store: { getState: t } } = e;
      return { ...t().video.capturedVideoDimension };
    })(this[J]);
  }
  isSupportMultipleVideos() {
    return ((e) => {
      const { store: { getState: t } } = e, { media: { enforceMultipleVideos: r } } = t();
      return J0() || !!r && !window.crossOriginIsolated && Ia(r) > 1;
    })(this[J]);
  }
  isSupportHDVideo() {
    return ((e) => {
      var t;
      const { store: { getState: r } } = e;
      return (t = r().video) === null || t === void 0 ? void 0 : t.isSupportHDVideo;
    })(this[J]);
  }
  getHardwareAccelerationStatus() {
    return ((e) => {
      var t;
      const { store: { getState: r } } = e;
      return (t = r().video) === null || t === void 0 ? void 0 : t.hardwareAcceleration;
    })(this[J]);
  }
  getVideoStatisticData() {
    return ((e) => {
      let { store: { getState: t } } = e;
      const { video: { statistic: r } } = t();
      return { ...r };
    })(this[J]);
  }
  isSupportVirtualBackground() {
    return ((e) => {
      const { store: { getState: t } } = e;
      return zf(t().media.enforceVirtualBackground);
    })(this[J]);
  }
  getVirtualbackgroundStatus() {
    return ((e) => {
      const { store: { getState: t } } = e;
      return { ...t().video.virtualBackground };
    })(this[J]);
  }
  isRenderSelfViewWithVideoElement() {
    return Sl(this[At].getState().media.enforceVirtualBackground);
  }
  getNetworkQuality(e) {
    return ((t, r) => {
      var n;
      const { store: { getState: o } } = t, i = o(), { video: s, meeting: { userId: a } } = i, l = r != null ? r : a, u = s == null || (n = s.networkQuality) === null || n === void 0 ? void 0 : n[`${l}`];
      if (u) {
        const d = {};
        return u.uplink && Object.assign(d, { uplink: u.uplink.level }), u.downlink && Object.assign(d, { downlink: u.downlink.level }), d;
      }
      return null;
    })(this[J], e);
  }
  getFarEndCameraPTZCapability(e) {
    return ((t, r) => {
      const { store: { getState: n } } = t, o = wh(n()).find((i) => i.userId === r);
      return (o == null ? void 0 : o.nFECC) !== void 0 ? a_(o == null ? void 0 : o.nFECC) : { pan: !1, tilt: !1, zoom: !1 };
    })(this[J], e);
  }
  getCameraPTZCapability(e) {
    return ((t, r) => {
      const { store: { getState: n } } = t, { video: { ptz: o, activeCamera: i } } = n(), s = o[r != null ? r : i];
      return { pan: !(s == null || !s.pan), tilt: !(s == null || !s.tilt), zoom: !(s == null || !s.zoom) };
    })(this[J], e);
  }
  isBrowserSupportPTZ() {
    const { pan: e, tilt: t, zoom: r } = ke.getPTZCapability();
    return e || t || r;
  }
  getVideoMaskStatus() {
    return ((e) => {
      var t;
      const { store: { getState: r } } = e, n = r(), { isMaskConfigured: o, imageSrc: i, ...s } = ((t = n.video) === null || t === void 0 ? void 0 : t.mask) || {};
      return { ...s, imageUrl: i };
    })(this[J]);
  }
  startShareView(e, t, r) {
    return ((n, o, i, s) => {
      const { store: { getState: a, dispatch: l }, mediaAgent: u, rwgAgent: d } = n, { share: { isReceiveSharing: c, isRemoteSharingActive: p, activeNodeId: h, activeSsrc: v, status: f, renderedEnsuredCanvas: m, isReceiveSharingFromMainSession: g }, media: { sharingDecodeStatus: C } } = a();
      if (!o || i !== h)
        return Promise.reject({ type: De, reason: "" });
      if (!p || c || f !== Fe.End)
        return Promise.reject({ type: W, reason: "" });
      o.id || (o.id = Qo("__ZOOM_SDK_SHARE_CANVAS_@__"));
      const b = !!s;
      return _r("sharing", "success", C).subscribe((E) => {
        let [, w] = E;
        if (w) {
          let _ = o;
          m.includes(o.id) || (_ = Xd(o), l(xE(o.id))), l(Gc(!0)), Ma(d, a(), i), u.renderSharing(v, _, b, s, g);
          const { audio: I } = a();
          if (I != null && I.localShareAudioUserMutedList) {
            const D = I.localShareAudioUserMutedList.find((B) => B.userId === i);
            D && u.setSharingAudioVolume(i, D.muted, D.isFromMainSession);
          }
        }
      }), C === "failed" ? Promise.reject({ type: Eo, reason: "" }) : Te(xc, (E) => !!E, 6e4);
    })(this[J], e, t, r);
  }
  stopShareView() {
    return ((e) => {
      const { store: { dispatch: t, getState: r }, rwgAgent: n, mediaAgent: o } = e, { share: { isReceiveSharing: i, activeNodeId: s }, breakoutRoom: a } = r();
      if (!i)
        return Promise.resolve("");
      let l = !1;
      return (a == null ? void 0 : a.currentRoom.status) === Ee.InRoom && a.mainSessionAttendeeList.length > 0 && (l = a.mainSessionAttendeeList.findIndex((u) => u.userId === s) > -1), o.stopRenderSharing(), n.unsubscribeSharing(s, l), t(Gc(!1)), Promise.resolve("");
    })(this[J]);
  }
  switchShareView(e) {
    return ((t, r) => {
      const { store: { getState: n, dispatch: o }, rwgAgent: i, mediaAgent: s } = t, a = n(), { share: { isReceiveSharing: l, activeNodeId: u, isReceiveSharingFromMainSession: d, remoteControlledUserList: c, isGrabRemoteControl: p }, audio: h, breakoutRoom: v } = a;
      if (!l)
        return Promise.reject({ type: W });
      if (r === u)
        return Promise.resolve("");
      let f = [];
      return f = d ? v.mainSessionAttendeeList.filter((m) => m.bShareToBORooms && m.sharerOn) : gs(a), f.findIndex((m) => m.userId === u) > -1 ? (c.includes(u) && (p && i.subscribeGrabRemoteControl(u, !1), s.updateRemoteControlProperties({ isControllerNow: !1 })), i.unsubscribeSharing(u, d), Ma(i, n(), r), s.switchSharingSource(r, d), c.includes(r) && t7(r, void 0, a, i, s), h == null || h.localShareAudioUserMutedList.forEach((m) => {
        s.setSharingAudioVolume(r, m.userId !== r || m.muted, m.isFromMainSession);
      }), o(Zc({ bStatus: 1, activeNodeID: r, ssrc: r })), O(Vc, { userId: r }), Promise.resolve("")) : Promise.reject({ type: De, reason: "no matching user id" });
    })(this[J], e);
  }
  updateSharingCanvasDimension(e, t) {
    return ((r, n, o) => {
      const { store: { getState: i }, mediaAgent: s } = r, a = i(), { share: { isReceiveSharing: l, isGrabRemoteControl: u, remoteControlViewportDomSelector: d } } = a;
      if (l && (s.updateRenderedSharingDimension(n, o), u && d)) {
        const c = document.querySelector(d);
        s.updateRemoteControlProperties({ dimension: c && Hf(c) });
      }
      return Promise.resolve("");
    })(this[J], e, t);
  }
  startShareScreen(e, t) {
    return ((r, n, o) => {
      var i;
      const { store: { getState: s, dispatch: a }, mediaAgent: l } = r, u = s(), { meeting: { bIbDisableShare: d, meetingOptions: c }, share: { sharePrivilege: p, ssrc: h, isChromeExtensionInstalled: v, capturedEnsuredCanvas: f, isReceiveSharingFromMainSession: m }, media: { sharingEncodeStatus: g }, breakoutRoom: C } = u, { isSupportMediaStreamTrackProcessor: b, isLegacyChrome: E } = ve;
      if (d)
        return Promise.reject({ type: W, reason: "information barrier" });
      if (typeof ((i = navigator.mediaDevices) === null || i === void 0 ? void 0 : i.getDisplayMedia) != "function")
        return Promise.reject({ type: W, reason: "Unable to share your screen due to the technical limitation" });
      if (m)
        return Promise.reject({ type: W, reason: "Unable to share your screen while someone is sharing from the main session" });
      var w;
      if (b) {
        if (!(n instanceof HTMLVideoElement))
          return Promise.reject({ type: De, reason: "Use Video element instead of Canvas element when WebCodecs enabled" });
      } else if (!(n instanceof HTMLCanvasElement))
        return Promise.reject({ type: De, reason: `Expected to accept HTMLCanvasElement, but actual it is ${typeof n == "object" && n !== null ? (w = Object.getPrototypeOf(n)) === null || w === void 0 ? void 0 : w.constructor.name : n}` });
      const _ = Sn(u);
      if (o != null && o.broadcastToBreakoutRoom) {
        if (!_ || (C == null ? void 0 : C.currentRoom.status) === Ee.InRoom)
          return _ ? Promise.reject({ type: W, reason: "Unable to share screen to breakout room when in the room" }) : Promise.reject({ type: Or });
        a(xl(!0));
      } else
        a(xl(!1));
      (o == null ? void 0 : o.requestReadReceipt) !== void 0 && a(LE(o == null ? void 0 : o.requestReadReceipt)), (o == null ? void 0 : o.optimizedForSharedVideo) !== void 0 && p !== vn.MultipleShare && a(qc((o == null ? void 0 : o.optimizedForSharedVideo) && ke.isSupportVideoShareSend()));
      const I = gs(u);
      if (p === vn.OnlyHost && !_)
        return Promise.reject({ type: Or, reason: "only host can start screen share" });
      if (p === vn.HostGrab && !_ && I.length > 0)
        return Promise.reject({ type: Or, reason: "only host can grab screen share" });
      const D = be(u);
      if ((D == null ? void 0 : D.sharerOn) === !0)
        return Promise.reject({ type: W, reason: "you have already started screen share." });
      let B = Je(!0);
      return E && !v && (l.checkChromeSharingExtension(), B = ht(Y1, 1)), n.id || (n.id = Qo("__ZOOM_SDK_SELF_SHARE_CANVAS_@__")), G0([_r("sharing", g, "success"), B]).subscribe((L) => {
        let [R, y] = L;
        const [A] = R;
        if (A && y) {
          f.includes(n.id) || (Xd(n), a(NE(n.id)));
          let k = document.querySelector(`#${kp}`);
          k && k.tagName === "VIDEO" || (k = document.createElement("video"), k.id = kp, k.style.display = "none", document.body.appendChild(k));
          const T = o != null && o.secondaryCameraId ? { cameraId: o.secondaryCameraId, width: o.captureWidth, height: o.captureHeight } : void 0, N = !(o != null && o.hideShareAudioOption);
          l.startDesktopSharing(h, n.id, kp, T, c != null && c.isDisableShareAudioIntoBo ? N && !(o != null && o.broadcastToBreakoutRoom) : N, o == null ? void 0 : o.displaySurface, o == null ? void 0 : o.sourceId, o == null ? void 0 : o.controls), a(Wc(void 0)), a(PE(!!T));
        }
      }), new Promise((L, R) => {
        Vn(ht(Qr).pipe(z((y) => y.sharerOn !== void 0), Ge(1)), ht(Y1).pipe(z((y) => !y), Ge(1), Ie(cs({ reason: "required extension", extensionUrl: "https://chrome.google.com/webstore/detail/zoom-scheduler/kgjfgplpablkjnlkjmjdecgdpfankdle" }))), ht(hw, 1).pipe(G((y) => cs({ reason: y.reason || "user deny screen share" })))).subscribe((y) => {
          if (y.sharerOn === !0) {
            const { share: { isSharingToBreakoutRoom: A }, meeting: { meetingOptions: k } } = s(), T = !(k != null && k.isDisableShareAudioIntoBo || !A);
            l.enableShareAudioToBreakoutRoom(T), L("");
          } else
            R({ type: Eo });
        }, (y) => {
          R({ type: W, ...y });
        });
      });
    })(this[J], e, t);
  }
  stopShareScreen() {
    return ((e) => {
      const { store: { getState: t, dispatch: r }, rwgAgent: n, mediaAgent: o } = e, { share: { status: i }, meeting: { userId: s } } = t();
      return i === Fe.End ? Promise.resolve("") : (r(bn(Fe.End)), n.stopSharing(s), o.stopDesktopSharing(), Te(Qr, (a) => a.sharerOn === !1));
    })(this[J]);
  }
  pauseShareScreen() {
    return ((e) => {
      const { store: { getState: t, dispatch: r }, rwgAgent: n, mediaAgent: o } = e, { share: { status: i } } = t();
      return i === Fe.Sharing ? (n.pauseSharing(), o.pauseDesktopSharing(), Te(Qr, (s) => s.sharerPause === !0).then(() => (r(bn(Fe.Paused)), ""))) : Promise.reject({ type: W });
    })(this[J]);
  }
  resumeShareScreen() {
    return ((e) => {
      const { store: { getState: t, dispatch: r }, rwgAgent: n, mediaAgent: o } = e, { share: { status: i } } = t();
      return i === Fe.Paused ? (n.resumeSharing(), o.resumeDesktopSharing(), Te(Qr, (s) => s.sharerOn === !0 && s.sharerPause === !1).then(() => (r(bn(Fe.Sharing)), ""))) : Promise.reject({ type: W });
    })(this[J]);
  }
  setSharePrivilege(e) {
    return Xy(this[J], e);
  }
  lockShare(e) {
    return ((t, r) => Xy(t, r ? vn.OnlyHost : vn.HostGrab))(this[J], e);
  }
  shareToBreakoutRoom() {
    return ((e) => {
      const { store: { getState: t, dispatch: r }, rwgAgent: n, mediaAgent: o } = e, { meeting: { userId: i }, breakoutRoom: s, share: { isSharingToBreakoutRoom: a, status: l } } = t();
      return l === Fe.End ? Promise.reject({ type: W, reason: "Invalid sharing status" }) : a ? Promise.resolve("") : s.currentRoom.status === Ee.InRoom ? Promise.reject({ type: W, reason: "Unable to share screen to breakout room when in the room" }) : (n.startShareToBreakoutRoom(i), r(xl(!0)), o.enableShareAudioToBreakoutRoom(!0), Promise.resolve(""));
    })(this[J]);
  }
  stopShareToBreakoutRoom() {
    return ((e) => {
      const { store: { getState: t, dispatch: r }, rwgAgent: n, mediaAgent: o } = e, { meeting: { userId: i }, share: { isSharingToBreakoutRoom: s } } = t();
      return s && (n.stopShareToBreakoutRoom(i), r(xl(!1)), o.enableShareAudioToBreakoutRoom(!1)), Promise.resolve("");
    })(this[J]);
  }
  muteOthersScreenShare(e) {
    return ((t, r) => {
      const { store: { getState: n }, rwgAgent: o } = t, i = n(), { meeting: { userId: s } } = i, a = gs(i);
      return r === s ? Promise.reject({ type: W, reason: "Cannot mute self share, use 'stopScreenShare' instead" }) : a.findIndex((l) => l.userId === r) === -1 ? Promise.reject({ type: De, reason: "Target user is not sharing" }) : (o.stopSharing(r), Te(Mo, (l) => l.some((u) => u.userId === r && u.sharerOn === !1)));
    })(this[J], e);
  }
  enableOptimizeForSharedVideo(e) {
    return ((t, r) => {
      const { store: { getState: n, dispatch: o }, mediaAgent: i, rwgAgent: s } = t, { share: { status: a, isOptimizedForSharedVideo: l, isSharingToBreakoutRoom: u, sharePrivilege: d }, audio: { isSharingAudio: c }, meeting: { userId: p } } = n();
      return a !== Fe.End ? l === r ? Promise.resolve("") : d !== vn.MultipleShare ? r && !ke.isSupportVideoShareSend() ? Promise.reject({ type: W, reason: "Cannot enable optimize for shared video due to the platform is not supported " }) : (s.startSharing(p, { bShareAudio: c, bShareToBO: u, bShareVideo: r }), i.switchSharingMode(r ? Zl.VideoMode : Zl.Normal), Te({ event: Qr, operations: [z((h) => h.bVideoShare !== void 0), Ge(1)] }, (h) => h.bVideoShare === r).then(() => (o(qc(r)), ""))) : Promise.reject({ type: W, reason: "Cannot enable optimize for shared video when enabling multiple screen shares" }) : Promise.reject({ type: W, reason: "Cannot enable optimize for shared video when screen share is not started" });
    })(this[J], e);
  }
  updateSharedVideoQuality(e) {
    return ((t, r) => {
      const { store: { getState: n, dispatch: o }, rwgAgent: i } = t, s = n(), { share: { shareQuality: a, activeNodeId: l, isReceiveSharing: u } } = s, d = uA(s);
      return u && l !== 0 ? (d && a !== r && (Ma(i, s, l, r), o(Im(r))), Promise.resolve("")) : Promise.reject({ type: W, reason: "Cannot update shared video quality when screen share is not started" });
    })(this[J], e);
  }
  subscribeShareStatisticData(e) {
    return (async (t, r) => {
      const { mediaAgent: n, store: { getState: o } } = t, i = o(), { media: { sharingEncodeStatus: s, sharingDecodeStatus: a } } = o(), l = be(i), u = !r || r.decode, d = !r || r.encode;
      if (!l)
        return Promise.reject({ type: W, reason: "Call this function after the 'join' method resolved." });
      {
        const c = Jt(l.userRole) || !ve.isSupportSendScreenSharing ? "failed" : s;
        _r("sharing", c, a).subscribe((p) => {
          let [h, v] = p;
          h && v && (u && n.subscribeToQos([ur.SharingDecode], fi), d && n.subscribeToQos([ur.SharingEncode], fi));
        });
      }
      return "";
    })(this[J], e);
  }
  unsubscribeShareStatisticData(e) {
    return (async (t, r) => {
      const { mediaAgent: n, store: { dispatch: o } } = t, i = !r || r.decode, s = !r || r.encode;
      return i && (n.unsubscribeFromQos([ur.SharingDecode]), o(vu(Ri))), s && (n.unsubscribeFromQos([ur.SharingEncode]), o(vu(Ri))), null;
    })(this[J], e);
  }
  getShareUserList() {
    return ((e) => {
      const { store: { getState: t } } = e, r = t();
      if (!r.share)
        return [];
      const { share: { isReceiveSharingFromMainSession: n } } = r;
      if (n) {
        const { breakoutRoom: { mainSessionAttendeeList: o } } = r;
        return o.filter((i) => i.bShareToBORooms && (i.sharerOn || i.sharerPause)).map((i) => La(i));
      }
      return gs(r).map((o) => La(o));
    })(this[J]);
  }
  getActiveShareUserId() {
    return ((e) => {
      const { store: { getState: t } } = e, r = t();
      return r.share && r.share.isRemoteSharingActive ? r.share.activeNodeId : 0;
    })(this[J]);
  }
  isReceiveSharing() {
    return ((e) => {
      const { store: { getState: t } } = e, r = t();
      return !!r.share && r.share.isReceiveSharing;
    })(this[J]);
  }
  getShareViewDimension() {
    return ((e) => {
      const { store: { getState: t } } = e, r = t();
      if (r.share) {
        if (r.share.status !== Fe.End)
          return { ...r.share.shareDimension };
        {
          const { share: { receivedShareDimension: n } } = r;
          return { width: n.width, height: n.height };
        }
      }
      return null;
    })(this[J]);
  }
  getShareStatus() {
    return ((e) => {
      const { store: { getState: t } } = e, r = t();
      return r.share ? r.share.status : null;
    })(this[J]);
  }
  isShareLocked() {
    return ((e) => {
      const { store: { getState: t } } = e, r = t();
      return !!r.share && r.share.sharePrivilege === vn.OnlyHost;
    })(this[J]);
  }
  isReceiveSharingFromMainSession() {
    return ((e) => {
      const { store: { getState: t } } = e, r = t();
      return !!r.share && r.share.isReceiveSharingFromMainSession;
    })(this[J]);
  }
  getSharePrivilege() {
    return ((e) => {
      const { store: { getState: t } } = e, r = t();
      return r.share ? r.share.sharePrivilege : null;
    })(this[J]);
  }
  isStartShareScreenWithVideoElement() {
    return ve.isSupportMediaStreamTrackProcessor;
  }
  isOptimizeForSharedVideoEnabled() {
    return ((e) => {
      const { store: { getState: t } } = e, r = t();
      return !!r.share && r.share.isOptimizedForSharedVideo;
    })(this[J]);
  }
  isSupportOptimizedForSharedVideo() {
    return ke.isSupportVideoShareSend();
  }
  getShareStatisticData() {
    return ((e) => {
      let { store: { getState: t } } = e;
      const { share: { statistic: r } } = t();
      return { ...r };
    })(this[J]);
  }
  requestRemoteControl() {
    return ((e) => {
      const { store: { getState: t }, rwgAgent: r } = e, { share: { isReceiveSharing: n, activeNodeId: o, isRemoteControlEnabled: i } } = t();
      return i ? e5(e, o) ? n ? rs(t()) ? Promise.reject({ type: W, reason: "Already get the approval" }) : (r.sharingRequestRemoteControl(o, !0), new Promise((s) => {
        ht(jc, 1).subscribe((a) => {
          s(a);
        });
      })) : Promise.reject({ type: W, reason: "Cannot request control due to no sharing available" }) : Promise.reject({ type: De }) : Promise.reject({ type: W, reason: "Cannot request control due to the feature is not enabled." });
    })(this[J]);
  }
  giveUpRemoteControl() {
    return ((e) => {
      const { store: { getState: t }, rwgAgent: r } = e, { share: { isGrabRemoteControl: n, activeNodeId: o } } = t();
      return rs(t()) ? (n && r.subscribeGrabRemoteControl(o, !1), r.sharingRequestRemoteControl(o, !1), Te(jc, (i) => i === !1)) : Promise.reject({ type: W });
    })(this[J]);
  }
  startRemoteControl(e) {
    return (async (t, r) => {
      const { store: { getState: n, dispatch: o }, mediaAgent: i, rwgAgent: s } = t, { share: { isSDKGrabControl: a, activeNodeId: l } } = n();
      return rs(n()) ? (await t7(l, r, n(), s, i), r.dataset.zmrvId || r.setAttribute("data-zmrv-id", Qo("__ZOOM_SDK_RC_VIEWPORT_DATA_ID_@__")), o(UE(`${r.tagName}[data-zmrv-id="${r.dataset.zmrvId}"]`)), a ? Te(Es, (u) => !!u) : $o({ success: bw, fail: [Cw] })) : Promise.reject({ type: W, reason: "required to be approved" });
    })(this[J], e);
  }
  grabRemotoControl() {
    return ((e) => {
      const { store: { getState: t }, rwgAgent: r } = e, { share: { isGrabRemoteControl: n, activeNodeId: o } } = t();
      return rs(t()) ? n ? Promise.resolve("") : (r.subscribeGrabRemoteControl(o, !0), Te(Es, (i) => !!i)) : Promise.reject({ type: W, reason: "should be approved before grab" });
    })(this[J]);
  }
  updateRemoteControlViewportDimension(e) {
    return ((t, r) => {
      const { store: { getState: n }, mediaAgent: o } = t;
      return rs(n()) && o.updateRemoteControlProperties({ dimension: { scaleWidth: r.width, scaleHeight: r.height, srcOffsetX: r.left, srcOffsetY: r.top } }), Promise.resolve("");
    })(this[J], e);
  }
  approveRemoteControl(e) {
    return ((t, r) => {
      const { store: { getState: n, dispatch: o }, rwgAgent: i, mediaAgent: s } = t, a = n(), { share: { status: l, isEnableAutoDeleteRcApp: u, remoteControllingSsrc: d, userSsrcMapping: c }, meeting: { userId: p } } = a;
      if (l === Fe.End)
        return Promise.reject({ type: W, reason: "Cannot approve remote control when sharing is not ongoing." });
      if (l === Fe.Paused && (i.resumeSharing(), s.resumeDesktopSharing(), o(bn(Fe.Sharing))), s.isSharingEntireScreen()) {
        var h;
        d && !Xr(d, r) && (y0(a, i), o(Co("")));
        const v = (h = c[`${r}`]) !== null && h !== void 0 ? h : r;
        return i.remoteControlConsent(Pc.Approve, v, p, { ...s.getShareStreamInfo(), platform: ve.isMacOS ? "mac" : "win" }, u), o(Ra(v)), Te(Aw);
      }
      return Promise.reject({ type: W, reason: "Cannot approve remote control when not sharing entire screen." });
    })(this[J], e);
  }
  declineRemoteControl(e) {
    return ((t, r) => {
      var n;
      const { store: { getState: o }, rwgAgent: i, mediaAgent: s } = t, a = o(), { meeting: { userId: l }, share: { isEnableAutoDeleteRcApp: u, userSsrcMapping: d } } = a, c = (n = d[`${r}`]) !== null && n !== void 0 ? n : r;
      return i.remoteControlConsent(Pc.Decline, c, l, { ...s.getShareStreamInfo(), platform: ve.isMacOS ? "mac" : "win" }, u), Promise.resolve("");
    })(this[J], e);
  }
  stopRemoteControl() {
    return ((e) => {
      const { store: { getState: t, dispatch: r }, rwgAgent: n } = e;
      return y0(t(), n), r(Co("")), r(Ra(0)), Promise.resolve("");
    })(this[J]);
  }
  launchRemoteControlApp(e) {
    return ((t, r) => {
      const { store: { getState: n, dispatch: o } } = t, i = n(), { share: { remoteControlAppLaunchSheme: s } } = i;
      return s ? (o(Co(r ? `${s}&bAutoDelete=1` : s)), o(ls(dr.Unknown)), Promise.resolve("")) : Promise.reject({ type: W, reason: "Cannot launch app due to no permission" });
    })(this[J], e);
  }
  isRemoteControlEnabled() {
    return ((e) => {
      var t;
      const { store: { getState: r } } = e;
      return !((t = r().share) === null || t === void 0 || !t.isRemoteControlEnabled);
    })(this[J]);
  }
  getRemoteControlAppDownloadUrl() {
    return ((e) => {
      const { store: { getState: t } } = e, r = t();
      return r.share ? r.share.remoteControlAppDownloadUrl : null;
    })(this[J]);
  }
  isTargetShareSupportRemoteControl(e) {
    return e5(this[J], e);
  }
  isRemotelyControlApproved() {
    return ((e) => {
      const { store: { getState: t } } = e, r = t();
      return !!r.share && rs(r);
    })(this[J]);
  }
  isControllingUserRemotely() {
    return ((e) => {
      const { store: { getState: t } } = e, r = t();
      return !!r.share && r.share.isGrabRemoteControl;
    })(this[J]);
  }
  getRemotelyControllingUser() {
    return ((e) => {
      const { store: { getState: t } } = e, r = t();
      if (r.share) {
        const { remoteControllingSsrc: n } = r.share;
        if (n)
          return ft(r).find((o) => Xr(o.userId, n));
      }
      return null;
    })(this[J]);
  }
}, K(V.prototype, "startAudio", [Y, t5, Jr], Object.getOwnPropertyDescriptor(V.prototype, "startAudio"), V.prototype), K(V.prototype, "stopAudio", [Y, r5, Jr], Object.getOwnPropertyDescriptor(V.prototype, "stopAudio"), V.prototype), K(V.prototype, "muteAudio", [Y, n5, Jr], Object.getOwnPropertyDescriptor(V.prototype, "muteAudio"), V.prototype), K(V.prototype, "unmuteAudio", [Y, o5, Jr], Object.getOwnPropertyDescriptor(V.prototype, "unmuteAudio"), V.prototype), K(V.prototype, "dialOut", [Y, i5, s5], Object.getOwnPropertyDescriptor(V.prototype, "dialOut"), V.prototype), K(V.prototype, "cancelDialOut", [Y, a5, l5], Object.getOwnPropertyDescriptor(V.prototype, "cancelDialOut"), V.prototype), K(V.prototype, "hangup", [Y, u5, Jr], Object.getOwnPropertyDescriptor(V.prototype, "hangup"), V.prototype), K(V.prototype, "switchMicrophone", [Y, d5, Jr], Object.getOwnPropertyDescriptor(V.prototype, "switchMicrophone"), V.prototype), K(V.prototype, "switchSpeaker", [Y, c5, Jr], Object.getOwnPropertyDescriptor(V.prototype, "switchSpeaker"), V.prototype), K(V.prototype, "muteShareAudio", [Y, p5, h5, Jr], Object.getOwnPropertyDescriptor(V.prototype, "muteShareAudio"), V.prototype), K(V.prototype, "unmuteShareAudio", [Y, f5, v5, Jr], Object.getOwnPropertyDescriptor(V.prototype, "unmuteShareAudio"), V.prototype), K(V.prototype, "subscribeAudioStatisticData", [Y, m5, Jr], Object.getOwnPropertyDescriptor(V.prototype, "subscribeAudioStatisticData"), V.prototype), K(V.prototype, "unsubscribeAudioStatisticData", [Y, g5, Jr], Object.getOwnPropertyDescriptor(V.prototype, "unsubscribeAudioStatisticData"), V.prototype), K(V.prototype, "enableBackgroundNoiseSuppression", [Y, y5, Jr], Object.getOwnPropertyDescriptor(V.prototype, "enableBackgroundNoiseSuppression"), V.prototype), K(V.prototype, "enableSyncButtonsOnHeadset", [Y, S5, Jr], Object.getOwnPropertyDescriptor(V.prototype, "enableSyncButtonsOnHeadset"), V.prototype), K(V.prototype, "enableOriginalSound", [Y, b5, Jr], Object.getOwnPropertyDescriptor(V.prototype, "enableOriginalSound"), V.prototype), K(V.prototype, "callCRCDevice", [Y, C5, w5], Object.getOwnPropertyDescriptor(V.prototype, "callCRCDevice"), V.prototype), K(V.prototype, "cancelCallCRCDevice", [Y, E5, I5], Object.getOwnPropertyDescriptor(V.prototype, "cancelCallCRCDevice"), V.prototype), K(V.prototype, "startVideo", [Y, A5, Wt], Object.getOwnPropertyDescriptor(V.prototype, "startVideo"), V.prototype), K(V.prototype, "stopVideo", [Y, _5, Wt], Object.getOwnPropertyDescriptor(V.prototype, "stopVideo"), V.prototype), K(V.prototype, "switchCamera", [Y, R5, Wt], Object.getOwnPropertyDescriptor(V.prototype, "switchCamera"), V.prototype), K(V.prototype, "renderVideo", [VP, Y, O5, Wt], Object.getOwnPropertyDescriptor(V.prototype, "renderVideo"), V.prototype), K(V.prototype, "stopRenderVideo", [IS, Y, T5, Wt], Object.getOwnPropertyDescriptor(V.prototype, "stopRenderVideo"), V.prototype), K(V.prototype, "updateVideoCanvasDimension", [ES, Y, k5, Wt], Object.getOwnPropertyDescriptor(V.prototype, "updateVideoCanvasDimension"), V.prototype), K(V.prototype, "adjustRenderedVideoPosition", [IS, Y, M5, Wt], Object.getOwnPropertyDescriptor(V.prototype, "adjustRenderedVideoPosition"), V.prototype), K(V.prototype, "clearVideoCanvas", [ES, Y, P5, Wt], Object.getOwnPropertyDescriptor(V.prototype, "clearVideoCanvas"), V.prototype), K(V.prototype, "mirrorVideo", [Y, D5, Wt], Object.getOwnPropertyDescriptor(V.prototype, "mirrorVideo"), V.prototype), K(V.prototype, "enableHardwareAcceleration", [Y, L5, Wt], Object.getOwnPropertyDescriptor(V.prototype, "enableHardwareAcceleration"), V.prototype), K(V.prototype, "subscribeVideoStatisticData", [Y, N5, Wt], Object.getOwnPropertyDescriptor(V.prototype, "subscribeVideoStatisticData"), V.prototype), K(V.prototype, "unsubscribeVideoStatisticData", [Y, x5, Wt], Object.getOwnPropertyDescriptor(V.prototype, "unsubscribeVideoStatisticData"), V.prototype), K(V.prototype, "previewVirtualBackground", [Eh, Y, V5, Wt], Object.getOwnPropertyDescriptor(V.prototype, "previewVirtualBackground"), V.prototype), K(V.prototype, "updateVirtualBackgroundImage", [Y, j5, Wt], Object.getOwnPropertyDescriptor(V.prototype, "updateVirtualBackgroundImage"), V.prototype), K(V.prototype, "stopPreviewVirtualBackground", [Y, U5, Wt], Object.getOwnPropertyDescriptor(V.prototype, "stopPreviewVirtualBackground"), V.prototype), K(V.prototype, "previewVideoMask", [Eh, Y, B5, Wt], Object.getOwnPropertyDescriptor(V.prototype, "previewVideoMask"), V.prototype), K(V.prototype, "updateVideoMask", [Y, $5, Wt], Object.getOwnPropertyDescriptor(V.prototype, "updateVideoMask"), V.prototype), K(V.prototype, "stopPreviewVideoMask", [Y, H5, Wt], Object.getOwnPropertyDescriptor(V.prototype, "stopPreviewVideoMask"), V.prototype), K(V.prototype, "requestFarEndCameraControl", [Y, F5, ta], Object.getOwnPropertyDescriptor(V.prototype, "requestFarEndCameraControl"), V.prototype), K(V.prototype, "approveFarEndCameraControl", [Y, z5, ta], Object.getOwnPropertyDescriptor(V.prototype, "approveFarEndCameraControl"), V.prototype), K(V.prototype, "declineFarEndCameraControl", [Y, W5, ta], Object.getOwnPropertyDescriptor(V.prototype, "declineFarEndCameraControl"), V.prototype), K(V.prototype, "giveUpFarEndCameraControl", [Y, Z5, ta], Object.getOwnPropertyDescriptor(V.prototype, "giveUpFarEndCameraControl"), V.prototype), K(V.prototype, "controlCamera", [Y, G5, ta], Object.getOwnPropertyDescriptor(V.prototype, "controlCamera"), V.prototype), K(V.prototype, "controlFarEndCamera", [Y, q5, ta], Object.getOwnPropertyDescriptor(V.prototype, "controlFarEndCamera"), V.prototype), K(V.prototype, "attachVideo", [Y, K5, Wt], Object.getOwnPropertyDescriptor(V.prototype, "attachVideo"), V.prototype), K(V.prototype, "detachVideo", [Y, J5, Wt], Object.getOwnPropertyDescriptor(V.prototype, "detachVideo"), V.prototype), K(V.prototype, "startShareView", [Eh, Y, Q5, wr], Object.getOwnPropertyDescriptor(V.prototype, "startShareView"), V.prototype), K(V.prototype, "stopShareView", [Y, Y5, wr], Object.getOwnPropertyDescriptor(V.prototype, "stopShareView"), V.prototype), K(V.prototype, "switchShareView", [Y, X5, wr], Object.getOwnPropertyDescriptor(V.prototype, "switchShareView"), V.prototype), K(V.prototype, "updateSharingCanvasDimension", [Y, eS, wr], Object.getOwnPropertyDescriptor(V.prototype, "updateSharingCanvasDimension"), V.prototype), K(V.prototype, "startShareScreen", [Y, tS, wr], Object.getOwnPropertyDescriptor(V.prototype, "startShareScreen"), V.prototype), K(V.prototype, "stopShareScreen", [Y, rS, wr], Object.getOwnPropertyDescriptor(V.prototype, "stopShareScreen"), V.prototype), K(V.prototype, "pauseShareScreen", [Y, nS, wr], Object.getOwnPropertyDescriptor(V.prototype, "pauseShareScreen"), V.prototype), K(V.prototype, "resumeShareScreen", [Y, oS, wr], Object.getOwnPropertyDescriptor(V.prototype, "resumeShareScreen"), V.prototype), K(V.prototype, "setSharePrivilege", [rr, iS, Y, wr], Object.getOwnPropertyDescriptor(V.prototype, "setSharePrivilege"), V.prototype), K(V.prototype, "lockShare", [rr, sS, Y, wr], Object.getOwnPropertyDescriptor(V.prototype, "lockShare"), V.prototype), K(V.prototype, "shareToBreakoutRoom", [Y, rr, aS, wr], Object.getOwnPropertyDescriptor(V.prototype, "shareToBreakoutRoom"), V.prototype), K(V.prototype, "stopShareToBreakoutRoom", [Y, rr, lS, wr], Object.getOwnPropertyDescriptor(V.prototype, "stopShareToBreakoutRoom"), V.prototype), K(V.prototype, "muteOthersScreenShare", [Y, rr, uS, wr], Object.getOwnPropertyDescriptor(V.prototype, "muteOthersScreenShare"), V.prototype), K(V.prototype, "enableOptimizeForSharedVideo", [Y, dS, wr], Object.getOwnPropertyDescriptor(V.prototype, "enableOptimizeForSharedVideo"), V.prototype), K(V.prototype, "updateSharedVideoQuality", [Y, cS, wr], Object.getOwnPropertyDescriptor(V.prototype, "updateSharedVideoQuality"), V.prototype), K(V.prototype, "subscribeShareStatisticData", [Y, pS, wr], Object.getOwnPropertyDescriptor(V.prototype, "subscribeShareStatisticData"), V.prototype), K(V.prototype, "unsubscribeShareStatisticData", [Y, hS, wr], Object.getOwnPropertyDescriptor(V.prototype, "unsubscribeShareStatisticData"), V.prototype), K(V.prototype, "requestRemoteControl", [Y, fS, Uo], Object.getOwnPropertyDescriptor(V.prototype, "requestRemoteControl"), V.prototype), K(V.prototype, "giveUpRemoteControl", [Y, vS, Uo], Object.getOwnPropertyDescriptor(V.prototype, "giveUpRemoteControl"), V.prototype), K(V.prototype, "startRemoteControl", [Y, mS, Uo], Object.getOwnPropertyDescriptor(V.prototype, "startRemoteControl"), V.prototype), K(V.prototype, "grabRemotoControl", [Y, gS, Uo], Object.getOwnPropertyDescriptor(V.prototype, "grabRemotoControl"), V.prototype), K(V.prototype, "updateRemoteControlViewportDimension", [Y, yS, Uo], Object.getOwnPropertyDescriptor(V.prototype, "updateRemoteControlViewportDimension"), V.prototype), K(V.prototype, "approveRemoteControl", [Y, SS, Uo], Object.getOwnPropertyDescriptor(V.prototype, "approveRemoteControl"), V.prototype), K(V.prototype, "declineRemoteControl", [Y, bS, Uo], Object.getOwnPropertyDescriptor(V.prototype, "declineRemoteControl"), V.prototype), K(V.prototype, "stopRemoteControl", [Y, CS, Uo], Object.getOwnPropertyDescriptor(V.prototype, "stopRemoteControl"), V.prototype), K(V.prototype, "launchRemoteControlApp", [Y, wS, Uo], Object.getOwnPropertyDescriptor(V.prototype, "launchRemoteControlApp"), V.prototype), V);
var AS, _S, RS, OS, TS, kS, MS, PS, yt;
const qi = nn("Audio"), UP = nn("Sharing");
let BP = (AS = de("share"), _S = de("audio"), RS = de("audio"), OS = de("audio"), TS = de("audio"), kS = de("audio"), MS = de("audio"), PS = de("audio"), yt = class extends jP {
  switchSharingSecondaryCamera(e) {
    return ((t, r) => {
      const { store: { getState: n, dispatch: o }, mediaAgent: i } = t, s = n(), { video: { cameraDevicesList: a }, share: { status: l, isSharingWithSecondCamera: u } } = s;
      return r !== "default" && a.map((d) => d.deviceId).indexOf(r) === -1 ? Promise.reject({ type: De, reason: "Cannot find cameraDeviceId in camera devices list." }) : (l === Fe.Sharing && u && i.changeSharingSecondCamera(r), o(DE(r)), Promise.resolve());
    })(this[J], e);
  }
  muteUserAudioLocally(e) {
    return ((t, r) => {
      const { mediaAgent: n, store: { getState: o, dispatch: i } } = t, s = o(), { audio: { locallyMutedAudioList: a } } = s, l = ft(s).filter((u) => u.audio === et.Computer);
      return a.includes(r) || l.findIndex((u) => u.userId === r) === -1 || (n.muteOrUnmuteOtherAudio(r, !0), i(CE(r))), Promise.resolve("");
    })(this[J], e);
  }
  unmuteUserAudioLocally(e) {
    return ((t, r) => {
      const { mediaAgent: n, store: { getState: o, dispatch: i } } = t, { audio: { locallyMutedAudioList: s } } = o();
      return s.includes(r) && (n.muteOrUnmuteOtherAudio(r, !1), i(zc(r))), Promise.resolve("");
    })(this[J], e);
  }
  adjustUserAudioVolumeLocally(e, t) {
    return ((r, n, o) => {
      const { mediaAgent: i, store: { getState: s, dispatch: a } } = r, l = s();
      return ft(l).findIndex((u) => u.userId === n) !== -1 && (i.adjustOtherAudioVolume(n, o), a(wE({ userId: n, volume: o }))), Promise.resolve("");
    })(this[J], e, t);
  }
  muteAllUserAudioLocally() {
    return ((e) => {
      const { mediaAgent: t, store: { getState: r, dispatch: n } } = e, { audio: { isStopAllImcomingAudio: o } } = r();
      return o || (t.stopAllIncomingAudio(!0), n(mf(!0))), Promise.resolve("");
    })(this[J]);
  }
  unmuteAllUserAudioLocally() {
    return ((e) => {
      const { mediaAgent: t, store: { getState: r, dispatch: n } } = e, { audio: { isStopAllImcomingAudio: o, locallyMutedAudioList: i } } = r();
      return o && (t.stopAllIncomingAudio(!1), n(mf(!1)), i.length > 0 && i.forEach((s) => {
        t.muteOrUnmuteOtherAudio(s, !1), n(zc(s));
      })), Promise.resolve("");
    })(this[J]);
  }
  startSecondaryAudio(e, t) {
    return (async (r, n, o) => {
      const { mediaAgent: i, rwgAgent: s, store: { getState: a, dispatch: l } } = r, u = a(), { audio: { microphoneDevicesList: d, activeMicrophone: c }, share: { status: p } } = u, h = be(u);
      if (!ke.isSupportShare2ndAudioDevice(fr()))
        return Promise.reject({ type: W, reason: "Cannot start secondary audio due to platform is not supported" });
      if ((h == null ? void 0 : h.audio) === et.Computer && c === n)
        return Promise.reject({ type: W, reason: "Cannot start secondary audio with the same microphone" });
      if (p !== Fe.End)
        return Promise.reject({ type: W, reason: "Cannot start secondary audio while screen sharing is in progress" });
      let v = d;
      if (d.length === 0) {
        const { microphones: f } = await gr(c0());
        v = f;
      }
      return n && v.findIndex((f) => f.deviceId === n) === -1 ? Promise.reject({ type: De, reason: "Cannot find the microphone" }) : (s.muteShareAudio(!1, !0), i.share2ndAudio(n, o), l(Wc(n)), Te(uw));
    })(this[J], e, t);
  }
  stopSecondaryAudio() {
    return (async (e) => {
      const { mediaAgent: t, rwgAgent: r, store: { getState: n, dispatch: o } } = e, i = n(), { audio: { secondaryAudioMicrophoneId: s } } = i;
      if (!s)
        return Promise.reject({ type: W, reason: "Cannot stop secondary audio due to not started " });
      r.muteShareAudio(!0, !0), t.leaveSharingAudio(!1), o(Wc(void 0));
    })(this[J]);
  }
  isUserAudioMutedLocally(e) {
    return ((t, r) => {
      let { store: { getState: n } } = t;
      const { audio: { locallyMutedAudioList: o } } = n();
      return o.includes(r);
    })(this[J], e);
  }
  getUserVolumeLocally(e) {
    return ((t, r) => {
      var n, o;
      let { store: { getState: i } } = t;
      const { audio: { localUserAudioVolumeList: s, locallyMutedAudioList: a } } = i();
      return (n = (o = s.find((l) => l.userId === r)) === null || o === void 0 ? void 0 : o.volume) !== null && n !== void 0 ? n : a.includes(r) ? 0 : 100;
    })(this[J], e);
  }
}, K(yt.prototype, "switchSharingSecondaryCamera", [Y, AS, UP], Object.getOwnPropertyDescriptor(yt.prototype, "switchSharingSecondaryCamera"), yt.prototype), K(yt.prototype, "muteUserAudioLocally", [Y, _S, qi], Object.getOwnPropertyDescriptor(yt.prototype, "muteUserAudioLocally"), yt.prototype), K(yt.prototype, "unmuteUserAudioLocally", [Y, RS, qi], Object.getOwnPropertyDescriptor(yt.prototype, "unmuteUserAudioLocally"), yt.prototype), K(yt.prototype, "adjustUserAudioVolumeLocally", [Y, OS, qi], Object.getOwnPropertyDescriptor(yt.prototype, "adjustUserAudioVolumeLocally"), yt.prototype), K(yt.prototype, "muteAllUserAudioLocally", [Y, TS, qi], Object.getOwnPropertyDescriptor(yt.prototype, "muteAllUserAudioLocally"), yt.prototype), K(yt.prototype, "unmuteAllUserAudioLocally", [Y, kS, qi], Object.getOwnPropertyDescriptor(yt.prototype, "unmuteAllUserAudioLocally"), yt.prototype), K(yt.prototype, "startSecondaryAudio", [Y, MS, qi], Object.getOwnPropertyDescriptor(yt.prototype, "startSecondaryAudio"), yt.prototype), K(yt.prototype, "stopSecondaryAudio", [Y, PS, qi], Object.getOwnPropertyDescriptor(yt.prototype, "stopSecondaryAudio"), yt.prototype), yt);
const gd = { controlStatus: $e.NotStarted, sequenceId: 1, rooms: [], isHugeBO: !1, allocationPattern: pu.Automatically, currentRoom: { status: Ee.Initial, boStatus: lE.NoToken, boConfId: "", boId: "", name: "", boToken: "" }, options: { isAutoJoinRoom: !1, isBackToMainSessionEnabled: !0, isTimerEnabled: !1, timerDuration: 1800, isTimerAutoEnabled: !1, waitSeconds: 60, isAutoMovetoMainSession: !1, isRoomSelectionEnabled: !1 }, mainSessionAttendeeList: [], preAssignedRooms: [], meetingElapsedTime: 0, startRoomElapsedTime: 0, closingRoomTime: 0, broadcastMessage: "", hostReplyToQuestionerType: void 0, hostReplyToRequestId: void 0, isUserRoleUpdated: !1, mainSessionConfId: "", isEnableBOBroadcast: !1, isEnableBreakoutRoom: !1, isEnableBOViewActivityStatus: !1, inRoomUserActivityStatusMap: {}, isEnableBOBroadcastVoice: !1, isBroadcastVoice: !1 }, $P = zr({ [`${gI}`]: M((e, t) => {
  let { payload: r } = t;
  Array.isArray(r) ? e.rooms.push(...r) : e.rooms.push(r);
}), [`${yI}`]: M((e, t) => {
  let { payload: r } = t;
  e.allocationPattern = r;
}), [`${Pm}`]: M((e, t) => {
  let { payload: r } = t;
  e.sequenceId = r;
}), [`${Mf}`]: M((e, t) => {
  let { payload: r } = t;
  e.meetingElapsedTime = r;
}), [`${SI}`]: M((e, t) => {
  let { payload: r } = t;
  e.startRoomElapsedTime = r;
}), [`${bI}`]: M((e, t) => {
  let { payload: r } = t;
  const { options: n } = e;
  Object.assign(n, r);
}), [`${CI}`]: M((e, t) => {
  let { payload: r } = t;
  e.controlStatus = r;
}), [`${Jd}`]: M((e, t) => {
  let { payload: r } = t;
  e.rooms = r;
}), [`${s0}`]: M((e, t) => {
  let { payload: r } = t;
  const { currentRoom: n } = e;
  Object.assign(n, r);
}), [`${Is}`]: M((e, t) => {
  let { payload: r } = t;
  const { currentRoom: n } = e;
  n.status = r;
}), [`${Pf}`]: M((e, t) => {
  let { payload: r } = t;
  const { currentRoom: n } = e;
  n.boConfId = r;
}), [`${Df}`]: M((e, t) => {
  let { payload: r } = t;
  const { currentRoom: n } = e;
  n.boToken = r;
}), [`${Lf}`]: M((e, t) => {
  let { payload: r } = t;
  e.closingRoomTime = r;
}), [`${EI}`]: M((e, t) => {
  let { payload: r } = t;
  e.broadcastMessage = r;
}), [`${Dm}`]: M((e, t) => {
  let { payload: r } = t;
  e.hostReplyToQuestionerType = r;
}), [`${II}`]: M((e, t) => {
  let { payload: r } = t;
  e.hostReplyToRequestId = r;
}), [`${AI}`]: M((e, t) => {
  let { payload: r } = t;
  r.add !== void 0 && r.add.length > 0 && r.add.forEach((n) => {
    const o = e.mainSessionAttendeeList.find((i) => i.userId === n.userId);
    o !== void 0 ? Object.assign(o, n) : Bc(n.userRole) || e.mainSessionAttendeeList.push(n);
  }), r.update !== void 0 && r.update.length > 0 && r.update.forEach((n) => {
    const o = e.mainSessionAttendeeList.find((i) => i.userId === n.userId);
    o !== void 0 && Object.assign(o, n);
  }), r.remove !== void 0 && r.remove.length > 0 && r.remove.forEach((n) => {
    const o = e.mainSessionAttendeeList.findIndex((i) => i.userId === n.userId);
    o !== -1 && e.mainSessionAttendeeList.splice(o, 1);
  });
}), [`${_I}`]: M((e, t) => {
  let { payload: r } = t;
  e.isHugeBO = r;
}), [`${xf}`]: M((e, t) => {
  let { payload: r } = t;
  e.isUserRoleUpdated = r;
}), [`${Nf}`]: M((e, t) => {
  let { payload: r } = t;
  e.preAssignedRooms = r;
}), [`${RI}`]: M((e, t) => {
  let { payload: r } = t;
  e.isEnableBreakoutRoom = r.isEnableBreakoutRoom, e.isEnableBOBroadcast = r.isEnableBOBroadcast, e.isEnableBOViewActivityStatus = r.isEnableBOViewActivityStatus, e.isEnableBOBroadcastVoice = r.isEnableBOBroadcastVoice;
}), [`${OI}`]: M((e, t) => {
  let { payload: r } = t;
  const { userGuid: n, status: o } = r, { inRoomUserActivityStatusMap: i } = e;
  i[`${n}`] = o;
}), [`${a0}`]: M((e, t) => {
  let { payload: r } = t;
  e.isBroadcastVoice = r;
}), [`${wI}`]: (e) => {
  const { currentRoom: { status: t } } = e;
  return t === Ee.Joining ? { ...gd, preAssignedRooms: e.preAssignedRooms, currentRoom: e.currentRoom, closingRoomTime: e.closingRoomTime } : t === Ee.Leaving ? { ...gd, preAssignedRooms: e.preAssignedRooms, closingRoomTime: e.closingRoomTime } : { ...gd, preAssignedRooms: e.preAssignedRooms };
} }, gd);
var pr = Uint8Array, on = Uint16Array, op = Uint32Array, ip = new pr([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0, 0]), sp = new pr([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 0, 0]), cv = new pr([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), I_ = function(e, t) {
  for (var r = new on(31), n = 0; n < 31; ++n)
    r[n] = t += 1 << e[n - 1];
  var o = new op(r[30]);
  for (n = 1; n < 30; ++n)
    for (var i = r[n]; i < r[n + 1]; ++i)
      o[i] = i - r[n] << 5 | n;
  return [r, o];
}, A_ = I_(ip, 2), __ = A_[0], pv = A_[1];
__[28] = 258, pv[258] = 28;
for (var DS = I_(sp, 0), HP = DS[0], LS = DS[1], hv = new on(32768), _t = 0; _t < 32768; ++_t) {
  var Ki = (43690 & _t) >>> 1 | (21845 & _t) << 1;
  Ki = (61680 & (Ki = (52428 & Ki) >>> 2 | (13107 & Ki) << 2)) >>> 4 | (3855 & Ki) << 4, hv[_t] = ((65280 & Ki) >>> 8 | (255 & Ki) << 8) >>> 1;
}
var Oo = function(e, t, r) {
  for (var n = e.length, o = 0, i = new on(t); o < n; ++o)
    e[o] && ++i[e[o] - 1];
  var s, a = new on(t);
  for (o = 0; o < t; ++o)
    a[o] = a[o - 1] + i[o - 1] << 1;
  if (r) {
    s = new on(1 << t);
    var l = 15 - t;
    for (o = 0; o < n; ++o)
      if (e[o])
        for (var u = o << 4 | e[o], d = t - e[o], c = a[e[o] - 1]++ << d, p = c | (1 << d) - 1; c <= p; ++c)
          s[hv[c] >>> l] = u;
  } else
    for (s = new on(n), o = 0; o < n; ++o)
      e[o] && (s[o] = hv[a[e[o] - 1]++] >>> 15 - e[o]);
  return s;
}, Ni = new pr(288);
for (_t = 0; _t < 144; ++_t)
  Ni[_t] = 8;
for (_t = 144; _t < 256; ++_t)
  Ni[_t] = 9;
for (_t = 256; _t < 280; ++_t)
  Ni[_t] = 7;
for (_t = 280; _t < 288; ++_t)
  Ni[_t] = 8;
var Ou = new pr(32);
for (_t = 0; _t < 32; ++_t)
  Ou[_t] = 5;
var FP = Oo(Ni, 9, 0), zP = Oo(Ni, 9, 1), WP = Oo(Ou, 5, 0), ZP = Oo(Ou, 5, 1), Ih = function(e) {
  for (var t = e[0], r = 1; r < e.length; ++r)
    e[r] > t && (t = e[r]);
  return t;
}, Fn = function(e, t, r) {
  var n = t / 8 | 0;
  return (e[n] | e[n + 1] << 8) >> (7 & t) & r;
}, Ah = function(e, t) {
  var r = t / 8 | 0;
  return (e[r] | e[r + 1] << 8 | e[r + 2] << 16) >> (7 & t);
}, rg = function(e) {
  return (e + 7) / 8 | 0;
}, P0 = function(e, t, r) {
  (t == null || t < 0) && (t = 0), (r == null || r > e.length) && (r = e.length);
  var n = new (e.BYTES_PER_ELEMENT == 2 ? on : e.BYTES_PER_ELEMENT == 4 ? op : pr)(r - t);
  return n.set(e.subarray(t, r)), n;
}, GP = ["unexpected EOF", "invalid block type", "invalid length/literal", "invalid distance", "stream finished", "no stream handler", , "no callback", "invalid UTF-8 data", "extra field too long", "date not in range 1980-2099", "filename too long", "stream finishing", "invalid zip data"], fo = function(e, t, r) {
  var n = new Error(t || GP[e]);
  if (n.code = e, Error.captureStackTrace && Error.captureStackTrace(n, fo), !r)
    throw n;
  return n;
}, Bo = function(e, t, r) {
  r <<= 7 & t;
  var n = t / 8 | 0;
  e[n] |= r, e[n + 1] |= r >>> 8;
}, _l = function(e, t, r) {
  r <<= 7 & t;
  var n = t / 8 | 0;
  e[n] |= r, e[n + 1] |= r >>> 8, e[n + 2] |= r >>> 16;
}, _h = function(e, t) {
  for (var r = [], n = 0; n < e.length; ++n)
    e[n] && r.push({ s: n, f: e[n] });
  var o = r.length, i = r.slice();
  if (!o)
    return [ng, 0];
  if (o == 1) {
    var s = new pr(r[0].s + 1);
    return s[r[0].s] = 1, [s, 1];
  }
  r.sort(function(w, _) {
    return w.f - _.f;
  }), r.push({ s: -1, f: 25001 });
  var a = r[0], l = r[1], u = 0, d = 1, c = 2;
  for (r[0] = { s: -1, f: a.f + l.f, l: a, r: l }; d != o - 1; )
    a = r[r[u].f < r[c].f ? u++ : c++], l = r[u != d && r[u].f < r[c].f ? u++ : c++], r[d++] = { s: -1, f: a.f + l.f, l: a, r: l };
  var p = i[0].s;
  for (n = 1; n < o; ++n)
    i[n].s > p && (p = i[n].s);
  var h = new on(p + 1), v = fv(r[d - 1], h, 0);
  if (v > t) {
    n = 0;
    var f = 0, m = v - t, g = 1 << m;
    for (i.sort(function(w, _) {
      return h[_.s] - h[w.s] || w.f - _.f;
    }); n < o; ++n) {
      var C = i[n].s;
      if (!(h[C] > t))
        break;
      f += g - (1 << v - h[C]), h[C] = t;
    }
    for (f >>>= m; f > 0; ) {
      var b = i[n].s;
      h[b] < t ? f -= 1 << t - h[b]++ - 1 : ++n;
    }
    for (; n >= 0 && f; --n) {
      var E = i[n].s;
      h[E] == t && (--h[E], ++f);
    }
    v = t;
  }
  return [new pr(h), v];
}, fv = function(e, t, r) {
  return e.s == -1 ? Math.max(fv(e.l, t, r + 1), fv(e.r, t, r + 1)) : t[e.s] = r;
}, NS = function(e) {
  for (var t = e.length; t && !e[--t]; )
    ;
  for (var r = new on(++t), n = 0, o = e[0], i = 1, s = function(l) {
    r[n++] = l;
  }, a = 1; a <= t; ++a)
    if (e[a] == o && a != t)
      ++i;
    else {
      if (!o && i > 2) {
        for (; i > 138; i -= 138)
          s(32754);
        i > 2 && (s(i > 10 ? i - 11 << 5 | 28690 : i - 3 << 5 | 12305), i = 0);
      } else if (i > 3) {
        for (s(o), --i; i > 6; i -= 6)
          s(8304);
        i > 2 && (s(i - 3 << 5 | 8208), i = 0);
      }
      for (; i--; )
        s(o);
      i = 1, o = e[a];
    }
  return [r.subarray(0, n), t];
}, Rl = function(e, t) {
  for (var r = 0, n = 0; n < t.length; ++n)
    r += e[n] * t[n];
  return r;
}, vv = function(e, t, r) {
  var n = r.length, o = rg(t + 2);
  e[o] = 255 & n, e[o + 1] = n >>> 8, e[o + 2] = 255 ^ e[o], e[o + 3] = 255 ^ e[o + 1];
  for (var i = 0; i < n; ++i)
    e[o + i + 4] = r[i];
  return 8 * (o + 4 + n);
}, xS = function(e, t, r, n, o, i, s, a, l, u, d) {
  Bo(t, d++, r), ++o[256];
  for (var c = _h(o, 15), p = c[0], h = c[1], v = _h(i, 15), f = v[0], m = v[1], g = NS(p), C = g[0], b = g[1], E = NS(f), w = E[0], _ = E[1], I = new on(19), D = 0; D < C.length; ++D)
    I[31 & C[D]]++;
  for (D = 0; D < w.length; ++D)
    I[31 & w[D]]++;
  for (var B = _h(I, 7), L = B[0], R = B[1], y = 19; y > 4 && !L[cv[y - 1]]; --y)
    ;
  var A, k, T, N, F = u + 5 << 3, $ = Rl(o, Ni) + Rl(i, Ou) + s, re = Rl(o, p) + Rl(i, f) + s + 14 + 3 * y + Rl(I, L) + (2 * I[16] + 3 * I[17] + 7 * I[18]);
  if (F <= $ && F <= re)
    return vv(t, d, e.subarray(l, l + u));
  if (Bo(t, d, 1 + (re < $)), d += 2, re < $) {
    A = Oo(p, h, 0), k = p, T = Oo(f, m, 0), N = f;
    var fe = Oo(L, R, 0);
    for (Bo(t, d, b - 257), Bo(t, d + 5, _ - 1), Bo(t, d + 10, y - 4), d += 14, D = 0; D < y; ++D)
      Bo(t, d + 3 * D, L[cv[D]]);
    d += 3 * y;
    for (var le = [C, w], Ae = 0; Ae < 2; ++Ae) {
      var Re = le[Ae];
      for (D = 0; D < Re.length; ++D) {
        var Se = 31 & Re[D];
        Bo(t, d, fe[Se]), d += L[Se], Se > 15 && (Bo(t, d, Re[D] >>> 5 & 127), d += Re[D] >>> 12);
      }
    }
  } else
    A = FP, k = Ni, T = WP, N = Ou;
  for (D = 0; D < a; ++D)
    if (n[D] > 255) {
      Se = n[D] >>> 18 & 31, _l(t, d, A[Se + 257]), d += k[Se + 257], Se > 7 && (Bo(t, d, n[D] >>> 23 & 31), d += ip[Se]);
      var ye = 31 & n[D];
      _l(t, d, T[ye]), d += N[ye], ye > 3 && (_l(t, d, n[D] >>> 5 & 8191), d += sp[ye]);
    } else
      _l(t, d, A[n[D]]), d += k[n[D]];
  return _l(t, d, A[256]), d + k[256];
}, qP = new op([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]), ng = new pr(0), KP = function() {
  for (var e = new Int32Array(256), t = 0; t < 256; ++t) {
    for (var r = t, n = 9; --n; )
      r = (1 & r && -306674912) ^ r >>> 1;
    e[t] = r;
  }
  return e;
}(), Rh = function(e, t, r) {
  for (; r; ++t)
    e[t] = r, r >>>= 8;
};
function JP(e, t) {
  t || (t = {});
  var r = /* @__PURE__ */ function() {
    var s = -1;
    return { p: function(a) {
      for (var l = s, u = 0; u < a.length; ++u)
        l = KP[255 & l ^ a[u]] ^ l >>> 8;
      s = l;
    }, d: function() {
      return ~s;
    } };
  }(), n = e.length;
  r.p(e);
  var o = function(s, a, l, u, d) {
    return function(c, p, h, v, f, m) {
      var g = c.length, C = new pr(v + g + 5 * (1 + Math.ceil(g / 7e3)) + f), b = C.subarray(v, C.length - f), E = 0;
      if (!p || g < 8)
        for (var w = 0; w <= g; w += 65535) {
          var _ = w + 65535;
          _ >= g && (b[E >> 3] = m), E = vv(b, E + 1, c.subarray(w, _));
        }
      else {
        for (var I = qP[p - 1], D = I >>> 13, B = 8191 & I, L = (1 << h) - 1, R = new on(32768), y = new on(L + 1), A = Math.ceil(h / 3), k = 2 * A, T = function(Ze) {
          return (c[Ze] ^ c[Ze + 1] << A ^ c[Ze + 2] << k) & L;
        }, N = new op(25e3), F = new on(288), $ = new on(32), re = 0, fe = 0, le = (w = 0, 0), Ae = 0, Re = 0; w < g; ++w) {
          var Se = T(w), ye = 32767 & w, Oe = y[Se];
          if (R[ye] = Oe, y[Se] = ye, Ae <= w) {
            var Ue = g - w;
            if ((re > 7e3 || le > 24576) && Ue > 423) {
              E = xS(c, b, 0, N, F, $, fe, le, Re, w - Re, E), le = re = fe = 0, Re = w;
              for (var Ve = 0; Ve < 286; ++Ve)
                F[Ve] = 0;
              for (Ve = 0; Ve < 30; ++Ve)
                $[Ve] = 0;
            }
            var U = 2, j = 0, P = B, Z = ye - Oe & 32767;
            if (Ue > 2 && Se == T(w - Z))
              for (var H = Math.min(D, Ue) - 1, me = Math.min(32767, w), Ce = Math.min(258, Ue); Z <= me && --P && ye != Oe; ) {
                if (c[w + U] == c[w + U - Z]) {
                  for (var _e = 0; _e < Ce && c[w + _e] == c[w + _e - Z]; ++_e)
                    ;
                  if (_e > U) {
                    if (U = _e, j = Z, _e > H)
                      break;
                    var Me = Math.min(Z, _e - 2), je = 0;
                    for (Ve = 0; Ve < Me; ++Ve) {
                      var Ne = w - Z + Ve + 32768 & 32767, Le = Ne - R[Ne] + 32768 & 32767;
                      Le > je && (je = Le, Oe = Ne);
                    }
                  }
                }
                Z += (ye = Oe) - (Oe = R[ye]) + 32768 & 32767;
              }
            if (j) {
              N[le++] = 268435456 | pv[U] << 18 | LS[j];
              var Qe = 31 & pv[U], Ye = 31 & LS[j];
              fe += ip[Qe] + sp[Ye], ++F[257 + Qe], ++$[Ye], Ae = w + U, ++re;
            } else
              N[le++] = c[w], ++F[c[w]];
          }
        }
        E = xS(c, b, m, N, F, $, fe, le, Re, w - Re, E), !m && 7 & E && (E = vv(b, E + 1, ng));
      }
      return P0(C, 0, v + rg(E) + f);
    }(s, a.level == null ? 6 : a.level, a.mem == null ? Math.ceil(1.5 * Math.max(8, Math.min(13, Math.log(s.length)))) : 12 + a.mem, l, u, !d);
  }(e, t, function(s) {
    return 10 + (s.filename && s.filename.length + 1 || 0);
  }(t), 8), i = o.length;
  return function(s, a) {
    var l = a.filename;
    if (s[0] = 31, s[1] = 139, s[2] = 8, s[8] = a.level < 2 ? 4 : a.level == 9 ? 2 : 0, s[9] = 3, a.mtime != 0 && Rh(s, 4, Math.floor(new Date(a.mtime || Date.now()) / 1e3)), l) {
      s[3] = 8;
      for (var u = 0; u <= l.length; ++u)
        s[u + 10] = l.charCodeAt(u);
    }
  }(o, t), Rh(o, i - 8, r.d()), Rh(o, i - 4, n), o;
}
var VS = typeof TextEncoder != "undefined" && new TextEncoder(), mv = typeof TextDecoder != "undefined" && new TextDecoder();
try {
  mv.decode(ng, { stream: !0 });
} catch {
}
const { WebclientBreakoutRoomAttendeeStatus: og, WebclientBreakoutRoomCommand: QP } = lt, Oh = Vr(ke.getInstance());
function Zn(e, t) {
  let r = 0;
  for (; r < e.length; r++) {
    const n = e[r], { attendeeGuidList: o } = n;
    if (o != null && o.includes(t))
      break;
  }
  return r < e.length ? e[r] : void 0;
}
function sa() {
  xe.remove(og), xe.remove(QP);
}
function gv() {
  return We.createAgent().leaveBO(1), O(Hr, { reason: hr.BackToMainSession }), sa(), [Is(Ee.Leaving), Tr(or.NormalCase)];
}
function Th(e, t) {
  return O(Hr, { reason: hr.JoinBreakoutRoom, roomName: e }), t === Ee.InRoom && We.createAgent().leaveBO(1), [Is(Ee.Joining), Tr(or.NormalCase)];
}
function jS(e) {
  return O(Hr, { reason: hr.MoveToBreakoutRoom, roomName: e }), We.createAgent().leaveBO(1), [Is(Ee.Joining), Tr(or.NormalCase)];
}
function kh(e) {
  return e !== Ee.InRoom && e !== Ee.Joining && e !== Ee.Leaving;
}
function yd(e) {
  const t = arguments.length > 1 && arguments[1] !== void 0 && arguments[1] ? Ee.InRoom : Ee.Invited;
  return xe.set(og, JSON.stringify({ status: t, boId: e.boId }), qe.SessionStorage), s0({ status: t, boId: e.boId, name: e.name, boStatus: e.boStatus });
}
function Mh(e) {
  const { breakoutRoom: { isUserRoleUpdated: t, currentRoom: { boConfId: r } } } = e.value, n = be(e.value);
  return n && (!r || r && t) ? Je(n.isHost) : (r ? ht(of, 1) : ht(xu, 2).pipe(yr(function(i, s) {
    var a = [];
    i.subscribe(Ht(s, function(l) {
      a.push(l), 1 < a.length && a.shift();
    }, function() {
      var l, u;
      try {
        for (var d = ja(a), c = d.next(); !c.done; c = d.next()) {
          var p = c.value;
          s.next(p);
        }
      } catch (h) {
        l = { error: h };
      } finally {
        try {
          c && !c.done && (u = d.return) && u.call(d);
        } finally {
          if (l)
            throw l.error;
        }
      }
      s.complete();
    }, void 0, function() {
      a = null;
    }));
  }))).pipe(Fr(Du), pe(e), ae((i) => {
    let [, s] = i;
    return be(s).isHost;
  }));
}
function R_(e) {
  return G0({ boIdList: ht($w).pipe(m9((t, r) => [...t, r], []), Ge(e)) }).pipe(u4(1e4));
}
const YP = [{ mask: xp.Connect, key: "audio", value: "" }, { mask: xp.Voip, key: "audio", value: "computer" }, { mask: xp.Muted, key: "muted", value: !0 }, { mask: N2.Connect, key: "bVideoOn", value: !1 }, { mask: N2.On, key: "bVideoOn", value: !0 }, { mask: x2.Share, key: "sharerOn", value: !0 }, { mask: x2.ShareAudio, key: "bShareAudioOn", value: !0 }];
function US(e, t) {
  const r = (Ro(t) ? t.breakoutRoom.mainSessionAttendeeList : t.participants.attendeesList).find((n) => n.userId === Number(e));
  return r ? { inviterId: r.userId, inviterGuid: r.userGUID, inviterName: r.displayName } : {};
}
const zn = We.createAgent(), BS = ["userRole", "bCoHost", "bCCEditor", "bHold"], XP = We.createAgent(), eD = Vr(ke.getInstance());
var He;
const Ut = We.createAgent(), $S = Vr(ke.getInstance()), dn = nn("Breakout Room");
let tD = (He = class extends Po {
  createRooms(e, t) {
    const r = this[ce](), n = this[Nt], { breakoutRoom: { isHugeBO: o, sequenceId: i, rooms: s, controlStatus: a, isEnableBreakoutRoom: l } } = r;
    if (!l)
      return Promise.reject({ type: W, reason: "Breakout room feature is not enabled." });
    if (a === $e.InProgress || a === $e.Closing)
      return Promise.resolve({ type: W, reason: "breakout room has started!" });
    let u;
    u = typeof e == "string" ? [e] : typeof e == "number" ? Array.from({ length: e }).map((c, p) => `Subsession ${p + i}`) : e;
    const d = o ? 100 : 50;
    return u.length < 1 || s.length + u.length > d ? Promise.reject({ type: De, reason: "exceed maximum size" }) : (Ut.batchCreateBOToken(u), new Promise((c, p) => {
      R_(u.length).subscribe((h) => {
        let { boIdList: v } = h, f = v.map((g, C) => ({ boId: g, name: u[C] }));
        if (t === pu.Automatically) {
          const g = yh(r), C = f.length, b = g.length;
          f = f.map((E, w) => {
            const _ = [];
            let I = w;
            for (; I < b; )
              _.push(g[I]), I += C;
            return { ...E, attendeeList: _ };
          });
        }
        const m = f.map((g) => {
          let { boId: C, name: b, attendeeList: E } = g;
          return { boId: C, name: b, attendeeGuidList: E && E.map((w) => w.userGUID) };
        });
        if (n(gI(m)), n(yI(t)), n(Pm(i + f.length)), t === pu.Automatically) {
          const g = f.map((C) => ({ roomId: C.boId, name: C.name, attendeeList: C.attendeeList.map((b) => ({ userId: b.userId, avatar: b.avatar, displayName: b.displayName })) }));
          c(g);
        } else
          c(f.map((g) => ({ roomId: g.boId, name: g.name, attendeeList: [] })));
      }, () => {
        p({ type: Eo });
      });
    }));
  }
  openRooms(e, t) {
    var r;
    const n = this[ce](), o = { isAutoJoinRoom: !1, isBackToMainSessionEnabled: !0, isTimerEnabled: !1, timerDuration: 1800, isTimerAutoEnabled: !1, waitSeconds: 60, isAutoMoveBackToMainSession: !1, isRoomSelectionEnabled: !1 }, { breakoutRoom: { controlStatus: i, rooms: s, sequenceId: a, isHugeBO: l } } = n;
    if (i === $e.InProgress || i === $e.Closing)
      return Promise.resolve({ type: W, reason: "breakout room has started!" });
    if (e.some((v) => s.findIndex((f) => f.boId === v.roomId) === -1))
      return Promise.reject({ type: De, reason: "roomId is wrong" });
    const u = ft(n);
    if (e.reduce((v, f) => v.concat(f.attendeeList), []).some((v) => u.findIndex((f) => f.userId === v.userId) === -1))
      return Promise.reject({ type: De, reason: "bad user" });
    const d = e.map((v) => {
      const { attendeeList: f } = v, m = f.map((g) => {
        const C = u.find((b) => b.userId === g.userId);
        return C == null ? void 0 : C.userGUID;
      });
      return { BID: v.roomId, MeetingTitle: v.name, MeetingToken: void 0, Status: lE.Started, HostID: "", ParticipantList: m };
    }), c = t ? { ...o, ...t } : o, p = { ControlStatus: $e.InProgress, NameIndex: a, IsAutoJoinEnabled: +c.isAutoJoinRoom, IsBackToMainSessionEnabled: +c.isBackToMainSessionEnabled, IsTimerEnabled: +c.isTimerEnabled, TimerDuration: c.timerDuration, IsTimerAutoEndEnabled: +c.isTimerAutoEnabled, WaitSeconds: c.waitSeconds < 0 ? 0 : c.waitSeconds, StartTimeOnMMR: void 0, ItemList: d, IsAutoMovetoMainSessionEnabled: c.isAutoMoveBackToMainSession, IsParticipantsChooseRoomEnabled: +c.isRoomSelectionEnabled };
    let h = q4(JSON.stringify(p));
    if (l && (h = ((v) => K0.fromUint8Array(JP(function(f, m) {
      var g;
      if (VS)
        return VS.encode(f);
      var C = f.length, b = new pr(f.length + (f.length >> 1)), E = 0, w = function(D) {
        b[E++] = D;
      };
      for (g = 0; g < C; ++g) {
        if (E + 5 > b.length) {
          var _ = new pr(E + 8 + (C - g << 1));
          _.set(b), b = _;
        }
        var I = f.charCodeAt(g);
        I < 128 ? w(I) : I < 2048 ? (w(192 | I >> 6), w(128 | 63 & I)) : I > 55295 && I < 57344 ? (w(240 | (I = 65536 + (1047552 & I) | 1023 & f.charCodeAt(++g)) >> 18), w(128 | I >> 12 & 63), w(128 | I >> 6 & 63), w(128 | 63 & I)) : (w(224 | I >> 12), w(128 | I >> 6 & 63), w(128 | 63 & I));
      }
      return P0(b, 0, E);
    }(v))))(h)), (r = be(n)) !== null && r !== void 0 && r.isHost)
      Ut.startBO(h);
    else {
      const v = ea(n);
      v && Ut.coHostStartBO(h, v.userId);
    }
    return Te(as, (v) => v.controlStatus === $e.InProgress);
  }
  joinRoom(e) {
    const t = this[ce](), r = be(t), { breakoutRoom: { controlStatus: n, rooms: o, mainSessionAttendeeList: i, options: { isRoomSelectionEnabled: s }, currentRoom: { status: a, boId: l } }, meeting: { userGUID: u } } = t;
    if (n !== $e.InProgress)
      return Promise.reject({ type: _a, reason: "Breakout room is not started" });
    if (r != null && r.isHost) {
      const d = o.find((c) => c.boId === e);
      if (!d)
        return Promise.reject({ type: De, reason: "Room ID is not correct" });
      Ut.joinBO(d.boId);
    } else if (r != null && r.bCoHost && a === Ee.InRoom) {
      if (!o.find((d) => d.boId === e))
        return Promise.reject({ type: De, reason: "Room ID is not correct" });
      {
        const d = i.find((c) => c.isHost);
        d && Ut.wantJoinBO(d == null ? void 0 : d.userId, e);
      }
    } else {
      if (a === Ee.InRoom && l === e)
        return Promise.resolve("");
      {
        let d = !1;
        const c = Zn(o, u);
        if (c && c.boId === e)
          Ut.joinBO(c.boId);
        else if (s)
          if (o.findIndex((p) => p.boId === e) !== -1) {
            const p = ea(t);
            p && Ut.wantJoinBO(p.userId, e);
          } else
            d = !0;
        else
          d = !0;
        if (d)
          return Promise.reject({ type: De, reason: "Room ID is not correct" });
      }
    }
    return Te(Hd, (d) => d.boId === e);
  }
  leaveRoom() {
    const e = this[ce](), t = this[Nt], { breakoutRoom: { controlStatus: r, options: n, currentRoom: { status: o } } } = e;
    if (r !== $e.InProgress && r !== $e.Closing || o !== Ee.InRoom)
      return Promise.reject({ type: W });
    {
      const i = Sn(e);
      if (!n.isBackToMainSessionEnabled && !i)
        return Promise.reject({ type: Or, reason: "Can not return main session during the breakout room" });
      gv().forEach((s) => t(s));
    }
    return Promise.resolve("");
  }
  askForHelp() {
    const e = this[ce](), { breakoutRoom: { controlStatus: t, mainSessionAttendeeList: r, currentRoom: { status: n } }, participants: { attendeesList: o } } = e, i = Sn(e);
    if (t !== $e.InProgress || n !== Ee.InRoom)
      return Promise.reject({ type: W, reason: "you are not in breakout room" });
    if (i)
      return Promise.reject({ type: W, reason: "host or co-host can not ask for help" });
    {
      const s = r.find((a) => a.isHost);
      if (s) {
        if (o.findIndex((a) => a.zoomID === s.zoomID) > -1)
          return Promise.reject({ type: W, reason: "host is in room" });
        Ut.askForHelpBO(s.userId);
      }
    }
    return Te(gm, (s) => s.result === Ci.Received);
  }
  postponeHelping(e) {
    const t = this[ce](), r = this[Nt], { breakoutRoom: { mainSessionAttendeeList: n, currentRoom: { status: o } }, participants: { attendeesList: i } } = t;
    let s = i;
    return o === Ee.InRoom && (s = n), s.findIndex((a) => a.userId === e) > -1 ? (Ut.askForHelpResultBO(e, Ci.Ignore), r(Dm(Ci.Ignore)), Promise.resolve("")) : Promise.reject({ type: De, reason: "user id is not correct" });
  }
  broadcast(e) {
    const { breakoutRoom: { isEnableBOBroadcast: t } } = this[ce]();
    return t ? e ? ir.beginEncrypt({ text: e, type: mr.BO_BROADCAST }).then((r) => (Ut.broadcastBO(r), Promise.resolve(""))) : Promise.reject({ type: De, reason: "content empty" }) : Promise.reject({ type: W, reason: "Cannot broadcast message due to the feature is not enable" });
  }
  startBroadcastVoice() {
    const e = this[ce](), t = this[Nt], { breakoutRoom: { isEnableBOBroadcast: r, isEnableBOBroadcastVoice: n, isBroadcastVoice: o } } = e;
    if (r && n) {
      if (Ro(e))
        return Promise.reject({ type: W, reason: "Cannot broadcast voice in the room" });
      {
        if (o)
          return Promise.resolve("");
        const i = be(e);
        return (i == null ? void 0 : i.audio) === et.Computer && i.muted === !1 ? (Ut.broadcastVoiceReq(!0), $S.broadcastVoiceToBreakoutRoom(!0), t(a0(!0)), Promise.resolve("")) : Promise.reject({ type: W, reason: "Start audio and unmute to broadcast" });
      }
    }
    return Promise.reject({ type: W, reason: "Cannot broadcast voice due to the feature is not enable" });
  }
  stopBroadcastVoice() {
    const e = this[ce](), t = this[Nt], { breakoutRoom: { isBroadcastVoice: r } } = e;
    return r ? (Ut.broadcastVoiceReq(!1), $S.broadcastVoiceToBreakoutRoom(!1), t(a0(!1)), Promise.resolve("")) : Promise.reject({ type: W, reason: "Cannot stop broadcast voice due to it is not started" });
  }
  assignUserToRoom(e, t) {
    const r = this[ce](), { breakoutRoom: { rooms: n } } = r, o = yh(r).find((s) => s.userId === e);
    if (!(o && n.findIndex((s) => s.boId === t) > -1))
      return Promise.reject({ type: De, reason: "" });
    var i;
    if ((i = be(r)) !== null && i !== void 0 && i.isHost)
      Ut.assignToBO(e, t);
    else {
      const s = ea(r);
      s && Ut.coHostAssignToBO(o.userGUID, t, s.userId);
    }
    return Te(as, (s) => {
      const { controlStatus: a, roomList: l } = s, u = l.find((d) => d.boId === t);
      return a === $e.InProgress && u && u.attendeeGuidList.includes(o.userGUID);
    });
  }
  moveUserToRoom(e, t) {
    const r = this[ce](), { breakoutRoom: { rooms: n, mainSessionAttendeeList: o }, participants: { attendeesList: i } } = r, s = (Ro(r) ? o : i).find((l) => l.userId === e);
    if (!s)
      return Promise.reject({ type: De, reason: "user id not correct" });
    {
      const l = Zn(n, s.userGUID);
      if (!l)
        return Promise.reject({ type: W, reason: "user not in a room" });
      if (l.boId === t)
        return Promise.reject({ type: W, reason: "user already in the target room" });
      {
        const u = n.find((d) => d.boId === t);
        if (!u)
          return Promise.reject({ type: De, reason: "invalid room id" });
        var a;
        if ((a = be(r)) !== null && a !== void 0 && a.isHost)
          Ut.switchBO(e, u.boId);
        else {
          const d = ea(r);
          d && Ut.coHostAssignToBO(s.userGUID, u.boId, d.userId);
        }
      }
    }
    return Te(as, (l) => {
      const { controlStatus: u, roomList: d } = l, c = d.find((p) => p.boId === t);
      return u === $e.InProgress && c && c.attendeeGuidList.includes(s.userGUID);
    });
  }
  moveBackToMainSession(e) {
    const t = this[ce](), { breakoutRoom: { rooms: r, mainSessionAttendeeList: n }, participants: { attendeesList: o } } = t, i = (Ro(t) ? n : o).find((a) => a.userId === e);
    if (!i)
      return Promise.reject({ type: De, reason: "user id not correct" });
    if (!Zn(r, i.userGUID))
      return Promise.reject({ type: W, reason: "user not in a room" });
    var s;
    if ((s = be(t)) !== null && s !== void 0 && s.isHost)
      Ut.moveToMainSession(i.userGUID);
    else {
      const a = ea(t);
      a && Ut.coHostMoveToMainSession(i.userGUID, a.userId);
    }
    return Te(as, (a) => {
      const { controlStatus: l, roomList: u } = a;
      return l === $e.InProgress && u.some((d) => {
        const { attendeeGuidList: c } = d;
        return c.includes(i.userGUID);
      });
    });
  }
  closeRoom() {
    const e = this[ce](), { breakoutRoom: { controlStatus: t } } = e;
    if (t !== $e.InProgress)
      return Promise.reject({ type: W, reason: "room is not started" });
    var r;
    if ((r = be(e)) !== null && r !== void 0 && r.isHost)
      Ut.stopBO($e.Closing);
    else {
      const n = ea(e);
      n && Ut.coHostStopBO($e.Closing, n.userId);
    }
    return Te(as, (n) => n.controlStatus === $e.Closing);
  }
  loadPreAssignedRooms() {
    const e = this[ce](), { meeting: { meetingOptions: t }, breakoutRoom: { controlStatus: r } } = e;
    return !t.isAllowBreakoutRoomPreAssign || r !== $e.NotStarted && r !== $e.Closed ? Promise.reject({ type: W }) : (Ut.preAssignBreakoutRoom(), Te(Ww));
  }
  getUnassignedAttendeeList() {
    const e = this[ce](), t = be(e);
    return t != null && t.isHost || t != null && t.bCoHost ? yh(e).map((r) => La(r)) : [];
  }
  getRoomList() {
    const e = this[ce](), { breakoutRoom: { rooms: t, currentRoom: { status: r, boId: n }, mainSessionAttendeeList: o, inRoomUserActivityStatusMap: i, options: { isRoomSelectionEnabled: s } }, participants: { attendeesList: a } } = e, l = be(e);
    if (l && (l.isHost || l.bCoHost || s)) {
      const u = r === Ee.InRoom, d = u ? o : a;
      return t.map((c) => {
        const { attendeeGuidList: p, boId: h, name: v } = c, f = (p || []).map((m) => d.find((g) => g.userGUID === m)).filter((m) => !(m != null && m.isHost)).filter(Boolean);
        return u && l.isHost && h === n && f.unshift(l), { roomId: h, name: v, attendeeList: f.filter((m) => !!m).map((m) => {
          var g;
          const C = (g = i[m.userGUID]) !== null && g !== void 0 ? g : {};
          return { userId: m.userId, displayName: m.displayName, avatar: m.avatar, isInRoom: m.bid === h, userGuid: m.userGUID, ...C };
        }) };
      });
    }
    return e.breakoutRoom.rooms.map((u) => {
      const { boId: d, name: c } = u;
      return { roomId: d, name: c, attendeeList: [] };
    });
  }
  getAttendeeStatus() {
    return this[ce]().breakoutRoom.currentRoom.status;
  }
  getRoomStatus() {
    return this[ce]().breakoutRoom.controlStatus;
  }
  getCurrentRoom() {
    const e = this[ce](), { breakoutRoom: { currentRoom: { status: t, name: r, boId: n } } } = e;
    return { attendeeStatus: t, name: r, roomId: n };
  }
  getRoomOptions() {
    const e = this[ce](), { breakoutRoom: { options: t } } = e, { whoStart: r, whoStop: n, ...o } = t;
    return { ...o };
  }
}, K(He.prototype, "createRooms", [Y, rr, dn], Object.getOwnPropertyDescriptor(He.prototype, "createRooms"), He.prototype), K(He.prototype, "openRooms", [Y, rr, dn], Object.getOwnPropertyDescriptor(He.prototype, "openRooms"), He.prototype), K(He.prototype, "joinRoom", [Y, dn], Object.getOwnPropertyDescriptor(He.prototype, "joinRoom"), He.prototype), K(He.prototype, "leaveRoom", [Y, dn], Object.getOwnPropertyDescriptor(He.prototype, "leaveRoom"), He.prototype), K(He.prototype, "askForHelp", [Y, dn], Object.getOwnPropertyDescriptor(He.prototype, "askForHelp"), He.prototype), K(He.prototype, "postponeHelping", [Qt, Y, dn], Object.getOwnPropertyDescriptor(He.prototype, "postponeHelping"), He.prototype), K(He.prototype, "broadcast", [rr, Y], Object.getOwnPropertyDescriptor(He.prototype, "broadcast"), He.prototype), K(He.prototype, "startBroadcastVoice", [Qt, Y, dn], Object.getOwnPropertyDescriptor(He.prototype, "startBroadcastVoice"), He.prototype), K(He.prototype, "stopBroadcastVoice", [Qt, Y, dn], Object.getOwnPropertyDescriptor(He.prototype, "stopBroadcastVoice"), He.prototype), K(He.prototype, "assignUserToRoom", [rr, Y, dn], Object.getOwnPropertyDescriptor(He.prototype, "assignUserToRoom"), He.prototype), K(He.prototype, "moveUserToRoom", [rr, Y, dn], Object.getOwnPropertyDescriptor(He.prototype, "moveUserToRoom"), He.prototype), K(He.prototype, "moveBackToMainSession", [rr, Y, dn], Object.getOwnPropertyDescriptor(He.prototype, "moveBackToMainSession"), He.prototype), K(He.prototype, "closeRoom", [rr, Y, dn], Object.getOwnPropertyDescriptor(He.prototype, "closeRoom"), He.prototype), K(He.prototype, "loadPreAssignedRooms", [Qt, Y, dn], Object.getOwnPropertyDescriptor(He.prototype, "loadPreAssignedRooms"), He.prototype), He);
const rD = { breakoutRoomSharingEpics0: (e, t) => vs(e, gt).pipe(z((r) => {
  var n;
  const { payload: { body: o } } = r;
  return o == null || (n = o.update) === null || n === void 0 ? void 0 : n.some((i) => i.bShareToBORooms !== void 0 || i.bShareOn !== void 0);
}), pe(t), ae((r) => {
  let [n, o] = r;
  const { payload: { body: { update: i } } } = n, { breakoutRoom: { mainSessionAttendeeList: s } } = o, a = i.filter((d) => d.bShareOn && d.bShareToBORooms), l = i.filter((d) => !d.bShareOn || !d.bShareToBORooms), u = s.filter((d) => d.sharerOn && d.bShareToBORooms);
  return a.length > 0 && a.forEach((d) => {
    u.findIndex((c) => c.userId === d.id) === -1 && O(fm, { ...d, isFromMainSession: !0 });
  }), l.length > 0 && l.forEach((d) => {
    O(vm, { ...d, isFromMainSession: !0 });
  }), i.map((d) => {
    if (d.bShareOn && d.bShareToBORooms) {
      if (s.filter((c) => c.sharerOn && c.bShareToBORooms && c.userId !== d.id).length === 0)
        return { activeNodeID: d.id, bStatus: 1, ssrc: d.shareSsrc };
      {
        const c = s.find((p) => p.userId === d.id);
        if (c != null && c.isHost)
          return { activeNodeID: d.id, bStatus: 1, ssrc: d.shareSsrc };
      }
    } else if (!d.bShareOn || !d.bShareToBORooms) {
      const c = s.filter((p) => p.bShareToBORooms && p.sharerOn);
      if (c.length === 1 && c[0].userId === d.id)
        return { activeNodeID: d.id, bStatus: 0, ssrc: 0 };
      {
        const p = c.filter((v) => v.userId !== d.id), h = p.find((v) => v.isHost);
        if (h)
          return { activeNodeID: h.userId, bStatus: 1, ssrc: h.shareSsrc };
        {
          const v = p[0];
          if (v)
            return { activeNodeID: v.userId, bStatus: 1, ssrc: v.shareSsrc };
        }
      }
    }
  }).filter(Boolean);
}), G((r) => {
  const { share: { status: n }, meeting: { userId: o } } = t.value, i = [];
  return r.map((s) => {
    const { activeNodeID: a, bStatus: l, ssrc: u } = s, d = l === 1;
    i.push(ME(d)), d && n !== Fe.End && (XP.stopSharing(o), eD.stopDesktopSharing(), i.push(bn(Fe.End)), O(gw));
    let c = { activeNodeID: a, bStatus: l, ssrc: u, fromMainSession: !0 };
    if (!d) {
      const { participants: { attendeesList: p } } = t.value, h = p.filter((v) => v.sharerOn);
      if (h.length > 0) {
        const v = h[0];
        c = { activeNodeID: v.userId, bStatus: 1, ssrc: v.shareSsrc || 0 };
      }
    }
    i.push(js({ evt: P1, body: c }));
  }), ne(i);
})), breakoutRoomSharingEpics1: (e, t) => vs(e, Q0).pipe(ze((r) => {
  const { payload: { body: { userID: n, confID: o } } } = r;
  return Kt(...["sharing", "audio"].map((i) => function(s, a, l, u, d) {
    return vs(a, s === "audio" ? D1 : sm).pipe(Ge(1), he((c) => {
      const { payload: { body: { encryptKey: p, additionalType: h } } } = c, { media: { sharingDecodeStatus: v, audioDecodeStatus: f }, meeting: { svcUrl: m, meetingNumber: g, conId: C, zoomId: b, meetingId: E } } = l.value;
      _r(s, "success", s === "audio" ? f : v).subscribe((w) => {
        let [, _] = w;
        if (_) {
          const I = `wss://${m}/wc/media/${g}?type=${s === "audio" ? "ma" : "ms"}&cid=${C}&mode=1`;
          Oh.createMainSessionChannel(s, I), Oh.updateMediaParams({ iVType: s === "audio" ? qt.AUDIO_DECODE : qt.SHARING_DECODE, isFromMainSession: !0, updateParams: { userId: u, sn: wn(b), confId: d, encryptType: h, encryptKey: wn(p), meetingId: E, meetingNumber: g } });
          const { breakoutRoom: { mainSessionAttendeeList: D } } = l.value;
          if ((D == null ? void 0 : D.length) > 0) {
            const B = D.map((L) => ({ userid: L.userId, sn: L.zoomID && wn(L.zoomID) }));
            Oh.updateUserMediaSN({ added: B, isFromMainSession: !0, iVType: s === "audio" ? qt.AUDIO_DECODE : qt.SHARING_DECODE });
          }
        }
      });
    }), Ie(oe));
  }(i, e, t, n, o)));
})) }, nD = { epics0: (e, t) => e.pipe(ge(`${ti}`), ze((r) => {
  const { breakoutRoom: n, meeting: { meetingOptions: o } } = t.value, { payload: { hugeBO: i, elapsed: s } } = r, a = [];
  return n && (o && (a.push(_I(i && o.isBO100Enabled === !0)), a.push(RI({ isEnableBreakoutRoom: o.isEnableBreakoutRoom, isEnableBOBroadcast: o.isEnableBOBroadcast, isEnableBOViewActivityStatus: o.isEnableBOViewActivityStatus, isEnableBOBroadcastVoice: o.isEnableBOBroadcastVoice }))), n.currentRoom.boConfId && a.push(b1()), s !== void 0 && a.push(Mf(s))), ne(a);
})), epics1: (e) => se(e, 4174).pipe(he((t) => {
  O($w, t.payload.body.bid);
}), Ie(oe)), epics2: (e, t) => to(e, 7950).pipe(pe(t), ze((r) => {
  let [n, o] = r;
  const { payload: { body: { proto: i } } } = n, { breakoutRoom: { isHugeBO: s, currentRoom: { status: a, boId: l } }, meeting: { userGUID: u } } = o;
  let d = i;
  s && (d = function(h, v) {
    if (v) {
      for (var f = "", m = 0; m < h.length; m += 16384)
        f += String.fromCharCode.apply(null, h.subarray(m, m + 16384));
      return f;
    }
    if (mv)
      return mv.decode(h);
    var g = function(b) {
      for (var E = "", w = 0; ; ) {
        var _ = b[w++], I = (_ > 127) + (_ > 223) + (_ > 239);
        if (w + I > b.length)
          return [E, P0(b, w - 1)];
        I ? I == 3 ? (_ = ((15 & _) << 18 | (63 & b[w++]) << 12 | (63 & b[w++]) << 6 | 63 & b[w++]) - 65536, E += String.fromCharCode(55296 | _ >> 10, 56320 | 1023 & _)) : E += 1 & I ? String.fromCharCode((31 & _) << 6 | 63 & b[w++]) : String.fromCharCode((15 & _) << 12 | (63 & b[w++]) << 6 | 63 & b[w++]) : E += String.fromCharCode(_);
      }
    }(h), C = g[0];
    return g[1].length && fo(8), C;
  }(function(h, v) {
    return function(f, m, g) {
      var C = f.length;
      if (!C || g && g.f && !g.l)
        return m || new pr(0);
      var b = !m || g, E = !g || g.i;
      g || (g = {}), m || (m = new pr(3 * C));
      var w = function(Qe) {
        var Ye = m.length;
        if (Qe > Ye) {
          var Ze = new pr(Math.max(2 * Ye, Qe));
          Ze.set(m), m = Ze;
        }
      }, _ = g.f || 0, I = g.p || 0, D = g.b || 0, B = g.l, L = g.d, R = g.m, y = g.n, A = 8 * C;
      do {
        if (!B) {
          _ = Fn(f, I, 1);
          var k = Fn(f, I + 1, 3);
          if (I += 3, !k) {
            var T = f[(Oe = rg(I) + 4) - 4] | f[Oe - 3] << 8, N = Oe + T;
            if (N > C) {
              E && fo(0);
              break;
            }
            b && w(D + T), m.set(f.subarray(Oe, N), D), g.b = D += T, g.p = I = 8 * N, g.f = _;
            continue;
          }
          if (k == 1)
            B = zP, L = ZP, R = 9, y = 5;
          else if (k == 2) {
            var F = Fn(f, I, 31) + 257, $ = Fn(f, I + 10, 15) + 4, re = F + Fn(f, I + 5, 31) + 1;
            I += 14;
            for (var fe = new pr(re), le = new pr(19), Ae = 0; Ae < $; ++Ae)
              le[cv[Ae]] = Fn(f, I + 3 * Ae, 7);
            I += 3 * $;
            var Re = Ih(le), Se = (1 << Re) - 1, ye = Oo(le, Re, 1);
            for (Ae = 0; Ae < re; ) {
              var Oe, Ue = ye[Fn(f, I, Se)];
              if (I += 15 & Ue, (Oe = Ue >>> 4) < 16)
                fe[Ae++] = Oe;
              else {
                var Ve = 0, U = 0;
                for (Oe == 16 ? (U = 3 + Fn(f, I, 3), I += 2, Ve = fe[Ae - 1]) : Oe == 17 ? (U = 3 + Fn(f, I, 7), I += 3) : Oe == 18 && (U = 11 + Fn(f, I, 127), I += 7); U--; )
                  fe[Ae++] = Ve;
              }
            }
            var j = fe.subarray(0, F), P = fe.subarray(F);
            R = Ih(j), y = Ih(P), B = Oo(j, R, 1), L = Oo(P, y, 1);
          } else
            fo(1);
          if (I > A) {
            E && fo(0);
            break;
          }
        }
        b && w(D + 131072);
        for (var Z = (1 << R) - 1, H = (1 << y) - 1, me = I; ; me = I) {
          var Ce = (Ve = B[Ah(f, I) & Z]) >>> 4;
          if ((I += 15 & Ve) > A) {
            E && fo(0);
            break;
          }
          if (Ve || fo(2), Ce < 256)
            m[D++] = Ce;
          else {
            if (Ce == 256) {
              me = I, B = null;
              break;
            }
            var _e = Ce - 254;
            if (Ce > 264) {
              var Me = ip[Ae = Ce - 257];
              _e = Fn(f, I, (1 << Me) - 1) + __[Ae], I += Me;
            }
            var je = L[Ah(f, I) & H], Ne = je >>> 4;
            if (je || fo(3), I += 15 & je, P = HP[Ne], Ne > 3 && (Me = sp[Ne], P += Ah(f, I) & (1 << Me) - 1, I += Me), I > A) {
              E && fo(0);
              break;
            }
            b && w(D + 131072);
            for (var Le = D + _e; D < Le; D += 4)
              m[D] = m[D - P], m[D + 1] = m[D + 1 - P], m[D + 2] = m[D + 2 - P], m[D + 3] = m[D + 3 - P];
            D = Le;
          }
        }
        g.l = B, g.p = me, g.b = D, g.f = _, B && (_ = 1, g.m = R, g.d = L, g.n = y);
      } while (!_);
      return D == m.length ? m : P0(m, 0, D);
    }(h.subarray(function(f) {
      f[0] == 31 && f[1] == 139 && f[2] == 8 || fo(6, "invalid gzip data");
      var m = f[3], g = 10;
      4 & m && (g += f[10] | 2 + (f[11] << 8));
      for (var C = (m >> 3 & 1) + (m >> 4 & 1); C > 0; C -= !f[g++])
        ;
      return g + (2 & m);
    }(h), -8), v || new pr(function(f) {
      var m = f.length;
      return (f[m - 4] | f[m - 3] << 8 | f[m - 2] << 16 | f[m - 1] << 24) >>> 0;
    }(h)));
  }(wn(i))));
  const c = [];
  let p;
  try {
    const h = JSON.parse(no(d)), { ControlStatus: v, NameIndex: f, IsAutoJoinEnabled: m, IsBackToMainSessionEnabled: g, IsParticipantsChooseRoomEnabled: C, IsTimerEnabled: b, TimerDuration: E, IsTimerAutoEndEnabled: w, WaitSeconds: _, StartTimeOnMMR: I, ItemList: D, WhoStart: B, WhoStop: L, IsAutoMovetoMainSessionEnabled: R } = h, y = { isAutoJoinRoom: m, isBackToMainSessionEnabled: g, isTimerEnabled: b, timerDuration: E, isTimerAutoEnabled: w, waitSeconds: _, isAutoMoveBackToMainSession: R, isRoomSelectionEnabled: C, whoStart: B, whoStop: L };
    c.push(bI(y)), c.push(SI(I)), c.push(Pm(f)), c.push(CI(v));
    const A = D && D.map((k) => ({ boId: k.BID, name: k.MeetingTitle, boStatus: k.Status, hostId: k.HostID, attendeeGuidList: k.ParticipantList || [] })) || [];
    switch (c.push(Jd(A)), O(as, { controlStatus: v, roomList: A }), v) {
      case $e.InProgress:
        if (a !== Ee.InRoom && a !== Ee.Joining) {
          const k = function(T, N) {
            const { meeting: { isHost: F, userGUID: $ }, breakoutRoom: { currentRoom: { status: re, boId: fe } } } = N.value, le = xe.get(og), Ae = [];
            if (le)
              try {
                const { status: Re, boId: Se } = JSON.parse(le);
                if (Re === Ee.Invited)
                  if (F)
                    sa();
                  else {
                    const ye = Zn(T, $);
                    ye && (Ae.push(yd(ye)), re !== Ee.Initial && fe === ye.boId || O($d, { roomId: ye.boId, name: ye.name }));
                  }
                else if (Re === Ee.InRoom) {
                  let ye;
                  if (ye = F ? T.find((Oe) => Oe.boId === Se) : Zn(T, $), ye) {
                    Ae.push(yd(ye));
                    const Oe = ye.boId;
                    Ns(N).subscribe(() => {
                      We.createAgent().joinBO(Oe);
                    });
                  }
                  sa();
                }
              } catch (Re) {
                console.error(Re);
              }
            return Ae;
          }(A, t);
          if (k.length === 0) {
            const T = Zn(A, u);
            T && c.push(yd(T));
          } else
            c.push(...k);
        } else if (a === Ee.InRoom && n.type === `${Yo}`) {
          const k = Zn(A, u);
          k && Mh(t).subscribe((T) => {
            l === k.boId || T || zn.joinBO(k.boId);
          });
        }
        y.isTimerEnabled && y.timerDuration > 0 && (p = function(k, T, N) {
          return Mh(k).pipe(pe(k), ze((F) => {
            let [$, re] = F;
            const { breakoutRoom: { currentRoom: { status: fe }, meetingElapsedTime: le }, meeting: { joinMeetingTimeStamp: Ae } } = re, Re = Ae - 1e3 * le + 1e3 * N + 1e3 * T;
            if (performance.now() < Re) {
              if ($)
                return ps(1e3).pipe(ae(() => Math.floor((Re - performance.now()) / 1e3)), pe(k), hs((Se) => {
                  let [ye, Oe] = Se;
                  const { breakoutRoom: { controlStatus: Ue, currentRoom: { status: Ve } }, socket: { zoomSocketStatus: U }, meeting: { isHost: j } } = Oe;
                  return ye >= 0 && j && Ue === $e.InProgress && (Ve === Ee.InRoom || Ve === Ee.MainSession || Ve === Ee.Initial) && U === dt.Connected;
                }), he((Se) => {
                  let [ye] = Se;
                  O(nf, { countdown: ye });
                }), z((Se) => {
                  let [ye] = Se;
                  return ye === 0;
                }), he((Se) => {
                  let [, ye] = Se;
                  const { breakoutRoom: { options: Oe } } = ye;
                  Oe.isTimerAutoEnabled ? We.createAgent().stopBO($e.Closing) : O(zw);
                }), Ie(oe));
              if (fe === Ee.InRoom)
                return ps(1e3).pipe(ae(() => Math.floor((Re - performance.now()) / 1e3)), pe(k), hs((Se) => {
                  let [ye, Oe] = Se;
                  const { breakoutRoom: { currentRoom: { status: Ue } }, meeting: { isHost: Ve }, socket: { zoomSocketStatus: U } } = Oe;
                  return ye >= 0 && Ue === Ee.InRoom && !Ve && U === dt.Connected;
                }), he((Se) => {
                  let [ye] = Se;
                  O(nf, { countdown: ye });
                }), Ie(oe));
            }
            return oe;
          }));
        }(t, y.timerDuration, I));
        break;
      case $e.Closing:
        p = Mh(t).pipe(z((k) => k), G(() => {
          const k = [], { breakoutRoom: { closingRoomTime: T, currentRoom: { status: N } }, participants: { attendeesList: F } } = o;
          let $ = y.waitSeconds;
          if (T !== 0 && y.waitSeconds > 0) {
            const re = Math.floor((performance.now() - T) / 1e3);
            $ = Math.max(y.waitSeconds - re, 0);
          }
          if ($ === 0)
            return zn.stopBO($e.Closed), oe;
          {
            if (N !== Ee.InRoom && F.length > 1 && F.every((fe) => !fe.bid))
              return zn.stopBO($e.Closed), oe;
            T || k.push(Lf(performance.now()));
            const re = performance.now() + 1e3 * $;
            return Kt(ne(k), ps(1e3).pipe(ae(() => Math.floor((re - performance.now()) / 1e3)), pe(t), hs((fe) => {
              let [le, Ae] = fe;
              const { breakoutRoom: { controlStatus: Re }, meeting: { isHost: Se }, socket: { zoomSocketStatus: ye } } = Ae;
              return le >= 0 && Re === $e.Closing && ye === dt.Connected && Se;
            }), he((fe) => {
              let [le] = fe;
              le >= 0 && O(rf, { countdown: le });
            }), z((fe) => {
              let [le] = fe;
              return le === 0;
            }), he(() => {
              zn.stopBO($e.Closed);
            }), Ie(oe)));
          }
        }));
        break;
      case $e.Closed:
        c.push(Lf(0)), a === Ee.Leaving ? c.push(Is(Ee.MainSession)) : a === Ee.Invited ? c.push(Is(Ee.Initial)) : a !== Ee.InRoom && a !== Ee.Joining || c.push(...gv()), sa();
    }
  } catch (h) {
    console.error(h);
  }
  return p ? Kt(ne(c), p) : ne(c);
})), epics3: (e, t) => to(e, 4194).pipe(pe(t), ze((r) => {
  let [n, o] = r;
  const { payload: { body: { bid: i, botoken: s, confID: a } } } = n, { meeting: { isHost: l }, breakoutRoom: { rooms: u, currentRoom: { status: d } } } = o, c = [], p = u.find((h) => h.boId === i);
  return p && (c.push(yd(p, l)), c.push(Pf(a)), c.push(Df(s)), l || d !== Ee.InRoom ? c.push(...Th(p.name, d)) : c.push(...jS(p.name))), O(Hd, { boId: i }), ne(c);
})), epics4: (e, t) => e.pipe(ge(`${js}`, `${Yo}`), z((r) => r.payload.evt === 7949), pe(t), G((r) => {
  var n;
  let [o, i] = r;
  const { payload: { body: s } } = o, { meeting: { userGUID: a }, breakoutRoom: { rooms: l, options: { isAutoJoinRoom: u, isAutoMovetoMainSession: d }, currentRoom: { status: c }, mainSessionAttendeeList: p }, participants: { attendeesList: h } } = i, { commandType: v } = s, f = [];
  let m;
  const g = (n = (kh(c) ? h : p).find((_) => _.userGUID === a)) === null || n === void 0 ? void 0 : n.userId;
  switch (v) {
    case Ui.Join: {
      const { targetBID: _, botoken: I, confID: D, joinReason: B, requestSourceID: L } = s, R = Zn(l, a);
      if (R && R.boId === _) {
        f.push(Pf(D)), f.push(Df(I));
        const y = Number(B) === LO.Active && g === Number(L);
        u || y ? (y && O(Hd, { boId: _ }), f.push(...Th(R.name))) : (xe.set(lt.WebclientBreakoutRoomCommand, v, qe.SessionStorage), O($d, { roomId: _, name: R.name, ...US(L, i) }));
      }
      break;
    }
    case Ui.Switch: {
      const { targetBID: _, botoken: I, confID: D, joinMethod: B, requestSourceID: L } = s, R = Zn(l, a);
      if (R && R.boId === _) {
        f.push(s0({ boId: R.boId, boToken: I, boConfId: D, name: R.name }));
        const y = g === Number(L) && Number(B) === L2.AskToLeave;
        c === Ee.Invited ? (xe.set(lt.WebclientBreakoutRoomCommand, v, qe.SessionStorage), u || g === Number(L) ? f.push(...Th(R.name)) : O($d, { roomId: _, name: R.name, ...US(L, i) })) : f.push(...jS(R.name)), y && O(Hd, { boId: _ });
      }
      break;
    }
    case Ui.Leave: {
      const { waitTime: _, joinMethod: I } = s;
      if (kh(c))
        f.push(s0({ boId: "", boToken: "", boConfId: "", status: Ee.Initial }));
      else {
        const D = Number(_);
        if (D > 0) {
          const B = performance.now() + 1e3 * D;
          m = ps(1e3).pipe(ae(() => Math.floor((B - performance.now()) / 1e3)), pe(t), hs((L) => {
            let [R, y] = L;
            const { breakoutRoom: { controlStatus: A, currentRoom: { status: k } }, meeting: { isHost: T }, socket: { zoomSocketStatus: N } } = y;
            return R >= 0 && N === dt.Connected && A === $e.Closing && k === Ee.InRoom && !T;
          }), he((L) => {
            let [R] = L;
            R >= 0 && O(rf, { countdown: R });
          }), Ie(oe));
        } else if (Number(I) !== L2.AskToLeave || d)
          f.push(...gv());
        else {
          var C, b, E;
          const { requestSourceID: B } = s, L = Number(B), { participants: { attendeesList: R } } = i;
          let y = R.find((A) => A.userId === L);
          if (!y) {
            const { breakoutRoom: { mainSessionAttendeeList: A } } = i;
            y = A.find((k) => k.userId === L);
          }
          O(Gw, { inviterId: (C = y) === null || C === void 0 ? void 0 : C.userId, inviterGuid: (b = y) === null || b === void 0 ? void 0 : b.userGUID, inviterName: (E = y) === null || E === void 0 ? void 0 : E.displayName });
        }
        sa();
      }
      break;
    }
    case Ui.Broadcast: {
      const { textContent: _, requestID: I } = s;
      if (_) {
        const { meeting: { encType: D }, participants: { attendeesList: B }, breakoutRoom: { mainSessionAttendeeList: L } } = i;
        let R = "";
        if (D === Nu.AES_GCM) {
          const y = (kh(c) ? B : L).find((A) => A.userId === Number(I));
          y && (R = y.zoomID);
        }
        m = ne(ir.beginDecrypt({ decryptedText: _, type: mr.BO_BROADCAST, zoomId: R }).then((y) => {
          let { message: A } = y;
          return O(Hw, { message: A }), EI(A);
        }));
      }
      break;
    }
    case Ui.HelpReq: {
      const { requestID: _ } = s, { breakoutRoom: { mainSessionAttendeeList: I, rooms: D, currentRoom: { boId: B }, hostReplyToQuestionerType: L, hostReplyToRequestId: R }, participants: { attendeesList: y } } = i;
      if (_) {
        if (c === Ee.InRoom) {
          const A = I.find((k) => k.userId === _);
          if (A && A.bid === B) {
            zn.askForHelpResultBO(_, Ci.AlreadyInRoom);
            break;
          }
        }
        if (L === Ci.Received && R !== _)
          zn.askForHelpResultBO(_, Ci.Busy);
        else {
          zn.askForHelpResultBO(_, Ci.Received), f.push(Dm(Ci.Received), II(_));
          const A = (c === Ee.InRoom ? I : y).find((k) => k.userId === _);
          if (A) {
            const k = A.bid, T = D.find((N) => N.boId === k);
            T && O(Fw, { userId: _, userGuid: A.userGUID, displayName: A.displayName, roomName: T.name, roomId: T.boId });
          }
        }
      }
      break;
    }
    case Ui.HelpRes: {
      const { helpResult: _ } = s;
      O(gm, { result: Number(_) });
      break;
    }
    case Ui.BOActivity: {
      var w;
      const { activityRoster: _, activityTalking: I, requestID: D } = s, B = (w = (Ro(i) ? i.breakoutRoom.mainSessionAttendeeList : i.participants.attendeesList).find((L) => L.userId === D)) === null || w === void 0 ? void 0 : w.userGUID;
      if (B) {
        const { breakoutRoom: { rooms: L } } = i, R = Zn(L, B), y = function(A, k) {
          const T = { isTalking: k === 1 };
          return YP.forEach((N) => {
            const { mask: F, key: $, value: re } = N;
            return (F & A) === F && Object.assign(T, { [`${$}`]: re }), T;
          }), T;
        }(Number(_), Number(I));
        f.push(OI({ userGuid: B, status: y })), O(qw, { ...y, userId: D, userGuid: B, roomId: R == null ? void 0 : R.boId, roomName: R == null ? void 0 : R.name });
      }
      break;
    }
  }
  return m ? Kt(ne(f), m) : ne(f);
})), epics5: (e, t) => vs(e, Q0).pipe(pe(t), ze((r) => {
  let [n, o] = r;
  const { payload: { body: { res: i, elapsed: s } } } = n, a = [];
  return i === fn.MeetingHasClosed || i === fn.UserHasBeenRemoved ? (sa(), a.push(...ma(o, !1))) : i === fn.Success && (a.push(Mf(s)), a.push(Is(Ee.InRoom)), xe.set(lt.WebclientBreakoutRoomAttendeeStatus, JSON.stringify({ status: Ee.InRoom, boId: o.breakoutRoom.currentRoom.boId }), qe.SessionStorage)), ne(a);
})), epics6: (e, t) => vs(e, gt).pipe(ae((r) => E0(r.payload.body)), pe(t), G((r) => {
  let [n, o] = r;
  const i = [AI(n)], { participants: { attendeesList: s }, breakoutRoom: { mainSessionAttendeeList: a, isUserRoleUpdated: l }, meeting: { userId: u } } = o;
  let d = [];
  return ["add", "update"].forEach((c) => n[c] && d.push(...n[c])), d = d.filter((c) => BS.some((p) => c[p] !== void 0)).map((c) => {
    const p = a.find((h) => h.userId === c.userId);
    if (p) {
      const h = s.find((v) => v.zoomID === p.zoomID);
      if (h)
        return c.userRole === void 0 || l || h.userId !== u || (i.push(xf(!0)), O(of, c)), c.bCCEditor !== void 0 && i.push(mI({ editorId: c.bCCEditor ? h.userId : "", isEditor: !!c.bCCEditor, editorZoomId: c.bCCEditor ? h.zoomID : "" })), delete c.bRaiseHand, delete c.bCapsPinMultiVideo, { ...c, userId: h.userId };
    }
    return null;
  }).filter((c) => !!c), d.length > 0 && (O(Mo, d), i.push(Uc({ update: d }))), O(Zw), ne(i);
})), epics7: (e) => vs(e, En).pipe(z((t) => {
  const { payload: { body: r } } = t;
  return (r == null ? void 0 : r.bAllowAttendeeRename) !== void 0 || (r == null ? void 0 : r.chatPriviledge) !== void 0 || (r == null ? void 0 : r.lockShare) !== void 0;
}), ae((t) => {
  const { payload: { body: r } } = t;
  return r.bAllowAttendeeRename !== void 0 ? Ec(t.payload.body) : r.chatPriviledge !== void 0 ? Om(r.chatPriviledge) : r.lockShare !== void 0 ? Em(r.lockShare) : void 0;
})), epics8: (e, t) => se(e, gt).pipe(pe(t), z((r) => {
  let [, n] = r;
  const { meeting: { isHost: o }, breakoutRoom: { controlStatus: i, currentRoom: { status: s } } } = n;
  return o && i === $e.Closing && s !== Ee.InRoom;
}), Fr(Du), he(() => {
  const { participants: { attendeesList: r } } = t.value;
  r.every((n) => !n.bid) && r.length > 1 && zn.stopBO($e.Closed);
}), Ie(oe)), epics9: (e, t) => se(e, 4214).pipe(pe(t), ze((r) => {
  let [n, o] = r;
  const { payload: { body: { proto: i } } } = n, { breakoutRoom: { rooms: s, isHugeBO: a } } = o;
  try {
    const l = JSON.parse(no(i)), u = [];
    if (l && l.PreAssignBoList && Array.isArray(l.PreAssignBoList)) {
      const d = l.PreAssignBoList.map((p) => ({ name: p.BoName, emails: p.email }));
      u.push(Nf(d));
      const c = a ? 100 : 50;
      if (s.length + d.length < c) {
        const p = d.map((h) => h.name);
        return zn.batchCreateBOToken(p), Kt(ne(u), R_(p.length).pipe(pe(t), G((h) => {
          let [{ boIdList: v }, f] = h;
          const m = ft(f), g = d.map((b, E) => {
            const { emails: w, name: _ } = b;
            let I = [];
            return w && Array.isArray(w) && (I = w.map((D) => m.filter((B) => B.userEmail === D).map((B) => B.userGUID)).reduce((D, B) => [...D, ...B], [])), { boId: v[E], name: _, attendeeGuidList: I };
          }), C = g.map((b, E) => ({ roomId: b.boId, name: b.name, emails: d[E].emails }));
          return O(Ww, { rooms: C }), ne([Jd(g), Nf(C)]);
        })));
      }
      return ne(u);
    }
  } catch {
    console.error("pre assign proto is not valid");
  }
  return oe;
})), epics10: (e, t) => to(e, gt).pipe(pe(t), z((r) => {
  let [n, o] = r;
  const { meeting: { isHost: i, meetingStatus: s, meetingOptions: a }, breakoutRoom: { controlStatus: l } } = o, { payload: { body: u } } = n;
  return s === xt.Joined && (a == null ? void 0 : a.isAllowBreakoutRoomPreAssign) && i && (l === $e.NotStarted || l === $e.InProgress) && Array.isArray(u.add);
}), G((r) => {
  let [n, o] = r;
  const { breakoutRoom: { controlStatus: i, rooms: s, preAssignedRooms: a, currentRoom: { status: l } }, participants: { failoverAttendeesList: u } } = o, d = a == null ? void 0 : a.filter((h) => s.findIndex((v) => v.boId === h.roomId) > -1), { payload: { body: { add: c } } } = n, p = [];
  return d.length > 0 && c.filter((h) => h.userEmail && h.userGUID).filter((h) => u.findIndex((v) => v.zoomID === h.zoomID) === -1).forEach((h) => {
    if (!Zn(s, h.userGUID))
      for (let v = 0; v < (d == null ? void 0 : d.length); v++) {
        const f = d[v];
        if (f.emails.includes(h.userEmail)) {
          if (i === $e.NotStarted) {
            const m = M(s, (g) => {
              const C = g.find((b) => b.boId === f.roomId);
              C == null || C.attendeeGuidList.push(h.userGUID);
            });
            p.push(Jd(m));
          } else
            i === $e.InProgress && (l === Ee.InRoom && n.type === `${Yo}` ? zn.assignToBO(h.id, String(f.roomId)) : l !== Ee.Initial && l !== Ee.MainSession || zn.assignToBO(h.id, String(f.roomId)));
          break;
        }
      }
  }), ne(p);
})), epics11: (e, t) => se(e, gt).pipe(z((r) => {
  const { breakoutRoom: { mainSessionAttendeeList: n } } = t.value, { payload: { body: o } } = r;
  return n.length > 0 && (o.add !== void 0 || o.update !== void 0);
}), Fr(ri), ae((r) => E0(r.payload.body)), G((r) => {
  const { breakoutRoom: { mainSessionAttendeeList: n, isUserRoleUpdated: o }, participants: { attendeesList: i } } = t.value;
  let s = [];
  const a = [];
  ["add", "update"].forEach((d) => r[d] && s.push(...r[d]));
  const l = [...BS, "isHost"];
  s = s.filter((d) => l.some((c) => d[c] !== void 0));
  const u = s.filter((d) => d.zoomID !== void 0);
  return s = s.map((d) => {
    var c, p, h, v;
    const f = (c = (p = d.zoomID) !== null && p !== void 0 ? p : (h = u.find((m) => m.userId === d.userId)) === null || h === void 0 ? void 0 : h.zoomID) !== null && c !== void 0 ? c : (v = i.find((m) => m.userId === d.userId)) === null || v === void 0 ? void 0 : v.zoomID;
    if (f) {
      const m = n.find((g) => g.zoomID === f);
      if (m)
        return o || (a.push(xf(!0)), O(of, m)), Object.keys(d).filter((g) => Object.prototype.hasOwnProperty.call(d, g)).filter((g) => l.includes(g)).reduce((g, C) => {
          const b = m[C];
          if (b !== void 0 || C === "bCoHost") {
            const E = typeof d[C] == "boolean" ? !!b : b;
            Object.assign(g, { [C]: E });
          }
          return g;
        }, { userId: d.userId });
    }
  }).filter(Boolean), s.length > 0 && (O(Mo, s), a.push(Uc({ update: s }))), ne(a);
})), epics12: (e) => vs(e, 7999).pipe(he((t) => {
  const { payload: { body: { bStatus: r } } } = t;
  O(Kw, { status: !!r });
}), G(() => oe)), epics13: (e, t) => se(e, 7940).pipe(G((r) => {
  const { payload: { body: { bHost: n } } } = r, { breakoutRoom: { isBroadcastVoice: o } } = t.value, i = [];
  return !n && o && (ke.getInstance().broadcastVoiceToBreakoutRoom(!1), i.push(a0(!1))), ne(i);
})) }, oD = Wr(nD, rD);
let Sd = function(e) {
  return e[e.Ready = 0] = "Ready", e[e.UserSub = 1] = "UserSub", e[e.ManualCaptionerEnabled = 2] = "ManualCaptionerEnabled", e[e.ManualCaptionerDisabled = 3] = "ManualCaptionerDisabled", e;
}({}), Ln = function(e) {
  return e[e.Unspecified = -1] = "Unspecified", e[e.English = 0] = "English", e[e["Chinese (Simplified)"] = 1] = "Chinese (Simplified)", e[e.Japanese = 2] = "Japanese", e[e.German = 3] = "German", e[e.French = 4] = "French", e[e.Russian = 5] = "Russian", e[e.Portuguese = 6] = "Portuguese", e[e.Spanish = 7] = "Spanish", e[e.Korean = 8] = "Korean", e[e.Italian = 9] = "Italian", e[e.Reserved = 10] = "Reserved", e[e.Vietnamese = 11] = "Vietnamese", e[e.Dutch = 12] = "Dutch", e[e.Ukrainian = 13] = "Ukrainian", e[e.Arabic = 14] = "Arabic", e[e.Bengali = 15] = "Bengali", e[e["Chinese (Traditional)"] = 16] = "Chinese (Traditional)", e[e.Czech = 17] = "Czech", e[e.Estonian = 18] = "Estonian", e[e.Finnish = 19] = "Finnish", e[e.Greek = 20] = "Greek", e[e.Hebrew = 21] = "Hebrew", e[e.Hindi = 22] = "Hindi", e[e.Hungarian = 23] = "Hungarian", e[e.Indonesian = 24] = "Indonesian", e[e.Malay = 25] = "Malay", e[e.Persian = 26] = "Persian", e[e.Polish = 27] = "Polish", e[e.Romanian = 28] = "Romanian", e[e.Swedish = 29] = "Swedish", e[e.Tamil = 30] = "Tamil", e[e.Telugu = 31] = "Telugu", e[e.Tagalog = 32] = "Tagalog", e[e.Turkish = 33] = "Turkish", e[e.NoTranslation = 400] = "NoTranslation", e[e.DefaultManualInput = 401] = "DefaultManualInput", e[e.Customized = 500] = "Customized", e;
}({}), ui = function(e) {
  return e[e.Unknown = 0] = "Unknown", e[e.Close = 1] = "Close", e[e.New = 2] = "New", e[e.Insert = 3] = "Insert", e[e.Delete = 4] = "Delete", e[e.Reset = 5] = "Reset", e[e.Audiodesc = 6] = "Audiodesc", e[e.Speaker = 7] = "Speaker", e[e.Error = 8] = "Error", e;
}({}), HS = function(e) {
  return e[e.TranslateNotSupport = 1] = "TranslateNotSupport", e;
}({}), hi = function(e) {
  return e[e.Unspecified = 0] = "Unspecified", e[e.InMeetingManual = 1] = "InMeetingManual", e[e.ExternalCaptioner = 2] = "ExternalCaptioner", e[e.ASR = 4] = "ASR", e;
}({});
const Yl = { en: 0, zh: 1, ja: 2, de: 3, fr: 4, ru: 5, pt: 6, es: 7, ko: 8, it: 9, en1: 10, vi: 11, nl: 12, uk: 13, ar: 14, bn: 15, "zh-hant": 16, cs: 17, et: 18, fi: 19, el: 20, he: 21, hi: 22, hu: 23, id: 24, ms: 25, fa: 26, pl: 27, ro: 28, sv: 29, ta: 30, te: 31, tl: 32, tr: 33 }, Xl = Object.keys(Ln).filter((e) => /\d+/.test(Ln[e])).reduce((e, t) => ({ ...e, [`${Ln[t]}`]: t }), {}), FS = Object.keys(Yl).reduce((e, t) => (Object.assign(e, { [`${Yl[`${t}`]}`]: t }), e), {}), uc = "zoom-sdk-live-trasncription", Wo = "live-trasncription";
(function(e) {
  return e[e.English = 0] = "English", e[e.Chinese = 1] = "Chinese", e[e.Japanese = 2] = "Japanese", e[e.German = 3] = "German", e[e.French = 4] = "French", e[e.Russian = 5] = "Russian", e[e.Portuguese = 6] = "Portuguese", e[e.Spanish = 7] = "Spanish", e[e.Korean = 8] = "Korean", e[e.Italian = 9] = "Italian", e[e.Reserved = 10] = "Reserved", e[e.Vietnamese = 11] = "Vietnamese", e[e.Dutch = 12] = "Dutch", e[e.Ukrainian = 13] = "Ukrainian", e[e.Arabic = 14] = "Arabic", e[e.Bengali = 15] = "Bengali", e[e["Chinese (Traditional)"] = 16] = "Chinese (Traditional)", e[e.Czech = 17] = "Czech", e[e.Estonian = 18] = "Estonian", e[e.Finnish = 19] = "Finnish", e[e.Greek = 20] = "Greek", e[e.Hebrew = 21] = "Hebrew", e[e.Hindi = 22] = "Hindi", e[e.Hungarian = 23] = "Hungarian", e[e.Indonesian = 24] = "Indonesian", e[e.Malay = 25] = "Malay", e[e.Persian = 26] = "Persian", e[e.Polish = 27] = "Polish", e[e.Romanian = 28] = "Romanian", e[e.Swedish = 29] = "Swedish", e[e.Tamil = 30] = "Tamil", e[e.Telugu = 31] = "Telugu", e[e.Tagalog = 32] = "Tagalog", e[e.Turkish = 33] = "Turkish", e[e.NoTranslation = 400] = "NoTranslation", e[e.DefaultManualInput = 401] = "DefaultManualInput", e;
})({});
(function(e) {
  return e.English = "en", e["Chinese (Simplified)"] = "zh", e.Japanese = "ja", e.German = "de", e.French = "fr", e.Russian = "ru", e.Portuguese = "pt", e.Spanish = "es", e.Korean = "ko", e.Italian = "it", e.Reserved = "en1", e.Vietnamese = "vi", e.Dutch = "nl", e.Ukrainian = "uk", e.Arabic = "ar", e.Bengali = "bn", e["Chinese (Traditional)"] = "zh-hant", e.Czech = "cs", e.Estonian = "et", e.Finnish = "fi", e.Greek = "el", e.Hebrew = "he", e.Hindi = "hi", e.Hungarian = "hu", e.Indonesian = "id", e.Malay = "ms", e.Persian = "fa", e.Polish = "pl", e.Romanian = "ro", e.Swedish = "sv", e.Tamil = "ta", e.Telugu = "te", e.Tagalog = "tl", e.Turkish = "tr", e;
})({});
function eu(e) {
  const t = e === Ln.Unspecified ? Ln.Reserved : e;
  ke.getInstance().selectLanguageChannelForNewLTT(t);
}
const iD = iE(oE, function(e, t) {
  return r_(e, t);
})([ft, (e) => {
  let { meeting: { gatewayUserList: t } } = e;
  return t;
}], (e, t) => {
  const r = {};
  return e.forEach((n) => {
    Object.assign(r, { [`${n.userId}`]: n.zoomID });
  }), t == null || t.forEach((n) => {
    Object.assign(r, { [`${n.userId}`]: n.sn });
  }), r;
}), zS = Mt([ft], (e) => e.find((t) => t.bCCEditor === !0)), sD = Mt([ft, sE], (e, t) => e.some((r) => r.bCCEditor === !0 && r.userId === t)), WS = We.createAgent(), Ph = { isEnableTranslatedCaptions: !1, isHostLockSpeakingLanguage: !1, transcriptionLang: [], isEnableAutomatedCaptions: !1, supportedTranscriptionLanguage: [], isLiveTranscriptionEnabled: !1, isHostDisableCaptions: !1, isManualCaptionerEnabled: !1, gatewayId: void 0, isLiveTranscriptionSubscribed: !1, messageRecords: [], isRecordsReduced: !1, reducedRecordsCount: 0 }, aD = zr({ [`${BI}`]: M((e, t) => {
  let { payload: r } = t;
  e.isLiveTranscriptionEnabled = r;
}), [`${$I}`]: M((e, t) => {
  let { payload: r } = t;
  const { transcriptionLang: n, translatedSetting: o, ...i } = r;
  n && (e.transcriptionLang = n.split(";").map((s) => {
    const a = s && Yl[s];
    return a !== void 0 ? { lang: s, code: a } : null;
  }).filter(Boolean)), o && (e.translatedSetting = Object.keys(o).map((s) => {
    const a = o[s];
    if (a) {
      const l = a.split(";").map((u) => {
        const d = u && Yl[u];
        return d !== void 0 ? { lang: u, code: d } : null;
      }).filter(Boolean);
      return { lang: s, code: Yl[s], translatedToLanguage: l };
    }
    return null;
  }).filter(Boolean)), Object.assign(e, i);
}), [`${jf}`]: M((e, t) => {
  let { payload: r } = t;
  e.isManualCaptionerEnabled = r;
}), [`${HI}`]: M((e, t) => {
  let { payload: r } = t;
  e.gatewayId = r;
}), [`${JI}`]: M((e, t) => {
  let { payload: r } = t;
  e.isHostDisableCaptions = r;
}), [`${FI}`]: M((e, t) => {
  let { payload: r } = t;
  e.supportedTranscriptionLanguage = r;
}), [`${ms}`]: M((e, t) => {
  let { payload: r } = t;
  e.currentTranscriptionLang = r;
}), [`${l0}`]: M((e, t) => {
  let { payload: r } = t;
  e.currentTranslationLang = r;
}), [`${Bf}`]: M((e, t) => {
  let { payload: r } = t;
  e.messageRecords.push(r);
}), [`${zI}`]: M((e, t) => {
  let { payload: r } = t;
  const n = e.messageRecords.find((o) => o.msgId === r.msgId);
  n && Object.assign(n, r);
}), [`${WI}`]: M((e, t) => {
  let { payload: r } = t;
  const { remains: n, reducedRecordsCount: o } = r, i = e.messageRecords.length - n;
  e.isRecordsReduced = !0, e.reducedRecordsCount = o, e.messageRecords.splice(0, i);
}), [`${Uf}`]: M((e, t) => {
  let { payload: r } = t;
  e.isLiveTranscriptionSubscribed = r;
}), [`${ZI}`]: M((e, t) => {
  let { payload: r } = t;
  e.liveTransEngineType = r;
}), [`${GI}`]: M((e) => {
  e.stateBeforeFailover = void 0;
}), [`${qI}`]: M((e, t) => {
  let { payload: r } = t;
  e.lastManualCaption = r;
}), [`${KI}`]: (e, t) => {
  let { payload: r } = t;
  return r ? { ...Ph, stateBeforeFailover: { currentTranscriptionLang: e.currentTranscriptionLang, currentTranslationLang: e.currentTranslationLang, isLiveTranscriptionSubscribed: e.isLiveTranscriptionSubscribed }, messageRecords: e.messageRecords, isRecordsReduced: e.isRecordsReduced, reducedRecordsCount: e.reducedRecordsCount } : { ...Ph };
} }, Ph);
var St;
const kn = We.createAgent(), di = nn("Live transcription");
let lD = (St = class extends Po {
  startLiveTranscription() {
    const { [ce]: e, [Nt]: t } = this, { liveTranscription: { isLiveTranscriptionEnabled: r, isEnableTranslatedCaptions: n, isLiveTranscriptionSubscribed: o, isHostLockSpeakingLanguage: i, isHostDisableCaptions: s } } = e();
    return o ? Promise.resolve("") : s ? Promise.reject({ type: W, reason: "Captions has been disabled by host." }) : r ? (kn.enableNewLLT(), Te(Jn).then(() => (i ? kn.setSpokenLanguage(Ln.English) : eu(Ln.Unspecified), t(ms(Ln.English)), n && kn.setTranslationLanguage(), Te({ event: Jn, operations: [z((a) => a.autoCaption === !0 && a.lang !== void 0)] })))) : Promise.reject({ type: W, reason: "Live transcription is not enabled." });
  }
  disableCaptions(e) {
    const { [ce]: t } = this, { liveTranscription: { isHostDisableCaptions: r } } = t();
    return e ? r ? Promise.resolve() : (kn.disableCaptions(!0), Te(Rc)) : r ? (kn.disableCaptions(!1), Te(Rc)) : Promise.resolve();
  }
  setSpeakingLanguage(e) {
    const { [ce]: t, [Nt]: r } = this, { liveTranscription: { isLiveTranscriptionSubscribed: n, isHostLockSpeakingLanguage: o, transcriptionLang: i } } = t(), s = i.find((a) => a.lang === e);
    if (s) {
      const { code: a } = s;
      return n ? (o ? kn.setSpokenLanguage(a) : eu(a), r(ms(a)), Promise.resolve("")) : Promise.reject({ type: W, reason: "Cannot set speaking language before starting live transcription" });
    }
    return Promise.reject({ type: De, reason: "Unsupported transcription language" });
  }
  setTranslationLanguage(e) {
    const { [ce]: t, [Nt]: r } = this, n = t(), { liveTranscription: { isEnableTranslatedCaptions: o, isLiveTranscriptionSubscribed: i, translatedSetting: s, currentTranscriptionLang: a } } = n;
    if (!o)
      return Promise.reject({ type: W, reason: "Live translation is not enabled." });
    if (!i)
      return Promise.reject({ type: W, reason: "Cannot set translation language before starting live transcription" });
    if (e) {
      const l = s == null ? void 0 : s.find((u) => u.code === a);
      if (l) {
        const { translatedToLanguage: u } = l, d = u.find((c) => c.lang === e);
        if (d)
          return kn.setTranslationLanguage(d.code), Te({ event: Jn, operations: [z((c) => c.autoCaption === !0 && c.lang === d.code), Ge(1)] }, (c) => {
            let { lang: p } = c;
            return p === d.code;
          });
      }
      return Promise.reject({ type: W, reason: `Cannot support translating ${Xl[a || 0]} to ${e}` });
    }
    return kn.setTranslationLanguage(), r(l0(void 0)), Promise.resolve("");
  }
  enableManualCaptioner() {
    const { [ce]: e } = this, { meeting: { meetingOptions: t }, liveTranscription: { isManualCaptionerEnabled: r, isHostDisableCaptions: n } } = e();
    if (n)
      return Promise.reject({ type: W, reason: "Captions has been disabled by host." });
    const { isEnableManualCaptions: o, isEnableClosedCaption: i } = t;
    return (o != null ? o : i) ? r ? Promise.resolve() : (kn.enableManualCaption(!0), Te(Jn, (s) => {
      let { autoCaption: a } = s;
      return a === !1;
    })) : Promise.reject({ type: W, reason: "Manual caption is not enabled." });
  }
  disableManualCaptioner() {
    const { [ce]: e } = this, { liveTranscription: { isManualCaptionerEnabled: t } } = e();
    return t ? (kn.enableManualCaption(!1), Te(Jn, (r) => {
      let { autoCaption: n } = r;
      return n === !0;
    })) : Promise.resolve();
  }
  assignManualCaption(e) {
    var t;
    const { [ce]: r } = this, n = r(), { liveTranscription: { isManualCaptionerEnabled: o }, participants: { attendeesList: i }, meeting: { userId: s } } = n;
    return o ? ((t = zS(n)) === null || t === void 0 ? void 0 : t.userId) === e ? Promise.resolve("") : i.find((l) => l.userId === e) ? (kn.assignCC(e, !0), Te({ event: s === e ? Qr : Mo, operations: [z((l) => l.userId === e), Ge(1)] }, (l) => l.bCCEditor === !0)) : Promise.reject({ type: De, reason: "Cannot find the user" }) : Promise.reject({ type: W, reason: "Cannot assign caption editor due to the manual captioner is not enabled." });
  }
  sendCaptionTextManually(e, t) {
    var r;
    const { [ce]: n, [Nt]: o } = this, i = n(), { liveTranscription: { lastManualCaption: s }, meeting: { userId: a } } = i, l = be(i);
    let u = Promise.resolve();
    const d = (r = zS(i)) === null || r === void 0 ? void 0 : r.userId;
    return l != null && l.isHost && d !== a && (u = this.assignManualCaption(a)), u.then(() => sD(n()) ? function(c, p, h) {
      const v = c.length, f = [];
      var m;
      if (h)
        f.push({ op: "close", text: c, msgId: (m = p == null ? void 0 : p.msgId) !== null && m !== void 0 ? m : bc() });
      else if (p && p != null && p.text) {
        const g = p.text.length;
        let C = 0, b = 0;
        for (; c[C] === p.text[C] && C < v; )
          b += K4(c[C]), C += 1;
        C === g && C === v ? f.push({ op: "same" }) : C === g && C < v ? f.push({ op: "insert", text: c.slice(C), size: 0, pos: b, msgId: p.msgId }) : C < g && C === v ? f.push({ op: "delete", size: 0, pos: b, msgId: p.msgId }) : (f.push({ op: "delete", size: 0, pos: b, msgId: p.msgId }), f.push({ op: "insert", text: c.slice(C), pos: b, msgId: p.msgId }));
      } else
        v > 0 && f.push({ op: "start", text: c, pos: 0, size: 0, msgId: bc() });
      return f.filter((g) => g.op !== "same");
    }(e, s, t) : Promise.reject({ type: Or, reason: "Cannot type caption " })).then((c) => Array.isArray(c) ? (c.forEach((p) => {
      const { text: h, ...v } = p;
      ir.beginEncrypt({ text: h != null ? h : "", type: mr.CC_MESSAGE }).then((f) => {
        kn.sendManualCaption({ text: f, ...v });
        const m = t ? void 0 : { text: h, msgId: p.msgId };
        o(qI(m));
      });
    }), Te(Hl, (p) => p.source === hi.InMeetingManual)) : "");
  }
  getLiveTranscriptionStatus() {
    const { [ce]: e } = this, { liveTranscription: { isLiveTranscriptionEnabled: t, isEnableTranslatedCaptions: r, isManualCaptionerEnabled: n, transcriptionLang: o, translatedSetting: i, isHostDisableCaptions: s } } = e();
    return { isLiveTranscriptionEnabled: t, isLiveTranslationEnabled: r, isHostDisableCaptions: s, isManualCaptionerEnabled: n, transcriptionLanguage: o.map((a) => a.lang).join(";"), translationLanguage: i == null ? void 0 : i.map((a) => ({ speakingLanguage: a.lang, translatedToLanguage: a.translatedToLanguage.map((l) => l.lang).join(";") })) };
  }
  getLiveTranscriptionSetting() {
    const { [ce]: e } = this, { meeting: { meetingOptions: t } } = e(), { isEnableManualCaptions: r, isEnableLiveTranscription: n, isEnableClosedCaption: o, isEnableAllowThirdPartyCCToken: i, isEnableViewFullTranscript: s, isEnableSaveCaptions: a } = t || {};
    return { isEnableManualCaptions: r, isEnableLiveTranscription: n, isEnableClosedCaption: o, isEnableAllowThirdPartyCCToken: i, isEnableViewFullTranscript: s, isEnableSaveCaptions: a };
  }
  getCurrentTranscriptionLanguage() {
    const { [ce]: e } = this, { liveTranscription: { currentTranscriptionLang: t } } = e();
    return t !== void 0 ? { code: FS[t], name: Xl[t] } : null;
  }
  getCurrentTranslationLanguage() {
    const { [ce]: e } = this, { liveTranscription: { currentTranslationLang: t } } = e();
    return t !== void 0 ? { code: FS[t], name: Xl[t] } : null;
  }
  getLatestTranscription() {
    const { [ce]: e } = this, { liveTranscription: { messageRecords: t, isManualCaptionerEnabled: r } } = e(), n = r ? Ln.DefaultManualInput : Ln.NoTranslation, o = t.filter((i) => i.language === n);
    return o.length ? o[o.length - 1].text : "";
  }
  getLatestTranslation() {
    const { [ce]: e } = this, { liveTranscription: { messageRecords: t, currentTranslationLang: r, isEnableTranslatedCaptions: n } } = e();
    if (n || r !== void 0) {
      const o = t.filter((i) => i.language === r);
      return o.length ? o[o.length - 1].text : "";
    }
    return "";
  }
  getFullTranscriptionHistory() {
    const { [ce]: e } = this, t = e(), { liveTranscription: { messageRecords: r, isRecordsReduced: n } } = t;
    return n ? function(o) {
      return window.indexedDB !== void 0 ? new Promise((i) => {
        const s = window.indexedDB.open(uc, 1);
        s.addEventListener("success", () => {
          const a = s.result;
          if (a.objectStoreNames.contains(Wo)) {
            const l = a.transaction([Wo], "readonly").objectStore(Wo), u = [], d = o.meeting.meetingId, c = l.openCursor();
            c.onsuccess = () => {
              const p = c.result;
              p ? (p.value.mid === d && u.push(...p.value.records), p.continue()) : (i(u), a.close());
            };
          } else
            i("");
        });
      }) : Promise.resolve("");
    }(t).then((o) => Array.isArray(o) ? o.concat(r) : [...r]) : [...r];
  }
  getManualCaptionEditor() {
    const { [ce]: e } = this, t = e(), { closedCaption: { editorId: r } } = t;
    let n;
    if (!r)
      return {};
    if (n = ft(t).find((d) => d.userId === r), !n)
      return {};
    const { userId: o, isHost: i, displayName: s, avatar: a, bCoHost: l, zoomID: u } = n;
    return { userId: o, isHost: i, displayName: s, avatar: a, bCoHost: l, zoomID: u };
  }
  getManualCaptionUrl() {
    const { [ce]: e } = this, { meeting: { meetingOptions: t, ccUrl: r } } = e(), { isEnableManualCaptions: n } = t || {};
    return n ? r : (console.warn("you not enable manual caption"), "");
  }
}, K(St.prototype, "startLiveTranscription", [Y, di], Object.getOwnPropertyDescriptor(St.prototype, "startLiveTranscription"), St.prototype), K(St.prototype, "disableCaptions", [Qt, Y, di], Object.getOwnPropertyDescriptor(St.prototype, "disableCaptions"), St.prototype), K(St.prototype, "setSpeakingLanguage", [Y, di], Object.getOwnPropertyDescriptor(St.prototype, "setSpeakingLanguage"), St.prototype), K(St.prototype, "setTranslationLanguage", [Y, di], Object.getOwnPropertyDescriptor(St.prototype, "setTranslationLanguage"), St.prototype), K(St.prototype, "enableManualCaptioner", [Qt, Y, di], Object.getOwnPropertyDescriptor(St.prototype, "enableManualCaptioner"), St.prototype), K(St.prototype, "disableManualCaptioner", [Qt, Y, di], Object.getOwnPropertyDescriptor(St.prototype, "disableManualCaptioner"), St.prototype), K(St.prototype, "assignManualCaption", [Y, Qt, di], Object.getOwnPropertyDescriptor(St.prototype, "assignManualCaption"), St.prototype), K(St.prototype, "sendCaptionTextManually", [Y, di], Object.getOwnPropertyDescriptor(St.prototype, "sendCaptionTextManually"), St.prototype), St);
const uD = { epics0: (e) => e.pipe(ge(`${Un}`), ae((t) => {
  const { payload: { liveTranscription: r } } = t;
  return $I(r);
})), epics1: (e, t) => se(e, En).pipe(z((r) => {
  var n, o;
  return ((n = r.payload.body) === null || n === void 0 ? void 0 : n.NewLttAvaliable) !== void 0 || ((o = r.payload.body) === null || o === void 0 ? void 0 : o.LiveTransEngineType) !== void 0;
}), ae((r) => {
  const { payload: { body: { NewLttAvaliable: n, LiveTransEngineType: o } } } = r, { liveTranscription: { isEnableAutomatedCaptions: i } } = t.value;
  return n !== void 0 ? (O(TC, !!n), BI(i && !!n)) : ZI(o);
})), epics2: (e, t) => se(e, 7982).pipe(G((r) => {
  const { payload: { body: { status: n, gwId: o } } } = r, i = [];
  switch (n) {
    case Sd.Ready:
      i.push(HI(o));
      break;
    case Sd.ManualCaptionerEnabled:
      O(Jn, { autoCaption: !1 }), i.push(jf(!0));
      break;
    case Sd.ManualCaptionerDisabled:
      O(Jn, { autoCaption: !0 }), i.push(mI({ editorId: "", isEditor: !1, editorZoomId: "" })), i.push(jf(!1));
      break;
    case Sd.UserSub: {
      O(Jn, { autoCaption: t.value.liveTranscription.isLiveTranscriptionEnabled });
      const { liveTranscription: { stateBeforeFailover: a } } = t.value;
      if (a != null && a.isLiveTranscriptionSubscribed) {
        var s;
        WS.enableNewLLT();
        const l = (s = a.currentTranscriptionLang) !== null && s !== void 0 ? s : Ln.Unspecified;
        eu(l), i.push(ms(l)), a.currentTranslationLang !== void 0 && WS.setTranslationLanguage(a.currentTranslationLang), i.push(GI());
      }
      break;
    }
  }
  return ne(i);
})), epics3: (e) => se(e, 7984).pipe(ae((t) => {
  const { payload: { body: { langs: r } } } = t;
  return FI(r);
})), epics4: (e) => se(e, 8011).pipe(G((t) => {
  const { payload: { body: { disabled: r } } } = t, n = [];
  return O(Rc, r), n.push(JI(r)), r && n.push(Uf(!1)), ne(n);
})), epics5: (e) => se(e, 7985).pipe(z((t) => {
  var r;
  return ((r = t.payload.body) === null || r === void 0 ? void 0 : r.success) === !0;
}), G((t) => {
  const { payload: { body: { src: r, lang: n, success: o } } } = t, i = [];
  return o && i.push(Uf(!0)), r === hi.ASR ? (n === Ln.NoTranslation ? i.push(l0(void 0)) : i.push(l0(n)), O(Jn, { autoCaption: !0, lang: n })) : [hi.InMeetingManual, hi.ExternalCaptioner].includes(r) && O(Jn, { autoCaption: !1 }), ne(i);
})), epics6: (e, t) => se(e, 7986).pipe(pe(t), G((r) => {
  let [n, o] = r;
  const i = be(o), { liveTranscription: { currentTranscriptionLang: s } } = o, { payload: { body: a } } = n, l = [];
  if ((a == null ? void 0 : a.lang) !== void 0) {
    const { lang: u } = a;
    (i == null ? void 0 : i.audio) === "computer" && s !== u && eu(u), l.push(ms(u));
  }
  return ne(l);
})), epics7: (e, t) => Pe(e, X.JoinComputerAudioComplete).pipe(z(() => t.value.liveTranscription.isLiveTranscriptionSubscribed), he(() => {
  const { liveTranscription: { currentTranscriptionLang: r } } = t.value;
  r && eu(r);
}), Ie(oe)), epics8: (e, t) => se(e, 7983).pipe(z((r) => r.payload.body !== void 0), G((r) => {
  const { payload: { body: { msgType: n, errorCode: o, language: i, source: s, content: a, keyNodeId: l, msgId: u, nodeId: d, pos: c, size: p, audioLanguage: h } } } = r;
  if (n === ui.Error) {
    if (o === HS.TranslateNotSupport) {
      const { liveTranscription: { currentTranslationLang: v } } = t.value;
      v && O(Hl, { error: HS.TranslateNotSupport, errorMessage: `${Xl[h]} to ${Xl[v]} translation is not supported!`, audioLanguage: h, translationLang: v });
    }
  } else {
    const v = t.value, f = ft(v), { liveTranscription: { isManualCaptionerEnabled: m } } = v;
    if (m && s === hi.ASR)
      return Promise.resolve();
    if (function(g, C) {
      const { liveTranscription: { isEnableTranslatedCaptions: b, isLiveTranscriptionEnabled: E }, meeting: { meetingOptions: w } } = C, { isEnableManualCaptions: _, isEnableAllowHostAssignTypeCC: I, isEnableClosedCaption: D, isEnableAllowThirdPartyCCToken: B } = w;
      return g === hi.ASR ? b || E : g === hi.InMeetingManual ? _ && I || _ === void 0 && D : g === hi.ExternalCaptioner ? B : void 0;
    }(s, v) && a && l) {
      const g = iD(v)[l];
      if (g)
        return ir.beginDecrypt({ decryptedText: a, type: mr.CC_MESSAGE, zoomId: g }).then((C) => {
          let { message: b } = C;
          const { liveTranscription: { messageRecords: E } } = t.value, w = [], _ = E.find((I) => I.msgId === u);
          if (_) {
            const { text: I } = _, D = ((L, R) => {
              if (!L || R === 0)
                return "";
              let y = 0;
              for (let A = 0; A < L.length; A++)
                if (y += K4(L[A]), y === R)
                  return L.slice(0, A + 1);
              return L;
            })(I, c);
            let B;
            n === ui.Insert && p === 0 || n === ui.Delete && p === 0 ? B = { ..._, text: D + b, msgType: n } : n === ui.Close && (B = { ..._, text: b, msgType: n, done: !0 }), B && (w.push(zI(B)), O(Hl, B));
          } else if ([ui.New, ui.Close].includes(n) || m && n === ui.Insert) {
            const I = f.find((B) => B.userId === d), D = { msgId: u, userId: d, displayName: I == null ? void 0 : I.displayName, avatar: I == null ? void 0 : I.avatar, text: b, source: s, language: i, timestamp: (/* @__PURE__ */ new Date()).getTime(), done: n === ui.Close };
            w.push(Bf({ ...D, msgType: n })), O(Hl, D);
          }
          return w;
        });
    }
  }
  return Promise.resolve();
}), G((r) => Array.isArray(r) ? ne(r) : oe)), epics9: (e, t) => e.pipe(ge(`${Bf}`), Fr(Du), G(() => {
  const { liveTranscription: { messageRecords: r } } = t.value;
  return r.length >= 1e5 ? function(n) {
    const { meeting: { meetingId: o }, liveTranscription: { messageRecords: i, reducedRecordsCount: s } } = n;
    return window.indexedDB !== void 0 ? new Promise((a) => {
      const l = window.indexedDB.open(uc, 1);
      l.addEventListener("upgradeneeded", () => {
        const u = l.result;
        if (!u.objectStoreNames.contains(Wo)) {
          const d = u.createObjectStore(Wo, { keyPath: ["startIndex", "mid"], autoIncrement: !1 });
          d.createIndex("mid", "mid", { unique: !1 }), d.transaction.oncomplete = () => {
            console.log(`Create objectStore [${Wo}] complete`);
          };
        }
      }), l.addEventListener("success", () => {
        const u = l.result, d = i.length, c = 0.9 * d, p = d - c, h = i.slice(0, c), v = s + h.length, f = u.transaction([Wo], "readwrite");
        f.objectStore(Wo).put({ startIndex: s, mid: o, records: h }), f.oncomplete = () => {
          a(WI({ remains: p, reducedRecordsCount: v })), u.close();
        }, f.onerror = () => {
          a(""), u.close();
        };
      });
    }) : Promise.resolve("");
  }(t.value) : Promise.resolve("");
}), z((r) => typeof r == "object")), epics10: (e, t) => e.pipe(ge(`${au}`, `${Ha}`), z(() => t.value.liveTranscription.isRecordsReduced), he(() => {
  (function() {
    if (window.indexedDB !== void 0) {
      const r = window.indexedDB.open(uc, 1);
      r.addEventListener("success", () => {
        const n = r.result;
        n.objectStoreNames.contains(Wo) && (window.indexedDB.deleteDatabase(uc), n.close());
      });
    }
  })();
}), Ie(oe)), epics11: (e, t) => Pe(e, [X.AudiobridgeSetCcLangSuccess, X.AudiobridgeSetCcLangFailure]).pipe(G((r) => {
  const { payload: { type: n, data: o } } = r, { liveTranscription: { currentTranscriptionLang: i } } = t.value, s = [];
  return n === X.AudiobridgeSetCcLangSuccess && o !== i ? s.push(ms(o)) : n === X.AudiobridgeSetCcLangFailure && s.push(ms(void 0)), ne(s);
})) }, dD = Wr(uD), ZS = { isLiveStreamEnable: !1, status: 0 }, cD = zr({ [`${YI}`]: M((e, t) => {
  let { payload: r } = t;
  e.isLiveStreamEnable = r;
}), [`${d0}`]: M((e, t) => {
  let { payload: r } = t;
  e.status = r;
}), [`${XI}`]: (e, t) => {
  let { payload: r } = t;
  return r ? { ...e } : { ...ZS };
} }, ZS);
let ci = function(e) {
  return e[e.Ended = 0] = "Ended", e[e.InProgress = 1] = "InProgress", e[e.Connecting = 2] = "Connecting", e[e.Timeout = 3] = "Timeout", e;
}({});
var Ji;
const GS = We.createAgent();
let pD = (K((Ji = class extends Po {
  startLiveStream(e, t, r) {
    const { [ce]: n, [Nt]: o } = this, { liveStream: { isLiveStreamEnable: i, status: s } } = n();
    return s === ci.InProgress ? Promise.reject({ type: W, reason: "Live stream is already on" }) : i ? e && t && r ? (GS.startLiveStream(e, t, r), Te({ event: Gl, operations: [z((a) => a === ci.InProgress), Ge(1)] }, void 0, 3e4).then(() => "").catch(() => {
      const { liveStream: { status: a } } = n();
      return a === ci.Connecting ? (O(Gl, ci.Timeout), o(d0(ci.Timeout)), Promise.reject({ type: Eo })) : Promise.resolve("");
    })) : Promise.reject({ type: De, reason: "parameter cannot be empty" }) : Promise.reject({ type: W, reason: "Live stream is not enabled" });
  }
  stopLiveStream() {
    const { [ce]: e, [Nt]: t } = this, { liveStream: { status: r } } = e();
    return r === ci.InProgress && (GS.stopLiveStream(), O(Gl, ci.Ended), t(d0(ci.Ended))), Promise.resolve("");
  }
  isLiveStreamEnabled() {
    var e;
    const { [ce]: t } = this;
    return !((e = t().liveStream) === null || e === void 0 || !e.isLiveStreamEnable);
  }
  getLiveStreamStatus() {
    var e;
    const { [ce]: t } = this;
    return (e = t().liveStream) === null || e === void 0 ? void 0 : e.status;
  }
}).prototype, "startLiveStream", [Qt], Object.getOwnPropertyDescriptor(Ji.prototype, "startLiveStream"), Ji.prototype), K(Ji.prototype, "stopLiveStream", [Qt], Object.getOwnPropertyDescriptor(Ji.prototype, "stopLiveStream"), Ji.prototype), Ji);
const hD = Wr({ epics0: (e) => e.pipe(ge(`${Un}`), ae((t) => {
  const { payload: { liveStreamInfo: r } } = t;
  return YI(!(r == null || !r.isEnabledLiveStream));
})), epics1: (e) => se(e, 7970).pipe(ae((t) => {
  const { payload: { body: { channelName: r, liveStreamOn: n, isApiCall: o, status: i, viewerUrl: s } } } = t;
  return O(Gl, i), d0(i);
})) }), { setSummaryEnable: O_, setSmartSummaryStatus: T_, resetSummary: fD } = Yt("SET_SUMMARY_ENABLE", "SET_SMART_SUMMARY_STATUS", "RESET_SUMMARY"), { setMeetingQueryEnable: k_, setMeetingQueryStatus: M_ } = Yt("SET_MEETING_QUERY_ENABLE", "SET_MEETING_QUERY_STATUS");
let Ii = function(e) {
  return e.Default = "", e.Start = "Start", e.Paused = "Paused", e.Stopped = "Stopped", e;
}({}), ki = function(e) {
  return e[e.GW_IND_NONE = 0] = "GW_IND_NONE", e[e.GW_IND_START = 1] = "GW_IND_START", e[e.GW_IND_PAUSE = 2] = "GW_IND_PAUSE", e[e.GW_IND_STOP = 3] = "GW_IND_STOP", e;
}({}), Ai = function(e) {
  return e.Default = "", e.Start = "Start", e.Paused = "Paused", e.Stopped = "Stopped", e;
}({}), Mi = function(e) {
  return e[e.GW_IND_NONE = 0] = "GW_IND_NONE", e[e.GW_IND_START = 1] = "GW_IND_START", e[e.GW_IND_PAUSE = 2] = "GW_IND_PAUSE", e[e.GW_IND_STOP = 3] = "GW_IND_STOP", e;
}({});
const qS = { summaryStatus: ki.GW_IND_STOP, summaryEnable: !1, meetingQueryStatus: Mi.GW_IND_STOP, meetingQueryEnable: !1 }, vD = zr({ [`${O_}`]: M((e, t) => {
  let { payload: r } = t;
  e.summaryEnable = r;
}), [`${T_}`]: M((e, t) => {
  let { payload: r } = t;
  e.summaryStatus = r;
}), [`${k_}`]: M((e, t) => {
  let { payload: r } = t;
  e.meetingQueryEnable = r;
}), [`${M_}`]: M((e, t) => {
  let { payload: r } = t;
  e.meetingQueryStatus = r;
}), [`${fD}`]: () => ({ ...qS }) }, qS);
var KS, JS, QS, YS, cn;
const bd = We.createAgent();
let mD = (KS = de("summary"), JS = de("summary"), QS = de("summary"), YS = de("summary"), K((cn = class extends Po {
  startSummary() {
    const e = this[ce](), { summary: { summaryEnable: t, summaryStatus: r } } = e;
    return t ? r === ki.GW_IND_START ? Promise.resolve("") : (bd.summaryMeeting(!0), Te(Si, (n) => n.status === Ii.Start)) : Promise.reject({ type: W, reason: "The account of the meeting disabled the smart summary" });
  }
  stopSummary() {
    const e = this[ce](), { summary: { summaryStatus: t } } = e;
    return t !== ki.GW_IND_START ? Promise.resolve("not start summary, do nothing") : (bd.summaryMeeting(!1), Te(Si, (r) => r.status === Ii.Stopped));
  }
  getSummaryStatus() {
    const e = this[ce](), { summary: { summaryStatus: t } } = e;
    return t === ki.GW_IND_START ? Ii.Start : t === ki.GW_IND_STOP ? Ii.Stopped : Ii.Default;
  }
  isSummaryEnabled() {
    const e = this[ce](), { summary: { summaryEnable: t } } = e;
    return t;
  }
  startMeetingQuery() {
    const e = this[ce](), { summary: { meetingQueryEnable: t, meetingQueryStatus: r } } = e;
    return t ? r === Mi.GW_IND_START ? Promise.resolve("") : (bd.startMeetingQuery(!0), Te(bi, (n) => n.status === Ai.Start)) : Promise.reject({ type: W, reason: "The account of the meeting disabled the smart summary" });
  }
  stopMeetingQuery() {
    const e = this[ce](), { summary: { meetingQueryStatus: t } } = e;
    return t !== Mi.GW_IND_START ? Promise.resolve("not start meeting query, do nothing") : (bd.startMeetingQuery(!1), Te(bi, (r) => r.status === Ai.Stopped));
  }
  getMeetingQueryStatus() {
    const e = this[ce](), { summary: { meetingQueryStatus: t } } = e;
    return t === Mi.GW_IND_START ? Ai.Start : t === Mi.GW_IND_STOP ? Ai.Stopped : Ai.Default;
  }
  isMeetingQueryEnabled() {
    const e = this[ce](), { summary: { meetingQueryEnable: t } } = e;
    return t;
  }
}).prototype, "startSummary", [Qt, Y, KS], Object.getOwnPropertyDescriptor(cn.prototype, "startSummary"), cn.prototype), K(cn.prototype, "stopSummary", [Qt, Y, JS], Object.getOwnPropertyDescriptor(cn.prototype, "stopSummary"), cn.prototype), K(cn.prototype, "startMeetingQuery", [Qt, Y, QS], Object.getOwnPropertyDescriptor(cn.prototype, "startMeetingQuery"), cn.prototype), K(cn.prototype, "stopMeetingQuery", [Qt, Y, YS], Object.getOwnPropertyDescriptor(cn.prototype, "stopMeetingQuery"), cn.prototype), cn);
const gD = Wr({ moduleEpics0: (e) => se(e, 8007).pipe(z((t) => {
  var r;
  return ((r = t.payload.body) === null || r === void 0 ? void 0 : r.supported) !== void 0;
}), ae((t) => {
  const { supported: r } = t.payload.body;
  return O(Si, { supported: r }), O_(r);
})), moduleEpics1: (e, t) => se(e, 8008).pipe(z((r) => {
  var n;
  return ((n = r.payload.body) === null || n === void 0 ? void 0 : n.status) !== void 0;
}), pe(t), G((r) => {
  let [n, o] = r;
  const { status: i } = n.payload.body, { summary: { summaryStatus: s } } = o, a = [];
  if (i !== s)
    switch (i) {
      case ki.GW_IND_START:
        O(Si, { status: Ii.Start });
        break;
      case ki.GW_IND_PAUSE:
        O(Si, { status: Ii.Paused });
        break;
      case ki.GW_IND_STOP:
        O(Si, { status: Ii.Stopped });
        break;
      default:
        O(Si, { status: "" });
    }
  return a.push(T_(i)), ne(a);
})), moduleEpics2: (e, t) => se(e, 8015).pipe(z((r) => {
  var n;
  return ((n = r.payload.body) === null || n === void 0 ? void 0 : n.supported) !== void 0;
}), pe(t), ae((r) => {
  let [n, o] = r;
  const { supported: i } = n.payload.body;
  O(bi, { supported: i });
  const { meeting: { zlkJwtToken: s } } = o;
  if (s) {
    const { auto_transcription: a } = nl(s);
    a && (i ? We.createAgent().startMeetingQuery(!0) : console.warn("You account don't support auto transcription"));
  }
  return k_(i);
})), moduleEpics3: (e, t) => se(e, 8016).pipe(z((r) => {
  var n;
  return ((n = r.payload.body) === null || n === void 0 ? void 0 : n.status) !== void 0;
}), pe(t), G((r) => {
  let [n, o] = r;
  const { status: i } = n.payload.body, { summary: { meetingQueryStatus: s } } = o, a = [];
  if (i !== s)
    switch (i) {
      case Mi.GW_IND_START:
        O(bi, { status: Ai.Start });
        break;
      case Mi.GW_IND_PAUSE:
        O(bi, { status: Ai.Paused });
        break;
      case Mi.GW_IND_STOP:
        O(bi, { status: Ai.Stopped });
        break;
      default:
        O(bi, { status: "" });
    }
  return a.push(M_(i)), ne(a);
})) });
var Ol;
const yD = { chat: { epic: QM, reducer: qM, Client: KM }, logger: { epic: _P, reducer: wP, Client: class extends Po {
  getLogs(e) {
    return md.getLogs(this[At], e);
  }
  getStore() {
    return md.doNotUseDirtyGetStore();
  }
  setLogOptions(e) {
    e && this[At].dispatch(Vm(e));
  }
  reportToGlobalTracing(e) {
    return md.reportToGlobalTracing(e);
  }
  reportRating(e, t) {
    const { meeting: r, media: n, socket: o } = this[At].getState();
    if (r) {
      var i, s, a, l, u;
      const { zlkJwtToken: d, meetingStatus: c } = r, { assetsPath: p, enforceMultipleVideos: h, enforceVirtualBackground: v, disableRenderLimits: f } = n;
      md.report(`rating:${e}, feedback:${t}, appKey:${d ? (i = nl(d)) === null || i === void 0 ? void 0 : i.app_key : ""}, CPU:${navigator.hardwareConcurrency}, GPU:${(s = ve.gpu) !== null && s !== void 0 ? s : ""}, browser:${ve.browser} ${ve.browserVersion}, OS:${ve.os} ${ve.osVersion}, SharedArrayBuffer:${!!window.crossOriginIsolated}, assetPath:${p}, enforceMultipleVideos:${h},disableRenderLimits:${f} enforceVirtualBackground:${v}, ${c === xt.Joined ? `session duration:${Math.floor(((a = performance.now() - (r == null ? void 0 : r.pingRWCTimestamp)) !== null && a !== void 0 ? a : 0) / 1e3)}, rwg:${o == null || (l = o.rwgServerList) === null || l === void 0 || (u = l[o.retryCount]) === null || u === void 0 ? void 0 : u.rwg}, failover count:${r == null ? void 0 : r.failover.count}` : ""}`, "User Rating", "info"), Number(e) <= 2 && this.reportToGlobalTracing();
    }
    return Promise.resolve();
  }
} }, recording: { epic: MP, reducer: OP, Client: TP }, cmd: { epic: xP, reducer: PP, Client: DP }, breakoutRoom: { epic: oD, reducer: $P, Client: tD }, liveTranscription: { epic: dD, reducer: aD, Client: lD }, liveStream: { epic: hD, reducer: cD, Client: pD }, summary: { epic: gD, reducer: vD, Client: mD } }, SD = We.createAgent();
let bD = (Ol = class extends HM {
  constructor(e) {
    super(e), this.mediaStream = void 0, this[O0] = yD;
  }
  getMediaStream() {
    return this.mediaStream === void 0 && (this.mediaStream = new BP(this[At])), this.mediaStream;
  }
  joinInstant(e, t, r, n, o, i) {
    const { [ce]: s, [Nt]: a } = this, { meeting: { lang: l, meetingStatus: u }, socket: { zoomSocketStatus: d } } = s();
    return t ? u !== xt.Joined && d === dt.Closed ? (a(su({ topic: e, password: o || "", userName: r, zlk: t, lang: l, cv: n })), i && a(uC(i)), $o(lO.JoinMeeting)) : Promise.reject({ type: W, reason: "duplicated operation" }) : Promise.reject({ type: W, reason: "invalid  signature" });
  }
  removeUser(e) {
    const t = this[At].getState(), { participants: { attendeesList: r } } = t;
    return r.find((o) => o.userId === e) ? (SD.expel(e), Te(am, (o) => o.some((i) => i.userId === e))) : Promise.reject({ type: De, reason: "no matched user" });
  }
}, K(Ol.prototype, "removeUser", [rr, Y], Object.getOwnPropertyDescriptor(Ol.prototype, "removeUser"), Ol.prototype), Ol);
class CD {
  constructor(t) {
    this.instant = void 0, this.context = void 0, this.script = void 0, this.mic = void 0, this.instant = 0, this.context = t, this.mic = null, this.script = t.createScriptProcessor(2048, 1, 1), this.script.onaudioprocess = (r) => {
      const n = r.inputBuffer.getChannelData(0);
      let o, i = 0;
      for (o = 0; o < n.length; ++o)
        i += n[o] * n[o];
      this.instant = Math.sqrt(i / n.length);
    };
  }
  connectToSource(t) {
    console.log("InputMicDetector is listening");
    try {
      var r;
      this.mic = this.context.createMediaStreamSource(t), this.mic.connect(this.script), (r = this.script) === null || r === void 0 || r.connect(this.context.destination);
    } catch (n) {
      console.error(n);
    }
  }
  stop() {
    var t, r;
    console.log("Audio Previewer stopped"), (t = this.mic) === null || t === void 0 || t.disconnect(), this.mic = null, (r = this.script) === null || r === void 0 || r.disconnect(), this.script = null;
  }
  getMicVolume() {
    return this.instant;
  }
}
const wD = "https://st1.zoom.us/web_client/4qu8baa/audio/ring.mp3";
class ED {
  constructor() {
    this.sampleAudio = void 0, this.audioCtx = void 0, this.destinationNode = void 0, this.audioPlayer = void 0, this.analyzserInterval = void 0, this.analyserNode = void 0, this.analyserNodeBufferDataArray = void 0, this.analyserCallback = void 0, this.sourceNode = void 0, this.mAudioStream = void 0, this.mSourceNode = void 0, this.mediaRecorder = void 0, this.isRecording = void 0, this.recorderChunks = [], this.recorderObjUrl = void 0, this.recorderPlayer = void 0, this.maximumRecordingTimer = void 0, this.shouldPlayAfterRecording = !0, this.isRunning = !1;
  }
  testSpeaker(t) {
    var r;
    if (typeof AudioContext != "function" || typeof MediaStreamAudioDestinationNode != "function" || !AudioContext.prototype.decodeAudioData)
      return void console.warn("Cannot test the speaker due to the browser capability");
    const { speakerId: n, sampleAudioUrl: o = wD, onAnalyseFrequency: i } = t || {};
    if (this.isRunning)
      return void console.warn("A tester is running,please stop it first");
    this.isRunning = !0, this.initAudioContext(), (((r = this.sampleAudio) === null || r === void 0 ? void 0 : r.url) === o && this.sampleAudio.data ? Promise.resolve(this.sampleAudio.data) : window.fetch(o).then((a) => a.arrayBuffer()).then((a) => this.audioCtx.decodeAudioData(a)).then((a) => (this.sampleAudio = { url: o, data: a }, a))).then((a) => {
      var l, u, d;
      this.sourceNode = this.audioCtx.createBufferSource(), this.sourceNode.buffer = a, this.sourceNode.loop = !0, n && (l = this.audioPlayer) !== null && l !== void 0 && l.setSinkId && this.audioPlayer.setSinkId(n), i ? typeof AudioContext.prototype.createAnalyser == "function" ? (this.analyzserInterval && window.clearInterval(this.analyzserInterval), this.analyserCallback = i, this.initAnalyserNode(), this.analyserNode && this.sourceNode.connect(this.analyserNode)) : (this.sourceNode.connect(this.destinationNode), console.warn("Cannot analyze the stream due to the browser capability")) : (this.analyserCallback = void 0, this.sourceNode.connect(this.destinationNode)), this.sourceNode.start(0), ((u = this.audioCtx) === null || u === void 0 ? void 0 : u.state) !== "running" && ((d = this.audioCtx) === null || d === void 0 || d.resume()), this.audioPlayer && (this.audioPlayer.muted = !1, this.audioPlayer.currentTime = 0, this.audioPlayer.play());
    });
    const s = () => {
      this.isRunning = !1, this.audioPlayer && (this.audioPlayer.currentTime = 0, this.audioPlayer.pause()), this.analyserNode && this.analyzserInterval && (window.clearInterval(this.analyzserInterval), this.analyzserInterval = void 0, this.analyserNodeBufferDataArray = void 0), this.sourceNode && (this.sourceNode.stop(0), this.sourceNode.disconnect(), this.sourceNode.buffer = null, this.sourceNode = void 0);
    };
    return { stop: s, destroy: () => {
      var a;
      s(), this.analyserNode && this.destinationNode && (this.analyserNode.disconnect(this.destinationNode), this.analyserNode = void 0), (a = this.audioCtx) === null || a === void 0 || a.close(), this.audioCtx = void 0;
    } };
  }
  testMicrophone(t) {
    var r;
    if (typeof AudioContext != "function" || typeof MediaStreamAudioDestinationNode != "function" || typeof AudioContext.prototype.createMediaStreamSource != "function" || typeof ((r = navigator.mediaDevices) === null || r === void 0 ? void 0 : r.getUserMedia) != "function")
      return void console.warn("Cannot test the microphone due to the browser capability");
    const { microphoneId: n, speakerId: o, recordAndPlay: i, maxRecordDuration: s, onAnalyseFrequency: a, onStartRecording: l, onStopRecording: u, onStartPlayRecording: d, onStopPlayRecording: c } = t || {};
    if (this.isRunning)
      return void console.warn("A tester is running,please stop it first");
    this.isRunning = !0, this.initAudioContext();
    const p = () => {
      i && this.mediaRecorder && this.isRecording && (this.shouldPlayAfterRecording = !0, this.mediaRecorder.state !== "inactive" && this.mediaRecorder.stop());
    };
    window.navigator.mediaDevices.getUserMedia({ audio: !n || { deviceId: { exact: n } } }).then((v) => {
      var f, m, g, C;
      this.mAudioStream = v, this.mSourceNode = (f = this.audioCtx) === null || f === void 0 ? void 0 : f.createMediaStreamSource(v), this.audioPlayer.muted = !0, a ? (this.analyzserInterval && window.clearInterval(this.analyzserInterval), this.analyserCallback = a, this.initAnalyserNode(), this.analyserNode && ((g = this.mSourceNode) === null || g === void 0 || g.connect(this.analyserNode))) : this.analyserCallback = void 0, i && (typeof MediaRecorder == "function" ? (this.recorderObjUrl && window.URL.revokeObjectURL(this.recorderObjUrl), this.mediaRecorder = new MediaRecorder(this.mAudioStream), this.mediaRecorder.ondataavailable = (b) => {
        b.data && this.recorderChunks.push(b.data);
      }, this.mediaRecorder.onstop = () => {
        if (this.isRecording = !1, this.maximumRecordingTimer && (window.clearTimeout(this.maximumRecordingTimer), this.maximumRecordingTimer = void 0), u == null || u(), this.recorderChunks.length > 0) {
          var b;
          const E = new Blob(this.recorderChunks, { type: ((b = this.recorderChunks[0]) === null || b === void 0 ? void 0 : b.type) || "audio/ogg; codecs=opus" });
          this.recorderObjUrl = window.URL.createObjectURL(E), this.shouldPlayAfterRecording && this.playRecording(this.recorderObjUrl, o, d, c).catch((w) => {
            this.analyzserInterval && (window.clearInterval(this.analyzserInterval), this.analyzserInterval = void 0, this.analyserNodeBufferDataArray = void 0), console.warn(w);
          }), this.recorderChunks = [], this.mediaRecorder && (this.mediaRecorder.ondataavailable = null, this.mediaRecorder.onstop = null, this.mediaRecorder = void 0);
        }
      }, this.mediaRecorder.start(), this.isRecording = !0, l == null || l(), this.maximumRecordingTimer = window.setTimeout(() => {
        p();
      }, s || 1e4)) : console.warn("Cannot record the sound due to the browser capability")), ((m = this.audioCtx) === null || m === void 0 ? void 0 : m.state) !== "running" && ((C = this.audioCtx) === null || C === void 0 || C.resume()), this.audioPlayer && (this.audioPlayer.currentTime = 0, this.audioPlayer.play());
    });
    const h = () => {
      this.isRunning = !1, this.maximumRecordingTimer && (window.clearTimeout(this.maximumRecordingTimer), this.maximumRecordingTimer = void 0), this.audioPlayer && (this.audioPlayer.currentTime = 0, this.audioPlayer.pause()), this.analyserNode && this.analyzserInterval && (window.clearInterval(this.analyzserInterval), this.analyzserInterval = void 0, this.analyserNodeBufferDataArray = void 0), this.mSourceNode && (a && this.analyserNode && this.mSourceNode.disconnect(this.analyserNode), this.mSourceNode = void 0), this.mAudioStream && (this.mAudioStream.getAudioTracks().forEach((v) => {
        v.stop();
      }), this.mAudioStream = void 0), this.mediaRecorder && (this.shouldPlayAfterRecording = !1, this.mediaRecorder.ondataavailable = null, this.mediaRecorder.onstop = null, this.mediaRecorder.state !== "inactive" && this.mediaRecorder.stop(), this.isRecording = !1, this.mediaRecorder = void 0, this.recorderChunks = []), this.recorderPlayer && (this.recorderPlayer.currentTime = 0, this.recorderPlayer.pause());
    };
    return { stop: h, stopRecording: p, destroy: () => {
      var v;
      h(), this.analyserNode && this.destinationNode && (this.analyserNode.disconnect(this.destinationNode), this.analyserNode = void 0), (v = this.audioCtx) === null || v === void 0 || v.close(), this.audioCtx = void 0;
    } };
  }
  initAudioContext() {
    this.audioCtx && this.audioPlayer || (this.audioCtx = new AudioContext(), this.destinationNode = new MediaStreamAudioDestinationNode(this.audioCtx), this.audioPlayer = new Audio(), this.audioPlayer.loop = !0, this.audioPlayer.srcObject = this.destinationNode.stream);
  }
  initAnalyserNode() {
    this.analyserNode || (this.analyserNode = this.audioCtx.createAnalyser(), this.analyserNode.connect(this.destinationNode), this.analyserNode.fftSize = 1024);
    const t = this.analyserNode.frequencyBinCount;
    this.analyserNodeBufferDataArray = new Uint8Array(t), this.analyzserInterval = window.setInterval(this.audioAnalyserCallback.bind(this), 20);
  }
  audioAnalyserCallback() {
    if (this.analyserNodeBufferDataArray && this.analyserNode && this.analyserCallback) {
      this.analyserNode.getByteFrequencyData(this.analyserNodeBufferDataArray);
      let t = 0;
      for (const n of this.analyserNodeBufferDataArray)
        t += n;
      const r = t / this.analyserNodeBufferDataArray.length;
      this.analyserCallback(r);
    }
  }
  playRecording(t, r, n, o) {
    this.recorderPlayer = new Audio(), this.recorderPlayer.src = t, this.recorderPlayer.currentTime = 0, this.recorderPlayer.setSinkId && r && this.recorderPlayer.setSinkId(r);
    const i = () => {
      o == null || o(), this.recorderPlayer && (this.recorderPlayer.onpause = null, this.recorderPlayer.onended = null, this.recorderPlayer = void 0, this.isRunning = !1);
    };
    return new Promise((s, a) => {
      this.recorderPlayer && (this.recorderPlayer.onpause = () => {
        s(!0);
      }, this.recorderPlayer.onended = () => {
        s(!0);
      }, this.recorderPlayer.onerror = a, n == null || n(), this.recorderPlayer.play().catch(a));
    }).finally(() => {
      window.URL.revokeObjectURL(t), i();
    });
  }
}
const Dh = "AudioNotStartedError";
class ID {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    this.audioContext = void 0, this.inputMicDetector = void 0, this.isMicUnmuted = void 0, this.isAudioStarted = void 0, this.audioStream = void 0, this.deviceId = void 0, this.tester = void 0, this.audioContext = null, this.inputMicDetector = null, this.isMicUnmuted = !1, this.isAudioStarted = !1, this.audioStream = null, this.deviceId = t, this.tester = new ED();
  }
  async start() {
    if (this.audioStream || this.isAudioStarted)
      throw new Error("AudioAlreadyStartedError");
    try {
      const t = await navigator.mediaDevices.getUserMedia(this.getAudioConstraints());
      this.audioStream = t, this.isAudioStarted = !0;
    } catch (t) {
      throw t;
    }
  }
  async unmute() {
    if (!this.audioStream || !this.isAudioStarted)
      throw new Error(Dh);
    if (this.isMicUnmuted)
      throw new Error("AudioAlreadyUnmutedError");
    return this.toggleMicIsMuted(!0);
  }
  async mute() {
    if (!this.audioStream || !this.isAudioStarted)
      throw new Error(Dh);
    if (!this.isMicUnmuted)
      throw new Error("AudioAlreadyMutedError");
    return this.toggleMicIsMuted(!1);
  }
  getCurrentVolume() {
    return this.inputMicDetector ? this.inputMicDetector.getMicVolume() : 0;
  }
  async stop() {
    if (!this.audioStream || !this.isAudioStarted)
      throw new Error(Dh);
    this.audioStream.getAudioTracks().forEach((t) => t.stop()), this.audioStream = null, this.isAudioStarted = !1;
  }
  async toggleMicIsMuted(t) {
    if (t) {
      if (!this.audioContext) {
        const r = window.AudioContext || window.webkitAudioContext;
        this.audioContext = new r();
      }
      this.inputMicDetector = new CD(this.audioContext), this.inputMicDetector.connectToSource(this.audioStream);
    } else
      this.inputMicDetector && this.inputMicDetector.stop(), this.inputMicDetector = null;
    this.isMicUnmuted = t;
  }
  getAudioConstraints() {
    return { audio: this.deviceId === "" || { deviceId: { exact: this.deviceId } }, video: !1 };
  }
  testSpeaker(t) {
    return this.tester.testSpeaker(t);
  }
  testMicrophone(t) {
    return this.tester.testMicrophone(t);
  }
}
const AD = { width: { min: 1024, ideal: 1280, max: 1920 }, height: { min: 576, ideal: 720, max: 1080 }, aspectRatio: { ideal: 1.777777778 } };
class _D {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    this.isVideoStarted = void 0, this.videoStream = void 0, this.deviceId = void 0, this.localPreview = void 0, this.vbPreviewInProgress = void 0, this.videoParams = void 0, this.isVideoStarted = !1, this.videoStream = null, this.vbPreviewInProgress = !1, this.deviceId = t, this.localPreview = new Os();
  }
  async start(t, r) {
    if (!t)
      throw new Error("Video DOM element is falsy");
    if (this.isVideoStarted || this.videoStream)
      throw new Error("VideoAlreadyStartedError");
    this.videoParams = { videoDOMElement: t, virtualBackground: r };
    const n = async (o) => {
      if (!o || o.name !== "OverconstrainedError" && o.name !== "ConstraintNotSatisfiedError")
        throw o;
      console.log(`Warning: detected ${o.name} -- trying to fall back to lower aspect ratio`);
      try {
        const i = await navigator.mediaDevices.getUserMedia(this.getVideoConstraints(!0));
        return this.tryPlayVideo(t, i);
      } catch (i) {
        throw i;
      }
    };
    if (t instanceof HTMLVideoElement)
      try {
        const o = await navigator.mediaDevices.getUserMedia(this.getVideoConstraints());
        return this.tryPlayVideo(t, o);
      } catch (o) {
        return n(o);
      }
    else {
      if (!(t instanceof HTMLCanvasElement && r != null && r.imageUrl))
        throw new Error("Cannot start video with virtual background");
      this.localPreview.setup().then(() => this.localPreview.startPreview(t, { ...r, deviceId: this.deviceId })).then(() => {
        this.vbPreviewInProgress = !0;
      });
    }
  }
  async stop() {
    if (this.vbPreviewInProgress)
      await this.localPreview.stopPreview(), this.vbPreviewInProgress = !1;
    else {
      if (!this.videoStream || !this.isVideoStarted)
        throw new Error("VideoNotStartedError");
      this.videoStream.getVideoTracks().forEach((t) => t.stop()), this.videoStream = null, this.isVideoStarted = !1;
    }
  }
  async switchCamera(t) {
    t !== this.deviceId && (this.deviceId = t, await this.stop(), this.videoParams && await this.start(this.videoParams.videoDOMElement, this.videoParams.virtualBackground));
  }
  async updateVirtualBackground(t, r) {
    this.vbPreviewInProgress && await this.localPreview.updatePreview(t, r);
  }
  getVideoConstraints() {
    let t = AD;
    return arguments.length > 0 && arguments[0] !== void 0 && arguments[0] ? t = this.deviceId === "" || { deviceId: { exact: this.deviceId } } : this.deviceId !== "" && (t.deviceId = { exact: this.deviceId }), { audio: !1, video: t };
  }
  async tryPlayVideo(t, r) {
    if (!t)
      throw new Error("Video DOM element is falsy");
    try {
      this.videoStream = r, t.srcObject = this.videoStream, await t.play(), this.isVideoStarted = !0;
    } catch (n) {
      throw n;
    }
  }
}
class bo {
  static createClient() {
    if (!this.meetingClient) {
      const t = function() {
        const r = function(a) {
          a === void 0 && (a = {});
          var l, u = new qg.constructor(qg.schedulerActionCtor), d = new xn(), c = function(p) {
            l = p;
            var h = new xn(), v = new xn(), f = h.asObservable().pipe(Fr(u)), m = new y9(v.pipe(Fr(u)), l.getState());
            return d.pipe(ae(function(g) {
              var C = g(f, m, a.dependencies);
              if (!C)
                throw new TypeError('Your root Epic "' + (g.name || "<anonymous>") + `" does not return a stream. Double check you're not missing a return statement!`);
              return C;
            }), G(function(g) {
              return ne(g).pipe(g1(u), Fr(u));
            })).subscribe(l.dispatch), function(g) {
              return function(C) {
                var b = g(C);
                return v.next(l.getState()), h.next(C), b;
              };
            };
          };
          return c.run = function(p) {
            d.next(p);
          }, c;
        }(), { epicSubject: n, rootEpic: o } = function() {
          const a = new K6(x4(ek, dk, vk, jM));
          return { epicSubject: a, rootEpic: (l, u, d) => a.pipe(G((c) => c(l, u, d))) };
        }(), i = [r], s = h4(my(), BM(function() {
          for (var a = arguments.length, l = new Array(a), u = 0; u < a; u++)
            l[u] = arguments[u];
          return function(d) {
            return function() {
              var c = d.apply(void 0, arguments), p = function() {
                throw new Error(Dr(15));
              }, h = { getState: c.getState, dispatch: function() {
                return p.apply(void 0, arguments);
              } }, v = l.map(function(f) {
                return f(h);
              });
              return p = f4.apply(void 0, v)(c.dispatch), Xg(Xg({}, c), {}, { dispatch: p });
            };
          };
        }(...i)));
        return s.asyncReducers = {}, s.injectReducer = (a, l) => {
          s.asyncReducers[a] === void 0 && (s.asyncReducers[a] = l, s.replaceReducer(my(s.asyncReducers)));
        }, s.injectEpic = (a) => {
          n.next(a);
        }, r.run(o), s;
      }();
      this.meetingClient = new bD(t);
    }
    return this.meetingClient;
  }
  static destroyClient() {
    this.meetingClient && (this.meetingClient.leave().then(() => {
      nr(500).subscribe(() => {
        ym();
      });
    }), this.meetingClient = null);
  }
  static checkFeatureRequirements() {
    return function() {
      const t = [], r = [], { isAndroidOrIOSBrowser: n, browser: o, browserVersion: i, os: s, osVersion: a, isChrome: l, isFirefox: u } = ve;
      !n && (l || u) && pl() ? t.push("Virtual Background") : r.push("Virtual Background"), (n || l) && pl() ? (t.push("720p Video (send)"), t.push("Share Chrome Tab Audio")) : (r.push("720p Video (send)"), r.push("Share Chrome Tab Audio")), (n || l || u) && pl() ? t.push("Render Multiple Videos") : r.push("Render Multiple Videos"), !n && pl() ? (t.push("Screen Share (send)"), t.push("720p Video (receive)"), t.push("Share 2nd Camera")) : (r.push("Screen Share (send)"), r.push("720p Video (receive)"), r.push("Share 2nd Camera")), pl() ? (t.push("Audio"), t.push("Video"), t.push("Screen Share (receive)"), t.push("Chat"), t.push("Closed Captioning"), t.push("Live Transcription"), t.push("Live Translation"), t.push("Cloud Recording"), t.push("Call Out (PSTN)"), t.push("Command Channel"), t.push("RTMP Live Streaming"), t.push("Encryption")) : (r.push("Audio"), r.push("Video"), r.push("Screen Share (receive)"), r.push("Chat"), r.push("Closed Captioning"), r.push("Live Transcription"), r.push("Live Translation"), r.push("Cloud Recording"), r.push("Call Out (PSTN)"), r.push("Command Channel"), r.push("RTMP Live Streaming"), r.push("Encryption"));
      const d = n ? `${s}${a}` : `${o}${i}`;
      return r.length > 0 && console.log("Some features are not supported on your platform, please refer to https://developers.zoom.us/docs/video-sdk/web/browser-support/"), { platform: d, supportFeatures: t, unSupportFeatures: r };
    }();
  }
  static checkSystemRequirements() {
    return d_();
  }
  static getDevices(t) {
    return t ? navigator.mediaDevices.enumerateDevices() : navigator.mediaDevices.getUserMedia({ audio: !0, video: !0 }).then((r) => (r.getTracks().forEach((n) => n.stop()), navigator.mediaDevices.enumerateDevices())).catch((r) => (console.warn(r), navigator.mediaDevices.enumerateDevices()));
  }
  static createLocalAudioTrack() {
    return new ID(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "");
  }
  static createLocalVideoTrack() {
    return new _D(arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "");
  }
  static preloadDependentAssets(t) {
    (async (r) => {
      const n = r || us, o = `${n}/${ss}`, i = [], s = [], a = `${n}/`;
      if (ed()) {
        const { workers: u, wasms: d } = Bi("audio", "simd", a);
        i.push(...u), s.push(...d);
      } else {
        const { workers: u, wasms: d } = Bi("audio", "", a);
        i.push(...u), s.push(...d);
      }
      if (ed() && function() {
        const { browser: u, browserVersion: d, isAndroidBrowser: c } = ve;
        return !c && u.toLowerCase() === "chrome" && Sc(d, "100") > 0 && window.crossOriginIsolated;
      }()) {
        const { workers: u, wasms: d } = Bi(["video", "sharing"], "videoShare", a);
        i.push(...u), s.push(...d);
      } else if (ed() && Ff()) {
        const { workers: u, wasms: d } = Bi(["video", "sharing"], "simd,thread", a);
        i.push(...u), s.push(...d);
      } else if (Ff()) {
        const { workers: u, wasms: d } = Bi(["video", "sharing"], "thread", a);
        i.push(...u), s.push(...d);
      } else if (ed()) {
        const { workers: u, wasms: d } = Bi(["video", "sharing"], "simd", a);
        i.push(...u), s.push(...d);
      } else {
        const { workers: u, wasms: d } = Bi(["video", "sharing"], "", a);
        i.push(...u), s.push(...d);
      }
      const l = [Up(o, "script")];
      i.forEach((u) => {
        l.push(Up(u, "fetch"));
      }), s.forEach((u) => {
        l.push(Up(u, "fetch"));
      });
      try {
        document.head.append(...l);
      } catch {
      }
    })(t);
  }
}
bo.meetingClient = void 0, bo.VERSION = tp;
var Hu = "1.11.0", Cd = "INVALID_PARAMETERS", RD = "https://dmogdx0jrul3u.cloudfront.net/videosdk/".concat(Hu, "/lib"), OD = "https://source.zoom.us/videosdk/".concat(Hu, "/lib"), TD = "https://jssdk.zoomus.cn/videosdk/".concat(Hu, "/lib"), Lh = function(e) {
  return typeof e == "string" && e.length > 0;
}, P_ = function(e) {
  var t = "";
  switch (e) {
    case "Global":
      t = OD;
      break;
    case "CN":
      t = TD;
      break;
    case "CDN":
      t = RD;
      break;
    default:
      t = e;
  }
  return t;
}, D_ = ["userId", "avatar", "displayName", "isHost", "audio", "muted", "bVideoOn", "sharerOn", "sharerPause", "userIdentity", "isSpeakerOnly", "bVideoShare", "bShareAudioOn", "userGuid", "isPhoneUser", "isInFailover", { from: "isCoHost", to: "isManager" }, { from: "bAllowISORecord", to: "isAllowIndividualRecording" }, { from: "bVideoConnect", to: "isVideoConnect" }, { from: "bShareToBORooms", to: "bShareToSubsession" }, { from: "bid", to: "subsessionId" }, { from: "phoneNumber", to: function(e) {
  return e === void 0 ? {} : { phoneNumber: e };
} }], L_ = [].concat(D_, [{ from: "userGUID", to: "userGuid" }, { from: "bCoHost", to: function(e) {
  return { isManager: !!e };
} }, { from: "userType", to: function(e) {
  return { isPhoneUser: (5 & e) == 5 };
} }, { from: "bid", to: function(e) {
  return e ? { subsessionId: e } : {};
} }]), kD = L_.map(function(e) {
  return typeof e == "string" ? e : e.from;
});
function N_(e, t) {
  return typeof e == "string" ? p1({}, "".concat(e), t) : typeof e.to == "string" ? p1({}, "".concat(e.to), t) : e.to(t);
}
function Sa(e) {
  if (e)
    return D_.reduce(function(t, r) {
      var n = typeof r == "string" ? r : r.from, o = N_(r, e[n]);
      return en(en({}, t), o);
    }, {});
}
function Nh(e) {
  if (e)
    return Object.keys(e).reduce(function(t, r) {
      var n = kD.indexOf(r);
      if (n > -1) {
        var o = L_[n], i = typeof o == "string" ? o : o.from, s = N_(o, e[i]);
        return en(en({}, t), s);
      }
      return t;
    }, {});
}
var XS, eb, tb, rb, nb, ob, ib, sb, Q = Symbol("stream"), MD = function() {
  function e(t) {
    so(this, e), this[Q] = void 0, this[Q] = t;
  }
  return ao(e, [{ key: "startAudio", value: function(t) {
    return this[Q].startAudio(t);
  } }, { key: "stopAudio", value: function() {
    return this[Q].stopAudio();
  } }, { key: "muteAudio", value: function(t) {
    return this[Q].muteAudio(t);
  } }, { key: "unmuteAudio", value: function(t) {
    return this[Q].unmuteAudio(t);
  } }, { key: "inviteByPhone", value: function(t, r, n, o) {
    return this[Q].dialOut(t, r, n, o);
  } }, { key: "cancelInviteByPhone", value: function(t, r, n) {
    return this[Q].cancelDialOut(t, r, n);
  } }, { key: "hangup", value: function() {
    return this[Q].hangup();
  } }, { key: "getCurrentSessionCallinInfo", value: function() {
    return this[Q].getDialInInfo();
  } }, { key: "muteShareAudio", value: function(t) {
    return this[Q].muteShareAudio(t);
  } }, { key: "unmuteShareAudio", value: function(t) {
    return this[Q].unmuteShareAudio(t);
  } }, { key: "subscribeAudioStatisticData", value: function(t) {
    return this[Q].subscribeAudioStatisticData(t);
  } }, { key: "unsubscribeAudioStatisticData", value: function(t) {
    return this[Q].unsubscribeAudioStatisticData(t);
  } }, { key: "muteUserAudioLocally", value: function(t) {
    return this[Q].muteUserAudioLocally(t);
  } }, { key: "unmuteUserAudioLocally", value: function(t) {
    return this[Q].unmuteUserAudioLocally(t);
  } }, { key: "adjustUserAudioVolumeLocally", value: function(t, r) {
    return this[Q].adjustUserAudioVolumeLocally(t, r);
  } }, { key: "enableBackgroundNoiseSuppression", value: function(t) {
    return this[Q].enableBackgroundNoiseSuppression(t);
  } }, { key: "enableSyncButtonsOnHeadset", value: function(t) {
    return this[Q].enableSyncButtonsOnHeadset(t);
  } }, { key: "muteAllUserAudioLocally", value: function() {
    return this[Q].muteAllUserAudioLocally();
  } }, { key: "unmuteAllUserAudioLocally", value: function() {
    return this[Q].unmuteAllUserAudioLocally();
  } }, { key: "enableOriginalSound", value: function(t) {
    return this[Q].enableOriginalSound(t);
  } }, { key: "callCRCDevice", value: function(t, r) {
    return this[Q].callCRCDevice(t, r);
  } }, { key: "cancelCallCRCDevice", value: function(t, r) {
    return this[Q].cancelCallCRCDevice(t, r);
  } }, { key: "startSecondaryAudio", value: function(t, r) {
    return this[Q].startSecondaryAudio(t, r);
  } }, { key: "stopSecondaryAudio", value: function() {
    return this[Q].stopSecondaryAudio();
  } }, { key: "isAudioMuted", value: function(t) {
    return this[Q].isAudioMuted(t);
  } }, { key: "getMicList", value: function() {
    return this[Q].getMicList();
  } }, { key: "getSpeakerList", value: function() {
    return this[Q].getSpeakerList();
  } }, { key: "getActiveMicrophone", value: function() {
    return this[Q].getActiveMicrophone();
  } }, { key: "getActiveSpeaker", value: function() {
    return this[Q].getActiveSpeaker();
  } }, { key: "switchMicrophone", value: function(t) {
    return this[Q].switchMicrophone(t);
  } }, { key: "switchSpeaker", value: function(t) {
    return this[Q].switchSpeaker(t);
  } }, { key: "isSupportPhoneFeature", value: function() {
    return this[Q].isSupportCallOut();
  } }, { key: "getSupportCountryInfo", value: function() {
    return this[Q].getDialOutCountries();
  } }, { key: "getInviteByPhoneStatus", value: function() {
    return this[Q].getDialOutStatus();
  } }, { key: "getShareAudioStatus", value: function() {
    return this[Q].getShareAudioStatus();
  } }, { key: "isOthersShareAudioMutedLocally", value: function(t) {
    return this[Q].isOthersShareAudioMutedLocally(t);
  } }, { key: "getAudioStatisticData", value: function() {
    return this[Q].getAudioStatisticData();
  } }, { key: "isUserAudioMutedLocally", value: function(t) {
    return this[Q].isUserAudioMutedLocally(t);
  } }, { key: "getUserVolumeLocally", value: function(t) {
    return this[Q].getUserVolumeLocally(t);
  } }, { key: "isSupportMicrophoneAndShareAudioSimultaneously", value: function() {
    return this[Q].isSupportMicrophoneAndShareAudioSimultaneously();
  } }, { key: "startVideo", value: function(t) {
    return this[Q].startVideo(t);
  } }, { key: "stopVideo", value: function() {
    return this[Q].stopVideo();
  } }, { key: "renderVideo", value: function(t, r, n, o, i, s, a, l) {
    return this[Q].renderVideo(t, r, n, o, i, s, a, l);
  } }, { key: "stopRenderVideo", value: function(t, r, n, o) {
    var i = arguments.length > 4 && arguments[4] !== void 0 && arguments[4], s = arguments.length > 5 ? arguments[5] : void 0;
    return this[Q].stopRenderVideo(t, r, n, o, i, s);
  } }, { key: "updateVideoCanvasDimension", value: function(t, r, n) {
    return this[Q].updateVideoCanvasDimension(t, r, n);
  } }, { key: "adjustRenderedVideoPosition", value: function(t, r, n, o, i, s, a) {
    return this[Q].adjustRenderedVideoPosition(t, r, n, o, i, s, a);
  } }, { key: "clearVideoCanvas", value: function(t, r) {
    return this[Q].clearVideoCanvas(t, r);
  } }, { key: "mirrorVideo", value: function(t) {
    return this[Q].mirrorVideo(t);
  } }, { key: "enableHardwareAcceleration", value: function(t) {
    return this[Q].enableHardwareAcceleration(t);
  } }, { key: "previewVirtualBackground", value: function(t, r, n, o) {
    return this[Q].previewVirtualBackground(t, r, n, o);
  } }, { key: "updateVirtualBackgroundImage", value: function(t, r) {
    return this[Q].updateVirtualBackgroundImage(t, r);
  } }, { key: "stopPreviewVirtualBackground", value: function() {
    return this[Q].stopPreviewVirtualBackground();
  } }, { key: "previewVideoMask", value: function(t, r) {
    return this[Q].previewVideoMask(t, r);
  } }, { key: "updateVideoMask", value: function(t) {
    return this[Q].updateVideoMask(t);
  } }, { key: "stopPreviewVideoMask", value: function() {
    return this[Q].stopPreviewVideoMask();
  } }, { key: "switchCamera", value: function(t) {
    return this[Q].switchCamera(t);
  } }, { key: "subscribeVideoStatisticData", value: function(t) {
    return this[Q].subscribeVideoStatisticData(t);
  } }, { key: "unsubscribeVideoStatisticData", value: function(t) {
    return this[Q].unsubscribeVideoStatisticData(t);
  } }, { key: "attachVideo", value: function(t, r, n) {
    return this[Q].attachVideo(t, r, n);
  } }, { key: "detachVideo", value: function(t, r) {
    return this[Q].detachVideo(t, r);
  } }, { key: "isCapturingVideo", value: function() {
    return this[Q].isCapturingVideo();
  } }, { key: "isCameraTaken", value: function() {
    return this[Q].isCameraTaken();
  } }, { key: "getActiveVideoId", value: function() {
    return this[Q].getActiveVideoId();
  } }, { key: "getActiveCamera", value: function() {
    return this[Q].getActiveCamera();
  } }, { key: "getCameraList", value: function() {
    return this[Q].getCameraList();
  } }, { key: "isCaptureForbidden", value: function() {
    return this[Q].isCaptureForbidden();
  } }, { key: "getVideoMaxQuality", value: function() {
    return this[Q].getVideoMaxQuality();
  } }, { key: "getReceivedVideoDimension", value: function() {
    return this[Q].getReceivedVideoDimension();
  } }, { key: "isSupportMultipleVideos", value: function() {
    return this[Q].isSupportMultipleVideos();
  } }, { key: "isSupportHDVideo", value: function() {
    return this[Q].isSupportHDVideo();
  } }, { key: "isSupportVirtualBackground", value: function() {
    return this[Q].isSupportVirtualBackground();
  } }, { key: "getVirtualbackgroundStatus", value: function() {
    return this[Q].getVirtualbackgroundStatus();
  } }, { key: "getVideoStatisticData", value: function() {
    return this[Q].getVideoStatisticData();
  } }, { key: "isRenderSelfViewWithVideoElement", value: function() {
    return this[Q].isRenderSelfViewWithVideoElement();
  } }, { key: "getCapturedVideoResolution", value: function() {
    return this[Q].getCapturedVideoResolution();
  } }, { key: "getVideoMaskStatus", value: function() {
    return this[Q].getVideoMaskStatus();
  } }, { key: "startShareView", value: function(t, r) {
    return this[Q].startShareView(t, r);
  } }, { key: "stopShareView", value: function() {
    return this[Q].stopShareView();
  } }, { key: "switchShareView", value: function(t) {
    return this[Q].switchShareView(t);
  } }, { key: "startShareScreen", value: function(t, r) {
    return (r == null ? void 0 : r.broadcastToSubsession) !== void 0 && Object.assign(r || {}, { broadcastToBreakoutRoom: r == null ? void 0 : r.broadcastToSubsession }), this[Q].startShareScreen(t, r);
  } }, { key: "pauseShareScreen", value: function() {
    return this[Q].pauseShareScreen();
  } }, { key: "resumeShareScreen", value: function() {
    return this[Q].resumeShareScreen();
  } }, { key: "stopShareScreen", value: function() {
    return this[Q].stopShareScreen();
  } }, { key: "lockShare", value: function(t) {
    return this[Q].lockShare(t);
  } }, { key: "updateSharingCanvasDimension", value: function(t, r) {
    return this[Q].updateSharingCanvasDimension(t, r);
  } }, { key: "switchSharingSecondaryCamera", value: function(t) {
    return this[Q].switchSharingSecondaryCamera(t);
  } }, { key: "setSharePrivilege", value: function(t) {
    return this[Q].setSharePrivilege(t);
  } }, { key: "shareToSubsession", value: function() {
    return this[Q].shareToBreakoutRoom();
  } }, { key: "stopShareToSubsession", value: function() {
    return this[Q].stopShareToBreakoutRoom();
  } }, { key: "enableOptimizeForSharedVideo", value: function(t) {
    return this[Q].enableOptimizeForSharedVideo(t);
  } }, { key: "updateSharedVideoQuality", value: function(t) {
    return this[Q].updateSharedVideoQuality(t);
  } }, { key: "subscribeShareStatisticData", value: function(t) {
    return this[Q].subscribeShareStatisticData(t);
  } }, { key: "unsubscribeShareStatisticData", value: function(t) {
    return this[Q].unsubscribeShareStatisticData(t);
  } }, { key: "isShareLocked", value: function() {
    return this[Q].isShareLocked();
  } }, { key: "getSharePrivilege", value: function() {
    return this[Q].getSharePrivilege();
  } }, { key: "getActiveShareUserId", value: function() {
    return this[Q].getActiveShareUserId();
  } }, { key: "getShareStatus", value: function() {
    return this[Q].getShareStatus();
  } }, { key: "getShareUserList", value: function() {
    return this[Q].getShareUserList().map(function(t) {
      return Sa(t);
    });
  } }, { key: "isStartShareScreenWithVideoElement", value: function() {
    return this[Q].isStartShareScreenWithVideoElement();
  } }, { key: "isOptimizeForSharedVideoEnabled", value: function() {
    return this[Q].isOptimizeForSharedVideoEnabled();
  } }, { key: "isSupportOptimizedForSharedVideo", value: function() {
    return this[Q].isSupportOptimizedForSharedVideo();
  } }, { key: "getShareStatisticData", value: function() {
    return this[Q].getShareStatisticData();
  } }, { key: "requestFarEndCameraControl", value: function(t) {
    return this[Q].requestFarEndCameraControl(t);
  } }, { key: "approveFarEndCameraControl", value: function(t) {
    return this[Q].approveFarEndCameraControl(t);
  } }, { key: "declineFarEndCameraControl", value: function(t) {
    return this[Q].declineFarEndCameraControl(t);
  } }, { key: "giveUpFarEndCameraControl", value: function(t) {
    return this[Q].giveUpFarEndCameraControl(t);
  } }, { key: "controlCamera", value: function(t) {
    return this[Q].controlCamera(t);
  } }, { key: "controlFarEndCamera", value: function(t) {
    return this[Q].controlFarEndCamera(t);
  } }, { key: "getFarEndCameraPTZCapability", value: function(t) {
    return this[Q].getFarEndCameraPTZCapability(t);
  } }, { key: "getCameraPTZCapability", value: function(t) {
    return this[Q].getCameraPTZCapability(t);
  } }, { key: "isBrowserSupportPTZ", value: function() {
    return this[Q].isBrowserSupportPTZ();
  } }, { key: "getNetworkQuality", value: function(t) {
    return this[Q].getNetworkQuality(t);
  } }, { key: "requestRemoteControl", value: function() {
    return this[Q].requestRemoteControl();
  } }, { key: "giveUpRemoteControl", value: function() {
    return this[Q].giveUpRemoteControl();
  } }, { key: "startRemoteControl", value: function(t) {
    return this[Q].startRemoteControl(t);
  } }, { key: "grabRemotoControl", value: function() {
    return this[Q].grabRemotoControl();
  } }, { key: "approveRemoteControl", value: function(t) {
    return this[Q].approveRemoteControl(t);
  } }, { key: "declineRemoteControl", value: function(t) {
    return this[Q].declineRemoteControl(t);
  } }, { key: "stopRemoteControl", value: function() {
    return this[Q].stopRemoteControl();
  } }, { key: "launchRemoteControlApp", value: function(t) {
    return this[Q].launchRemoteControlApp(t);
  } }, { key: "isRemotelyControlApproved", value: function() {
    return this[Q].isRemotelyControlApproved();
  } }, { key: "isControllingUserRemotely", value: function() {
    return this[Q].isControllingUserRemotely();
  } }, { key: "isTargetShareSupportRemoteControl", value: function(t) {
    return this[Q].isTargetShareSupportRemoteControl(t);
  } }, { key: "getRemoteControlAppDownloadUrl", value: function() {
    return this[Q].getRemoteControlAppDownloadUrl();
  } }, { key: "getRemotelyControllingUser", value: function() {
    return this[Q].getRemotelyControllingUser();
  } }, { key: "isRemoteControlEnabled", value: function() {
    return this[Q].isRemoteControlEnabled();
  } }]), e;
}(), PD = ["isCoHost"], Mn = Symbol("chat"), DD = function() {
  function e(t) {
    so(this, e), this[Mn] = void 0, this[Mn] = t;
  }
  return ao(e, [{ key: "send", value: function(t, r) {
    return this[Mn].send(t, r);
  } }, { key: "sendToAll", value: function(t) {
    return this[Mn].send(t, ut.All);
  } }, { key: "sendFile", value: function(t, r) {
    return this[Mn].sendFile(t, r);
  } }, { key: "downloadFile", value: function(t, r, n) {
    return this[Mn].downloadFile(t, r, n);
  } }, { key: "setPrivilege", value: function(t) {
    return this[Mn].setPrivilege(t);
  } }, { key: "getPrivilege", value: function() {
    return this[Mn].getPrivilege();
  } }, { key: "getReceivers", value: function() {
    return this[Mn].getReceivers().map(function(t) {
      return en({ isManager: t.isCoHost }, ou(t, PD));
    });
  } }, { key: "getHistory", value: function() {
    return this[Mn].getHistory();
  } }, { key: "isFileTransferEnabled", value: function() {
    return this[Mn].isFileTransferEnabled();
  } }, { key: "getFileTransferSetting", value: function() {
    return this[Mn].getFileTransferSetting();
  } }]), e;
}(), po = Symbol("recording"), LD = function() {
  function e(t) {
    so(this, e), this[po] = void 0, this[po] = t;
  }
  return ao(e, [{ key: "canStartRecording", value: function() {
    return this[po].isRecordingEnabled();
  } }, { key: "startCloudRecording", value: function() {
    return this[po].startRecording();
  } }, { key: "pauseCloudRecording", value: function() {
    return this[po].pauseRecording();
  } }, { key: "resumeCloudRecording", value: function() {
    return this[po].startRecording();
  } }, { key: "stopCloudRecording", value: function() {
    return this[po].stopRecording();
  } }, { key: "getCloudRecordingStatus", value: function() {
    return this[po].getRecordingStatus();
  } }, { key: "acceptIndividualRecording", value: function() {
    return this[po].accept();
  } }, { key: "declineIndividualRecording", value: function() {
    return this[po].decline();
  } }]), e;
}(), xh = Symbol("command"), ND = function() {
  function e(t) {
    so(this, e), this[xh] = void 0, this[xh] = t;
  }
  return ao(e, [{ key: "send", value: function(t, r) {
    return this[xh].send(t, r);
  } }]), e;
}(), xD = ["isInRoom"], VD = ["isAutoJoinRoom", "isRoomSelectionEnabled"], Bt = Symbol("breakout-room"), jD = function() {
  function e(t) {
    so(this, e), this[Bt] = void 0, this[Bt] = t;
  }
  return ao(e, [{ key: "createSubsessions", value: function(t, r) {
    return this[Bt].createRooms(t, r).then(function(n) {
      return n.map(function(o) {
        return { subsessionId: o.roomId, subsessionName: o.name, userList: o.attendeeList };
      });
    });
  } }, { key: "openSubsessions", value: function(t, r) {
    var n = r ? en(en({}, r), {}, { isAutoJoinRoom: r.isAutoJoinSubsession, isRoomSelectionEnabled: r.isSubsessionSelectionEnabled }) : void 0, o = t.map(function(i) {
      return { roomId: i.subsessionId, name: i.subsessionName, attendeeList: i.userList };
    });
    return this[Bt].openRooms(o, n);
  } }, { key: "joinSubsession", value: function(t) {
    return this[Bt].joinRoom(t);
  } }, { key: "leaveSubsession", value: function() {
    return this[Bt].leaveRoom();
  } }, { key: "askForHelp", value: function() {
    return this[Bt].askForHelp();
  } }, { key: "postponeHelping", value: function(t) {
    return this[Bt].postponeHelping(t);
  } }, { key: "broadcast", value: function(t) {
    return this[Bt].broadcast(t);
  } }, { key: "assignUserToSubsession", value: function(t, r) {
    return this[Bt].assignUserToRoom(t, r);
  } }, { key: "moveUserToSubsession", value: function(t, r) {
    return this[Bt].moveUserToRoom(t, r);
  } }, { key: "moveBackToMainSession", value: function(t) {
    return this[Bt].moveBackToMainSession(t);
  } }, { key: "closeAllSubsessions", value: function() {
    return this[Bt].closeRoom();
  } }, { key: "startBroadcastVoice", value: function() {
    return this[Bt].startBroadcastVoice();
  } }, { key: "stopBroadcastVoice", value: function() {
    return this[Bt].stopBroadcastVoice();
  } }, { key: "getUnassignedUserList", value: function() {
    return this[Bt].getUnassignedAttendeeList().map(function(t) {
      return Sa(t);
    });
  } }, { key: "getSubsessionList", value: function() {
    return this[Bt].getRoomList().map(function(t) {
      return { subsessionId: t.roomId, subsessionName: t.name, userList: t.attendeeList.map(function(r) {
        var n = r;
        return en({ isInSubsession: n.isInRoom }, ou(n, xD));
      }) };
    });
  } }, { key: "getUserStatus", value: function() {
    return this[Bt].getAttendeeStatus();
  } }, { key: "getSubsessionStatus", value: function() {
    return this[Bt].getRoomStatus();
  } }, { key: "getCurrentSubsession", value: function() {
    var t = this[Bt].getCurrentRoom();
    return { userStatus: t.attendeeStatus, subsessionName: t.name, subsessionId: t.roomId };
  } }, { key: "getSubsessionOptions", value: function() {
    var t = this[Bt].getRoomOptions();
    return en({ isAutoJoinSubsession: t.isAutoJoinRoom, isSubsessionSelectionEnabled: t.isRoomSelectionEnabled }, ou(t, VD));
  } }]), e;
}(), Pn = Symbol("liveTranscription"), UD = function() {
  function e(t) {
    so(this, e), this[Pn] = void 0, this[Pn] = t;
  }
  return ao(e, [{ key: "startLiveTranscription", value: function() {
    return this[Pn].startLiveTranscription();
  } }, { key: "setSpeakingLanguage", value: function(t) {
    return this[Pn].setSpeakingLanguage(t);
  } }, { key: "setTranslationLanguage", value: function(t) {
    return this[Pn].setTranslationLanguage(t);
  } }, { key: "getLiveTranscriptionStatus", value: function() {
    return this[Pn].getLiveTranscriptionStatus();
  } }, { key: "getCurrentTranscriptionLanguage", value: function() {
    return this[Pn].getCurrentTranscriptionLanguage();
  } }, { key: "getCurrentTranslationLanguage", value: function() {
    return this[Pn].getCurrentTranslationLanguage();
  } }, { key: "getLatestTranscription", value: function() {
    return this[Pn].getLatestTranscription();
  } }, { key: "getLatestTranslation", value: function() {
    return this[Pn].getLatestTranslation();
  } }, { key: "getFullTranscriptionHistory", value: function() {
    return this[Pn].getFullTranscriptionHistory();
  } }, { key: "disableCaptions", value: function(t) {
    return this[Pn].disableCaptions(t);
  } }]), e;
}(), ra = Symbol("liveStream"), BD = function() {
  function e(t) {
    so(this, e), this[ra] = void 0, this[ra] = t;
  }
  return ao(e, [{ key: "startLiveStream", value: function(t, r, n) {
    return this[ra].startLiveStream(t, r, n);
  } }, { key: "stopLiveStream", value: function() {
    return this[ra].stopLiveStream();
  } }, { key: "isLiveStreamEnabled", value: function() {
    return this[ra].isLiveStreamEnabled();
  } }, { key: "getLiveStreamStatus", value: function() {
    return this[ra].getLiveStreamStatus();
  } }]), e;
}(), Tl = Symbol("logger"), $D = function() {
  function e(t, r) {
    if (so(this, e), this[Tl] = void 0, this[Tl] = t, r) {
      var n = r.debugMode, o = r.trackingId;
      this[Tl].setLogOptions({ debugMode: n, trackingId: o });
    }
  }
  return ao(e, [{ key: "reportToGlobalTracing", value: function(t) {
    return this[Tl].reportToGlobalTracing(t);
  } }, { key: "reportRating", value: function(t, r) {
    return this[Tl].reportRating(t, r);
  } }]), e;
}(), HD = ["roomName"], FD = ["roomId", "roomName"], ab = [{ event: "connection-change", originalEvent: "connection-change", payloadTransform: function(e) {
  var t = e.roomName, r = ou(e, HD);
  return t ? en(en({}, r), {}, { subsessionName: t }) : e;
} }, { event: "user-added", originalEvent: "user-added", payloadTransform: function(e) {
  return e.map(function(t) {
    return Nh(t);
  });
} }, { event: "user-updated", originalEvent: "user-updated", payloadTransform: function(e) {
  return e.map(function(t) {
    return Nh(t);
  });
} }, { event: "user-removed", originalEvent: "user-removed", payloadTransform: function(e) {
  return e.map(function(t) {
    return Nh(t);
  });
} }, { event: "subsession-invite-to-join", originalEvent: "invite-to-join", payloadTransform: function(e) {
  return { subsessionId: e.roomId, subsessionName: e.name };
} }, { event: "subsession-countdown", originalEvent: "room-countdown" }, { event: "subsession-time-up", originalEvent: "room-time-up" }, { event: "closing-subsession-countdown", originalEvent: "closing-room-countdown" }, { event: "subsession-broadcast-message", originalEvent: "broadcast-message" }, { event: "subsession-broadcast-voice", originalEvent: "broadcast-voice" }, { event: "subsession-ask-for-help", originalEvent: "ask-for-help", payloadTransform: function(e) {
  return { userId: e.userId, userGuid: e.userGuid, displayName: e.displayName, subsessionId: e.roomId, subsessionName: e.roomName };
} }, { event: "subsession-ask-for-help-response", originalEvent: "ask-for-help-response" }, { event: "subsession-invite-back-to-main-session", originalEvent: "invite-back-to-main-session" }, { event: "subsession-state-change", originalEvent: "room-state-change" }, { event: "host-ask-unmute-audio", originalEvent: "unmute-audio-consent" }, { event: "subsession-user-update", originalEvent: "room-user-update", payloadTransform: function(e) {
  return en({ subsessionId: e.roomId, subsessionName: e.roomName }, ou(e, FD));
} }], ho = Symbol("summary"), zD = function() {
  function e(t) {
    so(this, e), this[ho] = void 0, this[ho] = t;
  }
  return ao(e, [{ key: "startSummary", value: function() {
    return this[ho].startSummary();
  } }, { key: "stopSummary", value: function() {
    return this[ho].stopSummary();
  } }, { key: "isSummaryEnabled", value: function() {
    return this[ho].isSummaryEnabled();
  } }, { key: "getSummaryStatus", value: function() {
    return this[ho].getSummaryStatus();
  } }, { key: "startMeetingQuery", value: function() {
    return this[ho].startMeetingQuery();
  } }, { key: "stopMeetingQuery", value: function() {
    return this[ho].stopMeetingQuery();
  } }, { key: "isMeetingQueryEnabled", value: function() {
    return this[ho].isMeetingQueryEnabled();
  } }, { key: "getMeetingQueryStatus", value: function() {
    return this[ho].getMeetingQueryStatus();
  } }]), e;
}(), Xe = Symbol("Client"), wd = /* @__PURE__ */ new WeakMap(), WD = function() {
  function e() {
    so(this, e), this[Xe] = void 0, this.stream = void 0, this.chat = void 0, this.command = void 0, this.recording = void 0, this.subsession = void 0, this.liveTranscription = void 0, this.logger = void 0, this.liveStream = void 0, this.aiClient = void 0, this[Xe] = bo.createClient(), wd.set(this, /* @__PURE__ */ new Map());
  }
  return ao(e, [{ key: "init", value: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "en-US", r = arguments.length > 2 ? arguments[2] : void 0, n = P_(arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "Global");
    return window.isSecureContext === !1 && console.warn("The page is not in a secure context, to use audio, video, screen, a secure context must be enabled."), function() {
      var o = "__ZOOM_VIDEO_SDK_DOM_STORAGE_TEST__";
      try {
        return localStorage.setItem(o, o), localStorage.removeItem(o), sessionStorage.setItem(o, o), sessionStorage.removeItem(o), !0;
      } catch {
        return !1;
      }
    }() || console.warn("localstorage or sessionstorage is not enabled, please enable to use the video sdk,"), this[Xe].init("", "", { language: t, dependentAssets: n, constraints: en(en({}, bo.checkSystemRequirements()), {}, { screen: (typeof WebAssembly == "undefined" ? "undefined" : c1(WebAssembly)) === "object" && typeof Worker == "function" }), additionalFeatures: ["chat", "cmd", "recording", "breakoutRoom", "liveTranscription", "logger", "liveStream", "summary"], webEndpoint: (r == null ? void 0 : r.webEndpoint) || "zoom.us", skipJsMedia: r == null ? void 0 : r.skipJsMedia, enforceMultipleVideos: r == null ? void 0 : r.enforceMultipleVideos, stayAwake: r == null ? void 0 : r.stayAwake, enforceVirtualBackground: r == null ? void 0 : r.enforceVirtualBackground, quicklyLeaveMeeting: r == null ? void 0 : r.leaveOnPageUnload, patchJsMedia: r == null ? void 0 : r.patchJsMedia, alternativeNameForVideoPlayer: r == null ? void 0 : r.alternativeNameForVideoPlayer });
  } }, { key: "join", value: function(t, r, n, o, i) {
    return Lh(t) && Lh(r) && Lh(n) ? t.length > 200 ? Promise.reject({ type: Cd, reason: "The maximum length of topic is 200" }) : n.length > 200 ? Promise.reject({ type: Cd, reason: "The maximum length of username is 200" }) : o && (typeof o != "string" || o.length > 10) ? Promise.reject({ type: Cd, reason: "The maximum length of password is 10" }) : this[Xe].joinInstant(t, r, n, Hu, o, i) : Promise.reject({ type: Cd, reason: "Topic, token and userName must be string and required" });
  } }, { key: "leave", value: function() {
    var t;
    return arguments.length > 0 && arguments[0] !== void 0 && arguments[0] ? ((t = wd.get(this)) === null || t === void 0 || t.clear(), this[Xe].end()) : this[Xe].leave();
  } }, { key: "on", value: function(t, r) {
    var n = ab.find(function(u) {
      return u.event === t;
    });
    if (n) {
      var o = n.originalEvent, i = n.payloadTransform;
      if (i) {
        var s = function(u) {
          var d = i(u);
          r(d);
        };
        this[Xe].on(o, s);
        var a = wd.get(this);
        if (a) {
          a.has(t) || a.set(t, []);
          var l = a.get(t);
          l == null || l.push({ originalCb: r, newCb: s });
        }
      } else
        this[Xe].on(o, r);
    } else
      this[Xe].on(t, r);
  } }, { key: "off", value: function(t, r) {
    var n = ab.find(function(u) {
      return u.event === t;
    });
    if (n) {
      var o = n.originalEvent;
      if (n.payloadTransform) {
        var i = wd.get(this);
        if (i) {
          var s = i.get(t), a = s == null ? void 0 : s.find(function(u) {
            return u.originalCb === r;
          });
          if (a && s) {
            this[Xe].off(o, a.newCb);
            var l = s == null ? void 0 : s.filter(function(u) {
              return u.originalCb !== r;
            });
            i.set(t, l);
          }
        }
      } else
        this[Xe].off(o, r);
    } else
      this[Xe].off(t, r);
  } }, { key: "getMediaStream", value: function() {
    return this.stream || (this.stream = new MD(this[Xe].getMediaStream())), this.stream;
  } }, { key: "getChatClient", value: function() {
    return this.chat || (this.chat = new DD(this[Xe].getFeatureModule("chat"))), this.chat;
  } }, { key: "getRecordingClient", value: function() {
    return this.recording || (this.recording = new LD(this[Xe].getFeatureModule("recording"))), this.recording;
  } }, { key: "getCommandClient", value: function() {
    return this.command || (this.command = new ND(this[Xe].getFeatureModule("cmd"))), this.command;
  } }, { key: "getSubsessionClient", value: function() {
    return this.subsession || (this.subsession = new jD(this[Xe].getFeatureModule("breakoutRoom"))), this.subsession;
  } }, { key: "getLiveTranscriptionClient", value: function() {
    return this.liveTranscription || (this.liveTranscription = new UD(this[Xe].getFeatureModule("liveTranscription"))), this.liveTranscription;
  } }, { key: "getLoggerClient", value: function(t) {
    return this.logger || (this.logger = new $D(this[Xe].getFeatureModule("logger"), t)), this.logger;
  } }, { key: "getLiveStreamClient", value: function() {
    return this.liveStream || (this.liveStream = new BD(this[Xe].getFeatureModule("liveStream"))), this.liveStream;
  } }, { key: "getAIClient", value: function() {
    return this.aiClient || (this.aiClient = new zD(this[Xe].getFeatureModule("summary"))), this.aiClient;
  } }, { key: "getSessionInfo", value: function() {
    var t = this[Xe].getMeetingInfo();
    return { isInMeeting: t.isInMeeting || !1, password: t.password || "", topic: t.topic, userName: t.userName, userId: t.userId, sessionId: t.meetingId };
  } }, { key: "getCurrentUserInfo", value: function() {
    return Sa(this[Xe].getCurrentUserInfo());
  } }, { key: "getUser", value: function(t) {
    return Sa(this[Xe].getParticipantsList().find(function(r) {
      return r.userId === t;
    }));
  } }, { key: "getAllUser", value: function() {
    return this[Xe].getParticipantsList().map(function(t) {
      return Sa(t);
    });
  } }, { key: "changeName", value: function(t, r) {
    return this[Xe].changeName(t, r);
  } }, { key: "makeHost", value: function(t) {
    return this[Xe].makeHost(t);
  } }, { key: "removeUser", value: function(t) {
    return this[Xe].removeUser(t);
  } }, { key: "makeManager", value: function(t) {
    return this[Xe].makeCoHost(t);
  } }, { key: "revokeManager", value: function(t) {
    return this[Xe].revokeCoHost(t);
  } }, { key: "reclaimHost", value: function() {
    return this[Xe].reclaimHost();
  } }, { key: "isHost", value: function() {
    return this[Xe].isHost();
  } }, { key: "isOriginalHost", value: function() {
    return this[Xe].isOriginHost();
  } }, { key: "getSessionHost", value: function() {
    return Sa(this[Xe].getMeetingHost());
  } }, { key: "isManager", value: function() {
    return this[Xe].isCoHost();
  } }]), e;
}(), D0 = function() {
  function e() {
    so(this, e);
  }
  return ao(e, null, [{ key: "createClient", value: function() {
    return this.videoClient || (this.videoClient = new WD()), this.videoClient;
  } }, { key: "destroyClient", value: function() {
    this.videoClient && (this.videoClient.leave(), this.videoClient = null);
  } }, { key: "checkSystemRequirements", value: function() {
    return bo.checkSystemRequirements();
  } }, { key: "checkFeatureRequirements", value: function() {
    return bo.checkFeatureRequirements();
  } }, { key: "getDevices", value: function(t) {
    return bo.getDevices(t);
  } }, { key: "createLocalAudioTrack", value: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return bo.createLocalAudioTrack(t);
  } }, { key: "createLocalVideoTrack", value: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return bo.createLocalVideoTrack(t);
  } }, { key: "preloadDependentAssets", value: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Global";
    bo.preloadDependentAssets(P_(t));
  } }]), e;
}();
D0.videoClient = void 0, D0.VERSION = Hu, function(e) {
  e[e.All = 1] = "All", e[e.NoOne = 4] = "NoOne", e[e.EveryonePublicly = 5] = "EveryonePublicly";
}(XS || (XS = {})), function(e) {
  e[e.All = 0] = "All";
}(eb || (eb = {})), function(e) {
  e[e.Automatically = pu.Automatically] = "Automatically", e[e.Manually = pu.Manually] = "Manually";
}(tb || (tb = {})), function(e) {
  e[e.Initial = Ee.Initial] = "Initial", e[e.Invited = Ee.Invited] = "Invited", e[e.Joining = Ee.Joining] = "Joining", e[e.InSubsession = Ee.InRoom] = "InSubsession", e[e.Leaving = Ee.Leaving] = "Leaving", e[e.MainSession = Ee.MainSession] = "MainSession";
}(rb || (rb = {})), function(e) {
  e[e.NotStarted = $e.NotStarted] = "NotStarted", e[e.InProgress = $e.InProgress] = "InProgress", e[e.Closing = $e.Closing] = "Closing", e[e.Closed = $e.Closed] = "Closed";
}(nb || (nb = {})), function(e) {
  e[e.Failover = hr.Failover] = "Failover", e[e.JoinSubsession = hr.JoinBreakoutRoom] = "JoinSubsession", e[e.MoveToSubsession = hr.MoveToBreakoutRoom] = "MoveToSubsession", e[e.BackToMainSession = hr.BackToMainSession] = "BackToMainSession";
}(ob || (ob = {})), function(e) {
  e[e.Unlocked = vn.HostGrab] = "Unlocked", e[e.Locked = vn.OnlyHost] = "Locked", e[e.MultipleShare = vn.MultipleShare] = "MultipleShare";
}(ib || (ib = {})), function(e) {
  e[e.Unknown = dr.Unknown] = "Unknown", e[e.Uninstalled = dr.Uninstalled] = "Uninstalled", e[e.Installed = dr.Installed] = "Installed", e[e.Unlaunched = Dc.Unlaunched] = "Unlaunched", e[e.Launched = Dc.Launched] = "Launched";
}(sb || (sb = {}));
const x_ = $b(null), ZD = D0.createClient(), GD = ({
  children: e
}) => {
  const t = N0(() => ZD, []);
  return /* @__PURE__ */ S(x_.Provider, { value: t, children: e });
}, ap = () => {
  const e = wv(x_);
  if (!e)
    throw new Error("useZoomContext must be used within a ZoomProvider");
  return e;
};
var ig = { exports: {} }, V_ = function(t, r) {
  return function() {
    for (var o = new Array(arguments.length), i = 0; i < o.length; i++)
      o[i] = arguments[i];
    return t.apply(r, o);
  };
}, qD = V_, $s = Object.prototype.toString;
function sg(e) {
  return $s.call(e) === "[object Array]";
}
function yv(e) {
  return typeof e == "undefined";
}
function KD(e) {
  return e !== null && !yv(e) && e.constructor !== null && !yv(e.constructor) && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
}
function JD(e) {
  return $s.call(e) === "[object ArrayBuffer]";
}
function QD(e) {
  return typeof FormData != "undefined" && e instanceof FormData;
}
function YD(e) {
  var t;
  return typeof ArrayBuffer != "undefined" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && e.buffer instanceof ArrayBuffer, t;
}
function XD(e) {
  return typeof e == "string";
}
function eL(e) {
  return typeof e == "number";
}
function j_(e) {
  return e !== null && typeof e == "object";
}
function dc(e) {
  if ($s.call(e) !== "[object Object]")
    return !1;
  var t = Object.getPrototypeOf(e);
  return t === null || t === Object.prototype;
}
function tL(e) {
  return $s.call(e) === "[object Date]";
}
function rL(e) {
  return $s.call(e) === "[object File]";
}
function nL(e) {
  return $s.call(e) === "[object Blob]";
}
function U_(e) {
  return $s.call(e) === "[object Function]";
}
function oL(e) {
  return j_(e) && U_(e.pipe);
}
function iL(e) {
  return typeof URLSearchParams != "undefined" && e instanceof URLSearchParams;
}
function sL(e) {
  return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
}
function aL() {
  return typeof navigator != "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window != "undefined" && typeof document != "undefined";
}
function ag(e, t) {
  if (!(e === null || typeof e == "undefined"))
    if (typeof e != "object" && (e = [e]), sg(e))
      for (var r = 0, n = e.length; r < n; r++)
        t.call(null, e[r], r, e);
    else
      for (var o in e)
        Object.prototype.hasOwnProperty.call(e, o) && t.call(null, e[o], o, e);
}
function Sv() {
  var e = {};
  function t(o, i) {
    dc(e[i]) && dc(o) ? e[i] = Sv(e[i], o) : dc(o) ? e[i] = Sv({}, o) : sg(o) ? e[i] = o.slice() : e[i] = o;
  }
  for (var r = 0, n = arguments.length; r < n; r++)
    ag(arguments[r], t);
  return e;
}
function lL(e, t, r) {
  return ag(t, function(o, i) {
    r && typeof o == "function" ? e[i] = qD(o, r) : e[i] = o;
  }), e;
}
function uL(e) {
  return e.charCodeAt(0) === 65279 && (e = e.slice(1)), e;
}
var An = {
  isArray: sg,
  isArrayBuffer: JD,
  isBuffer: KD,
  isFormData: QD,
  isArrayBufferView: YD,
  isString: XD,
  isNumber: eL,
  isObject: j_,
  isPlainObject: dc,
  isUndefined: yv,
  isDate: tL,
  isFile: rL,
  isBlob: nL,
  isFunction: U_,
  isStream: oL,
  isURLSearchParams: iL,
  isStandardBrowserEnv: aL,
  forEach: ag,
  merge: Sv,
  extend: lL,
  trim: sL,
  stripBOM: uL
}, na = An;
function lb(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var B_ = function(t, r, n) {
  if (!r)
    return t;
  var o;
  if (n)
    o = n(r);
  else if (na.isURLSearchParams(r))
    o = r.toString();
  else {
    var i = [];
    na.forEach(r, function(l, u) {
      l === null || typeof l == "undefined" || (na.isArray(l) ? u = u + "[]" : l = [l], na.forEach(l, function(c) {
        na.isDate(c) ? c = c.toISOString() : na.isObject(c) && (c = JSON.stringify(c)), i.push(lb(u) + "=" + lb(c));
      }));
    }), o = i.join("&");
  }
  if (o) {
    var s = t.indexOf("#");
    s !== -1 && (t = t.slice(0, s)), t += (t.indexOf("?") === -1 ? "?" : "&") + o;
  }
  return t;
}, dL = An;
function lp() {
  this.handlers = [];
}
lp.prototype.use = function(t, r, n) {
  return this.handlers.push({
    fulfilled: t,
    rejected: r,
    synchronous: n ? n.synchronous : !1,
    runWhen: n ? n.runWhen : null
  }), this.handlers.length - 1;
};
lp.prototype.eject = function(t) {
  this.handlers[t] && (this.handlers[t] = null);
};
lp.prototype.forEach = function(t) {
  dL.forEach(this.handlers, function(n) {
    n !== null && t(n);
  });
};
var cL = lp, pL = An, hL = function(t, r) {
  pL.forEach(t, function(o, i) {
    i !== r && i.toUpperCase() === r.toUpperCase() && (t[r] = o, delete t[i]);
  });
}, $_ = function(t, r, n, o, i) {
  return t.config = r, n && (t.code = n), t.request = o, t.response = i, t.isAxiosError = !0, t.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  }, t;
}, Vh, ub;
function H_() {
  if (ub)
    return Vh;
  ub = 1;
  var e = $_;
  return Vh = function(r, n, o, i, s) {
    var a = new Error(r);
    return e(a, n, o, i, s);
  }, Vh;
}
var jh, db;
function fL() {
  if (db)
    return jh;
  db = 1;
  var e = H_();
  return jh = function(r, n, o) {
    var i = o.config.validateStatus;
    !o.status || !i || i(o.status) ? r(o) : n(e(
      "Request failed with status code " + o.status,
      o.config,
      null,
      o.request,
      o
    ));
  }, jh;
}
var Uh, cb;
function vL() {
  if (cb)
    return Uh;
  cb = 1;
  var e = An;
  return Uh = e.isStandardBrowserEnv() ? (
    // Standard browser envs support document.cookie
    /* @__PURE__ */ function() {
      return {
        write: function(n, o, i, s, a, l) {
          var u = [];
          u.push(n + "=" + encodeURIComponent(o)), e.isNumber(i) && u.push("expires=" + new Date(i).toGMTString()), e.isString(s) && u.push("path=" + s), e.isString(a) && u.push("domain=" + a), l === !0 && u.push("secure"), document.cookie = u.join("; ");
        },
        read: function(n) {
          var o = document.cookie.match(new RegExp("(^|;\\s*)(" + n + ")=([^;]*)"));
          return o ? decodeURIComponent(o[3]) : null;
        },
        remove: function(n) {
          this.write(n, "", Date.now() - 864e5);
        }
      };
    }()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    /* @__PURE__ */ function() {
      return {
        write: function() {
        },
        read: function() {
          return null;
        },
        remove: function() {
        }
      };
    }()
  ), Uh;
}
var Bh, pb;
function mL() {
  return pb || (pb = 1, Bh = function(t) {
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(t);
  }), Bh;
}
var $h, hb;
function gL() {
  return hb || (hb = 1, $h = function(t, r) {
    return r ? t.replace(/\/+$/, "") + "/" + r.replace(/^\/+/, "") : t;
  }), $h;
}
var Hh, fb;
function yL() {
  if (fb)
    return Hh;
  fb = 1;
  var e = mL(), t = gL();
  return Hh = function(n, o) {
    return n && !e(o) ? t(n, o) : o;
  }, Hh;
}
var Fh, vb;
function SL() {
  if (vb)
    return Fh;
  vb = 1;
  var e = An, t = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return Fh = function(n) {
    var o = {}, i, s, a;
    return n && e.forEach(n.split(`
`), function(u) {
      if (a = u.indexOf(":"), i = e.trim(u.substr(0, a)).toLowerCase(), s = e.trim(u.substr(a + 1)), i) {
        if (o[i] && t.indexOf(i) >= 0)
          return;
        i === "set-cookie" ? o[i] = (o[i] ? o[i] : []).concat([s]) : o[i] = o[i] ? o[i] + ", " + s : s;
      }
    }), o;
  }, Fh;
}
var zh, mb;
function bL() {
  if (mb)
    return zh;
  mb = 1;
  var e = An;
  return zh = e.isStandardBrowserEnv() ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function() {
      var r = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a"), o;
      function i(s) {
        var a = s;
        return r && (n.setAttribute("href", a), a = n.href), n.setAttribute("href", a), {
          href: n.href,
          protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
          host: n.host,
          search: n.search ? n.search.replace(/^\?/, "") : "",
          hash: n.hash ? n.hash.replace(/^#/, "") : "",
          hostname: n.hostname,
          port: n.port,
          pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
        };
      }
      return o = i(window.location.href), function(a) {
        var l = e.isString(a) ? i(a) : a;
        return l.protocol === o.protocol && l.host === o.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    /* @__PURE__ */ function() {
      return function() {
        return !0;
      };
    }()
  ), zh;
}
var Wh, gb;
function yb() {
  if (gb)
    return Wh;
  gb = 1;
  var e = An, t = fL(), r = vL(), n = B_, o = yL(), i = SL(), s = bL(), a = H_();
  return Wh = function(u) {
    return new Promise(function(c, p) {
      var h = u.data, v = u.headers, f = u.responseType;
      e.isFormData(h) && delete v["Content-Type"];
      var m = new XMLHttpRequest();
      if (u.auth) {
        var g = u.auth.username || "", C = u.auth.password ? unescape(encodeURIComponent(u.auth.password)) : "";
        v.Authorization = "Basic " + btoa(g + ":" + C);
      }
      var b = o(u.baseURL, u.url);
      m.open(u.method.toUpperCase(), n(b, u.params, u.paramsSerializer), !0), m.timeout = u.timeout;
      function E() {
        if (m) {
          var _ = "getAllResponseHeaders" in m ? i(m.getAllResponseHeaders()) : null, I = !f || f === "text" || f === "json" ? m.responseText : m.response, D = {
            data: I,
            status: m.status,
            statusText: m.statusText,
            headers: _,
            config: u,
            request: m
          };
          t(c, p, D), m = null;
        }
      }
      if ("onloadend" in m ? m.onloadend = E : m.onreadystatechange = function() {
        !m || m.readyState !== 4 || m.status === 0 && !(m.responseURL && m.responseURL.indexOf("file:") === 0) || setTimeout(E);
      }, m.onabort = function() {
        m && (p(a("Request aborted", u, "ECONNABORTED", m)), m = null);
      }, m.onerror = function() {
        p(a("Network Error", u, null, m)), m = null;
      }, m.ontimeout = function() {
        var I = "timeout of " + u.timeout + "ms exceeded";
        u.timeoutErrorMessage && (I = u.timeoutErrorMessage), p(a(
          I,
          u,
          u.transitional && u.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
          m
        )), m = null;
      }, e.isStandardBrowserEnv()) {
        var w = (u.withCredentials || s(b)) && u.xsrfCookieName ? r.read(u.xsrfCookieName) : void 0;
        w && (v[u.xsrfHeaderName] = w);
      }
      "setRequestHeader" in m && e.forEach(v, function(I, D) {
        typeof h == "undefined" && D.toLowerCase() === "content-type" ? delete v[D] : m.setRequestHeader(D, I);
      }), e.isUndefined(u.withCredentials) || (m.withCredentials = !!u.withCredentials), f && f !== "json" && (m.responseType = u.responseType), typeof u.onDownloadProgress == "function" && m.addEventListener("progress", u.onDownloadProgress), typeof u.onUploadProgress == "function" && m.upload && m.upload.addEventListener("progress", u.onUploadProgress), u.cancelToken && u.cancelToken.promise.then(function(I) {
        m && (m.abort(), p(I), m = null);
      }), h || (h = null), m.send(h);
    });
  }, Wh;
}
var Ir = An, Sb = hL, CL = $_, wL = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function bb(e, t) {
  !Ir.isUndefined(e) && Ir.isUndefined(e["Content-Type"]) && (e["Content-Type"] = t);
}
function EL() {
  var e;
  return (typeof XMLHttpRequest != "undefined" || typeof process != "undefined" && Object.prototype.toString.call(process) === "[object process]") && (e = yb()), e;
}
function IL(e, t, r) {
  if (Ir.isString(e))
    try {
      return (t || JSON.parse)(e), Ir.trim(e);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (r || JSON.stringify)(e);
}
var up = {
  transitional: {
    silentJSONParsing: !0,
    forcedJSONParsing: !0,
    clarifyTimeoutError: !1
  },
  adapter: EL(),
  transformRequest: [function(t, r) {
    return Sb(r, "Accept"), Sb(r, "Content-Type"), Ir.isFormData(t) || Ir.isArrayBuffer(t) || Ir.isBuffer(t) || Ir.isStream(t) || Ir.isFile(t) || Ir.isBlob(t) ? t : Ir.isArrayBufferView(t) ? t.buffer : Ir.isURLSearchParams(t) ? (bb(r, "application/x-www-form-urlencoded;charset=utf-8"), t.toString()) : Ir.isObject(t) || r && r["Content-Type"] === "application/json" ? (bb(r, "application/json"), IL(t)) : t;
  }],
  transformResponse: [function(t) {
    var r = this.transitional, n = r && r.silentJSONParsing, o = r && r.forcedJSONParsing, i = !n && this.responseType === "json";
    if (i || o && Ir.isString(t) && t.length)
      try {
        return JSON.parse(t);
      } catch (s) {
        if (i)
          throw s.name === "SyntaxError" ? CL(s, this, "E_JSON_PARSE") : s;
      }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  }
};
up.headers = {
  common: {
    Accept: "application/json, text/plain, */*"
  }
};
Ir.forEach(["delete", "get", "head"], function(t) {
  up.headers[t] = {};
});
Ir.forEach(["post", "put", "patch"], function(t) {
  up.headers[t] = Ir.merge(wL);
});
var lg = up, AL = An, _L = lg, RL = function(t, r, n) {
  var o = this || _L;
  return AL.forEach(n, function(s) {
    t = s.call(o, t, r);
  }), t;
}, Zh, Cb;
function F_() {
  return Cb || (Cb = 1, Zh = function(t) {
    return !!(t && t.__CANCEL__);
  }), Zh;
}
var wb = An, Gh = RL, OL = F_(), TL = lg;
function qh(e) {
  e.cancelToken && e.cancelToken.throwIfRequested();
}
var kL = function(t) {
  qh(t), t.headers = t.headers || {}, t.data = Gh.call(
    t,
    t.data,
    t.headers,
    t.transformRequest
  ), t.headers = wb.merge(
    t.headers.common || {},
    t.headers[t.method] || {},
    t.headers
  ), wb.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function(o) {
      delete t.headers[o];
    }
  );
  var r = t.adapter || TL.adapter;
  return r(t).then(function(o) {
    return qh(t), o.data = Gh.call(
      t,
      o.data,
      o.headers,
      t.transformResponse
    ), o;
  }, function(o) {
    return OL(o) || (qh(t), o && o.response && (o.response.data = Gh.call(
      t,
      o.response.data,
      o.response.headers,
      t.transformResponse
    ))), Promise.reject(o);
  });
}, Mr = An, z_ = function(t, r) {
  r = r || {};
  var n = {}, o = ["url", "method", "data"], i = ["headers", "auth", "proxy", "params"], s = [
    "baseURL",
    "transformRequest",
    "transformResponse",
    "paramsSerializer",
    "timeout",
    "timeoutMessage",
    "withCredentials",
    "adapter",
    "responseType",
    "xsrfCookieName",
    "xsrfHeaderName",
    "onUploadProgress",
    "onDownloadProgress",
    "decompress",
    "maxContentLength",
    "maxBodyLength",
    "maxRedirects",
    "transport",
    "httpAgent",
    "httpsAgent",
    "cancelToken",
    "socketPath",
    "responseEncoding"
  ], a = ["validateStatus"];
  function l(p, h) {
    return Mr.isPlainObject(p) && Mr.isPlainObject(h) ? Mr.merge(p, h) : Mr.isPlainObject(h) ? Mr.merge({}, h) : Mr.isArray(h) ? h.slice() : h;
  }
  function u(p) {
    Mr.isUndefined(r[p]) ? Mr.isUndefined(t[p]) || (n[p] = l(void 0, t[p])) : n[p] = l(t[p], r[p]);
  }
  Mr.forEach(o, function(h) {
    Mr.isUndefined(r[h]) || (n[h] = l(void 0, r[h]));
  }), Mr.forEach(i, u), Mr.forEach(s, function(h) {
    Mr.isUndefined(r[h]) ? Mr.isUndefined(t[h]) || (n[h] = l(void 0, t[h])) : n[h] = l(void 0, r[h]);
  }), Mr.forEach(a, function(h) {
    h in r ? n[h] = l(t[h], r[h]) : h in t && (n[h] = l(void 0, t[h]));
  });
  var d = o.concat(i).concat(s).concat(a), c = Object.keys(t).concat(Object.keys(r)).filter(function(h) {
    return d.indexOf(h) === -1;
  });
  return Mr.forEach(c, u), n;
};
const ML = "axios", PL = "0.21.4", DL = "Promise based HTTP client for the browser and node.js", LL = "index.js", NL = {
  test: "grunt test",
  start: "node ./sandbox/server.js",
  build: "NODE_ENV=production grunt build",
  preversion: "npm test",
  version: "npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json",
  postversion: "git push && git push --tags",
  examples: "node ./examples/server.js",
  coveralls: "cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js",
  fix: "eslint --fix lib/**/*.js"
}, xL = {
  type: "git",
  url: "https://github.com/axios/axios.git"
}, VL = [
  "xhr",
  "http",
  "ajax",
  "promise",
  "node"
], jL = "Matt Zabriskie", UL = "MIT", BL = {
  url: "https://github.com/axios/axios/issues"
}, $L = "https://axios-http.com", HL = {
  coveralls: "^3.0.0",
  "es6-promise": "^4.2.4",
  grunt: "^1.3.0",
  "grunt-banner": "^0.6.0",
  "grunt-cli": "^1.2.0",
  "grunt-contrib-clean": "^1.1.0",
  "grunt-contrib-watch": "^1.0.0",
  "grunt-eslint": "^23.0.0",
  "grunt-karma": "^4.0.0",
  "grunt-mocha-test": "^0.13.3",
  "grunt-ts": "^6.0.0-beta.19",
  "grunt-webpack": "^4.0.2",
  "istanbul-instrumenter-loader": "^1.0.0",
  "jasmine-core": "^2.4.1",
  karma: "^6.3.2",
  "karma-chrome-launcher": "^3.1.0",
  "karma-firefox-launcher": "^2.1.0",
  "karma-jasmine": "^1.1.1",
  "karma-jasmine-ajax": "^0.1.13",
  "karma-safari-launcher": "^1.0.0",
  "karma-sauce-launcher": "^4.3.6",
  "karma-sinon": "^1.0.5",
  "karma-sourcemap-loader": "^0.3.8",
  "karma-webpack": "^4.0.2",
  "load-grunt-tasks": "^3.5.2",
  minimist: "^1.2.0",
  mocha: "^8.2.1",
  sinon: "^4.5.0",
  "terser-webpack-plugin": "^4.2.3",
  typescript: "^4.0.5",
  "url-search-params": "^0.10.0",
  webpack: "^4.44.2",
  "webpack-dev-server": "^3.11.0"
}, FL = {
  "./lib/adapters/http.js": "./lib/adapters/xhr.js"
}, zL = "dist/axios.min.js", WL = "dist/axios.min.js", ZL = "./index.d.ts", GL = {
  "follow-redirects": "^1.14.0"
}, qL = [
  {
    path: "./dist/axios.min.js",
    threshold: "5kB"
  }
], KL = {
  name: ML,
  version: PL,
  description: DL,
  main: LL,
  scripts: NL,
  repository: xL,
  keywords: VL,
  author: jL,
  license: UL,
  bugs: BL,
  homepage: $L,
  devDependencies: HL,
  browser: FL,
  jsdelivr: zL,
  unpkg: WL,
  typings: ZL,
  dependencies: GL,
  bundlesize: qL
};
var W_ = KL, ug = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(e, t) {
  ug[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
var Eb = {}, JL = W_.version.split(".");
function Z_(e, t) {
  for (var r = t ? t.split(".") : JL, n = e.split("."), o = 0; o < 3; o++) {
    if (r[o] > n[o])
      return !0;
    if (r[o] < n[o])
      return !1;
  }
  return !1;
}
ug.transitional = function(t, r, n) {
  var o = r && Z_(r);
  function i(s, a) {
    return "[Axios v" + W_.version + "] Transitional option '" + s + "'" + a + (n ? ". " + n : "");
  }
  return function(s, a, l) {
    if (t === !1)
      throw new Error(i(a, " has been removed in " + r));
    return o && !Eb[a] && (Eb[a] = !0, console.warn(
      i(
        a,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), t ? t(s, a, l) : !0;
  };
};
function QL(e, t, r) {
  if (typeof e != "object")
    throw new TypeError("options must be an object");
  for (var n = Object.keys(e), o = n.length; o-- > 0; ) {
    var i = n[o], s = t[i];
    if (s) {
      var a = e[i], l = a === void 0 || s(a, i, e);
      if (l !== !0)
        throw new TypeError("option " + i + " must be " + l);
      continue;
    }
    if (r !== !0)
      throw Error("Unknown option " + i);
  }
}
var YL = {
  isOlderVersion: Z_,
  assertOptions: QL,
  validators: ug
}, G_ = An, XL = B_, Ib = cL, Ab = kL, dp = z_, q_ = YL, oa = q_.validators;
function Fu(e) {
  this.defaults = e, this.interceptors = {
    request: new Ib(),
    response: new Ib()
  };
}
Fu.prototype.request = function(t) {
  typeof t == "string" ? (t = arguments[1] || {}, t.url = arguments[0]) : t = t || {}, t = dp(this.defaults, t), t.method ? t.method = t.method.toLowerCase() : this.defaults.method ? t.method = this.defaults.method.toLowerCase() : t.method = "get";
  var r = t.transitional;
  r !== void 0 && q_.assertOptions(r, {
    silentJSONParsing: oa.transitional(oa.boolean, "1.0.0"),
    forcedJSONParsing: oa.transitional(oa.boolean, "1.0.0"),
    clarifyTimeoutError: oa.transitional(oa.boolean, "1.0.0")
  }, !1);
  var n = [], o = !0;
  this.interceptors.request.forEach(function(p) {
    typeof p.runWhen == "function" && p.runWhen(t) === !1 || (o = o && p.synchronous, n.unshift(p.fulfilled, p.rejected));
  });
  var i = [];
  this.interceptors.response.forEach(function(p) {
    i.push(p.fulfilled, p.rejected);
  });
  var s;
  if (!o) {
    var a = [Ab, void 0];
    for (Array.prototype.unshift.apply(a, n), a = a.concat(i), s = Promise.resolve(t); a.length; )
      s = s.then(a.shift(), a.shift());
    return s;
  }
  for (var l = t; n.length; ) {
    var u = n.shift(), d = n.shift();
    try {
      l = u(l);
    } catch (c) {
      d(c);
      break;
    }
  }
  try {
    s = Ab(l);
  } catch (c) {
    return Promise.reject(c);
  }
  for (; i.length; )
    s = s.then(i.shift(), i.shift());
  return s;
};
Fu.prototype.getUri = function(t) {
  return t = dp(this.defaults, t), XL(t.url, t.params, t.paramsSerializer).replace(/^\?/, "");
};
G_.forEach(["delete", "get", "head", "options"], function(t) {
  Fu.prototype[t] = function(r, n) {
    return this.request(dp(n || {}, {
      method: t,
      url: r,
      data: (n || {}).data
    }));
  };
});
G_.forEach(["post", "put", "patch"], function(t) {
  Fu.prototype[t] = function(r, n, o) {
    return this.request(dp(o || {}, {
      method: t,
      url: r,
      data: n
    }));
  };
});
var eN = Fu, Kh, _b;
function K_() {
  if (_b)
    return Kh;
  _b = 1;
  function e(t) {
    this.message = t;
  }
  return e.prototype.toString = function() {
    return "Cancel" + (this.message ? ": " + this.message : "");
  }, e.prototype.__CANCEL__ = !0, Kh = e, Kh;
}
var Jh, Rb;
function tN() {
  if (Rb)
    return Jh;
  Rb = 1;
  var e = K_();
  function t(r) {
    if (typeof r != "function")
      throw new TypeError("executor must be a function.");
    var n;
    this.promise = new Promise(function(s) {
      n = s;
    });
    var o = this;
    r(function(s) {
      o.reason || (o.reason = new e(s), n(o.reason));
    });
  }
  return t.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, t.source = function() {
    var n, o = new t(function(s) {
      n = s;
    });
    return {
      token: o,
      cancel: n
    };
  }, Jh = t, Jh;
}
var Qh, Ob;
function rN() {
  return Ob || (Ob = 1, Qh = function(t) {
    return function(n) {
      return t.apply(null, n);
    };
  }), Qh;
}
var Yh, Tb;
function nN() {
  return Tb || (Tb = 1, Yh = function(t) {
    return typeof t == "object" && t.isAxiosError === !0;
  }), Yh;
}
var kb = An, oN = V_, cc = eN, iN = z_, sN = lg;
function J_(e) {
  var t = new cc(e), r = oN(cc.prototype.request, t);
  return kb.extend(r, cc.prototype, t), kb.extend(r, t), r;
}
var io = J_(sN);
io.Axios = cc;
io.create = function(t) {
  return J_(iN(io.defaults, t));
};
io.Cancel = K_();
io.CancelToken = tN();
io.isCancel = F_();
io.all = function(t) {
  return Promise.all(t);
};
io.spread = rN();
io.isAxiosError = nN();
ig.exports = io;
ig.exports.default = io;
var aN = ig.exports, lN = aN;
const uN = /* @__PURE__ */ IR(lN);
var dN = Object.defineProperty, cN = (e, t, r) => t in e ? dN(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, pN = (e, t, r) => (cN(e, typeof t != "symbol" ? t + "" : t, r), r);
class hN {
  constructor(t) {
    pN(this, "axiosInstance"), this.axiosInstance = uN.create(), this.setBaseURL(t);
  }
  setBaseURL(t) {
    this.axiosInstance.defaults.baseURL = t;
  }
  async get(t, r) {
    return this.axiosInstance.get(t, r);
  }
  async post(t, r, n) {
    return this.axiosInstance.post(t, r, n);
  }
  async put(t, r, n) {
    return this.axiosInstance.put(t, r, n);
  }
  async delete(t, r) {
    return this.axiosInstance.delete(t, r);
  }
}
let bv;
const fN = (e) => {
  bv = new hN(e);
}, vN = () => {
  if (!bv)
    throw new Error("HttpClient is not registered. Call registerHttpClient with a baseUrl first.");
  return bv;
};
class mN {
  async triggerEvent(t) {
    return void await vN().post("/hooks", t);
  }
}
const Xh = new mN(), cp = gR(() => ({
  stream: null
}));
function L0(e) {
  let t = e.replace(/\{\{.*?\}\}/g, "");
  return t = t.replace(/^Dr\s*/, "").trim(), t;
}
function Mb(e) {
  const t = /\{\{([^}]+)\}\}/, r = e.match(t);
  return r ? r[1] : "";
}
function gN(e) {
  const t = xa(null);
  return sn(() => {
    t.current = e;
  }, [e]), t.current;
}
const yN = (e, t) => {
  const r = xa(t);
  r.current = t;
  const n = Jo((o) => {
    const i = e == null ? void 0 : e.getAllUser();
    r.current(i, o);
  }, [e]);
  sn(() => (e.on("user-added", n), e.on("user-removed", n), e.on("user-updated", n), () => {
    e.off("user-added", n), e.off("user-removed", n), e.off("user-updated", n);
  }), [e, n]), sn(() => {
    n();
  }, []);
}, SN = ({
  topic: e,
  token: t,
  userName: r,
  password: n = "",
  callId: o
}) => {
  const i = ap(), [s, a] = Yr(null), [l, u] = Yr(!0), [d, c] = Yr(i.getAllUser()), p = gN(d);
  return yN(i, (h) => {
    let v = [];
    if (h.length > 0)
      if (h.length === 1)
        v = h;
      else {
        v = h.filter((C) => C.userId !== i.getSessionInfo().userId).sort((C, b) => Number(b.bVideoOn) - Number(C.bVideoOn));
        const f = i.getCurrentUserInfo(), m = Mb(f == null ? void 0 : f.displayName), g = h.filter((C) => Mb(C.displayName) === m);
        (g == null ? void 0 : g.length) > 1 && (t1.trigger("duplicate-user", `${f.userId}`, "warning"), i.removeUser(f.userId), i.leave()), f && v.splice(1, 0, f);
      }
    c(v);
  }), sn(() => {
    const h = p == null ? void 0 : p.filter((m) => {
      var g;
      return (m == null ? void 0 : m.userId) !== ((g = i == null ? void 0 : i.getSessionInfo()) == null ? void 0 : g.userId);
    }), v = h == null ? void 0 : h.filter((m) => !d.some((g) => g.userId === m.userId)), f = d.filter((m) => !(h != null && h.some((g) => g.userId === m.userId)));
    (v == null ? void 0 : v.length) > 0 && (v == null || v.forEach((m) => {
      vR({
        message: `${L0(m.displayName)} saius da sessão`,
        variant: "warning"
      }), t1.trigger("participantLeft", `${o}`, "info"), Xh.triggerEvent({
        callId: o,
        event: "participantLeft",
        meetService: "ZOOM",
        customData: {
          participant: `${L0(m.displayName)} saiu da sessão`
        }
      });
    })), f.length > 0 && Xh.triggerEvent({
      callId: o,
      event: "participantsChanged",
      meetService: "ZOOM",
      customData: {
        participants: d
      }
    });
  }, [o, d == null ? void 0 : d.length, p == null ? void 0 : p.length, i]), sn(() => ((async () => {
    if (!(!e || !t || !r)) {
      await i.init("pt-BR", "Global", {
        stayAwake: !0,
        patchJsMedia: !0,
        leaveOnPageUnload: !0
      }), console.info("[ZoomClient] Client created");
      try {
        await i.join(e, t, r, n);
        const v = i.getMediaStream();
        cp.setState({
          stream: v
        }), a(v);
      } catch (v) {
        console.log("error", v), u(!1), Xh.triggerEvent({
          callId: o,
          event: "error-start-meet",
          meetService: "ZOOM",
          customData: {
            error: v
          }
        });
      } finally {
        u(!1);
      }
    }
  })(), () => {
    D0.destroyClient();
  }), [o, n, t, e, r, i]), {
    isLoading: l,
    participants: d,
    mediaStream: s
  };
}, bN = () => {
  const e = ap(), [t, r] = Yr(!1), [n, o] = Yr(null);
  return sn(() => {
    if (!e)
      return;
    const i = async (s) => {
      o(s.userId), s.state === "Active" ? r(!0) : s.state === "Inactive" && r(!1);
    };
    return e.on("active-share-change", i), () => {
      e.off("active-share-change", i);
    };
  }, [e]), {
    userShareScreenId: n,
    hasShareScreenView: t
  };
}, CN = (e) => {
  const [t, r] = Yr({
    width: 0,
    height: 0
  }), n = Jo(() => {
    if (e) {
      const {
        width: o,
        height: i
      } = e.getBoundingClientRect();
      r({
        width: o,
        height: i
      });
    }
  }, [e]);
  return sn(() => {
    if (!e)
      return;
    n();
    const o = new ResizeObserver(n);
    return e && o.observe(e), () => {
      o.disconnect();
    };
  }, [e, n]), {
    width: t == null ? void 0 : t.width,
    height: t == null ? void 0 : t.height
  };
};
function Pb() {
  const e = window.document;
  return e.fullscreenElement || e.webkitFullscreenElement || e.mozFullScreenElement || e.msFullscreenElement;
}
async function wN() {
  const e = window.document;
  return typeof e.exitFullscreen == "function" ? e.exitFullscreen() : typeof e.msExitFullscreen == "function" ? e.msExitFullscreen() : typeof e.webkitExitFullscreen == "function" ? e.webkitExitFullscreen() : typeof e.mozCancelFullScreen == "function" ? e.mozCancelFullScreen() : null;
}
async function EN(e) {
  var t, r, n, o, i;
  const s = e;
  return ((t = s.requestFullscreen) == null ? void 0 : t.call(s)) || ((r = s.msRequestFullscreen) == null ? void 0 : r.call(s)) || ((n = s.webkitEnterFullscreen) == null ? void 0 : n.call(s)) || ((o = s.webkitRequestFullscreen) == null ? void 0 : o.call(s)) || ((i = s.mozRequestFullscreen) == null ? void 0 : i.call(s));
}
const Db = ["", "webkit", "moz", "ms"];
function Lb(e, {
  onFullScreen: t,
  onError: r
}) {
  return Db.forEach((n) => {
    e.addEventListener(`${n}fullscreenchange`, t), e.addEventListener(`${n}fullscreenerror`, r);
  }), () => {
    Db.forEach((n) => {
      e.removeEventListener(`${n}fullscreenchange`, t), e.removeEventListener(`${n}fullscreenerror`, r);
    });
  };
}
function IN() {
  const [e, t] = Yr(!1), r = xa(), n = Jo((a) => {
    t(a.target === Pb());
  }, [t]), o = Jo((a) => {
    t(!1), console.error(`use-fullscreen: Error attempting full-screen mode method: ${a} (${a.target})`);
  }, [t]), i = Jo(async () => {
    Pb() ? await wN() : await EN(r.current);
  }, []), s = Jo((a) => {
    a === null ? r.current = window.document.documentElement : r.current = a;
  }, []);
  return sn(() => {
    if (!r.current && window.document)
      return r.current = window.document.documentElement, Lb(r.current, {
        onFullScreen: n,
        onError: o
      });
    if (r.current)
      return Lb(r.current, {
        onFullScreen: n,
        onError: o
      });
  }, []), {
    ref: s,
    toggle: i,
    fullscreen: e
  };
}
const Nb = "#my-screen-share-content-video", AN = (e, t) => {
  const [r, n] = Yr(!1), [o, i] = Yr(!1), [s, a] = Yr(!1), [l, u] = Yr(!1), [d, c] = Yr(!1), p = ap(), h = IN(), [v, f] = Yr(p.getCurrentUserInfo() && p.getCurrentUserInfo().audio !== ""), m = cp((D) => D.stream), g = async () => {
    try {
      c(!0), e && await e(), p.leave(!0);
    } catch (D) {
      console.error("Error finishing meet", D);
    } finally {
      c(!1);
    }
  }, C = async () => {
    if (m) {
      if (r) {
        m.stopVideo(), n(!1);
        return;
      }
      m.startVideo(), n(!0);
    }
  }, b = async () => {
    if (m) {
      if (v) {
        if (o) {
          m.muteAudio();
          return;
        }
        m.unmuteAudio();
        return;
      }
      try {
        await (m == null ? void 0 : m.startAudio({
          highBitrate: !0
        }));
      } catch (D) {
        D.type === "INSUFFICIENT_PRIVILEGES" && D.reason === "USER_FORBIDDEN_MICROPHONE" && console.warn("User has denied access to the microphone"), console.warn(D);
      }
    }
  }, E = () => {
    const D = s ? "collapse" : "expand";
    a(!s), t1.trigger("dispatch-expand", D, "info"), ["PATIENT", "GUEST"].includes(t) && h.toggle();
  }, w = Jo(async () => {
    if ((m == null ? void 0 : m.getShareStatus()) === Fe.End && Nb) {
      await (m == null ? void 0 : m.startShareScreen(document.querySelector(Nb), {
        requestReadReceipt: !0,
        captureHeight: 300,
        captureWidth: 300
      })), u(!0);
      return;
    }
    await (m == null ? void 0 : m.stopShareScreen()), u(!1);
  }, [m]), _ = Jo(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (D) => {
      const {
        action: B,
        source: L
      } = D;
      B === Go.Join ? (f(!0), setTimeout(() => {
        var R;
        i(!((R = p.getCurrentUserInfo()) != null && R.muted));
      }, 500)) : B === Go.Leave ? (f(!1), i(!1)) : B === Go.Muted ? (i(!1), L === Gn.PassiveByMuteOne && console.log("Host muted you")) : B === Go.Unmuted && (i(!0), L === "passive" && console.log("Host unmuted you"));
    },
    [p]
  ), I = Jo(() => {
    u(!1);
  }, []);
  return sn(() => (p.on("current-audio-change", _), p.on("passively-stop-share", I), () => {
    p.off("current-audio-change", _), p.off("passively-stop-share", I);
  }), [_, I, p]), sn(() => {
    (async () => m && (console.log("[Zoom] Starting audio stream"), await m.startAudio({
      mute: !0
    })))();
  }, [m]), {
    hasVideo: r,
    hasAudio: o,
    hasShareScreen: l,
    hasExpand: s,
    hasFullScreen: h == null ? void 0 : h.fullscreen,
    loadingFinishMeet: d,
    toggleVideo: C,
    toggleAudio: b,
    toggleExpand: E,
    toogleShareScreen: w,
    finishMeet: g
  };
};
var q = function() {
  return q = Object.assign || function(t) {
    for (var r, n = 1, o = arguments.length; n < o; n++) {
      r = arguments[n];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, q.apply(this, arguments);
};
function _N(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
}
var RN = ee(function() {
  return Promise.resolve().then(function() {
    return JV;
  });
}), ON = ee(function() {
  return Promise.resolve().then(function() {
    return YV;
  });
}), TN = ee(function() {
  return Promise.resolve().then(function() {
    return ej;
  });
}), kN = ee(function() {
  return Promise.resolve().then(function() {
    return rj;
  });
}), MN = ee(function() {
  return Promise.resolve().then(function() {
    return oj;
  });
}), PN = ee(function() {
  return Promise.resolve().then(function() {
    return sj;
  });
}), DN = ee(function() {
  return Promise.resolve().then(function() {
    return lj;
  });
}), LN = ee(function() {
  return Promise.resolve().then(function() {
    return dj;
  });
}), NN = ee(function() {
  return Promise.resolve().then(function() {
    return pj;
  });
}), xN = ee(function() {
  return Promise.resolve().then(function() {
    return fj;
  });
}), VN = ee(function() {
  return Promise.resolve().then(function() {
    return mj;
  });
}), jN = ee(function() {
  return Promise.resolve().then(function() {
    return yj;
  });
}), UN = ee(function() {
  return Promise.resolve().then(function() {
    return bj;
  });
}), BN = ee(function() {
  return Promise.resolve().then(function() {
    return wj;
  });
}), $N = ee(function() {
  return Promise.resolve().then(function() {
    return Ij;
  });
}), HN = ee(function() {
  return Promise.resolve().then(function() {
    return _j;
  });
}), FN = ee(function() {
  return Promise.resolve().then(function() {
    return Oj;
  });
}), zN = ee(function() {
  return Promise.resolve().then(function() {
    return kj;
  });
}), WN = ee(function() {
  return Promise.resolve().then(function() {
    return Pj;
  });
}), ZN = ee(function() {
  return Promise.resolve().then(function() {
    return Lj;
  });
}), GN = ee(function() {
  return Promise.resolve().then(function() {
    return xj;
  });
}), qN = ee(function() {
  return Promise.resolve().then(function() {
    return jj;
  });
}), KN = ee(function() {
  return Promise.resolve().then(function() {
    return Bj;
  });
}), JN = ee(function() {
  return Promise.resolve().then(function() {
    return Hj;
  });
}), QN = ee(function() {
  return Promise.resolve().then(function() {
    return zj;
  });
}), YN = ee(function() {
  return Promise.resolve().then(function() {
    return Zj;
  });
}), XN = ee(function() {
  return Promise.resolve().then(function() {
    return eB;
  });
}), ex = ee(function() {
  return Promise.resolve().then(function() {
    return qj;
  });
}), tx = ee(function() {
  return Promise.resolve().then(function() {
    return Jj;
  });
}), rx = ee(function() {
  return Promise.resolve().then(function() {
    return Yj;
  });
}), nx = ee(function() {
  return Promise.resolve().then(function() {
    return eU;
  });
}), ox = ee(function() {
  return Promise.resolve().then(function() {
    return rU;
  });
}), ix = ee(function() {
  return Promise.resolve().then(function() {
    return oU;
  });
}), sx = ee(function() {
  return Promise.resolve().then(function() {
    return sU;
  });
}), ax = ee(function() {
  return Promise.resolve().then(function() {
    return lU;
  });
}), lx = ee(function() {
  return Promise.resolve().then(function() {
    return dU;
  });
}), ux = ee(function() {
  return Promise.resolve().then(function() {
    return pU;
  });
}), dx = ee(function() {
  return Promise.resolve().then(function() {
    return fU;
  });
}), cx = ee(function() {
  return Promise.resolve().then(function() {
    return mU;
  });
}), px = ee(function() {
  return Promise.resolve().then(function() {
    return yU;
  });
}), hx = ee(function() {
  return Promise.resolve().then(function() {
    return bU;
  });
}), fx = ee(function() {
  return Promise.resolve().then(function() {
    return wU;
  });
}), vx = ee(function() {
  return Promise.resolve().then(function() {
    return IU;
  });
}), mx = ee(function() {
  return Promise.resolve().then(function() {
    return _U;
  });
}), gx = ee(function() {
  return Promise.resolve().then(function() {
    return OU;
  });
}), yx = ee(function() {
  return Promise.resolve().then(function() {
    return kU;
  });
}), Sx = ee(function() {
  return Promise.resolve().then(function() {
    return PU;
  });
}), bx = ee(function() {
  return Promise.resolve().then(function() {
    return LU;
  });
}), Cx = ee(function() {
  return Promise.resolve().then(function() {
    return xU;
  });
}), wx = ee(function() {
  return Promise.resolve().then(function() {
    return jU;
  });
}), Ex = ee(function() {
  return Promise.resolve().then(function() {
    return BU;
  });
}), Ix = ee(function() {
  return Promise.resolve().then(function() {
    return HU;
  });
}), Ax = ee(function() {
  return Promise.resolve().then(function() {
    return zU;
  });
}), _x = ee(function() {
  return Promise.resolve().then(function() {
    return ZU;
  });
}), Rx = ee(function() {
  return Promise.resolve().then(function() {
    return qU;
  });
}), Ox = ee(function() {
  return Promise.resolve().then(function() {
    return JU;
  });
}), Tx = ee(function() {
  return Promise.resolve().then(function() {
    return YU;
  });
}), kx = ee(function() {
  return Promise.resolve().then(function() {
    return oH;
  });
}), Mx = ee(function() {
  return Promise.resolve().then(function() {
    return sH;
  });
}), Px = ee(function() {
  return Promise.resolve().then(function() {
    return lH;
  });
}), Dx = ee(function() {
  return Promise.resolve().then(function() {
    return dH;
  });
}), Lx = ee(function() {
  return Promise.resolve().then(function() {
    return pH;
  });
}), Nx = ee(function() {
  return Promise.resolve().then(function() {
    return fH;
  });
}), xx = ee(function() {
  return Promise.resolve().then(function() {
    return mH;
  });
}), Vx = ee(function() {
  return Promise.resolve().then(function() {
    return yH;
  });
}), jx = ee(function() {
  return Promise.resolve().then(function() {
    return bH;
  });
}), Ux = ee(function() {
  return Promise.resolve().then(function() {
    return wH;
  });
}), Bx = ee(function() {
  return Promise.resolve().then(function() {
    return IH;
  });
}), $x = ee(function() {
  return Promise.resolve().then(function() {
    return _H;
  });
}), Hx = ee(function() {
  return Promise.resolve().then(function() {
    return OH;
  });
}), Fx = ee(function() {
  return Promise.resolve().then(function() {
    return kH;
  });
}), zx = ee(function() {
  return Promise.resolve().then(function() {
    return PH;
  });
}), Wx = ee(function() {
  return Promise.resolve().then(function() {
    return rB;
  });
}), Zx = ee(function() {
  return Promise.resolve().then(function() {
    return oB;
  });
}), Gx = ee(function() {
  return Promise.resolve().then(function() {
    return sB;
  });
}), qx = ee(function() {
  return Promise.resolve().then(function() {
    return lB;
  });
}), Kx = ee(function() {
  return Promise.resolve().then(function() {
    return dB;
  });
}), Jx = ee(function() {
  return Promise.resolve().then(function() {
    return pB;
  });
}), Qx = ee(function() {
  return Promise.resolve().then(function() {
    return fB;
  });
}), Yx = ee(function() {
  return Promise.resolve().then(function() {
    return mB;
  });
}), Xx = ee(function() {
  return Promise.resolve().then(function() {
    return yB;
  });
}), eV = ee(function() {
  return Promise.resolve().then(function() {
    return bB;
  });
}), tV = ee(function() {
  return Promise.resolve().then(function() {
    return wB;
  });
}), rV = ee(function() {
  return Promise.resolve().then(function() {
    return IB;
  });
}), nV = ee(function() {
  return Promise.resolve().then(function() {
    return _B;
  });
}), oV = ee(function() {
  return Promise.resolve().then(function() {
    return OB;
  });
}), iV = ee(function() {
  return Promise.resolve().then(function() {
    return kB;
  });
}), sV = ee(function() {
  return Promise.resolve().then(function() {
    return PB;
  });
}), aV = ee(function() {
  return Promise.resolve().then(function() {
    return LB;
  });
}), lV = ee(function() {
  return Promise.resolve().then(function() {
    return xB;
  });
}), uV = ee(function() {
  return Promise.resolve().then(function() {
    return jB;
  });
}), dV = ee(function() {
  return Promise.resolve().then(function() {
    return BB;
  });
}), cV = ee(function() {
  return Promise.resolve().then(function() {
    return HB;
  });
}), pV = ee(function() {
  return Promise.resolve().then(function() {
    return zB;
  });
}), hV = ee(function() {
  return Promise.resolve().then(function() {
    return ZB;
  });
}), fV = ee(function() {
  return Promise.resolve().then(function() {
    return qB;
  });
}), vV = ee(function() {
  return Promise.resolve().then(function() {
    return JB;
  });
}), mV = ee(function() {
  return Promise.resolve().then(function() {
    return YB;
  });
}), gV = ee(function() {
  return Promise.resolve().then(function() {
    return e$;
  });
}), yV = ee(function() {
  return Promise.resolve().then(function() {
    return r$;
  });
}), SV = ee(function() {
  return Promise.resolve().then(function() {
    return o$;
  });
}), bV = ee(function() {
  return Promise.resolve().then(function() {
    return s$;
  });
}), CV = ee(function() {
  return Promise.resolve().then(function() {
    return l$;
  });
}), wV = ee(function() {
  return Promise.resolve().then(function() {
    return d$;
  });
}), EV = ee(function() {
  return Promise.resolve().then(function() {
    return p$;
  });
}), IV = ee(function() {
  return Promise.resolve().then(function() {
    return f$;
  });
}), AV = ee(function() {
  return Promise.resolve().then(function() {
    return m$;
  });
}), _V = ee(function() {
  return Promise.resolve().then(function() {
    return y$;
  });
}), RV = ee(function() {
  return Promise.resolve().then(function() {
    return b$;
  });
}), OV = ee(function() {
  return Promise.resolve().then(function() {
    return w$;
  });
}), TV = ee(function() {
  return Promise.resolve().then(function() {
    return I$;
  });
}), kV = ee(function() {
  return Promise.resolve().then(function() {
    return _$;
  });
}), MV = ee(function() {
  return Promise.resolve().then(function() {
    return O$;
  });
}), PV = ee(function() {
  return Promise.resolve().then(function() {
    return k$;
  });
}), DV = ee(function() {
  return Promise.resolve().then(function() {
    return P$;
  });
}), LV = ee(function() {
  return Promise.resolve().then(function() {
    return L$;
  });
}), NV = ee(function() {
  return Promise.resolve().then(function() {
    return x$;
  });
}), xV = ee(function() {
  return Promise.resolve().then(function() {
    return j$;
  });
}), VV = ee(function() {
  return Promise.resolve().then(function() {
    return B$;
  });
}), jV = ee(function() {
  return Promise.resolve().then(function() {
    return H$;
  });
}), UV = ee(function() {
  return Promise.resolve().then(function() {
    return z$;
  });
}), BV = ee(function() {
  return Promise.resolve().then(function() {
    return Z$;
  });
}), $V = ee(function() {
  return Promise.resolve().then(function() {
    return q$;
  });
}), HV = ee(function() {
  return Promise.resolve().then(function() {
    return J$;
  });
}), FV = ee(function() {
  return Promise.resolve().then(function() {
    return Y$;
  });
}), zV = ee(function() {
  return Promise.resolve().then(function() {
    return eH;
  });
}), WV = ee(function() {
  return Promise.resolve().then(function() {
    return rH;
  });
}), ZV = {
  "arrow-down": RN,
  "arrow-left": ON,
  "arrow-right": TN,
  "arrow-up": kN,
  back: MN,
  "left-arrow-circle": PN,
  up: DN,
  add: LN,
  bullet: NN,
  calendar: xN,
  check: VN,
  clip: jN,
  clock: UN,
  "close-circle": BN,
  close: $N,
  copy: HN,
  download: FN,
  edit: zN,
  email: WN,
  exit: ZN,
  "eye-off": GN,
  "eye-on": qN,
  fail: KN,
  "filter-close": JN,
  filter: QN,
  flag: YN,
  group: XN,
  home: ex,
  image: tx,
  information: rx,
  "item-documents-files": nx,
  key: ox,
  lock: ix,
  menu: sx,
  minus: ax,
  more: lx,
  notification: ux,
  plus: dx,
  print: cx,
  "question-checkmark-circle": px,
  question: hx,
  refresh: fx,
  search: vx,
  "send-share": mx,
  settings: gx,
  star: yx,
  success: Sx,
  support: bx,
  "time-zone": Cx,
  trash: wx,
  unlock: Ex,
  upload: Ix,
  user: Ax,
  warning: _x,
  wifi: Rx,
  overflow: Ox,
  "plus-circle": Tx,
  brain: kx,
  "card-edit": Mx,
  "doctor-talk": Px,
  folder: Dx,
  heartbeat: Lx,
  hospital: Nx,
  mask: xx,
  "medical-certificate": Vx,
  "medical-cross": jx,
  notes: Ux,
  pill: Bx,
  "scale-weight": $x,
  "shield-heart": Hx,
  stethoscope: Fx,
  syringe: zx,
  audio: Wx,
  "camera-off": Zx,
  "camera-on": Gx,
  fullscreen: qx,
  "microphone-off": Kx,
  "microphone-on": Jx,
  minimize: Qx,
  miniplayer: Yx,
  "phone-on": Xx,
  rotate: eV,
  "share-screen": tV,
  book: rV,
  "browser-video-player": nV,
  chart: oV,
  chat: iV,
  "clipboard-saved": sV,
  clipboard: aV,
  "credit-card": lV,
  dashboard: uV,
  "document-atestado": dV,
  "face-id": cV,
  "file-check": pV,
  "file-error": hV,
  "file-exams": fV,
  file: vV,
  "file-image": mV,
  "file-pdf": gV,
  "file-text": yV,
  "file-warning-error": SV,
  "file-crossed": bV,
  "filter-cross-delete": CV,
  "file-warning": wV,
  "user-error": EV,
  "font-bold": IV,
  "font-italic": AV,
  "font-underline": _V,
  frame: RV,
  "icon-share": OV,
  identity: TV,
  "justify-center": kV,
  "justify-left": MV,
  "medical-cross-fast-help-circle": PV,
  mobile: DV,
  "paragraph-list": LV,
  "paragraph-number": NV,
  receipt: xV,
  "select-all": VV,
  send: jV,
  "settings-handles": UV,
  "signin-send-share": BV,
  "receipt-bullet": $V,
  analytics: HV,
  "document-calculator": FV,
  "profile-checkmark": zV,
  "hand-key": WV
}, GV = function(e) {
  var t = e.name, r = e.size, n = e.color, o = e.onClick, i = _N(e, ["name", "size", "color", "onClick"]), s = N0(function() {
    if (!t)
      throw new Error("Icon name was not provided");
    return t;
  }, [t]), a = ZV[s];
  return S(hR, q({ fallback: S("span", { className: "icon-on-suspense" }) }, { children: S(a, q({ color: n, onClick: o, size: r }, i)) }));
}, qV = {
  "x-small": 14,
  small: 16,
  medium: 24,
  large: 32
}, te = function(e) {
  return qV[e || "medium"];
}, KV = function(e) {
  var t = te(e.size);
  return S("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.231 9.24a.77.77 0 0 1 1.117 0L12 13.025l3.652-3.785a.77.77 0 0 1 1.117 0 .84.84 0 0 1 0 1.157l-4.21 4.363a.77.77 0 0 1-1.117 0l-4.21-4.363a.84.84 0 0 1 0-1.157Z", fill: "currentColor" }) }));
}, JV = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: KV
}), QV = function(e) {
  var t = te(e.size);
  return S("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.76 7.231a.77.77 0 0 1 0 1.117L10.975 12l3.785 3.652a.77.77 0 0 1 0 1.117.84.84 0 0 1-1.157 0l-4.363-4.21a.77.77 0 0 1 0-1.117l4.363-4.21a.84.84 0 0 1 1.157 0Z", fill: "currentColor" }) }));
}, YV = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: QV
}), XV = function(e) {
  var t = te(e.size);
  return S("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.24 7.231a.84.84 0 0 1 1.157 0l4.363 4.21a.77.77 0 0 1 0 1.117l-4.363 4.21a.84.84 0 0 1-1.157 0 .77.77 0 0 1 0-1.116L13.025 12 9.24 8.348a.77.77 0 0 1 0-1.117Z", fill: "currentColor" }) }));
}, ej = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: XV
}), tj = function(e) {
  var t = te(e.size);
  return S("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.442 9.24a.77.77 0 0 1 1.116 0l4.21 4.363a.84.84 0 0 1 0 1.157.77.77 0 0 1-1.116 0L12 10.975 8.348 14.76a.77.77 0 0 1-1.117 0 .84.84 0 0 1 0-1.157l4.21-4.363Z", fill: "currentColor" }) }));
}, rj = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: tj
}), nj = function(e) {
  var t = te(e.size);
  return S("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.53 6.47a.75.75 0 0 1 0 1.06l-3.72 3.72H19a.75.75 0 0 1 0 1.5H6.81l3.72 3.72a.75.75 0 1 1-1.06 1.06l-5-5a.75.75 0 0 1 0-1.06l5-5a.75.75 0 0 1 1.06 0Z", fill: "currentColor" }) }));
}, oj = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: nj
}), ij = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 2.949A7.05 7.05 0 0 0 2.95 10 7.05 7.05 0 0 0 10 17.051 7.05 7.05 0 0 0 17.052 10 7.05 7.05 0 0 0 10 2.949Zm0 15.384A8.333 8.333 0 0 1 1.667 10 8.333 8.333 0 0 1 10 1.667 8.333 8.333 0 0 1 18.334 10 8.333 8.333 0 0 1 10 18.333Z", fill: e.color }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.94 10c0-.354.287-.641.641-.641h6.838a.641.641 0 0 1 0 1.282H6.581a.641.641 0 0 1-.64-.641Z", fill: e.color }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.599 6.983c.25.25.25.656 0 .906L7.488 10l2.11 2.112a.641.641 0 1 1-.906.906l-2.564-2.564a.641.641 0 0 1 0-.906l2.564-2.564c.25-.25.656-.25.907 0Z", fill: e.color })] }));
}, sj = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: ij
}), aj = function(e) {
  var t = te(e.size);
  return S("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.48 10.48a.75.75 0 0 1-1.06 0L12.7 6.76v12.19a.75.75 0 0 1-1.5 0V6.76l-3.72 3.72a.75.75 0 1 1-1.06-1.06l5-5a.75.75 0 0 1 1.06 0l5 5a.75.75 0 0 1 0 1.06Z", fill: "currentColor" }) }));
}, lj = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: aj
}), uj = function(e) {
  var t = te(e.size);
  return S("svg", q({}, e, { width: t, height: t, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.25 15.25a.75.75 0 0 0 1.5 0v-6.5h6.5a.75.75 0 0 0 0-1.5h-6.5V.75a.75.75 0 0 0-1.5 0v6.5H.75a.75.75 0 0 0 0 1.5h6.5v6.5Z", fill: "currentColor" }) }));
}, dj = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: uj
}), cj = function(e) {
  var t = te(e.size);
  return S("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.243 7.757a6 6 0 1 1-8.485 8.486 6 6 0 0 1 8.485-8.486Z", fill: "currentColor" }) }));
}, pj = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: cj
}), hj = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 5.999A3.749 3.749 0 0 1 5.999 2.25H18a3.749 3.749 0 0 1 3.749 3.749V18a3.749 3.749 0 0 1-3.749 3.749H6a3.749 3.749 0 0 1-3.749-3.749V6Zm3.749-2.25A2.25 2.25 0 0 0 3.749 6V18A2.25 2.25 0 0 0 6 20.251H18a2.25 2.25 0 0 0 2.25-2.25V6A2.25 2.25 0 0 0 18 3.749H6Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 8A.75.75 0 0 1 3 7.25h18a.75.75 0 0 1 0 1.5H3A.75.75 0 0 1 2.25 8ZM17.805 10.945a.748.748 0 0 0-.555-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.245-.555Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.5 11.45a.75.75 0 0 1 .75-.75.8.8 0 0 1 .8.8.75.75 0 0 1-1.304.505.748.748 0 0 1-.245-.555ZM14.304 10.945a.748.748 0 0 0-.555-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.245-.555Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 11.45a.75.75 0 0 1 .75-.75.8.8 0 0 1 .799.8.75.75 0 0 1-1.304.505.748.748 0 0 1-.246-.555ZM10.803 10.945a.748.748 0 0 0-.554-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.245-.555Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.5 11.45a.75.75 0 0 1 .749-.75.8.8 0 0 1 .8.8.75.75 0 0 1-1.305.505.748.748 0 0 1-.245-.555ZM7.303 13.945a.748.748 0 0 0-.554-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.246-.555Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 14.45a.75.75 0 0 1 .749-.75.8.8 0 0 1 .8.8.75.75 0 0 1-1.305.505A.748.748 0 0 1 6 14.45ZM10.803 13.945a.748.748 0 0 0-.554-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.245-.555Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.5 14.45a.75.75 0 0 1 .749-.75.8.8 0 0 1 .8.8.75.75 0 0 1-1.305.505.748.748 0 0 1-.245-.555ZM14.304 13.945a.748.748 0 0 0-.555-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.245-.555Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 14.45a.75.75 0 0 1 .75-.75.8.8 0 0 1 .799.8.75.75 0 0 1-1.304.505.748.748 0 0 1-.246-.555ZM17.805 13.945a.748.748 0 0 0-.555-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.245-.555Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.5 14.45a.75.75 0 0 1 .75-.75.8.8 0 0 1 .8.8.75.75 0 0 1-1.304.505.748.748 0 0 1-.245-.555ZM17.805 16.946a.748.748 0 0 0-.555-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.245-.555Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.5 17.45a.75.75 0 0 1 .75-.75.8.8 0 0 1 .8.8.75.75 0 0 1-1.304.505.748.748 0 0 1-.245-.555ZM14.304 16.946a.748.748 0 0 0-.555-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.245-.555Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 17.45a.75.75 0 0 1 .75-.75.8.8 0 0 1 .799.8.75.75 0 0 1-1.304.505.748.748 0 0 1-.246-.555ZM10.803 16.946a.748.748 0 0 0-.554-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.245-.555Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.5 17.45a.75.75 0 0 1 .749-.75.8.8 0 0 1 .8.8.75.75 0 0 1-1.305.505.748.748 0 0 1-.245-.555ZM7.303 16.946a.748.748 0 0 0-.554-.245.8.8 0 1 0 .8.8.748.748 0 0 0-.246-.555Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 17.45a.75.75 0 0 1 .749-.75.8.8 0 0 1 .8.8.75.75 0 0 1-1.305.505A.748.748 0 0 1 6 17.45Z", fill: "currentColor" })] }));
}, fj = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: hj
}), vj = function(e) {
  var t = te(e.size);
  return S("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.774 5.728a.786.786 0 0 1 0 1.104L9.46 18.272a.765.765 0 0 1-1.091 0l-5.143-5.2a.786.786 0 0 1 0-1.103.765.765 0 0 1 1.09 0l4.598 4.648 10.77-10.889a.765.765 0 0 1 1.09 0Z", fill: "currentColor" }) }));
}, mj = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: vj
}), gj = function(e) {
  var t = te(e.size);
  return S("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.6 3.605a4.629 4.629 0 1 1 6.547 6.546l-7.232 7.232a2.866 2.866 0 0 1-4.052-4.052l5.486-5.486a.75.75 0 1 1 1.06 1.06l-5.486 5.486a1.366 1.366 0 0 0 1.932 1.932l7.232-7.232a3.13 3.13 0 1 0-4.426-4.426L6.43 11.897a4.892 4.892 0 1 0 6.92 6.92l4.389-4.39a.75.75 0 1 1 1.06 1.061l-4.389 4.39a6.392 6.392 0 0 1-9.04 0 6.392 6.392 0 0 1 0-9.041L12.6 3.605Z", fill: "currentColor" }) }));
}, yj = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: gj
}), Sj = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.613 12.618c0-.425.345-.77.77-.77h4.769a.769.769 0 0 1 0 1.539h-4.77a.769.769 0 0 1-.769-.77Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3.538a8.462 8.462 0 1 0 0 16.924 8.462 8.462 0 0 0 0-16.924ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.382 6.103c.425 0 .77.344.77.769v5.746a.769.769 0 1 1-1.539 0V6.872c0-.425.345-.77.77-.77Z", fill: "currentColor" })] }));
}, bj = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Sj
}), Cj = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.298 5.702c.2.2.2.525 0 .726l-3.87 3.87a.513.513 0 0 1-.726-.725l3.87-3.87c.2-.2.526-.2.726 0Z", fill: e.color }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.702 5.702c.2-.2.525-.2.726 0l3.87 3.87a.513.513 0 0 1-.725.726l-3.87-3.87c-.2-.2-.2-.525 0-.726Z", fill: e.color }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 2.36a5.64 5.64 0 1 0 0 11.28A5.64 5.64 0 0 0 8 2.36ZM1.333 8a6.666 6.666 0 1 1 13.334 0A6.666 6.666 0 1 1 1.334 8Z", fill: e.color })] }));
}, wj = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Cj
}), Ej = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.277 6.277c.37-.37.97-.37 1.34 0l10.105 10.106a.947.947 0 1 1-1.34 1.34L6.278 7.617a.947.947 0 0 1 0-1.34Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.723 6.277c.37.37.37.97 0 1.34L7.617 17.722a.947.947 0 1 1-1.34-1.34L16.383 6.278c.37-.37.97-.37 1.34 0Z", fill: "currentColor" })] }));
}, Ij = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Ej
}), Aj = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.103 8.922a2.82 2.82 0 0 1 2.82-2.82H19.18A2.82 2.82 0 0 1 22 8.923v10.259A2.82 2.82 0 0 1 19.18 22H8.923a2.82 2.82 0 0 1-2.82-2.82V8.923Zm2.82-1.281c-.709 0-1.282.573-1.282 1.281v10.259c0 .707.573 1.281 1.281 1.281h10.259c.707 0 1.281-.574 1.281-1.281V8.922c0-.708-.574-1.281-1.281-1.281H8.922Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.82 3.538c-.708 0-1.282.574-1.282 1.282v10.257c0 .708.574 1.282 1.282 1.282h2.052a.769.769 0 0 1 0 1.538H4.82A2.82 2.82 0 0 1 2 15.077V4.82A2.82 2.82 0 0 1 4.82 2h10.257a2.82 2.82 0 0 1 2.82 2.82v2.052a.769.769 0 0 1-1.538 0V4.82c0-.708-.574-1.282-1.282-1.282H4.82Z", fill: "currentColor" })] }));
}, _j = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Aj
}), Rj = function(e) {
  var t = te(e.size);
  return S("svg", q({}, e, { width: t, height: t, viewBox: "0 0 18 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 .25a.75.75 0 0 1 .75.75v12.19l3.72-3.72a.75.75 0 0 1 1.06 1.06l-5 5.001a.75.75 0 0 1-1.061 0l-5-5a.75.75 0 0 1 1.06-1.061L8.25 13.19V1A.75.75 0 0 1 9 .25ZM.25 19a.75.75 0 0 1 .75-.75h16a.75.75 0 0 1 0 1.5H1A.75.75 0 0 1 .25 19Z", fill: "currentColor" }) }));
}, Oj = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Rj
}), Tj = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.834 3.622c-.71 0-1.296.612-1.296 1.381v13.994c0 .768.586 1.381 1.296 1.381h14.332c.71 0 1.296-.613 1.296-1.381v-6.384c0-.448.344-.81.769-.81.425 0 .769.362.769.81v6.384C22 20.65 20.737 22 19.166 22H4.834C3.264 22 2 20.65 2 18.997V5.003C2 3.35 3.263 2 4.834 2H12c.425 0 .77.363.77.81 0 .449-.345.812-.77.812H4.834Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.009 2.871a2.719 2.719 0 0 1 3.988 0l.177.186c1.101 1.16 1.101 3.043 0 4.204l-8.605 9.07-.003.002a1.78 1.78 0 0 1-.832.496l-3.812 1.005a.751.751 0 0 1-.745-.21.835.835 0 0 1-.199-.785l.954-4.018c.079-.333.242-.637.472-.88l8.605-9.07Zm-8.23 13.065 2.582-.68a.26.26 0 0 0 .121-.073l8.604-9.069c.5-.527.5-1.383 0-1.91l-.176-.186a1.236 1.236 0 0 0-1.813 0l-8.605 9.07a.276.276 0 0 0-.068.126l-.646 2.722Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.384 4.583a.742.742 0 0 1 1.088 0l3.077 3.244c.3.316.3.83 0 1.146a.742.742 0 0 1-1.088 0L15.385 5.73a.842.842 0 0 1 0-1.147ZM8.616 12.22c.08-.011.24-.035.387-.035 1.841 0 3.333 1.573 3.333 3.513 0 .161-.022.325-.034.415a2.576 2.576 0 0 0-.005.039c-.056.444-.442.756-.863.697-.421-.058-.718-.466-.662-.91l.012-.094c.01-.08.014-.11.014-.147 0-1.045-.803-1.892-1.795-1.892a.633.633 0 0 0-.103.01l-.133.02c-.421.054-.805-.263-.857-.707-.051-.444.249-.849.67-.903l.036-.006Z", fill: "currentColor" })] }));
}, kj = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Tj
}), Mj = function(e) {
  var t = te(e.size);
  return S("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 6.8A2.543 2.543 0 0 1 4.8 4.25h14.4a2.543 2.543 0 0 1 2.547 2.68.75.75 0 0 1 .003.07v10A2.756 2.756 0 0 1 19 19.75H5A2.756 2.756 0 0 1 2.25 17V7c0-.024.001-.047.003-.07a2.55 2.55 0 0 1-.003-.13Zm1.5 2.374V17c0 .06.004.119.013.177l4.748-4.75L3.75 9.175Zm6.39 2.55a.77.77 0 0 0-.072-.05l-5.82-3.976c-.357-.293-.498-.589-.498-.898 0-.586.464-1.05 1.05-1.05h14.4c.586 0 1.05.464 1.05 1.05 0 .312-.14.62-.466 1.042l-5.827 3.885a.65.65 0 0 0-.025.017l-.043.028c-1.149.736-2.525.737-3.675.003l-.074-.051Zm-.344 1.54-4.973 4.973c.058.009.117.013.177.013h14c.06 0 .119-.004.177-.013l-4.94-4.939a4.81 4.81 0 0 1-4.44-.034Zm5.741-.787 4.7 4.7c.009-.058.013-.117.013-.177V9.335l-4.713 3.142Z", fill: "currentColor" }) }));
}, Pj = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Mj
}), Dj = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.825 12a.77.77 0 0 1 .77-.77h5.135a.77.77 0 1 1 0 1.538h-5.135a.77.77 0 0 1-.77-.768Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.131 9.405c.301-.3.789-.3 1.09 0l2.053 2.051c.301.3.301.787 0 1.087l-2.054 2.052c-.3.3-.788.3-1.089 0-.3-.3-.3-.788 0-1.088L19.641 12l-1.51-1.508c-.3-.3-.3-.787 0-1.087Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.324 3.538c-.71 0-1.284.574-1.284 1.282v14.36c0 .708.574 1.282 1.284 1.282H17.65c.71 0 1.284-.574 1.284-1.283v-2.051a.77.77 0 0 1 1.54 0v2.051A2.822 2.822 0 0 1 17.649 22H5.324A2.822 2.822 0 0 1 2.5 19.18V4.82A2.822 2.822 0 0 1 5.324 2H17.65a2.822 2.822 0 0 1 2.824 2.82v2.051a.77.77 0 0 1-1.54 0v-2.05c0-.71-.575-1.283-1.284-1.283H5.324Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.405 10.205a.77.77 0 0 1 .77.769v2.051a.77.77 0 0 1-1.54 0v-2.051a.77.77 0 0 1 .77-.769Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.486 2a.77.77 0 0 1 .77.769v14.355c0 1.069-.604 2.044-1.56 2.523l-4.11 2.052c-1.876.937-4.086-.427-4.086-2.523a.77.77 0 0 1 1.54 0 1.284 1.284 0 0 0 1.858 1.147l4.107-2.05c.437-.22.711-.663.711-1.15V2.77a.77.77 0 0 1 .77-.769Z", fill: "currentColor" })] }));
}, Lj = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Dj
}), Nj = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.714 18.435a.768.768 0 0 1 .995-.442c.766.298 1.536.459 2.291.459.425 0 .77.346.77.774A.772.772 0 0 1 12 20c-.972 0-1.931-.207-2.846-.563a.776.776 0 0 1-.44-1.002Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.476 11.802a.777.777 0 0 1 .31 1.05c-1.016 1.892-2.465 3.664-4.144 4.97C15.967 19.123 14.014 20 12 20a.772.772 0 0 1-.77-.774c0-.428.345-.774.77-.774 1.57 0 3.202-.69 4.701-1.856 1.495-1.162 2.809-2.762 3.732-4.481a.767.767 0 0 1 1.043-.313Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.761 8.233a.766.766 0 0 1 1.085.086 16.398 16.398 0 0 1 1.94 2.83c.285.53.285 1.173 0 1.702a.766.766 0 0 1-1.041.313.777.777 0 0 1-.312-1.05.245.245 0 0 0 0-.228 14.858 14.858 0 0 0-1.757-2.562.778.778 0 0 1 .085-1.091ZM19.724 4.227c.3.302.3.792 0 1.095L5.364 19.773a.766.766 0 0 1-1.088 0 .778.778 0 0 1 0-1.095l14.36-14.451a.766.766 0 0 1 1.088 0Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.741 10.248a2.45 2.45 0 0 0-3.481 0 2.49 2.49 0 0 0 0 3.503c.3.303.3.793 0 1.095a.766.766 0 0 1-1.088 0 4.045 4.045 0 0 1 0-5.693 3.983 3.983 0 0 1 5.657 0c.3.302.3.792 0 1.095a.766.766 0 0 1-1.088 0Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.358 6.179C8.033 4.876 9.986 4 12 4c2.014 0 3.97.877 5.644 2.181a.778.778 0 0 1 .138 1.086.766.766 0 0 1-1.08.139C15.205 6.238 13.573 5.548 12 5.548c-1.57 0-3.202.69-4.701 1.856-1.495 1.163-2.809 2.763-3.732 4.482a.245.245 0 0 0 0 .23c.923 1.718 2.236 3.316 3.73 4.48a.778.778 0 0 1 .138 1.085.766.766 0 0 1-1.08.14c-1.676-1.307-3.125-3.077-4.142-4.97a1.805 1.805 0 0 1 0-1.7C3.23 9.256 4.679 7.483 6.358 6.178Z", fill: "currentColor" })] }));
}, xj = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Nj
}), Vj = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.299 7.404c-1.495 1.162-2.809 2.762-3.732 4.481a.245.245 0 0 0 0 .23c.923 1.719 2.237 3.318 3.732 4.481 1.499 1.166 3.13 1.856 4.701 1.856 1.57 0 3.202-.69 4.701-1.856 1.495-1.162 2.809-2.762 3.732-4.481a.246.246 0 0 0 0-.23c-.923-1.719-2.237-3.318-3.732-4.481-1.5-1.166-3.13-1.856-4.701-1.856-1.571 0-3.202.69-4.701 1.856Zm-.941-1.225C8.033 4.876 9.986 4 12 4c2.014 0 3.967.876 5.642 2.179 1.679 1.305 3.128 3.077 4.145 4.97.284.53.284 1.172 0 1.702-1.017 1.893-2.466 3.665-4.145 4.97C15.967 19.125 14.014 20 12 20c-2.014 0-3.967-.876-5.642-2.179-1.679-1.306-3.128-3.077-4.145-4.97a1.804 1.804 0 0 1 0-1.702C3.23 9.256 4.679 7.484 6.358 6.18Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.658 10.332a2.334 2.334 0 0 0-3.316 0 2.37 2.37 0 0 0 0 3.336c.916.922 2.4.922 3.316 0a2.37 2.37 0 0 0 0-3.336Zm1.036-1.043a3.793 3.793 0 0 0-5.388 0 3.852 3.852 0 0 0 0 5.422 3.793 3.793 0 0 0 5.388 0 3.852 3.852 0 0 0 0-5.422Z", fill: "currentColor" })] }));
}, jj = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Vj
}), Uj = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.447 8.553c.3.3.3.788 0 1.088L9.64 15.447a.77.77 0 1 1-1.088-1.088l5.806-5.806c.3-.3.787-.3 1.088 0Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.553 8.553c.3-.3.788-.3 1.088 0l5.806 5.806a.77.77 0 0 1-1.088 1.088L8.553 9.64a.77.77 0 0 1 0-1.088Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3.538A8.461 8.461 0 0 0 3.538 12 8.46 8.46 0 0 0 12 20.462 8.46 8.46 0 0 0 20.462 12 8.46 8.46 0 0 0 12 3.538ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Z", fill: "currentColor" })] }));
}, Bj = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Uj
}), $j = function(e) {
  var t = te(e.size);
  return S("svg", q({}, e, { width: t, height: t, viewBox: "0 0 19 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.234 3.473h9.896c.681 0 1.239.553 1.243 1.234v1.034c0 .147-.11.246-.234.258a.253.253 0 0 1-.205-.07l-.541-.517a.26.26 0 0 1-.041-.053.139.139 0 0 1-.025-.05.214.214 0 0 1-.016-.085v-.517a.175.175 0 0 0-.177-.176H4.24a.175.175 0 0 0-.177.176v1.83c0 .044.017.09.05.122l3.682 3.675a.6.6 0 0 1 .086.115l.002.004.002.004.005.008a.144.144 0 0 1 .014.03l.002.007a.29.29 0 0 0 .02.05c.002.003.003.008.004.013l.005.015.001.007c.001.004.003.008.003.013 0 .004 0 .01.002.015a.08.08 0 0 1 .002.014c0 .004 0 .008.002.012a.051.051 0 0 1 .002.013v4.466c0 .23.217.402.439.344l1.767-.443a.356.356 0 0 0 .267-.344v-2.334c0-.147.11-.246.234-.258a.253.253 0 0 1 .205.07l.541.516a.261.261 0 0 1 .041.054l.025.049a.214.214 0 0 1 .016.086V14.673c0 .648-.443 1.214-1.07 1.37l-1.768.442a1.414 1.414 0 0 1-1.755-1.37v-4.19l-3.523-3.52A1.225 1.225 0 0 1 3 6.533V4.707c0-.68.554-1.234 1.234-1.234Zm9.33 3.367a.57.57 0 0 1 .804.804L13.15 8.862l1.218 1.218a.57.57 0 0 1-.804.803l-1.218-1.218-1.218 1.219a.57.57 0 0 1-.803-.804l1.218-1.218-1.218-1.218a.57.57 0 0 1 .803-.804l1.218 1.218 1.218-1.218Z", fill: "currentColor" }) }));
}, Hj = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: $j
}), Fj = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 4.797C3 3.805 3.806 3 4.8 3h14.4c.994 0 1.8.805 1.8 1.797v2.656c0 .477-.19.933-.527 1.27l-5.356 5.349c-.301.3-.79.3-1.091 0a.77.77 0 0 1 0-1.09l5.356-5.347a.255.255 0 0 0 .075-.182V4.797a.257.257 0 0 0-.257-.256H4.8a.257.257 0 0 0-.257.256v2.656c0 .07.027.134.074.18l.001.002 5.356 5.347a.77.77 0 0 1 0 1.09c-.301.3-.79.3-1.09 0L3.528 8.725h-.001A1.793 1.793 0 0 1 3 7.453V4.797Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.429 12.757a.77.77 0 0 1 .771.77v6.418c0 .334.315.58.64.498l2.57-.642a.514.514 0 0 0 .39-.498v-5.776a.77.77 0 0 1 1.543 0v5.776c0 .943-.643 1.764-1.559 1.993l-2.571.642a2.057 2.057 0 0 1-2.556-1.993v-6.418a.77.77 0 0 1 .772-.77Z", fill: "currentColor" })] }));
}, zj = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Fj
}), Wj = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.774 2.954c.428 0 .774.344.774.77V21.23c0 .425-.346.769-.774.769A.772.772 0 0 1 4 21.23V3.724c0-.425.347-.77.774-.77ZM19.226 3.026c.427 0 .774.344.774.769v10.277c0 .425-.347.769-.774.769a.772.772 0 0 1-.774-.77V3.796c0-.425.346-.77.774-.77Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m4.774 14.051-.495-.591a.766.766 0 0 0-.1 1.083.778.778 0 0 0 1.074.113l.002-.002a.97.97 0 0 1 .078-.046c.084-.047.238-.121.476-.2.475-.157 1.295-.333 2.578-.333 1.187 0 2.186.384 3.329.832l.043.017c1.105.433 2.351.922 3.854.922 1.453 0 2.465-.27 3.138-.568.336-.149.582-.303.754-.43a2.532 2.532 0 0 0 .283-.244l.008-.008.003-.004.002-.002v-.001s.002 0-.575-.514l.576.513a.766.766 0 0 0-.06-1.086.778.778 0 0 0-1.08.045l-.004.005a.988.988 0 0 1-.078.062 2.434 2.434 0 0 1-.46.26c-.456.202-1.25.434-2.507.434-1.187 0-2.186-.384-3.329-.832l-.043-.017c-1.105-.434-2.351-.923-3.854-.923-1.426 0-2.413.197-3.067.412-.326.108-.568.22-.737.314a2.536 2.536 0 0 0-.287.184l-.009.008-.004.003-.002.001s-.002.002.493.593ZM5.325 4.266a.778.778 0 0 1-1.08.02.766.766 0 0 1-.035-1.087l.564.526c-.564-.526-.563-.527-.563-.527v-.001l.002-.002.004-.004.008-.008a1.23 1.23 0 0 1 .083-.077 2.51 2.51 0 0 1 .201-.157c.172-.121.418-.268.752-.41C5.931 2.256 6.94 2 8.387 2c1.503 0 2.75.489 3.854.922l.043.017c1.143.449 2.142.832 3.329.832 1.283 0 2.103-.176 2.578-.333.238-.079.392-.153.476-.2a.987.987 0 0 0 .077-.046l.003-.002a.778.778 0 0 1 1.074.113.766.766 0 0 1-.1 1.084l-.495-.592.494.592-.001.001-.002.001-.004.004-.009.007a1.536 1.536 0 0 1-.085.062 2.52 2.52 0 0 1-.202.122 4.38 4.38 0 0 1-.737.314c-.654.215-1.64.412-3.067.412-1.503 0-2.75-.49-3.854-.923-.014-.005-.029-.01-.043-.017-1.143-.448-2.142-.832-3.329-.832-1.261 0-2.06.223-2.519.417-.23.097-.38.19-.462.248a.975.975 0 0 0-.081.063Z", fill: "currentColor" })] }));
}, Zj = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Wj
}), Gj = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.757 3.27a3.653 3.653 0 0 1 4.487 0l5.845 4.547a3.653 3.653 0 0 1 1.411 2.884v7.145a3.654 3.654 0 0 1-3.654 3.654H6.154A3.654 3.654 0 0 1 2.5 17.846v-7.145c0-1.127.52-2.192 1.41-2.884L9.757 3.27Zm.897 1.154L4.808 8.97a2.191 2.191 0 0 0-.846 1.73v7.145c0 1.211.98 2.192 2.192 2.192h11.692c1.211 0 2.192-.98 2.192-2.192v-7.145a2.19 2.19 0 0 0-.846-1.73l-5.846-4.547a2.192 2.192 0 0 0-2.692 0Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.55 11.912a2.192 2.192 0 1 0-3.1 3.1 2.192 2.192 0 0 0 3.1-3.1Zm1.033-1.034a3.654 3.654 0 1 0-5.167 5.167 3.654 3.654 0 0 0 5.167-5.167Z", fill: "currentColor" })] }));
}, qj = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Gj
}), Kj = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.558 4.385c-.642 0-1.162.516-1.162 1.153v12.924c0 .637.52 1.153 1.162 1.153h14.88c.643 0 1.164-.516 1.164-1.153V5.538c0-.637-.52-1.153-1.163-1.153H4.559ZM2 5.538A2.548 2.548 0 0 1 4.558 3h14.88a2.548 2.548 0 0 1 2.56 2.538v12.924A2.549 2.549 0 0 1 19.437 21H4.559A2.548 2.548 0 0 1 2 18.462V5.538Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.1 8.415a1.17 1.17 0 0 0-1.645 0 1.147 1.147 0 0 0 0 1.632c.454.45 1.19.45 1.645 0a1.147 1.147 0 0 0 0-1.632Zm.986-.98c-1-.99-2.62-.99-3.618 0-1 .992-1 2.6 0 3.59 1 .992 2.62.992 3.618 0 1-.99 1-2.598 0-3.59ZM15.524 12.288a1.638 1.638 0 0 1 2.29-.252l3.924 3.116c.301.239.35.674.11.973a.702.702 0 0 1-.982.108l-3.925-3.116a.235.235 0 0 0-.327.036m0 0-3.104 3.85a1.638 1.638 0 0 1-2.288.252l-1.739-1.38a.234.234 0 0 0-.324.032l-4.067 4.844a.701.701 0 0 1-.983.088.689.689 0 0 1-.09-.974l4.068-4.844a1.637 1.637 0 0 1 2.268-.228l1.738 1.38c.1.08.248.064.328-.035l3.103-3.85", fill: "currentColor" })] }));
}, Jj = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Kj
}), Qj = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 8.253a1 1 0 1 1 2-.005 1 1 0 0 1-2 .005Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3.75A8.25 8.25 0 0 0 3.75 12 8.25 8.25 0 0 0 12 20.25 8.25 8.25 0 0 0 20.25 12 8.25 8.25 0 0 0 12 3.75ZM2.25 12A9.75 9.75 0 0 1 12 2.25 9.75 9.75 0 0 1 21.75 12 9.75 9.75 0 0 1 12 21.75 9.75 9.75 0 0 1 2.25 12Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 11.25a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0v-5a.75.75 0 0 1 .75-.75Z", fill: "currentColor" })] }));
}, Yj = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Qj
}), Xj = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { d: "M7.748 4.663h-1.75a2 2 0 0 0-2.001 2.001V19.67a2 2 0 0 0 2 2h2.001M20.003 7.665v-1a2 2 0 0 0-2-2.002h-1.751", stroke: e.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), S("rect", { x: 10.999, y: 10.541, width: 9.004, height: 11.13, rx: 1.125, stroke: e.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), S("rect", { x: 7.749, y: 2.663, width: 8.504, height: 4.002, rx: 2, stroke: e.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, eU = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Xj
}), tU = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.673 8.406c.186-.187.476-.357.83-.357s.644.17.83.357c.185.186.355.477.355.833s-.17.647-.355.833a1.183 1.183 0 0 1-.83.357c-.354 0-.644-.17-.83-.357a1.192 1.192 0 0 1-.355-.833c0-.356.17-.647.355-.833Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.01 4.166c-.59-.218-1.073-.12-1.433.241L9.589 7.408a1.48 1.48 0 0 0-.346 1.538l.916 2.044a.778.778 0 0 1-.163.872l-5.95 5.876v2.21H6.25l5.955-5.98a.77.77 0 0 1 .85-.165l2.147.923c.59.218 1.073.12 1.433-.242l2.961-2.973c.341-.426.456-.948.268-1.467l-1.538-3.603-.007-.018a1.27 1.27 0 0 0-.703-.706l-.017-.007-3.589-1.544Zm-2.526-.856c.872-.876 2.034-.987 3.084-.592a.832.832 0 0 1 .033.014L18.2 4.28a2.82 2.82 0 0 1 1.55 1.557l1.543 3.614.013.033c.419 1.121.128 2.238-.542 3.046a.8.8 0 0 1-.047.051l-2.988 3.001c-.873.876-2.034.987-3.084.592a.784.784 0 0 1-.033-.014l-1.683-.724-5.812 5.837a.771.771 0 0 1-.546.227H3.273a.774.774 0 0 1-.773-.776v-3.311c0-.208.083-.407.23-.553l5.799-5.726-.706-1.577a3.037 3.037 0 0 1 .673-3.247l2.988-3Z", fill: "currentColor" })] }));
}, rU = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: tU
}), nU = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.839 10.718c-.713 0-1.29.573-1.29 1.282v7.18c0 .708.577 1.282 1.29 1.282H17.16c.713 0 1.29-.574 1.29-1.282V12c0-.709-.577-1.282-1.29-1.282H6.84ZM4 12a2.83 2.83 0 0 1 2.839-2.82H17.16A2.83 2.83 0 0 1 20 12v7.18A2.83 2.83 0 0 1 17.161 22H6.84A2.83 2.83 0 0 1 4 19.18V12Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3.538c-1.853 0-3.355 1.493-3.355 3.334v3.077c0 .425-.346.769-.774.769a.772.772 0 0 1-.774-.77V6.873C7.097 4.182 9.292 2 12 2c2.708 0 4.903 2.181 4.903 4.872v3.077c0 .425-.346.769-.774.769a.772.772 0 0 1-.774-.77V6.873c0-1.841-1.502-3.334-3.355-3.334Z", fill: "currentColor" })] }));
}, oU = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: nU
}), iU = function(e) {
  var t = te(e.size);
  return S("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.251 6a.75.75 0 0 1 .75-.75h17.992a.75.75 0 1 1 0 1.5H3.001A.75.75 0 0 1 2.25 6ZM2.251 12a.75.75 0 0 1 .75-.75h17.992a.75.75 0 1 1 0 1.5H3.001a.75.75 0 0 1-.75-.75ZM2.251 18a.75.75 0 0 1 .75-.75h17.992a.75.75 0 1 1 0 1.5H3.001a.75.75 0 0 1-.75-.75Z", fill: "currentColor" }) }));
}, sU = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: iU
}), aU = function(e) {
  var t = te(e.size);
  return S("svg", q({}, e, { width: t, height: t, viewBox: "0 0 16 2", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 1c0-.552.398-1 .889-1H15.11c.491 0 .889.448.889 1s-.398 1-.889 1H.89C.398 2 0 1.552 0 1Z", fill: "currentColor" }) }));
}, lU = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: aU
}), uU = function(e) {
  var t = te(e.size);
  return S("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.75 18.004a1.247 1.247 0 0 1 1.247-1.254c.69 0 1.253.558 1.253 1.25 0 .69-.56 1.25-1.25 1.25a1.252 1.252 0 0 1-1.25-1.246Zm.688-.004h-.688v.004M10.75 12.004a1.247 1.247 0 0 1 1.247-1.254c.69 0 1.253.558 1.253 1.25 0 .69-.56 1.25-1.25 1.25a1.252 1.252 0 0 1-1.25-1.246Zm.688-.004h-.688v.004M10.75 6.004a1.247 1.247 0 0 1 1.247-1.254c.69 0 1.253.558 1.253 1.25 0 .69-.56 1.25-1.25 1.25a1.252 1.252 0 0 1-1.25-1.246ZM11.438 6h-.688v.004", fill: "currentColor" }) }));
}, dU = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: uU
}), cU = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.292 17.593a.75.75 0 0 1 .75.75v.365a3.042 3.042 0 0 1-6.084.001v-.365a.75.75 0 0 1 1.5 0v.365a1.542 1.542 0 0 0 3.084-.001v-.365a.75.75 0 0 1 .75-.75ZM9.417 4.833a2.583 2.583 0 1 1 5.166 0v.918a.75.75 0 0 1-1.5 0v-.918a1.083 1.083 0 1 0-2.166 0v.918a.75.75 0 0 1-1.5 0v-.918Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.094 6.407a3.78 3.78 0 0 0-3.781 3.781v2.797c0 .73-.29 1.429-.806 1.944l-.64.641a1.25 1.25 0 0 0-.367.884c0 .63.51 1.14 1.14 1.14h10.721c.63 0 1.14-.51 1.14-1.14 0-.33-.132-.65-.366-.884l-.641-.64a2.75 2.75 0 0 1-.806-1.945v-2.797a3.78 3.78 0 0 0-3.781-3.781h-1.813Zm-5.281 3.781a5.28 5.28 0 0 1 5.281-5.281h1.813a5.28 5.28 0 0 1 5.281 5.281v2.797c0 .33.132.65.366.884l.641.64a2.75 2.75 0 0 1 .806 1.945 2.64 2.64 0 0 1-2.64 2.64H6.64A2.64 2.64 0 0 1 4 16.454c0-.73.29-1.429.806-1.944l.64-.641a1.25 1.25 0 0 0 .367-.884v-2.797Z", fill: "currentColor" })] }));
}, pU = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: cU
}), hU = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 .907c.523 0 .947.424.947.948v14.29a.947.947 0 0 1-1.894 0V1.855c0-.524.424-.948.947-.948Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.093 9a.947.947 0 0 1-.948.947H1.855a.947.947 0 1 1 0-1.894h14.29c.524 0 .948.424.948.947Z", fill: "currentColor" })] }));
}, fU = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: hU
}), vU = function(e) {
  var t = te(e.size);
  return S("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 3.75a.25.25 0 0 0-.25.25v3.25h8.5V4a.25.25 0 0 0-.25-.25H8Zm9.75 3.5V4A1.75 1.75 0 0 0 16 2.25H8A1.75 1.75 0 0 0 6.25 4v3.25H5A2.75 2.75 0 0 0 2.25 10v5A2.75 2.75 0 0 0 5 17.75h1.25V20c0 .966.784 1.75 1.75 1.75h8A1.75 1.75 0 0 0 17.75 20v-2.25H19A2.75 2.75 0 0 0 21.75 15v-5A2.75 2.75 0 0 0 19 7.25h-1.25ZM5 8.75c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h1.25V13.8a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 .75.75v2.45H19c.69 0 1.25-.56 1.25-1.25v-5c0-.69-.56-1.25-1.25-1.25H5Zm11.25 5.8h-8.5V20c0 .138.112.25.25.25h8a.25.25 0 0 0 .25-.25v-5.45ZM6.25 11a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75Z", fill: "currentColor" }) }));
}, mU = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: vU
}), gU = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { d: "M13 21.608a8.119 8.119 0 0 1-1 .063 9.004 9.004 0 1 1 9.004-9.004c0 .334-.02.668-.062 1M20.004 17.669l-2.501 2.5-1.501-1.5", stroke: e.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "m12 13.378 1.328-.737a2.087 2.087 0 0 0 1.073-1.825 2.298 2.298 0 0 0-2.42-2.15 2.345 2.345 0 0 0-2.382 1.812M12.1 16.569a.1.1 0 1 1-.2 0 .1.1 0 0 1 .2 0", stroke: e.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, yU = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: gU
}), SU = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3.538a8.462 8.462 0 1 0 0 16.924 8.462 8.462 0 0 0 0-16.924ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.436 9.971a1.422 1.422 0 0 0-1.496-1.306.771.771 0 0 1-.074 0 1.467 1.467 0 0 0-1.49 1.135.769.769 0 0 1-1.499-.348 3.005 3.005 0 0 1 3.015-2.324 2.96 2.96 0 0 1 3.082 2.82c0 1.175-.856 1.899-1.386 2.33l-.196.157c-.209.168-.365.294-.492.426a.597.597 0 0 0-.131.173.769.769 0 0 1-1.538-.008c0-.552.301-.96.558-1.229.204-.213.466-.422.686-.598l.143-.115c.56-.455.808-.755.818-1.113ZM12.604 15.242A.767.767 0 0 0 12 14.95a.897.897 0 1 0 .897.897.768.768 0 0 0-.293-.604Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.231 15.718c0-.425.344-.769.769-.769.495 0 .897.402.897.897a.769.769 0 0 1-1.373.476.767.767 0 0 1-.293-.604Z", fill: "currentColor" })] }));
}, bU = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: SU
}), CU = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.77 3.538a.77.77 0 0 1 .768.77v3.077h3.077a.77.77 0 1 1 0 1.538H2.77A.77.77 0 0 1 2 8.153V4.309a.77.77 0 0 1 .77-.77Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.917 7.833C4.497 4.396 7.964 2 12 2c5.523 0 10 4.477 10 10a.77.77 0 0 1-1.538 0A8.46 8.46 0 0 0 12 3.538c-3.41 0-6.345 2.023-7.685 4.937a.77.77 0 0 1-1.398-.642ZM16.615 15.846a.77.77 0 0 1 .77-.77h3.846a.77.77 0 0 1 .769.77v3.846a.77.77 0 0 1-1.538 0v-3.077h-3.077a.77.77 0 0 1-.77-.769Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.77 11.23a.77.77 0 0 1 .768.77A8.46 8.46 0 0 0 12 20.462c3.41 0 6.345-2.023 7.685-4.937a.77.77 0 1 1 1.398.642C19.502 19.604 16.035 22 12 22 6.477 22 2 17.523 2 12a.77.77 0 0 1 .77-.77Z", fill: "currentColor" })] }));
}, wU = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: CU
}), EU = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.286 7.22a5.704 5.704 0 1 0-8.067 8.066 5.704 5.704 0 0 0 8.067-8.067Zm1.095-1.096A7.253 7.253 0 1 0 6.124 16.381 7.253 7.253 0 0 0 16.381 6.124Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.282 15.282a.774.774 0 0 1 1.095 0l3.396 3.396a.774.774 0 1 1-1.095 1.095l-3.396-3.396a.774.774 0 0 1 0-1.095Z", fill: "currentColor" })] }));
}, IU = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: EU
}), AU = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { d: "m12 12 9-9v7-7h-7", stroke: e.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M9 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-4", stroke: e.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, _U = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: AU
}), RU = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { clipRule: "evenodd", d: "M14.121 9.879A3 3 0 1 1 9.88 14.12 3 3 0 0 1 14.12 9.88Z", stroke: e.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { clipRule: "evenodd", d: "M16.18 18.725a1.29 1.29 0 0 0 1.823 0l.722-.722a1.29 1.29 0 0 0 0-1.823 1.324 1.324 0 0 1-.284-1.453 7.63 7.63 0 0 0 .065-.16 1.217 1.217 0 0 1 1.137-.766h.067c.712 0 1.289-.577 1.289-1.289v-1.021c0-.712-.577-1.289-1.289-1.289h-.067c-.5 0-.954-.301-1.137-.766a7.63 7.63 0 0 0-.065-.16 1.324 1.324 0 0 1 .284-1.453 1.29 1.29 0 0 0 0-1.823l-.722-.722a1.29 1.29 0 0 0-1.823 0 1.324 1.324 0 0 1-1.453.284l-.16-.065a1.227 1.227 0 0 1-.767-1.141v-.067C13.8 3.577 13.223 3 12.511 3H11.49a1.29 1.29 0 0 0-1.29 1.289v.067c0 .5-.301.954-.766 1.137-.054.022-.107.043-.16.066a1.324 1.324 0 0 1-1.453-.284 1.29 1.29 0 0 0-1.823 0l-.723.722a1.29 1.29 0 0 0 0 1.823c.382.382.494.955.284 1.453a5.419 5.419 0 0 0-.065.161 1.22 1.22 0 0 1-1.138.766h-.067C3.577 10.2 3 10.777 3 11.489v1.021c0 .713.577 1.29 1.289 1.29h.067c.5 0 .954.301 1.137.766l.065.16c.21.498.098 1.071-.284 1.453a1.29 1.29 0 0 0 0 1.823l.722.722a1.29 1.29 0 0 0 1.823 0 1.324 1.324 0 0 1 1.453-.284l.16.065c.466.183.766.637.766 1.137v.067c0 .712.577 1.289 1.289 1.289h1.021c.712 0 1.289-.577 1.289-1.289v-.067c0-.5.301-.954.766-1.137l.16-.065a1.332 1.332 0 0 1 1.457.285Z", stroke: e.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, OU = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: RU
}), TU = function(e) {
  var t = te(e.size);
  return S("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2a.73.73 0 0 1 .657.426l2.694 5.722 6.024.923a.74.74 0 0 1 .589.518.783.783 0 0 1-.183.778L17.42 14.82l1.03 6.291a.775.775 0 0 1-.293.745.708.708 0 0 1-.772.055L12 18.943l-5.385 2.968a.708.708 0 0 1-.772-.055.775.775 0 0 1-.292-.745l1.03-6.291-4.362-4.453a.783.783 0 0 1-.183-.778.74.74 0 0 1 .59-.518l6.022-.923 2.695-5.722A.73.73 0 0 1 12 2Zm0 2.491L9.793 9.178a.735.735 0 0 1-.55.418l-4.948.758 3.583 3.658a.78.78 0 0 1 .21.671l-.845 5.16 4.414-2.434a.707.707 0 0 1 .686 0l4.414 2.434-.844-5.16a.78.78 0 0 1 .209-.67l3.583-3.659-4.948-.758a.734.734 0 0 1-.55-.418L12 4.49Z", fill: "currentColor" }) }));
}, kU = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: TU
}), MU = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3.538a8.462 8.462 0 1 0 0 16.924 8.462 8.462 0 0 0 0-16.924ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.12 8.998c.3.3.3.787 0 1.087l-4.89 4.89a.77.77 0 0 1-1.198.14L7.809 12.89a.769.769 0 1 1 1.087-1.087l1.665 1.665 4.47-4.471c.301-.3.788-.3 1.088 0Z", fill: "currentColor" })] }));
}, PU = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: MU
}), DU = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 10.62a.25.25 0 0 0-.25.25v5c0 .138.112.25.25.25h1c.69 0 1.25-.56 1.25-1.25v-3c0-.69-.56-1.25-1.25-1.25h-1Zm-1.75.25c0-.966.784-1.75 1.75-1.75h1a2.75 2.75 0 0 1 2.75 2.75v3A2.75 2.75 0 0 1 19 17.62h-1a1.75 1.75 0 0 1-1.75-1.75v-5ZM5 10.62c-.69 0-1.25.56-1.25 1.25v3c0 .69.56 1.25 1.25 1.25h1a.25.25 0 0 0 .25-.25v-5a.25.25 0 0 0-.25-.25H5Zm-2.75 1.25A2.75 2.75 0 0 1 5 9.12h1c.966 0 1.75.784 1.75 1.75v5A1.75 1.75 0 0 1 6 17.62H5a2.75 2.75 0 0 1-2.75-2.75v-3Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.75 9.37a7.25 7.25 0 1 1 14.5 0v.5a.75.75 0 0 1-1.5 0v-.5a5.75 5.75 0 1 0-11.5 0v.5a.75.75 0 0 1-1.5 0v-.5ZM11.375 19.37a.5.5 0 0 0 0 1h1.25a.5.5 0 0 0 0-1h-1.25Zm-2 .5a2 2 0 0 1 2-2h1.25a2 2 0 0 1 0 4h-1.25a2 2 0 0 1-2-2Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 16.12a.75.75 0 0 1 .75.75v1A2.75 2.75 0 0 1 16 20.62h-2.125a.75.75 0 0 1 0-1.5H16c.69 0 1.25-.56 1.25-1.25v-1a.75.75 0 0 1 .75-.75Z", fill: "currentColor" })] }));
}, LU = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: DU
}), NU = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.754 3.5a8.254 8.254 0 0 0 0 16.508.75.75 0 1 1 0 1.5C6.367 21.508 2 17.14 2 11.754S6.367 2 11.754 2s9.754 4.367 9.754 9.754a.75.75 0 1 1-1.5 0A8.254 8.254 0 0 0 11.754 3.5Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.513 8.752a.75.75 0 0 1 .75-.75h16.981a.75.75 0 0 1 0 1.5H3.264a.75.75 0 0 1-.75-.75ZM2.514 14.755a.75.75 0 0 1 .75-.75h8.49a.75.75 0 1 1 0 1.5h-8.49a.75.75 0 0 1-.75-.75Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.273 3.433a2.865 2.865 0 0 1 4.962-.001 16.234 16.234 0 0 1 2.27 8.324.75.75 0 1 1-1.5-.004 14.733 14.733 0 0 0-2.063-7.559l-.005-.008a1.366 1.366 0 0 0-2.366 0l-.004.007a14.885 14.885 0 0 0 0 15.125l.003.005c.245.424.697.685 1.187.687a.75.75 0 0 1-.004 1.5 2.876 2.876 0 0 1-2.48-1.432 16.385 16.385 0 0 1 0-16.644Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.756 14.505a3.252 3.252 0 1 0 0 6.503 3.252 3.252 0 0 0 0-6.503Zm0-1.5a4.752 4.752 0 1 0 0 9.503 4.752 4.752 0 0 0 0-9.503Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.294 15.799c.345 0 .624.279.624.623v1.488h1.129a.624.624 0 1 1 0 1.247h-1.753a.624.624 0 0 1-.623-.623v-2.111c0-.345.279-.624.623-.624Z", fill: "currentColor" })] }));
}, xU = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: NU
}), VU = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.818 5.077c.427 0 .773.344.773.77v13.076c0 .859.68 1.539 1.526 1.539h7.727c.862 0 1.565-.697 1.565-1.539V5.846c0-.425.346-.77.773-.77a.77.77 0 0 1 .773.77v13.077c0 1.708-1.413 3.077-3.11 3.077H8.116a3.067 3.067 0 0 1-3.072-3.077V5.846c0-.425.346-.77.773-.77Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.5 5.846c0-.425.346-.77.773-.77h15.454c.427 0 .773.345.773.77 0 .425-.346.77-.773.77H4.273a.771.771 0 0 1-.773-.77ZM9.167 2.77c0-.426.346-.77.772-.77h4.122a.77.77 0 0 1 .772.77.77.77 0 0 1-.772.768H9.939a.771.771 0 0 1-.772-.769ZM14.06 9.18a.77.77 0 0 1 .773.769v7.18a.77.77 0 0 1-.772.768.77.77 0 0 1-.773-.769v-7.18a.77.77 0 0 1 .773-.769ZM9.94 9.18a.77.77 0 0 1 .772.769v7.18a.77.77 0 0 1-.773.768.771.771 0 0 1-.772-.769v-7.18c0-.424.346-.769.772-.769Z", fill: "currentColor" })] }));
}, jU = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: VU
}), UU = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.839 10.718c-.713 0-1.29.573-1.29 1.282v7.18c0 .708.577 1.282 1.29 1.282H17.16c.713 0 1.29-.574 1.29-1.282V12c0-.709-.577-1.282-1.29-1.282H6.84ZM4 12a2.83 2.83 0 0 1 2.839-2.82H17.16A2.83 2.83 0 0 1 20 12v7.18A2.83 2.83 0 0 1 17.161 22H6.84A2.83 2.83 0 0 1 4 19.18V12ZM7.259 5.681A4.89 4.89 0 0 1 12 2c2.708 0 4.903 2.181 4.903 4.872 0 .425-.346.769-.774.769a.772.772 0 0 1-.774-.77c0-1.84-1.502-3.333-3.355-3.333a3.343 3.343 0 0 0-3.24 2.52.775.775 0 0 1-1.501-.377Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.129 6.103c.428 0 .774.344.774.769v3.077c0 .425-.346.769-.774.769a.772.772 0 0 1-.774-.77V6.873c0-.425.346-.77.774-.77Z", fill: "currentColor" })] }));
}, BU = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: UU
}), $U = function(e) {
  var t = te(e.size);
  return S("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2.25a.75.75 0 0 1 .75.75v12.19l3.72-3.72a.75.75 0 0 1 1.06 1.06l-5 5.001a.75.75 0 0 1-1.061 0l-5-5a.75.75 0 0 1 1.06-1.061l3.721 3.721V3a.75.75 0 0 1 .75-.75ZM3.25 21a.75.75 0 0 1 .75-.75h16a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75Z", fill: "currentColor" }) }));
}, HU = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: $U
}), FU = function(e) {
  var t = te(e.size);
  return S("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.348 16.472c-2.082 0-3.806 1.625-3.806 3.765A.767.767 0 0 1 4.77 21 .767.767 0 0 1 4 20.237c0-3.005 2.437-5.29 5.348-5.29h5.304c3.038 0 5.348 2.41 5.348 5.29a.767.767 0 0 1-.771.763.767.767 0 0 1-.77-.763c0-2.06-1.643-3.765-3.807-3.765H9.348ZM14.63 5.56a3.774 3.774 0 0 0-5.164.009c-1.41 1.313-1.378 3.599.034 5.083 1.327 1.396 3.638 1.364 5.138-.033 1.429-1.33 1.456-3.6-.009-5.058Zm1.074-1.118a5.346 5.346 0 0 0-7.307.003c-2.126 1.98-1.95 5.25-.034 7.265 2.001 2.103 5.308 1.93 7.344.033 2.104-1.959 2.08-5.238.02-7.28a.778.778 0 0 0-.011-.01l-.012-.011Z", fill: "currentColor" }) }));
}, zU = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: FU
}), WU = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3.538A8.461 8.461 0 0 0 3.538 12 8.46 8.46 0 0 0 12 20.462 8.46 8.46 0 0 0 20.462 12 8.46 8.46 0 0 0 12 3.538ZM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 6.615a.77.77 0 0 1 .77.77v5.128a.77.77 0 1 1-1.54 0V7.385a.77.77 0 0 1 .77-.77ZM10.974 16.362a1.026 1.026 0 1 1 2.05-.005 1.026 1.026 0 0 1-2.05.005Z", fill: "currentColor" })] }));
}, ZU = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: WU
}), GU = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.876 19.627a1.125 1.125 0 1 1 2.247-.003 1.125 1.125 0 0 1-2.247.003Zm.473-.003-.473-.003v.006M18.901 12.553c-3.805-3.49-9.998-3.49-13.803 0a.75.75 0 1 1-1.014-1.106c4.38-4.016 11.452-4.016 15.831 0a.75.75 0 1 1-1.014 1.106Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.91 8.366c-5.463-4.821-14.356-4.821-19.82 0a.75.75 0 0 1-.992-1.124c6.03-5.323 15.774-5.323 21.805 0a.75.75 0 1 1-.993 1.124ZM15.891 16.353a5.526 5.526 0 0 0-7.783 0 .75.75 0 1 1-1.058-1.064 7.026 7.026 0 0 1 9.9 0 .75.75 0 0 1-1.059 1.064Z", fill: "currentColor" })] }));
}, qU = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: GU
}), KU = function(e) {
  var t = te(e.size);
  return ie("svg", q({ width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [S("path", { d: "M18.5027 12C18.5027 12.2763 18.2788 12.5002 18.0025 12.5002C17.7263 12.5002 17.5023 12.2763 17.5023 12C17.5023 11.7237 17.7263 11.4998 18.0025 11.4998C18.2788 11.4998 18.5027 11.7237 18.5027 12", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M12.5002 12C12.5002 12.2763 12.2762 12.5002 12 12.5002C11.7237 12.5002 11.4998 12.2763 11.4998 12C11.4998 11.7237 11.7237 11.4998 12 11.4998C12.2762 11.4998 12.5002 11.7237 12.5002 12", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M6.49773 12C6.49773 12.2763 6.27378 12.5002 5.99752 12.5002C5.72127 12.5002 5.49731 12.2763 5.49731 12C5.49731 11.7237 5.72127 11.4998 5.99752 11.4998C6.27378 11.4998 6.49773 11.7237 6.49773 12", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, JU = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: KU
}), QU = function(e) {
  var t = te(e.size);
  return ie("svg", q({ width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { d: "M12 8V16", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M16 12H8", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 21V21C7.029 21 3 16.971 3 12V12C3 7.029 7.029 3 12 3V3C16.971 3 21 7.029 21 12V12C21 16.971 16.971 21 12 21Z", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, YU = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: QU
}), XU = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.2621 10.0539C19.765 9.55675 18.959 9.55675 18.4618 10.0539C17.9647 10.551 17.9647 11.357 18.4618 11.8542C18.959 12.3513 19.765 12.3513 20.2621 11.8542C20.7593 11.357 20.7593 10.551 20.2621 10.0539ZM21.3219 8.99237C20.2389 7.9103 18.4838 7.91059 17.4012 8.99322C16.3183 10.0761 16.3183 11.8319 17.4012 12.9148C18.4841 13.9978 20.2399 13.9978 21.3228 12.9148C22.4057 11.8319 22.4057 10.0761 21.3228 8.99322L21.3219 8.99237Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.949 15.4041C18.949 14.9898 19.2848 14.6541 19.699 14.6541H20.5C22.2952 14.6541 23.75 16.1088 23.75 17.9041V19.0001C23.75 19.4143 23.4142 19.7501 23 19.7501C22.5858 19.7501 22.25 19.4143 22.25 19.0001V17.9041C22.25 16.9373 21.4668 16.1541 20.5 16.1541H19.699C19.2848 16.1541 18.949 15.8183 18.949 15.4041Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.53813 10.0539C5.041 9.55675 4.23498 9.55675 3.73784 10.0539C3.24071 10.551 3.24071 11.357 3.73784 11.8542C4.23498 12.3513 5.041 12.3513 5.53813 11.8542C6.03527 11.357 6.03527 10.551 5.53813 10.0539ZM6.59794 8.99237C5.51494 7.9103 3.75982 7.91059 2.67718 8.99322C1.59426 10.0761 1.59426 11.8319 2.67718 12.9148C3.76011 13.9978 5.51587 13.9978 6.59879 12.9148C7.68172 11.8319 7.68172 10.0761 6.59879 8.99322L6.59794 8.99237Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.5 16.1541C2.53321 16.1541 1.75 16.9373 1.75 17.9041V19.0001C1.75 19.4143 1.41421 19.7501 1 19.7501C0.585786 19.7501 0.25 19.4143 0.25 19.0001V17.9041C0.25 16.1088 1.70479 14.6541 3.5 14.6541H4.301C4.71521 14.6541 5.051 14.9898 5.051 15.4041C5.051 15.8183 4.71521 16.1541 4.301 16.1541H3.5Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.6723 6.44269C12.7487 5.5191 11.2513 5.5191 10.3277 6.44269C9.40411 7.36629 9.40411 8.86372 10.3277 9.78731C11.2513 10.7109 12.7487 10.7109 13.6723 9.78731C14.5959 8.86371 14.5959 7.36628 13.6723 6.44269ZM14.7326 5.38165C13.2232 3.87266 10.7763 3.87278 9.26704 5.38203C7.75767 6.89141 7.75766 9.3386 9.26704 10.848C10.7764 12.3573 13.2236 12.3573 14.733 10.848C16.2423 9.33859 16.242 6.89103 14.7326 5.38165Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.91003 17.399C5.91003 15.0518 7.81282 13.149 10.16 13.149H13.839C16.1862 13.149 18.089 15.0518 18.089 17.399V19C18.089 19.4143 17.7532 19.75 17.339 19.75C16.9248 19.75 16.589 19.4143 16.589 19V17.399C16.589 15.8803 15.3578 14.649 13.839 14.649H10.16C8.64125 14.649 7.41003 15.8803 7.41003 17.399V19C7.41003 19.4143 7.07425 19.75 6.66003 19.75C6.24582 19.75 5.91003 19.4143 5.91003 19V17.399Z", fill: "currentColor" })] }));
}, eB = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: XU
}), tB = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 16 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.662 4.338v5.147a2.34 2.34 0 0 0 4.676 0V4.338a2.34 2.34 0 0 0-4.676 0ZM8 .5a3.839 3.839 0 0 0-3.838 3.838v5.147a3.839 3.839 0 0 0 7.676 0V4.338A3.84 3.84 0 0 0 8 .5Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 8.9a.75.75 0 0 1 .75.75 6.25 6.25 0 1 0 12.5 0 .75.75 0 0 1 1.5 0 7.75 7.75 0 1 1-15.5 0A.75.75 0 0 1 1 8.9Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 15.9a.75.75 0 0 1 .75.75v2.1a.75.75 0 1 1-1.5 0v-2.1A.75.75 0 0 1 8 15.9Z", fill: "currentColor" })] }));
}, rB = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: tB
}), nB = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.81 2.886a.75.75 0 0 1 1.044.184l11.9 17a.75.75 0 1 1-1.228.86l-11.9-17a.75.75 0 0 1 .184-1.044Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 7.75a.75.75 0 0 1 .75.75v7a1.5 1.5 0 0 0 1.5 1.5h7.962a.75.75 0 0 1 0 1.5H5.25a3 3 0 0 1-3-3v-7A.75.75 0 0 1 3 7.75ZM4.412 6.25a.75.75 0 0 1 .75-.75h7.963a3 3 0 0 1 3 3v7a.75.75 0 0 1-1.5 0v-7a1.5 1.5 0 0 0-1.5-1.5H5.162a.75.75 0 0 1-.75-.75Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.7 7.265c1.227-.988 3.05-.114 3.05 1.46v6.55c0 1.575-1.823 2.449-3.05 1.46l-3.795-3.054a.75.75 0 1 1 .94-1.168l3.795 3.054c.245.197.61.024.61-.292v-6.55a.374.374 0 0 0-.61-.292l-3.795 3.054a.75.75 0 0 1-.94-1.168L18.7 7.265Z", fill: "currentColor" })] }));
}, oB = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: nB
}), iB = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 22 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.633 1.625c-.898 0-1.625.727-1.625 1.625v7.583c0 .898.727 1.625 1.625 1.625h8.532c.897 0 1.625-.727 1.625-1.625V3.25c0-.898-.728-1.625-1.625-1.625H3.633ZM.383 3.25A3.25 3.25 0 0 1 3.633 0h8.532a3.25 3.25 0 0 1 3.25 3.25v7.583a3.25 3.25 0 0 1-3.25 3.25H3.633a3.25 3.25 0 0 1-3.25-3.25V3.25Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.204 1.912c1.33-1.07 3.304-.124 3.304 1.582v7.096c0 1.705-1.975 2.652-3.305 1.581l-4.11-3.308a.812.812 0 1 1 1.018-1.266l4.112 3.309c.265.213.66.025.66-.316V3.494a.406.406 0 0 0-.66-.317l-4.112 3.31a.812.812 0 1 1-1.018-1.267l4.11-3.308Z", fill: "currentColor" })] }));
}, sB = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: iB
}), aB = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.073 1.375c0-.397.322-.719.719-.719h3.833c.397 0 .719.322.719.72v3.832a.719.719 0 0 1-1.438 0V2.094h-3.114a.719.719 0 0 1-.72-.719Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.133.867c.28.28.28.736 0 1.016l-5.75 5.75a.719.719 0 1 1-1.016-1.016l5.75-5.75a.719.719 0 0 1 1.016 0ZM1.375 14.073c.397 0 .719.322.719.719v3.114h3.114a.719.719 0 1 1 0 1.438H1.375a.719.719 0 0 1-.719-.719v-3.833c0-.397.322-.719.719-.719Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.633 12.367c.28.28.28.736 0 1.016l-5.75 5.75a.719.719 0 1 1-1.016-1.016l5.75-5.75a.719.719 0 0 1 1.016 0ZM4.25 3.052c-.662 0-1.198.536-1.198 1.198v4.792a.719.719 0 1 1-1.437 0V4.25A2.635 2.635 0 0 1 4.25 1.615h4.792a.719.719 0 1 1 0 1.437H4.25ZM17.667 10.24c.397 0 .718.321.718.718v4.792a2.635 2.635 0 0 1-2.635 2.636H10a.719.719 0 0 1 0-1.438h5.75c.662 0 1.198-.536 1.198-1.198v-4.792c0-.397.322-.718.719-.718Z", fill: "currentColor" })] }));
}, lB = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: aB
}), uB = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.5 11.25a.75.75 0 0 1 .75.75A2.751 2.751 0 0 0 12 14.752a.75.75 0 0 1 0 1.5A4.251 4.251 0 0 1 7.75 12a.75.75 0 0 1 .75-.75ZM8.5 8.75a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.5 7.75a.75.75 0 0 1 .75.75V12a.75.75 0 1 1-1.5 0V8.5a.75.75 0 0 1 .75-.75Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.498 10.75a.75.75 0 0 1 .749.75 6.744 6.744 0 0 0 11.29 4.99.75.75 0 0 1 1.012 1.107A8.244 8.244 0 0 1 3.747 11.5a.75.75 0 0 1 .75-.75Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 18.253a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75ZM3.466 3.466a.75.75 0 0 1 1.061 0l16.007 16.007a.75.75 0 0 1-1.061 1.06L3.466 4.528a.75.75 0 0 1 0-1.06ZM8.238 4.566A4.236 4.236 0 0 1 16.252 6.5V11a.75.75 0 0 1-1.5 0V6.495a2.736 2.736 0 0 0-5.176-1.25.75.75 0 1 1-1.338-.678ZM19.505 10.75a.75.75 0 0 1 .748.752 8.159 8.159 0 0 1-.835 3.572.75.75 0 1 1-1.346-.661 6.658 6.658 0 0 0 .681-2.915.75.75 0 0 1 .752-.748Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.006 13.945a.75.75 0 0 1 .001 1.061 4.238 4.238 0 0 1-3.006 1.245.75.75 0 0 1 0-1.5c.729.001 1.43-.288 1.944-.804a.75.75 0 0 1 1.061-.002Z", fill: "currentColor" })] }));
}, dB = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: uB
}), cB = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 16 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.662 4.338v5.147a2.34 2.34 0 0 0 4.676 0V4.338a2.34 2.34 0 0 0-4.676 0ZM8 .5a3.839 3.839 0 0 0-3.838 3.838v5.147a3.839 3.839 0 0 0 7.676 0V4.338A3.84 3.84 0 0 0 8 .5Z", fill: e.color }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 8.9a.75.75 0 0 1 .75.75 6.25 6.25 0 1 0 12.5 0 .75.75 0 0 1 1.5 0 7.75 7.75 0 1 1-15.5 0A.75.75 0 0 1 1 8.9Z", fill: e.color }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 15.9a.75.75 0 0 1 .75.75v2.1a.75.75 0 1 1-1.5 0v-2.1A.75.75 0 0 1 8 15.9Z", fill: e.color })] }));
}, pB = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: cB
}), hB = function(e) {
  var t = te(e.size);
  return S("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.246 2.996a.75.75 0 0 1 .75-.75h4.002a.75.75 0 1 1 0 1.5H3.746v3.252a.75.75 0 0 1-1.5 0V2.996Zm8.004 2A2.75 2.75 0 0 1 13 2.246h6.004a2.75 2.75 0 0 1 2.75 2.75V11a2.75 2.75 0 0 1-2.75 2.75H13A2.75 2.75 0 0 1 10.25 11V4.996ZM13 3.746c-.69 0-1.25.56-1.25 1.25V11c0 .69.56 1.25 1.25 1.25h6.004c.69 0 1.25-.56 1.25-1.25V4.996c0-.69-.56-1.25-1.25-1.25H13ZM8.529 15.471a.75.75 0 0 1 0 1.06l-3.722 3.723h2.191a.75.75 0 0 1 0 1.5H2.996a.75.75 0 0 1-.75-.75v-4.002a.75.75 0 0 1 1.5 0v2.19l3.722-3.72a.75.75 0 0 1 1.06 0Zm12.475.78a.75.75 0 0 1 .75.75v4.003a.75.75 0 0 1-.75.75h-4.002a.75.75 0 0 1 0-1.5h3.252v-3.252a.75.75 0 0 1 .75-.75Z", fill: "currentColor" }) }));
}, fB = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: hB
}), vB = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.283 14c0-.966.783-1.75 1.75-1.75H20c.966 0 1.75.784 1.75 1.75v6A1.75 1.75 0 0 1 20 21.75h-8.969A1.75 1.75 0 0 1 9.283 20v-6Zm1.75-.25a.25.25 0 0 0-.25.25v6c0 .139.111.25.25.25H20a.25.25 0 0 0 .25-.25v-6a.25.25 0 0 0-.25-.25h-8.969ZM5.47 6.47a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1-1.06 1.06l-3-3a.75.75 0 0 1 0-1.06Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 6.538a.75.75 0 0 1 .75.75V10a.75.75 0 0 1-.75.75H6.29a.75.75 0 1 1 0-1.5H8.25V7.288a.75.75 0 0 1 .75-.75Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 4.75c-.69 0-1.25.56-1.25 1.25v7c0 .69.56 1.25 1.25 1.25h2a.75.75 0 1 1 0 1.5H5A2.75 2.75 0 0 1 2.252 13V6a2.75 2.75 0 0 1 2.75-2.75h11A2.75 2.75 0 0 1 18.75 6v4a.75.75 0 0 1-1.5 0V6c0-.69-.56-1.25-1.25-1.25H5Z", fill: "currentColor" })] }));
}, mB = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: vB
}), gB = function(e) {
  var t = te(e.size);
  return S("svg", q({}, e, { width: t, height: t, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: S("path", { clipRule: "evenodd", d: "M11.19 11.192a13.162 13.162 0 0 0 2.749-3.968.78.78 0 0 0-.173-.862l-.853-.852c-.7-.699-.7-1.687-.089-2.298l1.223-1.222a2.083 2.083 0 0 1 2.946 0l.68.679c.771.772 1.093 1.885.885 2.99-.515 2.721-2.096 5.701-4.647 8.253-2.551 2.55-5.532 4.132-8.253 4.646-1.105.209-2.218-.113-2.99-.885l-.678-.678a2.083 2.083 0 0 1 0-2.946l1.222-1.222c.61-.61 1.6-.61 2.209 0l.94.942a.78.78 0 0 0 .862.173c1.385-.612 2.75-1.532 3.968-2.75Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}, yB = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: gB
}), SB = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.424 4.053a.75.75 0 0 1 .75.75v2.893a.75.75 0 0 1-.75.75h-2.893a.75.75 0 0 1 0-1.5h2.143V4.803a.75.75 0 0 1 .75-.75Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 12c0-5.384 4.365-9.75 9.75-9.75a9.747 9.747 0 0 1 8.563 5.087.75.75 0 0 1-1.316.718A8.25 8.25 0 1 0 20.25 12a.75.75 0 0 1 1.5 0c0 5.384-4.365 9.75-9.75 9.75S2.25 17.384 2.25 12Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.945 10.055a2.75 2.75 0 1 0-3.89 3.89 2.75 2.75 0 0 0 3.89-3.89Zm1.06-1.06a4.25 4.25 0 1 0-6.01 6.01 4.25 4.25 0 0 0 6.01-6.01Z", fill: "currentColor" })] }));
}, bB = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: SB
}), CB = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 5.12A2.75 2.75 0 0 1 5 2.37h5a.75.75 0 0 1 0 1.5H5c-.69 0-1.25.56-1.25 1.25v14c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25v-6.125a.75.75 0 1 1 1.5 0v6.125A2.75 2.75 0 0 1 19 21.87H5a2.75 2.75 0 0 1-2.75-2.75v-14Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.25 8.372a3.751 3.751 0 0 1 3.752-3.75h5.002a.75.75 0 0 1 0 1.5h-5.002a2.251 2.251 0 0 0-2.252 2.25v2.501a.75.75 0 0 1-1.5 0v-2.5Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.972 2.34a.75.75 0 0 1 1.061 0l2.501 2.5a.75.75 0 0 1 0 1.061l-2.501 2.502a.75.75 0 1 1-1.06-1.061l1.97-1.97-1.97-1.972a.75.75 0 0 1 0-1.06Z", fill: "currentColor" })] }));
}, wB = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: CB
}), EB = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { d: "M17 5.317a20.42 20.42 0 0 1 2.956-.3A1.005 1.005 0 0 1 21 6.016v11.837c0 .542-.433.99-.974.998-3.092.047-5.42.617-8.026 2.149-2.606-1.532-4.934-2.102-8.026-2.148A.996.996 0 0 1 3 17.853V6.016a.995.995 0 0 1 1.017-1c3.071.099 5.389.677 7.983 2.13", stroke: e.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { clipRule: "evenodd", d: "M17 15.238V3.012c0-.729-.766-1.238-1.417-.911-1.756.88-3.236 2.669-3.583 4.511V21c.396-2.099 2.261-4.129 4.331-4.824a.987.987 0 0 0 .669-.938Z", stroke: e.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, IB = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: EB
}), AB = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { d: "M3 8h18M11 5.495l-.005.005.005.005.005-.005L11 5.495M8.5 5.495l-.005.005.005.005.005-.005-.005-.005M6 5.495l-.005.005.005.005.005-.005L6 5.495", stroke: e.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M9 20H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v5", stroke: e.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { clipRule: "evenodd", d: "M22 17v0a5 5 0 0 1-5 5v0a5 5 0 0 1-5-5v0a5 5 0 0 1 5-5v0a5 5 0 0 1 5 5v0Z", stroke: e.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { clipRule: "evenodd", d: "M15.586 18.498v-2.995a.496.496 0 0 1 .749-.432l2.507 1.498a.504.504 0 0 1 0 .863l-2.507 1.498a.496.496 0 0 1-.749-.431v0Z", stroke: e.color, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, _B = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: AB
}), RB = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.194 15.334a.194.194 0 0 0-.194.194v3.778c0 .107.087.194.194.194h4.723a.75.75 0 0 1 0 1.5H4.194c-.937 0-1.694-.76-1.694-1.694v-3.778c0-.937.76-1.694 1.694-1.694h4.722a.75.75 0 0 1 0 1.5H4.194ZM13.833 4.194c0-.935.759-1.694 1.694-1.694h3.778c.935 0 1.694.757 1.694 1.694v15.112c0 .935-.757 1.694-1.694 1.694h-4.722a.75.75 0 0 1-.75-.75V4.194Zm1.5 0V19.5h3.972a.194.194 0 0 0 .194-.194V4.194A.194.194 0 0 0 19.305 4h-3.778a.194.194 0 0 0-.194.194Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.86 9.667a.194.194 0 0 0-.194.194V19.5h4.917a.75.75 0 0 1 0 1.5H8.917a.75.75 0 0 1-.751-.75V9.861c0-.937.76-1.694 1.694-1.694h4.722a.75.75 0 0 1 0 1.5H9.86Z", fill: "currentColor" })] }));
}, OB = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: RB
}), TB = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 3.75c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h3c.219 0 .416.094.553.243l3.446 3.446 3.47-3.47A.75.75 0 0 1 16 16.25h3c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25H5Zm7.553 17.757a.75.75 0 0 1-1.083.024L7.688 17.75H5A2.75 2.75 0 0 1 2.25 15V5A2.75 2.75 0 0 1 5 2.25h14A2.75 2.75 0 0 1 21.75 5v10A2.75 2.75 0 0 1 19 17.75h-2.69l-3.757 3.757Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.25 12a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75ZM7.25 8A.75.75 0 0 1 8 7.25h8a.75.75 0 0 1 0 1.5H8A.75.75 0 0 1 7.25 8Z", fill: "currentColor" })] }));
}, kB = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: TB
}), MB = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.167 12.321c.29.293.29.768 0 1.06l-2.768 2.792a.74.74 0 0 1-1.051.001l-1.665-1.673a.755.755 0 0 1-.002-1.06.74.74 0 0 1 1.052-.002l1.139 1.144 2.243-2.262a.74.74 0 0 1 1.052 0ZM9.946 3.555 8.843 4.939v.72c0 .134.109.243.243.243h5.828c.134 0 .243-.11.243-.244V4.94l-1.102-1.384a.244.244 0 0 0-.19-.092h-3.73a.244.244 0 0 0-.19.092Zm5.94 1.128.569-.457-1.262-1.586A1.698 1.698 0 0 0 13.864 2h-3.73c-.516 0-1.004.235-1.326.64L7.545 4.226a.733.733 0 0 0-.16.46v-.003h.73v.731a.728.728 0 0 1-.73-.728v.972c0 .943.762 1.708 1.7 1.708h5.83c.938 0 1.7-.765 1.7-1.708v-.975h-.73Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.5 6.634A2.677 2.677 0 0 1 6.171 3.95h1.943a.73.73 0 0 1 .729.732.73.73 0 0 1-.729.731H6.171c-.67 0-1.214.546-1.214 1.22v12.683c0 .674.543 1.22 1.214 1.22H17.83c.67 0 1.214-.546 1.214-1.22V6.634c0-.674-.543-1.22-1.214-1.22h-1.943a.73.73 0 0 1-.729-.731.73.73 0 0 1 .729-.732h1.943c1.475 0 2.671 1.2 2.671 2.683v12.683A2.677 2.677 0 0 1 17.829 22H6.17A2.677 2.677 0 0 1 3.5 19.317V6.634Z", fill: "currentColor" })] }));
}, PB = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: MB
}), DB = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.946 3.555 8.843 4.94v.719c0 .134.109.243.243.243h5.828c.134 0 .243-.109.243-.243v-.72l-1.102-1.384a.244.244 0 0 0-.19-.092h-3.73a.244.244 0 0 0-.19.092Zm5.94 1.128.569-.457-1.262-1.585V2.64A1.698 1.698 0 0 0 13.864 2h-3.73c-.516 0-1.004.236-1.326.64L7.545 4.226a.733.733 0 0 0-.16.46v-.003h.73v.732a.728.728 0 0 1-.73-.729v.973c0 .942.762 1.707 1.7 1.707h5.83c.938 0 1.7-.765 1.7-1.707v-.976h-.73Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.5 6.634a2.677 2.677 0 0 1 2.671-2.683h1.943a.73.73 0 0 1 .729.732.73.73 0 0 1-.729.732H6.171c-.67 0-1.214.545-1.214 1.22v12.682c0 .674.543 1.22 1.214 1.22H17.83c.67 0 1.214-.546 1.214-1.22V6.634c0-.674-.543-1.22-1.214-1.22h-1.943a.73.73 0 0 1-.729-.731.73.73 0 0 1 .729-.732h1.943c1.475 0 2.671 1.201 2.671 2.683v12.683A2.677 2.677 0 0 1 17.829 22H6.17A2.677 2.677 0 0 1 3.5 19.317V6.634Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.386 11.512a.73.73 0 0 1 .728-.732h7.772a.73.73 0 0 1 .728.732.73.73 0 0 1-.728.732H8.114a.73.73 0 0 1-.728-.732ZM7.386 16.39a.73.73 0 0 1 .728-.732h7.772a.73.73 0 0 1 .728.732.73.73 0 0 1-.728.732H8.114a.73.73 0 0 1-.728-.732Z", fill: "currentColor" })] }));
}, LB = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: DB
}), NB = function(e) {
  var t = te(e.size);
  return S("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: S("path", { d: "M3 9h18M9.57 13H7m11 6H6a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }) }));
}, xB = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: NB
}), VB = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.128 3.962a3.167 3.167 0 0 0-3.166 3.166v9.744a3.167 3.167 0 0 0 3.166 3.166h9.744a3.167 3.167 0 0 0 3.166-3.166V7.128a3.167 3.167 0 0 0-3.166-3.166H7.128ZM2.5 7.128A4.628 4.628 0 0 1 7.128 2.5h9.744A4.628 4.628 0 0 1 21.5 7.128v9.744a4.628 4.628 0 0 1-4.628 4.628H7.128A4.628 4.628 0 0 1 2.5 16.872V7.128Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m11.124 8.615 2.825 5.648 1.16-2.32a1.219 1.219 0 0 1 1.09-.674h4.57a.73.73 0 0 1 0 1.462h-4.42l-1.31 2.62c-.45.9-1.731.9-2.18.001l-2.833-5.664L8.73 12.09v.002a1.22 1.22 0 0 1-1.072.638H3.231a.73.73 0 0 1 0-1.462h4.282l1.45-2.688a1.218 1.218 0 0 1 2.16.034Zm-.875.66Zm-.432-.007ZM13.73 14.7Z", fill: "currentColor" })] }));
}, jB = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: VB
}), UB = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.783 7.398a3.751 3.751 0 0 1 1.677-.396h1.293a.75.75 0 1 1 0 1.5H6.46c-.35 0-.694.081-1.006.238l-.586.292a2.25 2.25 0 0 0-.924.856l-1.55 2.585a.75.75 0 1 1-1.287-.772l1.551-2.585c.367-.612.901-1.106 1.54-1.425m0 0 .585-.293M17.257 5.001a.75.75 0 0 1 .75.75v3.001a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.006 7.252a.75.75 0 0 1 .75-.75h3.001a.75.75 0 0 1 0 1.5h-3.001a.75.75 0 0 1-.75-.75ZM16.006 12.754a.75.75 0 0 1 .75-.75h2.001a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75ZM14.005 15.755a.75.75 0 0 1 .75-.75h4.002a.75.75 0 0 1 0 1.5h-4.002a.75.75 0 0 1-.75-.75ZM10.414 10.033a2.396 2.396 0 0 1 3.688 3.025l-2.994 4.49A4.751 4.751 0 0 1 8.77 19.38l-5.765 2.083a.75.75 0 0 1-.51-1.41l5.765-2.084a3.252 3.252 0 0 0 1.6-1.254l2.994-4.49a.896.896 0 0 0-1.38-1.131l-2.19 2.19a.75.75 0 0 1-.531.22h-2a.75.75 0 0 1 0-1.5h1.69l1.971-1.97Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.003 4.25A2.25 2.25 0 0 1 9.253 2h11.005a2.25 2.25 0 0 1 2.25 2.25v15.007a2.25 2.25 0 0 1-2.25 2.25H9.253a2.25 2.25 0 0 1-2.25-2.25v-.307a.75.75 0 0 1 1.5 0v.307c0 .414.336.75.75.75h11.005a.75.75 0 0 0 .75-.75V4.25a.75.75 0 0 0-.75-.751H9.253a.75.75 0 0 0-.75.75v8.504a.75.75 0 0 1-1.5 0V4.251Z", fill: "currentColor" })] }));
}, BB = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: UB
}), $B = function(e) {
  var t = te(e.size);
  return S("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.385 8.236a.77.77 0 0 1 .769.77v1.538a.77.77 0 0 1-1.539 0V9.005a.77.77 0 0 1 .77-.77ZM16.615 8.236a.77.77 0 0 1 .77.77v1.538a.77.77 0 0 1-1.539 0V9.005a.77.77 0 0 1 .77-.77ZM12.513 8.253a.77.77 0 0 1 .77.77v3.59c0 .99-.805 1.794-1.796 1.794h-.513a.77.77 0 1 1 0-1.538h.513a.257.257 0 0 0 .257-.257v-3.59a.77.77 0 0 1 .769-.769ZM8.132 15.72c.3-.3.787-.3 1.088 0a3.933 3.933 0 0 0 5.561 0 .77.77 0 0 1 1.088 1.088 5.471 5.471 0 0 1-7.737 0 .77.77 0 0 1 0-1.088ZM2 4.82A2.82 2.82 0 0 1 4.82 2h2.655a.77.77 0 1 1 0 1.538H4.82c-.709 0-1.283.574-1.283 1.283v2.654a.77.77 0 1 1-1.538 0V4.82ZM21.23 15.756a.77.77 0 0 1 .77.77v2.654A2.82 2.82 0 0 1 19.18 22h-2.655a.77.77 0 0 1 0-1.538h2.655c.708 0 1.282-.574 1.282-1.282v-2.655a.77.77 0 0 1 .769-.77ZM2.77 15.756a.77.77 0 0 1 .768.77v2.654c0 .708.574 1.282 1.283 1.282h2.654a.77.77 0 0 1 0 1.538H4.82A2.82 2.82 0 0 1 2 19.18v-2.655a.77.77 0 0 1 .77-.77ZM15.756 2.77a.77.77 0 0 1 .77-.77h2.654A2.82 2.82 0 0 1 22 4.82v2.655a.77.77 0 1 1-1.538 0V4.82c0-.709-.574-1.283-1.282-1.283h-2.655a.77.77 0 0 1-.77-.769Z", fill: "currentColor" }) }));
}, HB = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: $B
}), FB = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.246 2.25a.75.75 0 0 1 .749.75v3.998c0 .139.112.25.25.25h3.999a.75.75 0 1 1 0 1.5h-3.999a1.75 1.75 0 0 1-1.749-1.75V3a.75.75 0 0 1 .75-.749ZM10.64 11.429a.75.75 0 0 1 0 1.06l-2.5 2.5a.75.75 0 0 1-1.06 0l-1.5-1.5a.75.75 0 0 1 1.06-1.06l.97.97 1.97-1.97a.75.75 0 0 1 1.06 0Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.5 10.996a3.747 3.747 0 0 1 3.747-3.748h4.001a3.747 3.747 0 0 1 3.748 3.748v4.001a3.747 3.747 0 0 1-3.748 3.747h-4A3.747 3.747 0 0 1 2.5 14.997v-4.001Zm3.747-2.249A2.248 2.248 0 0 0 4 10.996v4.001a2.248 2.248 0 0 0 2.248 2.248h4.001a2.248 2.248 0 0 0 2.249-2.248v-4.001a2.248 2.248 0 0 0-2.249-2.249h-4Z", fill: "currentColor" }), S("path", { d: "M7 5.002c0-.69.56-1.25 1.25-1.25h7.171c.331 0 .649.132.883.366l2.83 2.827c.235.234.367.552.367.884v11.173c0 .69-.56 1.25-1.249 1.25H8.249c-.69 0-1.249-.56-1.249-1.25v-.763H5.501v.763A2.748 2.748 0 0 0 8.25 21.75h10.003A2.748 2.748 0 0 0 21 19.002V7.829c0-.73-.29-1.429-.806-1.944l-2.83-2.828a2.748 2.748 0 0 0-1.943-.803H8.25a2.748 2.748 0 0 0-2.748 2.748v3.244h1.5V5.002Z", fill: "currentColor" })] }));
}, zB = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: FB
}), WB = function(e) {
  var t = te(e.size);
  return S("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.748 2.003h6.922a.758.758 0 0 1 .15 0h.1c.729 0 1.427.289 1.942.804l2.83 2.827c.517.515.807 1.215.807 1.944v11.173A2.748 2.748 0 0 1 17.75 21.5H7.748A2.748 2.748 0 0 1 5 18.751v-.332A3.749 3.749 0 0 1 2 14.746v-4.001A3.749 3.749 0 0 1 5 7.072V4.75a2.748 2.748 0 0 1 2.748-2.748ZM6.5 18.75v-.257h3.248a3.747 3.747 0 0 0 3.748-3.748v-4.001a3.747 3.747 0 0 0-3.748-3.747H6.5V4.75c0-.69.56-1.25 1.25-1.25h6.246v3.247c0 .966.783 1.749 1.75 1.749H19V18.75c0 .69-.56 1.25-1.249 1.25H7.748c-.69 0-1.249-.56-1.249-1.25Zm9.245-11.753h3.113a1.248 1.248 0 0 0-.223-.304l-2.83-2.827a1.25 1.25 0 0 0-.31-.226v3.107c0 .138.112.25.25.25ZM3.498 10.745a2.248 2.248 0 0 1 2.248-2.248h4.001a2.248 2.248 0 0 1 2.249 2.248v4.001a2.248 2.248 0 0 1-2.249 2.249h-4a2.248 2.248 0 0 1-2.25-2.249v-4.001Zm3.574.268a.75.75 0 1 0-1.152.96l.85 1.019-.85 1.019a.75.75 0 0 0 1.152.96l.673-.809.673.808a.75.75 0 0 0 1.152-.96l-.85-1.018.85-1.02a.75.75 0 0 0-1.152-.96l-.673.809-.673-.808Z", fill: "currentColor" }) }));
}, ZB = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: WB
}), GB = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.25 5A2.75 2.75 0 0 1 7 2.25h7.172c.73 0 1.429.29 1.944.806l2.828 2.828a2.75 2.75 0 0 1 .806 1.944V19A2.75 2.75 0 0 1 17 21.75H7A2.75 2.75 0 0 1 4.25 19V5ZM7 3.75c-.69 0-1.25.56-1.25 1.25v14c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V7.828c0-.33-.132-.65-.366-.884l-2.828-2.828a1.25 1.25 0 0 0-.884-.366H7Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 2.25a.75.75 0 0 1 .75.75v4c0 .138.112.25.25.25h4a.75.75 0 0 1 0 1.5h-4A1.75 1.75 0 0 1 13.25 7V3a.75.75 0 0 1 .75-.75ZM7.961 16.432A.755.755 0 1 1 9.029 17.5a.755.755 0 0 1-1.068-1.068ZM7.25 10.995a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75ZM7.25 13.995a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75ZM14.961 16.466a.755.755 0 1 1 1.068 1.069.755.755 0 0 1-1.068-1.069ZM11.466 16.456a.755.755 0 1 1 1.068 1.069.755.755 0 0 1-1.068-1.069Z", fill: "currentColor" })] }));
}, qB = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: GB
}), KB = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.25 5A2.75 2.75 0 0 1 7 2.25h7.172c.73 0 1.429.29 1.944.806l2.828 2.828a2.75 2.75 0 0 1 .806 1.944V19A2.75 2.75 0 0 1 17 21.75H7A2.75 2.75 0 0 1 4.25 19V5ZM7 3.75c-.69 0-1.25.56-1.25 1.25v14c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V7.828c0-.33-.132-.65-.366-.884l-2.828-2.828a1.25 1.25 0 0 0-.884-.366H7Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 2.25a.75.75 0 0 1 .75.75v4c0 .138.112.25.25.25h4a.75.75 0 0 1 0 1.5h-4A1.75 1.75 0 0 1 13.25 7V3a.75.75 0 0 1 .75-.75Z", fill: "currentColor" })] }));
}, JB = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: KB
}), QB = function(e) {
  var t = te(e.size);
  return ie("svg", q({ width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [S("path", { d: "M20.0033 7.99867H16.0016C15.4491 7.99867 15.0012 7.55076 15.0012 6.99825V2.99658", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M5.99744 7.99867V4.99742C5.99744 3.89239 6.89324 2.99658 7.99827 2.99658H15.1733C15.7039 2.99658 16.2127 3.20757 16.5878 3.58283L19.417 6.412C19.7923 6.78715 20.0033 7.29598 20.0033 7.82659V19.0032C20.0033 20.1083 19.1075 21.0041 18.0024 21.0041H7.99827C6.89324 21.0041 5.99744 20.1083 5.99744 19.0032V18.0028", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M6.38866 10.9994C6.46883 11.0787 6.49318 11.1986 6.45031 11.3029C6.40745 11.4072 6.30584 11.4753 6.19308 11.4753C6.08032 11.4753 5.97871 11.4072 5.93584 11.3029C5.89298 11.1986 5.91733 11.0787 5.9975 10.9994C6.10632 10.8915 6.28184 10.8915 6.39066 10.9994", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M13.0004 11.9502C11.4628 11.7149 9.89938 12.1655 8.72294 13.1831C7.54651 14.2007 6.8754 15.683 6.88686 17.2384C6.88843 17.4943 6.90883 17.7498 6.94789 18.0027", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("rect", { x: "2.99622", y: "7.99841", width: "10.0042", height: "10.0042", rx: "3", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, YB = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: QB
}), XB = function(e) {
  var t = te(e.size);
  return ie("svg", q({ width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.414 6.414L15.586 3.586C15.211 3.211 14.702 3 14.172 3H7C5.895 3 5 3.895 5 5V19C5 20.105 5.895 21 7 21H17C18.105 21 19 20.105 19 19V7.828C19 7.298 18.789 6.789 18.414 6.414V6.414Z", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M19 8H15C14.448 8 14 7.552 14 7V3", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M10.34 16.5498H13.66", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.833 12.751V11.583C10.833 11.261 11.094 11 11.416 11H12.584C12.906 11 13.167 11.261 13.167 11.583V12.751C13.167 13.073 12.906 13.334 12.584 13.334H11.416C11.094 13.333 10.833 13.072 10.833 12.751Z", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 17.417V16.249C8 15.927 8.261 15.666 8.583 15.666H9.751C10.073 15.666 10.334 15.927 10.334 16.249V17.417C10.334 17.739 10.073 18 9.751 18H8.583C8.261 18 8 17.739 8 17.417Z", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.667 17.417V16.249C13.667 15.927 13.928 15.666 14.25 15.666H15.418C15.74 15.666 16.001 15.927 16.001 16.249V17.417C16 17.739 15.739 18 15.417 18H14.249C13.928 18 13.667 17.739 13.667 17.417H13.667Z", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M14.24 15.6701L12.73 13.3101", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M9.76001 15.6701L11.27 13.3101", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, e$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: XB
}), t$ = function(e) {
  var t = te(e.size);
  return ie("svg", q({ width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [S("path", { d: "M20.0033 7.99867H16.0016C15.4491 7.99867 15.0012 7.55076 15.0012 6.99825V2.99658", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("rect", { x: "2.99622", y: "7.99841", width: "10.0042", height: "10.0042", rx: "3", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M5.74731 11.2499L6.24752 14.7513H6.57666L7.99825 11.7501L9.41984 14.7513H9.74898L10.2492 11.2499", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M5.99744 7.99867V4.99742C5.99744 3.89239 6.89324 2.99658 7.99827 2.99658H15.1733C15.7039 2.99658 16.2127 3.20757 16.5878 3.58283L19.417 6.412C19.7923 6.78715 20.0033 7.29598 20.0033 7.82659V19.0032C20.0033 20.1083 19.1075 21.0041 18.0024 21.0041H7.99827C6.89324 21.0041 5.99744 20.1083 5.99744 19.0032V18.0028", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, r$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: t$
}), n$ = function(e) {
  var t = te(e.size);
  return ie("svg", q({ width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [S("path", { d: "M20.0034 7.99867H16.0018C15.4492 7.99867 15.0013 7.55076 15.0013 6.99825V2.99658", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M5.99744 7.99867V4.99742C5.99744 3.89239 6.89324 2.99658 7.99827 2.99658H15.1733C15.7039 2.99658 16.2127 3.20757 16.5878 3.58283L19.417 6.412C19.7923 6.78715 20.0033 7.29598 20.0033 7.82659V19.0032C20.0033 20.1083 19.1075 21.0041 18.0024 21.0041H7.99827C6.89324 21.0041 5.99744 20.1083 5.99744 19.0032V18.0028", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M7.99826 12.8151V10.9794", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M7.99811 14.8403C7.97406 14.8403 7.951 14.8499 7.93409 14.8671C7.91717 14.8842 7.90781 14.9073 7.90807 14.9314C7.90808 14.9683 7.93037 15.0015 7.96451 15.0156C7.99865 15.0296 8.03788 15.0216 8.06384 14.9954C8.0898 14.9691 8.09734 14.9298 8.08293 14.8958C8.06852 14.8618 8.03502 14.8399 7.99811 14.8403", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("rect", { x: "2.99658", y: "7.99841", width: "10.0042", height: "10.0042", rx: "3", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, o$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: n$
}), i$ = function(e) {
  var t = te(e.size);
  return ie("svg", q({ width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [S("path", { d: "M5.00012 8V19C5.00012 20.105 5.89512 21 7.00012 21H15.0001", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M19.0001 20.75L5.00012 3.25", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M19 16V7.828C19 7.298 18.789 6.789 18.414 6.414L15.586 3.586C15.211 3.211 14.702 3 14.172 3H9", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M19.0001 8H15.0001C14.4481 8 14.0001 7.552 14.0001 7V3", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, s$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: i$
}), a$ = function(e) {
  var t = te(e.size);
  return ie("svg", q({ width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [S("path", { d: "M14 21H8C5.23858 21 3 18.7614 3 16V8C3 5.23858 5.23858 3 8 3H16C18.7614 3 21 5.23858 21 8V14", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M21 18L18 21", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M18 18L21 21", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.625 12.4996V14.3737C13.625 14.7524 13.411 15.0987 13.0722 15.2681L11.8222 15.8931C11.5123 16.0481 11.1441 16.0315 10.8493 15.8493C10.5545 15.6671 10.375 15.3452 10.375 14.9987V12.4996L8.38921 10.9677C8.14376 10.7784 8 10.4859 8 10.1759V9C8 8.44772 8.44772 8 9 8H15C15.5523 8 16 8.44772 16 9V10.1759C16 10.4859 15.8562 10.7784 15.6108 10.9677L13.625 12.4996Z", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, l$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: a$
}), u$ = function(e) {
  var t = te(e.size);
  return ie("svg", q({ width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [S("path", { d: "M12.0003 12.6588V10.709", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.4167 6.41152L15.5875 3.58234C15.2124 3.20708 14.7036 2.99609 14.173 2.99609H6.99796C5.89293 2.99609 4.99713 3.8919 4.99713 4.99693V19.0028C4.99713 20.1078 5.89293 21.0036 6.99796 21.0036H17.0021C18.1072 21.0036 19.003 20.1078 19.003 19.0028V7.82611C19.003 7.29549 18.792 6.78666 18.4167 6.41152Z", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M11.9997 14.8084C11.9445 14.8084 11.8997 14.8532 11.8997 14.9084C11.8997 14.9637 11.9445 15.0085 11.9997 15.0085C12.0433 14.9966 12.0735 14.9571 12.0735 14.9119C12.0735 14.8668 12.0433 14.8272 11.9997 14.8154", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, d$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: u$
}), c$ = function(e) {
  var t = te(e.size);
  return ie("svg", q({ width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [S("circle", { cx: "12.001", cy: "8.24884", r: "4.25177", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M3.99731 20.0038C3.99731 17.5178 6.01315 15.502 8.49919 15.502H11.0833", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M15.7346 19.7718L19.2721 16.2344", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M15.7346 16.2344L19.2721 19.7718", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, p$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: c$
}), h$ = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.25 6A.75.75 0 0 1 7 5.25h5.875a3.75 3.75 0 1 1 0 7.5H7a.75.75 0 0 1-.75-.75V6Zm1.5.75v4.5h5.125a2.25 2.25 0 0 0 0-4.5H7.75Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.25 12a.75.75 0 0 1 .75-.75h7a3.75 3.75 0 1 1 0 7.5H7a.75.75 0 0 1-.75-.75v-6Zm1.5.75v4.5H14a2.25 2.25 0 0 0 0-4.5H7.75Z", fill: "currentColor" })] }));
}, f$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: h$
}), v$ = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.682 5.273a.75.75 0 0 1 .546.91l-3 12a.75.75 0 0 1-1.456-.365l3-12a.75.75 0 0 1 .91-.545Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.25 18a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75ZM9.25 6a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 0 1.5h-7A.75.75 0 0 1 9.25 6Z", fill: "currentColor" })] }));
}, m$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: v$
}), g$ = function(e) {
  var t = te(e.size);
  return S("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 5a.75.75 0 0 1 .75.75v6a3.25 3.25 0 0 0 6.5 0v-6a.75.75 0 0 1 1.5 0v6a4.75 4.75 0 1 1-9.5 0v-6A.75.75 0 0 1 8 5ZM6.25 18.75A.75.75 0 0 1 7 18h10a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75Z", fill: "currentColor" }) }));
}, y$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: g$
}), S$ = function(e) {
  var t = te(e.size);
  return S("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 12.75c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h3c.69 0 1.25-.56 1.25-1.25v-5c0-.69-.56-1.25-1.25-1.25h-3ZM13.25 14A2.75 2.75 0 0 1 16 11.25h3A2.75 2.75 0 0 1 21.75 14v5A2.75 2.75 0 0 1 19 21.75h-3A2.75 2.75 0 0 1 13.25 19v-5ZM16 3.75c-.69 0-1.25.56-1.25 1.25v2c0 .69.56 1.25 1.25 1.25h3c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25h-3ZM13.25 5A2.75 2.75 0 0 1 16 2.25h3A2.75 2.75 0 0 1 21.75 5v2A2.75 2.75 0 0 1 19 9.75h-3A2.75 2.75 0 0 1 13.25 7V5ZM5 3.75c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h3c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25H5ZM2.25 5A2.75 2.75 0 0 1 5 2.25h3A2.75 2.75 0 0 1 10.75 5v5A2.75 2.75 0 0 1 8 12.75H5A2.75 2.75 0 0 1 2.25 10V5ZM5 15.75c-.69 0-1.25.56-1.25 1.25v2c0 .69.56 1.25 1.25 1.25h3c.69 0 1.25-.56 1.25-1.25v-2c0-.69-.56-1.25-1.25-1.25H5ZM2.25 17A2.75 2.75 0 0 1 5 14.25h3A2.75 2.75 0 0 1 10.75 17v2A2.75 2.75 0 0 1 8 21.75H5A2.75 2.75 0 0 1 2.25 19v-2Z", fill: "currentColor" }) }));
}, b$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: S$
}), C$ = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 5.5A2.75 2.75 0 0 1 5 2.75h5a.75.75 0 0 1 0 1.5H5c-.69 0-1.25.56-1.25 1.25v14c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25v-6.125a.75.75 0 0 1 1.5 0V19.5A2.75 2.75 0 0 1 19 22.25H5a2.75 2.75 0 0 1-2.75-2.75v-14Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.25 8.752a3.751 3.751 0 0 1 3.752-3.751h5.002a.75.75 0 0 1 0 1.5h-5.002a2.251 2.251 0 0 0-2.252 2.251v2.501a.75.75 0 0 1-1.5 0v-2.5Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.972 2.72a.75.75 0 0 1 1.061 0l2.501 2.5a.75.75 0 0 1 0 1.061l-2.501 2.501a.75.75 0 1 1-1.06-1.06l1.97-1.971-1.97-1.97a.75.75 0 0 1 0-1.061Z", fill: "currentColor" })] }));
}, w$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: C$
}), E$ = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.246 6.998a.75.75 0 0 1 .75-.75h18.008a.75.75 0 0 1 0 1.5H2.996a.75.75 0 0 1-.75-.75ZM6.248 11a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75ZM6.25 14.5a.75.75 0 0 1 .75-.75h5a.75.75 0 1 1 0 1.5H7a.75.75 0 0 1-.75-.75Z", fill: e.color }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.997 4.747a2.251 2.251 0 0 0-2.25 2.251V15a2.251 2.251 0 0 0 2.25 2.252H10a.75.75 0 0 1 0 1.5H5.997A3.751 3.751 0 0 1 2.247 15V6.998a3.752 3.752 0 0 1 3.75-3.751h12.005a3.752 3.752 0 0 1 3.752 3.751V11a.75.75 0 0 1-1.5 0V6.998a2.251 2.251 0 0 0-2.252-2.251H5.997Z", fill: e.color }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.093 16.253H18.41a2.85 2.85 0 0 1 2.843 2.843V19.504c0 .69-.56 1.25-1.25 1.25H13.5c-.69 0-1.25-.56-1.25-1.25v-.409a2.85 2.85 0 0 1 2.843-2.842Zm.003 1.5a1.35 1.35 0 0 0-1.346 1.346v.155h6.003v-.155a1.35 1.35 0 0 0-1.346-1.346h-3.311ZM14 12.49a2.75 2.75 0 1 1 5.502.022 2.75 2.75 0 0 1-5.501-.022Zm2.751 1.262a1.25 1.25 0 1 0-1.25-1.256m1.25 1.256a1.25 1.25 0 0 1-1.25-1.256", fill: e.color })] }));
}, I$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: E$
}), A$ = function(e) {
  var t = te(e.size);
  return S("svg", q({}, e, { width: t, height: t, viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.251 4.002a.75.75 0 0 1 .75-.75h16.007a.75.75 0 0 1 0 1.5H4.001a.75.75 0 0 1-.75-.75ZM3.251 8.003a.75.75 0 0 1 .75-.75h16.007a.75.75 0 0 1 0 1.5H4.001a.75.75 0 0 1-.75-.75ZM3.251 12.005a.75.75 0 0 1 .75-.75h16.007a.75.75 0 0 1 0 1.5H4.001a.75.75 0 0 1-.75-.75ZM3.251 16.007a.75.75 0 0 1 .75-.75h16.007a.75.75 0 0 1 0 1.5H4.001a.75.75 0 0 1-.75-.75ZM7.253 20.008a.75.75 0 0 1 .75-.75h8.003a.75.75 0 0 1 0 1.5H8.003a.75.75 0 0 1-.75-.75Z", fill: "currentColor" }) }));
}, _$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: A$
}), R$ = function(e) {
  var t = te(e.size);
  return S("svg", q({}, e, { width: t, height: t, viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.251 4.002a.75.75 0 0 1 .75-.75h16.007a.75.75 0 0 1 0 1.5H4.001a.75.75 0 0 1-.75-.75ZM3.251 8.003a.75.75 0 0 1 .75-.75h13.006a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75ZM3.251 12.005a.75.75 0 0 1 .75-.75h13.006a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75ZM3.251 16.007a.75.75 0 0 1 .75-.75h16.007a.75.75 0 0 1 0 1.5H4.001a.75.75 0 0 1-.75-.75ZM3.251 20.008a.75.75 0 0 1 .75-.75h8.004a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75Z", fill: "currentColor" }) }));
}, O$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: R$
}), T$ = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { clipRule: "evenodd", d: "M15.752 11.25a.75.75 0 0 0-.75-.75H13.5V8.998a.75.75 0 0 0-.75-.75H11.25a.75.75 0 0 0-.75.75v1.5H8.998a.75.75 0 0 0-.75.75v1.501c0 .415.335.75.75.75h1.5v1.501c0 .415.336.75.75.75h1.501a.75.75 0 0 0 .75-.75v-1.5h1.501a.75.75 0 0 0 .75-.75V11.25Z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M5.633 5.633a9.004 9.004 0 1 1 0 12.734M4.497 12H1.996M5.997 8.999h-2.5M5.997 15.001h-2.5", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, k$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: T$
}), M$ = function(e) {
  var t = te(e.size);
  return S("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.998 3.746c-.69 0-1.25.56-1.25 1.251v14.006c0 .69.56 1.25 1.25 1.25h8.004c.69 0 1.25-.56 1.25-1.25V4.997c0-.69-.56-1.25-1.25-1.25h-.75v1.026A1.307 1.307 0 0 1 14 6.147H9.999a1.307 1.307 0 0 1-1.25-1.375V3.747h-.75Zm0-1.5a2.75 2.75 0 0 0-2.75 2.751v14.006a2.75 2.75 0 0 0 2.75 2.75h8.004a2.75 2.75 0 0 0 2.75-2.75V4.997a2.75 2.75 0 0 0-2.75-2.75H7.998Zm2.251 1.5v.901h3.502v-.9H10.25Zm-1 14.257a.75.75 0 0 1 .75-.75h4.002a.75.75 0 0 1 0 1.5H9.999a.75.75 0 0 1-.75-.75Z", fill: "currentColor" }) }));
}, P$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: M$
}), D$ = function(e) {
  var t = te(e.size);
  return S("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.25 5a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5h-8a.75.75 0 0 1-.75-.75ZM6 3.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM3.25 5a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0ZM11.25 12a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5h-8a.75.75 0 0 1-.75-.75ZM11.25 19a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5h-8a.75.75 0 0 1-.75-.75ZM6 10.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM3.25 12a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0ZM6 17.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM3.25 19a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0Z", fill: "currentColor" }) }));
}, L$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: D$
}), N$ = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.25 4a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1-.75-.75ZM10.4 9a.75.75 0 0 1 .75-.75H20a.75.75 0 0 1 0 1.5h-8.85A.75.75 0 0 1 10.4 9ZM5.537 3.307A.75.75 0 0 1 6 4v5a.75.75 0 1 1-1.5 0V5.81a.75.75 0 0 1-1.03-1.09l1.25-1.25a.75.75 0 0 1 .817-.163ZM10.25 14a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1-.75-.75ZM10.4 19a.75.75 0 0 1 .75-.75H20a.75.75 0 0 1 0 1.5h-8.85a.75.75 0 0 1-.75-.75ZM5 14.75a.25.25 0 0 0-.25.25.75.75 0 0 1-1.5 0c0-.966.784-1.75 1.75-1.75h.614a1.979 1.979 0 0 1 1.503 3.266L5.63 18.25H7a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.57-1.238l2.548-2.972a.479.479 0 0 0-.364-.79H5Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.25 9A.75.75 0 0 1 4 8.25h2.5a.75.75 0 0 1 0 1.5H4A.75.75 0 0 1 3.25 9Z", fill: "currentColor" })] }));
}, x$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: N$
}), V$ = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.114 7.394c0-.427.346-.773.772-.773h8.228a.772.772 0 0 1 0 1.546H7.886a.772.772 0 0 1-.772-.773ZM7.114 11.515c0-.427.346-.773.772-.773h8.362a.772.772 0 0 1 0 1.546H7.886a.772.772 0 0 1-.772-.773Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.8 4.045a.258.258 0 0 0-.257.258v15.235l1.626-.815a.77.77 0 0 1 .69 0l2.398 1.201 2.398-1.2a.77.77 0 0 1 .69-.001l2.398 1.2 2.397-1.2a.77.77 0 0 1 .69 0l1.627.814V4.303a.258.258 0 0 0-.257-.258H4.8ZM3 4.303C3 3.308 3.806 2.5 4.8 2.5h14.4c.994 0 1.8.808 1.8 1.803v15.651c0 .96-1.007 1.578-1.86 1.152h-.001l-1.654-.829-2.167 1.086-.002.001c-.362.18-.785.18-1.146 0h-.002L12 20.277l-2.168 1.086-.002.001c-.36.18-.784.18-1.146 0h-.002l-2.167-1.087-1.654.829-.002.001A1.287 1.287 0 0 1 3 19.954V4.303Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.114 15.636c0-.427.346-.773.772-.773h5.142a.772.772 0 0 1 0 1.546H7.886a.772.772 0 0 1-.772-.773Z", fill: "currentColor" })] }));
}, j$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: V$
}), U$ = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 5A2.75 2.75 0 0 1 5 2.25a.75.75 0 0 1 0 1.5c-.69 0-1.25.56-1.25 1.25a.75.75 0 0 1-1.5 0ZM3 7.58a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2A.75.75 0 0 1 3 7.58ZM7.58 3a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2A.75.75 0 0 1 7.58 3ZM21 18.25a.75.75 0 0 1 .75.75A2.75 2.75 0 0 1 19 21.75a.75.75 0 0 1 0-1.5c.69 0 1.25-.56 1.25-1.25a.75.75 0 0 1 .75-.75ZM18.25 3a.75.75 0 0 1 .75-.75A2.75 2.75 0 0 1 21.75 5a.75.75 0 0 1-1.5 0c0-.69-.56-1.25-1.25-1.25a.75.75 0 0 1-.75-.75ZM21 7.58a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75ZM21 12.92a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75ZM12.92 3a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75ZM12.92 21a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75ZM9.308 15.58a.75.75 0 0 1 0 1.061l-2.222 2.222a.75.75 0 0 1-1.06 0l-1.334-1.332a.75.75 0 1 1 1.06-1.061l.804.803 1.692-1.692a.75.75 0 0 1 1.06 0Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 13.75c-.69 0-1.25.56-1.25 1.25v4c0 .69.56 1.25 1.25 1.25h4c.69 0 1.25-.56 1.25-1.25v-4c0-.69-.56-1.25-1.25-1.25H5ZM2.25 15A2.75 2.75 0 0 1 5 12.25h4A2.75 2.75 0 0 1 11.75 15v4A2.75 2.75 0 0 1 9 21.75H5A2.75 2.75 0 0 1 2.25 19v-4Z", fill: "currentColor" })] }));
}, B$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: U$
}), $$ = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.874 5.995C2.27 4.308 3.979 2.672 5.639 3.442l14.429 6.697c1.577.731 1.577 2.989 0 3.72l-14.43 6.7c-1.659.769-3.367-.867-2.764-2.554l2.143-6.008-2.143-6.002Zm2.133-1.193a.54.54 0 0 0-.72.689l2.232 6.254a.75.75 0 0 1 0 .504l-2.232 6.26c-.171.478.31.879.72.689l14.43-6.7a.555.555 0 0 0 0-.999L5.006 4.802Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.06 12a.75.75 0 0 1 .75-.75H20.5a.75.75 0 0 1 0 1.5H5.81a.75.75 0 0 1-.75-.75Z", fill: "currentColor" })] }));
}, H$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: $$
}), F$ = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.385 4.82a.77.77 0 0 1 .769-.769h3.077a.77.77 0 1 1 0 1.539h-3.077a.77.77 0 0 1-.77-.77ZM2 4.82a.77.77 0 0 1 .77-.769H14.05a.77.77 0 0 1 0 1.539H2.77A.77.77 0 0 1 2 4.82ZM9.18 12a.77.77 0 0 1 .769-.77H21.23a.77.77 0 0 1 0 1.54H9.949a.77.77 0 0 1-.77-.77ZM2 12a.77.77 0 0 1 .77-.77h3.076a.77.77 0 1 1 0 1.54H2.77A.77.77 0 0 1 2 12ZM17.385 19.18a.77.77 0 0 1 .769-.77h3.077a.77.77 0 1 1 0 1.539h-3.077a.77.77 0 0 1-.77-.77ZM2 19.18a.77.77 0 0 1 .77-.77H14.05a.77.77 0 0 1 0 1.539H2.77a.77.77 0 0 1-.769-.77Z", fill: e.color }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.01 3.914a1.282 1.282 0 1 0-1.814 1.813 1.282 1.282 0 0 0 1.813-1.813Zm1.086-1.089a2.82 2.82 0 1 0-3.988 3.989 2.82 2.82 0 0 0 3.99-3.988h-.002ZM8.804 11.093a1.282 1.282 0 1 0-1.813 1.813 1.282 1.282 0 0 0 1.813-1.813Zm1.087-1.088a2.82 2.82 0 1 0-3.989 3.989 2.82 2.82 0 0 0 3.99-3.988v-.001ZM17.01 18.273a1.282 1.282 0 1 0-1.814 1.813 1.282 1.282 0 0 0 1.813-1.813Zm1.086-1.089a2.82 2.82 0 1 0-3.988 3.989 2.82 2.82 0 0 0 3.99-3.988h-.002Z", fill: e.color })] }));
}, z$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: F$
}), W$ = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.5 8.5A.5.5 0 0 1 2 8h8.253a.5.5 0 1 1 0 1H2a.5.5 0 0 1-.5-.5Z", fill: "#4E535C" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.646 5.896a.5.5 0 0 1 .708 0l2.25 2.25a.5.5 0 0 1 0 .708l-2.25 2.249a.5.5 0 1 1-.707-.707L9.543 8.5 7.646 6.604a.5.5 0 0 1 0-.708Z", fill: "#4E535C" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.5 4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-9a2 2 0 0 1-2-2v-1.5a.5.5 0 0 1 1 0V13a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-9a1 1 0 0 0-1 1v1.5a.5.5 0 0 1-1 0V4Z", fill: "#4E535C" })] }));
}, Z$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: W$
}), G$ = function(e) {
  var t = te(e.size);
  return ie("svg", q({ width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { d: "M16 7H12", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M16 11H12", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M16 15H12", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 20.191V4C4 3.448 4.448 3 5 3H19C19.552 3 20 3.448 20 4V20.191C20 20.563 19.609 20.804 19.276 20.638L17.333 19.666L14.667 21L12 19.667L9.333 21L6.666 19.667L4.723 20.639C4.391 20.804 4 20.563 4 20.191Z", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M8 6.99C7.997 6.99 7.995 6.992 7.995 6.995C7.995 6.998 7.997 7 8 7C8.003 7 8.005 6.998 8.005 6.995C8.005 6.992 8.003 6.99 8 6.99", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M8 11C7.997 11 7.995 11.002 7.995 11.005C7.995 11.008 7.997 11.01 8 11.01C8.003 11.01 8.005 11.008 8.005 11.005C8.005 11.002 8.003 11 8 11", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M8 14.99C7.997 14.99 7.995 14.992 7.995 14.995C7.995 14.998 7.997 15 8 15C8.003 15 8.005 14.998 8.005 14.995C8.005 14.992 8.003 14.99 8 14.99", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, q$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: G$
}), K$ = function(e) {
  var t = te(e.size);
  return ie("svg", q({ width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { d: "M9 17V8C9 7.448 9.448 7 10 7H15V17", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M15 7V4C15 3.448 15.448 3 16 3H20C20.552 3 21 3.448 21 4V16C21 16.552 20.552 17 20 17H4C3.448 17 3 16.552 3 16V12C3 11.448 3.448 11 4 11H9", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M3 21H21", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, J$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: K$
}), Q$ = function(e) {
  var t = te(e.size);
  return ie("svg", q({ width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.0037 12.4998V21.0033C22.0037 21.5559 21.5558 22.0038 21.0033 22.0038H15.0008C14.4483 22.0038 14.0004 21.5559 14.0004 21.0033V12.4998C14.0004 11.9473 14.4483 11.4994 15.0008 11.4994H21.0033C21.5558 11.4994 22.0037 11.9473 22.0037 12.4998Z", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M22.0037 15.0008H14.0004", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M7.49771 7.99789H16.0013", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M7.49771 11.4994H9.99875", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M7.49771 15.0008H9.99875", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M10.9992 19.0025H5.99708C4.89205 19.0025 3.99625 18.1067 3.99625 17.0016V5.99705C3.99625 4.89202 4.89205 3.99622 5.99708 3.99622H18.0021C19.1071 3.99622 20.0029 4.89202 20.0029 5.99705V8.9983", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M16.7516 17.2018C16.7239 17.2018 16.7015 17.2242 16.7015 17.2518C16.7015 17.2794 16.7239 17.3018 16.7516 17.3018C16.7792 17.3018 16.8016 17.2794 16.8016 17.2518C16.8016 17.2242 16.7792 17.2018 16.7516 17.2018", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M19.2526 17.2018C19.225 17.2018 19.2026 17.2242 19.2026 17.2518C19.2026 17.2794 19.225 17.3018 19.2526 17.3018C19.2802 17.3018 19.3026 17.2794 19.3026 17.2518C19.3026 17.2242 19.2802 17.2018 19.2526 17.2018", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M16.7516 19.7028C16.7239 19.7028 16.7015 19.7251 16.7015 19.7528C16.7015 19.7804 16.7239 19.8028 16.7516 19.8028C16.7792 19.8028 16.8016 19.7804 16.8016 19.7528C16.8016 19.7251 16.7792 19.7028 16.7516 19.7028", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M19.2526 19.7028C19.225 19.7028 19.2026 19.7251 19.2026 19.7528C19.2026 19.7804 19.225 19.8028 19.2526 19.8028C19.2802 19.8028 19.3026 19.7804 19.3026 19.7528C19.3026 19.7251 19.2802 19.7028 19.2526 19.7028", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, Y$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Q$
}), X$ = function(e) {
  var t = te(e.size);
  return ie("svg", q({ width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { d: "M19.0029 21.0038C20.108 21.0038 21.0038 20.108 21.0038 19.0029", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M21.0037 19.0029V15.0012", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M19.0029 21.0037H14.0008", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M9.99917 2.99622H4.99709C3.89206 2.99622 2.99625 3.89202 2.99625 4.99705V7.9983", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.0029 10.9995H15.0013C13.8962 10.9995 13.0004 10.1037 13.0004 8.99872V4.99705C13.0004 3.89202 13.8962 2.99622 15.0013 2.99622H19.0029C20.1079 2.99622 21.0038 3.89202 21.0038 4.99705V8.99872C21.0038 10.1037 20.1079 10.9995 19.0029 10.9995Z", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M18.3637 6.14661L16.6629 7.84731L15.6405 6.82789", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.99917 21.0037H3.49646C3.2202 21.0037 2.99625 20.7797 2.99625 20.5035V20.0973C2.99955 18.9417 3.93553 18.0057 5.09113 18.0024H8.40451C9.5601 18.0057 10.4961 18.9417 10.4994 20.0973V20.5035C10.4994 20.7797 10.2754 21.0037 9.99917 21.0037Z", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.74781 15.5014C5.64383 15.5014 4.74846 14.6072 4.747 13.5033C4.74553 12.3993 5.63852 11.5027 6.7425 11.4998C7.84648 11.4968 8.74423 12.3886 8.74866 13.4926C8.75077 14.0246 8.54091 14.5356 8.16545 14.9126C7.78999 15.2895 7.27986 15.5014 6.74781 15.5014Z", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, eH = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: X$
}), tH = function(e) {
  var t = te(e.size);
  return ie("svg", q({ width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.9975 21.0038H3.99667C3.44444 21.0038 2.99625 20.5556 2.99625 20.0034V14.0009C2.99625 13.4487 3.44444 13.0005 3.99667 13.0005H5.9975C6.54973 13.0005 6.99792 13.4487 6.99792 14.0009V20.0034C6.99792 20.5556 6.54973 21.0038 5.9975 21.0038Z", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M13.0004 17.0021H15.3344C15.7676 17.0021 16.1887 16.862 16.5349 16.6019L18.9519 14.7892C19.5551 14.337 20.3995 14.397 20.9327 14.9302V14.9302C21.525 15.5225 21.525 16.4819 20.9327 17.0731L18.8589 19.147C18.3006 19.7052 17.5883 20.0864 16.814 20.2414L13.8828 20.8277C13.3015 20.9437 12.7023 20.9297 12.1271 20.7857L9.47595 20.1234C9.15882 20.0434 8.83368 20.0033 8.50655 20.0033H6.99792", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M13.0004 17.0022H14.486C15.3234 17.0022 16.0017 16.3239 16.0017 15.4865V15.1834C16.0017 14.4881 15.5285 13.8819 14.8542 13.7138L12.5612 13.1405C12.1881 13.0475 11.8059 13.0005 11.4218 13.0005V13.0005C10.4944 13.0005 9.587 13.2746 8.81567 13.7898L6.99792 15.0013", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M13.4496 4.17076L8.82268 4.17376C8.55757 4.17376 8.30346 4.2798 8.11638 4.46688L7.29104 5.29223C6.89987 5.68339 6.89987 6.31665 7.29104 6.70682L8.11938 7.53516C8.30646 7.72224 8.56157 7.82828 8.82668 7.82728L13.4526 7.82428L13.4636 7.82528C14.1269 9.11282 15.4544 10.0012 17.0041 9.99918C19.213 9.99318 21.0037 8.19744 21.0037 5.98952C21.0047 3.7806 19.216 1.99385 17.0071 1.99585C15.4634 1.99985 14.1389 2.88923 13.4726 4.17176", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }), S("path", { d: "M17.0041 6.26168C17.1481 6.26168 17.2642 6.14463 17.2642 6.00057C17.2642 5.85651 17.1461 5.73947 17.0031 5.73947C16.859 5.73947 16.742 5.85651 16.742 6.00057C16.742 6.14463 16.859 6.26168 17.0041 6.26168", stroke: e.color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] }));
}, rH = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: tH
}), nH = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.165 2.84a3.849 3.849 0 0 1 6.14 2.1l.004.016a.27.27 0 0 0 .204.206 4.355 4.355 0 0 1 2.757 6.681l-.004.007a.256.256 0 0 0 0 .29l.005.006a4.355 4.355 0 0 1-2.758 6.682.27.27 0 0 0-.204.205l-.003.015a3.845 3.845 0 0 1-6.14 2.112l-.004-.004a.257.257 0 0 0-.323 0l-.004.003a3.849 3.849 0 0 1-6.14-2.099l-.004-.016a.27.27 0 0 0-.204-.206 4.355 4.355 0 0 1-2.758-6.68l.005-.008a.256.256 0 0 0 0-.29l-.006-.008a4.355 4.355 0 0 1 2.759-6.68.27.27 0 0 0 .204-.205l.004-.016a3.845 3.845 0 0 1 6.14-2.105l.004.003c.084.068.2.075.291.022a.715.715 0 0 1 .035-.03Zm1.012 1.162a1.796 1.796 0 0 1-2.304.044 2.31 2.31 0 0 0-3.68 1.258 1.808 1.808 0 0 1-1.386 1.372l-.008.002a2.821 2.821 0 0 0-1.791 4.32 1.793 1.793 0 0 1 0 2.014 2.818 2.818 0 0 0 1.79 4.32l.01.002c.689.148 1.23.684 1.384 1.371a2.308 2.308 0 0 0 3.681 1.255 1.796 1.796 0 0 1 2.254 0 2.31 2.31 0 0 0 3.681-1.264 1.808 1.808 0 0 1 1.385-1.372l.009-.002a2.821 2.821 0 0 0 1.79-4.321 1.793 1.793 0 0 1 0-2.012 2.818 2.818 0 0 0-1.79-4.322l-.009-.001a1.808 1.808 0 0 1-1.385-1.371 2.308 2.308 0 0 0-3.63-1.293Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2.904c.425 0 .77.344.77.769v16.653a.769.769 0 0 1-1.539 0V3.673c0-.425.344-.769.77-.769ZM17.13 14.82c-.709 0-1.283.573-1.283 1.281a.769.769 0 0 1-1.538 0 2.82 2.82 0 0 1 2.82-2.82.769.769 0 1 1 0 1.538ZM8.922 7.13c.425 0 .77.345.77.769a2.82 2.82 0 0 1-2.821 2.82.769.769 0 1 1 0-1.538c.708 0 1.282-.574 1.282-1.282 0-.424.345-.769.77-.769ZM6.101 14.05c0-.424.345-.768.77-.768A2.82 2.82 0 0 1 9.69 16.1a.769.769 0 0 1-1.538 0c0-.708-.574-1.282-1.282-1.282a.769.769 0 0 1-.77-.769ZM15.078 7.13c.425 0 .769.345.769.769 0 .708.574 1.282 1.283 1.282a.769.769 0 1 1 0 1.537A2.82 2.82 0 0 1 14.309 7.9c0-.424.344-.769.769-.769Z", fill: "currentColor" })] }));
}, oH = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: nH
}), iH = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 4.82A2.82 2.82 0 0 1 4.82 2h12.308a2.82 2.82 0 0 1 2.82 2.82V9.95a.77.77 0 0 1-1.538 0V4.82c0-.709-.573-1.283-1.282-1.283H4.821c-.709 0-1.283.574-1.283 1.283V19.18c0 .707.574 1.282 1.283 1.282h5.128a.77.77 0 1 1 0 1.538H4.82A2.82 2.82 0 0 1 2 19.18V4.82Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.31 13.658c.7-.7 1.837-.7 2.538 0l1.626 1.627c.701.7.701 1.837 0 2.538l-3.65 3.651a1.795 1.795 0 0 1-1.27.526h-2.652a.77.77 0 0 1-.77-.77v-2.652c0-.476.19-.932.526-1.269l3.652-3.65Zm1.087 1.088-3.65 3.651a.257.257 0 0 0-.076.181v1.884h1.883a.256.256 0 0 0 .181-.076l3.652-3.65c.1-.101.1-.263 0-.363m-1.627-1.627Zm-.363 0c.1-.1.263-.1.363 0h-.363ZM10.975 11.23a.77.77 0 0 1 .769.77v3.077a.77.77 0 0 1-1.539 0V12a.77.77 0 0 1 .77-.77Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.667 13.539a.77.77 0 0 1 .769-.77h3.077a.77.77 0 0 1 0 1.539H9.436a.77.77 0 0 1-.77-.77ZM7.128 6.872a.77.77 0 0 1 .77-.77h6.153a.77.77 0 1 1 0 1.54H7.898a.77.77 0 0 1-.77-.77Z", fill: "currentColor" })] }));
}, sH = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: iH
}), aH = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.262 2.75a1.04 1.04 0 0 0-1.04 1.04v1.039h5.659v-1.04a1.04 1.04 0 0 0-1.04-1.039H8.262Zm6.119 1.04a2.54 2.54 0 0 0-2.54-2.54H8.262a2.54 2.54 0 0 0-2.54 2.54v3.578a4.32 4.32 0 0 0 1.6 3.36l-.335 1.342a1.56 1.56 0 0 0-.43.025l-.216.043a.82.82 0 0 0-.032.007l-2.299.46a3.434 3.434 0 0 0-2.761 3.367v.344a.75.75 0 0 0 1.5 0v-.344c0-.922.65-1.716 1.555-1.897l1.419-.283v1.902a2.252 2.252 0 1 0 1.5 0v-1.912c1.133.67 2.386.908 3.724.643a.75.75 0 0 0-.291-1.472 3.628 3.628 0 0 1-2.28-.257l.305-1.22c.431.144.892.221 1.37.221.482 0 .946-.078 1.379-.224l.092.359a.75.75 0 1 0 1.453-.375l-.19-.732a4.32 4.32 0 0 0 1.596-3.357V3.79Zm-1.5 2.539H7.223v1.04a2.827 2.827 0 0 0 2.829 2.828 2.829 2.829 0 0 0 2.829-2.829v-1.04ZM6.473 17.066a.75.75 0 1 0 0 1.501.75.75 0 0 0 0-1.501ZM11.443 16.904a5.654 5.654 0 1 1 5.654 5.654.75.75 0 0 1 0-1.5 4.155 4.155 0 1 0-4.154-4.154.75.75 0 0 1-1.5 0Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.193 16.154a.75.75 0 0 1 .75.75c0 .628.139 1.222.387 1.756a.75.75 0 0 1 .054.47l-.396 1.898 1.893-.403a.75.75 0 0 1 .471.054 4.148 4.148 0 0 0 1.75.384.75.75 0 1 1 0 1.5c-.758 0-1.482-.15-2.144-.42l-2.783.59a.75.75 0 0 1-.89-.886l.582-2.79a5.651 5.651 0 0 1-.424-2.153.75.75 0 0 1 .75-.75ZM14.814 16.965a.05.05 0 1 1-.07.07.05.05 0 0 1 .07-.07Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.213 16.434a.8.8 0 1 1 1.132 1.132.8.8 0 0 1-1.132-1.132ZM17.064 16.965a.05.05 0 1 1-.07.07.05.05 0 0 1 .07-.07Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.463 16.434a.8.8 0 1 1 1.132 1.132.8.8 0 0 1-1.132-1.132ZM19.314 16.965a.05.05 0 1 1-.07.07.05.05 0 0 1 .07-.07Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.713 16.434a.8.8 0 1 1 1.132 1.132.8.8 0 0 1-1.132-1.132Z", fill: "currentColor" })] }));
}, lH = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: aH
}), uH = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.846 5.509a3.004 3.004 0 0 1 3-3.009h5.657c.918 0 1.799.366 2.448 1.017l2.189 2.195a3.477 3.477 0 0 1 1.014 2.455v3.381a.693.693 0 1 1-1.385 0v-3.38c0-.553-.219-1.083-.608-1.474L14.97 4.5c-.389-.39-.917-.61-1.468-.61H7.846c-.892 0-1.615.725-1.615 1.62V8.77a.693.693 0 1 1-1.385 0V5.509Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.846 2.522c.383 0 .693.31.693.694v3.218c0 .384.31.695.692.695h3.209a.693.693 0 0 1 0 1.388h-3.21a2.08 2.08 0 0 1-2.076-2.083V3.216c0-.383.31-.694.692-.694ZM3 10.622a2.542 2.542 0 0 1 2.538-2.546h3.875a2.075 2.075 0 0 1 1.728.928l1.024 1.54c.128.194.344.31.576.31h5.72A2.542 2.542 0 0 1 21 13.4v5.554a2.542 2.542 0 0 1-2.538 2.546H5.538A2.542 2.542 0 0 1 3 18.954v-8.332Zm2.538-1.157c-.637 0-1.153.518-1.153 1.157v8.332c0 .64.516 1.157 1.153 1.157h12.924c.637 0 1.153-.518 1.153-1.157V13.4c0-.64-.516-1.158-1.153-1.158H12.74a2.075 2.075 0 0 1-1.728-.927l-1.024-1.54a.692.692 0 0 0-.576-.31H5.538Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.462 15.02c0-.384.31-.695.692-.695h2.77a.693.693 0 0 1 0 1.389h-2.77a.693.693 0 0 1-.692-.694Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.538 12.937c.383 0 .693.31.693.694v2.777a.693.693 0 1 1-1.385 0v-2.777c0-.383.31-.694.692-.694Z", fill: "currentColor" })] }));
}, dH = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: uH
}), cH = function(e) {
  var t = te(e.size);
  return S("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.086 21.23a.77.77 0 0 1 .771-.768h10.286a.77.77 0 1 1 0 1.538H6.857a.77.77 0 0 1-.771-.77ZM5.829 3.538c-.71 0-1.286.574-1.286 1.283v1.025a.77.77 0 0 1-1.543 0V4.821A2.824 2.824 0 0 1 5.829 2H18.17A2.824 2.824 0 0 1 21 4.82V9.95a.77.77 0 0 1-.771.769h-4.115a.772.772 0 0 1-.622-.315l-1.714-2.335-2.73 5.582a.771.771 0 0 1-1.316.117l-2.238-3.05H4.543v4.36c0 .709.575 1.282 1.285 1.282h12.345c.709 0 1.284-.573 1.284-1.282V14.05a.77.77 0 0 1 .772-.769.77.77 0 0 1 .771.77v1.025a2.824 2.824 0 0 1-2.828 2.82H5.829A2.824 2.824 0 0 1 3 15.077V9.949a.77.77 0 0 1 .771-.77h4.115c.246 0 .477.117.622.315l1.714 2.335 2.73-5.582a.771.771 0 0 1 1.316-.117l2.238 3.05h2.951V4.82c0-.708-.575-1.282-1.286-1.282H5.83Z", fill: "currentColor" }) }));
}, pH = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: cH
}), hH = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.326 9.432c0-.425.343-.77.767-.77h4.093c.99 0 1.79.805 1.79 1.797V20.73c0 .425-.343.77-.766.77a.769.769 0 0 1-.768-.77V10.46a.257.257 0 0 0-.256-.258h-4.093a.769.769 0 0 1-.767-.77Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.814 4.04a.257.257 0 0 0-.256.257V20.73a.769.769 0 1 1-1.534 0V4.297c0-.992.8-1.797 1.79-1.797H15.07c.989 0 1.79.805 1.79 1.797V20.73c0 .425-.343.77-.767.77a.769.769 0 0 1-.767-.77V4.297a.257.257 0 0 0-.256-.257H3.814Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.023 20.73c0 .425-.343.77-.767.77H6.628a.769.769 0 0 1-.767-.77v-4.108c0-.425.343-.77.767-.77h5.628c.424 0 .767.345.767.77v4.108Zm-1.534-.77v-2.568H7.395v2.568h4.094Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.442 15.852c.423 0 .767.345.767.77v4.108c0 .425-.344.77-.767.77a.769.769 0 0 1-.767-.77v-4.108c0-.425.343-.77.767-.77Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 20.73c0-.425.343-.77.767-.77h20.466c.424 0 .767.345.767.77 0 .425-.343.77-.767.77H1.767A.769.769 0 0 1 1 20.73ZM9.442 7.635c.423 0 .767.345.767.77v3.082c0 .425-.344.77-.767.77a.769.769 0 0 1-.767-.77V8.404c0-.425.343-.77.767-.77Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.14 9.946c0-.425.343-.77.767-.77h3.07c.423 0 .767.345.767.77 0 .425-.344.77-.767.77h-3.07a.769.769 0 0 1-.767-.77Z", fill: "currentColor" })] }));
}, fH = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: hH
}), vH = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.39 13.718a.77.77 0 0 1 .767-.772h5.686a.77.77 0 0 1 .767.772.77.77 0 0 1-.767.773H9.157a.77.77 0 0 1-.767-.773ZM8.39 10.284a.77.77 0 0 1 .767-.773h5.686a.77.77 0 0 1 .767.773.77.77 0 0 1-.767.772H9.157a.77.77 0 0 1-.767-.772Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.998 5.2 6.5 6.641a1.287 1.287 0 0 0-.896 1.227v8.264c0 .562.363 1.058.896 1.227h.002l4.492 1.438a3.29 3.29 0 0 0 2.011 0l4.498-1.437c.532-.17.893-.667.893-1.228V7.87a1.287 1.287 0 0 0-.893-1.224l-4.499-1.442a3.29 3.29 0 0 0-2.006-.005Zm2.474-1.468a4.812 4.812 0 0 0-2.936-.006l-.002.001L6.04 5.168h-.001a2.83 2.83 0 0 0-1.968 2.7v8.265a2.832 2.832 0 0 0 1.968 2.7h.001l4.49 1.437a4.816 4.816 0 0 0 2.942 0l4.497-1.437a2.83 2.83 0 0 0 1.962-2.7V7.867a2.83 2.83 0 0 0-1.962-2.693l-4.496-1.442Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.396 9.139a.77.77 0 0 1 .767-.772h.227C21.384 8.367 23 9.994 23 12c0 2.007-1.616 3.634-3.61 3.634h-.227a.77.77 0 0 1-.767-.772.77.77 0 0 1 .767-.772h.227A2.083 2.083 0 0 0 21.466 12c0-1.154-.93-2.09-2.076-2.09h-.227a.77.77 0 0 1-.767-.772ZM4.61 9.911a2.083 2.083 0 0 0-2.076 2.09c0 1.154.93 2.09 2.076 2.09h.227a.77.77 0 0 1 .767.772.77.77 0 0 1-.767.772H4.61c-1.994 0-3.61-1.627-3.61-3.634 0-2.007 1.616-3.634 3.61-3.634h.227a.77.77 0 0 1 .767.772.77.77 0 0 1-.767.772H4.61ZM8.39 13.718a.77.77 0 0 1 .767-.772h5.686a.77.77 0 0 1 .767.772.77.77 0 0 1-.767.773H9.157a.77.77 0 0 1-.767-.773ZM8.39 10.284a.77.77 0 0 1 .767-.773h5.686a.77.77 0 0 1 .767.773.77.77 0 0 1-.767.772H9.157a.77.77 0 0 1-.767-.772Z", fill: "currentColor" })] }));
}, mH = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: vH
}), gH = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.031 7.646a3.75 3.75 0 0 1 1.677-.396H8a.75.75 0 1 1 0 1.5H6.708c-.35 0-.694.08-1.006.237l-.585.293a2.25 2.25 0 0 0-.924.855l-1.55 2.584a.75.75 0 1 1-1.286-.771l1.55-2.585A3.75 3.75 0 0 1 4.447 7.94m0 0 .585-.293M17.5 5.25a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0V6a.75.75 0 0 1 .75-.75Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.25 7.5a.75.75 0 0 1 .75-.75h3a.75.75 0 1 1 0 1.5h-3a.75.75 0 0 1-.75-.75ZM16.25 13a.75.75 0 0 1 .75-.75h2a.75.75 0 1 1 0 1.5h-2a.75.75 0 0 1-.75-.75ZM14.25 16a.75.75 0 0 1 .75-.75h4a.75.75 0 1 1 0 1.5h-4a.75.75 0 0 1-.75-.75ZM10.66 10.28a2.396 2.396 0 0 1 3.687 3.023l-2.993 4.488a4.75 4.75 0 0 1-2.337 1.832l-5.762 2.082a.75.75 0 1 1-.51-1.41l5.762-2.082a3.25 3.25 0 0 0 1.6-1.254l2.993-4.488a.896.896 0 0 0-1.38-1.13l-2.19 2.19a.75.75 0 0 1-.53.219H7a.75.75 0 1 1 0-1.5h1.69l1.97-1.97Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.25 4.5A2.25 2.25 0 0 1 9.5 2.25h11a2.25 2.25 0 0 1 2.25 2.25v15a2.25 2.25 0 0 1-2.25 2.25h-11a2.25 2.25 0 0 1-2.25-2.25v-.307a.75.75 0 0 1 1.5 0v.307c0 .415.336.75.75.75h11a.75.75 0 0 0 .75-.75v-15a.75.75 0 0 0-.75-.75h-11a.75.75 0 0 0-.75.75V13a.75.75 0 1 1-1.5 0V4.5Z", fill: "currentColor" })] }));
}, yH = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: gH
}), SH = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3.539a8.461 8.461 0 0 0-8.461 8.46v.002A8.462 8.462 0 1 0 12 3.539h-.002Zm10 8.46C22 6.477 17.523 2 12 2S2 6.477 2 12s4.478 10 10 10c5.523 0 10.001-4.478 10-10Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.367 7.911c0-.991.803-1.795 1.794-1.795h1.678c.992 0 1.795.804 1.795 1.795V9.38h1.47c.99 0 1.794.804 1.794 1.795v1.678c0 .99-.804 1.795-1.795 1.795h-1.469v1.469c0 .99-.803 1.794-1.795 1.794h-1.678a1.795 1.795 0 0 1-1.794-1.794v-1.47h-1.47a1.795 1.795 0 0 1-1.794-1.794v-1.678c0-.991.804-1.795 1.795-1.795h1.469V7.91Zm1.794-.256a.257.257 0 0 0-.256.256v2.238a.77.77 0 0 1-.77.77H7.899a.257.257 0 0 0-.257.256v1.678c0 .141.115.256.257.256h2.238a.77.77 0 0 1 .77.77v2.238c0 .14.114.256.255.256h1.678a.257.257 0 0 0 .257-.256v-2.239a.77.77 0 0 1 .77-.769h2.237a.257.257 0 0 0 .257-.256v-1.678a.257.257 0 0 0-.257-.257h-2.238a.77.77 0 0 1-.769-.769V7.911a.257.257 0 0 0-.257-.256h-1.678Z", fill: "currentColor" })] }));
}, bH = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: SH
}), CH = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.248 16.502a.75.75 0 0 1 .75-.75h4.001a.75.75 0 0 1 0 1.5H6.998a.75.75 0 0 1-.75-.75ZM18.032 15.033a.75.75 0 0 1 0 1.061l-1.876 1.876a.75.75 0 0 1-1.06 0l-1.126-1.126a.75.75 0 1 1 1.061-1.06l.595.595 1.346-1.346a.75.75 0 0 1 1.06 0Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.246 6.996a4.75 4.75 0 0 1 4.75-4.75h10.008a4.75 4.75 0 0 1 4.75 4.75v10.008a4.75 4.75 0 0 1-4.75 4.75H6.996a4.75 4.75 0 0 1-4.75-4.75V6.996Zm4.75-3.25a3.25 3.25 0 0 0-3.25 3.25v10.008a3.25 3.25 0 0 0 3.25 3.25h10.008a3.25 3.25 0 0 0 3.25-3.25V6.996a3.25 3.25 0 0 0-3.25-3.25H6.996Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.248 13a.75.75 0 0 1 .75-.75H15a.75.75 0 1 1 0 1.5H6.998a.75.75 0 0 1-.75-.75ZM8.498 5.748a.75.75 0 0 1 .75.75v3.001a.75.75 0 1 1-1.5 0V6.498a.75.75 0 0 1 .75-.75Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.248 7.998a.75.75 0 0 1 .75-.75h3.001a.75.75 0 1 1 0 1.5H6.998a.75.75 0 0 1-.75-.75Z", fill: "currentColor" })] }));
}, wH = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: CH
}), EH = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.824 3.562c-.699-.7-1.833-.7-2.532 0-.7.7-.7 1.835 0 2.535.7.7 1.833.7 2.532 0 .7-.7.7-1.835 0-2.535Zm1.085-1.087a3.323 3.323 0 0 0-4.702 0 3.332 3.332 0 0 0 0 4.708 3.323 3.323 0 0 0 4.703 0 3.332 3.332 0 0 0 0-4.708ZM8.212 8.11a3.323 3.323 0 0 0-4.703 0 3.332 3.332 0 0 0 0 4.708 3.323 3.323 0 0 0 4.703 0 3.332 3.332 0 0 0 0-4.709Zm1.085-1.088a4.857 4.857 0 0 0-6.873 0 4.87 4.87 0 0 0 0 6.882 4.857 4.857 0 0 0 6.873 0 4.87 4.87 0 0 0 0-6.882Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 10.463c0-.424.344-.768.767-.768h8.186a.768.768 0 0 1 0 1.537H1.767A.768.768 0 0 1 1 10.463ZM20.784 11.911a2.321 2.321 0 0 0-3.286 0l-5.075 5.081a2.327 2.327 0 0 0 0 3.29 2.321 2.321 0 0 0 3.286 0l5.075-5.081a2.328 2.328 0 0 0 0-3.29Zm-4.371-1.086a3.855 3.855 0 0 1 5.457 0 3.865 3.865 0 0 1 0 5.463l-5.076 5.08a3.855 3.855 0 0 1-5.456 0 3.865 3.865 0 0 1 0-5.462l5.075-5.081Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.893 13.383c.3-.3.785-.3 1.085 0l4.339 4.343a.769.769 0 0 1-1.086 1.087l-4.338-4.344c-.3-.3-.3-.786 0-1.086Z", fill: "currentColor" })] }));
}, IH = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: EH
}), AH = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 7.897A5.898 5.898 0 0 1 7.897 2h8.206A5.898 5.898 0 0 1 22 7.897v8.206A5.898 5.898 0 0 1 16.103 22H7.897A5.898 5.898 0 0 1 2 16.103V7.897Zm5.897-4.359a4.36 4.36 0 0 0-4.359 4.36v8.205a4.36 4.36 0 0 0 4.36 4.358h8.205a4.36 4.36 0 0 0 4.358-4.358V7.897a4.36 4.36 0 0 0-4.358-4.359H7.897Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 7.06a3.334 3.334 0 0 0-3.333 3.334c0 .141.115.256.256.256h6.154a.256.256 0 0 0 .256-.256A3.333 3.333 0 0 0 12 7.06Zm-4.872 3.334a4.872 4.872 0 0 1 9.744 0c0 .992-.805 1.795-1.795 1.795H8.923a1.795 1.795 0 0 1-1.795-1.795Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.37 8.676a.77.77 0 0 1 .344 1.032l-1.026 2.051a.77.77 0 1 1-1.376-.688l1.026-2.05a.77.77 0 0 1 1.032-.345Z", fill: "currentColor" })] }));
}, _H = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: AH
}), RH = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.515 3.836a4.009 4.009 0 0 0-3.03 0L5.342 5.934c-.483.197-.8.666-.8 1.187v4.04c0 4.233 3.169 8.234 7.458 9.28 4.29-1.046 7.457-5.047 7.457-9.28V7.12c0-.52-.315-.989-.8-1.187l-5.142-2.098Zm.584-1.424a5.556 5.556 0 0 0-4.198 0L4.758 4.51A2.82 2.82 0 0 0 3 7.12v4.04c0 5.027 3.77 9.687 8.83 10.821a.776.776 0 0 0 .34 0c5.06-1.134 8.83-5.794 8.83-10.82V7.12a2.82 2.82 0 0 0-1.758-2.61L14.1 2.41Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.522 9.692c-.757 0-1.35.708-1.35 1.444 0 .786.522 1.577 1.268 2.228.36.313.738.563 1.057.73.16.084.295.143.398.179.052.018.086.027.105.031.019-.004.053-.013.105-.031.103-.036.238-.095.398-.178a5.703 5.703 0 0 0 1.056-.731c.747-.65 1.27-1.442 1.27-2.228 0-.735-.595-1.444-1.35-1.444-.449 0-.73.206-.902.4a.772.772 0 0 1-1.154 0 1.158 1.158 0 0 0-.901-.4Zm-2.893 1.444c0-1.4 1.109-2.982 2.893-2.982.614 0 1.104.183 1.478.423.374-.24.864-.423 1.478-.423 1.783 0 2.893 1.582 2.893 2.982 0 1.445-.921 2.624-1.797 3.387-.45.393-.928.71-1.351.932a4.525 4.525 0 0 1-.61.27c-.177.062-.396.121-.613.121-.217 0-.436-.06-.613-.12a4.525 4.525 0 0 1-.61-.27c-.423-.223-.9-.54-1.351-.933-.876-.763-1.797-1.942-1.797-3.387Z", fill: "currentColor" })] }));
}, OH = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: RH
}), TH = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.94 12.269a1.79 1.79 0 1 0-2.532 2.532 1.79 1.79 0 0 0 2.533-2.532Zm1.085-1.086a3.326 3.326 0 1 0-4.702 4.704 3.326 3.326 0 0 0 4.703-4.704ZM1 4.837a2.813 2.813 0 0 1 2.814-2.814H5.86a.767.767 0 0 1 0 1.535H3.814c-.707 0-1.28.572-1.28 1.28V8.93a5.372 5.372 0 1 0 10.745 0V4.837c0-.707-.572-1.279-1.279-1.279H9.953a.767.767 0 0 1 0-1.535H12a2.813 2.813 0 0 1 2.814 2.814V8.93A6.907 6.907 0 1 1 1 8.93V4.837Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.907 14.302c.424 0 .767.344.767.768v1.279a5.116 5.116 0 1 0 10.233 0v-.256a.767.767 0 1 1 1.535 0v.256a6.65 6.65 0 1 1-13.302 0v-1.28c0-.423.343-.767.767-.767ZM5.86 1c.424 0 .768.344.768.767v2.047a.767.767 0 1 1-1.535 0V1.767c0-.423.344-.767.767-.767ZM9.953 1c.424 0 .768.344.768.767v2.047a.767.767 0 1 1-1.535 0V1.767c0-.423.344-.767.767-.767Z", fill: "currentColor" })] }));
}, kH = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: TH
}), MH = function(e) {
  var t = te(e.size);
  return ie("svg", q({}, e, { width: t, height: t, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: "img" }, { children: [S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.175 3.288c.3.3.3.785 0 1.085l-4.267 4.253c-.3.3-.787.3-1.088 0-.3-.3-.3-.785 0-1.084l4.267-4.254c.3-.3.787-.3 1.088 0ZM20.759 5.864c.3.3.301.785.001 1.085l-4.256 4.253c-.3.3-.788.3-1.088.002a.765.765 0 0 1-.002-1.085l4.257-4.254c.3-.3.787-.3 1.088 0Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.379 5.108c.3-.3.787-.3 1.088 0l7.487 7.454c.3.299.3.784 0 1.084-.3.3-.787.3-1.087 0l-7.488-7.453c-.3-.3-.3-.785 0-1.085ZM7.057 16.959c.3.3.3.785 0 1.084l-3.744 3.732c-.3.3-.787.3-1.088 0-.3-.3-.3-.785 0-1.084l3.744-3.732c.3-.3.787-.3 1.088 0ZM6.718 11.744c.3-.3.787-.3 1.087 0l1.498 1.493c.3.3.3.785 0 1.085-.3.299-.788.299-1.088 0l-1.497-1.493c-.3-.3-.3-.785 0-1.085ZM8.964 9.505c.3-.3.787-.3 1.088 0l1.497 1.493c.3.3.3.785 0 1.084-.3.3-.787.3-1.088 0L8.964 10.59c-.3-.3-.3-.785 0-1.084ZM16.02 2.225c.3-.3.788-.3 1.088 0l4.667 4.652c.3.3.3.785 0 1.084-.3.3-.788.3-1.088 0L16.02 3.31c-.3-.3-.3-.785 0-1.084Z", fill: "currentColor" }), S("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.964 6.596c.3.3.3.785 0 1.084L6.26 14.364a1.275 1.275 0 0 0 0 1.807l1.648 1.641c.5.5 1.312.5 1.813 0l6.704-6.684c.3-.299.788-.299 1.088 0 .3.3.3.786 0 1.085l-6.705 6.684a2.826 2.826 0 0 1-3.987 0l-1.649-1.64a2.806 2.806 0 0 1 0-3.977l6.705-6.684c.3-.3.787-.3 1.087 0Z", fill: "currentColor" })] }));
}, PH = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: MH
});
const Cv = (e) => {
  const {
    condition: t,
    children: r
  } = e;
  return t ? /* @__PURE__ */ S(Hb, { children: r }) : null;
}, DH = el({
  actionButton: ({
    colors: e
  }, {
    isMiniMode: t
  }) => Lt`
    background: ${e.neutral[300]};
    border: none;
    color: ${e.background.white};
    cursor: pointer;

    width: ${t ? "38px" : "48px"};
    height: ${t ? "38px" : "48px"};

    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: ${t ? "4px" : "8px"};

    svg {
      fill: ${e.background.white};
    }

    &:hover {
      background: ${e.neutral[300]};
    }

    &:disabled {
      background: ${e.neutral[400]};

      color: ${e.neutral[200]};

      svg {
        fill: ${e.neutral[200]};
      }
    }
  `,
  actionOff: ({
    colors: e
  }) => Lt`
    background: ${e.background.white};
    color: ${e.neutral[300]};
    filter: drop-shadow(0px 2px 6px rgba(0, 0, 0, 0.1));

    svg {
      fill: ${e.neutral[300]};
    }

    &:hover {
      background: ${e.neutral[100]};
    }
  `,
  endCall: ({
    colors: e
  }) => Lt`
    background: ${e.feedback.error[300]};

    svg {
      color: transparent;
      fill: ${e.background.white};
    }

    &:hover {
      background: ${e.feedback.error[300]};
    }

    &:disabled {
      background: ${e.feedback.error[500]};

      color: ${e.neutral[200]};

      svg {
        fill: ${e.neutral[200]};
      }
    }
  `,
  loader: Lt`
    padding-right: 0;
  `
});
var xb = {};
const aa = Bb(({
  active: e,
  disabled: t,
  icon: r,
  onClick: n,
  externalIcon: o,
  busy: i,
  endCall: s,
  isMiniMode: a,
  ...l
}, u) => {
  const d = DH({
    isMiniMode: a
  });
  return /* @__PURE__ */ ie("button", { ref: u, css: [d.actionButton, !e && d.actionOff, s && d.endCall, xb.NODE_ENV === "production" ? "" : ";label:IconButton;", xb.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"], onClick: n, disabled: t, ...l, children: [
    /* @__PURE__ */ S(Cv, { condition: i, children: /* @__PURE__ */ S(Fb, { styles: {
      spinner: d.loader
    }, spinColor: "#ffff", ringColor: "#ffff" }) }),
    /* @__PURE__ */ S(Cv, { condition: !i, children: o || r && /* @__PURE__ */ S(GV, { name: r }) })
  ] });
});
aa.displayName = "IconButton";
const LH = {
  miniMode: (e) => Lt`
    position: absolute;
    bottom: ${e.spacing.xxs};
    gap: ${e.spacing.xxs};
    z-index: 11;
  `
}, NH = el({
  root: (e) => Lt`
    margin-top: auto;
    align-self: center;
    justify-self: flex-end;

    display: flex;
    gap: ${e.spacing.xs};

    position: relative;
    bottom: 0;

    ${LH.miniMode(e)}
  `
}), Vb = {
  PATIENT: {
    active: "Fechar tela cheia",
    inactive: "Ativar tela cheia"
  },
  PROFESSIONAL: {
    active: "Restaurar",
    inactive: "Expandir"
  },
  GUEST: {
    active: "Fechar tela cheia",
    inactive: "Ativar tela cheia"
  }
}, xH = ({
  isMiniMode: e,
  userType: t,
  onFinishMeet: r
}) => {
  const n = NH({
    miniMode: e
  }), o = AN(r, t), i = U6(), s = N0(() => o.hasExpand ? Vb[t].active : Vb[t].inactive, [o.hasExpand, t]);
  return /* @__PURE__ */ ie("div", { css: n.root, children: [
    /* @__PURE__ */ S($g, { I: "finish-meet", an: "Meet", children: /* @__PURE__ */ S(al, { label: "Encerrar chamada", variant: "dark", withArrow: !0, children: /* @__PURE__ */ S(aa, { icon: "phone-on", endCall: !0, busy: o.loadingFinishMeet, onClick: o.finishMeet, isMiniMode: e }) }) }),
    (i.can("all", "Controls") || i.can("toggle-video", "Controls")) && /* @__PURE__ */ S(al, { label: o.hasVideo ? "Desativar vídeo" : "Ativar vídeo", variant: "dark", withArrow: !0, children: /* @__PURE__ */ S(aa, { icon: o.hasVideo ? "camera-on" : "camera-off", onClick: o.toggleVideo, active: o.hasVideo, isMiniMode: e }) }),
    (i.can("all", "Controls") || i.can("toggle-audio", "Controls")) && /* @__PURE__ */ S(al, { label: o.hasAudio ? "Desativar áudio" : "Ativar áudio", variant: "dark", withArrow: !0, children: /* @__PURE__ */ S(aa, { icon: o.hasAudio ? "microphone-on" : "microphone-off", onClick: o.toggleAudio, active: o.hasAudio, isMiniMode: e }) }),
    (i.can("all", "Controls") || i.can("share-screen", "Controls")) && !e && /* @__PURE__ */ S(al, { label: o.hasShareScreen ? "Parar compartilhamento" : "Compartilhar tela", variant: "dark", withArrow: !0, children: /* @__PURE__ */ S(aa, { icon: "share-screen", onClick: o.toogleShareScreen, isMiniMode: e, active: o.hasShareScreen }) }),
    /* @__PURE__ */ S($g, { I: "expand", an: "Controls", children: /* @__PURE__ */ S(al, { label: s, variant: "dark", withArrow: !0, children: /* @__PURE__ */ S(aa, { active: !(o != null && o.hasExpand) || !(o != null && o.hasFullScreen), onClick: o == null ? void 0 : o.toggleExpand, icon: "fullscreen", isMiniMode: e }) }) })
  ] });
}, VH = el({
  root: (e, {
    isShareEnded: t
  }) => Lt`
    position: absolute;
    width: 280px;
    z-index: 12;
    top: ${e.spacing.xs};
    left: ${e.spacing.xs};

    display: ${t ? "none" : "initial"};
  `,
  video: (e) => Lt`
    width: 300px;
    height: 180px;
    border-radius: ${e.spacing.xxs};
  `
}), jH = () => {
  const e = cp((n) => n.stream), t = (e == null ? void 0 : e.getShareStatus()) === Fe.End, r = VH({
    isShareEnded: t
  });
  return /* @__PURE__ */ S("div", { css: r.root, children: /* @__PURE__ */ S("video", { css: r.video, id: "my-screen-share-content-video" }) });
}, UH = el({
  root: (e, {
    hasShareScreenView: t
  }) => Lt`
    min-width: 100%;
    aspect-ratio: 16/9;
    /* background: blue; */
    position: relative;
    flex: 1;
    object-fit: contain;

    display: ${t ? "initial" : "none"};

    grid-column: 1;
    grid-row: span 2;

    @media (max-width: ${e.grid.breakpoint.sm}) {
      grid-row: span 1;
    }
  `,
  shareScreen: Lt`
    width: 100%;
    height: 100%;
    object-fit: contain;
  `
}), BH = ({
  hasShareScreenView: e,
  userId: t
}) => {
  const r = cp((o) => o.stream), n = UH({
    hasShareScreenView: e
  });
  return sn(() => {
    if (e) {
      r == null || r.startShareView(document.querySelector("#users-screen-share-content-canvas"), t);
      return;
    }
    return r == null || r.stopShareView(), () => {
      r == null || r.stopShareView();
    };
  }, [e, r, t]), /* @__PURE__ */ S("div", { css: n.root, children: /* @__PURE__ */ S("canvas", { id: "users-screen-share-content-canvas", css: n.shareScreen }) });
}, $H = (e) => yR`
  0% {
    box-shadow: 0 0 0 0px ${e.colors.brand.tertiary[400]};
  }

  100% {
    box-shadow: 0 0 0 16px rgba(0, 0, 0, 0);
  }
`, jb = {
  participant: (e, t, r) => Lt`
    border: 1px solid ${e.colors.brand.primary[500]};
    height: 100%;
    position: ${r ? "initial" : "absolute"};
    background: blue;
    z-index: 1;
  `,
  host: (e, t) => Lt`
    position: absolute;
    right: ${e.spacing.xxs};
    top: ${e.spacing.xxs};
    z-index: 2;
    width: ${t ? "70px" : "120px"};
    min-width: ${t ? "70px" : "140px"};
    height: ${t ? "90px" : "160px"};
    border-radius: ${e.border.radius.md};
    border: 1px solid ${e.colors.neutral[400]};
    overflow: hidden;
  `,
  alone: () => Lt`
    min-width: fit-content;
    height: 100%;
    position: absolute;
    background: blue;
    z-index: 1;
  `
}, HH = el({
  root: (e, {
    videoOn: t,
    hostType: r,
    isOneToOne: n,
    mobileView: o,
    miniModeView: i,
    hasShareScreen: s
  }) => Lt`
    width: 100%;
    height: 100%;
    min-width: 220px;
    aspect-ratio: 16/9;
    position: relative;
    flex: 1;

    ${o && n && jb[r](e, i, s)}

    ${o && !n && jb.alone()}

    background: ${t ? "none" : e.colors.neutral[500]};

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .video-player {
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 10;
    }
  `,
  video: Lt`
    width: 100%;
    height: 100%;
  `,
  avatar: (e) => Lt`
    background: ${e.colors.neutral[300]};

    width: 56px;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: ${e.border.radius.full};

    /* animation: ${$H(e)} 1.5s ease infinite; */
  `,
  userName: (e) => Lt`
    position: absolute;
    left: ${e.spacing.xxs};
    bottom: ${e.spacing.xxs};
    background: ${e.colors.neutral[400]};

    padding: ${e.spacing.xxs};
    border-radius: ${e.border.radius.md};
    z-index: 999;
  `
}), FH = ({
  participant: e,
  mediaStream: t,
  isOneToOne: r = !1,
  miniModeView: n = !1,
  mobileView: o = !1,
  hasShareScreen: i = !1
}) => {
  var s, a;
  const l = ap(), u = e.userId === ((s = l == null ? void 0 : l.getCurrentUserInfo()) == null ? void 0 : s.userId), d = HH({
    videoOn: e.bVideoOn,
    hostType: u ? "host" : "participant",
    isOneToOne: r,
    mobileView: o,
    miniModeView: n,
    hasShareScreen: i
  }), c = xa(null), p = xa(null), h = zb();
  return sn(() => (c.current && e.bVideoOn ? t == null || t.attachVideo(e.userId, gn.Video_720P, c.current).then(() => {
    var v;
    const m = ((v = p.current) == null ? void 0 : v.querySelector("video-player")).shadowRoot, g = m == null ? void 0 : m.querySelector("video");
    g && (g.style.objectFit = "cover", g.style.width = "100%", g.style.height = "100%");
  }) : t == null || t.detachVideo(e.userId), () => {
    t == null || t.detachVideo(e.userId);
  }), [t, e.bVideoOn, e.userId, l]), /* @__PURE__ */ ie("div", { css: d.root, children: [
    e.bVideoOn && /* @__PURE__ */ S("div", { css: d.video, ref: p, children: /* @__PURE__ */ S("video-player", { class: "video-player", ref: c }) }, e.userId),
    !(e != null && e.bVideoOn) && /* @__PURE__ */ S("div", { css: d.avatar, children: /* @__PURE__ */ S(e1, { color: h.colors.neutral[100], children: (a = L0(e == null ? void 0 : e.displayName)) == null ? void 0 : a.charAt(0) }) }),
    /* @__PURE__ */ S(Cv, { condition: !n && !u, children: /* @__PURE__ */ S("div", { css: d.userName, children: /* @__PURE__ */ S(e1, { variant: "microCopy", color: h.colors.neutral[100], children: L0(e == null ? void 0 : e.displayName) }) }) })
  ] }, e.userId);
}, zH = {
  isPresenting: (e) => Lt`
    grid-template-columns: 70% auto;

    @media (max-width: ${e.grid.breakpoint.sm}) {
      grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    }
  `
}, WH = el({
  root: (e, {
    isMiniMode: t
  }) => Lt`
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;

    padding: ${t ? 0 : e.spacing.xs};
    gap: ${e.spacing.xs};

    background: black;

    video-player-container {
      height: ${t ? "100%" : "calc(100% - 56px)"}; // 56px is the height of the controls
      border-radius: ${t ? 0 : e.border.radius.md};
      overflow: hidden;
      display: flex;
    }
  `,
  videoContainer: Lt`
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
  `,
  userList: (e, {
    hasShareScreenView: t
  }) => Lt`
    /* display: flex;
    flex-direction: row;
    gap: ${e.spacing.xs};
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: center;
    height: 100%; */

    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: ${e.spacing.xs};
    position: relative;
    place-items: center;
    place-content: center;

    ${t && zH.isPresenting(e)}
  `,
  meetContainer: (e) => Lt`
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: ${e.spacing.xs};
    position: relative;
  `,
  loading: (e) => Lt`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: ${e.spacing.xs};
    flex: 1;

    color: ${e.colors.background.white};
  `
}), ZH = (e) => {
  const [t, r] = Yr(null), n = xa(null), {
    width: o
  } = CN(n.current), i = o < 320, s = o < 480, {
    userShareScreenId: a,
    hasShareScreenView: l
  } = bN(), u = WH({
    isMiniMode: i || s,
    hasShareScreenView: l
  }), d = zb(), {
    participants: c,
    mediaStream: p,
    isLoading: h
  } = SN({
    token: t == null ? void 0 : t.token,
    topic: t == null ? void 0 : t.sessionId,
    userName: t == null ? void 0 : t.participantName,
    callId: e == null ? void 0 : e.callId
  });
  return sn(() => {
    e.credentialType === "CREDENTIALS" && r({
      sessionId: e.sessionId,
      token: e.token,
      participantName: e.participantName
    });
  }, [e]), sn(() => () => {
    p == null || p.stopVideo();
  }, [p]), /* @__PURE__ */ S("div", { css: u.root, ref: n, children: h && !p ? /* @__PURE__ */ ie("div", { css: u.loading, children: [
    /* @__PURE__ */ S(Fb, { ringColor: d.colors.neutral[100], spinColor: d.colors.brand.primary[100] }),
    /* @__PURE__ */ S(e1, { color: d.colors.brand.primary[100], children: "Entrando na sessão..." })
  ] }) : /* @__PURE__ */ ie(Hb, { children: [
    /* @__PURE__ */ S("video-player-container", { css: u.videoContainer, children: /* @__PURE__ */ ie("ul", { css: u.userList, children: [
      /* @__PURE__ */ S(BH, { hasShareScreenView: l, userId: a }),
      c.map((v) => /* @__PURE__ */ S(FH, { participant: v, mediaStream: p, isOneToOne: (c == null ? void 0 : c.length) === 2, miniModeView: i, mobileView: s, hasShareScreen: l }, v.userId))
    ] }) }),
    /* @__PURE__ */ S(jH, {}),
    /* @__PURE__ */ S(xH, { isMiniMode: i, onFinishMeet: e == null ? void 0 : e.onFinishMeet, userType: e == null ? void 0 : e.type })
  ] }) });
}, WF = (e) => (fR(() => {
  e != null && e.env && fN(U8[e.env].API_CORE);
}, [e.env]), /* @__PURE__ */ ie(GD, { children: [
  /* @__PURE__ */ S(j6, { participant: {
    enableTranscription: e == null ? void 0 : e.enableTranscription,
    role: e == null ? void 0 : e.type
  }, children: /* @__PURE__ */ S(ZH, { ...e }) }),
  (e == null ? void 0 : e.inlineNotificatios) && /* @__PURE__ */ S(mR, {})
] })), ZF = ER;
export {
  WF as ZoomRoom,
  ZF as roomEventListener
};
//# sourceMappingURL=index.es.js.map
